/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};


export type AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberReturn = {
  __typename?: 'AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberReturn';
  agreementAcceptedSuccessfully: Scalars['Boolean'];
};

export type AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberReturn = {
  __typename?: 'AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberReturn';
  agreementAcceptedSuccessfully: Scalars['Boolean'];
};

export type AcceptPerksLinkRequestReturn = {
  __typename?: 'AcceptPerksLinkRequestReturn';
  perksLinkAcceptedSuccessfully: Scalars['Boolean'];
};

export type ActivateBannerForCategoryAdvertisingBannerReturn = {
  __typename?: 'ActivateBannerForCategoryAdvertisingBannerReturn';
  bannerActivatedSuccessfully: Scalars['Boolean'];
};

export type ActivateMemberProfileAndPerksBannersForChamberMemberReturn = {
  __typename?: 'ActivateMemberProfileAndPerksBannersForChamberMemberReturn';
  activationSuccessful: Scalars['Boolean'];
};

export type ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn = {
  __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn';
  startDateUtcMilli: Scalars['Float'];
  memberProfileAndPerkBannerActivationFeeInDollarsAtTimeOfActivation: Scalars['Float'];
  memberProfileAndPerkBannerAnnualBannerFeeInDollarsAtTimeOfActivation: Scalars['Float'];
  sentEmailNotificationOfUpcomingExpiry: Scalars['Boolean'];
  chamberMemberHasAcceptedAgreement: Scalars['Boolean'];
  /** Disclaimer text version the member accepted (CMP pages). Empty for older acceptances. */
  chamberMemberAcceptedAgreementVersion?: Maybe<Scalars['String']>;
};

export type ActiveMemberProfileAndPerksBannersSettingsReturn = {
  __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn';
  activationInfo: ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn;
  reactivationInfo?: Maybe<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn>;
};

export type AddCmpMemberStaffNoteInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  body: Scalars['String'];
  operationId: Scalars['String'];
};

export type AddCmpMemberStaffNoteReturn = {
  __typename?: 'AddCmpMemberStaffNoteReturn';
  note: CmpStaffNoteReturn;
  notes: Array<CmpStaffNoteReturn>;
};

export type AddCmpNewsletterSubscriberInput = {
  chamberId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  isCmpNewsletterModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type AddressInput = {
  streetAddress: Scalars['String'];
  city: Scalars['String'];
  province: Scalars['String'];
  postalCode: Scalars['String'];
  country?: Maybe<Scalars['String']>;
};

export type AddressReturn = {
  __typename?: 'AddressReturn';
  streetAddress: Scalars['String'];
  city: Scalars['String'];
  province: Scalars['String'];
  postalCode: Scalars['String'];
  country?: Maybe<Scalars['String']>;
};

export type AdminConsoleLoginEmailReturn = {
  __typename?: 'AdminConsoleLoginEmailReturn';
  adminConsoleLoginEmail: Scalars['String'];
  /** Member only: true when the member's Member Dashboard logins belong to its contacts. */
  memberDashboardLoginsBelongToContacts?: Maybe<Scalars['Boolean']>;
};

export type AffinityProgramPartnerActivationInfoReturn = {
  __typename?: 'AffinityProgramPartnerActivationInfoReturn';
  activationStartDateUtcMilli: Scalars['Float'];
  activationEndDateUtcMilli: Scalars['Float'];
  activationFeeInDollarsAtTimeOfActivation: Scalars['Float'];
  sentEmailNotificationOfUpcomingExpiry: Scalars['Boolean'];
};

export enum AffinityProgramPartnerActivationStatusEnum {
  Activated = 'ACTIVATED',
  Reactivated = 'REACTIVATED',
  Deactivated = 'DEACTIVATED'
}

export type AffinityProgramPartnerActivationToMarkInvoicedInput = {
  activationId: Scalars['String'];
  invoiceSentAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum AffinityProgramPartnerEventActionEnum {
  IneligibleView = 'INELIGIBLE_VIEW',
  UnverifiedView = 'UNVERIFIED_VIEW',
  VerifiedView = 'VERIFIED_VIEW',
  IneligibleOpen = 'INELIGIBLE_OPEN',
  UnverifiedOpen = 'UNVERIFIED_OPEN',
  VerifiedOpen = 'VERIFIED_OPEN',
  IneligibleRedirect = 'INELIGIBLE_REDIRECT',
  UnverifiedRedirect = 'UNVERIFIED_REDIRECT',
  VerifiedRedirect = 'VERIFIED_REDIRECT'
}

export type AffinityProgramPartnerEventInput = {
  affinityProgramPartnerId: Scalars['String'];
  chamberId: Scalars['String'];
  chamberMemberId?: Maybe<Scalars['String']>;
  action: AffinityProgramPartnerEventActionEnum;
  redirectUserId?: Maybe<Scalars['String']>;
};

export type AffinityProgramPartnerInput = {
  id: Scalars['String'];
  companyName: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  redirectLink: Scalars['String'];
  logo: Scalars['String'];
  banner?: Maybe<Array<BannerInput>>;
  appPlacementOrder?: Maybe<Scalars['Float']>;
  cmpInternalOnly?: Maybe<Scalars['Boolean']>;
};

export enum AffinityProgramPartnerInquiryEmailDeliveryStatusEnum {
  Pending = 'PENDING',
  Sent = 'SENT',
  Failed = 'FAILED'
}

export type AffinityProgramPartnerInquiryReturn = {
  __typename?: 'AffinityProgramPartnerInquiryReturn';
  id: Scalars['String'];
  fullName: Scalars['String'];
  email: Scalars['String'];
  employerName: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
  emailDeliveryStatus: AffinityProgramPartnerInquiryEmailDeliveryStatusEnum;
};

export type AffinityProgramPartnerMonthlyInvoiceChamberDataReturn = {
  __typename?: 'AffinityProgramPartnerMonthlyInvoiceChamberDataReturn';
  chamberId: Scalars['String'];
  chamberName: Scalars['String'];
  affinityProgramPartnersActivated: Scalars['Float'];
  totalActivationFeeInDollars: Scalars['Float'];
  activations?: Maybe<Array<AffinityProgramPartnerMonthlyInvoiceIndividualActivationDataReturn>>;
  allInvoicesSentForChamberInMonth: Scalars['Boolean'];
};

export type AffinityProgramPartnerMonthlyInvoiceDataReturn = {
  __typename?: 'AffinityProgramPartnerMonthlyInvoiceDataReturn';
  year: Scalars['Float'];
  monthNum: Scalars['Float'];
  totalActivationFeeInDollars: Scalars['Float'];
  allInvoicesSentInMonth: Scalars['Boolean'];
  chamberData?: Maybe<Array<AffinityProgramPartnerMonthlyInvoiceChamberDataReturn>>;
};

export type AffinityProgramPartnerMonthlyInvoiceIndividualActivationDataReturn = {
  __typename?: 'AffinityProgramPartnerMonthlyInvoiceIndividualActivationDataReturn';
  activationId: Scalars['String'];
  affinityProgramPartnerId: Scalars['String'];
  affinityProgramPartnerCompanyName: Scalars['String'];
  activationLengthInMonths: Scalars['Float'];
  activationFeeInDollars: Scalars['Float'];
  includeInInvoice: Scalars['Boolean'];
  invoiceSentAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type AffinityProgramPartnerReturn = {
  __typename?: 'AffinityProgramPartnerReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  companyName: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  redirectLink: Scalars['String'];
  logo: Scalars['String'];
  banner?: Maybe<Array<BannerReturn>>;
  appPlacementOrder?: Maybe<Scalars['Float']>;
  cmpInternalOnly?: Maybe<Scalars['Boolean']>;
  activationInfo?: Maybe<AffinityProgramPartnerActivationInfoReturn>;
  reactivationInfo?: Maybe<AffinityProgramPartnerActivationInfoReturn>;
  activationStatus: AffinityProgramPartnerActivationStatusEnum;
  activationStartDateUtcMilli?: Maybe<Scalars['Float']>;
  activationEndDateUtcMilli?: Maybe<Scalars['Float']>;
  daysUntilExpiration?: Maybe<Scalars['Float']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type AffinityProgramPartnerStatReturn = {
  __typename?: 'AffinityProgramPartnerStatReturn';
  id: Scalars['String'];
  totalViewCount: Scalars['Float'];
  totalIneligibleViewCount: Scalars['Float'];
  totalUnverifiedViewCount: Scalars['Float'];
  totalVerifiedViewCount: Scalars['Float'];
  totalMemberViewCount: Scalars['Float'];
  totalNonMemberViewCount: Scalars['Float'];
  totalOpenCount: Scalars['Float'];
  totalIneligibleOpenCount: Scalars['Float'];
  totalUnverifiedOpenCount: Scalars['Float'];
  totalVerifiedOpenCount: Scalars['Float'];
  totalMemberOpenCount: Scalars['Float'];
  totalNonMemberOpenCount: Scalars['Float'];
  totalOpensFromViewsConversionRatePercentage: Scalars['Float'];
  totalRedirectCount: Scalars['Float'];
  totalIneligibleRedirectCount: Scalars['Float'];
  totalUnverifiedRedirectCount: Scalars['Float'];
  totalVerifiedRedirectCount: Scalars['Float'];
  totalMemberRedirectCount: Scalars['Float'];
  totalNonMemberRedirectCount: Scalars['Float'];
  totalRedirectCountFromOpensConversionRatePercentage: Scalars['Float'];
  totalInquirySubmissionCount: Scalars['Float'];
  displayInquirySubmissionCount: Scalars['Float'];
  inquirySubmissionCountIsDemo: Scalars['Boolean'];
  inquiries: Array<AffinityProgramPartnerInquiryReturn>;
  inquiriesReturnedCount: Scalars['Float'];
  inquiriesNextToken?: Maybe<Scalars['String']>;
  splitByChamber?: Maybe<Array<AffinityProgramPartnerStatSplitByChamberReturn>>;
  timeseriesData?: Maybe<AffinityProgramPartnerTimeseriesDataReturn>;
};

export type AffinityProgramPartnerStatSplitByChamberReturn = {
  __typename?: 'AffinityProgramPartnerStatSplitByChamberReturn';
  chamberId: Scalars['String'];
  chamberName: Scalars['String'];
  chamberIsEnabledForAffinityProgramPartner: Scalars['Boolean'];
  totalViewCount: Scalars['Float'];
  ineligibleViewCount: Scalars['Float'];
  unverifiedViewCount: Scalars['Float'];
  verifiedViewCount: Scalars['Float'];
  memberViewCount: Scalars['Float'];
  nonMemberViewCount: Scalars['Float'];
  totalOpenCount: Scalars['Float'];
  ineligibleOpenCount: Scalars['Float'];
  unverifiedOpenCount: Scalars['Float'];
  verifiedOpenCount: Scalars['Float'];
  memberOpenCount: Scalars['Float'];
  nonMemberOpenCount: Scalars['Float'];
  totalRedirectCount: Scalars['Float'];
  ineligibleRedirectCount: Scalars['Float'];
  unverifiedRedirectCount: Scalars['Float'];
  verifiedRedirectCount: Scalars['Float'];
  memberRedirectCount: Scalars['Float'];
  nonMemberRedirectCount: Scalars['Float'];
};

export type AffinityProgramPartnerTimeseriesDataPoint = {
  __typename?: 'AffinityProgramPartnerTimeseriesDataPoint';
  monthAndYear: Scalars['String'];
  totalOpenCount: Scalars['Float'];
  totalViewCount: Scalars['Float'];
  totalRedirectCount: Scalars['Float'];
};

export type AffinityProgramPartnerTimeseriesDataReturn = {
  __typename?: 'AffinityProgramPartnerTimeseriesDataReturn';
  allChambers: AffinityProgramPartnerTimeseriesDataset;
  chambers: Array<AffinityProgramPartnerTimeseriesDataset>;
};

export type AffinityProgramPartnerTimeseriesDataset = {
  __typename?: 'AffinityProgramPartnerTimeseriesDataset';
  id: Scalars['String'];
  name: Scalars['String'];
  timeseriesData: Array<AffinityProgramPartnerTimeseriesDataPoint>;
};

export enum AffinityProgramPartnerUpdateRecordEventEnum {
  Activation = 'ACTIVATION',
  Reactivation = 'REACTIVATION',
  Deactivation = 'DEACTIVATION',
  Expiration = 'EXPIRATION',
  ContentUpdate = 'CONTENT_UPDATE'
}

export type AffinityProgramPartnerUpdateRecordReturn = {
  __typename?: 'AffinityProgramPartnerUpdateRecordReturn';
  id: Scalars['String'];
  triggeringUserId: Scalars['String'];
  chamberId: Scalars['String'];
  affinityProgramPartnerId: Scalars['String'];
  recordEvent: AffinityProgramPartnerUpdateRecordEventEnum;
  affinityProgramPartnerAtEventTrigger: AffinityProgramPartnerReturn;
  excludeFromInvoice?: Maybe<Scalars['Boolean']>;
  invoiceSentAtUtcMilli?: Maybe<Scalars['Float']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  activationDateUtcMilli: Scalars['Float'];
  expirationDateUtcMilli: Scalars['Float'];
};

export type AllCategoryAdvertisingBannersForChamberReturn = {
  __typename?: 'AllCategoryAdvertisingBannersForChamberReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  categoryAdvertisingBanners: Array<CategoryAdvertisingBannerReturn>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type AppSignupMetricWithTargetReturn = {
  __typename?: 'AppSignupMetricWithTargetReturn';
  currentValue: Scalars['Float'];
  currentPercentage: Scalars['Float'];
  targetValue: Scalars['Float'];
  targetPercentage: Scalars['Float'];
  maxValue: Scalars['Float'];
  monthlyData: Array<MonthlyAppSignupDataReturn>;
  averageMonthlySignups: Scalars['Float'];
};

export type ApproveCmpEventSponsorshipRequestInput = {
  chamberId: Scalars['String'];
  operationId: Scalars['String'];
  draftInvoiceId?: Maybe<Scalars['String']>;
  draftExpectedUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  eventId: Scalars['String'];
  sponsorshipRequestId: Scalars['String'];
  paymentChoice: CmpPaymentChoiceInput;
  stripeSuccessUrl?: Maybe<Scalars['String']>;
  stripeCancelUrl?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  invoiceAccountCode?: Maybe<Scalars['String']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type ApproveCmpInvoiceInput = {
  chamberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId?: Maybe<Scalars['String']>;
  expectedUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  sendPaymentRequest?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type ApproveCmpMemberRenewalInvoiceDraftInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  expectedMemberUpdatedAtUtcMilli: Scalars['Float'];
  expectedInvoiceUpdatedAtUtcMilli: Scalars['Float'];
  membership?: Maybe<CmpMemberMembershipChangeFieldsInput>;
};

export type ArchiveCmpEventLibraryItemInput = {
  expectedUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  chamberId: Scalars['String'];
  itemId: Scalars['String'];
};

export type ArchiveCmpEventTypeInput = {
  chamberId: Scalars['String'];
  eventTypeId: Scalars['String'];
};

export type ArchiveCmpMemberInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  archivedAtUtcMilli?: Maybe<Scalars['Float']>;
  archiveReason: Scalars['String'];
};

export enum BannerContentTypeEnum {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type BannerInput = {
  contentUrl: Scalars['String'];
  imageLink?: Maybe<Scalars['String']>;
  contentType: BannerContentTypeEnum;
  position: Scalars['Float'];
  waitingForApprovalByChamberAdmin?: Maybe<Scalars['Boolean']>;
};

export type BannerReturn = {
  __typename?: 'BannerReturn';
  contentUrl: Scalars['String'];
  imageLink?: Maybe<Scalars['String']>;
  contentType: BannerContentTypeEnum;
  position: Scalars['Float'];
  waitingForApprovalByChamberAdmin?: Maybe<Scalars['Boolean']>;
};

export type CpaSignUpChambersForCityReturn = {
  __typename?: 'CPASignUpChambersForCityReturn';
  singleChamberInCity?: Maybe<SignUpSingleMatchingChamberReturn>;
  multipleChambersInCity?: Maybe<SignUpMultipleMatchingChambersReturn>;
  noChambersInCity_closestChambersToCity?: Maybe<SignUpNoMatchingChambersReturn>;
};

export type CancelCmpMemberPendingMembershipChangeInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  operationId: Scalars['String'];
  expectedMemberUpdatedAtUtcMilli: Scalars['Float'];
  expectedPendingOperationId: Scalars['String'];
  expectedPendingVersion: Scalars['Int'];
};

export type CancelCmpMemberRenewalInvoiceInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  expectedMemberUpdatedAtUtcMilli: Scalars['Float'];
  expectedInvoiceUpdatedAtUtcMilli: Scalars['Float'];
  reason?: Maybe<Scalars['String']>;
};

export type CapUserAffinityProgramPartnerReturn = {
  __typename?: 'CapUserAffinityProgramPartnerReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  companyName: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  logo: Scalars['String'];
  banner?: Maybe<Array<BannerReturn>>;
  appPlacementOrder?: Maybe<Scalars['Float']>;
  activationStatus: AffinityProgramPartnerActivationStatusEnum;
  activationStartDateUtcMilli?: Maybe<Scalars['Float']>;
  activationEndDateUtcMilli?: Maybe<Scalars['Float']>;
  daysUntilExpiration?: Maybe<Scalars['Float']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  showRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
};

export type CapUserAffinityProgramPartnersReturn = {
  __typename?: 'CapUserAffinityProgramPartnersReturn';
  affinityProgramPartners: Array<CapUserAffinityProgramPartnerReturn>;
  userHasValidChamberMemberId: Scalars['Boolean'];
};

export type CapUserAgreedToRewardCampaignMutationReturn = {
  __typename?: 'CapUserAgreedToRewardCampaignMutationReturn';
  capUserAgreedSuccessfully: Scalars['Boolean'];
};

export type CapUserAgreedToRewardCampaignReturn = {
  __typename?: 'CapUserAgreedToRewardCampaignReturn';
  id: Scalars['String'];
  rewardCampaignId: Scalars['String'];
  capUserId: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
};

export type CapUserAgreedToShopLocalCampaignMutationReturn = {
  __typename?: 'CapUserAgreedToShopLocalCampaignMutationReturn';
  capUserAgreedSuccessfully: Scalars['Boolean'];
};

export type CapUserAgreedToShopLocalCampaignReturn = {
  __typename?: 'CapUserAgreedToShopLocalCampaignReturn';
  id: Scalars['String'];
  shopLocalCampaignId: Scalars['String'];
  capUserId: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
};

export type CapUserPerkPartnerDiscountReturn = {
  __typename?: 'CapUserPerkPartnerDiscountReturn';
  unverified_eligiblePerkPartnerDiscountsForCurrentlyLoggedInCapUser?: Maybe<Array<PerkPartnerDiscountReturn>>;
  verified_eligiblePerkPartnerDiscountsForCurrentlyLoggedInCapUser?: Maybe<Array<PerkPartnerDiscountReturn>>;
  ineligiblePerkPartnerDiscountsForCurrentlyLoggedInCapUser?: Maybe<Array<IneligiblePerkPartnerDiscountReturn>>;
};

export type CapUserShareLeadingToOpenRecordInput = {
  sharerUserId: Scalars['String'];
  sharedItemId: Scalars['String'];
  shareType: CapUserShareLeadingToOpenRecordShareTypeEnum;
  sharedItemOwnedByChamberId: Scalars['String'];
  sharerChamberIdWhenShareExecuted: Scalars['String'];
  shareeIsBrandNewUser: Scalars['Boolean'];
  onlyTrackingAppOpenAndNotSharedItemOpen?: Maybe<Scalars['Boolean']>;
  capUniqueInstallationIdForLoggedOutCapUserTracking?: Maybe<Scalars['String']>;
};

export type CapUserShareLeadingToOpenRecordReturn = {
  __typename?: 'CapUserShareLeadingToOpenRecordReturn';
  id: Scalars['String'];
  sharerUserId: Scalars['String'];
  shareeUserId: Scalars['String'];
  sharedItemId: Scalars['String'];
  sharedItemOwnedByChamberId: Scalars['String'];
  sharerChamberIdWhenShareExecuted: Scalars['String'];
  shareeChamberIdWhenShareOpened: Scalars['String'];
  shareType: CapUserShareLeadingToOpenRecordShareTypeEnum;
  shareeIsBrandNewUser: Scalars['Boolean'];
  onlyTrackingAppOpenAndNotSharedItemOpen?: Maybe<Scalars['Boolean']>;
  capUniqueInstallationIdForLoggedOutCapUserTracking?: Maybe<Scalars['String']>;
  createdAtUtcMilli: Scalars['Float'];
};

export enum CapUserShareLeadingToOpenRecordShareTypeEnum {
  Discount = 'DISCOUNT',
  ChamberMember = 'CHAMBER_MEMBER'
}

export type CapUserShareRecordReturn = {
  __typename?: 'CapUserShareRecordReturn';
  id: Scalars['String'];
  userId: Scalars['String'];
  sharedItemId: Scalars['String'];
  sharedItemOwnedByChamberId: Scalars['String'];
  sharerChamberIdWhenShareExecuted: Scalars['String'];
  shareType: InAppShareTypes;
  createdAtUtcMilli: Scalars['Float'];
};

export type CapUserViewedRewardCampaignMutationReturn = {
  __typename?: 'CapUserViewedRewardCampaignMutationReturn';
  capUserViewedSuccessfully: Scalars['Boolean'];
};

export type CapUserViewedRewardCampaignReturn = {
  __typename?: 'CapUserViewedRewardCampaignReturn';
  id: Scalars['String'];
  rewardCampaignId: Scalars['String'];
  capUserId: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
};

export type CategoryAdvertisingBannerActivationInfoInput = {
  chamberMemberId: Scalars['String'];
  bannerFeeOptionSetAtActivationTime: CategoryAdvertisingBannersFeeOptionsInput;
  activationStartDateUtcMilli: Scalars['Float'];
  autoApproveBannerContentUpdate?: Maybe<Scalars['Boolean']>;
};

export type CategoryAdvertisingBannerActivationInfoReturn = {
  __typename?: 'CategoryAdvertisingBannerActivationInfoReturn';
  banner?: Maybe<Array<BannerReturn>>;
  chamberMemberId: Scalars['String'];
  bannerFeeOptionSetAtActivationTime: CategoryAdvertisingBannersFeeOptionsReturn;
  activationStartDateUtcMilli: Scalars['Float'];
  categoryAdvertisingBannersActivationFeeCpaSplitPercentageSetAtActivationTime: Scalars['Float'];
  sentEmailNotificationOfUpcomingExpiry: Scalars['Boolean'];
  chamberMemberHasAcceptedAgreement: Scalars['Boolean'];
  /** Disclaimer text version the member accepted (CMP pages). Empty for older acceptances. */
  chamberMemberAcceptedAgreementVersion?: Maybe<Scalars['String']>;
  autoApproveBannerContentUpdate?: Maybe<Scalars['Boolean']>;
};

export type CategoryAdvertisingBannerReactivationInfoInput = {
  chamberMemberId: Scalars['String'];
  bannerFeeOptionSetAtActivationTime: CategoryAdvertisingBannersFeeOptionsInput;
  autoApproveBannerContentUpdate?: Maybe<Scalars['Boolean']>;
};

export type CategoryAdvertisingBannerReturn = {
  __typename?: 'CategoryAdvertisingBannerReturn';
  categoryId: ChamberMemberCategory;
  bannerSettings?: Maybe<CategoryAdvertisingBannerSettingsReturn>;
};

export type CategoryAdvertisingBannerSettingsReturn = {
  __typename?: 'CategoryAdvertisingBannerSettingsReturn';
  activationInfo: CategoryAdvertisingBannerActivationInfoReturn;
  reactivationInfo?: Maybe<CategoryAdvertisingBannerActivationInfoReturn>;
};

export enum CategoryAdvertisingBannerUpdateRecordEventEnum {
  Activation = 'ACTIVATION',
  Reactivation = 'REACTIVATION',
  Deactivation = 'DEACTIVATION',
  Expiration = 'EXPIRATION',
  ChamberMemberAgreementAcceptance = 'CHAMBER_MEMBER_AGREEMENT_ACCEPTANCE',
  ContentUpdate = 'CONTENT_UPDATE',
  ContentUpdateAutoApprovalChange = 'CONTENT_UPDATE_AUTO_APPROVAL_CHANGE'
}

export type CategoryAdvertisingBannerUpdateRecordReturn = {
  __typename?: 'CategoryAdvertisingBannerUpdateRecordReturn';
  id: Scalars['String'];
  triggeringUserId: Scalars['String'];
  chamberId: Scalars['String'];
  categoryId: ChamberMemberCategory;
  recordEvent: CategoryAdvertisingBannerUpdateRecordEventEnum;
  bannerAtEventTrigger: CategoryAdvertisingBannerSettingsReturn;
  excludeFromInvoice?: Maybe<Scalars['Boolean']>;
  invoiceSentAtUtcMilli?: Maybe<Scalars['Float']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  activationDateUtcMilli: Scalars['Float'];
  expirationDateUtcMilli: Scalars['Float'];
};

export type CategoryAdvertisingBannersFeeOptionsInput = {
  timeLengthInMonths: Scalars['Float'];
  bannerFeeInDollars: Scalars['Float'];
};

export type CategoryAdvertisingBannersFeeOptionsReturn = {
  __typename?: 'CategoryAdvertisingBannersFeeOptionsReturn';
  timeLengthInMonths: Scalars['Float'];
  bannerFeeInDollars: Scalars['Float'];
};

export type CategoryReturn = {
  __typename?: 'CategoryReturn';
  id: ChamberMemberCategory;
  name: Scalars['String'];
};

export enum ChamberAccountRoleEnum {
  Root = 'ROOT',
  Staff = 'STAFF'
}

export type ChamberAdminStatsReturn = {
  __typename?: 'ChamberAdminStatsReturn';
  totalChamberMembersOnApp: Scalars['Float'];
  totalMemberCompaniesFeaturedOnAppSystemWide: Scalars['Float'];
  membersWithNewPerkNotificationsEnabled: MemberEngagementMetricWithTargetReturn;
  membersWhoDownloadedAppAndSetUpAccount: AppSignupMetricWithTargetReturn;
  membersWhoLoggedIntoMemberDashboard: MemberEngagementMetricWithStarsReturn;
  daysRemainingUntilSubscriptionAnniversary: Scalars['Float'];
  subscriptionAnniversaryUtcMilli: Scalars['Float'];
  subscriptionDate?: Maybe<Scalars['String']>;
  companyLeads: Array<ContactableCompanyReturn>;
  chamberPerksOffered: Scalars['Float'];
  chamberPerkViews: Scalars['Float'];
  totalPerksOfferedOnAppSystemWide: Scalars['Float'];
  totalPerkViewsOnAppSystemWide: Scalars['Float'];
  numberOfPerksOffered: PerkEngagementMetricWithTargetReturn;
  numberOfMembersOfferingPerks: PerkEngagementMetricWithTargetReturn;
  perkViewKPI: PerkViewKpiReturn;
  perkRedeemableByBreakdown: PerkRedeemableByBreakdownReturn;
  perksCategoryBreakdown: Array<PerkCategoryBreakdownItemReturn>;
  mostPopularPerks: Array<PerkListItemReturn>;
  newestPerks: Array<PerkListItemReturn>;
  downloadMilestones: Array<DownloadMilestoneReturn>;
  perkMilestones: Array<DownloadMilestoneReturn>;
  memberOfferingPerksMilestones: Array<MemberOfferingPerksMilestoneReturn>;
  nonDuesRevenueBreakdown: NonDuesRevenueBreakdownReturn;
};

export type ChamberAdminUserReturn = {
  __typename?: 'ChamberAdminUserReturn';
  chamberAddedSuccessfully: Scalars['Boolean'];
  email: Scalars['String'];
  password: Scalars['String'];
  failureReason?: Maybe<Scalars['String']>;
};

export type ChamberEngageActivationFeeRevenueReturn = {
  __typename?: 'ChamberEngageActivationFeeRevenueReturn';
  activationFeeRevenue: Scalars['Float'];
  featuredMemberActivationFeeRevenue: Scalars['Float'];
  categoryAdvertisingActivationFeeRevenue: Scalars['Float'];
  chamberRevenue: Scalars['Float'];
  chamberFeaturedMemberRevenue: Scalars['Float'];
  chamberCategoryAdvertisingRevenue: Scalars['Float'];
};

export type ChamberEngageActivationToMarkInvoicedInput = {
  activationId: Scalars['String'];
  activationType: ChamberEngageActivationTypeEnum;
  invoiceSentAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum ChamberEngageActivationTypeEnum {
  CategoryAdvertising = 'CATEGORY_ADVERTISING',
  MemberProfileAndPerksBanners = 'MEMBER_PROFILE_AND_PERKS_BANNERS'
}

export type ChamberEngageMonthlyInvoiceChamberDataReturn = {
  __typename?: 'ChamberEngageMonthlyInvoiceChamberDataReturn';
  chamberId: Scalars['String'];
  chamberName: Scalars['String'];
  memberProfileAndPerksBannersActivated: Scalars['Float'];
  memberProfileAndPerksBannersTotalActivationFeeInDollars: Scalars['Float'];
  memberProfileAndPerksBannersChamberRevenueInDollars: Scalars['Float'];
  categoryAdvertisingActivated: Scalars['Float'];
  categoryAdvertisingTotalActivationFeeInDollars: Scalars['Float'];
  categoryAdvertisingChamberRevenueInDollars: Scalars['Float'];
  totalActivationFeeInDollars: Scalars['Float'];
  totalChamberRevenueInDollars: Scalars['Float'];
  activations?: Maybe<Array<ChamberEngageMonthlyInvoiceIndividualActivationDataReturn>>;
  allInvoicesSentForChamberInMonth: Scalars['Boolean'];
};

export type ChamberEngageMonthlyInvoiceDataReturn = {
  __typename?: 'ChamberEngageMonthlyInvoiceDataReturn';
  year: Scalars['Float'];
  monthNum: Scalars['Float'];
  totalActivationFeeInDollars: Scalars['Float'];
  totalMemberProfileAndPerksBannersActivationFeeInDollars: Scalars['Float'];
  totalCategoryAdvertisingActivationFeeInDollars: Scalars['Float'];
  totalChamberRevenueInDollars: Scalars['Float'];
  totalMemberProfileAndPerksBannersChamberRevenueInDollars: Scalars['Float'];
  totalCategoryAdvertisingChamberRevenueInDollars: Scalars['Float'];
  allInvoicesSentInMonth: Scalars['Boolean'];
  chamberData?: Maybe<Array<ChamberEngageMonthlyInvoiceChamberDataReturn>>;
};

export type ChamberEngageMonthlyInvoiceIndividualActivationDataReturn = {
  __typename?: 'ChamberEngageMonthlyInvoiceIndividualActivationDataReturn';
  activationId: Scalars['String'];
  chamberMemberId: Scalars['String'];
  chamberMemberName: Scalars['String'];
  activationType: ChamberEngageActivationTypeEnum;
  activationLengthInMonths: Scalars['Float'];
  activationFeeInDollars: Scalars['Float'];
  chamberRevenueInDollars: Scalars['Float'];
  includeInInvoice: Scalars['Boolean'];
  invoiceSentAtUtcMilli?: Maybe<Scalars['Float']>;
  categoryAdvertisingCategoryId?: Maybe<ChamberMemberCategory>;
};

export type ChamberEngageSettingsInput = {
  isActive: Scalars['Boolean'];
  memberProfileAndPerkBannerActivationFeeInDollars: Scalars['Float'];
  memberProfileAndPerkBannerAnnualBannerFeeInDollars: Scalars['Float'];
  categoryAdvertisingBannersFeeOptions: Array<CategoryAdvertisingBannersFeeOptionsInput>;
  categoryAdvertisingBannersActivationFeeCpaSplitPercentage: Scalars['Float'];
};

export type ChamberEngageSettingsReturn = {
  __typename?: 'ChamberEngageSettingsReturn';
  isActive: Scalars['Boolean'];
  memberProfileAndPerkBannerActivationFeeInDollars: Scalars['Float'];
  memberProfileAndPerkBannerAnnualBannerFeeInDollars: Scalars['Float'];
  categoryAdvertisingBannersFeeOptions: Array<CategoryAdvertisingBannersFeeOptionsReturn>;
  categoryAdvertisingBannersActivationFeeCpaSplitPercentage: Scalars['Float'];
  activationTimeUtcMilli?: Maybe<Scalars['Float']>;
};

export type ChamberInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  website: Scalars['String'];
  address: AddressInput;
  supportContactEmail: Scalars['String'];
  supportContactName?: Maybe<Scalars['String']>;
  administratorContactName?: Maybe<Scalars['String']>;
  administratorContactEmail?: Maybe<Scalars['String']>;
  billingContactName?: Maybe<Scalars['String']>;
  billingContactEmail?: Maybe<Scalars['String']>;
  signingAuthorityContactName?: Maybe<Scalars['String']>;
  signingAuthorityContactEmail?: Maybe<Scalars['String']>;
  supportLink?: Maybe<Scalars['String']>;
  secondarySupportEmail?: Maybe<Scalars['String']>;
  chamberSupportPageUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberExtension?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  threads?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  tiktok?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  jobPostingLink?: Maybe<Scalars['String']>;
  jobPostingLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  jobPostingLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  eventsLink?: Maybe<Scalars['String']>;
  eventsLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  eventsLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  newsletterLink?: Maybe<Scalars['String']>;
  newsletterLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  newsletterLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  surveyLink?: Maybe<Scalars['String']>;
  surveyLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  surveyLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  advocacyWinsLink?: Maybe<Scalars['String']>;
  advocacyWinsLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  advocacyWinsLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  callForNominationsLink?: Maybe<Scalars['String']>;
  callForNominationsLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  callForNominationsLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  memberSignupLink?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  sponsorLogo?: Maybe<Scalars['String']>;
  sponsorLogoLink?: Maybe<Scalars['String']>;
  adminConsoleLoginEmail?: Maybe<Scalars['String']>;
  numberOfMembersFromInitialSubscriptionAgreement?: Maybe<Scalars['Float']>;
  subscriptionDate?: Maybe<Scalars['String']>;
  premiumChamberMarketerLink?: Maybe<Scalars['String']>;
  directoryBanner?: Maybe<Array<BannerInput>>;
  profileBanner?: Maybe<Array<BannerInput>>;
  hideInApp?: Maybe<Scalars['Boolean']>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  purchasedItems?: Maybe<Array<ItemsPurchasableByChamberEnum>>;
  chamberMemberProWebsiteUrl?: Maybe<Scalars['String']>;
  subscriptionPlanType?: Maybe<ChamberPerksAppSubscriptionPlanTypesEnum>;
};

export type ChamberLookupEntry = {
  __typename?: 'ChamberLookupEntry';
  chamberId: Scalars['String'];
  chamberName: Scalars['String'];
};

export enum ChamberMemberCategory {
  Restaurant = 'RESTAURANT',
  Retail = 'RETAIL',
  PersonalServices = 'PERSONAL_SERVICES',
  CommunicationTechnology = 'COMMUNICATION_TECHNOLOGY',
  MarketingAdvertising = 'MARKETING_ADVERTISING',
  ProfessionalServices = 'PROFESSIONAL_SERVICES',
  AutomotiveTransportation = 'AUTOMOTIVE_TRANSPORTATION',
  ConstructionSuppliers = 'CONSTRUCTION_SUPPLIERS',
  Industries = 'INDUSTRIES',
  Financial = 'FINANCIAL',
  AccommodationsAttractions = 'ACCOMMODATIONS_ATTRACTIONS',
  SportsRecreation = 'SPORTS_RECREATION',
  HealthSafety = 'HEALTH_SAFETY',
  GovernmentEducation = 'GOVERNMENT_EDUCATION',
  NonProfit = 'NON_PROFIT',
  RealEstate = 'REAL_ESTATE',
  ConstructionIndustrial = 'CONSTRUCTION_INDUSTRIAL',
  FarmingAgriculture = 'FARMING_AGRICULTURE'
}

export type ChamberMemberInput = {
  id: Scalars['String'];
  chamberId: Scalars['String'];
  categoryId: Array<ChamberMemberCategory>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  threads?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  tiktok?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  googleReviewLink?: Maybe<Scalars['String']>;
  address: AddressInput;
  hideAddressFromDirectory?: Maybe<Scalars['Boolean']>;
  phoneNumber: Scalars['String'];
  phoneNumberExtension?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  showInApp: Scalars['Boolean'];
  adminConsoleLoginEmail?: Maybe<Scalars['String']>;
  adminConsoleContactName?: Maybe<Scalars['String']>;
  customContacts?: Maybe<Array<CustomContactInput>>;
  hasSignedUp?: Maybe<Scalars['Boolean']>;
  firstLoginAfterSettingNewPermanentPasswordUtcMilli?: Maybe<Scalars['Float']>;
  isSuspended?: Maybe<Scalars['Boolean']>;
  banner?: Maybe<Array<BannerInput>>;
  cpaAdminCompanyAdminContactTitle?: Maybe<Scalars['String']>;
  cpaAdminCompanyAdminContactNumber?: Maybe<Scalars['String']>;
  cpaAdminCompanyAdminContactNumberExtension?: Maybe<Scalars['String']>;
  cpaAdminCompanyAdminContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  primaryContactName?: Maybe<Scalars['String']>;
  primaryContactTitle?: Maybe<Scalars['String']>;
  primaryContactEmail?: Maybe<Scalars['String']>;
  primaryContactPhoneNumber?: Maybe<Scalars['String']>;
  primaryContactPhoneNumberExtension?: Maybe<Scalars['String']>;
  primaryContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactName?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactEmail?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactTitle?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactNumber?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactNumberExtension?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  lifecycleStatus?: Maybe<CmpMemberLifecycleStatusEnum>;
  seoTags?: Maybe<Array<Scalars['String']>>;
  cmpExtension?: Maybe<CmpMemberExtensionInput>;
  cmpSavedProfileSections?: Maybe<Array<Scalars['String']>>;
};

export type ChamberMemberProAccountAllocationInput = {
  type: ChamberMemberProAccountAllocationTypeEnum;
  accountNumber: Scalars['String'];
  accountName: Scalars['String'];
};

export type ChamberMemberProAccountAllocationReturn = {
  __typename?: 'ChamberMemberProAccountAllocationReturn';
  type: ChamberMemberProAccountAllocationTypeEnum;
  accountNumber: Scalars['String'];
  accountName: Scalars['String'];
};

export enum ChamberMemberProAccountAllocationTypeEnum {
  MembershipSales = 'MEMBERSHIP_SALES',
  EventTicketSales = 'EVENT_TICKET_SALES',
  SponsorshipSales = 'SPONSORSHIP_SALES',
  AdvertisingSales = 'ADVERTISING_SALES',
  CustomSales = 'CUSTOM_SALES'
}

export enum ChamberMemberProAdditionalCostFeeTypeEnum {
  FixedAmount = 'FIXED_AMOUNT',
  PercentageOfMembership = 'PERCENTAGE_OF_MEMBERSHIP'
}

export type ChamberMemberProCardProcessingFeeSettingsInput = {
  enabled: Scalars['Boolean'];
  percentage: Scalars['Float'];
  fixedAmountInDollars: Scalars['Float'];
};

export type ChamberMemberProCardProcessingFeeSettingsReturn = {
  __typename?: 'ChamberMemberProCardProcessingFeeSettingsReturn';
  enabled: Scalars['Boolean'];
  percentage: Scalars['Float'];
  fixedAmountInDollars: Scalars['Float'];
};

export type ChamberMemberProChamberGroupInsuranceBillingDetailsInput = {
  companyName: Scalars['String'];
  streetAddress: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  province?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  contactName: Scalars['String'];
  contactTitle: Scalars['String'];
  contactEmail: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type ChamberMemberProChamberGroupInsuranceBillingDetailsReturn = {
  __typename?: 'ChamberMemberProChamberGroupInsuranceBillingDetailsReturn';
  companyName: Scalars['String'];
  streetAddress: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  province?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  contactName: Scalars['String'];
  contactTitle: Scalars['String'];
  contactEmail: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type ChamberMemberProChamberGroupInsurancePaymentSettingsInput = {
  enabled: Scalars['Boolean'];
  billingDetails: ChamberMemberProChamberGroupInsuranceBillingDetailsInput;
};

export type ChamberMemberProChamberGroupInsurancePaymentSettingsReturn = {
  __typename?: 'ChamberMemberProChamberGroupInsurancePaymentSettingsReturn';
  enabled: Scalars['Boolean'];
  billingDetails: ChamberMemberProChamberGroupInsuranceBillingDetailsReturn;
};

export type ChamberMemberProChamberInvoiceCopySettingsInput = {
  enabled: Scalars['Boolean'];
  email: Scalars['String'];
};

export type ChamberMemberProChamberInvoiceCopySettingsReturn = {
  __typename?: 'ChamberMemberProChamberInvoiceCopySettingsReturn';
  enabled: Scalars['Boolean'];
  email: Scalars['String'];
};

export enum ChamberMemberProCurrencyEnum {
  Cad = 'CAD',
  Usd = 'USD'
}

export enum ChamberMemberProEmailBodyFormatEnum {
  Text = 'TEXT',
  Html = 'HTML'
}

export enum ChamberMemberProEmailRecipientRoutingModeEnum {
  TestInboxOverride = 'TEST_INBOX_OVERRIDE',
  LiveRecipients = 'LIVE_RECIPIENTS'
}

export type ChamberMemberProEmailSettingsInput = {
  senderEmail: Scalars['String'];
  replyToEmail: Scalars['String'];
  recipientRoutingMode: ChamberMemberProEmailRecipientRoutingModeEnum;
  newsletterTestRecipientRoutingMode?: Maybe<ChamberMemberProNewsletterTestRecipientRoutingModeEnum>;
  enabledSenderEmails: Array<Scalars['String']>;
  emailTemplates: Array<ChamberMemberProEmailTemplateInput>;
};

export type ChamberMemberProEmailSettingsReturn = {
  __typename?: 'ChamberMemberProEmailSettingsReturn';
  senderEmail: Scalars['String'];
  replyToEmail: Scalars['String'];
  recipientRoutingMode: ChamberMemberProEmailRecipientRoutingModeEnum;
  newsletterTestRecipientRoutingMode: ChamberMemberProNewsletterTestRecipientRoutingModeEnum;
  enabledSenderEmails: Array<Scalars['String']>;
  emailTemplates: Array<ChamberMemberProEmailTemplateReturn>;
  subscriberTargets: Array<ChamberMemberProEmailSubscriberTargetReturn>;
  senderDomain: ChamberMemberProSenderDomainSettingsReturn;
};

export type ChamberMemberProEmailSubscriberTargetReturn = {
  __typename?: 'ChamberMemberProEmailSubscriberTargetReturn';
  calendarYear: Scalars['Float'];
  target: Scalars['Float'];
  updatedAtUtcMilli: Scalars['Float'];
};

export type ChamberMemberProEmailTemplateInput = {
  bodyFormat?: Maybe<ChamberMemberProEmailBodyFormatEnum>;
  toEmails?: Maybe<Array<Scalars['String']>>;
  ccEmails?: Maybe<Array<Scalars['String']>>;
  bccEmails?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  subject: Scalars['String'];
  body: Scalars['String'];
  senderEmail?: Maybe<Scalars['String']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type ChamberMemberProEmailTemplateReturn = {
  __typename?: 'ChamberMemberProEmailTemplateReturn';
  bodyFormat?: Maybe<ChamberMemberProEmailBodyFormatEnum>;
  toEmails?: Maybe<Array<Scalars['String']>>;
  ccEmails?: Maybe<Array<Scalars['String']>>;
  bccEmails?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  subject: Scalars['String'];
  body: Scalars['String'];
  senderEmail?: Maybe<Scalars['String']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum ChamberMemberProEventTicketCreditCardPaymentModeEnum {
  Disabled = 'DISABLED',
  NonMemberTickets = 'NON_MEMBER_TICKETS',
  AllTickets = 'ALL_TICKETS'
}

export type ChamberMemberProGovernanceGroupInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ChamberMemberProGovernanceGroupReturn = {
  __typename?: 'ChamberMemberProGovernanceGroupReturn';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ChamberMemberProGovernanceSettingsInput = {
  boards: Array<ChamberMemberProGovernanceGroupInput>;
  committees: Array<ChamberMemberProGovernanceGroupInput>;
  taskForces: Array<ChamberMemberProGovernanceGroupInput>;
};

export type ChamberMemberProGovernanceSettingsReturn = {
  __typename?: 'ChamberMemberProGovernanceSettingsReturn';
  boards: Array<ChamberMemberProGovernanceGroupReturn>;
  committees: Array<ChamberMemberProGovernanceGroupReturn>;
  taskForces: Array<ChamberMemberProGovernanceGroupReturn>;
};

export type ChamberMemberProInvoiceBillingContactInput = {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ChamberMemberProInvoiceBillingContactReturn = {
  __typename?: 'ChamberMemberProInvoiceBillingContactReturn';
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export enum ChamberMemberProInvoicePaymentTermsEnum {
  DueUponReceipt = 'DUE_UPON_RECEIPT',
  Net_30 = 'NET_30',
  Net_45 = 'NET_45'
}

export type ChamberMemberProInvoiceTaxCategorySettingsInput = {
  enabled: Scalars['Boolean'];
  firstTaxRateLabel?: Maybe<Scalars['String']>;
  firstTaxRatePercentage: Scalars['Float'];
  secondTaxRateLabel?: Maybe<Scalars['String']>;
  secondTaxRatePercentage: Scalars['Float'];
};

export type ChamberMemberProInvoiceTaxCategorySettingsReturn = {
  __typename?: 'ChamberMemberProInvoiceTaxCategorySettingsReturn';
  enabled: Scalars['Boolean'];
  firstTaxRateLabel: Scalars['String'];
  firstTaxRatePercentage: Scalars['Float'];
  secondTaxRateLabel: Scalars['String'];
  secondTaxRatePercentage: Scalars['Float'];
};

export type ChamberMemberProInvoiceTaxSettingsInput = {
  membershipInvoices: ChamberMemberProInvoiceTaxCategorySettingsInput;
  sponsorshipInvoices: ChamberMemberProInvoiceTaxCategorySettingsInput;
  eventTicketsInvoices: ChamberMemberProInvoiceTaxCategorySettingsInput;
  advertisingInvoices: ChamberMemberProInvoiceTaxCategorySettingsInput;
};

export type ChamberMemberProInvoiceTaxSettingsReturn = {
  __typename?: 'ChamberMemberProInvoiceTaxSettingsReturn';
  membershipInvoices: ChamberMemberProInvoiceTaxCategorySettingsReturn;
  sponsorshipInvoices: ChamberMemberProInvoiceTaxCategorySettingsReturn;
  eventTicketsInvoices: ChamberMemberProInvoiceTaxCategorySettingsReturn;
  advertisingInvoices: ChamberMemberProInvoiceTaxCategorySettingsReturn;
};

export type ChamberMemberProManualPaymentMethodInput = {
  id: Scalars['String'];
  label: Scalars['String'];
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  emailSubject: Scalars['String'];
  emailBody: Scalars['String'];
};

export type ChamberMemberProManualPaymentMethodReturn = {
  __typename?: 'ChamberMemberProManualPaymentMethodReturn';
  id: Scalars['String'];
  label: Scalars['String'];
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  emailSubject: Scalars['String'];
  emailBody: Scalars['String'];
};

export enum ChamberMemberProManualPaymentMethodTypeEnum {
  InvoiceMe = 'INVOICE_ME',
  Cash = 'CASH',
  Cheque = 'CHEQUE',
  ETransfer = 'E_TRANSFER',
  DirectDeposit = 'DIRECT_DEPOSIT'
}

export type ChamberMemberProMemberBenefitInput = {
  id: Scalars['String'];
  label: Scalars['String'];
};

export type ChamberMemberProMemberBenefitReturn = {
  __typename?: 'ChamberMemberProMemberBenefitReturn';
  id: Scalars['String'];
  label: Scalars['String'];
};

export type ChamberMemberProMembershipAdditionalCostInput = {
  id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
  annualAmountInDollars: Scalars['Float'];
  monthlyAmountInDollars: Scalars['Float'];
  accountNumber: Scalars['String'];
  description: Scalars['String'];
  feeType?: Maybe<ChamberMemberProAdditionalCostFeeTypeEnum>;
  percentage?: Maybe<Scalars['Float']>;
  taxExempt?: Maybe<Scalars['Boolean']>;
};

export type ChamberMemberProMembershipAdditionalCostReturn = {
  __typename?: 'ChamberMemberProMembershipAdditionalCostReturn';
  id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
  annualAmountInDollars: Scalars['Float'];
  monthlyAmountInDollars: Scalars['Float'];
  accountNumber: Scalars['String'];
  description: Scalars['String'];
  feeType: ChamberMemberProAdditionalCostFeeTypeEnum;
  percentage?: Maybe<Scalars['Float']>;
  taxExempt: Scalars['Boolean'];
};

export type ChamberMemberProMembershipApplicationCommunicationOptionsInput = {
  emailEnabled: Scalars['Boolean'];
  phoneEnabled: Scalars['Boolean'];
  textMessageEnabled: Scalars['Boolean'];
};

export type ChamberMemberProMembershipApplicationCommunicationOptionsReturn = {
  __typename?: 'ChamberMemberProMembershipApplicationCommunicationOptionsReturn';
  emailEnabled: Scalars['Boolean'];
  phoneEnabled: Scalars['Boolean'];
  textMessageEnabled: Scalars['Boolean'];
};

export type ChamberMemberProMembershipDiscountSettingsInput = {
  enabled: Scalars['Boolean'];
};

export type ChamberMemberProMembershipDiscountSettingsReturn = {
  __typename?: 'ChamberMemberProMembershipDiscountSettingsReturn';
  enabled: Scalars['Boolean'];
};

export type ChamberMemberProMembershipEmployeeRangeInput = {
  id: Scalars['String'];
  code: Scalars['String'];
  from: Scalars['Float'];
  to?: Maybe<Scalars['Float']>;
  annualPriceInDollars: Scalars['Float'];
  monthlyPriceInDollars: Scalars['Float'];
  memberTarget?: Maybe<Scalars['Float']>;
};

export type ChamberMemberProMembershipEmployeeRangeReturn = {
  __typename?: 'ChamberMemberProMembershipEmployeeRangeReturn';
  id: Scalars['String'];
  code: Scalars['String'];
  from: Scalars['Float'];
  to?: Maybe<Scalars['Float']>;
  annualPriceInDollars: Scalars['Float'];
  monthlyPriceInDollars: Scalars['Float'];
  memberTarget?: Maybe<Scalars['Float']>;
};

export type ChamberMemberProMembershipModelInput = {
  id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  publicMembershipApplicationEnabled: Scalars['Boolean'];
  position: Scalars['Float'];
  memberTarget: Scalars['Float'];
  paymentResponsibility: ChamberMemberProMembershipModelPaymentResponsibilityEnum;
  thirdPartyPayerName?: Maybe<Scalars['String']>;
  thirdPartyPaymentNotes?: Maybe<Scalars['String']>;
  pricingModel: ChamberMemberProMembershipPricingModelEnum;
  annualPriceInDollars: Scalars['Float'];
  monthlyPriceInDollars: Scalars['Float'];
  includedBenefitIds: Array<Scalars['String']>;
  additionalCosts: Array<ChamberMemberProMembershipAdditionalCostInput>;
  ranges: Array<ChamberMemberProMembershipEmployeeRangeInput>;
  iconUrl?: Maybe<Scalars['String']>;
  eligibilityEmployeesFrom?: Maybe<Scalars['Float']>;
  eligibilityEmployeesTo?: Maybe<Scalars['Float']>;
};

export enum ChamberMemberProMembershipModelPaymentResponsibilityEnum {
  MemberPays = 'MEMBER_PAYS',
  ThirdPartyPays = 'THIRD_PARTY_PAYS',
  NoCharge = 'NO_CHARGE'
}

export type ChamberMemberProMembershipModelReturn = {
  __typename?: 'ChamberMemberProMembershipModelReturn';
  id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
  publicMembershipApplicationEnabled: Scalars['Boolean'];
  position: Scalars['Float'];
  memberTarget: Scalars['Float'];
  paymentResponsibility: ChamberMemberProMembershipModelPaymentResponsibilityEnum;
  thirdPartyPayerName?: Maybe<Scalars['String']>;
  thirdPartyPaymentNotes?: Maybe<Scalars['String']>;
  pricingModel: ChamberMemberProMembershipPricingModelEnum;
  annualPriceInDollars: Scalars['Float'];
  monthlyPriceInDollars: Scalars['Float'];
  includedBenefitIds: Array<Scalars['String']>;
  additionalCosts: Array<ChamberMemberProMembershipAdditionalCostReturn>;
  ranges: Array<ChamberMemberProMembershipEmployeeRangeReturn>;
  iconUrl?: Maybe<Scalars['String']>;
  eligibilityEmployeesFrom?: Maybe<Scalars['Float']>;
  eligibilityEmployeesTo?: Maybe<Scalars['Float']>;
};

export enum ChamberMemberProMembershipPricingModelEnum {
  Fixed = 'FIXED',
  EmployeeRange = 'EMPLOYEE_RANGE'
}

export type ChamberMemberProMembershipSettingsInput = {
  enabledPaymentSchedules: Array<ChamberMemberProPaymentScheduleEnum>;
  renewalNoticeDays: Scalars['Float'];
  autoRenewalNoticeDays: Scalars['Float'];
  renewalReminderOneDays: Scalars['Float'];
  renewalReminderTwoDays: Scalars['Float'];
  partTimeEmployeesPerFullTime: Scalars['Float'];
  allowAutoRenewal: Scalars['Boolean'];
  requireApproval: Scalars['Boolean'];
  autoApproveRenewals: Scalars['Boolean'];
  paymentBeforeApprovalRule: ChamberMemberProPaymentBeforeApprovalRuleEnum;
  proratedSignupPricingEnabled: Scalars['Boolean'];
  memberBenefits: Array<ChamberMemberProMemberBenefitInput>;
  membershipModels: Array<ChamberMemberProMembershipModelInput>;
  proratedSignupPrices: Array<ChamberMemberProProratedSignupPriceInput>;
  membershipOptionsIntro?: Maybe<Scalars['String']>;
};

export type ChamberMemberProMembershipSettingsReturn = {
  __typename?: 'ChamberMemberProMembershipSettingsReturn';
  enabledPaymentSchedules: Array<ChamberMemberProPaymentScheduleEnum>;
  renewalNoticeDays: Scalars['Float'];
  autoRenewalNoticeDays: Scalars['Float'];
  renewalReminderOneDays: Scalars['Float'];
  renewalReminderTwoDays: Scalars['Float'];
  partTimeEmployeesPerFullTime: Scalars['Float'];
  allowAutoRenewal: Scalars['Boolean'];
  requireApproval: Scalars['Boolean'];
  autoApproveRenewals: Scalars['Boolean'];
  paymentBeforeApprovalRule: ChamberMemberProPaymentBeforeApprovalRuleEnum;
  proratedSignupPricingEnabled: Scalars['Boolean'];
  memberBenefits: Array<ChamberMemberProMemberBenefitReturn>;
  membershipModels: Array<ChamberMemberProMembershipModelReturn>;
  proratedSignupPrices: Array<ChamberMemberProProratedSignupPriceReturn>;
  membershipOptionsIntro?: Maybe<Scalars['String']>;
};

export type ChamberMemberProMonthDayInput = {
  month: MonthEnum;
  day: Scalars['Float'];
};

export type ChamberMemberProMonthDayReturn = {
  __typename?: 'ChamberMemberProMonthDayReturn';
  month: MonthEnum;
  day: Scalars['Float'];
};

export type ChamberMemberProMonthlyMembershipAdministrativeFeeSettingsInput = {
  enabled: Scalars['Boolean'];
  amountInDollars: Scalars['Float'];
};

export type ChamberMemberProMonthlyMembershipAdministrativeFeeSettingsReturn = {
  __typename?: 'ChamberMemberProMonthlyMembershipAdministrativeFeeSettingsReturn';
  enabled: Scalars['Boolean'];
  amountInDollars: Scalars['Float'];
};

export type ChamberMemberProMultipleBillingDatesInput = {
  enabled: Scalars['Boolean'];
  firstBillingDate: ChamberMemberProMonthDayInput;
  secondBillingDate: ChamberMemberProMonthDayInput;
};

export type ChamberMemberProMultipleBillingDatesReturn = {
  __typename?: 'ChamberMemberProMultipleBillingDatesReturn';
  enabled: Scalars['Boolean'];
  firstBillingDate: ChamberMemberProMonthDayReturn;
  secondBillingDate: ChamberMemberProMonthDayReturn;
};

export enum ChamberMemberProNewsletterTestRecipientRoutingModeEnum {
  SafeInboxOverride = 'SAFE_INBOX_OVERRIDE',
  ExplicitRecipients = 'EXPLICIT_RECIPIENTS'
}

export type ChamberMemberProOneTimeOnboardingFeeSettingsInput = {
  enabled: Scalars['Boolean'];
  code: Scalars['String'];
  description: Scalars['String'];
  amountInDollars: Scalars['Float'];
};

export type ChamberMemberProOneTimeOnboardingFeeSettingsReturn = {
  __typename?: 'ChamberMemberProOneTimeOnboardingFeeSettingsReturn';
  enabled: Scalars['Boolean'];
  code: Scalars['String'];
  description: Scalars['String'];
  amountInDollars: Scalars['Float'];
};

export enum ChamberMemberProPagePermissionsEnum {
  ChamberAdminMyChamberAnalytics = 'CHAMBER_ADMIN__MY_CHAMBER__ANALYTICS',
  ChamberAdminMyChamberManageChamberProfile = 'CHAMBER_ADMIN__MY_CHAMBER__MANAGE_CHAMBER_PROFILE',
  ChamberAdminMyChamberManageChamberTeam = 'CHAMBER_ADMIN__MY_CHAMBER__MANAGE_CHAMBER_TEAM',
  ChamberAdminMyChamberGlobalSettings = 'CHAMBER_ADMIN__MY_CHAMBER__GLOBAL_SETTINGS',
  ChamberAdminMyChamberMembershipSettings = 'CHAMBER_ADMIN__MY_CHAMBER__MEMBERSHIP_SETTINGS',
  ChamberAdminMyChamberEmailAndCommunicationSettings = 'CHAMBER_ADMIN__MY_CHAMBER__EMAIL_AND_COMMUNICATION_SETTINGS',
  ChamberAdminMyChamberAffinityProgramSetup = 'CHAMBER_ADMIN__MY_CHAMBER__AFFINITY_PROGRAM_SETUP',
  ChamberAdminProspectsCreateProspect = 'CHAMBER_ADMIN__PROSPECTS__CREATE_PROSPECT',
  ChamberAdminProspectsManageProspect = 'CHAMBER_ADMIN__PROSPECTS__MANAGE_PROSPECT',
  ChamberAdminMembersAnalytics = 'CHAMBER_ADMIN__MEMBERS__ANALYTICS',
  ChamberAdminMembersCreateMember = 'CHAMBER_ADMIN__MEMBERS__CREATE_MEMBER',
  ChamberAdminMembersManageMember = 'CHAMBER_ADMIN__MEMBERS__MANAGE_MEMBER',
  ChamberAdminMembersMembershipSettings = 'CHAMBER_ADMIN__MEMBERS__MEMBERSHIP_SETTINGS',
  ChamberAdminEventsAnalytics = 'CHAMBER_ADMIN__EVENTS__ANALYTICS',
  ChamberAdminEventsCreateEvent = 'CHAMBER_ADMIN__EVENTS__CREATE_EVENT',
  ChamberAdminEventsManageEvent = 'CHAMBER_ADMIN__EVENTS__MANAGE_EVENT',
  ChamberAdminEventsManageTicketSales = 'CHAMBER_ADMIN__EVENTS__MANAGE_TICKET_SALES',
  ChamberAdminEventsManageSponsorshipSales = 'CHAMBER_ADMIN__EVENTS__MANAGE_SPONSORSHIP_SALES',
  ChamberAdminWebsiteAnalytics = 'CHAMBER_ADMIN__WEBSITE__ANALYTICS',
  ChamberAdminWebsiteManageWebsite = 'CHAMBER_ADMIN__WEBSITE__MANAGE_WEBSITE',
  ChamberAdminEmailAnalytics = 'CHAMBER_ADMIN__EMAIL__ANALYTICS',
  ChamberAdminEmailCreateEmail = 'CHAMBER_ADMIN__EMAIL__CREATE_EMAIL',
  ChamberAdminEmailManageEmails = 'CHAMBER_ADMIN__EMAIL__MANAGE_EMAILS',
  ChamberAdminInvoicingAnalytics = 'CHAMBER_ADMIN__INVOICING__ANALYTICS',
  ChamberAdminInvoicingCreateInvoice = 'CHAMBER_ADMIN__INVOICING__CREATE_INVOICE',
  ChamberAdminInvoicingManageInvoices = 'CHAMBER_ADMIN__INVOICING__MANAGE_INVOICES',
  ChamberAdminReports = 'CHAMBER_ADMIN__REPORTS',
  ChamberAdminSurveyEngine = 'CHAMBER_ADMIN__SURVEY_ENGINE',
  ChamberAdminCalculators = 'CHAMBER_ADMIN__CALCULATORS',
  ChamberAdminViewUserActivityLog = 'CHAMBER_ADMIN__VIEW_USER_ACTIVITY_LOG',
  ChamberAdminSupport = 'CHAMBER_ADMIN__SUPPORT',
  ChamberAdminSettingsMyProfile = 'CHAMBER_ADMIN__SETTINGS__MY_PROFILE',
  ChamberAdminSettingsResetPassword = 'CHAMBER_ADMIN__SETTINGS__RESET_PASSWORD'
}

export enum ChamberMemberProPaymentBeforeApprovalRuleEnum {
  AllowPaymentBeforeApproval = 'ALLOW_PAYMENT_BEFORE_APPROVAL',
  CollectPaymentAfterApproval = 'COLLECT_PAYMENT_AFTER_APPROVAL'
}

export enum ChamberMemberProPaymentScheduleEnum {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

export type ChamberMemberProPaymentsAndTaxesSettingsInput = {
  eTransferEmail?: Maybe<Scalars['String']>;
  paidInvoiceReceiptCopy?: Maybe<ChamberMemberProChamberInvoiceCopySettingsInput>;
  createdInvoiceCopy?: Maybe<ChamberMemberProChamberInvoiceCopySettingsInput>;
  taxJurisdictionId: Scalars['String'];
  taxRegistrationNumber?: Maybe<Scalars['String']>;
  invoiceStartNumber: Scalars['String'];
  cardProcessingFee: ChamberMemberProCardProcessingFeeSettingsInput;
  manualPaymentMethods: Array<ChamberMemberProManualPaymentMethodInput>;
  provincialChamberFee: ChamberMemberProProvincialChamberFeeSettingsInput;
  invoiceTaxSettings: ChamberMemberProInvoiceTaxSettingsInput;
  monthlyMembershipAdministrativeFee: ChamberMemberProMonthlyMembershipAdministrativeFeeSettingsInput;
  membershipDiscount: ChamberMemberProMembershipDiscountSettingsInput;
  oneTimeOnboardingFee: ChamberMemberProOneTimeOnboardingFeeSettingsInput;
  eventTicketCreditCardPaymentMode: ChamberMemberProEventTicketCreditCardPaymentModeEnum;
  onlineMembershipCreditCardPaymentRequired?: Maybe<Scalars['Boolean']>;
  accountAllocations: Array<ChamberMemberProAccountAllocationInput>;
  chamberGroupInsurancePayment: ChamberMemberProChamberGroupInsurancePaymentSettingsInput;
  invoicePaymentTerms: ChamberMemberProInvoicePaymentTermsEnum;
  overdueInvoiceLateFeePercentage: Scalars['Float'];
  overdueInvoiceLateFeeAmountInDollars?: Maybe<Scalars['Float']>;
  overdueInvoiceLateFeeEnabled?: Maybe<Scalars['Boolean']>;
  invoiceBillingContact?: Maybe<ChamberMemberProInvoiceBillingContactInput>;
  stripeConnectMode?: Maybe<ChamberMemberProStripeConnectModeEnum>;
};

export type ChamberMemberProPaymentsAndTaxesSettingsReturn = {
  __typename?: 'ChamberMemberProPaymentsAndTaxesSettingsReturn';
  eTransferEmail?: Maybe<Scalars['String']>;
  paidInvoiceReceiptCopy: ChamberMemberProChamberInvoiceCopySettingsReturn;
  createdInvoiceCopy: ChamberMemberProChamberInvoiceCopySettingsReturn;
  taxJurisdictionId: Scalars['String'];
  taxRegistrationNumber?: Maybe<Scalars['String']>;
  invoiceStartNumber: Scalars['String'];
  invoiceStartNumberLocked: Scalars['Boolean'];
  cardProcessingFee: ChamberMemberProCardProcessingFeeSettingsReturn;
  manualPaymentMethods: Array<ChamberMemberProManualPaymentMethodReturn>;
  provincialChamberFee: ChamberMemberProProvincialChamberFeeSettingsReturn;
  invoiceTaxSettings: ChamberMemberProInvoiceTaxSettingsReturn;
  monthlyMembershipAdministrativeFee: ChamberMemberProMonthlyMembershipAdministrativeFeeSettingsReturn;
  membershipDiscount: ChamberMemberProMembershipDiscountSettingsReturn;
  oneTimeOnboardingFee: ChamberMemberProOneTimeOnboardingFeeSettingsReturn;
  eventTicketCreditCardPaymentMode: ChamberMemberProEventTicketCreditCardPaymentModeEnum;
  /** @deprecated Removed setting. Always false. */
  onlineMembershipCreditCardPaymentRequired: Scalars['Boolean'];
  accountAllocations: Array<ChamberMemberProAccountAllocationReturn>;
  chamberGroupInsurancePayment: ChamberMemberProChamberGroupInsurancePaymentSettingsReturn;
  invoicePaymentTerms: ChamberMemberProInvoicePaymentTermsEnum;
  overdueInvoiceLateFeePercentage: Scalars['Float'];
  overdueInvoiceLateFeeAmountInDollars: Scalars['Float'];
  overdueInvoiceLateFeeEnabled: Scalars['Boolean'];
  invoiceBillingContact: ChamberMemberProInvoiceBillingContactReturn;
  stripeConnect: ChamberMemberProStripeConnectSettingsReturn;
};

export type ChamberMemberProPermissionsNeededInput = {
  anyEnabledPermissionNeeded?: Maybe<Scalars['Boolean']>;
  chamberAdmin_EnabledPagesNeeded?: Maybe<Array<ChamberMemberProPagePermissionsEnum>>;
};

export type ChamberMemberProProratedSignupPriceInput = {
  pricingKey: Scalars['String'];
  month: MonthEnum;
  priceInDollars: Scalars['Float'];
  membershipMonths?: Maybe<Scalars['Int']>;
};

export type ChamberMemberProProratedSignupPriceReturn = {
  __typename?: 'ChamberMemberProProratedSignupPriceReturn';
  pricingKey: Scalars['String'];
  month: MonthEnum;
  priceInDollars: Scalars['Float'];
  membershipMonths?: Maybe<Scalars['Int']>;
};

export type ChamberMemberProProvincialChamberFeeSettingsInput = {
  enabled: Scalars['Boolean'];
  amountInDollars: Scalars['Float'];
  showSeparateOnInvoice: Scalars['Boolean'];
};

export type ChamberMemberProProvincialChamberFeeSettingsReturn = {
  __typename?: 'ChamberMemberProProvincialChamberFeeSettingsReturn';
  enabled: Scalars['Boolean'];
  amountInDollars: Scalars['Float'];
  showSeparateOnInvoice: Scalars['Boolean'];
};

export type ChamberMemberProSenderDomainDnsRecordReturn = {
  __typename?: 'ChamberMemberProSenderDomainDnsRecordReturn';
  type: ChamberMemberProSenderDomainDnsRecordTypeEnum;
  name: Scalars['String'];
  value: Scalars['String'];
};

export enum ChamberMemberProSenderDomainDnsRecordTypeEnum {
  Txt = 'TXT',
  Cname = 'CNAME'
}

export type ChamberMemberProSenderDomainSettingsReturn = {
  __typename?: 'ChamberMemberProSenderDomainSettingsReturn';
  status: ChamberMemberProSenderDomainStatusEnum;
  domain?: Maybe<Scalars['String']>;
  senderEmail?: Maybe<Scalars['String']>;
  dnsRecords: Array<ChamberMemberProSenderDomainDnsRecordReturn>;
  verificationStartedAtUtcMilli?: Maybe<Scalars['Float']>;
  verifiedAtUtcMilli?: Maybe<Scalars['Float']>;
  lastStatusCheckedAtUtcMilli?: Maybe<Scalars['Float']>;
  failureReason?: Maybe<Scalars['String']>;
};

export enum ChamberMemberProSenderDomainStatusEnum {
  NotConfigured = 'NOT_CONFIGURED',
  PendingVerification = 'PENDING_VERIFICATION',
  Verified = 'VERIFIED',
  Failed = 'FAILED'
}

export type ChamberMemberProSettingsInput = {
  governance?: Maybe<ChamberMemberProGovernanceSettingsInput>;
  setup: ChamberMemberProSetupSettingsInput;
  membership: ChamberMemberProMembershipSettingsInput;
  paymentsAndTaxes: ChamberMemberProPaymentsAndTaxesSettingsInput;
  email: ChamberMemberProEmailSettingsInput;
};

export type ChamberMemberProSettingsReturn = {
  __typename?: 'ChamberMemberProSettingsReturn';
  governance: ChamberMemberProGovernanceSettingsReturn;
  setup: ChamberMemberProSetupSettingsReturn;
  membership: ChamberMemberProMembershipSettingsReturn;
  paymentsAndTaxes: ChamberMemberProPaymentsAndTaxesSettingsReturn;
  email: ChamberMemberProEmailSettingsReturn;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum ChamberMemberProSettingsSectionEnum {
  GovernanceSettings = 'GOVERNANCE_SETTINGS',
  GlobalSettings = 'GLOBAL_SETTINGS',
  InvoicingOptions = 'INVOICING_OPTIONS',
  MembershipSettings = 'MEMBERSHIP_SETTINGS',
  EmailAndCommunicationSettings = 'EMAIL_AND_COMMUNICATION_SETTINGS'
}

export type ChamberMemberProSetupSettingsInput = {
  fiscalYearStartMonth: MonthEnum;
  fiscalYearStartDay: Scalars['Float'];
  currency: ChamberMemberProCurrencyEnum;
  timeZone: Scalars['String'];
  membershipRenewalFixedDateEnabled: Scalars['Boolean'];
  membershipRenewalFixedDateMonth: MonthEnum;
  membershipRenewalFixedDateDay: Scalars['Float'];
  multipleBillingDates?: Maybe<ChamberMemberProMultipleBillingDatesInput>;
  membershipApplicationCommunicationOptions?: Maybe<ChamberMemberProMembershipApplicationCommunicationOptionsInput>;
};

export type ChamberMemberProSetupSettingsReturn = {
  __typename?: 'ChamberMemberProSetupSettingsReturn';
  fiscalYearStartMonth: MonthEnum;
  fiscalYearStartDay: Scalars['Float'];
  currency: ChamberMemberProCurrencyEnum;
  timeZone: Scalars['String'];
  membershipRenewalFixedDateEnabled: Scalars['Boolean'];
  membershipRenewalFixedDateMonth: MonthEnum;
  membershipRenewalFixedDateDay: Scalars['Float'];
  multipleBillingDates: ChamberMemberProMultipleBillingDatesReturn;
  multipleBillingDatesAvailable?: Maybe<Scalars['Boolean']>;
  membershipApplicationCommunicationOptions: ChamberMemberProMembershipApplicationCommunicationOptionsReturn;
};

export enum ChamberMemberProStripeConnectModeEnum {
  Test = 'TEST',
  Live = 'LIVE'
}

export type ChamberMemberProStripeConnectSettingsReturn = {
  __typename?: 'ChamberMemberProStripeConnectSettingsReturn';
  mode: ChamberMemberProStripeConnectModeEnum;
  status: ChamberMemberProStripeConnectStatusEnum;
  connectedAccountId?: Maybe<Scalars['String']>;
  chargesEnabled: Scalars['Boolean'];
  payoutsEnabled: Scalars['Boolean'];
  detailsSubmitted: Scalars['Boolean'];
  creditCardPaymentsEnabled: Scalars['Boolean'];
  creditCardPaymentsReady?: Maybe<Scalars['Boolean']>;
  onboardingStartedAtUtcMilli?: Maybe<Scalars['Float']>;
  connectedAtUtcMilli?: Maybe<Scalars['Float']>;
  lastStatusCheckedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum ChamberMemberProStripeConnectStatusEnum {
  NotConnected = 'NOT_CONNECTED',
  OnboardingStarted = 'ONBOARDING_STARTED',
  Connected = 'CONNECTED',
  Restricted = 'RESTRICTED'
}

export type ChamberMemberReturn = {
  __typename?: 'ChamberMemberReturn';
  id: Scalars['String'];
  isChambersRootMember?: Maybe<Scalars['Boolean']>;
  chamberId: Scalars['String'];
  categoryId: Array<ChamberMemberCategory>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  threads?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  tiktok?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  googleReviewLink?: Maybe<Scalars['String']>;
  address: AddressReturn;
  hideAddressFromDirectory?: Maybe<Scalars['Boolean']>;
  phoneNumber: Scalars['String'];
  phoneNumberExtension?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  showInApp: Scalars['Boolean'];
  coordinates?: Maybe<CoordinateReturn>;
  hasSignedUp?: Maybe<Scalars['Boolean']>;
  firstLoginAfterSettingNewPermanentPasswordUtcMilli?: Maybe<Scalars['Float']>;
  numberOfUsers?: Maybe<Scalars['Float']>;
  adminConsoleLoginEmail?: Maybe<Scalars['String']>;
  adminConsoleContactName?: Maybe<Scalars['String']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  customContacts?: Maybe<Array<CustomContactReturn>>;
  lastDashboardLoginAtUtcMilli?: Maybe<Scalars['Float']>;
  dashboardLoginCountLast12Months?: Maybe<Scalars['Int']>;
  lastPasswordResetAtUtcMilli?: Maybe<Scalars['Float']>;
  credentialsSentAtUtcMilli?: Maybe<Scalars['Float']>;
  credentialsSentAtUtcMilliBeforeSigningUp?: Maybe<Scalars['Float']>;
  numberOfFavorites?: Maybe<Scalars['Float']>;
  currentLoggedInCapUserHasFavorited?: Maybe<Scalars['Boolean']>;
  activeMemberProfileAndPerksBannersSettings?: Maybe<ActiveMemberProfileAndPerksBannersSettingsReturn>;
  isSuspended?: Maybe<Scalars['Boolean']>;
  banner?: Maybe<Array<BannerReturn>>;
  showRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  views?: Maybe<Scalars['Float']>;
  cpaAdminCompanyAdminContactTitle?: Maybe<Scalars['String']>;
  cpaAdminCompanyAdminContactNumber?: Maybe<Scalars['String']>;
  cpaAdminCompanyAdminContactNumberExtension?: Maybe<Scalars['String']>;
  cpaAdminCompanyAdminContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  primaryContactName?: Maybe<Scalars['String']>;
  primaryContactTitle?: Maybe<Scalars['String']>;
  primaryContactEmail?: Maybe<Scalars['String']>;
  primaryContactPhoneNumber?: Maybe<Scalars['String']>;
  primaryContactPhoneNumberExtension?: Maybe<Scalars['String']>;
  primaryContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactName?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactEmail?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactTitle?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactNumber?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactNumberExtension?: Maybe<Scalars['String']>;
  cpaEmployeeAdoptionContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  lifecycleStatus?: Maybe<CmpMemberLifecycleStatusEnum>;
  seoTags?: Maybe<Array<Scalars['String']>>;
  cmpExtension?: Maybe<CmpMemberExtensionReturn>;
  cmpProfileSectionsSavedAt?: Maybe<Array<CmpProfileSectionSavedAtReturn>>;
};

export type ChamberMemberUserReturn = {
  __typename?: 'ChamberMemberUserReturn';
  chamberMemberAddedSuccessfully: Scalars['Boolean'];
  email: Scalars['String'];
  password: Scalars['String'];
  failureReason?: Maybe<Scalars['String']>;
  loginAvailability?: Maybe<MemberDashboardLoginAvailabilityReturn>;
};

export enum ChamberPerksAppAdminConsolePagePermissionsEnum {
  ChamberAdminAccessChamberDashboard = 'CHAMBER_ADMIN__ACCESS_CHAMBER_DASHBOARD'
}

export enum ChamberPerksAppSubscriptionPlanTypesEnum {
  Starter = 'STARTER',
  Standard = 'STANDARD'
}

export type ChamberReturn = {
  __typename?: 'ChamberReturn';
  id: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  website: Scalars['String'];
  address: AddressReturn;
  supportContactEmail: Scalars['String'];
  supportContactName?: Maybe<Scalars['String']>;
  administratorContactName?: Maybe<Scalars['String']>;
  administratorContactEmail?: Maybe<Scalars['String']>;
  billingContactName?: Maybe<Scalars['String']>;
  billingContactEmail?: Maybe<Scalars['String']>;
  signingAuthorityContactName?: Maybe<Scalars['String']>;
  signingAuthorityContactEmail?: Maybe<Scalars['String']>;
  supportLink?: Maybe<Scalars['String']>;
  secondarySupportEmail?: Maybe<Scalars['String']>;
  chamberSupportPageUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberExtension?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  threads?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  tiktok?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
  jobPostingLink?: Maybe<Scalars['String']>;
  jobPostingLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  jobPostingLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  eventsLink?: Maybe<Scalars['String']>;
  eventsLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  eventsLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  newsletterLink?: Maybe<Scalars['String']>;
  newsletterLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  newsletterLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  surveyLink?: Maybe<Scalars['String']>;
  surveyLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  surveyLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  advocacyWinsLink?: Maybe<Scalars['String']>;
  advocacyWinsLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  advocacyWinsLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  callForNominationsLink?: Maybe<Scalars['String']>;
  callForNominationsLinkUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  callForNominationsLinkShowRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  memberSignupLink?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  sponsorLogo?: Maybe<Scalars['String']>;
  sponsorLogoLink?: Maybe<Scalars['String']>;
  coordinates?: Maybe<CoordinateReturn>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  numberOfMembersFromInitialSubscriptionAgreement?: Maybe<Scalars['Float']>;
  subscriptionDate?: Maybe<Scalars['String']>;
  premiumChamberMarketerLink?: Maybe<Scalars['String']>;
  googleMapsApi_City_ProvinceShort_CountryShort: Scalars['String'];
  additionally_applicable_googleMapsApi_City_ProvinceShort_CountryShort?: Maybe<Array<Scalars['String']>>;
  isSandbox?: Maybe<Scalars['Boolean']>;
  allMemberLoginCredentialSuccessfulDownloadTimestampUtcMilli?: Maybe<Scalars['Float']>;
  allMemberMassSendLoginCredentialTimestampUtcMilli?: Maybe<Scalars['Float']>;
  directoryBanner?: Maybe<Array<BannerReturn>>;
  profileBanner?: Maybe<Array<BannerReturn>>;
  chamberEngageSettings: ChamberEngageSettingsReturn;
  hideInApp?: Maybe<Scalars['Boolean']>;
  purchasedItems?: Maybe<Array<ItemsPurchasableByChamberEnum>>;
  chamberMemberProWebsiteUrl?: Maybe<Scalars['String']>;
  subscriptionPlanType: ChamberPerksAppSubscriptionPlanTypesEnum;
};

export enum ChamberStaffAccountStatusEnum {
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED',
  DeletionPending = 'DELETION_PENDING'
}

export enum ChamberStaffCredentialDeliveryStatusEnum {
  NotSent = 'NOT_SENT',
  Suppressed = 'SUPPRESSED',
  Sent = 'SENT',
  Failed = 'FAILED',
  Unknown = 'UNKNOWN'
}

export type ChamberStaffUsagePermissionsInput = {
  chamberMemberPro_EnabledPages: Array<ChamberMemberProPagePermissionsEnum>;
  chamberPerksAppAdminConsole_EnabledPages: Array<ChamberPerksAppAdminConsolePagePermissionsEnum>;
};

export type ChamberStaffUserMutationReturn = {
  __typename?: 'ChamberStaffUserMutationReturn';
  staffUser: ChamberStaffUserReturn;
  credentialDeliveryStatus: ChamberStaffCredentialDeliveryStatusEnum;
  message?: Maybe<Scalars['String']>;
};

export type ChamberStaffUserReturn = {
  __typename?: 'ChamberStaffUserReturn';
  id: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  chamberId: Scalars['String'];
  userType: UserType;
  chamberAccountRole: ChamberAccountRoleEnum;
  accountStatus: ChamberStaffAccountStatusEnum;
  usagePermissions: UsagePermissionReturn;
  credentialDeliveryStatus: ChamberStaffCredentialDeliveryStatusEnum;
  credentialsLastSentAtUtcMilli?: Maybe<Scalars['Float']>;
  lastLoginAtUtcMilli?: Maybe<Scalars['Float']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli: Scalars['Float'];
};

export type ChambersStatsReturn = {
  __typename?: 'ChambersStatsReturn';
  name: Scalars['String'];
  subscriptionDate: Scalars['String'];
  subscriptionUTCMilli: Scalars['Float'];
  cpaDashboardLatestAccessAtUtcMilli?: Maybe<Scalars['Float']>;
  numberOfAppUsers: Scalars['Float'];
  numberOfAppUsersSignedUpWithAnEmployer: Scalars['Float'];
  numberOfAppUsersSignedUpWithoutAnEmployer: Scalars['Float'];
  numberOfLiveDiscounts: Scalars['Float'];
  numberOfDiscountViews: Scalars['Float'];
  numberOfDiscountRedemptions: Scalars['Float'];
  numberOfChamberMembersLiveOnApp: Scalars['Float'];
  numberOfSuspendedChamberMembers: Scalars['Float'];
  numberOfMembersFromInitialSubscriptionAgreement: Scalars['Float'];
  numberChangeInNumberOfChamberMembersBetweenNowAndInitial: Scalars['Float'];
  percentageChangeInNumberOfChamberMembersBetweenNowAndInitial: Scalars['Float'];
  numberOfChamberMembersLoggedInToAdminPortal: Scalars['Float'];
  percentageOfChamberMembersLoggedInToAdminPortal: Scalars['Float'];
  numberOfChamberMembersThatWereEmailedTheirCredentialsBeforeFirstLogin: Scalars['Float'];
  percentageOfChamberMembersThatWereEmailedTheirCredentialsBeforeFirstLogin: Scalars['Float'];
  numberOfChamberMembersOfferingLiveDiscounts: Scalars['Float'];
  percentageOfChamberMembersOfferingLiveDiscounts: Scalars['Float'];
  discountsPerCategoryBreakdown: Array<DiscountsPerCategoryBreakdownReturn>;
  numberOfAppUsersWithNewPerkNotificationEnabled: Scalars['Float'];
  percentageOfAppUsersWithNewPerkNotificationEnabled: Scalars['Float'];
  numberOfAppUsersWithEmployerAndNewPerkNotificationEnabled: Scalars['Float'];
  percentageOfAppUsersWithEmployerAndNewPerkNotificationEnabled: Scalars['Float'];
  numberOfAppUsersWithNearbyPerkNotificationEnabled: Scalars['Float'];
  percentageOfAppUsersWithNearbyPerkNotificationEnabled: Scalars['Float'];
};

export type ChangeAdminConsoleLoginEmailReturn = {
  __typename?: 'ChangeAdminConsoleLoginEmailReturn';
  adminConsoleLoginEmailChangedSuccessfully: Scalars['Boolean'];
  email: Scalars['String'];
  password: Scalars['String'];
  failureReason?: Maybe<Scalars['String']>;
  loginAvailability?: Maybe<MemberDashboardLoginAvailabilityReturn>;
};

export type ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerReturn = {
  __typename?: 'ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerReturn';
  autoApprovalUpdateSuccessful: Scalars['Boolean'];
};

export type ChangeChamberEventInput = {
  newChamberName: Scalars['String'];
  newChamberId: Scalars['String'];
  previousChamberName: Scalars['String'];
  previousChamberId: Scalars['String'];
};

export type ChangeCmpMemberMembershipInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  membership: CmpMemberMembershipChangeFieldsInput;
  operationId: Scalars['String'];
  expectedMemberUpdatedAtUtcMilli: Scalars['Float'];
  expectedCurrentInvoiceId?: Maybe<Scalars['String']>;
  renewalDetailsOnly?: Maybe<Scalars['Boolean']>;
};

export type ChangeCmpMemberMembershipReturn = {
  __typename?: 'ChangeCmpMemberMembershipReturn';
  changeCompletedSuccessfully: Scalars['Boolean'];
  operationId: Scalars['String'];
  outcome: CmpMemberMembershipChangeOutcomeEnum;
  reasonCode?: Maybe<CmpMemberMembershipChangeReasonCodeEnum>;
  message: Scalars['String'];
  conflictingInvoiceNumbers: Array<Scalars['String']>;
  detail: GetCmpMemberDetailReturn;
  replacedInvoice?: Maybe<CmpInvoiceReturn>;
  replacementInvoice?: Maybe<CmpInvoiceReturn>;
  effectiveAtUtcMilli?: Maybe<Scalars['Float']>;
  event?: Maybe<CmpOperationalEventReturn>;
  audit?: Maybe<CmpMemberMembershipChangeAuditReturn>;
};

export enum ClientsThatCanAccessApiEnum {
  ChamberPerksApp = 'CHAMBER_PERKS_APP',
  ChamberPerksAppAdminConsole = 'CHAMBER_PERKS_APP_ADMIN_CONSOLE',
  ChamberMemberPro = 'CHAMBER_MEMBER_PRO'
}

export type CmpAdvertisingOptionMutationReturn = {
  __typename?: 'CmpAdvertisingOptionMutationReturn';
  advertisingOptionSavedSuccessfully: Scalars['Boolean'];
  advertisingOption?: Maybe<CmpAdvertisingOptionReturn>;
};

export type CmpAdvertisingOptionReturn = {
  __typename?: 'CmpAdvertisingOptionReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Float'];
  sortOrder?: Maybe<Scalars['Float']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpAnalyticsAvailabilityEnum {
  Available = 'AVAILABLE',
  Partial = 'PARTIAL',
  Unavailable = 'UNAVAILABLE'
}

export type CmpAnalyticsBreakdownReturn = {
  __typename?: 'CmpAnalyticsBreakdownReturn';
  key: Scalars['String'];
  label: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
  count?: Maybe<Scalars['Float']>;
  percentage: Scalars['Float'];
  comparisonValue?: Maybe<Scalars['Float']>;
  comparisonPercentage?: Maybe<Scalars['Float']>;
};

export enum CmpAnalyticsBucketIntervalEnum {
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH'
}

export type CmpAnalyticsDateRangeInput = {
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type CmpAnalyticsDateRangeReturn = {
  __typename?: 'CmpAnalyticsDateRangeReturn';
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  startAtUtcMilli: Scalars['Float'];
  endExclusiveAtUtcMilli: Scalars['Float'];
  inclusiveDayCount: Scalars['Float'];
};

export type CmpAnalyticsEventFilterOptionsReturn = {
  __typename?: 'CmpAnalyticsEventFilterOptionsReturn';
  events: Array<CmpAnalyticsFilterOptionReturn>;
  eventTypes: Array<CmpAnalyticsFilterOptionReturn>;
  eventCodes: Array<CmpAnalyticsFilterOptionReturn>;
};

export type CmpAnalyticsFilterOptionReturn = {
  __typename?: 'CmpAnalyticsFilterOptionReturn';
  key: Scalars['String'];
  label: Scalars['String'];
  color?: Maybe<Scalars['String']>;
};

export type CmpAnalyticsFiltersInput = {
  memberModelIds?: Maybe<Array<Scalars['String']>>;
  membershipCategories?: Maybe<Array<ChamberMemberCategory>>;
  companySizeBucketKeys?: Maybe<Array<Scalars['String']>>;
  lifecycleStatuses?: Maybe<Array<CmpMemberLifecycleStatusEnum>>;
  eventIds?: Maybe<Array<Scalars['String']>>;
  eventTypeIds?: Maybe<Array<Scalars['String']>>;
  eventCodes?: Maybe<Array<Scalars['String']>>;
};

export type CmpAnalyticsListFieldReturn = {
  __typename?: 'CmpAnalyticsListFieldReturn';
  key: Scalars['String'];
  label: Scalars['String'];
  stringValue?: Maybe<Scalars['String']>;
  numberValue?: Maybe<Scalars['Float']>;
  unit?: Maybe<CmpAnalyticsMetricUnitEnum>;
  color?: Maybe<Scalars['String']>;
};

export type CmpAnalyticsListItemReturn = {
  __typename?: 'CmpAnalyticsListItemReturn';
  key: Scalars['String'];
  label: Scalars['String'];
  secondaryLabel?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  primaryValue?: Maybe<Scalars['Float']>;
  secondaryValue?: Maybe<Scalars['Float']>;
  tertiaryValue?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['String']>;
  fields: Array<CmpAnalyticsListFieldReturn>;
};

export enum CmpAnalyticsLookbackEnum {
  Days_30 = 'DAYS_30',
  Days_60 = 'DAYS_60',
  Days_90 = 'DAYS_90',
  Days_120 = 'DAYS_120'
}

export type CmpAnalyticsMemberFilterOptionsReturn = {
  __typename?: 'CmpAnalyticsMemberFilterOptionsReturn';
  membershipModels: Array<CmpAnalyticsFilterOptionReturn>;
  membershipCategories: Array<CmpAnalyticsFilterOptionReturn>;
  companySizeBuckets: Array<CmpAnalyticsFilterOptionReturn>;
  lifecycleStatuses: Array<CmpAnalyticsFilterOptionReturn>;
};

export type CmpAnalyticsMetadataReturn = {
  __typename?: 'CmpAnalyticsMetadataReturn';
  periodSource: CmpAnalyticsPeriodSourceEnum;
  timeZone: Scalars['String'];
  timeZoneLabel: Scalars['String'];
  currency: ChamberMemberProCurrencyEnum;
  currentPeriod: CmpAnalyticsDateRangeReturn;
  comparisonPeriod: CmpAnalyticsDateRangeReturn;
  generatedAtUtcMilli: Scalars['Float'];
  effectiveThroughLocalDate: Scalars['String'];
  availableFromLocalDate?: Maybe<Scalars['String']>;
  warnings: Array<CmpAnalyticsWarningReturn>;
};

export type CmpAnalyticsMetricReturn = {
  __typename?: 'CmpAnalyticsMetricReturn';
  availability: CmpAnalyticsAvailabilityEnum;
  unit: CmpAnalyticsMetricUnitEnum;
  value?: Maybe<Scalars['Float']>;
  comparisonValue?: Maybe<Scalars['Float']>;
  changePercent?: Maybe<Scalars['Float']>;
  trendDirection: CmpAnalyticsTrendDirectionEnum;
  trendSentiment: CmpAnalyticsTrendSentimentEnum;
  reason?: Maybe<Scalars['String']>;
};

export enum CmpAnalyticsMetricUnitEnum {
  Count = 'COUNT',
  CurrencyCents = 'CURRENCY_CENTS',
  Percent = 'PERCENT',
  Days = 'DAYS',
  Seconds = 'SECONDS'
}

export enum CmpAnalyticsPeriodSourceEnum {
  FiscalYearToDate = 'FISCAL_YEAR_TO_DATE',
  Custom = 'CUSTOM',
  RollingLookback = 'ROLLING_LOOKBACK'
}

export type CmpAnalyticsSectionReturn = {
  __typename?: 'CmpAnalyticsSectionReturn';
  availability: CmpAnalyticsAvailabilityEnum;
  reason?: Maybe<Scalars['String']>;
  series: Array<CmpAnalyticsSeriesPointReturn>;
  breakdown: Array<CmpAnalyticsBreakdownReturn>;
  items: Array<CmpAnalyticsListItemReturn>;
};

export type CmpAnalyticsSeriesPointReturn = {
  __typename?: 'CmpAnalyticsSeriesPointReturn';
  seriesKey: Scalars['String'];
  seriesLabel: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  bucketStartDate: Scalars['String'];
  bucketEndDate: Scalars['String'];
  bucketLabel: Scalars['String'];
  bucketInterval: CmpAnalyticsBucketIntervalEnum;
  value: Scalars['Float'];
  comparisonValue?: Maybe<Scalars['Float']>;
};

export enum CmpAnalyticsTrendDirectionEnum {
  Increase = 'INCREASE',
  Decrease = 'DECREASE',
  NoChange = 'NO_CHANGE',
  Unavailable = 'UNAVAILABLE'
}

export enum CmpAnalyticsTrendSentimentEnum {
  Favourable = 'FAVOURABLE',
  Adverse = 'ADVERSE',
  Neutral = 'NEUTRAL',
  Unavailable = 'UNAVAILABLE'
}

export type CmpAnalyticsWarningReturn = {
  __typename?: 'CmpAnalyticsWarningReturn';
  code: Scalars['String'];
  message: Scalars['String'];
  metricKeys: Array<Scalars['String']>;
};

export type CmpCalculatorDataReturn = {
  __typename?: 'CmpCalculatorDataReturn';
  members: Array<CmpCalculatorMemberReturn>;
  member?: Maybe<CmpMemberMetricsReturn>;
  cohortMemberCount: Scalars['Int'];
  cohortLifetimeValueInCents?: Maybe<Scalars['Float']>;
  cohortAverageLifetimeValueInCents?: Maybe<Scalars['Float']>;
  cohortUnavailableReason?: Maybe<Scalars['String']>;
  newMembersAcquired?: Maybe<Scalars['Int']>;
  timeZone: Scalars['String'];
  currency: ChamberMemberProCurrencyEnum;
  generatedAtUtcMilli: Scalars['Float'];
};

export type CmpCalculatorMemberReturn = {
  __typename?: 'CmpCalculatorMemberReturn';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CmpDuplicateMatchReturn = {
  __typename?: 'CmpDuplicateMatchReturn';
  id: Scalars['String'];
  lifecycleStatus?: Maybe<CmpMemberLifecycleStatusEnum>;
  companyName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  matchReasons: Array<Scalars['String']>;
};

export type CmpEmailCaptureAddressStatus = {
  __typename?: 'CmpEmailCaptureAddressStatus';
  address?: Maybe<Scalars['String']>;
  captureEnabled: Scalars['Boolean'];
};

export type CmpEmailSubscriberTargetMutationReturn = {
  __typename?: 'CmpEmailSubscriberTargetMutationReturn';
  target: ChamberMemberProEmailSubscriberTargetReturn;
  createdFromActiveMemberCount: Scalars['Boolean'];
};

export type CmpEventActionInput = {
  expectedUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  visibility?: Maybe<CmpEventVisibilityEnum>;
};

export type CmpEventAddressOptionReturn = {
  __typename?: 'CmpEventAddressOptionReturn';
  key: Scalars['String'];
  address: CmpEventPhysicalAddressReturn;
  provenance: Array<CmpEventAddressProvenanceEnum>;
  savedAddressId?: Maybe<Scalars['String']>;
  recentEventId?: Maybe<Scalars['String']>;
  savedAtUtcMilli?: Maybe<Scalars['Float']>;
  lastUsedAtUtcMilli?: Maybe<Scalars['Float']>;
  recencyUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpEventAddressProvenanceEnum {
  Saved = 'SAVED',
  Recent = 'RECENT'
}

export type CmpEventAgendaItemInput = {
  id?: Maybe<Scalars['String']>;
  timeLabel: Scalars['String'];
  details: Scalars['String'];
  sortOrder?: Maybe<Scalars['Float']>;
};

export type CmpEventAgendaItemReturn = {
  __typename?: 'CmpEventAgendaItemReturn';
  id: Scalars['String'];
  timeLabel: Scalars['String'];
  details: Scalars['String'];
  sortOrder?: Maybe<Scalars['Float']>;
};

export enum CmpEventAttendanceModeEnum {
  InPerson = 'IN_PERSON',
  Virtual = 'VIRTUAL',
  Either = 'EITHER'
}

export type CmpEventAttendeeCheckInReturn = {
  __typename?: 'CmpEventAttendeeCheckInReturn';
  isMember: Scalars['Boolean'];
  isComplimentary: Scalars['Boolean'];
  attendee: CmpEventAttendeeReturn;
  registrationId?: Maybe<Scalars['String']>;
  sponsorshipRequestId?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  sourceUpdatedAtUtcMilli: Scalars['Float'];
};

export type CmpEventAttendeeInput = {
  companyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ticketTypeId: Scalars['String'];
  status?: Maybe<CmpEventRegistrationStatusEnum>;
  customFieldAnswers?: Maybe<Array<CmpEventCustomFieldAnswerInput>>;
};

export type CmpEventAttendeeReturn = {
  __typename?: 'CmpEventAttendeeReturn';
  companyName?: Maybe<Scalars['String']>;
  preCheckedInAtUtcMilli?: Maybe<Scalars['Float']>;
  checkedInAtUtcMilli?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  ticketTypeId: Scalars['String'];
  ticketTypeNameSnapshot: Scalars['String'];
  attendanceMode: CmpEventAttendanceModeEnum;
  status: CmpEventRegistrationStatusEnum;
  customFieldAnswers: Array<CmpEventCustomFieldAnswerReturn>;
};

export type CmpEventCustomFieldAnswerInput = {
  fieldId: Scalars['String'];
  value: Scalars['String'];
};

export type CmpEventCustomFieldAnswerReturn = {
  __typename?: 'CmpEventCustomFieldAnswerReturn';
  fieldId: Scalars['String'];
  labelSnapshot?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type CmpEventCustomFieldInput = {
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  fieldType: CmpEventCustomFieldTypeEnum;
  scope: CmpEventCustomFieldScopeEnum;
  required: Scalars['Boolean'];
  helperText?: Maybe<Scalars['String']>;
  choices?: Maybe<Array<Scalars['String']>>;
  appliesToTicketTypeIds?: Maybe<Array<Scalars['String']>>;
  appliesToSponsorshipPackageIds?: Maybe<Array<Scalars['String']>>;
  sortOrder?: Maybe<Scalars['Float']>;
};

export type CmpEventCustomFieldReturn = {
  __typename?: 'CmpEventCustomFieldReturn';
  id: Scalars['String'];
  label: Scalars['String'];
  fieldType: CmpEventCustomFieldTypeEnum;
  scope: CmpEventCustomFieldScopeEnum;
  required: Scalars['Boolean'];
  helperText?: Maybe<Scalars['String']>;
  choices: Array<Scalars['String']>;
  appliesToTicketTypeIds: Array<Scalars['String']>;
  appliesToSponsorshipPackageIds: Array<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

export enum CmpEventCustomFieldScopeEnum {
  Purchaser = 'PURCHASER',
  Attendee = 'ATTENDEE',
  SponsorshipRequest = 'SPONSORSHIP_REQUEST'
}

export enum CmpEventCustomFieldTypeEnum {
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Select = 'SELECT',
  MultiSelect = 'MULTI_SELECT',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  FileUpload = 'FILE_UPLOAD'
}

export type CmpEventDataInput = {
  eventKind?: Maybe<CmpEventKindEnum>;
  externalEventUrl?: Maybe<Scalars['String']>;
  startDateOnly?: Maybe<Scalars['Boolean']>;
  endDateOnly?: Maybe<Scalars['Boolean']>;
  preCheckInEnabled?: Maybe<Scalars['Boolean']>;
  preCheckInHours?: Maybe<Scalars['Float']>;
  sponsorshipPublicDisplayEnabled?: Maybe<Scalars['Boolean']>;
  sponsorshipTaxMode?: Maybe<CmpEventSponsorshipTaxModeEnum>;
  publishAtUtcMilli?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  description: Scalars['String'];
  status?: Maybe<CmpEventStatusEnum>;
  startAtUtcMilli: Scalars['Float'];
  endAtUtcMilli: Scalars['Float'];
  timeZone: Scalars['String'];
  eventTypeId: Scalars['String'];
  eventTypeLabelSnapshot?: Maybe<Scalars['String']>;
  eventTypeColorSnapshot?: Maybe<Scalars['String']>;
  location: CmpEventLocationInput;
  maxAttendeeCapacity?: Maybe<Scalars['Float']>;
  featuredImageUrl?: Maybe<Scalars['String']>;
  visibility?: Maybe<CmpEventVisibilityEnum>;
  publicRegistrationEnabled?: Maybe<Scalars['Boolean']>;
  eventCode?: Maybe<Scalars['String']>;
  heroShortDescription?: Maybe<Scalars['String']>;
  hideHeroTitle?: Maybe<Scalars['Boolean']>;
  registrationDetailsHtml?: Maybe<Scalars['String']>;
  registrationQuestionSettingsJson?: Maybe<Scalars['String']>;
  specialVenueConsiderations?: Maybe<Scalars['String']>;
  dressCode?: Maybe<CmpEventDressCodeEnum>;
  speakers?: Maybe<Array<CmpEventSpeakerInput>>;
  partners?: Maybe<Array<CmpEventPartnerInput>>;
  agendaItems?: Maybe<Array<CmpEventAgendaItemInput>>;
  eventIsFree?: Maybe<Scalars['Boolean']>;
  displayRemainingTicketQuantity?: Maybe<Scalars['Boolean']>;
  displayRemainingTicketTypeQuantity?: Maybe<Scalars['Boolean']>;
  allowWaitlist?: Maybe<Scalars['Boolean']>;
  tickets: Array<CmpEventTicketTypeInput>;
  customFields?: Maybe<Array<CmpEventCustomFieldInput>>;
  sponsorshipEnabled?: Maybe<Scalars['Boolean']>;
  sponsorshipPackages?: Maybe<Array<CmpEventSponsorshipPackageInput>>;
  internalCosts?: Maybe<Array<CmpEventInternalCostInput>>;
  responsibilities?: Maybe<Array<CmpEventResponsibilityInput>>;
  notes?: Maybe<Array<CmpEventNoteInput>>;
};

export type CmpEventDraftReturn = {
  __typename?: 'CmpEventDraftReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  draftJson: Scalars['String'];
  revision: Scalars['Float'];
  updatedAtUtcMilli: Scalars['Float'];
};

export type CmpEventDraftSummaryReturn = {
  __typename?: 'CmpEventDraftSummaryReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  revision: Scalars['Float'];
  updatedAtUtcMilli: Scalars['Float'];
};

export enum CmpEventDressCodeEnum {
  Formal = 'FORMAL',
  BusinessAttire = 'BUSINESS_ATTIRE',
  Casual = 'CASUAL'
}

export type CmpEventInternalCostInput = {
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  amountInCents: Scalars['Float'];
  note?: Maybe<Scalars['String']>;
};

export type CmpEventInternalCostReturn = {
  __typename?: 'CmpEventInternalCostReturn';
  id: Scalars['String'];
  label: Scalars['String'];
  amountInCents: Scalars['Float'];
  note?: Maybe<Scalars['String']>;
};

export type CmpEventInvoiceDraftLineInput = {
  itemCode?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  unitPriceInCents: Scalars['Float'];
  subtotalAmountInCents: Scalars['Float'];
};

export enum CmpEventKindEnum {
  Standard = 'STANDARD',
  Community = 'COMMUNITY'
}

export type CmpEventLibraryItemMutationReturn = {
  __typename?: 'CmpEventLibraryItemMutationReturn';
  itemSavedSuccessfully: Scalars['Boolean'];
  item?: Maybe<CmpEventLibraryItemReturn>;
};

export type CmpEventLibraryItemReturn = {
  __typename?: 'CmpEventLibraryItemReturn';
  pairedValue?: Maybe<Scalars['String']>;
  attendeesPerTicket?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  chamberId: Scalars['String'];
  kind: CmpEventLibraryKindEnum;
  value: Scalars['String'];
  sortOrder?: Maybe<Scalars['Float']>;
  isArchived: Scalars['Boolean'];
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpEventLibraryKindEnum {
  SponsorCode = 'SPONSOR_CODE',
  SponsorName = 'SPONSOR_NAME',
  TicketCode = 'TICKET_CODE',
  TicketName = 'TICKET_NAME',
  Title = 'TITLE',
  Code = 'CODE'
}

export type CmpEventLocationInput = {
  mode: CmpEventLocationModeEnum;
  venueName?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  virtualDetails?: Maybe<Scalars['String']>;
};

export enum CmpEventLocationModeEnum {
  InPerson = 'IN_PERSON',
  Virtual = 'VIRTUAL',
  Hybrid = 'HYBRID'
}

export type CmpEventLocationReturn = {
  __typename?: 'CmpEventLocationReturn';
  mode: CmpEventLocationModeEnum;
  venueName?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  virtualDetails?: Maybe<Scalars['String']>;
};

export type CmpEventMutationReturn = {
  __typename?: 'CmpEventMutationReturn';
  eventSavedSuccessfully: Scalars['Boolean'];
  event?: Maybe<CmpEventReturn>;
};

export type CmpEventNoteInput = {
  id?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  visibility?: Maybe<Scalars['String']>;
};

export type CmpEventNoteReturn = {
  __typename?: 'CmpEventNoteReturn';
  id: Scalars['String'];
  body: Scalars['String'];
  visibility?: Maybe<Scalars['String']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpEventPartnerInput = {
  id?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  websiteUrl?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

export type CmpEventPartnerReturn = {
  __typename?: 'CmpEventPartnerReturn';
  id: Scalars['String'];
  logoUrl: Scalars['String'];
  websiteUrl?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

export enum CmpEventPaymentStatusEnum {
  NotRequired = 'NOT_REQUIRED',
  Unpaid = 'UNPAID',
  PaymentPending = 'PAYMENT_PENDING',
  Paid = 'PAID',
  Waived = 'WAIVED',
  Failed = 'FAILED',
  ActionRequired = 'ACTION_REQUIRED'
}

export type CmpEventPhysicalAddressReturn = {
  __typename?: 'CmpEventPhysicalAddressReturn';
  venueName?: Maybe<Scalars['String']>;
  streetAddress: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type CmpEventPricingPreviewLineItemReturn = {
  __typename?: 'CmpEventPricingPreviewLineItemReturn';
  ticketTypeId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  quantity: Scalars['Float'];
  unitAmountInCents: Scalars['Float'];
  lineTotalInCents: Scalars['Float'];
};

export type CmpEventPublicBillingInput = {
  companyName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type CmpEventRegistrationActionInput = {
  chamberId: Scalars['String'];
  operationId: Scalars['String'];
  eventId: Scalars['String'];
  registrationId: Scalars['String'];
};

export type CmpEventRegistrationMutationReturn = {
  __typename?: 'CmpEventRegistrationMutationReturn';
  registrationSavedSuccessfully: Scalars['Boolean'];
  registration?: Maybe<CmpEventRegistrationReturn>;
  event?: Maybe<CmpEventReturn>;
  creditInvoice?: Maybe<CmpInvoiceReturn>;
  refund?: Maybe<CmpRefundReturn>;
};

export type CmpEventRegistrationReturn = {
  __typename?: 'CmpEventRegistrationReturn';
  ticketQuantity?: Maybe<Scalars['Int']>;
  ticketQuantities?: Maybe<Array<CmpEventTicketQuantityReturn>>;
  reservedAttendeeCount?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  registrationNumber: Scalars['String'];
  status: CmpEventRegistrationStatusEnum;
  paymentStatus: CmpEventPaymentStatusEnum;
  paymentActionUnavailableReason?: Maybe<Scalars['String']>;
  purchaserFirstName: Scalars['String'];
  purchaserLastName: Scalars['String'];
  purchaserEmail: Scalars['String'];
  purchaserPhone?: Maybe<Scalars['String']>;
  selectedMemberCompanyId?: Maybe<Scalars['String']>;
  selectedMemberCompanyNameSnapshot?: Maybe<Scalars['String']>;
  billingSnapshot?: Maybe<CmpInvoiceBillingSnapshotReturn>;
  paymentChoice: CmpPaymentChoiceReturn;
  invoiceId?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
  subtotalInCents: Scalars['Float'];
  taxAmountInCents: Scalars['Float'];
  totalAmountInCents: Scalars['Float'];
  invoice?: Maybe<CmpInvoiceReturn>;
  payments: Array<CmpPaymentReturn>;
  outboundEmails: Array<CmpOutboundEmailReturn>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
  attendees: Array<CmpEventAttendeeReturn>;
  customFieldAnswers: Array<CmpEventCustomFieldAnswerReturn>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpEventRegistrationStatusEnum {
  Submitted = 'SUBMITTED',
  PaymentPending = 'PAYMENT_PENDING',
  Confirmed = 'CONFIRMED',
  Canceled = 'CANCELED',
  Attended = 'ATTENDED',
  NoShow = 'NO_SHOW'
}

export type CmpEventResponsibilityInput = {
  id?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  assignedTo?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export type CmpEventResponsibilityReturn = {
  __typename?: 'CmpEventResponsibilityReturn';
  id: Scalars['String'];
  label: Scalars['String'];
  assignedTo?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export type CmpEventReturn = {
  __typename?: 'CmpEventReturn';
  registrationClosesAtUtcMilli?: Maybe<Scalars['Float']>;
  duplicatedFromEventId?: Maybe<Scalars['String']>;
  privateGuestUrl?: Maybe<Scalars['String']>;
  eventKind?: Maybe<CmpEventKindEnum>;
  externalEventUrl?: Maybe<Scalars['String']>;
  startDateOnly?: Maybe<Scalars['Boolean']>;
  endDateOnly?: Maybe<Scalars['Boolean']>;
  preCheckInEnabled?: Maybe<Scalars['Boolean']>;
  preCheckInHours?: Maybe<Scalars['Float']>;
  sponsorshipPublicDisplayEnabled?: Maybe<Scalars['Boolean']>;
  sponsorshipTaxMode?: Maybe<CmpEventSponsorshipTaxModeEnum>;
  id: Scalars['String'];
  chamberId: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  status: CmpEventStatusEnum;
  slugLockedAtUtcMilli?: Maybe<Scalars['Float']>;
  publishAtUtcMilli?: Maybe<Scalars['Float']>;
  publishedAtUtcMilli?: Maybe<Scalars['Float']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  startAtUtcMilli: Scalars['Float'];
  endAtUtcMilli: Scalars['Float'];
  timeZone: Scalars['String'];
  eventTypeId: Scalars['String'];
  eventTypeLabelSnapshot: Scalars['String'];
  eventTypeColorSnapshot: Scalars['String'];
  location: CmpEventLocationReturn;
  maxAttendeeCapacity?: Maybe<Scalars['Float']>;
  attendeeCount: Scalars['Float'];
  featuredImageUrl?: Maybe<Scalars['String']>;
  visibility: CmpEventVisibilityEnum;
  publicRegistrationEnabled: Scalars['Boolean'];
  eventCode?: Maybe<Scalars['String']>;
  heroShortDescription?: Maybe<Scalars['String']>;
  hideHeroTitle?: Maybe<Scalars['Boolean']>;
  registrationDetailsHtml?: Maybe<Scalars['String']>;
  registrationQuestionSettingsJson?: Maybe<Scalars['String']>;
  specialVenueConsiderations?: Maybe<Scalars['String']>;
  dressCode?: Maybe<CmpEventDressCodeEnum>;
  speakers?: Maybe<Array<CmpEventSpeakerReturn>>;
  partners?: Maybe<Array<CmpEventPartnerReturn>>;
  agendaItems?: Maybe<Array<CmpEventAgendaItemReturn>>;
  eventIsFree?: Maybe<Scalars['Boolean']>;
  displayRemainingTicketQuantity?: Maybe<Scalars['Boolean']>;
  displayRemainingTicketTypeQuantity?: Maybe<Scalars['Boolean']>;
  allowWaitlist?: Maybe<Scalars['Boolean']>;
  sponsorshipEnabled: Scalars['Boolean'];
  ticketRevenueInCents: Scalars['Float'];
  sponsorshipRevenueInCents: Scalars['Float'];
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
  tickets: Array<CmpEventTicketTypeReturn>;
  customFields: Array<CmpEventCustomFieldReturn>;
  sponsorshipPackages: Array<CmpEventSponsorshipPackageReturn>;
  publicSponsorships?: Maybe<Array<CmpPublicEventSponsorReturn>>;
  internalCosts: Array<CmpEventInternalCostReturn>;
  responsibilities: Array<CmpEventResponsibilityReturn>;
  notes: Array<CmpEventNoteReturn>;
};

export type CmpEventSpeakerInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  isKeynote?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

export type CmpEventSpeakerReturn = {
  __typename?: 'CmpEventSpeakerReturn';
  id: Scalars['String'];
  name: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  isKeynote?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

export type CmpEventSponsorshipAddOnInput = {
  unitValueInCents?: Maybe<Scalars['Float']>;
  taxable?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
};

export type CmpEventSponsorshipAddOnReturn = {
  __typename?: 'CmpEventSponsorshipAddOnReturn';
  unitValueInCents?: Maybe<Scalars['Float']>;
  taxable?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  description: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
};

export type CmpEventSponsorshipPackageInput = {
  includedTicketValueInCents?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Float'];
  maxAvailable?: Maybe<Scalars['Float']>;
  publicDisplayEnabled: Scalars['Boolean'];
  websiteListingEnabled?: Maybe<Scalars['Boolean']>;
  heroBannerEnabled?: Maybe<Scalars['Boolean']>;
  includedAttendeeQuantity: Scalars['Float'];
  includedAttendeeTicketTypeId?: Maybe<Scalars['String']>;
  additionalBenefits?: Maybe<Scalars['String']>;
  addOns?: Maybe<Array<CmpEventSponsorshipAddOnInput>>;
  logoRequired?: Maybe<Scalars['Boolean']>;
  linkRequired?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

export type CmpEventSponsorshipPackageReturn = {
  __typename?: 'CmpEventSponsorshipPackageReturn';
  includedTicketValueInCents?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Float'];
  maxAvailable?: Maybe<Scalars['Float']>;
  remainingQuantity?: Maybe<Scalars['Float']>;
  publicDisplayEnabled: Scalars['Boolean'];
  websiteListingEnabled?: Maybe<Scalars['Boolean']>;
  heroBannerEnabled?: Maybe<Scalars['Boolean']>;
  includedAttendeeQuantity: Scalars['Float'];
  includedAttendeeTicketTypeId?: Maybe<Scalars['String']>;
  additionalBenefits?: Maybe<Scalars['String']>;
  addOns?: Maybe<Array<CmpEventSponsorshipAddOnReturn>>;
  logoRequired: Scalars['Boolean'];
  linkRequired: Scalars['Boolean'];
  sortOrder?: Maybe<Scalars['Float']>;
};

export type CmpEventSponsorshipRequestActionInput = {
  chamberId: Scalars['String'];
  operationId: Scalars['String'];
  eventId: Scalars['String'];
  sponsorshipRequestId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type CmpEventSponsorshipRequestMutationReturn = {
  __typename?: 'CmpEventSponsorshipRequestMutationReturn';
  sponsorshipRequestSavedSuccessfully: Scalars['Boolean'];
  sponsorshipRequest?: Maybe<CmpEventSponsorshipRequestReturn>;
  checkoutUrl?: Maybe<Scalars['String']>;
  creditInvoice?: Maybe<CmpInvoiceReturn>;
  refund?: Maybe<CmpRefundReturn>;
};

export type CmpEventSponsorshipRequestReturn = {
  __typename?: 'CmpEventSponsorshipRequestReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  sponsorshipPackageId: Scalars['String'];
  sponsorshipPackageNameSnapshot: Scalars['String'];
  status: CmpEventSponsorshipRequestStatusEnum;
  selectedMemberCompanyId?: Maybe<Scalars['String']>;
  selectedMemberCompanyNameSnapshot?: Maybe<Scalars['String']>;
  sponsorDisplayName: Scalars['String'];
  sponsorLogoUrl?: Maybe<Scalars['String']>;
  sponsorLogoLink?: Maybe<Scalars['String']>;
  /** Internal: the stored logo is the member logo (public pages follow the member, Monday D8). */
  sponsorLogoFromMember?: Maybe<Scalars['Boolean']>;
  purchaserFirstName: Scalars['String'];
  purchaserLastName: Scalars['String'];
  purchaserEmail: Scalars['String'];
  purchaserPhone?: Maybe<Scalars['String']>;
  paymentStatus: CmpEventPaymentStatusEnum;
  paymentActionUnavailableReason?: Maybe<Scalars['String']>;
  paymentChoice: CmpPaymentChoiceReturn;
  invoiceId?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
  billingSnapshot?: Maybe<CmpInvoiceBillingSnapshotReturn>;
  priceInCents: Scalars['Float'];
  includedAttendeeQuantity: Scalars['Float'];
  includedAttendees: Array<CmpEventAttendeeReturn>;
  additionalAttendees?: Maybe<Array<CmpEventAttendeeReturn>>;
  customFieldAnswers: Array<CmpEventCustomFieldAnswerReturn>;
  reviewedByUserId?: Maybe<Scalars['String']>;
  reviewedAtUtcMilli?: Maybe<Scalars['Float']>;
  rejectionEmailRequested?: Maybe<Scalars['Boolean']>;
  invoice?: Maybe<CmpInvoiceReturn>;
  payments: Array<CmpPaymentReturn>;
  outboundEmails: Array<CmpOutboundEmailReturn>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpEventSponsorshipRequestStatusEnum {
  PendingReview = 'PENDING_REVIEW',
  ApprovedAwaitingPayment = 'APPROVED_AWAITING_PAYMENT',
  PaymentPending = 'PAYMENT_PENDING',
  Live = 'LIVE',
  Rejected = 'REJECTED',
  Canceled = 'CANCELED',
  PaymentActionRequired = 'PAYMENT_ACTION_REQUIRED'
}

export enum CmpEventSponsorshipTaxModeEnum {
  Full = 'FULL',
  None = 'NONE',
  IncludedComponents = 'INCLUDED_COMPONENTS'
}

export enum CmpEventStatusEnum {
  Scheduled = 'SCHEDULED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Live = 'LIVE',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED'
}

export enum CmpEventTicketAudienceEnum {
  Everyone = 'EVERYONE',
  ActiveMembers = 'ACTIVE_MEMBERS',
  NonMembers = 'NON_MEMBERS',
  SponsorIncluded = 'SPONSOR_INCLUDED'
}

export type CmpEventTicketQuantityInput = {
  ticketTypeId: Scalars['String'];
  quantity: Scalars['Float'];
};

export type CmpEventTicketQuantityReturn = {
  __typename?: 'CmpEventTicketQuantityReturn';
  ticketTypeId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type CmpEventTicketTypeInput = {
  id?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Float'];
  attendeesPerTicket?: Maybe<Scalars['Float']>;
  audience: CmpEventTicketAudienceEnum;
  attendanceMode: CmpEventAttendanceModeEnum;
  salesStartUtcMilli?: Maybe<Scalars['Float']>;
  salesEndUtcMilli?: Maybe<Scalars['Float']>;
  availabilityLimit?: Maybe<Scalars['Float']>;
  visibleOnRegistrationForm?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

export type CmpEventTicketTypeReturn = {
  __typename?: 'CmpEventTicketTypeReturn';
  id: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Float'];
  attendeesPerTicket: Scalars['Float'];
  audience: CmpEventTicketAudienceEnum;
  attendanceMode: CmpEventAttendanceModeEnum;
  salesStartUtcMilli?: Maybe<Scalars['Float']>;
  salesEndUtcMilli?: Maybe<Scalars['Float']>;
  availabilityLimit?: Maybe<Scalars['Float']>;
  remainingQuantity?: Maybe<Scalars['Float']>;
  visibleOnRegistrationForm?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

export type CmpEventTypeMutationReturn = {
  __typename?: 'CmpEventTypeMutationReturn';
  eventTypeSavedSuccessfully: Scalars['Boolean'];
  eventType?: Maybe<CmpEventTypeReturn>;
};

export type CmpEventTypeReturn = {
  __typename?: 'CmpEventTypeReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  label: Scalars['String'];
  color: Scalars['String'];
  sortOrder?: Maybe<Scalars['Float']>;
  isArchived: Scalars['Boolean'];
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpEventVisibilityEnum {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type CmpEventWaitlistEntryReturn = {
  __typename?: 'CmpEventWaitlistEntryReturn';
  id: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  ticketTypeId?: Maybe<Scalars['String']>;
  createdAtUtcMilli: Scalars['Float'];
};

export enum CmpExternalMembershipStandingEnum {
  NotTracked = 'NOT_TRACKED',
  PaidExternally = 'PAID_EXTERNALLY',
  UnpaidExternally = 'UNPAID_EXTERNALLY'
}

export enum CmpHostedCheckoutPresentationEnum {
  PhoneLink = 'PHONE_LINK',
  WalkInQr = 'WALK_IN_QR'
}

export type CmpInvoiceAccountingExportColumnReturn = {
  __typename?: 'CmpInvoiceAccountingExportColumnReturn';
  key: Scalars['String'];
  label: Scalars['String'];
  required: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
};

export enum CmpInvoiceAccountingExportProfileEnum {
  QuickbooksOnline = 'QUICKBOOKS_ONLINE',
  SageBusinessCloud = 'SAGE_BUSINESS_CLOUD',
  GenericCsv = 'GENERIC_CSV'
}

export type CmpInvoiceAccountingExportProfileReturn = {
  __typename?: 'CmpInvoiceAccountingExportProfileReturn';
  profile: CmpInvoiceAccountingExportProfileEnum;
  label: Scalars['String'];
  columns: Array<CmpInvoiceAccountingExportColumnReturn>;
};

export type CmpInvoiceAccountingExportReturn = {
  __typename?: 'CmpInvoiceAccountingExportReturn';
  profile: CmpInvoiceAccountingExportProfileEnum;
  filename: Scalars['String'];
  contentType: Scalars['String'];
  csv: Scalars['String'];
  payerDataWarning?: Maybe<Scalars['String']>;
  rowCount: Scalars['Float'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type CmpInvoiceActionAvailabilityReturn = {
  __typename?: 'CmpInvoiceActionAvailabilityReturn';
  action: CmpInvoiceActionTypeEnum;
  available: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type CmpInvoiceActionInput = {
  chamberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  voidReason?: Maybe<CmpInvoiceVoidReasonEnum>;
  reasonExplanation?: Maybe<Scalars['String']>;
  sourceEffect?: Maybe<CmpInvoiceSourceEffectEnum>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CmpInvoiceActionMutationReturn = {
  __typename?: 'CmpInvoiceActionMutationReturn';
  actionCompletedSuccessfully: Scalars['Boolean'];
  detail?: Maybe<GetCmpInvoiceDetailReturn>;
  outboundEmail?: Maybe<CmpOutboundEmailReturn>;
  payment?: Maybe<CmpPaymentReturn>;
  refund?: Maybe<CmpRefundReturn>;
  creditInvoice?: Maybe<CmpInvoiceReturn>;
  download?: Maybe<CmpInvoiceDownloadReturn>;
  export?: Maybe<CmpInvoiceAccountingExportReturn>;
};

export enum CmpInvoiceActionTypeEnum {
  View = 'VIEW',
  Edit = 'EDIT',
  Approve = 'APPROVE',
  DeleteDraft = 'DELETE_DRAFT',
  Void = 'VOID',
  VoidReissue = 'VOID_REISSUE',
  SendPaymentRequest = 'SEND_PAYMENT_REQUEST',
  ResendPaymentRequest = 'RESEND_PAYMENT_REQUEST',
  RecordManualPayment = 'RECORD_MANUAL_PAYMENT',
  StartCardCheckout = 'START_CARD_CHECKOUT',
  Refund = 'REFUND',
  IssueCredit = 'ISSUE_CREDIT',
  EmailDocument = 'EMAIL_DOCUMENT',
  DownloadPdf = 'DOWNLOAD_PDF',
  ExportAccountingCsv = 'EXPORT_ACCOUNTING_CSV'
}

export type CmpInvoiceBillingSnapshotInput = {
  customerName: Scalars['String'];
  contactName?: Maybe<Scalars['String']>;
  contactTitle?: Maybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactPhone?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type CmpInvoiceBillingSnapshotReturn = {
  __typename?: 'CmpInvoiceBillingSnapshotReturn';
  customerName: Scalars['String'];
  contactName?: Maybe<Scalars['String']>;
  contactTitle?: Maybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactPhone?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type CmpInvoiceCardCheckoutReturn = {
  __typename?: 'CmpInvoiceCardCheckoutReturn';
  invoiceId: Scalars['String'];
  invoiceNumber: Scalars['String'];
  installmentId?: Maybe<Scalars['String']>;
  checkoutSessionId: Scalars['String'];
  checkoutMode: CmpStaffCheckoutModeEnum;
  mode?: Maybe<CmpStaffCheckoutModeEnum>;
  clientSecret?: Maybe<Scalars['String']>;
  checkoutUrl?: Maybe<Scalars['String']>;
  publishableKey?: Maybe<Scalars['String']>;
  connectedAccountId?: Maybe<Scalars['String']>;
  amountInCents: Scalars['Float'];
  expiresAtUtcMilli: Scalars['Float'];
  presentation?: Maybe<CmpHostedCheckoutPresentationEnum>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type CmpInvoiceCategoryDefaultsReturn = {
  __typename?: 'CmpInvoiceCategoryDefaultsReturn';
  accountNumber: Scalars['String'];
  accountName: Scalars['String'];
  taxRateLabel: Scalars['String'];
  taxRatePercentage: Scalars['Float'];
  taxEnabled: Scalars['Boolean'];
};

export type CmpInvoiceCreateDefaultsReturn = {
  __typename?: 'CmpInvoiceCreateDefaultsReturn';
  advertising: CmpInvoiceCategoryDefaultsReturn;
  custom: CmpInvoiceCategoryDefaultsReturn;
  taxRegistrationNumber?: Maybe<Scalars['String']>;
  paymentTermsNote: Scalars['String'];
  billingInquiryEmail: Scalars['String'];
  billingInquiryContactName?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
};

export type CmpInvoiceCreditLinkReturn = {
  __typename?: 'CmpInvoiceCreditLinkReturn';
  invoiceId: Scalars['String'];
  invoiceNumber: Scalars['String'];
  creditedAtUtcMilli?: Maybe<Scalars['Float']>;
  creditedAmountInCents?: Maybe<Scalars['Float']>;
};

export enum CmpInvoiceCreditReasonEnum {
  CustomerCancelled = 'CUSTOMER_CANCELLED',
  EventRegistrationCancelled = 'EVENT_REGISTRATION_CANCELLED',
  MembershipCancelled = 'MEMBERSHIP_CANCELLED',
  SponsorshipAdvertisingCancelled = 'SPONSORSHIP_ADVERTISING_CANCELLED',
  BillingError = 'BILLING_ERROR',
  DuplicatePayment = 'DUPLICATE_PAYMENT',
  Other = 'OTHER'
}

export enum CmpInvoiceDirectionEnum {
  Debit = 'DEBIT',
  Credit = 'CREDIT'
}

export enum CmpInvoiceDisplayStateEnum {
  Draft = 'DRAFT',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Overdue = 'OVERDUE',
  NotPaid = 'NOT_PAID',
  Paid = 'PAID',
  Waived = 'WAIVED',
  Voided = 'VOIDED',
  Credited = 'CREDITED',
  Refunded = 'REFUNDED',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentAbandoned = 'PAYMENT_ABANDONED',
  PaymentExpired = 'PAYMENT_EXPIRED',
  ActionRequired = 'ACTION_REQUIRED'
}

export enum CmpInvoiceDocumentEmailModeEnum {
  InvoiceDocument = 'INVOICE_DOCUMENT',
  PaymentReceipt = 'PAYMENT_RECEIPT'
}

export type CmpInvoiceDownloadReturn = {
  __typename?: 'CmpInvoiceDownloadReturn';
  filename: Scalars['String'];
  contentType: Scalars['String'];
  base64Data: Scalars['String'];
  generatedAtUtcMilli: Scalars['Float'];
};

export enum CmpInvoiceKindEnum {
  Application = 'APPLICATION',
  AddOn = 'ADD_ON',
  Renewal = 'RENEWAL',
  EventRegistration = 'EVENT_REGISTRATION',
  EventSponsorship = 'EVENT_SPONSORSHIP',
  Advertising = 'ADVERTISING',
  Custom = 'CUSTOM'
}

export type CmpInvoiceLineItemInput = {
  id?: Maybe<Scalars['String']>;
  itemCode?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  quantity: Scalars['Float'];
  unitPriceInCents: Scalars['Float'];
  taxRatePercentage?: Maybe<Scalars['Float']>;
};

export type CmpInvoiceLineItemReturn = {
  __typename?: 'CmpInvoiceLineItemReturn';
  id: Scalars['String'];
  itemCode?: Maybe<Scalars['String']>;
  accountCode?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  quantity: Scalars['Float'];
  unitPriceInCents: Scalars['Float'];
  taxRatePercentage: Scalars['Float'];
  subtotalAmountInCents: Scalars['Float'];
  taxAmountInCents: Scalars['Float'];
  totalAmountInCents: Scalars['Float'];
  note?: Maybe<Scalars['String']>;
};

export type CmpInvoiceLineItemSuggestionReturn = {
  __typename?: 'CmpInvoiceLineItemSuggestionReturn';
  description: Scalars['String'];
  itemCode?: Maybe<Scalars['String']>;
  unitPriceInCents: Scalars['Float'];
  taxRatePercentage: Scalars['Float'];
};

export type CmpInvoiceLookupOptionReturn = {
  __typename?: 'CmpInvoiceLookupOptionReturn';
  id: Scalars['String'];
  label: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  sourceKind: CmpOperationalSourceKindEnum;
  chamberMemberId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventRegistrationId?: Maybe<Scalars['String']>;
  eventSponsorshipRequestId?: Maybe<Scalars['String']>;
  billingSnapshot: CmpInvoiceBillingSnapshotReturn;
};

export type CmpInvoiceMutationReturn = {
  __typename?: 'CmpInvoiceMutationReturn';
  invoiceSavedSuccessfully: Scalars['Boolean'];
  invoice?: Maybe<CmpInvoiceReturn>;
  detail?: Maybe<GetCmpInvoiceDetailReturn>;
};

export enum CmpInvoiceOverdueBucketEnum {
  NotApplicable = 'NOT_APPLICABLE',
  Current = 'CURRENT',
  OverdueUnder_60 = 'OVERDUE_UNDER_60',
  Overdue_60_89 = 'OVERDUE_60_89',
  Overdue_90_119 = 'OVERDUE_90_119',
  Overdue_120Plus = 'OVERDUE_120_PLUS'
}

export type CmpInvoicePaymentInstallmentReturn = {
  __typename?: 'CmpInvoicePaymentInstallmentReturn';
  id: Scalars['String'];
  sequenceNumber: Scalars['Float'];
  dueAtUtcMilli: Scalars['Float'];
  amountInCents: Scalars['Float'];
  amountPaidInCents: Scalars['Float'];
  status: CmpInvoicePaymentInstallmentStatusEnum;
  paidAtUtcMilli?: Maybe<Scalars['Float']>;
  paymentId?: Maybe<Scalars['String']>;
  stripeCheckoutSessionId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export enum CmpInvoicePaymentInstallmentStatusEnum {
  Upcoming = 'UPCOMING',
  Due = 'DUE',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Failed = 'FAILED',
  Canceled = 'CANCELED'
}

export type CmpInvoicePaymentPlanReturn = {
  __typename?: 'CmpInvoicePaymentPlanReturn';
  enabled: Scalars['Boolean'];
  paymentSchedule: ChamberMemberProPaymentScheduleEnum;
  totalInstallments: Scalars['Float'];
  paidInstallments: Scalars['Float'];
  overdueInstallments: Scalars['Float'];
  nextInstallmentId?: Maybe<Scalars['String']>;
  nextInstallmentDueAtUtcMilli?: Maybe<Scalars['Float']>;
  nextInstallmentAmountInCents?: Maybe<Scalars['Float']>;
  amountPaidInCents: Scalars['Float'];
  balanceDueInCents: Scalars['Float'];
  status: CmpInvoicePaymentPlanStatusEnum;
  installments: Array<CmpInvoicePaymentInstallmentReturn>;
};

export enum CmpInvoicePaymentPlanStatusEnum {
  NotApplicable = 'NOT_APPLICABLE',
  Active = 'ACTIVE',
  Paid = 'PAID',
  Overdue = 'OVERDUE'
}

export enum CmpInvoicePaymentRuleKindEnum {
  Standard = 'STANDARD',
  MonthlyCreditCardOnly = 'MONTHLY_CREDIT_CARD_ONLY',
  InsuranceDirectDepositOnly = 'INSURANCE_DIRECT_DEPOSIT_ONLY',
  EventMemberTickets = 'EVENT_MEMBER_TICKETS',
  EventNonMemberTickets = 'EVENT_NON_MEMBER_TICKETS'
}

export type CmpInvoicePaymentRulesReturn = {
  __typename?: 'CmpInvoicePaymentRulesReturn';
  ruleKind: CmpInvoicePaymentRuleKindEnum;
  summary: Scalars['String'];
  creditCardAllowed: Scalars['Boolean'];
  manualPaymentAllowed: Scalars['Boolean'];
  manualConfirmationRequired: Scalars['Boolean'];
  allowedManualPaymentMethodIds: Array<Scalars['String']>;
  allowedManualPaymentMethodLabels: Array<Scalars['String']>;
};

export enum CmpInvoicePaymentSurfaceStatusEnum {
  Pending = 'PENDING',
  Complete = 'COMPLETE',
  ReconciliationRequired = 'RECONCILIATION_REQUIRED'
}

export type CmpInvoicePresentationDefaultsReturn = {
  __typename?: 'CmpInvoicePresentationDefaultsReturn';
  billingInquiryEmail: Scalars['String'];
  billingInquiryContactName?: Maybe<Scalars['String']>;
  billingInquiryPhone?: Maybe<Scalars['String']>;
  eTransferEmail?: Maybe<Scalars['String']>;
  timeZone: Scalars['String'];
};

export type CmpInvoiceReturn = {
  __typename?: 'CmpInvoiceReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  chamberMemberId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventRegistrationId?: Maybe<Scalars['String']>;
  eventSponsorshipRequestId?: Maybe<Scalars['String']>;
  isCmpMemberModuleTestData?: Maybe<Scalars['Boolean']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
  invoiceKind?: Maybe<CmpInvoiceKindEnum>;
  sourceKind?: Maybe<CmpOperationalSourceKindEnum>;
  eventInvoiceDraftForm?: Maybe<Scalars['String']>;
  invoiceDirection?: Maybe<CmpInvoiceDirectionEnum>;
  creditForInvoiceId?: Maybe<Scalars['String']>;
  creditForInvoiceNumber?: Maybe<Scalars['String']>;
  creditSequenceNumber?: Maybe<Scalars['Float']>;
  eventNameSnapshot?: Maybe<Scalars['String']>;
  eventStartAtUtcMilliSnapshot?: Maybe<Scalars['Float']>;
  eventTimeZoneSnapshot?: Maybe<Scalars['String']>;
  renewalCycleDateUtcMilli?: Maybe<Scalars['Float']>;
  invoiceNumber: Scalars['String'];
  invoiceStatus: CmpInvoiceStatusEnum;
  internalOnly?: Maybe<Scalars['Boolean']>;
  paymentRequestState?: Maybe<CmpPaymentRequestStateEnum>;
  firstPaymentRequestSentAtUtcMilli?: Maybe<Scalars['Float']>;
  lastPaymentRequestSentAtUtcMilli?: Maybe<Scalars['Float']>;
  paymentChoice: CmpPaymentChoiceReturn;
  paymentPlan?: Maybe<CmpInvoicePaymentPlanReturn>;
  paymentRules?: Maybe<CmpInvoicePaymentRulesReturn>;
  pricingSnapshot: CmpMembershipPricingSnapshotReturn;
  billingSnapshot?: Maybe<CmpInvoiceBillingSnapshotReturn>;
  billToSnapshot?: Maybe<CmpInvoiceBillingSnapshotReturn>;
  lineItems?: Maybe<Array<CmpInvoiceLineItemReturn>>;
  subtotalAmountInCents?: Maybe<Scalars['Float']>;
  taxAmountInCents?: Maybe<Scalars['Float']>;
  totalAmountInCents?: Maybe<Scalars['Float']>;
  amountDueInCents: Scalars['Float'];
  waivedAmountInCents: Scalars['Float'];
  issuedAtUtcMilli: Scalars['Float'];
  dueAtUtcMilli?: Maybe<Scalars['Float']>;
  referencePurchaseOrder?: Maybe<Scalars['String']>;
  coveragePeriodStartUtcMilli?: Maybe<Scalars['Float']>;
  coveragePeriodEndUtcMilli?: Maybe<Scalars['Float']>;
  paidAtUtcMilli?: Maybe<Scalars['Float']>;
  voidedAtUtcMilli?: Maybe<Scalars['Float']>;
  refundedAtUtcMilli?: Maybe<Scalars['Float']>;
  refundedAmountInCents?: Maybe<Scalars['Float']>;
  creditedAmountInCents?: Maybe<Scalars['Float']>;
  creditReason?: Maybe<CmpInvoiceCreditReasonEnum>;
  creditReasonExplanation?: Maybe<Scalars['String']>;
  creditSourceEffect?: Maybe<CmpInvoiceSourceEffectEnum>;
  creditRefundMethodLabel?: Maybe<Scalars['String']>;
  creditRefundReference?: Maybe<Scalars['String']>;
  creditRefundedAtUtcMilli?: Maybe<Scalars['Float']>;
  creditedAtUtcMilli?: Maybe<Scalars['Float']>;
  creditedByUserId?: Maybe<Scalars['String']>;
  creditedByInvoices?: Maybe<Array<CmpInvoiceCreditLinkReturn>>;
  publicMemo?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  replacesInvoiceId?: Maybe<Scalars['String']>;
  replacementInvoiceId?: Maybe<Scalars['String']>;
  voidReason?: Maybe<Scalars['String']>;
  stripeCheckoutSessionId?: Maybe<Scalars['String']>;
  stripeCheckoutSessionMode?: Maybe<CmpStripeSessionModeEnum>;
  stripeCheckoutSessionExpiresAtUtcMilli?: Maybe<Scalars['Float']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripeSetupIntentId?: Maybe<Scalars['String']>;
  cmpPastTransitionPaymentSurfaceStatus?: Maybe<CmpInvoicePaymentSurfaceStatusEnum>;
  cmpPastTransitionPaymentSurfaceDetail?: Maybe<Scalars['String']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpInvoiceSourceEffectEnum {
  PreserveSource = 'PRESERVE_SOURCE',
  ReverseSource = 'REVERSE_SOURCE'
}

export enum CmpInvoiceSourceFilterEnum {
  All = 'ALL',
  Membership = 'MEMBERSHIP',
  EventTicket = 'EVENT_TICKET',
  EventSponsorship = 'EVENT_SPONSORSHIP',
  Advertising = 'ADVERTISING',
  Custom = 'CUSTOM'
}

export enum CmpInvoiceStatusEnum {
  NotInvoiced = 'NOT_INVOICED',
  Draft = 'DRAFT',
  Unpaid = 'UNPAID',
  Paid = 'PAID',
  Waived = 'WAIVED',
  Void = 'VOID',
  Credited = 'CREDITED',
  Refunded = 'REFUNDED'
}

export enum CmpInvoiceVoidReasonEnum {
  CustomerCancelled = 'CUSTOMER_CANCELLED',
  EventRegistrationCancelled = 'EVENT_REGISTRATION_CANCELLED',
  MembershipCancelled = 'MEMBERSHIP_CANCELLED',
  SponsorshipAdvertisingCancelled = 'SPONSORSHIP_ADVERTISING_CANCELLED',
  BillingError = 'BILLING_ERROR',
  DuplicatePayment = 'DUPLICATE_PAYMENT',
  Other = 'OTHER'
}

export type CmpManageEventRowReturn = {
  __typename?: 'CmpManageEventRowReturn';
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  timeZone?: Maybe<Scalars['String']>;
  eventKind?: Maybe<CmpEventKindEnum>;
  privateGuestUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
  eventCode?: Maybe<Scalars['String']>;
  eventTypeLabel: Scalars['String'];
  eventTypeColor: Scalars['String'];
  status: CmpEventStatusEnum;
  startAtUtcMilli: Scalars['Float'];
  endAtUtcMilli: Scalars['Float'];
  attendeeCount: Scalars['Float'];
  maxAttendeeCapacity?: Maybe<Scalars['Float']>;
  ticketRevenueInCents: Scalars['Float'];
  sponsorshipRevenueInCents: Scalars['Float'];
  sponsorsSold: Scalars['Float'];
  visibility: CmpEventVisibilityEnum;
  publishAtUtcMilli?: Maybe<Scalars['Float']>;
  locationLabel: Scalars['String'];
  paymentActionRequiredReason?: Maybe<Scalars['String']>;
  allowWaitlist: Scalars['Boolean'];
};

export enum CmpManageEventsSortColumnEnum {
  EventName = 'EVENT_NAME',
  EventType = 'EVENT_TYPE',
  Status = 'STATUS',
  Date = 'DATE',
  TicketRevenue = 'TICKET_REVENUE',
  SponsorshipRevenue = 'SPONSORSHIP_REVENUE',
  Attendees = 'ATTENDEES',
  Location = 'LOCATION'
}

export type CmpManageInvoiceFiltersInput = {
  invoiceNumberSearchQuery?: Maybe<Scalars['String']>;
  memberSearchQuery?: Maybe<Scalars['String']>;
  typeFilters?: Maybe<Array<CmpInvoiceSourceFilterEnum>>;
  statusFilters?: Maybe<Array<Scalars['String']>>;
  invoiceDateFromFilter?: Maybe<Scalars['String']>;
  invoiceDateToFilter?: Maybe<Scalars['String']>;
  dateTimeZone?: Maybe<Scalars['String']>;
  billingMethodFilters?: Maybe<Array<Scalars['String']>>;
};

export type CmpManageInvoiceRowReturn = {
  __typename?: 'CmpManageInvoiceRowReturn';
  id: Scalars['String'];
  invoiceNumber: Scalars['String'];
  customerName: Scalars['String'];
  sourceLabel: Scalars['String'];
  invoiceKind: CmpInvoiceKindEnum;
  invoiceDirection: CmpInvoiceDirectionEnum;
  creditForInvoiceNumber?: Maybe<Scalars['String']>;
  creditedByInvoiceNumbers?: Maybe<Array<Scalars['String']>>;
  displayState: CmpInvoiceDisplayStateEnum;
  overdueBucket: CmpInvoiceOverdueBucketEnum;
  daysPastDue?: Maybe<Scalars['Float']>;
  issuedAtUtcMilli: Scalars['Float'];
  dueAtUtcMilli?: Maybe<Scalars['Float']>;
  referencePurchaseOrder?: Maybe<Scalars['String']>;
  amountDueInCents: Scalars['Float'];
  totalAmountInCents: Scalars['Float'];
  totalPaidInCents: Scalars['Float'];
  refundableAmountInCents: Scalars['Float'];
  paidRevenueContributionInCents: Scalars['Float'];
  balanceDueInCents: Scalars['Float'];
  paymentMethodLabel: Scalars['String'];
  paymentPlan?: Maybe<CmpInvoicePaymentPlanReturn>;
  paymentRules: CmpInvoicePaymentRulesReturn;
  actualEmailRecipient?: Maybe<Scalars['String']>;
  intendedEmailRecipient?: Maybe<Scalars['String']>;
  latestInvoiceDeliverySentAtUtcMilli?: Maybe<Scalars['Float']>;
  latestInvoiceDocumentViewedAtUtcMilli?: Maybe<Scalars['Float']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
  payerDataWarning?: Maybe<Scalars['String']>;
  paymentRequestHoldReason?: Maybe<Scalars['String']>;
  sponsorshipLevelLabel?: Maybe<Scalars['String']>;
  availableActions: Array<CmpInvoiceActionAvailabilityReturn>;
};

export enum CmpManageInvoicesSortColumnEnum {
  InvoiceNumber = 'INVOICE_NUMBER',
  CustomerName = 'CUSTOMER_NAME',
  InvoiceKind = 'INVOICE_KIND',
  IssueDate = 'ISSUE_DATE',
  DueDate = 'DUE_DATE',
  AmountDue = 'AMOUNT_DUE',
  TotalAmount = 'TOTAL_AMOUNT',
  BalanceDue = 'BALANCE_DUE',
  DisplayState = 'DISPLAY_STATE',
  PaymentMethod = 'PAYMENT_METHOD'
}

export type CmpManageInvoicesSummaryReturn = {
  __typename?: 'CmpManageInvoicesSummaryReturn';
  awaitingPaymentAmountInCents: Scalars['Float'];
  overdueAmountInCents: Scalars['Float'];
  aging31To60AmountInCents: Scalars['Float'];
  aging61To90AmountInCents: Scalars['Float'];
  aging91To120AmountInCents: Scalars['Float'];
  aging120PlusAmountInCents: Scalars['Float'];
  totalCount: Scalars['Float'];
  draftCount: Scalars['Float'];
  awaitingPaymentCount: Scalars['Float'];
  unpaidCount: Scalars['Float'];
  paidCount: Scalars['Float'];
  waivedCount: Scalars['Float'];
  voidedCount: Scalars['Float'];
  refundedCount: Scalars['Float'];
  creditedCount: Scalars['Float'];
  overdueCount: Scalars['Float'];
  overdue60To89Count: Scalars['Float'];
  overdue90To119Count: Scalars['Float'];
  overdue120PlusCount: Scalars['Float'];
  totalAmountDueInCents: Scalars['Float'];
  totalInvoicedAmountInCents: Scalars['Float'];
  totalPaidAmountInCents: Scalars['Float'];
  monthlyPaymentPlanCount: Scalars['Float'];
  insuranceDirectDepositCount: Scalars['Float'];
};

export type CmpManageMemberInvoiceSummaryReturn = {
  __typename?: 'CmpManageMemberInvoiceSummaryReturn';
  id: Scalars['String'];
  invoiceNumber: Scalars['String'];
  invoiceStatus: CmpInvoiceStatusEnum;
  paymentChoiceType: CmpPaymentChoiceTypeEnum;
  paymentMethodLabel: Scalars['String'];
  amountDueInCents: Scalars['Float'];
  waivedAmountInCents: Scalars['Float'];
  totalAmountInCents: Scalars['Float'];
  issuedAtUtcMilli: Scalars['Float'];
  dueAtUtcMilli?: Maybe<Scalars['Float']>;
  paidAtUtcMilli?: Maybe<Scalars['Float']>;
  voidedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpManageMemberRowReturn = {
  __typename?: 'CmpManageMemberRowReturn';
  id: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  showInApp: Scalars['Boolean'];
  categoryId: Array<ChamberMemberCategory>;
  categoryLabels: Array<Scalars['String']>;
  lifecycleStatus: CmpMemberLifecycleStatusEnum;
  invoiceStatus: CmpInvoiceStatusEnum;
  externalMembershipStanding: CmpExternalMembershipStandingEnum;
  latestInvoice?: Maybe<CmpManageMemberInvoiceSummaryReturn>;
  membershipFeeInCents?: Maybe<Scalars['Float']>;
  paymentMethodLabel?: Maybe<Scalars['String']>;
  dateJoinedUtcMilli?: Maybe<Scalars['Float']>;
  membershipTypeId?: Maybe<Scalars['String']>;
  membershipTypeName?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<ChamberMemberProPaymentScheduleEnum>;
  fullTimeEmployees?: Maybe<Scalars['Float']>;
  partTimeEmployees?: Maybe<Scalars['Float']>;
  renewalDateUtcMilli?: Maybe<Scalars['Float']>;
  lastRenewedAtUtcMilli?: Maybe<Scalars['Float']>;
  lastUpdatedUtcMilli?: Maybe<Scalars['Float']>;
  searchText: Scalars['String'];
  isLegacy: Scalars['Boolean'];
  actionRequiredReason?: Maybe<Scalars['String']>;
  renewalBlockedReason?: Maybe<Scalars['String']>;
  billingAddressMissingReason?: Maybe<Scalars['String']>;
};

export type CmpManageMembersAnalyticsReturn = {
  __typename?: 'CmpManageMembersAnalyticsReturn';
  totalMembersYtd: Scalars['Float'];
  totalNewMembersYtd: Scalars['Float'];
  totalMemberCancellationsYtd: Scalars['Float'];
  totalSuspendedMembersYtd: Scalars['Float'];
  totalNewProspectMembersYtd: Scalars['Float'];
  totalMembershipRevenueYtdInCents: Scalars['Float'];
  previousFiscalYearTotalMembersYtd: Scalars['Float'];
  previousFiscalYearNewMembersYtd: Scalars['Float'];
  previousFiscalYearMemberCancellationsYtd: Scalars['Float'];
  previousFiscalYearSuspendedMembersYtd: Scalars['Float'];
  previousFiscalYearNewProspectMembersYtd: Scalars['Float'];
  previousFiscalYearMembershipRevenueYtdInCents: Scalars['Float'];
};

export enum CmpManageMembersSortColumnEnum {
  MemberCompany = 'MEMBER_COMPANY',
  InvoiceStatus = 'INVOICE_STATUS',
  MemberStatus = 'MEMBER_STATUS',
  MembershipFee = 'MEMBERSHIP_FEE',
  PaymentMethod = 'PAYMENT_METHOD',
  DateJoined = 'DATE_JOINED',
  MembershipType = 'MEMBERSHIP_TYPE',
  RenewalDate = 'RENEWAL_DATE',
  MemberSize = 'MEMBER_SIZE',
  LastUpdated = 'LAST_UPDATED'
}

export type CmpManageNewsletterRowReturn = {
  __typename?: 'CmpManageNewsletterRowReturn';
  campaignName: Scalars['String'];
  audienceLabel: Scalars['String'];
  tags: Array<Scalars['String']>;
  id: Scalars['String'];
  slug: Scalars['String'];
  subject: Scalars['String'];
  emailType: CmpNewsletterTypeEnum;
  status: CmpNewsletterStatusEnum;
  newsroomStatus: CmpNewsletterNewsroomStatusEnum;
  scheduledAtUtcMilli?: Maybe<Scalars['Float']>;
  sentAtUtcMilli?: Maybe<Scalars['Float']>;
  publishedAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  estimatedRecipientCount: Scalars['Float'];
  invalidRecipientCount: Scalars['Float'];
  skippedRecipientCount: Scalars['Float'];
  sentRecipientCount: Scalars['Float'];
  failedRecipientCount: Scalars['Float'];
  skippedDeliveryCount: Scalars['Float'];
  attachmentCount: Scalars['Float'];
  openCount: Scalars['Float'];
  clickCount: Scalars['Float'];
};

export enum CmpManageProspectsSortColumnEnum {
  ProspectCompany = 'PROSPECT_COMPANY',
  Contact = 'CONTACT',
  Email = 'EMAIL',
  LeadCapture = 'LEAD_CAPTURE',
  CreatedBy = 'CREATED_BY',
  CreatedDate = 'CREATED_DATE'
}

export type CmpMassCredentialEmailBlock = {
  __typename?: 'CmpMassCredentialEmailBlock';
  kind: CmpMassCredentialEmailBlockKindEnum;
  text?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Scalars['String']>>;
};

export type CmpMassCredentialEmailBlockInput = {
  kind: CmpMassCredentialEmailBlockKindEnum;
  text?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Scalars['String']>>;
};

export enum CmpMassCredentialEmailBlockKindEnum {
  Paragraph = 'PARAGRAPH',
  List = 'LIST'
}

export type CmpMassCredentialEmailEdits = {
  __typename?: 'CmpMassCredentialEmailEdits';
  intro: Array<CmpMassCredentialEmailBlock>;
  closing: Array<CmpMassCredentialEmailBlock>;
  signatureName?: Maybe<Scalars['String']>;
  signatureEmail?: Maybe<Scalars['String']>;
  signaturePhone?: Maybe<Scalars['String']>;
  isSaved: Scalars['Boolean'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpMassCredentialEmailEditsDataInput = {
  intro: Array<CmpMassCredentialEmailBlockInput>;
  closing: Array<CmpMassCredentialEmailBlockInput>;
  signatureName?: Maybe<Scalars['String']>;
  signatureEmail?: Maybe<Scalars['String']>;
  signaturePhone?: Maybe<Scalars['String']>;
};

export type CmpMassCredentialEmailEditsInput = {
  chamberId: Scalars['String'];
  edits: CmpMassCredentialEmailEditsDataInput;
};

export type CmpMemberActionInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type CmpMemberActionReturn = {
  __typename?: 'CmpMemberActionReturn';
  actionSuccessful: Scalars['Boolean'];
  detail: GetCmpMemberDetailReturn;
  event?: Maybe<CmpOperationalEventReturn>;
};

export type CmpMemberActivityReturn = {
  __typename?: 'CmpMemberActivityReturn';
  metrics: CmpMemberMetricsReturn;
  sponsorshipRevenueInCents: Scalars['Float'];
  advertisingRevenueInCents: Scalars['Float'];
  ticketRevenueInCents: Scalars['Float'];
  totalNonDuesRevenueInCents: Scalars['Float'];
  lifetimeValueInCents: Scalars['Float'];
  totalPerks: Scalars['Int'];
  activePerks: Scalars['Int'];
  perkViews?: Maybe<Scalars['Float']>;
  firstPerkAtUtcMilli?: Maybe<Scalars['Float']>;
  lastPerkAtUtcMilli?: Maybe<Scalars['Float']>;
  subscriberCount: Scalars['Int'];
  emailsSent: Scalars['Int'];
  emailsOpened: Scalars['Int'];
  emailOpenRate?: Maybe<Scalars['Float']>;
  joinedAtUtcMilli?: Maybe<Scalars['Float']>;
  lastLoginAtUtcMilli?: Maybe<Scalars['Float']>;
  loginsLast12Months?: Maybe<Scalars['Int']>;
  retentionScore?: Maybe<Scalars['Int']>;
  emails: Array<CmpMemberCommunicationEmailReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type CmpMemberAdministrativeFieldsInput = {
  dateJoinedUtcMilli: Scalars['Float'];
  renewalDateUtcMilli?: Maybe<Scalars['Float']>;
  externalMembershipStanding: CmpExternalMembershipStandingEnum;
};

export type CmpMemberAffiliatedChamberInput = {
  isAffiliatedChamberMember?: Maybe<Scalars['Boolean']>;
  chamberName?: Maybe<Scalars['String']>;
};

export type CmpMemberAffiliatedChamberReturn = {
  __typename?: 'CmpMemberAffiliatedChamberReturn';
  isAffiliatedChamberMember: Scalars['Boolean'];
  chamberName?: Maybe<Scalars['String']>;
};

export type CmpMemberAffinityProgramEnrollmentInput = {
  id?: Maybe<Scalars['String']>;
  affinityProgramPartnerId?: Maybe<Scalars['String']>;
  affinityProgramPartnerName?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  billingOption?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

export type CmpMemberAffinityProgramEnrollmentReturn = {
  __typename?: 'CmpMemberAffinityProgramEnrollmentReturn';
  id: Scalars['String'];
  affinityProgramPartnerId?: Maybe<Scalars['String']>;
  affinityProgramPartnerName?: Maybe<Scalars['String']>;
  idNumber?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  billingOption?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};

export type CmpMemberApplicationMetadataInput = {
  privacyPolicyAccepted?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  dashboardAccessRequestedContactIds?: Maybe<Array<Scalars['String']>>;
  primaryVotingSameAsMainCompanyContact?: Maybe<Scalars['Boolean']>;
  administratorSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  accountsPayableSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  employeeAdoptionSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  marketingCommunicationSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  hrEmployeeEngagementSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  marketingSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  hrSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  salesSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  authorizedToSubmitApplication?: Maybe<Scalars['Boolean']>;
  termsAccepted?: Maybe<Scalars['Boolean']>;
  emailUnsubscribeAcknowledged?: Maybe<Scalars['Boolean']>;
  communicationPreferences?: Maybe<Array<Scalars['String']>>;
};

export type CmpMemberApplicationMetadataReturn = {
  __typename?: 'CmpMemberApplicationMetadataReturn';
  privacyPolicyAccepted?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  dashboardAccessRequestedContactIds?: Maybe<Array<Scalars['String']>>;
  primaryVotingSameAsMainCompanyContact?: Maybe<Scalars['Boolean']>;
  administratorSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  accountsPayableSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  employeeAdoptionSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  marketingCommunicationSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  hrEmployeeEngagementSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  marketingSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  hrSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  salesSameAsCompanyPrimaryContact?: Maybe<Scalars['Boolean']>;
  authorizedToSubmitApplication?: Maybe<Scalars['Boolean']>;
  termsAccepted?: Maybe<Scalars['Boolean']>;
  emailUnsubscribeAcknowledged?: Maybe<Scalars['Boolean']>;
  communicationPreferences: Array<Scalars['String']>;
};

export type CmpMemberApplicationPaymentRequestCapability = {
  __typename?: 'CmpMemberApplicationPaymentRequestCapability';
  invoiceId: Scalars['String'];
  available: Scalars['Boolean'];
  isResend: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export enum CmpMemberApplicationSourceEnum {
  Dashboard = 'DASHBOARD',
  Website = 'WEBSITE'
}

export type CmpMemberApprovalPolicySnapshotReturn = {
  __typename?: 'CmpMemberApprovalPolicySnapshotReturn';
  version: Scalars['Float'];
  capturedAtUtcMilli: Scalars['Float'];
  boardApprovalRequired: Scalars['Boolean'];
  paymentBeforeApprovalRule: ChamberMemberProPaymentBeforeApprovalRuleEnum;
  controlledAutomaticActivationReason?: Maybe<Scalars['String']>;
};

export type CmpMemberAssociationInput = {
  isAssociateCompanyMember?: Maybe<Scalars['Boolean']>;
  primaryMemberCompanyId?: Maybe<Scalars['String']>;
};

export type CmpMemberAssociationReturn = {
  __typename?: 'CmpMemberAssociationReturn';
  isAssociateCompanyMember: Scalars['Boolean'];
  primaryMemberCompanyId?: Maybe<Scalars['String']>;
};

export type CmpMemberBillingAddressInput = {
  streetAddress?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type CmpMemberBillingAddressReturn = {
  __typename?: 'CmpMemberBillingAddressReturn';
  streetAddress?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type CmpMemberCommunicationAttachmentReturn = {
  __typename?: 'CmpMemberCommunicationAttachmentReturn';
  filename: Scalars['String'];
  contentType?: Maybe<Scalars['String']>;
  sizeBytes: Scalars['Int'];
};

export type CmpMemberCommunicationEmailReturn = {
  __typename?: 'CmpMemberCommunicationEmailReturn';
  senderDisplayName?: Maybe<Scalars['String']>;
  senderUserId?: Maybe<Scalars['String']>;
  ccEmails?: Maybe<Array<Scalars['String']>>;
  bodyFormat?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<CmpMemberCommunicationAttachmentReturn>>;
  id: Scalars['String'];
  subject: Scalars['String'];
  toEmail: Scalars['String'];
  fromEmail: Scalars['String'];
  sentAtUtcMilli: Scalars['Float'];
  body?: Maybe<Scalars['String']>;
};

export type CmpMemberCompanyDetailsInput = {
  yearEstablished?: Maybe<Scalars['String']>;
  howDidYouHearAboutUs?: Maybe<Array<Scalars['String']>>;
  howDidYouHearAboutUsOther?: Maybe<Scalars['String']>;
  primaryReasonsForJoining?: Maybe<Array<Scalars['String']>>;
  primaryReasonForJoiningOther?: Maybe<Scalars['String']>;
  activeSocialPlatforms?: Maybe<Array<Scalars['String']>>;
  boardOrCommitteeInterest?: Maybe<Scalars['String']>;
};

export type CmpMemberCompanyDetailsReturn = {
  __typename?: 'CmpMemberCompanyDetailsReturn';
  yearEstablished?: Maybe<Scalars['String']>;
  howDidYouHearAboutUs: Array<Scalars['String']>;
  howDidYouHearAboutUsOther?: Maybe<Scalars['String']>;
  primaryReasonsForJoining: Array<Scalars['String']>;
  primaryReasonForJoiningOther?: Maybe<Scalars['String']>;
  activeSocialPlatforms: Array<Scalars['String']>;
  boardOrCommitteeInterest?: Maybe<Scalars['String']>;
};

export enum CmpMemberContactAccountActionEnum {
  Enable = 'ENABLE',
  Disable = 'DISABLE',
  SendCredentials = 'SEND_CREDENTIALS',
  ResetPassword = 'RESET_PASSWORD',
  DownloadCredentials = 'DOWNLOAD_CREDENTIALS'
}

export type CmpMemberContactAccountActionReturn = {
  __typename?: 'CmpMemberContactAccountActionReturn';
  accounts: Array<CmpMemberContactAccountReturn>;
  memberUpdatedAtUtcMilli: Scalars['Float'];
  deliveryConfirmed: Scalars['Boolean'];
  trackingWarning?: Maybe<Scalars['String']>;
  credentials?: Maybe<CmpMemberContactCredentialsReturn>;
};

export type CmpMemberContactAccountInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  contactId: Scalars['String'];
  expectedMemberUpdatedAtUtcMilli: Scalars['Float'];
  action: CmpMemberContactAccountActionEnum;
};

export type CmpMemberContactAccountReturn = {
  __typename?: 'CmpMemberContactAccountReturn';
  contactId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  usesLegacyMemberAccount?: Maybe<Scalars['Boolean']>;
  credentialActionsBlockedReason?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  hasSignedUp: Scalars['Boolean'];
  accessEnabledAtUtcMilli?: Maybe<Scalars['Float']>;
  credentialsSentAtUtcMilli?: Maybe<Scalars['Float']>;
  lastPasswordResetAtUtcMilli?: Maybe<Scalars['Float']>;
  lastDashboardLoginAtUtcMilli?: Maybe<Scalars['Float']>;
  dashboardLoginCountLast12Months?: Maybe<Scalars['Int']>;
  dashboardPermissions?: Maybe<CmpMemberContactDashboardPermissionsReturn>;
};

export type CmpMemberContactCredentialsReturn = {
  __typename?: 'CmpMemberContactCredentialsReturn';
  email: Scalars['String'];
  password: Scalars['String'];
  emailHtml: Scalars['String'];
  emailSubject: Scalars['String'];
  loginUrl?: Maybe<Scalars['String']>;
};

export type CmpMemberContactDashboardPermissionsInput = {
  profile: Scalars['Boolean'];
  createPerks: Scalars['Boolean'];
  managePerks: Scalars['Boolean'];
  banners: Scalars['Boolean'];
  invoices: Scalars['Boolean'];
};

export type CmpMemberContactDashboardPermissionsReturn = {
  __typename?: 'CmpMemberContactDashboardPermissionsReturn';
  profile: Scalars['Boolean'];
  createPerks: Scalars['Boolean'];
  managePerks: Scalars['Boolean'];
  banners: Scalars['Boolean'];
  invoices: Scalars['Boolean'];
};

export type CmpMemberCustomFieldInput = {
  id?: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  value: Scalars['String'];
};

export type CmpMemberCustomFieldReturn = {
  __typename?: 'CmpMemberCustomFieldReturn';
  id: Scalars['String'];
  fieldName: Scalars['String'];
  value: Scalars['String'];
};

export type CmpMemberDashboardAccessReturn = {
  __typename?: 'CmpMemberDashboardAccessReturn';
  cmpEnabled: Scalars['Boolean'];
  contactId?: Maybe<Scalars['String']>;
  canManageProfile: Scalars['Boolean'];
  canManagePerks: Scalars['Boolean'];
  canCreatePerks: Scalars['Boolean'];
  canManageBanners: Scalars['Boolean'];
  canViewInvoices: Scalars['Boolean'];
  isPrimaryContact: Scalars['Boolean'];
  roleLabel?: Maybe<Scalars['String']>;
  perksOffered?: Maybe<Scalars['Boolean']>;
  testMode?: Maybe<CmpMemberDashboardTestModeReturn>;
};

export type CmpMemberDashboardChamberReturn = {
  __typename?: 'CmpMemberDashboardChamberReturn';
  chamberId: Scalars['String'];
  slug: Scalars['String'];
  name: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
};

export type CmpMemberDashboardHelpRequestReturn = {
  __typename?: 'CmpMemberDashboardHelpRequestReturn';
  chamberName: Scalars['String'];
  replyToEmail: Scalars['String'];
};

export enum CmpMemberDashboardTestContactTypeEnum {
  PrimaryContact = 'PRIMARY_CONTACT',
  AccountsPayable = 'ACCOUNTS_PAYABLE',
  SalesPerson = 'SALES_PERSON',
  Marketing = 'MARKETING',
  Administrative = 'ADMINISTRATIVE',
  Hr = 'HR'
}

export type CmpMemberDashboardTestModeInput = {
  plan?: Maybe<CmpMemberDashboardTestPlanEnum>;
  contactType?: Maybe<CmpMemberDashboardTestContactTypeEnum>;
  switchChamber?: Maybe<CmpMemberDashboardTestSwitchChamberEnum>;
};

export type CmpMemberDashboardTestModeReturn = {
  __typename?: 'CmpMemberDashboardTestModeReturn';
  available: Scalars['Boolean'];
  plan?: Maybe<CmpMemberDashboardTestPlanEnum>;
  contactType?: Maybe<CmpMemberDashboardTestContactTypeEnum>;
  switchChamber?: Maybe<CmpMemberDashboardTestSwitchChamberEnum>;
};

export enum CmpMemberDashboardTestPlanEnum {
  Accelerator = 'ACCELERATOR',
  Essentials = 'ESSENTIALS',
  CpaStandard = 'CPA_STANDARD',
  CpaBasic = 'CPA_BASIC'
}

export enum CmpMemberDashboardTestSwitchChamberEnum {
  Show = 'SHOW',
  Hide = 'HIDE'
}

export type CmpMemberExtensionInput = {
  governanceGroupIds?: Maybe<Array<Scalars['String']>>;
  association?: Maybe<CmpMemberAssociationInput>;
  membership?: Maybe<CmpMemberMembershipInput>;
  companyDetails?: Maybe<CmpMemberCompanyDetailsInput>;
  applicationMetadata?: Maybe<CmpMemberApplicationMetadataInput>;
  profile?: Maybe<CmpMemberProfileInput>;
  chamberPerksAppHeardAbout?: Maybe<Scalars['String']>;
  chamberPerksAppDownloaded?: Maybe<Scalars['String']>;
  boardDirectorInterest?: Maybe<Scalars['String']>;
  committeeInterest?: Maybe<Scalars['String']>;
  referralTracking?: Maybe<Array<CmpMemberReferralTrackingInput>>;
  affiliatedChamberMember?: Maybe<CmpMemberAffiliatedChamberInput>;
  affinityProgramEnrollments?: Maybe<Array<CmpMemberAffinityProgramEnrollmentInput>>;
  boardApprovalRequired?: Maybe<Scalars['Boolean']>;
  boardApprovedAtUtcMilli?: Maybe<Scalars['Float']>;
  boardApprovedByUserId?: Maybe<Scalars['String']>;
  paymentRequestState?: Maybe<CmpPaymentRequestStateEnum>;
  lastPaymentRequestSentAtUtcMilli?: Maybe<Scalars['Float']>;
  archivedAtUtcMilli?: Maybe<Scalars['Float']>;
  archiveReason?: Maybe<Scalars['String']>;
  accountsPayableContactName?: Maybe<Scalars['String']>;
  accountsPayableContactTitle?: Maybe<Scalars['String']>;
  accountsPayableContactEmail?: Maybe<Scalars['String']>;
  accountsPayableContactNumber?: Maybe<Scalars['String']>;
  accountsPayableContactNumberExtension?: Maybe<Scalars['String']>;
  accountsPayableContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  accountsPayableBillingAddress?: Maybe<CmpMemberBillingAddressInput>;
  marketingCommunicationContactName?: Maybe<Scalars['String']>;
  marketingCommunicationContactTitle?: Maybe<Scalars['String']>;
  marketingCommunicationContactEmail?: Maybe<Scalars['String']>;
  marketingCommunicationContactNumber?: Maybe<Scalars['String']>;
  marketingCommunicationContactNumberExtension?: Maybe<Scalars['String']>;
  marketingCommunicationContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactName?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactTitle?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactEmail?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactNumber?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactNumberExtension?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactName?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactTitle?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactEmail?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactNumber?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactNumberExtension?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactMobilePhoneNumber?: Maybe<Scalars['String']>;
};

export type CmpMemberExtensionReturn = {
  __typename?: 'CmpMemberExtensionReturn';
  governanceGroupIds: Array<Scalars['String']>;
  source: CmpMemberApplicationSourceEnum;
  isCmpMemberModuleTestData?: Maybe<Scalars['Boolean']>;
  association: CmpMemberAssociationReturn;
  membership?: Maybe<CmpMemberMembershipReturn>;
  companyDetails: CmpMemberCompanyDetailsReturn;
  applicationMetadata: CmpMemberApplicationMetadataReturn;
  profile: CmpMemberProfileReturn;
  chamberPerksAppHeardAbout?: Maybe<Scalars['String']>;
  chamberPerksAppDownloaded?: Maybe<Scalars['String']>;
  boardDirectorInterest?: Maybe<Scalars['String']>;
  committeeInterest?: Maybe<Scalars['String']>;
  referralTracking: Array<CmpMemberReferralTrackingReturn>;
  affiliatedChamberMember: CmpMemberAffiliatedChamberReturn;
  affinityProgramEnrollments: Array<CmpMemberAffinityProgramEnrollmentReturn>;
  latestInvoiceId?: Maybe<Scalars['String']>;
  pendingMembershipChange?: Maybe<CmpMemberPendingMembershipChangeReturn>;
  submittedAtUtcMilli?: Maybe<Scalars['Float']>;
  createdByUserId?: Maybe<Scalars['String']>;
  dateJoinedUtcMilli?: Maybe<Scalars['Float']>;
  externalMembershipStanding?: Maybe<CmpExternalMembershipStandingEnum>;
  membershipTrackingUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  membershipTrackingUpdatedByUserId?: Maybe<Scalars['String']>;
  approvalPolicySnapshot?: Maybe<CmpMemberApprovalPolicySnapshotReturn>;
  boardApprovalRequired: Scalars['Boolean'];
  boardApprovedAtUtcMilli?: Maybe<Scalars['Float']>;
  boardApprovedByUserId?: Maybe<Scalars['String']>;
  paymentRequestState: CmpPaymentRequestStateEnum;
  lastPaymentRequestSentAtUtcMilli?: Maybe<Scalars['Float']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  stripeSetupIntentId?: Maybe<Scalars['String']>;
  stripeCardSavedAtUtcMilli?: Maybe<Scalars['Float']>;
  archivedAtUtcMilli?: Maybe<Scalars['Float']>;
  archiveReason?: Maybe<Scalars['String']>;
  declinedAtUtcMilli?: Maybe<Scalars['Float']>;
  declineReason?: Maybe<Scalars['String']>;
  declinedByUserId?: Maybe<Scalars['String']>;
  refundRequired?: Maybe<Scalars['Boolean']>;
  refundRequiredAmountInCents?: Maybe<Scalars['Float']>;
  refundRequiredInvoiceId?: Maybe<Scalars['String']>;
  accountsPayableContactName?: Maybe<Scalars['String']>;
  accountsPayableContactTitle?: Maybe<Scalars['String']>;
  accountsPayableContactEmail?: Maybe<Scalars['String']>;
  accountsPayableContactNumber?: Maybe<Scalars['String']>;
  accountsPayableContactNumberExtension?: Maybe<Scalars['String']>;
  accountsPayableContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  accountsPayableBillingAddress?: Maybe<CmpMemberBillingAddressReturn>;
  marketingCommunicationContactName?: Maybe<Scalars['String']>;
  marketingCommunicationContactTitle?: Maybe<Scalars['String']>;
  marketingCommunicationContactEmail?: Maybe<Scalars['String']>;
  marketingCommunicationContactNumber?: Maybe<Scalars['String']>;
  marketingCommunicationContactNumberExtension?: Maybe<Scalars['String']>;
  marketingCommunicationContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactName?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactTitle?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactEmail?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactNumber?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactNumberExtension?: Maybe<Scalars['String']>;
  hrEmployeeEngagementContactMobilePhoneNumber?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactName?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactTitle?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactEmail?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactNumber?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactNumberExtension?: Maybe<Scalars['String']>;
  salesBusinessDevelopmentContactMobilePhoneNumber?: Maybe<Scalars['String']>;
};

export type CmpMemberFeeComparisonReturn = {
  __typename?: 'CmpMemberFeeComparisonReturn';
  hasChanged: Scalars['Boolean'];
  currentTotalAmountInCents?: Maybe<Scalars['Float']>;
  projectedTotalAmountInCents?: Maybe<Scalars['Float']>;
  currentRenewalAmountInCents?: Maybe<Scalars['Float']>;
  projectedRenewalAmountInCents?: Maybe<Scalars['Float']>;
  warningMessage?: Maybe<Scalars['String']>;
};

export type CmpMemberInvoiceActionInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export type CmpMemberInvoiceCardFormReturn = {
  __typename?: 'CmpMemberInvoiceCardFormReturn';
  invoiceId: Scalars['String'];
  checkoutSessionId: Scalars['String'];
  clientSecret: Scalars['String'];
  publishableKey: Scalars['String'];
  connectedAccountId: Scalars['String'];
  amountInCents: Scalars['Int'];
  currency: Scalars['String'];
  expiresAtUtcMilli: Scalars['Float'];
};

export type CmpMemberInvoiceCheckoutReturn = {
  __typename?: 'CmpMemberInvoiceCheckoutReturn';
  checkoutUrl: Scalars['String'];
};

export type CmpMemberInvoiceInput = {
  invoiceId: Scalars['String'];
};

export type CmpMemberInvoiceOutstandingReturn = {
  __typename?: 'CmpMemberInvoiceOutstandingReturn';
  currency: Scalars['String'];
  amountInCents: Scalars['Float'];
  count: Scalars['Int'];
};

export type CmpMemberInvoiceRowReturn = {
  __typename?: 'CmpMemberInvoiceRowReturn';
  id: Scalars['String'];
  invoiceNumber: Scalars['String'];
  description: Scalars['String'];
  issuedAtUtcMilli: Scalars['Float'];
  dueAtUtcMilli?: Maybe<Scalars['Float']>;
  currency: Scalars['String'];
  totalAmountInCents: Scalars['Float'];
  amountDueInCents: Scalars['Float'];
  displayState: CmpInvoiceDisplayStateEnum;
  paymentMethodLabel: Scalars['String'];
  daysPastDue?: Maybe<Scalars['Int']>;
  installmentSummary?: Maybe<Scalars['String']>;
  canPay: Scalars['Boolean'];
  payableAmountInCents: Scalars['Float'];
  paymentUnavailableReason?: Maybe<Scalars['String']>;
  billToName: Scalars['String'];
  creditForInvoiceNumber?: Maybe<Scalars['String']>;
  creditedByInvoiceNumbers?: Maybe<Array<Scalars['String']>>;
};

export enum CmpMemberLifecycleStatusEnum {
  Prospect = 'PROSPECT',
  Pending = 'PENDING',
  Active = 'ACTIVE',
  Suspended = 'SUSPENDED',
  Past = 'PAST',
  Deleted = 'DELETED'
}

export type CmpMemberMembershipChangeAuditReturn = {
  __typename?: 'CmpMemberMembershipChangeAuditReturn';
  operationId: Scalars['String'];
  outcome: CmpMemberMembershipChangeOutcomeEnum;
  memberId: Scalars['String'];
  requestedByUserId?: Maybe<Scalars['String']>;
  requestedAtUtcMilli: Scalars['Float'];
  effectiveAtUtcMilli?: Maybe<Scalars['Float']>;
  oldMembership: CmpMemberMembershipReturn;
  newMembership: CmpMemberMembershipReturn;
  replacedInvoiceId?: Maybe<Scalars['String']>;
  replacementInvoiceId?: Maybe<Scalars['String']>;
};

export type CmpMemberMembershipChangeFieldsInput = {
  membershipTypeId: Scalars['String'];
  paymentSchedule: ChamberMemberProPaymentScheduleEnum;
  fullTimeEmployees: Scalars['Float'];
  partTimeEmployees: Scalars['Float'];
  membershipDiscount: CmpMemberMembershipDiscountInput;
  paymentResponsibility?: Maybe<ChamberMemberProMembershipModelPaymentResponsibilityEnum>;
  thirdPartyPayerName?: Maybe<Scalars['String']>;
  thirdPartyPaymentNotes?: Maybe<Scalars['String']>;
  thirdPartyBillingSnapshot?: Maybe<CmpInvoiceBillingSnapshotInput>;
  paymentChoice: CmpPaymentChoiceInput;
};

export enum CmpMemberMembershipChangeOutcomeEnum {
  InvoiceReplaced = 'INVOICE_REPLACED',
  InvoiceCreated = 'INVOICE_CREATED',
  InvoiceDraftUpdated = 'INVOICE_DRAFT_UPDATED',
  MemberActivated = 'MEMBER_ACTIVATED',
  QueuedForRenewal = 'QUEUED_FOR_RENEWAL',
  PendingChangeUpdated = 'PENDING_CHANGE_UPDATED',
  PendingChangeCancelled = 'PENDING_CHANGE_CANCELLED',
  RenewalInvoiceCreated = 'RENEWAL_INVOICE_CREATED',
  RenewalDraftSaved = 'RENEWAL_DRAFT_SAVED',
  RenewalDraftApproved = 'RENEWAL_DRAFT_APPROVED',
  RenewalInvoiceCancelled = 'RENEWAL_INVOICE_CANCELLED',
  NoChange = 'NO_CHANGE',
  RequiresManualReview = 'REQUIRES_MANUAL_REVIEW'
}

export enum CmpMemberMembershipChangeReasonCodeEnum {
  NoChange = 'NO_CHANGE',
  MemberReadOnly = 'MEMBER_READ_ONLY',
  MemberRevisionMismatch = 'MEMBER_REVISION_MISMATCH',
  CurrentInvoiceMismatch = 'CURRENT_INVOICE_MISMATCH',
  MultipleOpenMembershipInvoices = 'MULTIPLE_OPEN_MEMBERSHIP_INVOICES',
  PartialPaymentExists = 'PARTIAL_PAYMENT_EXISTS',
  CurrentInvoiceAmbiguous = 'CURRENT_INVOICE_AMBIGUOUS',
  MissingRenewalDate = 'MISSING_RENEWAL_DATE',
  PendingChangeExists = 'PENDING_CHANGE_EXISTS'
}

export type CmpMemberMembershipDiscountInput = {
  enabled?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  amountInCents?: Maybe<Scalars['Float']>;
};

export type CmpMemberMembershipDiscountReturn = {
  __typename?: 'CmpMemberMembershipDiscountReturn';
  enabled: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  amountInCents: Scalars['Float'];
};

export type CmpMemberMembershipInput = {
  membershipTypeId?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<ChamberMemberProPaymentScheduleEnum>;
  fullTimeEmployees?: Maybe<Scalars['Float']>;
  partTimeEmployees?: Maybe<Scalars['Float']>;
  selectedAdditionalCostIds?: Maybe<Array<Scalars['String']>>;
  membershipDiscount?: Maybe<CmpMemberMembershipDiscountInput>;
  paymentResponsibility?: Maybe<ChamberMemberProMembershipModelPaymentResponsibilityEnum>;
  thirdPartyPayerName?: Maybe<Scalars['String']>;
  thirdPartyPaymentNotes?: Maybe<Scalars['String']>;
  thirdPartyBillingSnapshot?: Maybe<CmpInvoiceBillingSnapshotInput>;
  paymentChoice?: Maybe<CmpPaymentChoiceInput>;
};

export type CmpMemberMembershipReturn = {
  __typename?: 'CmpMemberMembershipReturn';
  membershipTypeId: Scalars['String'];
  membershipTypeName: Scalars['String'];
  paymentSchedule: ChamberMemberProPaymentScheduleEnum;
  fullTimeEmployees: Scalars['Float'];
  partTimeEmployees: Scalars['Float'];
  weightedEmployees: Scalars['Float'];
  selectedAdditionalCostIds?: Maybe<Array<Scalars['String']>>;
  membershipDiscount?: Maybe<CmpMemberMembershipDiscountReturn>;
  paymentResponsibility?: Maybe<ChamberMemberProMembershipModelPaymentResponsibilityEnum>;
  thirdPartyPayerName?: Maybe<Scalars['String']>;
  thirdPartyPaymentNotes?: Maybe<Scalars['String']>;
  pricingSnapshot: CmpMembershipPricingSnapshotReturn;
  paymentChoice: CmpPaymentChoiceReturn;
};

export type CmpMemberMetricsReturn = {
  __typename?: 'CmpMemberMetricsReturn';
  memberId: Scalars['String'];
  currency: ChamberMemberProCurrencyEnum;
  lifetimeValueInCents?: Maybe<Scalars['Float']>;
  averageAnnualMemberValueInCents?: Maybe<Scalars['Float']>;
  chamberAverageLifetimeValueInCents?: Maybe<Scalars['Float']>;
  retentionScore?: Maybe<Scalars['Int']>;
  financialUnavailableReason?: Maybe<Scalars['String']>;
  retentionUnavailableReasons: Array<Scalars['String']>;
  /** Member Insight only: a score from recorded data when the full history is incomplete (Monday 13269231588). */
  partialRetentionScore?: Maybe<Scalars['Int']>;
  /** Member Insight only: average recorded lifetime value of the chamber active members. */
  recordedChamberAverageLifetimeValueInCents?: Maybe<Scalars['Float']>;
  joinedAtUtcMilli?: Maybe<Scalars['Float']>;
  tenureYears?: Maybe<Scalars['Float']>;
  lastLoginAtUtcMilli?: Maybe<Scalars['Float']>;
  loginsLast12Months?: Maybe<Scalars['Int']>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type CmpMemberPendingMembershipChangeReturn = {
  __typename?: 'CmpMemberPendingMembershipChangeReturn';
  version: Scalars['Float'];
  status: CmpMemberPendingMembershipChangeStatusEnum;
  actionRequiredReason?: Maybe<Scalars['String']>;
  operationId: Scalars['String'];
  effectiveAtUtcMilli: Scalars['Float'];
  requestedAtUtcMilli: Scalars['Float'];
  requestedByUserId?: Maybe<Scalars['String']>;
  currentInvoiceId?: Maybe<Scalars['String']>;
  oldMembership: CmpMemberMembershipReturn;
  newMembership: CmpMemberMembershipReturn;
};

export enum CmpMemberPendingMembershipChangeStatusEnum {
  Pending = 'PENDING',
  ActionRequired = 'ACTION_REQUIRED'
}

export type CmpMemberProfileInput = {
  internalNotes?: Maybe<Scalars['String']>;
  customFields?: Maybe<Array<CmpMemberCustomFieldInput>>;
};

export type CmpMemberProfileReturn = {
  __typename?: 'CmpMemberProfileReturn';
  internalNotes?: Maybe<Scalars['String']>;
  customFields: Array<CmpMemberCustomFieldReturn>;
};

export type CmpMemberReferralTrackingInput = {
  id?: Maybe<Scalars['String']>;
  referralDate?: Maybe<Scalars['String']>;
  becameMemberDate?: Maybe<Scalars['String']>;
  companyReferralName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  contactNumberExtension?: Maybe<Scalars['String']>;
};

export type CmpMemberReferralTrackingReturn = {
  __typename?: 'CmpMemberReferralTrackingReturn';
  id: Scalars['String'];
  referralDate?: Maybe<Scalars['String']>;
  becameMemberDate?: Maybe<Scalars['String']>;
  companyReferralName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  contactNumberExtension?: Maybe<Scalars['String']>;
};

export type CmpMemberRenewalActionReturn = {
  __typename?: 'CmpMemberRenewalActionReturn';
  available: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type CmpMemberRenewalActionsReturn = {
  __typename?: 'CmpMemberRenewalActionsReturn';
  createNow: CmpMemberRenewalActionReturn;
  saveDraft: CmpMemberRenewalActionReturn;
  approveDraft: CmpMemberRenewalActionReturn;
  cancelInvoice: CmpMemberRenewalActionReturn;
  cancelPendingChange: CmpMemberRenewalActionReturn;
  updateDetails: CmpMemberRenewalActionReturn;
};

export enum CmpMemberRenewalInvoiceDispositionEnum {
  SaveDraft = 'SAVE_DRAFT',
  CreateNow = 'CREATE_NOW'
}

export type CmpMemberRenewalInvoicePreviewInput = {
  membership: CmpMemberMembershipChangeFieldsInput;
  expectedMemberUpdatedAtUtcMilli: Scalars['Float'];
  expectedCurrentInvoiceId?: Maybe<Scalars['String']>;
  existingDraftInvoiceId?: Maybe<Scalars['String']>;
  expectedInvoiceUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpMemberRenewalInvoicePreviewReturn = {
  __typename?: 'CmpMemberRenewalInvoicePreviewReturn';
  membership: CmpMemberMembershipReturn;
  invoice: CmpInvoiceReturn;
  memberUpdatedAtUtcMilli: Scalars['Float'];
  existingDraftInvoiceId?: Maybe<Scalars['String']>;
  invoiceUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  generatedAtUtcMilli: Scalars['Float'];
};

export enum CmpMemberRenewalScenarioEnum {
  NotInvoiced = 'NOT_INVOICED',
  Draft = 'DRAFT',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Paid = 'PAID',
  AutoRenewEnabled = 'AUTO_RENEW_ENABLED'
}

export type CmpMemberRenewalStateReturn = {
  __typename?: 'CmpMemberRenewalStateReturn';
  pendingThirdPartyBillingSnapshot?: Maybe<CmpInvoiceBillingSnapshotReturn>;
  scenario: CmpMemberRenewalScenarioEnum;
  stepState: CmpMemberRenewalStepStateEnum;
  renewalInvoiceSentAtUtcMilli?: Maybe<Scalars['Float']>;
  renewalCycleDateUtcMilli?: Maybe<Scalars['Float']>;
  cycleInvoice?: Maybe<CmpInvoiceReturn>;
  lastRenewalInvoiceCreatedAtUtcMilli?: Maybe<Scalars['Float']>;
  autoRenewEnabled: Scalars['Boolean'];
  autoChargeReady: Scalars['Boolean'];
  pendingMembershipChange?: Maybe<CmpMemberPendingMembershipChangeReturn>;
  actions: CmpMemberRenewalActionsReturn;
};

export enum CmpMemberRenewalStepStateEnum {
  Editable = 'EDITABLE',
  InvoiceGenerated = 'INVOICE_GENERATED',
  InvoiceVoided = 'INVOICE_VOIDED'
}

export type CmpMemberSavedCardReturn = {
  __typename?: 'CmpMemberSavedCardReturn';
  brand: Scalars['String'];
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  label: Scalars['String'];
  last4: Scalars['String'];
  shortLabel: Scalars['String'];
};

export enum CmpMemberSectionEnum {
  MembershipTracking = 'MEMBERSHIP_TRACKING',
  MemberDirectory = 'MEMBER_DIRECTORY',
  MemberAddress = 'MEMBER_ADDRESS',
  SocialLinks = 'SOCIAL_LINKS',
  Contacts = 'CONTACTS',
  BillingAddress = 'BILLING_ADDRESS',
  CustomContacts = 'CUSTOM_CONTACTS',
  MemberInsights = 'MEMBER_INSIGHTS',
  ReferralTracking = 'REFERRAL_TRACKING',
  AssociateMember = 'ASSOCIATE_MEMBER',
  AffiliatedChamber = 'AFFILIATED_CHAMBER',
  AffinityPrograms = 'AFFINITY_PROGRAMS',
  SeoTags = 'SEO_TAGS'
}

export type CmpMemberStatusActionsReturn = {
  __typename?: 'CmpMemberStatusActionsReturn';
  canUpdateProfile: Scalars['Boolean'];
  canApproveBoard: Scalars['Boolean'];
  canResetPassword: Scalars['Boolean'];
  canSuspend: Scalars['Boolean'];
  canActivate: Scalars['Boolean'];
  canArchive: Scalars['Boolean'];
  canRecordManualPayment: Scalars['Boolean'];
  canResendPaymentRequest: Scalars['Boolean'];
  canChargeSavedCard: Scalars['Boolean'];
  canStartNewApplication: Scalars['Boolean'];
  boardApprovalRequired: Scalars['Boolean'];
  boardApproved: Scalars['Boolean'];
  paymentReceived: Scalars['Boolean'];
  paymentRequestState: CmpPaymentRequestStateEnum;
};

export type CmpMembershipApplicationManualPaymentMethodReturn = {
  __typename?: 'CmpMembershipApplicationManualPaymentMethodReturn';
  id: Scalars['String'];
  label: Scalars['String'];
  description: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export type CmpMembershipApplicationMembershipReturn = {
  __typename?: 'CmpMembershipApplicationMembershipReturn';
  enabledPaymentSchedules: Array<ChamberMemberProPaymentScheduleEnum>;
  partTimeEmployeesPerFullTime: Scalars['Float'];
  allowAutoRenewal: Scalars['Boolean'];
  requireApproval: Scalars['Boolean'];
  paymentBeforeApprovalRule: ChamberMemberProPaymentBeforeApprovalRuleEnum;
  proratedSignupPricingEnabled: Scalars['Boolean'];
  memberBenefits: Array<ChamberMemberProMemberBenefitReturn>;
  membershipModels: Array<ChamberMemberProMembershipModelReturn>;
  proratedSignupPrices: Array<ChamberMemberProProratedSignupPriceReturn>;
};

export type CmpMembershipApplicationPaymentsReturn = {
  __typename?: 'CmpMembershipApplicationPaymentsReturn';
  creditCardPaymentsEnabled: Scalars['Boolean'];
  creditCardPaymentsReady: Scalars['Boolean'];
  cardProcessingFee: ChamberMemberProCardProcessingFeeSettingsReturn;
  provincialChamberFee: ChamberMemberProProvincialChamberFeeSettingsReturn;
  invoiceTaxSettings: ChamberMemberProInvoiceTaxSettingsReturn;
  monthlyMembershipAdministrativeFee: ChamberMemberProMonthlyMembershipAdministrativeFeeSettingsReturn;
  oneTimeOnboardingFee: ChamberMemberProOneTimeOnboardingFeeSettingsReturn;
  eventTicketCreditCardPaymentMode: ChamberMemberProEventTicketCreditCardPaymentModeEnum;
  /** @deprecated Removed setting. Always false. */
  onlineMembershipCreditCardPaymentRequired: Scalars['Boolean'];
  invoicePaymentTerms: ChamberMemberProInvoicePaymentTermsEnum;
  overdueInvoiceLateFeePercentage: Scalars['Float'];
  manualPaymentMethods: Array<CmpMembershipApplicationManualPaymentMethodReturn>;
};

export type CmpMembershipApplicationSettingsReturn = {
  __typename?: 'CmpMembershipApplicationSettingsReturn';
  setup: CmpMembershipApplicationSetupReturn;
  membership: CmpMembershipApplicationMembershipReturn;
  payments: CmpMembershipApplicationPaymentsReturn;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpMembershipApplicationSetupReturn = {
  __typename?: 'CmpMembershipApplicationSetupReturn';
  currency: ChamberMemberProCurrencyEnum;
  timeZone: Scalars['String'];
  membershipApplicationCommunicationOptions: ChamberMemberProMembershipApplicationCommunicationOptionsReturn;
};

export type CmpMembershipPricingSnapshotReturn = {
  __typename?: 'CmpMembershipPricingSnapshotReturn';
  currency: ChamberMemberProCurrencyEnum;
  pricingKey: Scalars['String'];
  baseAmountInCents: Scalars['Float'];
  additionalCostsInCents: Scalars['Float'];
  lineItems?: Maybe<Array<CmpInvoiceLineItemReturn>>;
  proratedDiscountInCents: Scalars['Float'];
  taxAmountInCents: Scalars['Float'];
  cardProcessingFeeInCents: Scalars['Float'];
  totalAmountInCents: Scalars['Float'];
  renewalAmountInCents: Scalars['Float'];
  renewalDateUtcMilli?: Maybe<Scalars['Float']>;
  taxJurisdictionId: Scalars['String'];
  taxRatePercentage: Scalars['Float'];
  cardProcessingFeeEnabled: Scalars['Boolean'];
};

/** Wave C BE-4: the member's own auto-renewal and saved card (Member Dashboard Invoices). */
export type CmpMyMemberAutoRenewalReturn = {
  __typename?: 'CmpMyMemberAutoRenewalReturn';
  available: Scalars['Boolean'];
  unavailableReason?: Maybe<Scalars['String']>;
  autoRenew: Scalars['Boolean'];
  cardOnFile?: Maybe<CmpMemberSavedCardReturn>;
  memberName: Scalars['String'];
};

export type CmpMyMemberContactAccountsReturn = {
  __typename?: 'CmpMyMemberContactAccountsReturn';
  accounts: Array<CmpMemberContactAccountReturn>;
  memberUpdatedAtUtcMilli: Scalars['Float'];
};

export type CmpMyMemberEventAnswerReturn = {
  __typename?: 'CmpMyMemberEventAnswerReturn';
  fieldId: Scalars['String'];
  value: Scalars['String'];
};

export type CmpMyMemberEventAttendeeReturn = {
  __typename?: 'CmpMyMemberEventAttendeeReturn';
  id: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  ticketTypeId: Scalars['String'];
  ticketTypeName: Scalars['String'];
  complete: Scalars['Boolean'];
  answers: Array<CmpMyMemberEventAnswerReturn>;
};

export type CmpMyMemberEventQuestionReturn = {
  __typename?: 'CmpMyMemberEventQuestionReturn';
  id: Scalars['String'];
  label: Scalars['String'];
  fieldType: CmpEventCustomFieldTypeEnum;
  required: Scalars['Boolean'];
  helperText?: Maybe<Scalars['String']>;
  choices: Array<Scalars['String']>;
  appliesToTicketTypeIds: Array<Scalars['String']>;
};

export type CmpMyMemberEventRegistrationReturn = {
  __typename?: 'CmpMyMemberEventRegistrationReturn';
  registrationId: Scalars['String'];
  eventId: Scalars['String'];
  eventTitle: Scalars['String'];
  startAtUtcMilli?: Maybe<Scalars['Float']>;
  endAtUtcMilli?: Maybe<Scalars['Float']>;
  timeZone: Scalars['String'];
  locationText?: Maybe<Scalars['String']>;
  ticketSummary: Scalars['String'];
  ticketCount: Scalars['Int'];
  registrationNumber?: Maybe<Scalars['String']>;
  amountInCents: Scalars['Float'];
  amountDueInCents: Scalars['Float'];
  currency: Scalars['String'];
  paid: Scalars['Boolean'];
  updatedAtUtcMilli: Scalars['Float'];
  missingAttendeeCount: Scalars['Int'];
  canEditAttendees: Scalars['Boolean'];
  attendees: Array<CmpMyMemberEventAttendeeReturn>;
  questions: Array<CmpMyMemberEventQuestionReturn>;
};

/** Wave C BE-5: the member company's own event registrations (Member Dashboard Register for Events). */
export type CmpMyMemberEventsReturn = {
  __typename?: 'CmpMyMemberEventsReturn';
  upcoming: Array<CmpMyMemberEventRegistrationReturn>;
  past: Array<CmpMyMemberEventRegistrationReturn>;
  eventsPageUrl?: Maybe<Scalars['String']>;
};

export type CmpNewsletterActionInput = {
  chamberId: Scalars['String'];
  newsletterId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type CmpNewsletterAdditionalRecipientInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
};

export type CmpNewsletterAdditionalRecipientReturn = {
  __typename?: 'CmpNewsletterAdditionalRecipientReturn';
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
};

export type CmpNewsletterAnalyticsReturn = {
  __typename?: 'CmpNewsletterAnalyticsReturn';
  recipientCount: Scalars['Int'];
  openCount: Scalars['Int'];
  clickCount: Scalars['Int'];
  bounceCount?: Maybe<Scalars['Int']>;
  averageTimeToOpenMilli?: Maybe<Scalars['Float']>;
  recipients: Array<CmpNewsletterEngagementRecipientReturn>;
  links: Array<CmpNewsletterLinkEngagementReturn>;
  audiences: Array<CmpNewsletterAudienceEngagementReturn>;
};

export enum CmpNewsletterAssetUploadMethodEnum {
  Put = 'PUT'
}

export enum CmpNewsletterAssetUploadPurposeEnum {
  BuilderImage = 'BUILDER_IMAGE',
  BuilderPdf = 'BUILDER_PDF',
  Attachment = 'ATTACHMENT'
}

export type CmpNewsletterAttachmentInput = {
  id?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  sizeBytes: Scalars['Float'];
  storageKey?: Maybe<Scalars['String']>;
};

export type CmpNewsletterAttachmentReturn = {
  __typename?: 'CmpNewsletterAttachmentReturn';
  id: Scalars['String'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  sizeBytes: Scalars['Float'];
  storageKey?: Maybe<Scalars['String']>;
  eTag: Scalars['String'];
};

export type CmpNewsletterAttachmentUploadFieldReturn = {
  __typename?: 'CmpNewsletterAttachmentUploadFieldReturn';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CmpNewsletterAttachmentUploadReturn = {
  __typename?: 'CmpNewsletterAttachmentUploadReturn';
  uploadUrl: Scalars['String'];
  uploadMethod: CmpNewsletterAssetUploadMethodEnum;
  uploadFields: Array<CmpNewsletterAttachmentUploadFieldReturn>;
  publicUrl?: Maybe<Scalars['String']>;
  storageKey: Scalars['String'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  sizeBytes: Scalars['Float'];
};

export type CmpNewsletterAudienceEngagementReturn = {
  __typename?: 'CmpNewsletterAudienceEngagementReturn';
  label: Scalars['String'];
  recipientCount: Scalars['Int'];
  openCount: Scalars['Int'];
  clickCount: Scalars['Int'];
};

export type CmpNewsletterDataInput = {
  campaignName?: Maybe<Scalars['String']>;
  campaignDescription?: Maybe<Scalars['String']>;
  reviewNote?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  preheader?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  replyToEmail?: Maybe<Scalars['String']>;
  emailType: CmpNewsletterTypeEnum;
  status?: Maybe<CmpNewsletterStatusEnum>;
  scheduledAtUtcMilli?: Maybe<Scalars['Float']>;
  templateKey?: Maybe<Scalars['String']>;
  builderStateJson?: Maybe<Scalars['String']>;
  contentHtml?: Maybe<Scalars['String']>;
  contentText?: Maybe<Scalars['String']>;
  footerHtml?: Maybe<Scalars['String']>;
  recipientSelection?: Maybe<CmpNewsletterRecipientSelectionInput>;
  newsroom?: Maybe<CmpNewsletterNewsroomInput>;
  attachments?: Maybe<Array<CmpNewsletterAttachmentInput>>;
};

export type CmpNewsletterDeliverySummaryReturn = {
  __typename?: 'CmpNewsletterDeliverySummaryReturn';
  totalOutboundEmailCount: Scalars['Float'];
  sentCount: Scalars['Float'];
  failedCount: Scalars['Float'];
  skippedCount: Scalars['Float'];
  intendedRecipientCount: Scalars['Float'];
  actualRecipientCount: Scalars['Float'];
  recipientOverrideUsed: Scalars['Boolean'];
  latestOutboundEmailAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpNewsletterEngagementRecipientReturn = {
  __typename?: 'CmpNewsletterEngagementRecipientReturn';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  openCount?: Maybe<Scalars['Int']>;
  firstOpenedAtUtcMilli?: Maybe<Scalars['Float']>;
  lastOpenedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpNewsletterLinkEngagementReturn = {
  __typename?: 'CmpNewsletterLinkEngagementReturn';
  url: Scalars['String'];
  label: Scalars['String'];
  clickCount?: Maybe<Scalars['Int']>;
  uniqueClickCount?: Maybe<Scalars['Int']>;
};

export type CmpNewsletterMutationReturn = {
  __typename?: 'CmpNewsletterMutationReturn';
  newsletterSavedSuccessfully: Scalars['Boolean'];
  newsletter?: Maybe<CmpNewsletterReturn>;
};

export type CmpNewsletterNewsroomInput = {
  publishToNewsroom: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  featuredImageUrl?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  authorName?: Maybe<Scalars['String']>;
};

export type CmpNewsletterNewsroomReturn = {
  __typename?: 'CmpNewsletterNewsroomReturn';
  status: CmpNewsletterNewsroomStatusEnum;
  publishToNewsroom: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  featuredImageUrl?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  slugLockedAtUtcMilli?: Maybe<Scalars['Float']>;
  publishedAtUtcMilli?: Maybe<Scalars['Float']>;
  unpublishedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpNewsletterNewsroomStatusEnum {
  NotPublished = 'NOT_PUBLISHED',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type CmpNewsletterRecipientGroupActionInput = {
  chamberId: Scalars['String'];
  groupId: Scalars['String'];
};

export type CmpNewsletterRecipientGroupDataInput = {
  criteriaIds?: Maybe<Array<Scalars['String']>>;
  governanceGroupIds?: Maybe<Array<Scalars['String']>>;
  additionalRecipients?: Maybe<Array<CmpNewsletterAdditionalRecipientInput>>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  sourceKinds?: Maybe<Array<CmpNewsletterRecipientSourceKindEnum>>;
  memberIds?: Maybe<Array<Scalars['String']>>;
  eventIds?: Maybe<Array<Scalars['String']>>;
  directEmails?: Maybe<Array<Scalars['String']>>;
  excludedRecipientKeys?: Maybe<Array<Scalars['String']>>;
};

export type CmpNewsletterRecipientGroupMutationReturn = {
  __typename?: 'CmpNewsletterRecipientGroupMutationReturn';
  groupSavedSuccessfully: Scalars['Boolean'];
  group?: Maybe<CmpNewsletterRecipientGroupReturn>;
};

export type CmpNewsletterRecipientGroupReturn = {
  __typename?: 'CmpNewsletterRecipientGroupReturn';
  criteriaIds?: Maybe<Array<Scalars['String']>>;
  governanceGroupIds: Array<Scalars['String']>;
  additionalRecipients: Array<CmpNewsletterAdditionalRecipientReturn>;
  id: Scalars['String'];
  chamberId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  sourceKinds: Array<CmpNewsletterRecipientSourceKindEnum>;
  memberIds: Array<Scalars['String']>;
  eventIds: Array<Scalars['String']>;
  directEmails: Array<Scalars['String']>;
  excludedRecipientKeys?: Maybe<Array<Scalars['String']>>;
  estimatedRecipientCount: Scalars['Float'];
  isArchived: Scalars['Boolean'];
  isCmpNewsletterModuleTestData?: Maybe<Scalars['Boolean']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpNewsletterRecipientMemberFiltersInput = {
  membershipTypeIds?: Maybe<Array<Scalars['String']>>;
  employeeRangeIds?: Maybe<Array<Scalars['String']>>;
  categoryIds?: Maybe<Array<Scalars['String']>>;
  memberSinceRangeIds?: Maybe<Array<Scalars['String']>>;
  renewalRangeIds?: Maybe<Array<Scalars['String']>>;
};

export type CmpNewsletterRecipientMemberFiltersReturn = {
  __typename?: 'CmpNewsletterRecipientMemberFiltersReturn';
  membershipTypeIds: Array<Scalars['String']>;
  employeeRangeIds: Array<Scalars['String']>;
  categoryIds: Array<Scalars['String']>;
  memberSinceRangeIds: Array<Scalars['String']>;
  renewalRangeIds: Array<Scalars['String']>;
};

export type CmpNewsletterRecipientPreviewRecipientReturn = {
  __typename?: 'CmpNewsletterRecipientPreviewRecipientReturn';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  intendedEmail?: Maybe<Scalars['String']>;
  actualTestEmail?: Maybe<Scalars['String']>;
  sourceKind: CmpNewsletterRecipientSourceKindEnum;
  sourceLabel: Scalars['String'];
  memberId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  status: CmpNewsletterRecipientPreviewRecipientStatusEnum;
  skippedReason?: Maybe<Scalars['String']>;
};

export enum CmpNewsletterRecipientPreviewRecipientStatusEnum {
  Valid = 'VALID',
  Invalid = 'INVALID',
  Skipped = 'SKIPPED'
}

export type CmpNewsletterRecipientSelectionInput = {
  criteriaIds?: Maybe<Array<Scalars['String']>>;
  excludedEmails?: Maybe<Array<Scalars['String']>>;
  governanceGroupIds?: Maybe<Array<Scalars['String']>>;
  additionalRecipients?: Maybe<Array<CmpNewsletterAdditionalRecipientInput>>;
  sourceKinds?: Maybe<Array<CmpNewsletterRecipientSourceKindEnum>>;
  groupIds?: Maybe<Array<Scalars['String']>>;
  memberIds?: Maybe<Array<Scalars['String']>>;
  eventIds?: Maybe<Array<Scalars['String']>>;
  sponsorEventIds?: Maybe<Array<Scalars['String']>>;
  directEmails?: Maybe<Array<Scalars['String']>>;
  memberFilters?: Maybe<CmpNewsletterRecipientMemberFiltersInput>;
};

export type CmpNewsletterRecipientSelectionReturn = {
  __typename?: 'CmpNewsletterRecipientSelectionReturn';
  criteriaIds?: Maybe<Array<Scalars['String']>>;
  excludedEmails?: Maybe<Array<Scalars['String']>>;
  governanceGroupIds: Array<Scalars['String']>;
  additionalRecipients: Array<CmpNewsletterAdditionalRecipientReturn>;
  sourceKinds: Array<CmpNewsletterRecipientSourceKindEnum>;
  groupIds: Array<Scalars['String']>;
  memberIds: Array<Scalars['String']>;
  eventIds: Array<Scalars['String']>;
  sponsorEventIds: Array<Scalars['String']>;
  directEmails: Array<Scalars['String']>;
  memberFilters: CmpNewsletterRecipientMemberFiltersReturn;
};

export enum CmpNewsletterRecipientSourceKindEnum {
  ActivePrimaryContacts = 'ACTIVE_PRIMARY_CONTACTS',
  GovernanceGroups = 'GOVERNANCE_GROUPS',
  MembersOfferingPerks = 'MEMBERS_OFFERING_PERKS',
  ActiveMembers = 'ACTIVE_MEMBERS',
  AllMembers = 'ALL_MEMBERS',
  NewMembers = 'NEW_MEMBERS',
  RenewingMembers = 'RENEWING_MEMBERS',
  ProspectMembers = 'PROSPECT_MEMBERS',
  SelectedMembers = 'SELECTED_MEMBERS',
  RecipientGroups = 'RECIPIENT_GROUPS',
  DirectEmails = 'DIRECT_EMAILS',
  EventAttendees = 'EVENT_ATTENDEES',
  PastEventAttendees = 'PAST_EVENT_ATTENDEES',
  WebsiteSubscribers = 'WEBSITE_SUBSCRIBERS',
  NonMemberSubscribers = 'NON_MEMBER_SUBSCRIBERS',
  PendingMembers = 'PENDING_MEMBERS',
  SuspendedMembers = 'SUSPENDED_MEMBERS',
  EventSponsors = 'EVENT_SPONSORS'
}

export type CmpNewsletterReturn = {
  __typename?: 'CmpNewsletterReturn';
  campaignName?: Maybe<Scalars['String']>;
  campaignDescription?: Maybe<Scalars['String']>;
  reviewNote?: Maybe<Scalars['String']>;
  reviewHistory?: Maybe<Array<CmpNewsletterReviewNoteReturn>>;
  analytics?: Maybe<CmpNewsletterAnalyticsReturn>;
  id: Scalars['String'];
  chamberId: Scalars['String'];
  slug: Scalars['String'];
  subject: Scalars['String'];
  preheader?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  replyToEmail?: Maybe<Scalars['String']>;
  emailType: CmpNewsletterTypeEnum;
  status: CmpNewsletterStatusEnum;
  scheduledAtUtcMilli?: Maybe<Scalars['Float']>;
  sentAtUtcMilli?: Maybe<Scalars['Float']>;
  failedAtUtcMilli?: Maybe<Scalars['Float']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  templateKey?: Maybe<Scalars['String']>;
  builderStateJson?: Maybe<Scalars['String']>;
  contentHtml?: Maybe<Scalars['String']>;
  contentText?: Maybe<Scalars['String']>;
  footerHtml?: Maybe<Scalars['String']>;
  recipientSelection: CmpNewsletterRecipientSelectionReturn;
  newsroom: CmpNewsletterNewsroomReturn;
  senderReadiness: CmpNewsletterSenderReadinessReturn;
  attachments: Array<CmpNewsletterAttachmentReturn>;
  attachmentCount: Scalars['Float'];
  estimatedRecipientCount: Scalars['Float'];
  invalidRecipientCount: Scalars['Float'];
  skippedRecipientCount: Scalars['Float'];
  sentRecipientCount: Scalars['Float'];
  failedRecipientCount: Scalars['Float'];
  skippedDeliveryCount: Scalars['Float'];
  openCount: Scalars['Float'];
  clickCount: Scalars['Float'];
  outboundEmails?: Maybe<Array<CmpOutboundEmailReturn>>;
  deliverySummary?: Maybe<CmpNewsletterDeliverySummaryReturn>;
  isCmpNewsletterModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CmpNewsletterReviewNoteReturn = {
  __typename?: 'CmpNewsletterReviewNoteReturn';
  action: Scalars['String'];
  note: Scalars['String'];
  actorUserId: Scalars['String'];
  actorName?: Maybe<Scalars['String']>;
  createdAtUtcMilli: Scalars['Float'];
};

export type CmpNewsletterScheduleInput = {
  chamberId: Scalars['String'];
  newsletterId: Scalars['String'];
  scheduledAtUtcMilli: Scalars['Float'];
  note?: Maybe<Scalars['String']>;
};

export type CmpNewsletterSendMutationReturn = {
  __typename?: 'CmpNewsletterSendMutationReturn';
  newsletterSendQueuedSuccessfully: Scalars['Boolean'];
  newsletter?: Maybe<CmpNewsletterReturn>;
  outboundEmails: Array<CmpOutboundEmailReturn>;
  deliverySummary: CmpNewsletterDeliverySummaryReturn;
};

export type CmpNewsletterSenderReadinessReturn = {
  __typename?: 'CmpNewsletterSenderReadinessReturn';
  status: CmpNewsletterSenderReadinessStatusEnum;
  senderDomainStatus: ChamberMemberProSenderDomainStatusEnum;
  fromEmail: Scalars['String'];
  replyToEmail?: Maybe<Scalars['String']>;
  fallbackSenderWouldBeUsed: Scalars['Boolean'];
  blockingReason?: Maybe<Scalars['String']>;
  warning?: Maybe<Scalars['String']>;
};

export enum CmpNewsletterSenderReadinessStatusEnum {
  Verified = 'VERIFIED',
  FallbackAvailable = 'FALLBACK_AVAILABLE',
  Blocked = 'BLOCKED'
}

export enum CmpNewsletterStatusEnum {
  Draft = 'DRAFT',
  ReadyForReview = 'READY_FOR_REVIEW',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  Sent = 'SENT',
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Archived = 'ARCHIVED'
}

export type CmpNewsletterSubscriberListRowReturn = {
  __typename?: 'CmpNewsletterSubscriberListRowReturn';
  id: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  status: CmpNewsletterSubscriberStatusEnum;
  source: Scalars['String'];
  isMemberEmail: Scalars['Boolean'];
  subscribedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpNewsletterSubscriberMutationReturn = {
  __typename?: 'CmpNewsletterSubscriberMutationReturn';
  outcome: Scalars['String'];
  message: Scalars['String'];
};

export type CmpNewsletterSubscriberReturn = {
  __typename?: 'CmpNewsletterSubscriberReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  email: Scalars['String'];
  status: CmpNewsletterSubscriberStatusEnum;
  sourceUrl?: Maybe<Scalars['String']>;
  consentTextSnapshot?: Maybe<Scalars['String']>;
  subscribedAtUtcMilli?: Maybe<Scalars['Float']>;
  unsubscribedAtUtcMilli?: Maybe<Scalars['Float']>;
  isCmpNewsletterModuleTestData?: Maybe<Scalars['Boolean']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpNewsletterSubscriberStatusEnum {
  Active = 'ACTIVE',
  Unsubscribed = 'UNSUBSCRIBED'
}

export type CmpNewsletterTestSendInput = {
  chamberId: Scalars['String'];
  newsletterId: Scalars['String'];
  recipientEmails: Array<Scalars['String']>;
  clientRequestId: Scalars['String'];
  confirmationToken: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type CmpNewsletterTestSendPreview = {
  __typename?: 'CmpNewsletterTestSendPreview';
  normalizedRecipientEmails: Array<Scalars['String']>;
  fromEmail: Scalars['String'];
  replyToEmail?: Maybe<Scalars['String']>;
  explicitRecipientsAllowed: Scalars['Boolean'];
  blockingReason?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmationExpiresAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpNewsletterTestSendPreviewInput = {
  chamberId: Scalars['String'];
  newsletterId: Scalars['String'];
  recipientEmails: Array<Scalars['String']>;
  clientRequestId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type CmpNewsletterTrackingInput = {
  chamberId: Scalars['String'];
  newsletterId: Scalars['String'];
  outboundEmailId: Scalars['String'];
  trackingId: Scalars['String'];
  targetUrl?: Maybe<Scalars['String']>;
};

export type CmpNewsletterTrackingReturn = {
  __typename?: 'CmpNewsletterTrackingReturn';
  trackedSuccessfully: Scalars['Boolean'];
  newsletter?: Maybe<CmpNewsletterReturn>;
};

export enum CmpNewsletterTypeEnum {
  AdvocacyUpdate = 'ADVOCACY_UPDATE',
  MemberWelcome = 'MEMBER_WELCOME',
  FromTheDesk = 'FROM_THE_DESK',
  CustomEmail = 'CUSTOM_EMAIL',
  Newsletter = 'NEWSLETTER',
  EBlast = 'E_BLAST',
  Bulletin = 'BULLETIN',
  PressRelease = 'PRESS_RELEASE',
  Announcement = 'ANNOUNCEMENT'
}

export enum CmpNewsroomEntrySourceKindEnum {
  CmpNewsletter = 'CMP_NEWSLETTER',
  WebsiteBuilderManual = 'WEBSITE_BUILDER_MANUAL'
}

export type CmpOperationalEventReturn = {
  __typename?: 'CmpOperationalEventReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  chamberMemberId?: Maybe<Scalars['String']>;
  prospectId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventRegistrationId?: Maybe<Scalars['String']>;
  eventSponsorshipRequestId?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
  refundId?: Maybe<Scalars['String']>;
  sourceKind?: Maybe<CmpOperationalSourceKindEnum>;
  isCmpMemberModuleTestData?: Maybe<Scalars['Boolean']>;
  isCmpProspectModuleTestData?: Maybe<Scalars['Boolean']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
  eventType: CmpOperationalEventTypeEnum;
  lifecycleStatus?: Maybe<CmpMemberLifecycleStatusEnum>;
  createdByUserId?: Maybe<Scalars['String']>;
  operationId?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  reasonExplanation?: Maybe<Scalars['String']>;
  amountInCents?: Maybe<Scalars['Float']>;
  refundMethodLabel?: Maybe<Scalars['String']>;
  refundReference?: Maybe<Scalars['String']>;
  sourceEffect?: Maybe<CmpInvoiceSourceEffectEnum>;
  summary: Scalars['String'];
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpOperationalEventTypeEnum {
  ProspectCreated = 'PROSPECT_CREATED',
  ProspectUpdated = 'PROSPECT_UPDATED',
  ProspectConverted = 'PROSPECT_CONVERTED',
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  MemberUpdated = 'MEMBER_UPDATED',
  MemberStaffNoteAdded = 'MEMBER_STAFF_NOTE_ADDED',
  BoardApproved = 'BOARD_APPROVED',
  MemberSuspended = 'MEMBER_SUSPENDED',
  MemberActivated = 'MEMBER_ACTIVATED',
  MemberArchived = 'MEMBER_ARCHIVED',
  MemberMembershipChangeQueued = 'MEMBER_MEMBERSHIP_CHANGE_QUEUED',
  MemberMembershipChangeApplied = 'MEMBER_MEMBERSHIP_CHANGE_APPLIED',
  MemberMembershipChangeActionRequired = 'MEMBER_MEMBERSHIP_CHANGE_ACTION_REQUIRED',
  MemberMembershipChangeCancelled = 'MEMBER_MEMBERSHIP_CHANGE_CANCELLED',
  MemberDashboardLogin = 'MEMBER_DASHBOARD_LOGIN',
  MemberPerkCreated = 'MEMBER_PERK_CREATED',
  PasswordResetRequested = 'PASSWORD_RESET_REQUESTED',
  PaymentRequestResent = 'PAYMENT_REQUEST_RESENT',
  ManualPaymentRecorded = 'MANUAL_PAYMENT_RECORDED',
  MemberDeclined = 'MEMBER_DECLINED',
  ApplicationStartedFromExisting = 'APPLICATION_STARTED_FROM_EXISTING',
  StripeCheckoutStarted = 'STRIPE_CHECKOUT_STARTED',
  StripeCardSaved = 'STRIPE_CARD_SAVED',
  StripePaymentSucceeded = 'STRIPE_PAYMENT_SUCCEEDED',
  StripePaymentFailed = 'STRIPE_PAYMENT_FAILED',
  StripeSessionExpired = 'STRIPE_SESSION_EXPIRED',
  SavedCardChargeStarted = 'SAVED_CARD_CHARGE_STARTED',
  RenewalWorkClaimed = 'RENEWAL_WORK_CLAIMED',
  RenewalReminderSent = 'RENEWAL_REMINDER_SENT',
  RenewalInvoiceCreated = 'RENEWAL_INVOICE_CREATED',
  RenewalInvoiceFailed = 'RENEWAL_INVOICE_FAILED',
  RenewalPaymentRequestSent = 'RENEWAL_PAYMENT_REQUEST_SENT',
  RenewalAutoChargeStarted = 'RENEWAL_AUTO_CHARGE_STARTED',
  RenewalAutoChargeSkipped = 'RENEWAL_AUTO_CHARGE_SKIPPED',
  RenewalAutoChargeFailed = 'RENEWAL_AUTO_CHARGE_FAILED',
  UnpaidPaymentReminderSent = 'UNPAID_PAYMENT_REMINDER_SENT',
  ChamberUnpaidPaymentReminderSent = 'CHAMBER_UNPAID_PAYMENT_REMINDER_SENT',
  MemberRenewalDateAdvanced = 'MEMBER_RENEWAL_DATE_ADVANCED',
  EventCreated = 'EVENT_CREATED',
  EventUpdated = 'EVENT_UPDATED',
  EventPublished = 'EVENT_PUBLISHED',
  EventUnpublished = 'EVENT_UNPUBLISHED',
  EventCanceled = 'EVENT_CANCELED',
  EventCompleted = 'EVENT_COMPLETED',
  EventDuplicated = 'EVENT_DUPLICATED',
  EventRegistrationSubmitted = 'EVENT_REGISTRATION_SUBMITTED',
  EventRegistrationConfirmed = 'EVENT_REGISTRATION_CONFIRMED',
  EventRegistrationCanceled = 'EVENT_REGISTRATION_CANCELED',
  EventAttendeeUpdated = 'EVENT_ATTENDEE_UPDATED',
  EventSponsorshipRequestSubmitted = 'EVENT_SPONSORSHIP_REQUEST_SUBMITTED',
  EventSponsorshipApproved = 'EVENT_SPONSORSHIP_APPROVED',
  EventSponsorshipRejected = 'EVENT_SPONSORSHIP_REJECTED',
  InvoiceCreated = 'INVOICE_CREATED',
  InvoiceVoided = 'INVOICE_VOIDED',
  InvoiceReissued = 'INVOICE_REISSUED',
  InvoicePaymentReceivedAfterVoid = 'INVOICE_PAYMENT_RECEIVED_AFTER_VOID',
  InvoicePaymentReceivedAfterSettlement = 'INVOICE_PAYMENT_RECEIVED_AFTER_SETTLEMENT',
  InvoicePaymentReceivedFromRetiredSurface = 'INVOICE_PAYMENT_RECEIVED_FROM_RETIRED_SURFACE',
  InvoiceRefundRecorded = 'INVOICE_REFUND_RECORDED',
  InvoiceRefundFailed = 'INVOICE_REFUND_FAILED',
  InvoiceCreditIssued = 'INVOICE_CREDIT_ISSUED',
  InvoiceExportGenerated = 'INVOICE_EXPORT_GENERATED',
  InvoicePdfDownloaded = 'INVOICE_PDF_DOWNLOADED',
  InvoiceManualPaymentRecorded = 'INVOICE_MANUAL_PAYMENT_RECORDED',
  InvoicePaymentRequestSent = 'INVOICE_PAYMENT_REQUEST_SENT',
  InvoicePaymentRequestResent = 'INVOICE_PAYMENT_REQUEST_RESENT',
  InvoicePaymentReceiptResent = 'INVOICE_PAYMENT_RECEIPT_RESENT',
  InvoiceDocumentEmailed = 'INVOICE_DOCUMENT_EMAILED',
  InvoiceApproved = 'INVOICE_APPROVED',
  InvoiceDraftUpdated = 'INVOICE_DRAFT_UPDATED',
  InvoiceDraftDeleted = 'INVOICE_DRAFT_DELETED'
}

export enum CmpOperationalSourceKindEnum {
  ProspectManagement = 'PROSPECT_MANAGEMENT',
  MemberApplication = 'MEMBER_APPLICATION',
  MemberRenewal = 'MEMBER_RENEWAL',
  EventRegistration = 'EVENT_REGISTRATION',
  EventSponsorship = 'EVENT_SPONSORSHIP',
  EventManagement = 'EVENT_MANAGEMENT',
  NewsletterCampaign = 'NEWSLETTER_CAMPAIGN',
  Advertising = 'ADVERTISING',
  CustomInvoice = 'CUSTOM_INVOICE',
  InvoiceOperations = 'INVOICE_OPERATIONS'
}

export enum CmpOutboundEmailKindEnum {
  ExternalEmailCapture = 'EXTERNAL_EMAIL_CAPTURE',
  EventMemberPreCheckIn = 'EVENT_MEMBER_PRE_CHECK_IN',
  EventAttendeeInformationRequired = 'EVENT_ATTENDEE_INFORMATION_REQUIRED',
  Report = 'REPORT',
  MemberDashboardCredentials = 'MEMBER_DASHBOARD_CREDENTIALS',
  ChamberPaidInvoiceCopy = 'CHAMBER_PAID_INVOICE_COPY',
  ChamberInvoiceCreatedCopy = 'CHAMBER_INVOICE_CREATED_COPY',
  MemberDashboardHelpRequest = 'MEMBER_DASHBOARD_HELP_REQUEST',
  ApplicationAcknowledgement = 'APPLICATION_ACKNOWLEDGEMENT',
  ChamberApplicationReceived = 'CHAMBER_APPLICATION_RECEIVED',
  ChamberMembershipPaymentReceived = 'CHAMBER_MEMBERSHIP_PAYMENT_RECEIVED',
  DuplicateApplicationReview = 'DUPLICATE_APPLICATION_REVIEW',
  ManualPaymentInstructions = 'MANUAL_PAYMENT_INSTRUCTIONS',
  PaymentReceipt = 'PAYMENT_RECEIPT',
  MembershipApproved = 'MEMBERSHIP_APPROVED',
  MembershipDeclined = 'MEMBERSHIP_DECLINED',
  RenewalReminder = 'RENEWAL_REMINDER',
  RenewalPaymentInstructions = 'RENEWAL_PAYMENT_INSTRUCTIONS',
  UnpaidPaymentReminder = 'UNPAID_PAYMENT_REMINDER',
  ChamberUnpaidPaymentReminder = 'CHAMBER_UNPAID_PAYMENT_REMINDER',
  EventRegistrationAcknowledgement = 'EVENT_REGISTRATION_ACKNOWLEDGEMENT',
  EventManualPaymentInstructions = 'EVENT_MANUAL_PAYMENT_INSTRUCTIONS',
  EventPaymentReceipt = 'EVENT_PAYMENT_RECEIPT',
  ChamberEventRegistrationReceived = 'CHAMBER_EVENT_REGISTRATION_RECEIVED',
  ChamberEventSponsorshipRequestReceived = 'CHAMBER_EVENT_SPONSORSHIP_REQUEST_RECEIVED',
  ChamberEventSponsorshipPaymentReceived = 'CHAMBER_EVENT_SPONSORSHIP_PAYMENT_RECEIVED',
  EventSponsorshipRequestReceived = 'EVENT_SPONSORSHIP_REQUEST_RECEIVED',
  EventSponsorshipApprovalPaymentRequest = 'EVENT_SPONSORSHIP_APPROVAL_PAYMENT_REQUEST',
  EventSponsorshipRejection = 'EVENT_SPONSORSHIP_REJECTION',
  EventReminder_24Hour = 'EVENT_REMINDER_24_HOUR',
  InvoicePaymentRequest = 'INVOICE_PAYMENT_REQUEST',
  InvoicePaymentReminder = 'INVOICE_PAYMENT_REMINDER',
  InvoicePaymentReceipt = 'INVOICE_PAYMENT_RECEIPT',
  InvoiceDocument = 'INVOICE_DOCUMENT',
  NewsletterReview = 'NEWSLETTER_REVIEW',
  NewsletterCampaign = 'NEWSLETTER_CAMPAIGN'
}

export type CmpOutboundEmailReturn = {
  __typename?: 'CmpOutboundEmailReturn';
  senderDisplayName?: Maybe<Scalars['String']>;
  senderUserId?: Maybe<Scalars['String']>;
  memberCommunicationBody?: Maybe<Scalars['String']>;
  memberCommunicationBodyFormat?: Maybe<ChamberMemberProEmailBodyFormatEnum>;
  communicationAttachments?: Maybe<Array<CmpMemberCommunicationAttachmentReturn>>;
  additionalToEmails?: Maybe<Array<Scalars['String']>>;
  ccEmails?: Maybe<Array<Scalars['String']>>;
  bccEmails?: Maybe<Array<Scalars['String']>>;
  intendedToEmails?: Maybe<Array<Scalars['String']>>;
  intendedCcEmails?: Maybe<Array<Scalars['String']>>;
  intendedBccEmails?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  chamberId: Scalars['String'];
  chamberMemberId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventRegistrationId?: Maybe<Scalars['String']>;
  eventSponsorshipRequestId?: Maybe<Scalars['String']>;
  eventAttendeeId?: Maybe<Scalars['String']>;
  newsletterId?: Maybe<Scalars['String']>;
  sourceKind?: Maybe<CmpOperationalSourceKindEnum>;
  invoiceId?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
  isCmpMemberModuleTestData?: Maybe<Scalars['Boolean']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
  isCmpNewsletterModuleTestData?: Maybe<Scalars['Boolean']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
  kind: CmpOutboundEmailKindEnum;
  status: CmpOutboundEmailStatusEnum;
  toEmail: Scalars['String'];
  intendedToEmail?: Maybe<Scalars['String']>;
  recipientOverrideUsed: Scalars['Boolean'];
  fromEmail: Scalars['String'];
  replyToEmail?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  providerMessageId?: Maybe<Scalars['String']>;
  openedAtUtcMilli?: Maybe<Scalars['Float']>;
  clickedAtUtcMilli?: Maybe<Scalars['Float']>;
  errorMessage?: Maybe<Scalars['String']>;
  fallbackSenderUsed: Scalars['Boolean'];
  attachmentCount: Scalars['Float'];
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  attemptedAtUtcMilli?: Maybe<Scalars['Float']>;
  sentAtUtcMilli?: Maybe<Scalars['Float']>;
  failedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpOutboundEmailStatusEnum {
  Sending = 'SENDING',
  Sent = 'SENT',
  Failed = 'FAILED',
  Skipped = 'SKIPPED',
  DeliveryUnknown = 'DELIVERY_UNKNOWN'
}

export type CmpPaymentChoiceInput = {
  type: CmpPaymentChoiceTypeEnum;
  manualPaymentMethodId?: Maybe<Scalars['String']>;
  autoRenew?: Maybe<Scalars['Boolean']>;
  emailCommunicationConsentConfirmed?: Maybe<Scalars['Boolean']>;
};

export type CmpPaymentChoiceReturn = {
  __typename?: 'CmpPaymentChoiceReturn';
  type: CmpPaymentChoiceTypeEnum;
  manualPaymentMethodId?: Maybe<Scalars['String']>;
  manualPaymentMethodLabel?: Maybe<Scalars['String']>;
  autoRenew: Scalars['Boolean'];
  emailCommunicationConsentConfirmed: Scalars['Boolean'];
};

export enum CmpPaymentChoiceTypeEnum {
  CreditCard = 'CREDIT_CARD',
  Manual = 'MANUAL',
  Free = 'FREE',
  ThirdParty = 'THIRD_PARTY'
}

export enum CmpPaymentRequestStateEnum {
  NotSent = 'NOT_SENT',
  Sent = 'SENT',
  Expired = 'EXPIRED',
  Paid = 'PAID',
  Failed = 'FAILED',
  Abandoned = 'ABANDONED',
  CardSaved = 'CARD_SAVED',
  ActionRequired = 'ACTION_REQUIRED'
}

export type CmpPaymentReturn = {
  __typename?: 'CmpPaymentReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  chamberMemberId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventRegistrationId?: Maybe<Scalars['String']>;
  eventSponsorshipRequestId?: Maybe<Scalars['String']>;
  eventAttendeeId?: Maybe<Scalars['String']>;
  sourceKind?: Maybe<CmpOperationalSourceKindEnum>;
  invoiceId?: Maybe<Scalars['String']>;
  isCmpMemberModuleTestData?: Maybe<Scalars['Boolean']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
  amountInCents: Scalars['Float'];
  paymentMethodLabel: Scalars['String'];
  status: CmpPaymentStatusEnum;
  reference?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  stripeCheckoutSessionId?: Maybe<Scalars['String']>;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  stripePaymentMethodId?: Maybe<Scalars['String']>;
  receivedAtUtcMilli: Scalars['Float'];
  createdByUserId?: Maybe<Scalars['String']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpPaymentStatusEnum {
  Paid = 'PAID',
  Failed = 'FAILED',
  Sent = 'SENT',
  Recorded = 'RECORDED',
  Refunded = 'REFUNDED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED'
}

export enum CmpPrimaryMemberCredentialsActionEnum {
  Download = 'DOWNLOAD',
  Send = 'SEND'
}

export type CmpPrimaryMemberCredentialsExclusionCount = {
  __typename?: 'CmpPrimaryMemberCredentialsExclusionCount';
  reason: CmpPrimaryMemberCredentialsExclusionReasonEnum;
  count: Scalars['Int'];
};

export enum CmpPrimaryMemberCredentialsExclusionReasonEnum {
  Suspended = 'SUSPENDED',
  Pending = 'PENDING',
  Past = 'PAST',
  NotActive = 'NOT_ACTIVE',
  NoPrimaryEmail = 'NO_PRIMARY_EMAIL',
  PrimaryEmailDiffersFromLogin = 'PRIMARY_EMAIL_DIFFERS_FROM_LOGIN',
  AlreadyLoggedIn = 'ALREADY_LOGGED_IN',
  CredentialsAlreadySent = 'CREDENTIALS_ALREADY_SENT',
  NoDashboardAccount = 'NO_DASHBOARD_ACCOUNT',
  OpenAccessClaim = 'OPEN_ACCESS_CLAIM',
  Other = 'OTHER'
}

export type CmpPrimaryMemberCredentialsInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  expectedIdentity: Scalars['String'];
  action: CmpPrimaryMemberCredentialsActionEnum;
};

export type CmpPrimaryMemberCredentialsLastSentReturn = {
  __typename?: 'CmpPrimaryMemberCredentialsLastSentReturn';
  lastSentAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpPrimaryMemberCredentialsPlan = {
  __typename?: 'CmpPrimaryMemberCredentialsPlan';
  fromEmail: Scalars['String'];
  replyToEmail?: Maybe<Scalars['String']>;
  recipients: Array<CmpPrimaryMemberCredentialsRecipient>;
  skippedCount: Scalars['Int'];
  skippedReasons: Array<CmpPrimaryMemberCredentialsExclusionCount>;
  lastSentAtUtcMilli?: Maybe<Scalars['Float']>;
  subject: Scalars['String'];
  emailHtml: Scalars['String'];
  recipientOverrideUsed: Scalars['Boolean'];
  loginUrl: Scalars['String'];
};

export type CmpPrimaryMemberCredentialsRecipient = {
  __typename?: 'CmpPrimaryMemberCredentialsRecipient';
  memberId: Scalars['String'];
  memberName: Scalars['String'];
  contactName: Scalars['String'];
  email: Scalars['String'];
  actualRecipient: Scalars['String'];
  expectedIdentity: Scalars['String'];
};

export type CmpPrimaryMemberCredentialsResult = {
  __typename?: 'CmpPrimaryMemberCredentialsResult';
  completed: Scalars['Boolean'];
  alreadyProcessed: Scalars['Boolean'];
  warning?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  sentAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpProfileSectionSavedAtReturn = {
  __typename?: 'CmpProfileSectionSavedAtReturn';
  section: Scalars['String'];
  savedAtUtcMilli: Scalars['Float'];
};

export type CmpProspectAddressInput = {
  streetAddress?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type CmpProspectAddressReturn = {
  __typename?: 'CmpProspectAddressReturn';
  streetAddress?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
};

export type CmpProspectAnalyticsReturn = {
  __typename?: 'CmpProspectAnalyticsReturn';
  totalProspectsYtd: Scalars['Float'];
  newProspectsLast30Days: Scalars['Float'];
  convertedToMembersYtd: Scalars['Float'];
  previousFiscalYearTotalProspectsYtd: Scalars['Float'];
  previousYearNewProspectsSame30DayPeriod: Scalars['Float'];
  previousFiscalYearConvertedToMembersYtd: Scalars['Float'];
};

export type CmpProspectChamberInput = {
  chamberId: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  sortColumn?: Maybe<CmpManageProspectsSortColumnEnum>;
  sortDirection?: Maybe<CmpSortDirectionEnum>;
};

export type CmpProspectExportReturn = {
  __typename?: 'CmpProspectExportReturn';
  filename: Scalars['String'];
  contentType: Scalars['String'];
  csvContent: Scalars['String'];
  rowCount: Scalars['Float'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type CmpProspectFieldsInput = {
  leadCaptureId: Scalars['String'];
  createdByName?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyWebsite?: Maybe<Scalars['String']>;
  mainContactName: Scalars['String'];
  mainContactTitle?: Maybe<Scalars['String']>;
  mainContactEmail: Scalars['String'];
  mainPhoneNumber?: Maybe<Scalars['String']>;
  mainPhoneNumberExtension?: Maybe<Scalars['String']>;
  mobilePhoneNumber?: Maybe<Scalars['String']>;
  address: CmpProspectAddressInput;
};

export type CmpProspectLeadCaptureMutationReturn = {
  __typename?: 'CmpProspectLeadCaptureMutationReturn';
  leadCaptureSavedSuccessfully: Scalars['Boolean'];
  leadCapture: CmpProspectLeadCaptureReturn;
};

export type CmpProspectLeadCaptureReturn = {
  __typename?: 'CmpProspectLeadCaptureReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  label: Scalars['String'];
  isDefault: Scalars['Boolean'];
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpProspectMemberMatchOptionReturn = {
  __typename?: 'CmpProspectMemberMatchOptionReturn';
  id: Scalars['String'];
  name: Scalars['String'];
  lifecycleStatus: CmpMemberLifecycleStatusEnum;
};

export type CmpProspectMutationReturn = {
  __typename?: 'CmpProspectMutationReturn';
  prospectSavedSuccessfully: Scalars['Boolean'];
  prospect: CmpProspectReturn;
};

export type CmpProspectNoteMutationReturn = {
  __typename?: 'CmpProspectNoteMutationReturn';
  noteSavedSuccessfully: Scalars['Boolean'];
  note: CmpProspectNoteReturn;
};

export type CmpProspectNoteReturn = {
  __typename?: 'CmpProspectNoteReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  prospectId: Scalars['String'];
  comment: Scalars['String'];
  staffUserId?: Maybe<Scalars['String']>;
  staffDisplayName: Scalars['String'];
  isCmpProspectModuleTestData?: Maybe<Scalars['Boolean']>;
  createdAtUtcMilli: Scalars['Float'];
};

export type CmpProspectReturn = {
  __typename?: 'CmpProspectReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  status: CmpProspectStatusEnum;
  leadCaptureId: Scalars['String'];
  leadCaptureLabel: Scalars['String'];
  createdByName?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyWebsite?: Maybe<Scalars['String']>;
  mainContactName?: Maybe<Scalars['String']>;
  mainContactTitle?: Maybe<Scalars['String']>;
  mainContactEmail?: Maybe<Scalars['String']>;
  mainPhoneNumber?: Maybe<Scalars['String']>;
  mainPhoneNumberExtension?: Maybe<Scalars['String']>;
  mobilePhoneNumber?: Maybe<Scalars['String']>;
  address: CmpProspectAddressReturn;
  convertedMemberId?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  updatedByUserId?: Maybe<Scalars['String']>;
  convertedByUserId?: Maybe<Scalars['String']>;
  isCmpProspectModuleTestData?: Maybe<Scalars['Boolean']>;
  convertedAtUtcMilli?: Maybe<Scalars['Float']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli: Scalars['Float'];
};

export type CmpProspectStaffOptionReturn = {
  __typename?: 'CmpProspectStaffOptionReturn';
  id: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export enum CmpProspectStatusEnum {
  Active = 'ACTIVE',
  Converted = 'CONVERTED'
}

export type CmpPublicActiveMemberCompanyReturn = {
  __typename?: 'CmpPublicActiveMemberCompanyReturn';
  id: Scalars['String'];
  name: Scalars['String'];
  address?: Maybe<AddressReturn>;
  contactName?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type CmpPublicChamberContactsReturn = {
  __typename?: 'CmpPublicChamberContactsReturn';
  supportContactName?: Maybe<Scalars['String']>;
  supportContactEmail?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  titledStaff: Array<CmpPublicChamberStaffContactReturn>;
};

export type CmpPublicChamberMetricsReturn = {
  __typename?: 'CmpPublicChamberMetricsReturn';
  activeMemberCount: Scalars['Float'];
  employeeCount: Scalars['Float'];
  appWidePerkCount?: Maybe<Scalars['Float']>;
};

export type CmpPublicChamberStaffContactReturn = {
  __typename?: 'CmpPublicChamberStaffContactReturn';
  name: Scalars['String'];
  jobTitle: Scalars['String'];
  email?: Maybe<Scalars['String']>;
};

export type CmpPublicEventManualPaymentMethodReturn = {
  __typename?: 'CmpPublicEventManualPaymentMethodReturn';
  id: Scalars['String'];
  label: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
};

export type CmpPublicEventPaymentSettingsReturn = {
  __typename?: 'CmpPublicEventPaymentSettingsReturn';
  creditCardPaymentsEnabled: Scalars['Boolean'];
  creditCardPaymentsReady: Scalars['Boolean'];
  eventTicketCreditCardPaymentMode: ChamberMemberProEventTicketCreditCardPaymentModeEnum;
  manualPaymentMethods: Array<CmpPublicEventManualPaymentMethodReturn>;
};

export type CmpPublicEventPreCheckInInput = {
  outboundEmailId: Scalars['String'];
  credential: Scalars['String'];
};

export type CmpPublicEventPreCheckInReturn = {
  __typename?: 'CmpPublicEventPreCheckInReturn';
  eventName: Scalars['String'];
  attendeeName: Scalars['String'];
  startAtUtcMilli: Scalars['Float'];
  timeZone: Scalars['String'];
  preCheckedInAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpPublicEventPricingPreviewKindEnum {
  Registration = 'REGISTRATION',
  Sponsorship = 'SPONSORSHIP'
}

export type CmpPublicEventRegistrationReceiptReturn = {
  __typename?: 'CmpPublicEventRegistrationReceiptReturn';
  id: Scalars['String'];
  registrationNumber: Scalars['String'];
  invoiceNumber?: Maybe<Scalars['String']>;
  status: CmpEventRegistrationStatusEnum;
  paymentStatus: CmpEventPaymentStatusEnum;
  totalAmountInCents: Scalars['Float'];
};

export type CmpPublicEventSponsorReturn = {
  __typename?: 'CmpPublicEventSponsorReturn';
  id: Scalars['String'];
  sponsorshipRequestId: Scalars['String'];
  sponsorshipPackageId: Scalars['String'];
  sponsorshipPackageNameSnapshot: Scalars['String'];
  sponsorDisplayName: Scalars['String'];
  sponsorLogoUrl?: Maybe<Scalars['String']>;
  sponsorLogoLink?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

export type CmpPublicEventSponsorshipRequestReceiptReturn = {
  __typename?: 'CmpPublicEventSponsorshipRequestReceiptReturn';
  id: Scalars['String'];
  status: CmpEventSponsorshipRequestStatusEnum;
  sponsorDisplayName: Scalars['String'];
  sponsorshipPackageNameSnapshot: Scalars['String'];
  invoiceNumber?: Maybe<Scalars['String']>;
};

export type CmpPublicEventSummaryLocationReturn = {
  __typename?: 'CmpPublicEventSummaryLocationReturn';
  mode: CmpEventLocationModeEnum;
  venueName?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type CmpPublicEventSummaryReturn = {
  __typename?: 'CmpPublicEventSummaryReturn';
  eventKind?: Maybe<CmpEventKindEnum>;
  externalEventUrl?: Maybe<Scalars['String']>;
  startDateOnly?: Maybe<Scalars['Boolean']>;
  endDateOnly?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  heroShortDescription?: Maybe<Scalars['String']>;
  status: CmpEventStatusEnum;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  startAtUtcMilli: Scalars['Float'];
  endAtUtcMilli: Scalars['Float'];
  timeZone: Scalars['String'];
  eventTypeId: Scalars['String'];
  eventTypeLabelSnapshot: Scalars['String'];
  eventTypeColorSnapshot: Scalars['String'];
  location: CmpPublicEventSummaryLocationReturn;
  featuredImageUrl?: Maybe<Scalars['String']>;
};

export type CmpPublicMembershipApplicationAdditionalCostReturn = {
  __typename?: 'CmpPublicMembershipApplicationAdditionalCostReturn';
  id: Scalars['String'];
  name: Scalars['String'];
  enabled: Scalars['Boolean'];
  annualAmountInDollars: Scalars['Float'];
  monthlyAmountInDollars: Scalars['Float'];
  description: Scalars['String'];
  feeType: ChamberMemberProAdditionalCostFeeTypeEnum;
  percentage?: Maybe<Scalars['Float']>;
  taxExempt: Scalars['Boolean'];
};

export type CmpPublicMembershipApplicationBenefitComparisonReturn = {
  __typename?: 'CmpPublicMembershipApplicationBenefitComparisonReturn';
  valid: Scalars['Boolean'];
  benefits: Array<CmpPublicMembershipApplicationBenefitReturn>;
  models: Array<CmpPublicMembershipApplicationModelBenefitInclusionReturn>;
};

export type CmpPublicMembershipApplicationBenefitReturn = {
  __typename?: 'CmpPublicMembershipApplicationBenefitReturn';
  id: Scalars['String'];
  label: Scalars['String'];
};

export type CmpPublicMembershipApplicationCardProcessingFeeReturn = {
  __typename?: 'CmpPublicMembershipApplicationCardProcessingFeeReturn';
  enabled: Scalars['Boolean'];
  percentage: Scalars['Float'];
  fixedAmountInDollars: Scalars['Float'];
};

export type CmpPublicMembershipApplicationCheckoutReturn = {
  __typename?: 'CmpPublicMembershipApplicationCheckoutReturn';
  id: Scalars['String'];
  url: Scalars['String'];
  mode: CmpStripeSessionModeEnum;
};

export type CmpPublicMembershipApplicationCommunicationOptionsReturn = {
  __typename?: 'CmpPublicMembershipApplicationCommunicationOptionsReturn';
  emailEnabled: Scalars['Boolean'];
  phoneEnabled: Scalars['Boolean'];
  textMessageEnabled: Scalars['Boolean'];
};

export type CmpPublicMembershipApplicationEmployeeRangeReturn = {
  __typename?: 'CmpPublicMembershipApplicationEmployeeRangeReturn';
  id: Scalars['String'];
  from: Scalars['Float'];
  to?: Maybe<Scalars['Float']>;
  annualPriceInDollars: Scalars['Float'];
  monthlyPriceInDollars: Scalars['Float'];
};

export type CmpPublicMembershipApplicationInvoiceTaxCategoryReturn = {
  __typename?: 'CmpPublicMembershipApplicationInvoiceTaxCategoryReturn';
  enabled: Scalars['Boolean'];
  firstTaxRatePercentage: Scalars['Float'];
  secondTaxRatePercentage: Scalars['Float'];
};

export type CmpPublicMembershipApplicationInvoiceTaxSettingsReturn = {
  __typename?: 'CmpPublicMembershipApplicationInvoiceTaxSettingsReturn';
  membershipInvoices: CmpPublicMembershipApplicationInvoiceTaxCategoryReturn;
};

export type CmpPublicMembershipApplicationManualPaymentMethodReturn = {
  __typename?: 'CmpPublicMembershipApplicationManualPaymentMethodReturn';
  id: Scalars['String'];
  label: Scalars['String'];
  description: Scalars['String'];
};

export type CmpPublicMembershipApplicationMembershipModelReturn = {
  __typename?: 'CmpPublicMembershipApplicationMembershipModelReturn';
  id: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  paymentResponsibility: ChamberMemberProMembershipModelPaymentResponsibilityEnum;
  thirdPartyPayerName?: Maybe<Scalars['String']>;
  pricingModel: ChamberMemberProMembershipPricingModelEnum;
  annualPriceInDollars: Scalars['Float'];
  monthlyPriceInDollars: Scalars['Float'];
  additionalCosts: Array<CmpPublicMembershipApplicationAdditionalCostReturn>;
  ranges: Array<CmpPublicMembershipApplicationEmployeeRangeReturn>;
  iconUrl?: Maybe<Scalars['String']>;
  eligibilityEmployeesFrom?: Maybe<Scalars['Float']>;
  eligibilityEmployeesTo?: Maybe<Scalars['Float']>;
};

export type CmpPublicMembershipApplicationMembershipReturn = {
  __typename?: 'CmpPublicMembershipApplicationMembershipReturn';
  enabledPaymentSchedules: Array<ChamberMemberProPaymentScheduleEnum>;
  partTimeEmployeesPerFullTime: Scalars['Float'];
  allowAutoRenewal: Scalars['Boolean'];
  requireApproval: Scalars['Boolean'];
  paymentBeforeApprovalRule: ChamberMemberProPaymentBeforeApprovalRuleEnum;
  proratedSignupPricingEnabled: Scalars['Boolean'];
  proratedMembershipTermEndDate?: Maybe<Scalars['String']>;
  membershipOptionsIntro?: Maybe<Scalars['String']>;
  benefitComparison: CmpPublicMembershipApplicationBenefitComparisonReturn;
  membershipModels: Array<CmpPublicMembershipApplicationMembershipModelReturn>;
  proratedSignupPrices: Array<CmpPublicMembershipApplicationProratedSignupPriceReturn>;
};

export type CmpPublicMembershipApplicationModelBenefitInclusionReturn = {
  __typename?: 'CmpPublicMembershipApplicationModelBenefitInclusionReturn';
  modelId: Scalars['String'];
  includedBenefitIds: Array<Scalars['String']>;
};

export type CmpPublicMembershipApplicationMonthlyAdministrativeFeeReturn = {
  __typename?: 'CmpPublicMembershipApplicationMonthlyAdministrativeFeeReturn';
  enabled: Scalars['Boolean'];
  amountInDollars: Scalars['Float'];
};

export type CmpPublicMembershipApplicationOnboardingFeeReturn = {
  __typename?: 'CmpPublicMembershipApplicationOnboardingFeeReturn';
  enabled: Scalars['Boolean'];
  description: Scalars['String'];
  amountInDollars: Scalars['Float'];
};

export type CmpPublicMembershipApplicationPaymentsReturn = {
  __typename?: 'CmpPublicMembershipApplicationPaymentsReturn';
  creditCardPaymentsReady: Scalars['Boolean'];
  cardProcessingFee: CmpPublicMembershipApplicationCardProcessingFeeReturn;
  provincialChamberFee: CmpPublicMembershipApplicationProvincialChamberFeeReturn;
  invoiceTaxSettings: CmpPublicMembershipApplicationInvoiceTaxSettingsReturn;
  monthlyMembershipAdministrativeFee: CmpPublicMembershipApplicationMonthlyAdministrativeFeeReturn;
  oneTimeOnboardingFee: CmpPublicMembershipApplicationOnboardingFeeReturn;
  manualPaymentMethods: Array<CmpPublicMembershipApplicationManualPaymentMethodReturn>;
};

export type CmpPublicMembershipApplicationProratedSignupPriceReturn = {
  __typename?: 'CmpPublicMembershipApplicationProratedSignupPriceReturn';
  pricingKey: Scalars['String'];
  month: MonthEnum;
  priceInDollars: Scalars['Float'];
  membershipMonths?: Maybe<Scalars['Int']>;
};

export type CmpPublicMembershipApplicationProvincialChamberFeeReturn = {
  __typename?: 'CmpPublicMembershipApplicationProvincialChamberFeeReturn';
  enabled: Scalars['Boolean'];
  amountInDollars: Scalars['Float'];
};

export type CmpPublicMembershipApplicationSettingsReturn = {
  __typename?: 'CmpPublicMembershipApplicationSettingsReturn';
  setup: CmpPublicMembershipApplicationSetupReturn;
  membership: CmpPublicMembershipApplicationMembershipReturn;
  payments: CmpPublicMembershipApplicationPaymentsReturn;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  quoteFingerprint: Scalars['String'];
  quoteExpiresAtUtcMilli: Scalars['Float'];
};

export type CmpPublicMembershipApplicationSetupReturn = {
  __typename?: 'CmpPublicMembershipApplicationSetupReturn';
  currency: ChamberMemberProCurrencyEnum;
  membershipApplicationCommunicationOptions: CmpPublicMembershipApplicationCommunicationOptionsReturn;
};

export type CmpPublicMembershipCheckoutVerificationReturn = {
  __typename?: 'CmpPublicMembershipCheckoutVerificationReturn';
  verified: Scalars['Boolean'];
  checkoutCompleted: Scalars['Boolean'];
  paymentCompleted: Scalars['Boolean'];
  cardSaved: Scalars['Boolean'];
  mode: CmpStripeSessionModeEnum;
  lifecycleStatus: CmpMemberLifecycleStatusEnum;
  boardApprovalRequired: Scalars['Boolean'];
  boardApproved: Scalars['Boolean'];
  paymentRequestState: CmpPaymentRequestStateEnum;
};

export enum CmpPublicMembershipPaymentMethodEnum {
  CreditCard = 'CREDIT_CARD',
  Manual = 'MANUAL'
}

export type CmpPublicNewsroomEntryReturn = {
  __typename?: 'CmpPublicNewsroomEntryReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  sourceKind: CmpNewsroomEntrySourceKindEnum;
  slug: Scalars['String'];
  title: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  featuredImageUrl?: Maybe<Scalars['String']>;
  emailType?: Maybe<CmpNewsletterTypeEnum>;
  category?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  authorName?: Maybe<Scalars['String']>;
  publishedAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type CmpPublicWebsiteAnalyticsConfigReturn = {
  __typename?: 'CmpPublicWebsiteAnalyticsConfigReturn';
  enabled: Scalars['Boolean'];
  googleAnalyticsMeasurementId?: Maybe<Scalars['String']>;
  consentVersion: Scalars['String'];
  websiteBuilderUrl?: Maybe<Scalars['String']>;
  websiteHostname?: Maybe<Scalars['String']>;
};

export type CmpRefundReturn = {
  __typename?: 'CmpRefundReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  invoiceId: Scalars['String'];
  paymentId?: Maybe<Scalars['String']>;
  refundAmountInCents: Scalars['Float'];
  status: CmpRefundStatusEnum;
  reason?: Maybe<Scalars['String']>;
  paymentMethodLabel?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  refundedAtUtcMilli?: Maybe<Scalars['Float']>;
  stripeRefundId?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  completedAtUtcMilli?: Maybe<Scalars['Float']>;
  failedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpRefundStatusEnum {
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
  Failed = 'FAILED',
  Canceled = 'CANCELED',
  Recorded = 'RECORDED'
}

export enum CmpRenewalWorkKindEnum {
  RenewalReminder = 'RENEWAL_REMINDER',
  AutoRenewalNotice = 'AUTO_RENEWAL_NOTICE',
  RenewalReminderOne = 'RENEWAL_REMINDER_ONE',
  RenewalReminderTwo = 'RENEWAL_REMINDER_TWO',
  RenewalInvoice = 'RENEWAL_INVOICE',
  RenewalPaymentInstructions = 'RENEWAL_PAYMENT_INSTRUCTIONS',
  RenewalAutoCharge = 'RENEWAL_AUTO_CHARGE',
  UnpaidPaymentReminder = 'UNPAID_PAYMENT_REMINDER',
  ChamberUnpaidPaymentReminder = 'CHAMBER_UNPAID_PAYMENT_REMINDER',
  RenewalDateAdvance = 'RENEWAL_DATE_ADVANCE'
}

export type CmpRenewalWorkReturn = {
  __typename?: 'CmpRenewalWorkReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  chamberMemberId: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
  isCmpMemberModuleTestData?: Maybe<Scalars['Boolean']>;
  workKind: CmpRenewalWorkKindEnum;
  status: CmpRenewalWorkStatusEnum;
  renewalCycleDateUtcMilli?: Maybe<Scalars['Float']>;
  workKey: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  completedAtUtcMilli?: Maybe<Scalars['Float']>;
  failedAtUtcMilli?: Maybe<Scalars['Float']>;
  skippedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum CmpRenewalWorkStatusEnum {
  Started = 'STARTED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Skipped = 'SKIPPED'
}

export type CmpReportBreakdownReturn = {
  __typename?: 'CmpReportBreakdownReturn';
  title: Scalars['String'];
  items: Array<CmpReportSummaryReturn>;
  columnCount: Scalars['Int'];
};

export type CmpReportCellReturn = {
  __typename?: 'CmpReportCellReturn';
  text: Scalars['String'];
  detail?: Maybe<Scalars['String']>;
  sortValue: Scalars['String'];
  tone?: Maybe<Scalars['String']>;
};

export type CmpReportDocumentReturn = {
  __typename?: 'CmpReportDocumentReturn';
  title: Scalars['String'];
  category: Scalars['String'];
  columns: Array<Scalars['String']>;
  rows: Array<CmpReportRowReturn>;
  summary: Array<CmpReportSummaryReturn>;
  breakdowns?: Maybe<Array<CmpReportBreakdownReturn>>;
  metadata?: Maybe<Array<CmpReportSummaryReturn>>;
  totals: Array<Scalars['String']>;
  footer: Scalars['String'];
  warnings: Array<Scalars['String']>;
  defaultSortColumn: Scalars['Int'];
};

export type CmpReportFilterOptionReturn = {
  __typename?: 'CmpReportFilterOptionReturn';
  value: Scalars['String'];
  label: Scalars['String'];
};

export type CmpReportRowReturn = {
  __typename?: 'CmpReportRowReturn';
  cells: Array<CmpReportCellReturn>;
  tone?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  groupKey?: Maybe<Scalars['String']>;
  groupLabel?: Maybe<Scalars['String']>;
  groupDetail?: Maybe<Scalars['String']>;
};

export type CmpReportSalesAccountOptionReturn = {
  __typename?: 'CmpReportSalesAccountOptionReturn';
  value: Scalars['String'];
  label: Scalars['String'];
  type: ChamberMemberProAccountAllocationTypeEnum;
};

export type CmpReportSummaryReturn = {
  __typename?: 'CmpReportSummaryReturn';
  label: Scalars['String'];
  value: Scalars['String'];
  detail?: Maybe<Scalars['String']>;
  tone?: Maybe<Scalars['String']>;
};

export enum CmpReportTypeEnum {
  FullMembership = 'FULL_MEMBERSHIP',
  AccountsReceivable = 'ACCOUNTS_RECEIVABLE',
  MembershipRevenue = 'MEMBERSHIP_REVENUE',
  GroupInsuranceRevenue = 'GROUP_INSURANCE_REVENUE',
  StripeCreditCardPayments = 'STRIPE_CREDIT_CARD_PAYMENTS',
  EventAttendeeList = 'EVENT_ATTENDEE_LIST',
  EventSponsorshipList = 'EVENT_SPONSORSHIP_LIST',
  NewMember = 'NEW_MEMBER',
  SuspendedMember = 'SUSPENDED_MEMBER',
  CancelledMember = 'CANCELLED_MEMBER',
  MemberRenewal = 'MEMBER_RENEWAL',
  MembershipAccountsReceivable = 'MEMBERSHIP_ACCOUNTS_RECEIVABLE',
  MemberChamberAnniversary = 'MEMBER_CHAMBER_ANNIVERSARY',
  MemberYearsInBusiness = 'MEMBER_YEARS_IN_BUSINESS',
  MembersByCategory = 'MEMBERS_BY_CATEGORY',
  MembersByEmployeeSize = 'MEMBERS_BY_EMPLOYEE_SIZE',
  MembersByTier = 'MEMBERS_BY_TIER',
  ChamberGroupInsurance = 'CHAMBER_GROUP_INSURANCE',
  MemberDashboardSignIns = 'MEMBER_DASHBOARD_SIGN_INS',
  MonthlyPaymentMembers = 'MONTHLY_PAYMENT_MEMBERS',
  AutoRenewalMembers = 'AUTO_RENEWAL_MEMBERS',
  EventRevenue = 'EVENT_REVENUE',
  EventSponsorshipRevenue = 'EVENT_SPONSORSHIP_REVENUE',
  EventTicketRevenue = 'EVENT_TICKET_REVENUE',
  AdvertisingRevenue = 'ADVERTISING_REVENUE',
  CustomRevenue = 'CUSTOM_REVENUE',
  Prospect = 'PROSPECT'
}

export enum CmpSortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum CmpStaffCheckoutModeEnum {
  Custom = 'CUSTOM',
  HostedFallback = 'HOSTED_FALLBACK',
  LegacyHosted = 'LEGACY_HOSTED'
}

export type CmpStaffEventInvoiceDetailsInput = {
  invoiceDate: Scalars['String'];
  dueDate: Scalars['String'];
  referencePurchaseOrder?: Maybe<Scalars['String']>;
};

export type CmpStaffEventTicketInvoiceLineInput = {
  ticketTypeId: Scalars['String'];
  quantity: Scalars['Float'];
  discountPercentage: Scalars['Float'];
  discountAmountInCents?: Maybe<Scalars['Float']>;
};

export type CmpStaffNoteReturn = {
  __typename?: 'CmpStaffNoteReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  subjectKind: CmpStaffNoteSubjectKindEnum;
  chamberMemberId?: Maybe<Scalars['String']>;
  prospectId?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
  createdByUserId: Scalars['String'];
  createdByDisplayName: Scalars['String'];
  isCmpMemberModuleTestData?: Maybe<Scalars['Boolean']>;
  isCmpProspectModuleTestData?: Maybe<Scalars['Boolean']>;
};

export enum CmpStaffNoteSubjectKindEnum {
  Member = 'MEMBER',
  Prospect = 'PROSPECT'
}

export type CmpStaffRecordablePaymentMethod = {
  __typename?: 'CmpStaffRecordablePaymentMethod';
  id: ChamberMemberProManualPaymentMethodTypeEnum;
  label: Scalars['String'];
};

export type CmpStripeCheckoutSessionReturn = {
  __typename?: 'CmpStripeCheckoutSessionReturn';
  id: Scalars['String'];
  url: Scalars['String'];
  mode: CmpStripeSessionModeEnum;
};

export enum CmpStripeSessionModeEnum {
  Payment = 'PAYMENT',
  Setup = 'SETUP'
}

export type CmpUserActivityCsvReturn = {
  __typename?: 'CmpUserActivityCsvReturn';
  fileName: Scalars['String'];
  csv: Scalars['String'];
};

export type CmpUserActivityLogFilterInput = {
  search?: Maybe<Scalars['String']>;
  fromUtcMilli?: Maybe<Scalars['Float']>;
  toUtcMilli?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  relatedRecordSearch?: Maybe<Scalars['String']>;
};

export type CmpUserActivityReturn = {
  __typename?: 'CmpUserActivityReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  actorUserId: Scalars['String'];
  actorDisplayName: Scalars['String'];
  relatedRecordId?: Maybe<Scalars['String']>;
  relatedRecordDisplayName?: Maybe<Scalars['String']>;
  section: Scalars['String'];
  action: Scalars['String'];
  activityDetails: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
};

export type CmpWebsiteAnalyticsIntegrationReturn = {
  __typename?: 'CmpWebsiteAnalyticsIntegrationReturn';
  provider: CmpWebsiteAnalyticsProviderEnum;
  enabled: Scalars['Boolean'];
  configured: Scalars['Boolean'];
  consentVersion: Scalars['String'];
};

export enum CmpWebsiteAnalyticsProviderEnum {
  GoogleAnalytics_4 = 'GOOGLE_ANALYTICS_4'
}

export type CmpWebsiteBuilderSsoIdentityReturn = {
  __typename?: 'CmpWebsiteBuilderSsoIdentityReturn';
  identityIssuer: Scalars['String'];
  identitySubject: Scalars['String'];
  userId: Scalars['String'];
  userType: UserType;
  chamberId: Scalars['String'];
  tenantHost: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type CmpWebsiteBuilderSsoLaunchReturn = {
  __typename?: 'CmpWebsiteBuilderSsoLaunchReturn';
  launchId: Scalars['String'];
  authorizationCode: Scalars['String'];
  nonce: Scalars['String'];
  exchangeUrl: Scalars['String'];
  tenantHost: Scalars['String'];
  audience: Scalars['String'];
  expiresAtUtcMilli: Scalars['Float'];
};

export type CmpWebsiteBuilderSsoRedeemReturn = {
  __typename?: 'CmpWebsiteBuilderSsoRedeemReturn';
  launchId: Scalars['String'];
  sessionId: Scalars['String'];
  sessionToken: Scalars['String'];
  sessionExpiresAtUtcMilli: Scalars['Float'];
  audience: Scalars['String'];
  identity: CmpWebsiteBuilderSsoIdentityReturn;
};

export type CmpWebsiteBuilderSsoRevokeReturn = {
  __typename?: 'CmpWebsiteBuilderSsoRevokeReturn';
  sessionId: Scalars['String'];
  revokedSuccessfully: Scalars['Boolean'];
};

export type CmpWebsiteBuilderSsoSessionValidationReturn = {
  __typename?: 'CmpWebsiteBuilderSsoSessionValidationReturn';
  launchId: Scalars['String'];
  sessionId: Scalars['String'];
  sessionExpiresAtUtcMilli: Scalars['Float'];
  audience: Scalars['String'];
  identity: CmpWebsiteBuilderSsoIdentityReturn;
};

export type CompleteCmpMemberCardUpdateInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  setupIntentId: Scalars['String'];
};

/** outcome: UPDATED, ALREADY_APPLIED or SUPERSEDED (a newer card update was saved first). */
export type CompleteCmpMemberCardUpdateReturn = {
  __typename?: 'CompleteCmpMemberCardUpdateReturn';
  cardOnFile?: Maybe<CmpMemberSavedCardReturn>;
  outcome: Scalars['String'];
};

export type CompleteMyCmpMemberCardUpdateInput = {
  setupIntentId: Scalars['String'];
  turnOnAutoRenewal?: Maybe<Scalars['Boolean']>;
};

export type CompleteStripeConnectOAuthReturn = {
  __typename?: 'CompleteStripeConnectOAuthReturn';
  stripeConnectCompletedSuccessfully: Scalars['Boolean'];
  chamberMemberProSettings: ChamberMemberProSettingsReturn;
};

export type ContactableChamberReturn = {
  __typename?: 'ContactableChamberReturn';
  id: Scalars['String'];
  name: Scalars['String'];
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  createdAtUtcTimestamp?: Maybe<Scalars['String']>;
};

export type ContactableCompanyReturn = {
  __typename?: 'ContactableCompanyReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  chamberName: Scalars['String'];
  name: Scalars['String'];
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  createdAtUtcTimestamp?: Maybe<Scalars['String']>;
};

export type CoordinateReturn = {
  __typename?: 'CoordinateReturn';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CreateAffinityProgramPartnerReturn = {
  __typename?: 'CreateAffinityProgramPartnerReturn';
  affinityProgramPartnerCreatedSuccessfully: Scalars['Boolean'];
  id: Scalars['String'];
};

export type CreateAllMemberLoginCredentialsReturn = {
  __typename?: 'CreateAllMemberLoginCredentialsReturn';
  processId: Scalars['String'];
};

export type CreateCapUserShareLeadingToOpenRecordMutationReturn = {
  __typename?: 'CreateCapUserShareLeadingToOpenRecordMutationReturn';
  recordCreatedSuccessfully: Scalars['Boolean'];
};

export type CreateChamberContactableCompanyMutationInput = {
  id: Scalars['String'];
  chamberId: Scalars['String'];
  name: Scalars['String'];
};

export type CreateChamberMembersMutationInput = {
  data: Array<ChamberMemberInput>;
};

export type CreateChamberMembersMutationReturn = {
  __typename?: 'CreateChamberMembersMutationReturn';
  results: Array<ChamberMemberUserReturn>;
};

export type CreateChamberMutationInput = {
  data: Array<ChamberInput>;
};

export type CreateChamberMutationReturn = {
  __typename?: 'CreateChamberMutationReturn';
  results: Array<ChamberAdminUserReturn>;
};

export type CreateChamberStaffUserInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  usagePermissions: ChamberStaffUsagePermissionsInput;
};

export type CreateCmpAdvertisingOptionInput = {
  chamberId: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Float'];
  sortOrder?: Maybe<Scalars['Float']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CreateCmpEventInput = {
  draftId?: Maybe<Scalars['String']>;
  expectedDraftRevision?: Maybe<Scalars['Float']>;
  chamberId: Scalars['String'];
  data: CmpEventDataInput;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CreateCmpEventLibraryItemInput = {
  pairedValue?: Maybe<Scalars['String']>;
  attendeesPerTicket?: Maybe<Scalars['Float']>;
  chamberId: Scalars['String'];
  kind: CmpEventLibraryKindEnum;
  value: Scalars['String'];
  sortOrder?: Maybe<Scalars['Float']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CreateCmpEventPreviewInput = {
  chamberId: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
  draftJson: Scalars['String'];
};

export type CreateCmpEventPreviewReturn = {
  __typename?: 'CreateCmpEventPreviewReturn';
  previewUrl: Scalars['String'];
  expiresAtUtcMilli: Scalars['Float'];
};

export type CreateCmpEventRegistrationInput = {
  expectedEventUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  chamberId: Scalars['String'];
  operationId: Scalars['String'];
  draftInvoiceId?: Maybe<Scalars['String']>;
  draftExpectedUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  eventId: Scalars['String'];
  closedEventAcknowledgedAtRevision?: Maybe<Scalars['Float']>;
  purchaserFirstName: Scalars['String'];
  purchaserLastName: Scalars['String'];
  purchaserEmail: Scalars['String'];
  purchaserPhone?: Maybe<Scalars['String']>;
  selectedMemberCompanyId?: Maybe<Scalars['String']>;
  selectedMemberCompanyNameSnapshot?: Maybe<Scalars['String']>;
  billing?: Maybe<CmpEventPublicBillingInput>;
  invoiceDetails?: Maybe<CmpStaffEventInvoiceDetailsInput>;
  ticketInvoiceLines?: Maybe<Array<CmpStaffEventTicketInvoiceLineInput>>;
  ticketQuantities?: Maybe<Array<CmpEventTicketQuantityInput>>;
  attendees: Array<CmpEventAttendeeInput>;
  customFieldAnswers?: Maybe<Array<CmpEventCustomFieldAnswerInput>>;
  unitPriceOverrideInCents?: Maybe<Scalars['Float']>;
  invoiceTaxExempt?: Maybe<Scalars['Boolean']>;
  invoiceTaxExemptionNumber?: Maybe<Scalars['String']>;
  invoiceAccountCode?: Maybe<Scalars['String']>;
  treatAsComplimentary?: Maybe<Scalars['Boolean']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CreateCmpEventSponsorshipRequestInput = {
  expectedEventUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  chamberId: Scalars['String'];
  operationId: Scalars['String'];
  eventId: Scalars['String'];
  sponsorshipPackageId: Scalars['String'];
  selectedMemberCompanyId?: Maybe<Scalars['String']>;
  selectedMemberCompanyNameSnapshot?: Maybe<Scalars['String']>;
  billing?: Maybe<CmpEventPublicBillingInput>;
  invoiceDetails?: Maybe<CmpStaffEventInvoiceDetailsInput>;
  sponsorDisplayName: Scalars['String'];
  sponsorLogoUrl?: Maybe<Scalars['String']>;
  sponsorLogoLink?: Maybe<Scalars['String']>;
  purchaserFirstName: Scalars['String'];
  purchaserLastName: Scalars['String'];
  purchaserEmail: Scalars['String'];
  purchaserPhone?: Maybe<Scalars['String']>;
  includedAttendees?: Maybe<Array<CmpEventAttendeeInput>>;
  customFieldAnswers?: Maybe<Array<CmpEventCustomFieldAnswerInput>>;
  invoiceTaxExempt?: Maybe<Scalars['Boolean']>;
  unitPriceOverrideInCents?: Maybe<Scalars['Float']>;
  treatAsComplimentary?: Maybe<Scalars['Boolean']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CreateCmpEventTypeInput = {
  chamberId: Scalars['String'];
  label: Scalars['String'];
  color: Scalars['String'];
  sortOrder?: Maybe<Scalars['Float']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CreateCmpInvoiceInput = {
  chamberId: Scalars['String'];
  operationId?: Maybe<Scalars['String']>;
  sourceKind: CmpOperationalSourceKindEnum;
  chamberMemberId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventRegistrationId?: Maybe<Scalars['String']>;
  eventSponsorshipRequestId?: Maybe<Scalars['String']>;
  billingSnapshot: CmpInvoiceBillingSnapshotInput;
  billToSnapshot?: Maybe<CmpInvoiceBillingSnapshotInput>;
  lineItems: Array<CmpInvoiceLineItemInput>;
  paymentChoice: CmpPaymentChoiceInput;
  issuedAtUtcMilli?: Maybe<Scalars['Float']>;
  dueAtUtcMilli?: Maybe<Scalars['Float']>;
  referencePurchaseOrder?: Maybe<Scalars['String']>;
  publicMemo?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  replacesInvoiceId?: Maybe<Scalars['String']>;
  createAsDraft?: Maybe<Scalars['Boolean']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CreateCmpMemberRenewalInvoiceInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  operationId: Scalars['String'];
  expectedMemberUpdatedAtUtcMilli: Scalars['Float'];
  expectedCurrentInvoiceId?: Maybe<Scalars['String']>;
  existingDraftInvoiceId?: Maybe<Scalars['String']>;
  expectedInvoiceUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  membership: CmpMemberMembershipChangeFieldsInput;
  disposition: CmpMemberRenewalInvoiceDispositionEnum;
};

export type CreateCmpNewsletterAttachmentUploadInput = {
  chamberId: Scalars['String'];
  purpose: CmpNewsletterAssetUploadPurposeEnum;
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
  sizeBytes: Scalars['Float'];
};

export type CreateCmpNewsletterInput = {
  chamberId: Scalars['String'];
  data: CmpNewsletterDataInput;
  isCmpNewsletterModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CreateCmpNewsletterRecipientGroupInput = {
  chamberId: Scalars['String'];
  data: CmpNewsletterRecipientGroupDataInput;
  isCmpNewsletterModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CreateCmpProspectInput = {
  chamberId: Scalars['String'];
  data: CmpProspectFieldsInput;
  initialNoteComment?: Maybe<Scalars['String']>;
  isCmpProspectModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CreateCmpProspectLeadCaptureInput = {
  chamberId: Scalars['String'];
  label: Scalars['String'];
  isCmpProspectModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type CreateCmpProspectNoteInput = {
  chamberId: Scalars['String'];
  prospectId: Scalars['String'];
  comment: Scalars['String'];
};

export type CreateContactableChamberMutationInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CreateDiscountsMutationInput = {
  data: Array<DiscountInput>;
};

export type CreateDiscountsMutationReturn = {
  __typename?: 'CreateDiscountsMutationReturn';
  discountsAddedSuccessfully: Scalars['Boolean'];
};

export type CreateFavoritedChamberMemberMutationReturn = {
  __typename?: 'CreateFavoritedChamberMemberMutationReturn';
  favoritedChamberMemberAddedSuccessfully: Scalars['Boolean'];
};

export type CreateFavoritedDiscountMutationReturn = {
  __typename?: 'CreateFavoritedDiscountMutationReturn';
  favoritedDiscountAddedSuccessfully: Scalars['Boolean'];
};

export type CreatePerkPartnerDiscountAdminUserMutationReturn = {
  __typename?: 'CreatePerkPartnerDiscountAdminUserMutationReturn';
  perkPartnerDiscountAdminUserCreatedSuccessfully: Scalars['Boolean'];
  email: Scalars['String'];
  password: Scalars['String'];
  failureReason?: Maybe<Scalars['String']>;
};

export type CreatePerkPartnerDiscountMutationReturn = {
  __typename?: 'CreatePerkPartnerDiscountMutationReturn';
  perkPartnerDiscountAddedSuccessfully: Scalars['Boolean'];
};

export type CreateRedeemedDiscountMutationReturn = {
  __typename?: 'CreateRedeemedDiscountMutationReturn';
  redeemedDiscountAddedSuccessfully: Scalars['Boolean'];
};

export type CreateRedeemedDiscountsMutationInput = {
  data: Array<RedeemedDiscountInput>;
};

export type CreateRedeemedDiscountsMutationReturn = {
  __typename?: 'CreateRedeemedDiscountsMutationReturn';
  redeemedDiscountsAddedSuccessfully: Scalars['Boolean'];
};

export type CreateRewardCampaignMutationReturn = {
  __typename?: 'CreateRewardCampaignMutationReturn';
  campaignCreatedSuccessfully: Scalars['Boolean'];
};

export type CreateShopLocalCampaignPrizeDrawParticipantReturn = {
  __typename?: 'CreateShopLocalCampaignPrizeDrawParticipantReturn';
  shopLocalCampaignPrizeDrawParticipantCreatedSuccessfully: Scalars['Boolean'];
  status: ShopLocalCampaignPrizeDrawParticipantCreationStatusEnum;
};

export type CreateShopLocalCampaignReturn = {
  __typename?: 'CreateShopLocalCampaignReturn';
  shopLocalCampaignCreatedSuccessfully: Scalars['Boolean'];
  shopLocalCampaignId?: Maybe<Scalars['String']>;
  notificationDeliveryStatus: ShopLocalCampaignNotificationDeliveryStatusEnum;
  notificationTargetCount: Scalars['Int'];
  notificationSuccessCount: Scalars['Int'];
  notificationFailureCount: Scalars['Int'];
};

export type CreateUserMutationInput = {
  data: Array<UserInput>;
};

export type CreateUserMutationReturn = {
  __typename?: 'CreateUserMutationReturn';
  usersAddedSuccessfully: Scalars['Boolean'];
};

export type CustomContactInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  jobTitle: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberExtension?: Maybe<Scalars['String']>;
  mobilePhoneNumber?: Maybe<Scalars['String']>;
};

export type CustomContactReturn = {
  __typename?: 'CustomContactReturn';
  id: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  jobTitle: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberExtension?: Maybe<Scalars['String']>;
  mobilePhoneNumber?: Maybe<Scalars['String']>;
};

export enum DayEnum {
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY'
}

export type DeactivateAffinityProgramPartnerReturn = {
  __typename?: 'DeactivateAffinityProgramPartnerReturn';
  affinityProgramPartnerDeactivatedSuccessfully: Scalars['Boolean'];
};

export type DeactivateBannerForCategoryAdvertisingBannerReturn = {
  __typename?: 'DeactivateBannerForCategoryAdvertisingBannerReturn';
  deactivationSuccessful: Scalars['Boolean'];
};

export type DeactivateMemberProfileAndPerksBannersForChamberMemberReturn = {
  __typename?: 'DeactivateMemberProfileAndPerksBannersForChamberMemberReturn';
  deactivationSuccessful: Scalars['Boolean'];
};

export type DeclineCmpMemberApplicationInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  declinedAtUtcMilli?: Maybe<Scalars['Float']>;
  declineReason: Scalars['String'];
};

export type DeleteChamberStaffUserMutationReturn = {
  __typename?: 'DeleteChamberStaffUserMutationReturn';
  id: Scalars['String'];
  deleted: Scalars['Boolean'];
};

export type DeleteCmpAdvertisingOptionInput = {
  chamberId: Scalars['String'];
  advertisingOptionId: Scalars['String'];
};

export type DeleteCmpEventDraftInput = {
  chamberId: Scalars['String'];
  draftId: Scalars['String'];
  expectedRevision: Scalars['Float'];
};

export type DeleteFavoritedChamberMemberMutationReturn = {
  __typename?: 'DeleteFavoritedChamberMemberMutationReturn';
  favoritedChamberMemberDeletedSuccessfully: Scalars['Boolean'];
};

export type DeleteFavoritedDiscountMutationReturn = {
  __typename?: 'DeleteFavoritedDiscountMutationReturn';
  favoritedDiscountDeletedSuccessfully: Scalars['Boolean'];
};

export type DeletePerksLinkRequestReturn = {
  __typename?: 'DeletePerksLinkRequestReturn';
  perksLinkDeletedSuccessfully: Scalars['Boolean'];
};

export type DeleteReturn = {
  __typename?: 'DeleteReturn';
  id: Scalars['String'];
  deleted: Scalars['Boolean'];
};

export type DeleteStripeConnectForSandboxChamberReturn = {
  __typename?: 'DeleteStripeConnectForSandboxChamberReturn';
  stripeConnectDeletedSuccessfully: Scalars['Boolean'];
  chamberMemberProSettings: ChamberMemberProSettingsReturn;
};

export type DeleteUserMutationReturn = {
  __typename?: 'DeleteUserMutationReturn';
  id: Scalars['String'];
  deleted: Scalars['Boolean'];
};

export type DeletedAndNonDeletedChamberMemberStatsReturn = {
  __typename?: 'DeletedAndNonDeletedChamberMemberStatsReturn';
  name: Scalars['String'];
  chamberName: Scalars['String'];
  membershipStatus: Scalars['String'];
  category1: Scalars['String'];
  category2: Scalars['String'];
  numberOfAppUsersWithThisMemberSetAsTheirEmployer: Scalars['Float'];
  numberOfDeletedAndNonDeletedDiscounts: Scalars['Float'];
  hasLoggedInToAdminPortal: Scalars['String'];
  hasLogo: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
  createdAtUtcTimestamp: Scalars['String'];
};

export type DeletedAndNonDeletedDiscountStatsReturn = {
  __typename?: 'DeletedAndNonDeletedDiscountStatsReturn';
  title: Scalars['String'];
  chamberName: Scalars['String'];
  chamberMemberName: Scalars['String'];
  offeredTo: Scalars['String'];
  views: Scalars['Float'];
  numberOfRedemptions: Scalars['Float'];
  category1: Scalars['String'];
  category2: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
  createdAtUtcTimestamp: Scalars['String'];
  deletedAtUtcMilli: Scalars['Float'];
  deletedAtUtcTimestamp: Scalars['String'];
};

export type DeletedDiscountReturn = {
  __typename?: 'DeletedDiscountReturn';
  id: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  chamberId: Scalars['String'];
  chamberMemberId: Scalars['String'];
  views: Scalars['Float'];
  chamberInfo: ChamberReturn;
  chamberMemberInfo: ChamberMemberReturn;
  memberOnly: Scalars['Boolean'];
  isAvailableToAllMembers?: Maybe<Scalars['Boolean']>;
  isReoccuring: Scalars['Boolean'];
  daysAvailable?: Maybe<Array<DayEnum>>;
  monthsAvailable?: Maybe<Array<MonthEnum>>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  privateEmails?: Maybe<Array<Scalars['String']>>;
  redeemSettings: RedeemSettingsReturn;
  numberOfRedemptions: Scalars['Float'];
  numberOfFavorites: Scalars['Float'];
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  deletedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type DeletedPerkPartnerDiscountReturn = {
  __typename?: 'DeletedPerkPartnerDiscountReturn';
  id: Scalars['String'];
  companyName: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  verifiedChamberMemberCapUserRedirectLink: Scalars['String'];
  unverifiedChamberMemberCapUserRedirectLink: Scalars['String'];
  logo: Scalars['String'];
  availableToChamberIds?: Maybe<Array<Scalars['String']>>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  deletedAtUtcMilli: Scalars['Float'];
  banner?: Maybe<Array<BannerReturn>>;
};

export type DeletedPerksLinkRequestReturn = {
  __typename?: 'DeletedPerksLinkRequestReturn';
  status: PerksLinkRequestStatusEnum;
  requestorChamberId: Scalars['String'];
  requesteeChamberId: Scalars['String'];
  linkedAtTimeUtcMilli?: Maybe<Scalars['Float']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  deletedAtUtcMilli: Scalars['Float'];
  deletionReason: PerksLinkDeletionReasonEnum;
};

export type DiscountFilterEventInput = {
  chamberId: Scalars['String'];
  chamberMemberId?: Maybe<Scalars['String']>;
  sort: Scalars['String'];
  stringifiedCategories: Scalars['String'];
};

export type DiscountInUserPolygonBoundaryCoordsReturn = {
  __typename?: 'DiscountInUserPolygonBoundaryCoordsReturn';
  id: Scalars['String'];
  chamberMemberLocationCoords: CoordinateReturn;
};

export type DiscountInput = {
  id: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  chamberId: Scalars['String'];
  chamberMemberId: Scalars['String'];
  memberOnly: Scalars['Boolean'];
  isAvailableToAllMembers?: Maybe<Scalars['Boolean']>;
  isReoccuring: Scalars['Boolean'];
  daysAvailable?: Maybe<Array<DayEnum>>;
  monthsAvailable?: Maybe<Array<MonthEnum>>;
  isPrivate: Scalars['Boolean'];
  privateEmails?: Maybe<Array<Scalars['String']>>;
  redeemSettings: RedeemSettingsInput;
  notify?: Maybe<Scalars['Boolean']>;
  startTimeUtcMilli?: Maybe<Scalars['Float']>;
  expiryTimeUtcMilli?: Maybe<Scalars['Float']>;
  banner?: Maybe<Array<BannerInput>>;
};

export enum DiscountNotificationTypes {
  NewDiscount = 'NEW_DISCOUNT',
  NearbyDiscount = 'NEARBY_DISCOUNT',
  NearbyDiscountOpenProfile = 'NEARBY_DISCOUNT_OPEN_PROFILE',
  RewardCampaign = 'REWARD_CAMPAIGN',
  ShopLocalCampaign = 'SHOP_LOCAL_CAMPAIGN'
}

export type DiscountReturn = {
  __typename?: 'DiscountReturn';
  id: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  chamberId: Scalars['String'];
  chamberMemberId: Scalars['String'];
  views: Scalars['Float'];
  chamberInfo: ChamberReturn;
  chamberMemberInfo: ChamberMemberReturn;
  memberOnly: Scalars['Boolean'];
  isAvailableToAllMembers?: Maybe<Scalars['Boolean']>;
  isReoccuring: Scalars['Boolean'];
  daysAvailable?: Maybe<Array<DayEnum>>;
  monthsAvailable?: Maybe<Array<MonthEnum>>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  privateEmails?: Maybe<Array<Scalars['String']>>;
  redeemSettings: RedeemSettingsReturn;
  numberOfRedemptions: Scalars['Float'];
  numberOfFavorites: Scalars['Float'];
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  currentLoggedInCapUserHasRedeemed?: Maybe<Scalars['Boolean']>;
  currentLoggedInCapUserHasFavorited?: Maybe<Scalars['Boolean']>;
  currentLoggedInCapUserIsInPrizeDrawOfActiveShopLocalCampaignUnderDiscountsMember?: Maybe<Scalars['Boolean']>;
  activeShopLocalCampaignInfo?: Maybe<ShopLocalCampaignReturn>;
  chamberMemberLocationCoords?: Maybe<CoordinateReturn>;
  openStreetMapsGeneratedProvince?: Maybe<Scalars['String']>;
  chamberMemberIsSuspended?: Maybe<Scalars['Boolean']>;
  startTimeUtcMilli?: Maybe<Scalars['Float']>;
  expiryTimeUtcMilli?: Maybe<Scalars['Float']>;
  banner?: Maybe<Array<BannerReturn>>;
  showRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  notify?: Maybe<Scalars['Boolean']>;
};

export type DiscountsPerCategoryBreakdownReturn = {
  __typename?: 'DiscountsPerCategoryBreakdownReturn';
  categoryName: Scalars['String'];
  numberOfDiscounts: Scalars['Float'];
  percentageVersusOtherCategories: Scalars['Float'];
};

export type DownloadMilestoneReturn = {
  __typename?: 'DownloadMilestoneReturn';
  year: Scalars['Float'];
  goalValue: Scalars['Float'];
  isFilled: Scalars['Boolean'];
  fillPercentage: Scalars['Float'];
};

export type EmailCmpInvoiceDocumentInput = {
  chamberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  mode: CmpInvoiceDocumentEmailModeEnum;
  paymentId?: Maybe<Scalars['String']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type EmailUserVerificationCodeMutationReturn = {
  __typename?: 'EmailUserVerificationCodeMutationReturn';
  emailUserVerificationCodeSentSuccessfully: Scalars['Boolean'];
};

export type EndRewardCampaignMutationReturn = {
  __typename?: 'EndRewardCampaignMutationReturn';
  campaignEndedSuccessfully: Scalars['Boolean'];
};

export type EndShopLocalCampaignReturn = {
  __typename?: 'EndShopLocalCampaignReturn';
  shopLocalCampaignEndedSuccessfully: Scalars['Boolean'];
};

export enum ErrorCodeEnum {
  DisallowAccessTokenWithUserAuthYoungerThanUtcMilli = 'DISALLOW_ACCESS_TOKEN_WITH_USER_AUTH_YOUNGER_THAN_UTC_MILLI',
  DisallowAccessTokenPermanently = 'DISALLOW_ACCESS_TOKEN_PERMANENTLY',
  DisallowUserTypeAccess = 'DISALLOW_USER_TYPE_ACCESS'
}

export enum EventTypeEnum {
  NavbarButtonTap = 'NAVBAR_BUTTON_TAP',
  PerkPartner = 'PERK_PARTNER',
  AffinityProgramPartner = 'AFFINITY_PROGRAM_PARTNER',
  ChangeChamber = 'CHANGE_CHAMBER',
  DiscountFilter = 'DISCOUNT_FILTER'
}

export type ExcludeAffinityProgramPartnerActivationFromInvoiceReturn = {
  __typename?: 'ExcludeAffinityProgramPartnerActivationFromInvoiceReturn';
  excluded: Scalars['Boolean'];
};

export type ExcludeChamberEngageActivationFromInvoiceReturn = {
  __typename?: 'ExcludeChamberEngageActivationFromInvoiceReturn';
  excluded: Scalars['Boolean'];
};

export type ExportCmpEventAttendeesCsvInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
};

export type ExportCmpEventAttendeesCsvReturn = {
  __typename?: 'ExportCmpEventAttendeesCsvReturn';
  filename: Scalars['String'];
  contentType: Scalars['String'];
  csvContent: Scalars['String'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type ExportCmpEventSponsorsCsvInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
};

export type ExportCmpEventSponsorsCsvReturn = {
  __typename?: 'ExportCmpEventSponsorsCsvReturn';
  filename: Scalars['String'];
  contentType: Scalars['String'];
  csvContent: Scalars['String'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type ExportCmpEventsCsvInput = {
  chamberId: Scalars['String'];
};

export type ExportCmpEventsCsvReturn = {
  __typename?: 'ExportCmpEventsCsvReturn';
  filename: Scalars['String'];
  contentType: Scalars['String'];
  csvContent: Scalars['String'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type ExportCmpInvoicesAccountingCsvInput = {
  report?: Maybe<ExportCmpReportCsvInput>;
  chamberId: Scalars['String'];
  filters?: Maybe<CmpManageInvoiceFiltersInput>;
  profile: CmpInvoiceAccountingExportProfileEnum;
  invoiceIds?: Maybe<Array<Scalars['String']>>;
  invoiceDateFromUtcMilli?: Maybe<Scalars['Float']>;
  invoiceDateToUtcMilli?: Maybe<Scalars['Float']>;
  search?: Maybe<Scalars['String']>;
  invoiceKinds?: Maybe<Array<CmpInvoiceKindEnum>>;
  sourceFilter?: Maybe<CmpInvoiceSourceFilterEnum>;
  displayStates?: Maybe<Array<CmpInvoiceDisplayStateEnum>>;
  overdueBuckets?: Maybe<Array<CmpInvoiceOverdueBucketEnum>>;
  sortColumn?: Maybe<CmpManageInvoicesSortColumnEnum>;
  sortDirection?: Maybe<CmpSortDirectionEnum>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type ExportCmpReportCsvInput = {
  chamberId: Scalars['String'];
  reportType: CmpReportTypeEnum;
  membershipTypeIds?: Maybe<Array<Scalars['String']>>;
  memberSizeRanges?: Maybe<Array<Scalars['String']>>;
  membershipCategories?: Maybe<Array<ChamberMemberCategory>>;
  memberSinceRanges?: Maybe<Array<Scalars['String']>>;
  paymentMethods?: Maybe<Array<Scalars['String']>>;
  paymentTerms?: Maybe<Array<Scalars['String']>>;
  eventIds?: Maybe<Array<Scalars['String']>>;
  sponsorshipPackageIds?: Maybe<Array<Scalars['String']>>;
  ticketTypeIds?: Maybe<Array<Scalars['String']>>;
  advertisingOptionIds?: Maybe<Array<Scalars['String']>>;
  salesAccountNumbers?: Maybe<Array<Scalars['String']>>;
  invoiceKinds?: Maybe<Array<CmpInvoiceKindEnum>>;
  agingPeriods?: Maybe<Array<Scalars['String']>>;
  submittedQuestionsOnly?: Maybe<Scalars['Boolean']>;
  startDateUtcMilli?: Maybe<Scalars['Float']>;
  endDateUtcMilli?: Maybe<Scalars['Float']>;
  compareStartDateUtcMilli?: Maybe<Scalars['Float']>;
  compareEndDateUtcMilli?: Maybe<Scalars['Float']>;
  filterDateUtcMilli?: Maybe<Scalars['Float']>;
  membershipTypeId?: Maybe<Scalars['String']>;
  memberSize?: Maybe<Scalars['Float']>;
  membershipCategory?: Maybe<ChamberMemberCategory>;
  eventCode?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  eventTypeId?: Maybe<Scalars['String']>;
  sponsorshipPackageId?: Maybe<Scalars['String']>;
  ticketTypeId?: Maybe<Scalars['String']>;
  advertisingCode?: Maybe<Scalars['String']>;
  advertisingOptionId?: Maybe<Scalars['String']>;
  salesAccountNumber?: Maybe<Scalars['String']>;
  leadCaptureId?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
};

export type ExportCmpReportCsvReturn = {
  __typename?: 'ExportCmpReportCsvReturn';
  filename: Scalars['String'];
  contentType: Scalars['String'];
  csvContent: Scalars['String'];
  rowCount: Scalars['Float'];
  generatedAtUtcMilli: Scalars['Float'];
  document?: Maybe<CmpReportDocumentReturn>;
};

export type FavoritedChamberMemberReturn = {
  __typename?: 'FavoritedChamberMemberReturn';
  id: Scalars['String'];
  userId: Scalars['String'];
  chamberMemberId: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
};

export type FavoritedDiscountReturn = {
  __typename?: 'FavoritedDiscountReturn';
  id: Scalars['String'];
  userId: Scalars['String'];
  discountId: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
};

export type GenerateCmpInvoicePreviewPdfInput = {
  chamberId: Scalars['String'];
  sourceKind: CmpOperationalSourceKindEnum;
  chamberMemberId?: Maybe<Scalars['String']>;
  eventRegistrationId?: Maybe<Scalars['String']>;
  eventSponsorshipRequestId?: Maybe<Scalars['String']>;
  billingSnapshot: CmpInvoiceBillingSnapshotInput;
  billToSnapshot?: Maybe<CmpInvoiceBillingSnapshotInput>;
  lineItems: Array<CmpInvoiceLineItemInput>;
  paymentChoice: CmpPaymentChoiceInput;
  invoiceNumber: Scalars['String'];
  invoiceStatusOverride?: Maybe<CmpInvoiceStatusEnum>;
  issuedAtUtcMilli?: Maybe<Scalars['Float']>;
  dueAtUtcMilli?: Maybe<Scalars['Float']>;
  referencePurchaseOrder?: Maybe<Scalars['String']>;
  publicMemo?: Maybe<Scalars['String']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type GetAllMemberLoginCredentialsReturn = {
  __typename?: 'GetAllMemberLoginCredentialsReturn';
  status: GetAllMemberLoginCredentialsStatusEnum;
  successCSVRawTextOfAllMemberLoginCredentials?: Maybe<Scalars['String']>;
};

export enum GetAllMemberLoginCredentialsStatusEnum {
  Processing = 'PROCESSING',
  Success = 'SUCCESS',
  Failure = 'FAILURE'
}

export type GetCmpAdvertisingOptionsInput = {
  chamberId: Scalars['String'];
};

export type GetCmpAdvertisingOptionsReturn = {
  __typename?: 'GetCmpAdvertisingOptionsReturn';
  advertisingOptions: Array<CmpAdvertisingOptionReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpAnalyticsEmailsReturn = {
  __typename?: 'GetCmpAnalyticsEmailsReturn';
  metadata: CmpAnalyticsMetadataReturn;
  campaignsSent: CmpAnalyticsMetricReturn;
  emailsDelivered: CmpAnalyticsMetricReturn;
  openRate: CmpAnalyticsMetricReturn;
  clickThroughRate: CmpAnalyticsMetricReturn;
  averageTimeToOpen: CmpAnalyticsMetricReturn;
  bounceRate: CmpAnalyticsMetricReturn;
  subscriberTarget: CmpAnalyticsMetricReturn;
  activeSubscribers: CmpAnalyticsMetricReturn;
  subscribersToTargetPercent: CmpAnalyticsMetricReturn;
  subscriberTargetCalendarYear: Scalars['Float'];
  subscriberTargetWasDefault: Scalars['Boolean'];
  campaignTrend: CmpAnalyticsSectionReturn;
  campaignsByType: CmpAnalyticsSectionReturn;
  engagementByAudience: CmpAnalyticsSectionReturn;
  topEngagedSubscribers: CmpAnalyticsSectionReturn;
  bestPerformingTimes: CmpAnalyticsSectionReturn;
  subscriberGrowth: CmpAnalyticsSectionReturn;
  recentCampaigns: CmpAnalyticsSectionReturn;
};

export type GetCmpAnalyticsEventsReturn = {
  __typename?: 'GetCmpAnalyticsEventsReturn';
  metadata: CmpAnalyticsMetadataReturn;
  filterOptions: CmpAnalyticsEventFilterOptionsReturn;
  totalEvents: CmpAnalyticsMetricReturn;
  completedEvents: CmpAnalyticsMetricReturn;
  remainingEvents: CmpAnalyticsMetricReturn;
  averageTicketRegistrations: CmpAnalyticsMetricReturn;
  eventRevenue: CmpAnalyticsMetricReturn;
  ticketRevenueTrend: CmpAnalyticsSectionReturn;
  ticketRegistrationSummary: CmpAnalyticsSectionReturn;
  sponsorshipRevenueTrend: CmpAnalyticsSectionReturn;
  sponsorshipUnitSummary: CmpAnalyticsSectionReturn;
  registrationMode: CmpAnalyticsSectionReturn;
  eventsByType: CmpAnalyticsSectionReturn;
  topPerformingEvents: CmpAnalyticsSectionReturn;
  upcomingEvents: CmpAnalyticsSectionReturn;
};

export type GetCmpAnalyticsInput = {
  chamberId: Scalars['String'];
  period?: Maybe<CmpAnalyticsDateRangeInput>;
  comparisonPeriod?: Maybe<CmpAnalyticsDateRangeInput>;
  lookback?: Maybe<CmpAnalyticsLookbackEnum>;
  filters?: Maybe<CmpAnalyticsFiltersInput>;
};

export type GetCmpAnalyticsInvoicingReturn = {
  __typename?: 'GetCmpAnalyticsInvoicingReturn';
  metadata: CmpAnalyticsMetadataReturn;
  invoicesIssued: CmpAnalyticsMetricReturn;
  totalInvoiced: CmpAnalyticsMetricReturn;
  totalPaid: CmpAnalyticsMetricReturn;
  outstanding: CmpAnalyticsMetricReturn;
  overdue: CmpAnalyticsMetricReturn;
  totalReceivables: CmpAnalyticsMetricReturn;
  averageInvoice: CmpAnalyticsMetricReturn;
  averageDaysToPayment: CmpAnalyticsMetricReturn;
  invoiceTrend: CmpAnalyticsSectionReturn;
  invoiceStatus: CmpAnalyticsSectionReturn;
  invoiceType: CmpAnalyticsSectionReturn;
  paymentMethod: CmpAnalyticsSectionReturn;
};

export type GetCmpAnalyticsMembersReturn = {
  __typename?: 'GetCmpAnalyticsMembersReturn';
  metadata: CmpAnalyticsMetadataReturn;
  filterOptions: CmpAnalyticsMemberFilterOptionsReturn;
  activeMembers: CmpAnalyticsMetricReturn;
  suspendedMembers: CmpAnalyticsMetricReturn;
  newMembers: CmpAnalyticsMetricReturn;
  cancelledMembers: CmpAnalyticsMetricReturn;
  retentionRate: CmpAnalyticsMetricReturn;
  averageMembershipTenure: CmpAnalyticsMetricReturn;
  membershipRevenue: CmpAnalyticsMetricReturn;
  engagementRate: CmpAnalyticsMetricReturn;
  newMemberTrend: CmpAnalyticsSectionReturn;
  renewals: CmpAnalyticsSectionReturn;
  membershipByType: CmpAnalyticsSectionReturn;
  memberEngagement: CmpAnalyticsSectionReturn;
  memberLongevity: CmpAnalyticsSectionReturn;
};

export type GetCmpAnalyticsOverviewReturn = {
  __typename?: 'GetCmpAnalyticsOverviewReturn';
  metadata: CmpAnalyticsMetadataReturn;
  totalRevenue: CmpAnalyticsMetricReturn;
  activeMembers: CmpAnalyticsMetricReturn;
  newMembers: CmpAnalyticsMetricReturn;
  averageEmailOpenRate: CmpAnalyticsMetricReturn;
  totalWebsiteVisits: CmpAnalyticsMetricReturn;
  prospectConversion: CmpAnalyticsMetricReturn;
  convertedProspects: CmpAnalyticsMetricReturn;
  totalProspects: CmpAnalyticsMetricReturn;
  accountsReceivable: CmpAnalyticsMetricReturn;
  revenuePerformance: CmpAnalyticsSectionReturn;
  revenueByCategory: CmpAnalyticsSectionReturn;
  membershipStatus: CmpAnalyticsSectionReturn;
  companySize: CmpAnalyticsSectionReturn;
  invoiceStatus: CmpAnalyticsSectionReturn;
  newMembersVsRenewals: CmpAnalyticsSectionReturn;
};

export type GetCmpAnalyticsWebsiteReturn = {
  __typename?: 'GetCmpAnalyticsWebsiteReturn';
  metadata: CmpAnalyticsMetadataReturn;
  integration: CmpWebsiteAnalyticsIntegrationReturn;
  sessions: CmpAnalyticsMetricReturn;
  activeUsers: CmpAnalyticsMetricReturn;
  avgSessionDuration: CmpAnalyticsMetricReturn;
  bounceRate: CmpAnalyticsMetricReturn;
  viewsPerSession: CmpAnalyticsMetricReturn;
  pageViews: CmpAnalyticsMetricReturn;
  trafficTrend: CmpAnalyticsSectionReturn;
  trafficSources: CmpAnalyticsSectionReturn;
  deviceBreakdown: CmpAnalyticsSectionReturn;
  topPages: CmpAnalyticsSectionReturn;
  userEngagement: CmpAnalyticsSectionReturn;
};

export type GetCmpCalculatorDataInput = {
  chamberId: Scalars['String'];
  memberId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  memberSizeBucket?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};

export type GetCmpEventAddressOptionsInput = {
  chamberId: Scalars['String'];
  limit?: Maybe<Scalars['Float']>;
};

export type GetCmpEventAddressOptionsReturn = {
  __typename?: 'GetCmpEventAddressOptionsReturn';
  options: Array<CmpEventAddressOptionReturn>;
  manualEntryAllowed: Scalars['Boolean'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpEventAttendeeCheckInsInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
};

export type GetCmpEventDetailInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
};

export type GetCmpEventDetailReturn = {
  __typename?: 'GetCmpEventDetailReturn';
  event?: Maybe<CmpEventReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpEventDraftInput = {
  chamberId: Scalars['String'];
  draftId: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
};

export type GetCmpEventInvoiceDetailInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  invoiceId: Scalars['String'];
  eventRegistrationId?: Maybe<Scalars['String']>;
  eventSponsorshipRequestId?: Maybe<Scalars['String']>;
};

export type GetCmpEventLibraryItemsInput = {
  chamberId: Scalars['String'];
  kind: CmpEventLibraryKindEnum;
  includeArchived?: Maybe<Scalars['Boolean']>;
};

export type GetCmpEventLibraryItemsReturn = {
  __typename?: 'GetCmpEventLibraryItemsReturn';
  items: Array<CmpEventLibraryItemReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpEventPreviewInput = {
  chamberId: Scalars['String'];
  token: Scalars['String'];
  websiteOrigin: Scalars['String'];
};

export type GetCmpEventPreviewReturn = {
  __typename?: 'GetCmpEventPreviewReturn';
  draftJson: Scalars['String'];
  expiresAtUtcMilli: Scalars['Float'];
  dashboardOrigin: Scalars['String'];
};

export type GetCmpEventRegistrationsInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  statuses?: Maybe<Array<CmpEventRegistrationStatusEnum>>;
};

export type GetCmpEventRegistrationsReturn = {
  __typename?: 'GetCmpEventRegistrationsReturn';
  registrations: Array<CmpEventRegistrationReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpEventSponsorshipRequestByOperationInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  operationId: Scalars['String'];
};

export type GetCmpEventSponsorshipRequestsInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  statuses?: Maybe<Array<CmpEventSponsorshipRequestStatusEnum>>;
};

export type GetCmpEventSponsorshipRequestsReturn = {
  __typename?: 'GetCmpEventSponsorshipRequestsReturn';
  sponsorshipRequests: Array<CmpEventSponsorshipRequestReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpEventSponsorshipTaxDefaultInput = {
  chamberId: Scalars['String'];
};

export type GetCmpEventSponsorshipTaxDefaultReturn = {
  __typename?: 'GetCmpEventSponsorshipTaxDefaultReturn';
  sponsorshipTaxMode: CmpEventSponsorshipTaxModeEnum;
  sourceEventId?: Maybe<Scalars['String']>;
};

export type GetCmpEventTypesInput = {
  chamberId: Scalars['String'];
  includeArchived?: Maybe<Scalars['Boolean']>;
};

export type GetCmpEventTypesReturn = {
  __typename?: 'GetCmpEventTypesReturn';
  eventTypes: Array<CmpEventTypeReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpEventWaitlistInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
};

export type GetCmpEventsAnalyticsInput = {
  chamberId: Scalars['String'];
};

export type GetCmpEventsAnalyticsReturn = {
  __typename?: 'GetCmpEventsAnalyticsReturn';
  totalEvents: Scalars['Float'];
  totalRegistrations: Scalars['Float'];
  totalAttendeeSeats: Scalars['Float'];
  totalTicketRevenueInCents: Scalars['Float'];
  totalSponsorsSold: Scalars['Float'];
  totalSponsorshipRevenueInCents: Scalars['Float'];
  totalEventRevenueInCents: Scalars['Float'];
  priorTotalEvents: Scalars['Float'];
  priorTotalRegistrations: Scalars['Float'];
  priorTotalAttendeeSeats: Scalars['Float'];
  priorTotalTicketRevenueInCents: Scalars['Float'];
  priorTotalSponsorsSold: Scalars['Float'];
  priorTotalSponsorshipRevenueInCents: Scalars['Float'];
  priorTotalEventRevenueInCents: Scalars['Float'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpInvoiceCreateLookupsInput = {
  chamberId: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Float']>;
};

export type GetCmpInvoiceCreateLookupsReturn = {
  __typename?: 'GetCmpInvoiceCreateLookupsReturn';
  members: Array<CmpInvoiceLookupOptionReturn>;
  eventRegistrations: Array<CmpInvoiceLookupOptionReturn>;
  eventSponsorships: Array<CmpInvoiceLookupOptionReturn>;
  customLineItemSuggestions: Array<CmpInvoiceLineItemSuggestionReturn>;
  invoiceDefaults: CmpInvoiceCreateDefaultsReturn;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpInvoiceDetailInput = {
  chamberId: Scalars['String'];
  invoiceId: Scalars['String'];
};

export type GetCmpInvoiceDetailReturn = {
  __typename?: 'GetCmpInvoiceDetailReturn';
  invoice: CmpInvoiceReturn;
  displayState: CmpInvoiceDisplayStateEnum;
  overdueBucket: CmpInvoiceOverdueBucketEnum;
  daysPastDue?: Maybe<Scalars['Float']>;
  taxRegistrationNumber?: Maybe<Scalars['String']>;
  billingSnapshot?: Maybe<CmpInvoiceBillingSnapshotReturn>;
  lineItems: Array<CmpInvoiceLineItemReturn>;
  payments: Array<CmpPaymentReturn>;
  refunds: Array<CmpRefundReturn>;
  refundableAmountInCents: Scalars['Float'];
  outboundEmails: Array<CmpOutboundEmailReturn>;
  operationalEvents: Array<CmpOperationalEventReturn>;
  payerDataWarning?: Maybe<Scalars['String']>;
  eventCode?: Maybe<Scalars['String']>;
  taxNote?: Maybe<Scalars['String']>;
  availableActions: Array<CmpInvoiceActionAvailabilityReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpInvoicePresentationDefaultsInput = {
  chamberId: Scalars['String'];
};

export type GetCmpManageEventsInput = {
  chamberId: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<CmpEventStatusEnum>>;
  eventTypeIds?: Maybe<Array<Scalars['String']>>;
  sortColumn?: Maybe<CmpManageEventsSortColumnEnum>;
  sortDirection?: Maybe<CmpSortDirectionEnum>;
};

export type GetCmpManageEventsReturn = {
  __typename?: 'GetCmpManageEventsReturn';
  drafts: Array<CmpEventDraftSummaryReturn>;
  events: Array<CmpManageEventRowReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpManageInvoicesInput = {
  chamberId: Scalars['String'];
  filters?: Maybe<CmpManageInvoiceFiltersInput>;
  search?: Maybe<Scalars['String']>;
  invoiceKinds?: Maybe<Array<CmpInvoiceKindEnum>>;
  sourceFilter?: Maybe<CmpInvoiceSourceFilterEnum>;
  displayStates?: Maybe<Array<CmpInvoiceDisplayStateEnum>>;
  overdueBuckets?: Maybe<Array<CmpInvoiceOverdueBucketEnum>>;
  sortColumn?: Maybe<CmpManageInvoicesSortColumnEnum>;
  sortDirection?: Maybe<CmpSortDirectionEnum>;
  limit?: Maybe<Scalars['Float']>;
  offset?: Maybe<Scalars['Float']>;
};

export type GetCmpManageInvoicesReturn = {
  __typename?: 'GetCmpManageInvoicesReturn';
  billingMethodOptions: Array<Scalars['String']>;
  exportableCount: Scalars['Float'];
  rows: Array<CmpManageInvoiceRowReturn>;
  summary: CmpManageInvoicesSummaryReturn;
  totalCount: Scalars['Float'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpManageMembersInput = {
  chamberId: Scalars['String'];
  includeRenewalEvidence?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  lifecycleStatuses?: Maybe<Array<CmpMemberLifecycleStatusEnum>>;
  renewalDateFromUtcMilli?: Maybe<Scalars['Float']>;
  renewalDateToUtcMilli?: Maybe<Scalars['Float']>;
  billingAddressMissingOnly?: Maybe<Scalars['Boolean']>;
  sortColumn?: Maybe<CmpManageMembersSortColumnEnum>;
  sortDirection?: Maybe<CmpSortDirectionEnum>;
};

export type GetCmpManageMembersReturn = {
  __typename?: 'GetCmpManageMembersReturn';
  rows: Array<CmpManageMemberRowReturn>;
  analytics: CmpManageMembersAnalyticsReturn;
  defaultLifecycleStatuses: Array<CmpMemberLifecycleStatusEnum>;
  totalCount: Scalars['Float'];
};

export type GetCmpManageNewslettersInput = {
  chamberId: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<CmpNewsletterStatusEnum>>;
  emailTypes?: Maybe<Array<CmpNewsletterTypeEnum>>;
  newsroomStatuses?: Maybe<Array<CmpNewsletterNewsroomStatusEnum>>;
};

export type GetCmpManageNewslettersReturn = {
  __typename?: 'GetCmpManageNewslettersReturn';
  unsubscribesFiscalYearToDate: Scalars['Int'];
  fiscalYearStartAtUtcMilli: Scalars['Float'];
  newsletters: Array<CmpManageNewsletterRowReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpManageProspectsReturn = {
  __typename?: 'GetCmpManageProspectsReturn';
  prospects: Array<CmpProspectReturn>;
  analytics: CmpProspectAnalyticsReturn;
  totalCount: Scalars['Float'];
};

export type GetCmpMemberDetailInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  draftData?: Maybe<ChamberMemberInput>;
  renewalPreview?: Maybe<CmpMemberRenewalInvoicePreviewInput>;
};

export type GetCmpMemberDetailReturn = {
  __typename?: 'GetCmpMemberDetailReturn';
  member: ChamberMemberReturn;
  staffNotes: Array<CmpStaffNoteReturn>;
  renewal?: Maybe<CmpMemberRenewalStateReturn>;
  renewalPreview?: Maybe<CmpMemberRenewalInvoicePreviewReturn>;
  dateJoinedUtcMilli?: Maybe<Scalars['Float']>;
  lifecycleStatus: CmpMemberLifecycleStatusEnum;
  isLegacy: Scalars['Boolean'];
  isReadOnly: Scalars['Boolean'];
  actionRequiredReason?: Maybe<Scalars['String']>;
  renewalBlockedReason?: Maybe<Scalars['String']>;
  renewalBillingWarning?: Maybe<Scalars['String']>;
  statusActions: CmpMemberStatusActionsReturn;
  currentInvoice?: Maybe<CmpInvoiceReturn>;
  invoices: Array<CmpInvoiceReturn>;
  paymentHistory: Array<CmpPaymentReturn>;
  feeComparison: CmpMemberFeeComparisonReturn;
  thirdPartyBillingSnapshot?: Maybe<CmpInvoiceBillingSnapshotReturn>;
  paymentRequestCapabilities: Array<CmpMemberApplicationPaymentRequestCapability>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpMemberDirectoryExportInput = {
  chamberId: Scalars['String'];
};

export type GetCmpMemberDirectoryExportReturn = {
  __typename?: 'GetCmpMemberDirectoryExportReturn';
  members: Array<ChamberMemberReturn>;
  filename: Scalars['String'];
  contentType: Scalars['String'];
  csvContent: Scalars['String'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpMemberInvoicesInput = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type GetCmpMemberInvoicesReturn = {
  __typename?: 'GetCmpMemberInvoicesReturn';
  rows: Array<CmpMemberInvoiceRowReturn>;
  totalCount: Scalars['Int'];
  outstanding: Array<CmpMemberInvoiceOutstandingReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpNewsletterDetailInput = {
  chamberId: Scalars['String'];
  newsletterId: Scalars['String'];
};

export type GetCmpNewsletterDetailReturn = {
  __typename?: 'GetCmpNewsletterDetailReturn';
  newsletter?: Maybe<CmpNewsletterReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpNewsletterRecipientGroupsInput = {
  chamberId: Scalars['String'];
  includeArchived?: Maybe<Scalars['Boolean']>;
};

export type GetCmpNewsletterRecipientGroupsReturn = {
  __typename?: 'GetCmpNewsletterRecipientGroupsReturn';
  groups: Array<CmpNewsletterRecipientGroupReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpNewsletterSubscribersInput = {
  chamberId: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  includeUnsubscribed?: Maybe<Scalars['Boolean']>;
};

export type GetCmpNewsletterSubscribersReturn = {
  __typename?: 'GetCmpNewsletterSubscribersReturn';
  subscribers: Array<CmpNewsletterSubscriberListRowReturn>;
  totalCount: Scalars['Int'];
};

export type GetCmpProspectDetailInput = {
  chamberId: Scalars['String'];
  prospectId: Scalars['String'];
};

export type GetCmpPublicActiveMemberCompaniesInput = {
  chamberId: Scalars['String'];
  search?: Maybe<Scalars['String']>;
};

export type GetCmpPublicActiveMemberCompaniesReturn = {
  __typename?: 'GetCmpPublicActiveMemberCompaniesReturn';
  companies: Array<CmpPublicActiveMemberCompanyReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpPublicChamberContactsInput = {
  chamberId: Scalars['String'];
};

export type GetCmpPublicChamberMetricsInput = {
  chamberId: Scalars['String'];
};

export type GetCmpPublicEventDetailInput = {
  guestToken?: Maybe<Scalars['String']>;
  chamberId: Scalars['String'];
  slug: Scalars['String'];
};

export type GetCmpPublicEventDetailReturn = {
  __typename?: 'GetCmpPublicEventDetailReturn';
  event?: Maybe<CmpEventReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpPublicEventPricingPreviewInput = {
  guestToken?: Maybe<Scalars['String']>;
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  kind: CmpPublicEventPricingPreviewKindEnum;
  ticketQuantities?: Maybe<Array<CmpEventTicketQuantityInput>>;
  sponsorshipPackageId?: Maybe<Scalars['String']>;
  additionalTicketQuantities?: Maybe<Array<CmpEventTicketQuantityInput>>;
  paymentChoice: CmpPaymentChoiceInput;
};

export type GetCmpPublicEventPricingPreviewReturn = {
  __typename?: 'GetCmpPublicEventPricingPreviewReturn';
  billingInquiryEmail: Scalars['String'];
  lineItems: Array<CmpEventPricingPreviewLineItemReturn>;
  subtotalInCents: Scalars['Float'];
  taxAmountInCents: Scalars['Float'];
  cardProcessingFeeInCents: Scalars['Float'];
  totalAmountInCents: Scalars['Float'];
  taxRatePercentage: Scalars['Float'];
  taxRateLabel: Scalars['String'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpPublicEventSummariesInput = {
  chamberId: Scalars['String'];
  eventTypeIds?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  startDateFrom?: Maybe<Scalars['String']>;
  startDateTo?: Maybe<Scalars['String']>;
};

export type GetCmpPublicEventSummariesReturn = {
  __typename?: 'GetCmpPublicEventSummariesReturn';
  events: Array<CmpPublicEventSummaryReturn>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalCount: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpPublicEventsInput = {
  chamberId: Scalars['String'];
  eventTypeIds?: Maybe<Array<Scalars['String']>>;
};

export type GetCmpPublicEventsReturn = {
  __typename?: 'GetCmpPublicEventsReturn';
  events: Array<CmpEventReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpPublicNewsroomEntriesInput = {
  chamberId: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Scalars['String']>>;
  page?: Maybe<Scalars['Float']>;
  pageSize?: Maybe<Scalars['Float']>;
};

export type GetCmpPublicNewsroomEntriesReturn = {
  __typename?: 'GetCmpPublicNewsroomEntriesReturn';
  entries: Array<CmpPublicNewsroomEntryReturn>;
  totalCount: Scalars['Float'];
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpPublicNewsroomEntryDetailInput = {
  chamberId: Scalars['String'];
  slug: Scalars['String'];
};

export type GetCmpPublicNewsroomEntryDetailReturn = {
  __typename?: 'GetCmpPublicNewsroomEntryDetailReturn';
  entry?: Maybe<CmpPublicNewsroomEntryReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetCmpReportLookupsInput = {
  chamberId: Scalars['String'];
};

export type GetCmpReportLookupsReturn = {
  __typename?: 'GetCmpReportLookupsReturn';
  membershipTypes: Array<CmpReportFilterOptionReturn>;
  membershipTiers: Array<CmpReportFilterOptionReturn>;
  employeeRangeMembershipTypes: Array<CmpReportFilterOptionReturn>;
  membershipCategories: Array<CmpReportFilterOptionReturn>;
  eventCodes: Array<CmpReportFilterOptionReturn>;
  events: Array<CmpReportFilterOptionReturn>;
  eventTypes: Array<CmpReportFilterOptionReturn>;
  sponsorshipLevels: Array<CmpReportFilterOptionReturn>;
  ticketTypes: Array<CmpReportFilterOptionReturn>;
  advertisingCodes: Array<CmpReportFilterOptionReturn>;
  advertisingOptions: Array<CmpReportFilterOptionReturn>;
  prospectLeadCaptures: Array<CmpReportFilterOptionReturn>;
  prospectCreatedByNames: Array<CmpReportFilterOptionReturn>;
  salesAccounts: Array<CmpReportSalesAccountOptionReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type GetMemberDashboardLoginAvailabilityInput = {
  chamberId: Scalars['String'];
  loginEmail: Scalars['String'];
  memberId?: Maybe<Scalars['String']>;
};

export type GetSampleMemberLoginCredentialsReturn = {
  __typename?: 'GetSampleMemberLoginCredentialsReturn';
  sampleCSVRawTextOfAllMemberLoginCredentials: Scalars['String'];
};

export type HardcodedChamberAddressReturn = {
  __typename?: 'HardcodedChamberAddressReturn';
  city: Scalars['String'];
  province: Scalars['String'];
};

export type HardcodedChamberReturn = {
  __typename?: 'HardcodedChamberReturn';
  id: Scalars['String'];
  name: Scalars['String'];
  address: HardcodedChamberAddressReturn;
  coordinates?: Maybe<CoordinateReturn>;
  fullProvinceName: Scalars['String'];
  googleMapsApi_City_ProvinceShort_CountryShort: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
};

export type HowToRedeemInput = {
  code?: Maybe<Scalars['String']>;
  websiteToEnterCodeAt?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
};

export type HowToRedeemReturn = {
  __typename?: 'HowToRedeemReturn';
  code?: Maybe<Scalars['String']>;
  websiteToEnterCodeAt?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
};

export enum IdaEntityType {
  Company = 'COMPANY',
  Chamber = 'CHAMBER',
  Event = 'EVENT'
}

export type IdaGenerateInput = {
  entityName: Scalars['String'];
  entityType: IdaEntityType;
  mode: IdaGenerateMode;
  keyDetails: Scalars['String'];
  maxLength?: Maybe<Scalars['Int']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export enum IdaGenerateMode {
  CompanyDescription = 'COMPANY_DESCRIPTION',
  PerkTitle = 'PERK_TITLE',
  PerkDescription = 'PERK_DESCRIPTION',
  DirectoryCategories = 'DIRECTORY_CATEGORIES',
  EventDescription = 'EVENT_DESCRIPTION'
}

export type IdaGenerateReturn = {
  __typename?: 'IDAGenerateReturn';
  success: Scalars['Boolean'];
  generatedText: Scalars['String'];
  suggestedCategories?: Maybe<Array<CategoryReturn>>;
};

export enum InAppShareTypes {
  Discount = 'DISCOUNT',
  ChamberMemberProfile = 'CHAMBER_MEMBER_PROFILE'
}

export type IncludeAffinityProgramPartnerActivationInInvoiceReturn = {
  __typename?: 'IncludeAffinityProgramPartnerActivationInInvoiceReturn';
  included: Scalars['Boolean'];
};

export type IncludeChamberEngageActivationInInvoiceReturn = {
  __typename?: 'IncludeChamberEngageActivationInInvoiceReturn';
  included: Scalars['Boolean'];
};

export type IncrementChamberMemberViewCountReturn = {
  __typename?: 'IncrementChamberMemberViewCountReturn';
  incrementSuccessful: Scalars['Boolean'];
};

export type IndividualRewardCampaignChallengeReturn = {
  __typename?: 'IndividualRewardCampaignChallengeReturn';
  id: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  challengeType: RewardCampaignChallengeTypeEnum;
  ballotsNeededToComplete: Scalars['Float'];
  ballotsEarnedForCapUser: Scalars['Float'];
  showRedBubbleNotificationForNewShareForCurrentlyLoggedInCapUser: Scalars['Boolean'];
};

export type IneligiblePerkPartnerDiscountReturn = {
  __typename?: 'IneligiblePerkPartnerDiscountReturn';
  id: Scalars['String'];
  companyName: Scalars['String'];
  title: Scalars['String'];
  logo: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type IssueCmpEventRegistrationCreditInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  registrationId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  amountInCents: Scalars['Float'];
  reason: CmpInvoiceCreditReasonEnum;
  reasonExplanation?: Maybe<Scalars['String']>;
  sourceEffect?: Maybe<CmpInvoiceSourceEffectEnum>;
  refundMethodLabel: Scalars['String'];
  refundReference?: Maybe<Scalars['String']>;
  refundedAtUtcMilli?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type IssueCmpEventSponsorshipCreditInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  sponsorshipRequestId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  amountInCents: Scalars['Float'];
  reason: CmpInvoiceCreditReasonEnum;
  reasonExplanation?: Maybe<Scalars['String']>;
  sourceEffect?: Maybe<CmpInvoiceSourceEffectEnum>;
  refundMethodLabel: Scalars['String'];
  refundReference?: Maybe<Scalars['String']>;
  refundedAtUtcMilli?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type IssueCmpInvoiceCreditInput = {
  chamberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  amountInCents: Scalars['Float'];
  reason: CmpInvoiceCreditReasonEnum;
  reasonExplanation?: Maybe<Scalars['String']>;
  sourceEffect?: Maybe<CmpInvoiceSourceEffectEnum>;
  refundMethodLabel: Scalars['String'];
  refundReference?: Maybe<Scalars['String']>;
  refundedAtUtcMilli?: Maybe<Scalars['Float']>;
  note?: Maybe<Scalars['String']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export enum ItemsPurchasableByChamberEnum {
  ChamberPerksApp = 'CHAMBER_PERKS_APP',
  ChamberMemberPro = 'CHAMBER_MEMBER_PRO',
  ChamberMemberProWebsiteBuilderOnly = 'CHAMBER_MEMBER_PRO_WEBSITE_BUILDER_ONLY'
}

export type JoinCmpEventWaitlistInput = {
  chamberId: Scalars['String'];
  tenantHost: Scalars['String'];
  operationId: Scalars['String'];
  serviceAssertion: Scalars['String'];
  eventId: Scalars['String'];
  ticketTypeId?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  guestToken?: Maybe<Scalars['String']>;
};

export type JoinCmpEventWaitlistReturn = {
  __typename?: 'JoinCmpEventWaitlistReturn';
  joinedSuccessfully: Scalars['Boolean'];
};

export enum LanguageCodeEnum {
  En = 'EN',
  Fr = 'FR'
}

export enum LoginInfoEmailTypes {
  ResetPassword = 'RESET_PASSWORD',
  BrandNew = 'BRAND_NEW',
  ChangeEmailUsername = 'CHANGE_EMAIL_USERNAME'
}

export type ManageMyCmpMemberContactAccountInput = {
  contactId: Scalars['String'];
  action: CmpMemberContactAccountActionEnum;
  expectedMemberUpdatedAtUtcMilli: Scalars['Float'];
};

export type MarkAffinityProgramPartnerActivationInvoicedReturn = {
  __typename?: 'MarkAffinityProgramPartnerActivationInvoicedReturn';
  marked: Scalars['Boolean'];
};

export type MarkChamberEngageActivationInvoicedReturn = {
  __typename?: 'MarkChamberEngageActivationInvoicedReturn';
  marked: Scalars['Boolean'];
};

export type MassSendLoginInfoEmailReturn = {
  __typename?: 'MassSendLoginInfoEmailReturn';
  successCount: Scalars['Float'];
  failureCount: Scalars['Float'];
  totalCount: Scalars['Float'];
};

export type MatchCmpProspectToMemberInput = {
  chamberId: Scalars['String'];
  prospectId: Scalars['String'];
  memberId: Scalars['String'];
};

export type MemberCountForExternalCallerReturn = {
  __typename?: 'MemberCountForExternalCallerReturn';
  memberCount: Scalars['Float'];
  chamberName: Scalars['String'];
};

export type MemberDashboardChamberReturn = {
  __typename?: 'MemberDashboardChamberReturn';
  chamberId: Scalars['String'];
  name: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  isHome: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
};

export enum MemberDashboardLoginAvailabilityCodeEnum {
  Available = 'AVAILABLE',
  LoginEmailInUse = 'LOGIN_EMAIL_IN_USE'
}

export type MemberDashboardLoginAvailabilityReturn = {
  __typename?: 'MemberDashboardLoginAvailabilityReturn';
  code: MemberDashboardLoginAvailabilityCodeEnum;
  checkedLoginEmail: Scalars['String'];
  suggestedLoginEmail?: Maybe<Scalars['String']>;
};

export type MemberEngagementMetricWithStarsReturn = {
  __typename?: 'MemberEngagementMetricWithStarsReturn';
  currentValue: Scalars['Float'];
  currentPercentage: Scalars['Float'];
  targetValue: Scalars['Float'];
  targetPercentage: Scalars['Float'];
  maxValue: Scalars['Float'];
  starBreakdown: StarBreakdownReturn;
};

export type MemberEngagementMetricWithTargetReturn = {
  __typename?: 'MemberEngagementMetricWithTargetReturn';
  currentValue: Scalars['Float'];
  currentPercentage: Scalars['Float'];
  targetValue: Scalars['Float'];
  targetPercentage: Scalars['Float'];
  maxValue: Scalars['Float'];
};

export type MemberOfferingPerksMilestoneReturn = {
  __typename?: 'MemberOfferingPerksMilestoneReturn';
  year: Scalars['Float'];
  goalPercentage: Scalars['Float'];
  isFilled: Scalars['Boolean'];
  fillPercentage: Scalars['Float'];
};

export enum MemberProfileAndPerksBannersUpdateRecordEventEnum {
  Activation = 'ACTIVATION',
  Reactivation = 'REACTIVATION',
  Deactivation = 'DEACTIVATION',
  Expiration = 'EXPIRATION',
  ChamberMemberAgreementAcceptance = 'CHAMBER_MEMBER_AGREEMENT_ACCEPTANCE',
  ActivationFeeUpdateDoneByCpa = 'ACTIVATION_FEE_UPDATE_DONE_BY_CPA'
}

export type MemberProfileAndPerksBannersUpdateRecordReturn = {
  __typename?: 'MemberProfileAndPerksBannersUpdateRecordReturn';
  id: Scalars['String'];
  triggeringUserId: Scalars['String'];
  chamberId: Scalars['String'];
  chamberMemberId: Scalars['String'];
  recordEvent: MemberProfileAndPerksBannersUpdateRecordEventEnum;
  memberProfileAndPerksBannersSettingsAtEventTrigger: ActiveMemberProfileAndPerksBannersSettingsReturn;
  excludeFromInvoice?: Maybe<Scalars['Boolean']>;
  invoiceSentAtUtcMilli?: Maybe<Scalars['Float']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  activationDateUtcMilli: Scalars['Float'];
  expirationDateUtcMilli: Scalars['Float'];
};

export enum MonthEnum {
  January = 'JANUARY',
  February = 'FEBRUARY',
  March = 'MARCH',
  April = 'APRIL',
  May = 'MAY',
  June = 'JUNE',
  July = 'JULY',
  August = 'AUGUST',
  September = 'SEPTEMBER',
  October = 'OCTOBER',
  November = 'NOVEMBER',
  December = 'DECEMBER'
}

export type MonthToChamberAppUserDataChamberDataReturn = {
  __typename?: 'MonthToChamberAppUserDataChamberDataReturn';
  monthAndYear: Scalars['String'];
  chamberId: Scalars['String'];
  chamberName: Scalars['String'];
  chamberProvince: Scalars['String'];
  numberOfAppUsersInMonth: Scalars['Float'];
  percentageOfAppUsersInMonth: Scalars['Float'];
  numberOfAppUsersGrowthVersusPreviousMonth: Scalars['Float'];
  percentageGrowthVersusPreviousMonth: Scalars['Float'];
};

export type MonthlyAppSignupDataReturn = {
  __typename?: 'MonthlyAppSignupDataReturn';
  monthAndYear: Scalars['String'];
  appSignups: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  selectMemberDashboardChamber: SelectMemberDashboardChamberReturn;
  setMyCmpMemberDashboardTestMode: CmpMemberDashboardTestModeReturn;
  getCmpMemberInvoiceDocument: CmpInvoiceDownloadReturn;
  startCmpMemberInvoiceCheckout: CmpMemberInvoiceCheckoutReturn;
  startCmpMemberInvoiceCardForm: CmpMemberInvoiceCardFormReturn;
  saveCmpMemberInvoiceCardFormNote: Scalars['Boolean'];
  sendCmpMemberDashboardHelpRequest: CmpMemberDashboardHelpRequestReturn;
  manageMyCmpMemberContactAccount: CmpMemberContactAccountActionReturn;
  setMyCmpMemberContactPermissions: Scalars['Float'];
  setMyCmpMemberAutoRenewal: CmpMyMemberAutoRenewalReturn;
  startMyCmpMemberCardUpdate: StartCmpMemberCardUpdateReturn;
  completeMyCmpMemberCardUpdate: CmpMyMemberAutoRenewalReturn;
  updateMyCmpMemberEventAttendees: CmpMyMemberEventRegistrationReturn;
  deleteCmpEventDraft: Scalars['Boolean'];
  joinCmpEventWaitlist: JoinCmpEventWaitlistReturn;
  saveCmpEventDraft: CmpEventDraftReturn;
  createCmpEventPreview: CreateCmpEventPreviewReturn;
  confirmCmpPublicEventPreCheckIn: CmpPublicEventPreCheckInReturn;
  updateCmpEventAttendeeCheckIn: CmpEventAttendeeCheckInReturn;
  sendCmpReportEmail: SendCmpReportEmailReturn;
  createChambers: CreateChamberMutationReturn;
  createContactableChamber: ContactableChamberReturn;
  updateChamber: ChamberReturn;
  recordCpaDashboardAccess: Scalars['Boolean'];
  updateChamberMemberProSettingsForChamber: UpdateChamberMemberProSettingsForChamberReturn;
  createCmpProspect: CmpProspectMutationReturn;
  ensureCmpEmailSubscriberTargetForCurrentYear: CmpEmailSubscriberTargetMutationReturn;
  setCmpEmailSubscriberTarget: CmpEmailSubscriberTargetMutationReturn;
  createCmpProspectNote: CmpProspectNoteMutationReturn;
  matchCmpProspectToMember: CmpProspectMutationReturn;
  updateCmpProspect: CmpProspectMutationReturn;
  createCmpProspectLeadCapture: CmpProspectLeadCaptureMutationReturn;
  submitCmpMemberApplication: SubmitCmpMemberApplicationReturn;
  submitCmpPublicMembershipApplication: SubmitCmpMemberApplicationReturn;
  submitCmpPublicMembershipApplicationV2: SubmitCmpPublicMembershipApplicationReturn;
  submitCmpPublicMembershipApplicationV3: SubmitCmpPublicMembershipApplicationReturn;
  updateCmpMember: UpdateCmpMemberReturn;
  manageCmpMemberContactAccount: CmpMemberContactAccountActionReturn;
  issueCmpPrimaryMemberCredentials: CmpPrimaryMemberCredentialsResult;
  saveCmpMassCredentialEmailEdits: CmpMassCredentialEmailEdits;
  addCmpMemberStaffNote: AddCmpMemberStaffNoteReturn;
  changeCmpMemberMembership: ChangeCmpMemberMembershipReturn;
  createCmpMemberRenewalInvoice: ChangeCmpMemberMembershipReturn;
  approveCmpMemberRenewalInvoiceDraft: ChangeCmpMemberMembershipReturn;
  cancelCmpMemberRenewalInvoice: ChangeCmpMemberMembershipReturn;
  updateCmpMemberPendingMembershipChange: ChangeCmpMemberMembershipReturn;
  cancelCmpMemberPendingMembershipChange: ChangeCmpMemberMembershipReturn;
  sendCmpMemberMembershipChangeInvoice: CmpInvoiceActionMutationReturn;
  approveCmpMemberBoard: CmpMemberActionReturn;
  suspendCmpMember: CmpMemberActionReturn;
  activateCmpMember: CmpMemberActionReturn;
  archiveCmpMember: CmpMemberActionReturn;
  declineCmpMemberApplication: CmpMemberActionReturn;
  requestCmpMemberPasswordReset: CmpMemberActionReturn;
  resendCmpMemberPaymentRequest: CmpMemberActionReturn;
  recordCmpMemberManualPayment: CmpMemberActionReturn;
  chargeCmpMemberSavedCard: CmpMemberActionReturn;
  /** Monday D15/D18: start Update Credit Card Information (Stripe card fields confirm a SetupIntent). */
  startCmpMemberCardUpdate: StartCmpMemberCardUpdateReturn;
  /** Monday D15/D18: save the confirmed card as the member's card for auto-renewal. */
  completeCmpMemberCardUpdate: CompleteCmpMemberCardUpdateReturn;
  createCmpInvoice: CmpInvoiceMutationReturn;
  sendCmpInvoicePaymentRequest: CmpInvoiceActionMutationReturn;
  resendCmpInvoicePaymentRequest: CmpInvoiceActionMutationReturn;
  voidCmpInvoice: CmpInvoiceActionMutationReturn;
  approveCmpInvoice: CmpInvoiceActionMutationReturn;
  deleteCmpInvoiceDraft: CmpInvoiceActionMutationReturn;
  resendCmpInvoiceReceipt: CmpInvoiceActionMutationReturn;
  recordCmpInvoiceManualPayment: CmpInvoiceActionMutationReturn;
  startCmpInvoiceCardCheckout: CmpInvoiceCardCheckoutReturn;
  recordCmpInvoiceManualRefund: CmpInvoiceActionMutationReturn;
  updateCmpInvoiceDraft: CmpInvoiceMutationReturn;
  saveCmpEventInvoiceDraft: CmpInvoiceMutationReturn;
  generateCmpInvoicePreviewPdf: CmpInvoiceDownloadReturn;
  issueCmpInvoiceCredit: CmpInvoiceActionMutationReturn;
  emailCmpInvoiceDocument: CmpInvoiceActionMutationReturn;
  refundCmpInvoiceStripePayment: CmpInvoiceActionMutationReturn;
  downloadCmpInvoicePdf: CmpInvoiceActionMutationReturn;
  exportCmpInvoicesAccountingCsv: CmpInvoiceActionMutationReturn;
  startCmpMemberApplicationFromExisting: StartCmpMemberApplicationFromExistingReturn;
  createCmpEventType: CmpEventTypeMutationReturn;
  updateCmpEventType: CmpEventTypeMutationReturn;
  archiveCmpEventType: CmpEventTypeMutationReturn;
  createCmpEventLibraryItem: CmpEventLibraryItemMutationReturn;
  updateCmpEventLibraryItem: CmpEventLibraryItemMutationReturn;
  archiveCmpEventLibraryItem: CmpEventLibraryItemMutationReturn;
  createCmpAdvertisingOption: CmpAdvertisingOptionMutationReturn;
  updateCmpAdvertisingOption: CmpAdvertisingOptionMutationReturn;
  deleteCmpAdvertisingOption: CmpAdvertisingOptionMutationReturn;
  createCmpEvent: CmpEventMutationReturn;
  updateCmpEvent: CmpEventMutationReturn;
  publishCmpEvent: CmpEventMutationReturn;
  unpublishCmpEvent: CmpEventMutationReturn;
  cancelCmpEvent: CmpEventMutationReturn;
  completeCmpEvent: CmpEventMutationReturn;
  duplicateCmpEventAsDraft: CmpEventMutationReturn;
  deleteCmpEvent: CmpEventMutationReturn;
  createCmpEventRegistration: CmpEventRegistrationMutationReturn;
  updateCmpEventRegistration: CmpEventRegistrationMutationReturn;
  cancelCmpEventRegistration: CmpEventRegistrationMutationReturn;
  recordCmpEventRegistrationManualPayment: CmpEventRegistrationMutationReturn;
  startCmpEventRegistrationCardCheckout: CmpInvoiceCardCheckoutReturn;
  issueCmpEventRegistrationCredit: CmpEventRegistrationMutationReturn;
  voidCmpEventRegistrationInvoice: CmpEventRegistrationMutationReturn;
  createCmpEventSponsorshipRequest: CmpEventSponsorshipRequestMutationReturn;
  updateCmpEventSponsorshipRequest: CmpEventSponsorshipRequestMutationReturn;
  cancelCmpEventSponsorshipRequest: CmpEventSponsorshipRequestMutationReturn;
  submitCmpPublicEventRegistration: SubmitCmpPublicEventRegistrationReturn;
  submitCmpPublicEventSponsorshipRequest: SubmitCmpPublicEventSponsorshipRequestReturn;
  approveCmpEventSponsorshipRequest: CmpEventSponsorshipRequestMutationReturn;
  recordCmpEventSponsorshipManualPayment: CmpEventSponsorshipRequestMutationReturn;
  startCmpEventSponsorshipCardCheckout: CmpInvoiceCardCheckoutReturn;
  issueCmpEventSponsorshipCredit: CmpEventSponsorshipRequestMutationReturn;
  voidCmpEventSponsorshipInvoice: CmpEventSponsorshipRequestMutationReturn;
  createCmpNewsletter: CmpNewsletterMutationReturn;
  updateCmpNewsletter: CmpNewsletterMutationReturn;
  archiveCmpNewsletter: CmpNewsletterMutationReturn;
  createCmpNewsletterAttachmentUpload: CmpNewsletterAttachmentUploadReturn;
  sendCmpNewsletterReview: CmpNewsletterSendMutationReturn;
  previewCmpNewsletterTestSend: CmpNewsletterTestSendPreview;
  sendCmpNewsletterTest: CmpNewsletterSendMutationReturn;
  sendCmpNewsletterNow: CmpNewsletterSendMutationReturn;
  scheduleCmpNewsletter: CmpNewsletterMutationReturn;
  cancelCmpNewsletterSchedule: CmpNewsletterMutationReturn;
  trackCmpNewsletterOpen: CmpNewsletterTrackingReturn;
  trackCmpNewsletterClick: CmpNewsletterTrackingReturn;
  submitCmpPublicNewsletterSubscriber: SubmitCmpPublicNewsletterSubscriberReturn;
  publishCmpNewsletterToNewsroom: CmpNewsletterMutationReturn;
  updateCmpNewsletterNewsroom: CmpNewsletterMutationReturn;
  unpublishCmpNewsletterFromNewsroom: CmpNewsletterMutationReturn;
  addCmpNewsletterSubscriber: CmpNewsletterSubscriberMutationReturn;
  removeCmpNewsletterSubscriber: CmpNewsletterSubscriberMutationReturn;
  createCmpNewsletterRecipientGroup: CmpNewsletterRecipientGroupMutationReturn;
  updateCmpNewsletterRecipientGroup: CmpNewsletterRecipientGroupMutationReturn;
  archiveCmpNewsletterRecipientGroup: CmpNewsletterRecipientGroupMutationReturn;
  removeCmpNewsletterCustomAudienceRecipient: CmpNewsletterRecipientGroupMutationReturn;
  startStripeConnectForChamber: StartStripeConnectForChamberReturn;
  completeStripeConnectOAuth: CompleteStripeConnectOAuthReturn;
  refreshStripeConnectStatusForChamber: RefreshStripeConnectStatusForChamberReturn;
  deleteStripeConnectForSandboxChamber: DeleteStripeConnectForSandboxChamberReturn;
  startChamberMemberProSenderDomainVerification: StartChamberMemberProSenderDomainVerificationReturn;
  refreshChamberMemberProSenderDomainStatusForChamber: RefreshChamberMemberProSenderDomainStatusForChamberReturn;
  removeChamberMemberProSenderDomainForChamber: RemoveChamberMemberProSenderDomainForChamberReturn;
  sendChamberMemberProSenderDomainTestEmail: SendChamberMemberProSenderDomainTestEmailReturn;
  deleteChamber: DeleteReturn;
  chamberChangeAdminConsoleLoginEmail: ChangeAdminConsoleLoginEmailReturn;
  createChamberMembers: CreateChamberMembersMutationReturn;
  createChamberContactableCompany: ContactableCompanyReturn;
  deleteChamberMember: DeleteReturn;
  updateChamberMember: ChamberMemberReturn;
  setNewTemporaryChamberMemberPassword: NewTemporaryChamberMemberPasswordReturn;
  sendLoginInfoEmailToChamberMember: SendLoginInfoEmailToChamberMemberReturn;
  massSendLoginInfoEmail: MassSendLoginInfoEmailReturn;
  chamberMemberChangeAdminConsoleLoginEmail: ChangeAdminConsoleLoginEmailReturn;
  setHasSignedUpForChamberMember: SetHasSignedUpForChamberMemberReturn;
  recordCmpMemberDashboardLogin: Scalars['Boolean'];
  createChamberStaffUser: ChamberStaffUserMutationReturn;
  updateChamberStaffUser: ChamberStaffUserMutationReturn;
  resendChamberStaffCredentials: ChamberStaffUserMutationReturn;
  suspendChamberStaffUser: ChamberStaffUserMutationReturn;
  enableChamberStaffUser: ChamberStaffUserMutationReturn;
  deleteChamberStaffUser: DeleteChamberStaffUserMutationReturn;
  recordCmpStaffDashboardLogin: Scalars['Boolean'];
  issueCmpWebsiteBuilderSsoLaunch: CmpWebsiteBuilderSsoLaunchReturn;
  redeemCmpWebsiteBuilderSsoCode: CmpWebsiteBuilderSsoRedeemReturn;
  revalidateCmpWebsiteBuilderSsoSession: CmpWebsiteBuilderSsoSessionValidationReturn;
  revokeCmpWebsiteBuilderSsoSession: CmpWebsiteBuilderSsoRevokeReturn;
  createAllMemberLoginCredentials: CreateAllMemberLoginCredentialsReturn;
  incrementChamberMemberViewCount: IncrementChamberMemberViewCountReturn;
  createUsers: CreateUserMutationReturn;
  updateUser: UpdateUserMutationReturn;
  updateLoggedInUserLanguage: UpdateLoggedInUserLanguageMutationReturn;
  deleteUser: DeleteUserMutationReturn;
  emailUserVerificationCode: EmailUserVerificationCodeMutationReturn;
  verifyUserVerificationCode: VerifyUserVerificationCodeMutationReturn;
  createCapUserShareLeadingToOpenRecord: CreateCapUserShareLeadingToOpenRecordMutationReturn;
  upsertCapUserShareRecord: UpsertCapUserShareRecordMutationReturn;
  createDiscounts: CreateDiscountsMutationReturn;
  createRedeemedDiscounts: CreateRedeemedDiscountsMutationReturn;
  createRedeemedDiscount: CreateRedeemedDiscountMutationReturn;
  createFavoritedDiscount: CreateFavoritedDiscountMutationReturn;
  deleteFavoritedDiscount: DeleteFavoritedDiscountMutationReturn;
  createFavoritedChamberMember: CreateFavoritedChamberMemberMutationReturn;
  deleteFavoritedChamberMember: DeleteFavoritedChamberMemberMutationReturn;
  updateDiscount: UpdateDiscountReturn;
  deleteDiscount: DeleteReturn;
  incrementDiscountViewCount: UpdateDiscountReturn;
  createPerkPartnerDiscount: CreatePerkPartnerDiscountMutationReturn;
  updatePerkPartnerDiscount: UpdatePerkPartnerDiscountReturn;
  deletePerkPartnerDiscount: DeleteReturn;
  createPerkPartnerDiscountAdminUser: CreatePerkPartnerDiscountAdminUserMutationReturn;
  deletePerkPartnerDiscountAdminUser: DeleteReturn;
  createAffinityProgramPartner: CreateAffinityProgramPartnerReturn;
  updateAffinityProgramPartner: UpdateAffinityProgramPartnerReturn;
  deactivateAffinityProgramPartner: DeactivateAffinityProgramPartnerReturn;
  deleteAffinityProgramPartner: DeleteReturn;
  reactivateAffinityProgramPartner: ReactivateAffinityProgramPartnerReturn;
  excludeAffinityProgramPartnerActivationFromInvoice: ExcludeAffinityProgramPartnerActivationFromInvoiceReturn;
  includeAffinityProgramPartnerActivationInInvoice: IncludeAffinityProgramPartnerActivationInInvoiceReturn;
  markAffinityProgramPartnerActivationInvoiced: MarkAffinityProgramPartnerActivationInvoicedReturn;
  requestAffinityProgramPartnerRedirect: RequestAffinityProgramPartnerRedirectReturn;
  submitAffinityProgramPartnerInquiry: SubmitAffinityProgramPartnerInquiryReturn;
  createShopLocalCampaign: CreateShopLocalCampaignReturn;
  updateShopLocalCampaign: UpdateShopLocalCampaignReturn;
  endShopLocalCampaign: EndShopLocalCampaignReturn;
  createShopLocalCampaignPrizeDrawParticipant: CreateShopLocalCampaignPrizeDrawParticipantReturn;
  capUserAgreedToShopLocalCampaign: CapUserAgreedToShopLocalCampaignMutationReturn;
  requestPerksLink: RequestPerksLinkReturn;
  acceptPerksLinkRequest: AcceptPerksLinkRequestReturn;
  deletePerksLinkRequest: DeletePerksLinkRequestReturn;
  updateChamberEngageSettingsForChamber: UpdateChamberEngageSettingsForChamberReturn;
  excludeChamberEngageActivationFromInvoice: ExcludeChamberEngageActivationFromInvoiceReturn;
  includeChamberEngageActivationInInvoice: IncludeChamberEngageActivationInInvoiceReturn;
  markChamberEngageActivationInvoiced: MarkChamberEngageActivationInvoicedReturn;
  updateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivation: UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationReturn;
  upsertRedBubbleNotificationView: UpsertRedBubbleNotificationViewReturn;
  activateBannerForCategoryAdvertisingBanner: ActivateBannerForCategoryAdvertisingBannerReturn;
  reactivateBannerForCategoryAdvertisingBanner: ActivateBannerForCategoryAdvertisingBannerReturn;
  deactivateBannerForCategoryAdvertisingBanner: DeactivateBannerForCategoryAdvertisingBannerReturn;
  updateBannerContentForCategoryAdvertisingBanner: ActivateBannerForCategoryAdvertisingBannerReturn;
  acceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMember: AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberReturn;
  activateMemberProfileAndPerksBannersForChamberMember: ActivateMemberProfileAndPerksBannersForChamberMemberReturn;
  reactivateMemberProfileAndPerksBannersForChamberMember: ActivateMemberProfileAndPerksBannersForChamberMemberReturn;
  deactivateMemberProfileAndPerksBannersForChamberMember: DeactivateMemberProfileAndPerksBannersForChamberMemberReturn;
  acceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMember: AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberReturn;
  createRewardCampaign: CreateRewardCampaignMutationReturn;
  updateRewardCampaign: UpdateRewardCampaignMutationReturn;
  endRewardCampaign: EndRewardCampaignMutationReturn;
  capUserAgreedToRewardCampaign?: Maybe<CapUserAgreedToRewardCampaignMutationReturn>;
  capUserViewedRewardCampaign?: Maybe<CapUserViewedRewardCampaignMutationReturn>;
  changeAutoApprovalForBannerContentOfCategoryAdvertisingBanner: ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerReturn;
  getSupportCenterUrl: Scalars['String'];
  submitCMPBetaFeedback: SubmitBetaFeedbackReturn;
  requestMemberDashboardCredentials: RequestMemberDashboardCredentialsReturn;
  idaGenerate: IdaGenerateReturn;
};


export type MutationSelectMemberDashboardChamberArgs = {
  chamberId: Scalars['String'];
};


export type MutationSetMyCmpMemberDashboardTestModeArgs = {
  input: CmpMemberDashboardTestModeInput;
};


export type MutationGetCmpMemberInvoiceDocumentArgs = {
  input: CmpMemberInvoiceInput;
};


export type MutationStartCmpMemberInvoiceCheckoutArgs = {
  input: StartCmpMemberInvoiceCheckoutInput;
};


export type MutationStartCmpMemberInvoiceCardFormArgs = {
  input: StartCmpMemberInvoiceCheckoutInput;
};


export type MutationSaveCmpMemberInvoiceCardFormNoteArgs = {
  input: SaveCmpMemberInvoiceCardFormNoteInput;
};


export type MutationSendCmpMemberDashboardHelpRequestArgs = {
  input: SendCmpMemberDashboardHelpRequestInput;
};


export type MutationManageMyCmpMemberContactAccountArgs = {
  input: ManageMyCmpMemberContactAccountInput;
};


export type MutationSetMyCmpMemberContactPermissionsArgs = {
  input: SetMyCmpMemberContactPermissionsInput;
};


export type MutationSetMyCmpMemberAutoRenewalArgs = {
  input: SetMyCmpMemberAutoRenewalInput;
};


export type MutationStartMyCmpMemberCardUpdateArgs = {
  input: StartMyCmpMemberCardUpdateInput;
};


export type MutationCompleteMyCmpMemberCardUpdateArgs = {
  input: CompleteMyCmpMemberCardUpdateInput;
};


export type MutationUpdateMyCmpMemberEventAttendeesArgs = {
  input: UpdateMyCmpMemberEventAttendeesInput;
};


export type MutationDeleteCmpEventDraftArgs = {
  input: DeleteCmpEventDraftInput;
};


export type MutationJoinCmpEventWaitlistArgs = {
  input: JoinCmpEventWaitlistInput;
};


export type MutationSaveCmpEventDraftArgs = {
  input: SaveCmpEventDraftInput;
};


export type MutationCreateCmpEventPreviewArgs = {
  input: CreateCmpEventPreviewInput;
};


export type MutationConfirmCmpPublicEventPreCheckInArgs = {
  input: CmpPublicEventPreCheckInInput;
};


export type MutationUpdateCmpEventAttendeeCheckInArgs = {
  input: UpdateCmpEventAttendeeCheckInInput;
};


export type MutationSendCmpReportEmailArgs = {
  input: SendCmpReportEmailInput;
};


export type MutationCreateChambersArgs = {
  input: CreateChamberMutationInput;
};


export type MutationCreateContactableChamberArgs = {
  input: CreateContactableChamberMutationInput;
};


export type MutationUpdateChamberArgs = {
  input: ChamberInput;
  id: Scalars['String'];
};


export type MutationUpdateChamberMemberProSettingsForChamberArgs = {
  chamberId: Scalars['String'];
  chamberMemberProSettings: ChamberMemberProSettingsInput;
  section?: Maybe<ChamberMemberProSettingsSectionEnum>;
  templateId?: Maybe<Scalars['String']>;
};


export type MutationCreateCmpProspectArgs = {
  input: CreateCmpProspectInput;
};


export type MutationEnsureCmpEmailSubscriberTargetForCurrentYearArgs = {
  chamberId: Scalars['String'];
};


export type MutationSetCmpEmailSubscriberTargetArgs = {
  input: SetCmpEmailSubscriberTargetInput;
};


export type MutationCreateCmpProspectNoteArgs = {
  input: CreateCmpProspectNoteInput;
};


export type MutationMatchCmpProspectToMemberArgs = {
  input: MatchCmpProspectToMemberInput;
};


export type MutationUpdateCmpProspectArgs = {
  input: UpdateCmpProspectInput;
};


export type MutationCreateCmpProspectLeadCaptureArgs = {
  input: CreateCmpProspectLeadCaptureInput;
};


export type MutationSubmitCmpMemberApplicationArgs = {
  input: SubmitCmpMemberApplicationInput;
};


export type MutationSubmitCmpPublicMembershipApplicationArgs = {
  input: SubmitCmpPublicMembershipApplicationInput;
};


export type MutationSubmitCmpPublicMembershipApplicationV2Args = {
  input: SubmitCmpPublicMembershipApplicationV2Input;
};


export type MutationSubmitCmpPublicMembershipApplicationV3Args = {
  input: SubmitCmpPublicMembershipApplicationV2Input;
};


export type MutationUpdateCmpMemberArgs = {
  input: UpdateCmpMemberInput;
};


export type MutationManageCmpMemberContactAccountArgs = {
  input: CmpMemberContactAccountInput;
};


export type MutationIssueCmpPrimaryMemberCredentialsArgs = {
  input: CmpPrimaryMemberCredentialsInput;
};


export type MutationSaveCmpMassCredentialEmailEditsArgs = {
  input: CmpMassCredentialEmailEditsInput;
};


export type MutationAddCmpMemberStaffNoteArgs = {
  input: AddCmpMemberStaffNoteInput;
};


export type MutationChangeCmpMemberMembershipArgs = {
  input: ChangeCmpMemberMembershipInput;
};


export type MutationCreateCmpMemberRenewalInvoiceArgs = {
  input: CreateCmpMemberRenewalInvoiceInput;
};


export type MutationApproveCmpMemberRenewalInvoiceDraftArgs = {
  input: ApproveCmpMemberRenewalInvoiceDraftInput;
};


export type MutationCancelCmpMemberRenewalInvoiceArgs = {
  input: CancelCmpMemberRenewalInvoiceInput;
};


export type MutationUpdateCmpMemberPendingMembershipChangeArgs = {
  input: UpdateCmpMemberPendingMembershipChangeInput;
};


export type MutationCancelCmpMemberPendingMembershipChangeArgs = {
  input: CancelCmpMemberPendingMembershipChangeInput;
};


export type MutationSendCmpMemberMembershipChangeInvoiceArgs = {
  input: SendCmpMemberMembershipChangeInvoiceInput;
};


export type MutationApproveCmpMemberBoardArgs = {
  input: CmpMemberActionInput;
};


export type MutationSuspendCmpMemberArgs = {
  input: CmpMemberActionInput;
};


export type MutationActivateCmpMemberArgs = {
  input: CmpMemberActionInput;
};


export type MutationArchiveCmpMemberArgs = {
  input: ArchiveCmpMemberInput;
};


export type MutationDeclineCmpMemberApplicationArgs = {
  input: DeclineCmpMemberApplicationInput;
};


export type MutationRequestCmpMemberPasswordResetArgs = {
  input: CmpMemberActionInput;
};


export type MutationResendCmpMemberPaymentRequestArgs = {
  input: CmpMemberInvoiceActionInput;
};


export type MutationRecordCmpMemberManualPaymentArgs = {
  input: RecordCmpMemberManualPaymentInput;
};


export type MutationChargeCmpMemberSavedCardArgs = {
  input: CmpMemberInvoiceActionInput;
};


export type MutationStartCmpMemberCardUpdateArgs = {
  input: StartCmpMemberCardUpdateInput;
};


export type MutationCompleteCmpMemberCardUpdateArgs = {
  input: CompleteCmpMemberCardUpdateInput;
};


export type MutationCreateCmpInvoiceArgs = {
  input: CreateCmpInvoiceInput;
};


export type MutationSendCmpInvoicePaymentRequestArgs = {
  input: CmpInvoiceActionInput;
};


export type MutationResendCmpInvoicePaymentRequestArgs = {
  input: CmpInvoiceActionInput;
};


export type MutationVoidCmpInvoiceArgs = {
  input: CmpInvoiceActionInput;
};


export type MutationApproveCmpInvoiceArgs = {
  input: ApproveCmpInvoiceInput;
};


export type MutationDeleteCmpInvoiceDraftArgs = {
  input: CmpInvoiceActionInput;
};


export type MutationResendCmpInvoiceReceiptArgs = {
  input: CmpInvoiceActionInput;
};


export type MutationRecordCmpInvoiceManualPaymentArgs = {
  input: RecordCmpInvoiceManualPaymentInput;
};


export type MutationStartCmpInvoiceCardCheckoutArgs = {
  input: StartCmpInvoiceCardCheckoutInput;
};


export type MutationRecordCmpInvoiceManualRefundArgs = {
  input: RecordCmpInvoiceManualRefundInput;
};


export type MutationUpdateCmpInvoiceDraftArgs = {
  input: UpdateCmpInvoiceDraftInput;
};


export type MutationSaveCmpEventInvoiceDraftArgs = {
  input: SaveCmpEventInvoiceDraftInput;
};


export type MutationGenerateCmpInvoicePreviewPdfArgs = {
  input: GenerateCmpInvoicePreviewPdfInput;
};


export type MutationIssueCmpInvoiceCreditArgs = {
  input: IssueCmpInvoiceCreditInput;
};


export type MutationEmailCmpInvoiceDocumentArgs = {
  input: EmailCmpInvoiceDocumentInput;
};


export type MutationRefundCmpInvoiceStripePaymentArgs = {
  input: RefundCmpInvoiceStripePaymentInput;
};


export type MutationDownloadCmpInvoicePdfArgs = {
  input: CmpInvoiceActionInput;
};


export type MutationExportCmpInvoicesAccountingCsvArgs = {
  input: ExportCmpInvoicesAccountingCsvInput;
};


export type MutationStartCmpMemberApplicationFromExistingArgs = {
  input: StartCmpMemberApplicationFromExistingInput;
};


export type MutationCreateCmpEventTypeArgs = {
  input: CreateCmpEventTypeInput;
};


export type MutationUpdateCmpEventTypeArgs = {
  input: UpdateCmpEventTypeInput;
};


export type MutationArchiveCmpEventTypeArgs = {
  input: ArchiveCmpEventTypeInput;
};


export type MutationCreateCmpEventLibraryItemArgs = {
  input: CreateCmpEventLibraryItemInput;
};


export type MutationUpdateCmpEventLibraryItemArgs = {
  input: UpdateCmpEventLibraryItemInput;
};


export type MutationArchiveCmpEventLibraryItemArgs = {
  input: ArchiveCmpEventLibraryItemInput;
};


export type MutationCreateCmpAdvertisingOptionArgs = {
  input: CreateCmpAdvertisingOptionInput;
};


export type MutationUpdateCmpAdvertisingOptionArgs = {
  input: UpdateCmpAdvertisingOptionInput;
};


export type MutationDeleteCmpAdvertisingOptionArgs = {
  input: DeleteCmpAdvertisingOptionInput;
};


export type MutationCreateCmpEventArgs = {
  input: CreateCmpEventInput;
};


export type MutationUpdateCmpEventArgs = {
  input: UpdateCmpEventInput;
};


export type MutationPublishCmpEventArgs = {
  input: CmpEventActionInput;
};


export type MutationUnpublishCmpEventArgs = {
  input: CmpEventActionInput;
};


export type MutationCancelCmpEventArgs = {
  input: CmpEventActionInput;
};


export type MutationCompleteCmpEventArgs = {
  input: CmpEventActionInput;
};


export type MutationDuplicateCmpEventAsDraftArgs = {
  input: CmpEventActionInput;
};


export type MutationDeleteCmpEventArgs = {
  input: CmpEventActionInput;
};


export type MutationCreateCmpEventRegistrationArgs = {
  input: CreateCmpEventRegistrationInput;
};


export type MutationUpdateCmpEventRegistrationArgs = {
  input: UpdateCmpEventRegistrationInput;
};


export type MutationCancelCmpEventRegistrationArgs = {
  input: CmpEventRegistrationActionInput;
};


export type MutationRecordCmpEventRegistrationManualPaymentArgs = {
  input: RecordCmpEventRegistrationManualPaymentInput;
};


export type MutationStartCmpEventRegistrationCardCheckoutArgs = {
  input: StartCmpEventRegistrationCardCheckoutInput;
};


export type MutationIssueCmpEventRegistrationCreditArgs = {
  input: IssueCmpEventRegistrationCreditInput;
};


export type MutationVoidCmpEventRegistrationInvoiceArgs = {
  input: VoidCmpEventRegistrationInvoiceInput;
};


export type MutationCreateCmpEventSponsorshipRequestArgs = {
  input: CreateCmpEventSponsorshipRequestInput;
};


export type MutationUpdateCmpEventSponsorshipRequestArgs = {
  input: UpdateCmpEventSponsorshipRequestInput;
};


export type MutationCancelCmpEventSponsorshipRequestArgs = {
  input: CmpEventSponsorshipRequestActionInput;
};


export type MutationSubmitCmpPublicEventRegistrationArgs = {
  input: SubmitCmpPublicEventRegistrationInput;
};


export type MutationSubmitCmpPublicEventSponsorshipRequestArgs = {
  input: SubmitCmpPublicEventSponsorshipRequestInput;
};


export type MutationApproveCmpEventSponsorshipRequestArgs = {
  input: ApproveCmpEventSponsorshipRequestInput;
};


export type MutationRecordCmpEventSponsorshipManualPaymentArgs = {
  input: RecordCmpEventSponsorshipManualPaymentInput;
};


export type MutationStartCmpEventSponsorshipCardCheckoutArgs = {
  input: StartCmpEventSponsorshipCardCheckoutInput;
};


export type MutationIssueCmpEventSponsorshipCreditArgs = {
  input: IssueCmpEventSponsorshipCreditInput;
};


export type MutationVoidCmpEventSponsorshipInvoiceArgs = {
  input: VoidCmpEventSponsorshipInvoiceInput;
};


export type MutationCreateCmpNewsletterArgs = {
  input: CreateCmpNewsletterInput;
};


export type MutationUpdateCmpNewsletterArgs = {
  input: UpdateCmpNewsletterInput;
};


export type MutationArchiveCmpNewsletterArgs = {
  input: CmpNewsletterActionInput;
};


export type MutationCreateCmpNewsletterAttachmentUploadArgs = {
  input: CreateCmpNewsletterAttachmentUploadInput;
};


export type MutationSendCmpNewsletterReviewArgs = {
  input: CmpNewsletterActionInput;
};


export type MutationPreviewCmpNewsletterTestSendArgs = {
  input: CmpNewsletterTestSendPreviewInput;
};


export type MutationSendCmpNewsletterTestArgs = {
  input: CmpNewsletterTestSendInput;
};


export type MutationSendCmpNewsletterNowArgs = {
  input: CmpNewsletterActionInput;
};


export type MutationScheduleCmpNewsletterArgs = {
  input: CmpNewsletterScheduleInput;
};


export type MutationCancelCmpNewsletterScheduleArgs = {
  input: CmpNewsletterActionInput;
};


export type MutationTrackCmpNewsletterOpenArgs = {
  input: CmpNewsletterTrackingInput;
};


export type MutationTrackCmpNewsletterClickArgs = {
  input: CmpNewsletterTrackingInput;
};


export type MutationSubmitCmpPublicNewsletterSubscriberArgs = {
  input: SubmitCmpPublicNewsletterSubscriberInput;
};


export type MutationPublishCmpNewsletterToNewsroomArgs = {
  input: CmpNewsletterActionInput;
};


export type MutationUpdateCmpNewsletterNewsroomArgs = {
  input: UpdateCmpNewsletterNewsroomInput;
};


export type MutationUnpublishCmpNewsletterFromNewsroomArgs = {
  input: CmpNewsletterActionInput;
};


export type MutationAddCmpNewsletterSubscriberArgs = {
  input: AddCmpNewsletterSubscriberInput;
};


export type MutationRemoveCmpNewsletterSubscriberArgs = {
  input: RemoveCmpNewsletterSubscriberInput;
};


export type MutationCreateCmpNewsletterRecipientGroupArgs = {
  input: CreateCmpNewsletterRecipientGroupInput;
};


export type MutationUpdateCmpNewsletterRecipientGroupArgs = {
  input: UpdateCmpNewsletterRecipientGroupInput;
};


export type MutationArchiveCmpNewsletterRecipientGroupArgs = {
  input: CmpNewsletterRecipientGroupActionInput;
};


export type MutationRemoveCmpNewsletterCustomAudienceRecipientArgs = {
  input: RemoveCmpNewsletterCustomAudienceRecipientInput;
};


export type MutationStartStripeConnectForChamberArgs = {
  chamberId: Scalars['String'];
};


export type MutationCompleteStripeConnectOAuthArgs = {
  code: Scalars['String'];
  state: Scalars['String'];
};


export type MutationRefreshStripeConnectStatusForChamberArgs = {
  chamberId: Scalars['String'];
};


export type MutationDeleteStripeConnectForSandboxChamberArgs = {
  chamberId: Scalars['String'];
};


export type MutationStartChamberMemberProSenderDomainVerificationArgs = {
  chamberId: Scalars['String'];
  domain: Scalars['String'];
  senderEmail: Scalars['String'];
};


export type MutationRefreshChamberMemberProSenderDomainStatusForChamberArgs = {
  chamberId: Scalars['String'];
};


export type MutationRemoveChamberMemberProSenderDomainForChamberArgs = {
  chamberId: Scalars['String'];
};


export type MutationSendChamberMemberProSenderDomainTestEmailArgs = {
  chamberId: Scalars['String'];
  recipientEmail: Scalars['String'];
};


export type MutationDeleteChamberArgs = {
  id: Scalars['String'];
};


export type MutationChamberChangeAdminConsoleLoginEmailArgs = {
  currentAdminConsoleLoginEmail: Scalars['String'];
  newAdminConsoleLoginEmail: Scalars['String'];
  chamberId: Scalars['String'];
};


export type MutationCreateChamberMembersArgs = {
  input: CreateChamberMembersMutationInput;
};


export type MutationCreateChamberContactableCompanyArgs = {
  input: CreateChamberContactableCompanyMutationInput;
};


export type MutationDeleteChamberMemberArgs = {
  id: Scalars['String'];
};


export type MutationUpdateChamberMemberArgs = {
  input: ChamberMemberInput;
  id: Scalars['String'];
};


export type MutationSetNewTemporaryChamberMemberPasswordArgs = {
  adminConsoleLoginEmail: Scalars['String'];
  chamberMemberId: Scalars['String'];
};


export type MutationSendLoginInfoEmailToChamberMemberArgs = {
  adminConsoleLoginEmail: Scalars['String'];
  chamberMemberId: Scalars['String'];
  type: LoginInfoEmailTypes;
};


export type MutationChamberMemberChangeAdminConsoleLoginEmailArgs = {
  currentAdminConsoleLoginEmail: Scalars['String'];
  newAdminConsoleLoginEmail: Scalars['String'];
  chamberMemberId: Scalars['String'];
};


export type MutationCreateChamberStaffUserArgs = {
  input: CreateChamberStaffUserInput;
};


export type MutationUpdateChamberStaffUserArgs = {
  input: UpdateChamberStaffUserInput;
};


export type MutationResendChamberStaffCredentialsArgs = {
  staffUserId: Scalars['String'];
};


export type MutationSuspendChamberStaffUserArgs = {
  staffUserId: Scalars['String'];
};


export type MutationEnableChamberStaffUserArgs = {
  staffUserId: Scalars['String'];
};


export type MutationDeleteChamberStaffUserArgs = {
  staffUserId: Scalars['String'];
};


export type MutationRedeemCmpWebsiteBuilderSsoCodeArgs = {
  input: RedeemCmpWebsiteBuilderSsoCodeInput;
};


export type MutationRevalidateCmpWebsiteBuilderSsoSessionArgs = {
  input: RevalidateCmpWebsiteBuilderSsoSessionInput;
};


export type MutationRevokeCmpWebsiteBuilderSsoSessionArgs = {
  input: RevokeCmpWebsiteBuilderSsoSessionInput;
};


export type MutationIncrementChamberMemberViewCountArgs = {
  id: Scalars['String'];
};


export type MutationCreateUsersArgs = {
  input: CreateUserMutationInput;
};


export type MutationUpdateUserArgs = {
  input: UserInput;
  id: Scalars['String'];
};


export type MutationUpdateLoggedInUserLanguageArgs = {
  languageCode: LanguageCodeEnum;
};


export type MutationDeleteUserArgs = {
  id: Scalars['String'];
};


export type MutationVerifyUserVerificationCodeArgs = {
  code: Scalars['String'];
};


export type MutationCreateCapUserShareLeadingToOpenRecordArgs = {
  input: CapUserShareLeadingToOpenRecordInput;
};


export type MutationUpsertCapUserShareRecordArgs = {
  sharedItemId: Scalars['String'];
  shareType: InAppShareTypes;
};


export type MutationCreateDiscountsArgs = {
  input: CreateDiscountsMutationInput;
};


export type MutationCreateRedeemedDiscountsArgs = {
  input: CreateRedeemedDiscountsMutationInput;
};


export type MutationCreateRedeemedDiscountArgs = {
  discountId: Scalars['String'];
};


export type MutationCreateFavoritedDiscountArgs = {
  discountId: Scalars['String'];
};


export type MutationDeleteFavoritedDiscountArgs = {
  discountId: Scalars['String'];
};


export type MutationCreateFavoritedChamberMemberArgs = {
  chamberMemberId: Scalars['String'];
};


export type MutationDeleteFavoritedChamberMemberArgs = {
  chamberMemberId: Scalars['String'];
};


export type MutationUpdateDiscountArgs = {
  input: DiscountInput;
  id: Scalars['String'];
};


export type MutationDeleteDiscountArgs = {
  id: Scalars['String'];
};


export type MutationIncrementDiscountViewCountArgs = {
  id: Scalars['String'];
};


export type MutationCreatePerkPartnerDiscountArgs = {
  input: PerkPartnerDiscountInput;
};


export type MutationUpdatePerkPartnerDiscountArgs = {
  input: PerkPartnerDiscountInput;
  id: Scalars['String'];
};


export type MutationDeletePerkPartnerDiscountArgs = {
  id: Scalars['String'];
};


export type MutationCreatePerkPartnerDiscountAdminUserArgs = {
  input: PerkPartnerDiscountAdminUserInput;
};


export type MutationDeletePerkPartnerDiscountAdminUserArgs = {
  id: Scalars['String'];
};


export type MutationCreateAffinityProgramPartnerArgs = {
  input: AffinityProgramPartnerInput;
  activationStartDateUtcMilli: Scalars['Float'];
  chamberId?: Maybe<Scalars['String']>;
};


export type MutationUpdateAffinityProgramPartnerArgs = {
  id: Scalars['String'];
  input: AffinityProgramPartnerInput;
  activationStartDateUtcMilli?: Maybe<Scalars['Float']>;
};


export type MutationDeactivateAffinityProgramPartnerArgs = {
  id: Scalars['String'];
};


export type MutationDeleteAffinityProgramPartnerArgs = {
  id: Scalars['String'];
};


export type MutationReactivateAffinityProgramPartnerArgs = {
  id: Scalars['String'];
};


export type MutationExcludeAffinityProgramPartnerActivationFromInvoiceArgs = {
  activationId: Scalars['String'];
};


export type MutationIncludeAffinityProgramPartnerActivationInInvoiceArgs = {
  activationId: Scalars['String'];
};


export type MutationMarkAffinityProgramPartnerActivationInvoicedArgs = {
  activationsToMarkInvoiced: Array<AffinityProgramPartnerActivationToMarkInvoicedInput>;
};


export type MutationRequestAffinityProgramPartnerRedirectArgs = {
  affinityProgramPartnerId: Scalars['String'];
};


export type MutationSubmitAffinityProgramPartnerInquiryArgs = {
  input: SubmitAffinityProgramPartnerInquiryInput;
};


export type MutationCreateShopLocalCampaignArgs = {
  input: ShopLocalCampaignInput;
  sendNotification?: Scalars['Boolean'];
};


export type MutationUpdateShopLocalCampaignArgs = {
  id: Scalars['String'];
  input: ShopLocalCampaignInput;
};


export type MutationEndShopLocalCampaignArgs = {
  id: Scalars['String'];
};


export type MutationCreateShopLocalCampaignPrizeDrawParticipantArgs = {
  shopLocalCampaignId: Scalars['String'];
  participatingForMemberId: Scalars['String'];
  participatingForDiscountId: Scalars['String'];
  participationCode: Scalars['String'];
  redeemDiscount?: Scalars['Boolean'];
};


export type MutationCapUserAgreedToShopLocalCampaignArgs = {
  shopLocalCampaignId: Scalars['String'];
};


export type MutationRequestPerksLinkArgs = {
  requestingLinkToChamberId: Scalars['String'];
};


export type MutationAcceptPerksLinkRequestArgs = {
  requestId: Scalars['String'];
};


export type MutationDeletePerksLinkRequestArgs = {
  requestId: Scalars['String'];
  deletionReason: PerksLinkDeletionReasonEnum;
};


export type MutationUpdateChamberEngageSettingsForChamberArgs = {
  chamberId: Scalars['String'];
  chamberEngageSettings: ChamberEngageSettingsInput;
};


export type MutationExcludeChamberEngageActivationFromInvoiceArgs = {
  activationId: Scalars['String'];
  activationType: ChamberEngageActivationTypeEnum;
};


export type MutationIncludeChamberEngageActivationInInvoiceArgs = {
  activationId: Scalars['String'];
  activationType: ChamberEngageActivationTypeEnum;
};


export type MutationMarkChamberEngageActivationInvoicedArgs = {
  activationsToMarkInvoiced: Array<ChamberEngageActivationToMarkInvoicedInput>;
};


export type MutationUpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationArgs = {
  activationId: Scalars['String'];
  newActivationFeeInDollars: Scalars['Float'];
};


export type MutationUpsertRedBubbleNotificationViewArgs = {
  viewType: RedBubbleNotificationViewTypeEnum;
  viewTypeItemId: Scalars['String'];
};


export type MutationActivateBannerForCategoryAdvertisingBannerArgs = {
  chamberId?: Maybe<Scalars['String']>;
  categoryId: ChamberMemberCategory;
  activationInfo: CategoryAdvertisingBannerActivationInfoInput;
};


export type MutationReactivateBannerForCategoryAdvertisingBannerArgs = {
  chamberId?: Maybe<Scalars['String']>;
  categoryId: ChamberMemberCategory;
  reactivationInfo: CategoryAdvertisingBannerReactivationInfoInput;
};


export type MutationDeactivateBannerForCategoryAdvertisingBannerArgs = {
  chamberId?: Maybe<Scalars['String']>;
  categoryId: ChamberMemberCategory;
  chamberMemberId: Scalars['String'];
};


export type MutationUpdateBannerContentForCategoryAdvertisingBannerArgs = {
  chamberId?: Maybe<Scalars['String']>;
  categoryId: ChamberMemberCategory;
  banner?: Maybe<Array<BannerInput>>;
};


export type MutationAcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberArgs = {
  categoryId: ChamberMemberCategory;
  agreementVersion?: Maybe<Scalars['String']>;
};


export type MutationActivateMemberProfileAndPerksBannersForChamberMemberArgs = {
  chamberId?: Maybe<Scalars['String']>;
  chamberMemberId: Scalars['String'];
  startDateUtcMilli: Scalars['Float'];
};


export type MutationReactivateMemberProfileAndPerksBannersForChamberMemberArgs = {
  chamberId?: Maybe<Scalars['String']>;
  chamberMemberId: Scalars['String'];
};


export type MutationDeactivateMemberProfileAndPerksBannersForChamberMemberArgs = {
  chamberId?: Maybe<Scalars['String']>;
  chamberMemberId: Scalars['String'];
};


export type MutationAcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberArgs = {
  agreementVersion?: Maybe<Scalars['String']>;
};


export type MutationCreateRewardCampaignArgs = {
  input: RewardCampaignInput;
};


export type MutationUpdateRewardCampaignArgs = {
  id: Scalars['String'];
  input: RewardCampaignInput;
};


export type MutationEndRewardCampaignArgs = {
  id: Scalars['String'];
};


export type MutationCapUserAgreedToRewardCampaignArgs = {
  rewardCampaignId: Scalars['String'];
};


export type MutationCapUserViewedRewardCampaignArgs = {
  rewardCampaignId: Scalars['String'];
};


export type MutationChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerArgs = {
  chamberId?: Maybe<Scalars['String']>;
  categoryId: ChamberMemberCategory;
  autoApproveBannerContentUpdate: Scalars['Boolean'];
};


export type MutationGetSupportCenterUrlArgs = {
  nonce: Scalars['String'];
  state: Scalars['String'];
};


export type MutationSubmitCmpBetaFeedbackArgs = {
  feedback: Scalars['String'];
  urlPath: Scalars['String'];
};


export type MutationRequestMemberDashboardCredentialsArgs = {
  chamberId: Scalars['String'];
  chamberMemberId: Scalars['String'];
};


export type MutationIdaGenerateArgs = {
  input: IdaGenerateInput;
};

export type MyCmpMemberEventAttendeeInput = {
  id: Scalars['String'];
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  answers: Array<CmpEventCustomFieldAnswerInput>;
};

export enum NavBarButtonNameEnum {
  Directory = 'DIRECTORY',
  Perks = 'PERKS',
  Events = 'EVENTS',
  JobPosts = 'JOB_POSTS',
  PerkPartners = 'PERK_PARTNERS',
  Newsletter = 'NEWSLETTER',
  Survey = 'SURVEY',
  MyChamber = 'MY_CHAMBER',
  Rewards = 'REWARDS',
  BecomeAMember = 'BECOME_A_MEMBER',
  AdvocacyWins = 'ADVOCACY_WINS',
  CallForNominations = 'CALL_FOR_NOMINATIONS'
}

export type NavBarButtonTapEventInput = {
  buttonName: NavBarButtonNameEnum;
  chamberId: Scalars['String'];
  chamberMemberId?: Maybe<Scalars['String']>;
};

export type NewTemporaryChamberMemberPasswordReturn = {
  __typename?: 'NewTemporaryChamberMemberPasswordReturn';
  password: Scalars['String'];
  failureReason?: Maybe<Scalars['String']>;
  loginAvailability?: Maybe<MemberDashboardLoginAvailabilityReturn>;
  emailHtml?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
};

export type NonDuesRevenueBreakdownReturn = {
  __typename?: 'NonDuesRevenueBreakdownReturn';
  featuredMemberBannersSold: Scalars['Float'];
  featuredMemberBannersTotal: Scalars['Float'];
  featuredMemberRevenuePerBanner: Scalars['Float'];
  featuredMemberCurrentRevenue: Scalars['Float'];
  featuredMemberPotentialRevenue: Scalars['Float'];
  featuredMemberBannerPrice: Scalars['Float'];
  categoryBannersSold: Scalars['Float'];
  categoryBannersTotal: Scalars['Float'];
  categoryBannerRevenuePerBanner: Scalars['Float'];
  categoryBannerCurrentRevenue: Scalars['Float'];
  categoryBannerPotentialRevenue: Scalars['Float'];
  categoryBannerPrice: Scalars['Float'];
  hasTitleSponsor: Scalars['Boolean'];
  titleSponsorshipAmount: Scalars['Float'];
  totalCurrentRevenue: Scalars['Float'];
  totalPotentialRevenue: Scalars['Float'];
};

export type PerkCategoryBreakdownItemReturn = {
  __typename?: 'PerkCategoryBreakdownItemReturn';
  categoryId: ChamberMemberCategory;
  categoryName: Scalars['String'];
  numberOfMembers: Scalars['Float'];
  numberOfPerks: Scalars['Float'];
  actualPercentage: Scalars['Float'];
};

export type PerkEngagementMetricWithTargetReturn = {
  __typename?: 'PerkEngagementMetricWithTargetReturn';
  currentValue: Scalars['Float'];
  currentPercentage: Scalars['Float'];
  targetValue: Scalars['Float'];
  targetPercentage: Scalars['Float'];
  maxValue: Scalars['Float'];
  idealTargetValue: Scalars['Float'];
  idealTargetPercentage: Scalars['Float'];
};

export type PerkListItemReturn = {
  __typename?: 'PerkListItemReturn';
  companyName: Scalars['String'];
  companyLogo?: Maybe<Scalars['String']>;
  perkTitle: Scalars['String'];
  offeredTo: Scalars['String'];
  views?: Maybe<Scalars['Float']>;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type PerkPartnerDiscountAdminUserInput = {
  adminConsoleLoginEmail: Scalars['String'];
  perkPartnerDiscountId: Scalars['String'];
};

export type PerkPartnerDiscountAdminUserReturn = {
  __typename?: 'PerkPartnerDiscountAdminUserReturn';
  id: Scalars['String'];
  email: Scalars['String'];
  perkPartnerDiscountId: Scalars['String'];
  adminConsoleLoginEmail: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type PerkPartnerDiscountInput = {
  id: Scalars['String'];
  companyName: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  verifiedChamberMemberCapUserRedirectLink: Scalars['String'];
  unverifiedChamberMemberCapUserRedirectLink: Scalars['String'];
  logo: Scalars['String'];
  availableToChamberIds?: Maybe<Array<Scalars['String']>>;
  banner?: Maybe<Array<BannerInput>>;
};

export type PerkPartnerDiscountReturn = {
  __typename?: 'PerkPartnerDiscountReturn';
  id: Scalars['String'];
  companyName: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  verifiedChamberMemberCapUserRedirectLink: Scalars['String'];
  unverifiedChamberMemberCapUserRedirectLink: Scalars['String'];
  logo: Scalars['String'];
  availableToChamberIds?: Maybe<Array<Scalars['String']>>;
  availableToChambers?: Maybe<Array<RootAdminPerkPartnerDiscountAvailableToChambersReturn>>;
  showRedBubbleNotificationForLoggedInCapUser?: Maybe<Scalars['Boolean']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
  banner?: Maybe<Array<BannerReturn>>;
};

export type PerkPartnerDiscountStatReturn = {
  __typename?: 'PerkPartnerDiscountStatReturn';
  id: Scalars['String'];
  totalViewCount: Scalars['Float'];
  totalIneligibleViewCount: Scalars['Float'];
  totalUnverifiedViewCount: Scalars['Float'];
  totalVerifiedViewCount: Scalars['Float'];
  totalOpenCount: Scalars['Float'];
  totalIneligibleOpenCount: Scalars['Float'];
  totalUnverifiedOpenCount: Scalars['Float'];
  totalVerifiedOpenCount: Scalars['Float'];
  totalOpensFromViewsConversionRatePercentage: Scalars['Float'];
  totalRedeemCount: Scalars['Float'];
  totalUnverifiedRedeemCount: Scalars['Float'];
  totalVerifiedRedeemCount: Scalars['Float'];
  totalVerifiedNoAccessToEmailRedeemCount: Scalars['Float'];
  totalRedeemCountFromOpensConversionRatePercentage: Scalars['Float'];
  splitByChamber?: Maybe<Array<PerkPartnerDiscountStatSplitByChamberReturn>>;
  timeseriesData?: Maybe<PerkPartnerDiscountTimeseriesDataReturn>;
};

export type PerkPartnerDiscountStatSplitByChamberReturn = {
  __typename?: 'PerkPartnerDiscountStatSplitByChamberReturn';
  chamberId: Scalars['String'];
  chamberName: Scalars['String'];
  chamberIsEnabledForPerkPartnerDiscount: Scalars['Boolean'];
  totalViewCount: Scalars['Float'];
  ineligibleViewCount: Scalars['Float'];
  unverifiedViewCount: Scalars['Float'];
  verifiedViewCount: Scalars['Float'];
  totalOpenCount: Scalars['Float'];
  ineligibleOpenCount: Scalars['Float'];
  unverifiedOpenCount: Scalars['Float'];
  verifiedOpenCount: Scalars['Float'];
  totalRedeemCount: Scalars['Float'];
  unverifiedRedeemCount: Scalars['Float'];
  verifiedRedeemCount: Scalars['Float'];
  verifiedNoAccessToEmailRedeemCount: Scalars['Float'];
};

export type PerkPartnerDiscountTimeseriesDataPoint = {
  __typename?: 'PerkPartnerDiscountTimeseriesDataPoint';
  monthAndYear: Scalars['String'];
  totalOpenCount: Scalars['Float'];
  totalViewCount: Scalars['Float'];
  totalRedeemCount: Scalars['Float'];
};

export type PerkPartnerDiscountTimeseriesDataReturn = {
  __typename?: 'PerkPartnerDiscountTimeseriesDataReturn';
  allChambers: PerkPartnerDiscountTimeseriesDataset;
  chambers: Array<PerkPartnerDiscountTimeseriesDataset>;
};

export type PerkPartnerDiscountTimeseriesDataset = {
  __typename?: 'PerkPartnerDiscountTimeseriesDataset';
  id: Scalars['String'];
  name: Scalars['String'];
  timeseriesData: Array<PerkPartnerDiscountTimeseriesDataPoint>;
};

export type PerkPartnerDiscountUpdateRecordReturn = {
  __typename?: 'PerkPartnerDiscountUpdateRecordReturn';
  id: Scalars['String'];
  perkPartnerDiscountId: Scalars['String'];
  updatingUsersId: Scalars['String'];
  updatingUsersAdminConsoleLoginEmail: Scalars['String'];
  prevVersion: PerkPartnerDiscountReturn;
  newVersion: PerkPartnerDiscountReturn;
  createdAtUtcMilli: Scalars['Float'];
};

export enum PerkPartnerEventActionEnum {
  IneligibleView = 'INELIGIBLE_VIEW',
  UnverifiedView = 'UNVERIFIED_VIEW',
  VerifiedView = 'VERIFIED_VIEW',
  IneligibleOpen = 'INELIGIBLE_OPEN',
  UnverifiedOpen = 'UNVERIFIED_OPEN',
  VerifiedOpen = 'VERIFIED_OPEN',
  UnverifiedRedeem = 'UNVERIFIED_REDEEM',
  VerifiedRedeem = 'VERIFIED_REDEEM',
  VerifiedNoAccessToEmailRedeem = 'VERIFIED_NO_ACCESS_TO_EMAIL_REDEEM'
}

export type PerkPartnerEventInput = {
  perkPartnerId: Scalars['String'];
  chamberId: Scalars['String'];
  chamberMemberId?: Maybe<Scalars['String']>;
  action: PerkPartnerEventActionEnum;
  redeemUserId?: Maybe<Scalars['String']>;
};

export type PerkRedeemableByBreakdownReturn = {
  __typename?: 'PerkRedeemableByBreakdownReturn';
  numOfAllMemberPerks: Scalars['Float'];
  numOfLocalMemberOnlyPerks: Scalars['Float'];
  numOfGeneralPublicPerks: Scalars['Float'];
  numOfCompanyEmployeesOnlyPerks: Scalars['Float'];
  percentOfAllMemberPerks: Scalars['Float'];
  percentOfLocalMemberOnlyPerks: Scalars['Float'];
  percentOfGeneralPublicPerks: Scalars['Float'];
  percentOfCompanyEmployeesOnlyPerks: Scalars['Float'];
};

export type PerkViewKpiReturn = {
  __typename?: 'PerkViewKPIReturn';
  currentValue: Scalars['Float'];
  targetValue: Scalars['Float'];
  maxValue: Scalars['Float'];
};

export type PerksLinkChamberStatsReturn = {
  __typename?: 'PerksLinkChamberStatsReturn';
  chamberId: Scalars['String'];
  chamberName: Scalars['String'];
  perksLinks: Array<PerksLinkDetailReturn>;
};

export enum PerksLinkDeletionReasonEnum {
  Denied = 'DENIED',
  Cancelled = 'CANCELLED',
  Unlinked = 'UNLINKED'
}

export type PerksLinkDetailReturn = {
  __typename?: 'PerksLinkDetailReturn';
  linkedChamberId: Scalars['String'];
  linkedChamberName: Scalars['String'];
  status: PerksLinkRequestStatusEnum;
  requestedAtUtcMilli?: Maybe<Scalars['Float']>;
  acceptedAtUtcMilli?: Maybe<Scalars['Float']>;
  isRequestor: Scalars['Boolean'];
};

export type PerksLinkRequestReturn = {
  __typename?: 'PerksLinkRequestReturn';
  id: Scalars['String'];
  status: PerksLinkRequestStatusEnum;
  requestorChamberId: Scalars['String'];
  requesteeChamberId: Scalars['String'];
  linkedAtTimeUtcMilli?: Maybe<Scalars['Float']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum PerksLinkRequestStatusEnum {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING'
}

export type PerksLinkReturn = {
  __typename?: 'PerksLinkReturn';
  pendingOrAcceptedPerksLinkRequestInfo?: Maybe<PerksLinkRequestReturn>;
  chamberId: Scalars['String'];
  chamberName: Scalars['String'];
  chamberContactEmail: Scalars['String'];
  chamberContactNumber: Scalars['String'];
  chamberContactNumberExtension?: Maybe<Scalars['String']>;
};

export type PrepareCmpReportEmailInput = {
  report: ExportCmpReportCsvInput;
  to: Array<Scalars['String']>;
  cc?: Maybe<Array<Scalars['String']>>;
  bcc?: Maybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  body: Scalars['String'];
};

export type PrepareCmpReportEmailReturn = {
  __typename?: 'PrepareCmpReportEmailReturn';
  confirmationHash: Scalars['String'];
  fromEmail: Scalars['String'];
  replyToEmail?: Maybe<Scalars['String']>;
  to: Array<Scalars['String']>;
  cc: Array<Scalars['String']>;
  bcc: Array<Scalars['String']>;
  intendedTo: Array<Scalars['String']>;
  intendedCc: Array<Scalars['String']>;
  intendedBcc: Array<Scalars['String']>;
  subject: Scalars['String'];
  body: Scalars['String'];
  filename: Scalars['String'];
  csvContent: Scalars['String'];
  rowCount: Scalars['Float'];
  recipientOverrideUsed: Scalars['Boolean'];
  fallbackSenderUsed: Scalars['Boolean'];
};

export type PreviewCmpNewsletterRecipientsInput = {
  chamberId: Scalars['String'];
  newsletterId?: Maybe<Scalars['String']>;
  recipientSelection: CmpNewsletterRecipientSelectionInput;
};

export type PreviewCmpNewsletterRecipientsReturn = {
  __typename?: 'PreviewCmpNewsletterRecipientsReturn';
  totalCandidateCount: Scalars['Float'];
  uniqueValidRecipientCount: Scalars['Float'];
  invalidRecipientCount: Scalars['Float'];
  skippedRecipientCount: Scalars['Float'];
  recipientOverrideUsed: Scalars['Boolean'];
  actualTestRecipientEmail: Scalars['String'];
  recipientRoutingMode: ChamberMemberProEmailRecipientRoutingModeEnum;
  recipients: Array<CmpNewsletterRecipientPreviewRecipientReturn>;
  generatedAtUtcMilli: Scalars['Float'];
};

export type PrizeDrawParticipantReturn = {
  __typename?: 'PrizeDrawParticipantReturn';
  email: Scalars['String'];
  ballotsEarned: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  getMyMemberDashboardChambers: Array<MemberDashboardChamberReturn>;
  getCmpMemberInvoices: GetCmpMemberInvoicesReturn;
  getMyCmpMemberContactAccounts: CmpMyMemberContactAccountsReturn;
  getMyCmpMemberAutoRenewal: CmpMyMemberAutoRenewalReturn;
  getMyCmpMemberEvents: CmpMyMemberEventsReturn;
  getCmpMemberInvoiceDetail: CmpMemberInvoiceRowReturn;
  getCmpEventDraft?: Maybe<CmpEventDraftReturn>;
  getCmpEventPreview: GetCmpEventPreviewReturn;
  getCmpEventWaitlist: Array<CmpEventWaitlistEntryReturn>;
  getAllChambers?: Maybe<Array<ChamberReturn>>;
  getChamber: ChamberReturn;
  getCmpMemberDashboardChamberBySlug?: Maybe<CmpMemberDashboardChamberReturn>;
  getChamberMemberProSettings: ChamberMemberProSettingsReturn;
  getCmpAnalyticsOverview: GetCmpAnalyticsOverviewReturn;
  getCmpAnalyticsMembers: GetCmpAnalyticsMembersReturn;
  getCmpAnalyticsEvents: GetCmpAnalyticsEventsReturn;
  getCmpAnalyticsEmails: GetCmpAnalyticsEmailsReturn;
  getCmpAnalyticsWebsite: GetCmpAnalyticsWebsiteReturn;
  getCmpAnalyticsInvoicing: GetCmpAnalyticsInvoicingReturn;
  getCmpPublicWebsiteAnalyticsConfig: CmpPublicWebsiteAnalyticsConfigReturn;
  getCmpPublicChamberMetrics: CmpPublicChamberMetricsReturn;
  getCmpPublicChamberContacts: CmpPublicChamberContactsReturn;
  getCmpMembershipApplicationSettings: CmpMembershipApplicationSettingsReturn;
  getCmpPublicMembershipApplicationSettings: CmpPublicMembershipApplicationSettingsReturn;
  verifyCmpPublicMembershipCheckoutV2: CmpPublicMembershipCheckoutVerificationReturn;
  getCmpManageMembers: GetCmpManageMembersReturn;
  getCmpProspectLeadCaptures: Array<CmpProspectLeadCaptureReturn>;
  getCmpProspectDetail: CmpProspectReturn;
  getCmpProspectNotes: Array<CmpProspectNoteReturn>;
  getCmpProspectStaffOptions: Array<CmpProspectStaffOptionReturn>;
  getCmpProspectMemberMatchOptions: Array<CmpProspectMemberMatchOptionReturn>;
  getCmpManageProspects: GetCmpManageProspectsReturn;
  exportCmpProspectsCsv: CmpProspectExportReturn;
  getCmpMemberContactAccounts: Array<CmpMemberContactAccountReturn>;
  getCmpPrimaryMemberCredentialsPlan: CmpPrimaryMemberCredentialsPlan;
  getCmpMassCredentialEmailEdits: CmpMassCredentialEmailEdits;
  getCmpPrimaryMemberCredentialsLastSent: CmpPrimaryMemberCredentialsLastSentReturn;
  getCmpCalculatorData: CmpCalculatorDataReturn;
  getCmpMemberActivity: CmpMemberActivityReturn;
  getCmpMemberDetail: GetCmpMemberDetailReturn;
  getMemberDashboardLoginAvailability: MemberDashboardLoginAvailabilityReturn;
  getCmpMemberDirectoryExport: GetCmpMemberDirectoryExportReturn;
  getCmpReportLookups: GetCmpReportLookupsReturn;
  exportCmpReportCsv: ExportCmpReportCsvReturn;
  getCmpPublicEventPreCheckIn: CmpPublicEventPreCheckInReturn;
  getCmpEventAttendeeCheckIns: Array<CmpEventAttendeeCheckInReturn>;
  getCmpEmailCaptureAddressStatus: CmpEmailCaptureAddressStatus;
  getCmpEmailCaptureAddress?: Maybe<Scalars['String']>;
  prepareCmpReportEmail: PrepareCmpReportEmailReturn;
  getCmpManageInvoices: GetCmpManageInvoicesReturn;
  getCmpInvoiceDetail: GetCmpInvoiceDetailReturn;
  getCmpInvoicePresentationDefaults: CmpInvoicePresentationDefaultsReturn;
  getCmpInvoiceCreateLookups: GetCmpInvoiceCreateLookupsReturn;
  getCmpEventTypes: GetCmpEventTypesReturn;
  getCmpEventSponsorshipTaxDefault: GetCmpEventSponsorshipTaxDefaultReturn;
  getCmpEventLibraryItems: GetCmpEventLibraryItemsReturn;
  getCmpAdvertisingOptions: GetCmpAdvertisingOptionsReturn;
  getCmpManageEvents: GetCmpManageEventsReturn;
  getCmpEventInvoiceDetail: GetCmpInvoiceDetailReturn;
  cmpStaffRecordablePaymentMethods: Array<CmpStaffRecordablePaymentMethod>;
  getCmpEventAddressOptions: GetCmpEventAddressOptionsReturn;
  getCmpEventsAnalytics: GetCmpEventsAnalyticsReturn;
  getCmpEventDetail: GetCmpEventDetailReturn;
  getCmpEventRegistrations: GetCmpEventRegistrationsReturn;
  getCmpEventSponsorshipRequests: GetCmpEventSponsorshipRequestsReturn;
  getCmpEventSponsorshipRequestByOperation?: Maybe<CmpEventSponsorshipRequestReturn>;
  exportCmpEventAttendeesCsv: ExportCmpEventAttendeesCsvReturn;
  exportCmpEventSponsorsCsv: ExportCmpEventSponsorsCsvReturn;
  exportCmpEventsCsv: ExportCmpEventsCsvReturn;
  getCmpPublicEventSummaries: GetCmpPublicEventSummariesReturn;
  getCmpPublicEvents: GetCmpPublicEventsReturn;
  getCmpPublicEventDetail: GetCmpPublicEventDetailReturn;
  verifyCmpPublicEventRegistrationCheckout: VerifyCmpPublicEventRegistrationCheckoutReturn;
  getCmpPublicEventPaymentSettings: CmpPublicEventPaymentSettingsReturn;
  getCmpStaffEventSponsorshipPricingPreview: GetCmpPublicEventPricingPreviewReturn;
  getCmpPublicEventPricingPreview: GetCmpPublicEventPricingPreviewReturn;
  getCmpPublicActiveMemberCompanies: GetCmpPublicActiveMemberCompaniesReturn;
  getCmpManageNewsletters: GetCmpManageNewslettersReturn;
  getCmpNewsletterDetail: GetCmpNewsletterDetailReturn;
  getCmpNewsletterSubscribers: GetCmpNewsletterSubscribersReturn;
  getCmpNewsletterRecipientGroups: GetCmpNewsletterRecipientGroupsReturn;
  previewCmpNewsletterRecipients: PreviewCmpNewsletterRecipientsReturn;
  getCmpPublicNewsroomEntries: GetCmpPublicNewsroomEntriesReturn;
  getCmpPublicNewsroomEntryDetail: GetCmpPublicNewsroomEntryDetailReturn;
  getAllContactableCompaniesForChamber?: Maybe<Array<ContactableCompanyReturn>>;
  getAllChamberMembers?: Maybe<Array<ChamberMemberReturn>>;
  getChamberMember: ChamberMemberReturn;
  getSampleLoginInfoEmail: SampleLoginInfoEmailReturn;
  getAllCategories?: Maybe<Array<CategoryReturn>>;
  getDiscount: DiscountReturn;
  getAllDiscountsFromChamberMemberId?: Maybe<Array<DiscountReturn>>;
  getAllDiscountsFromChamberId?: Maybe<Array<DiscountReturn>>;
  getAllDeletedDiscountsFromChamberId?: Maybe<Array<DeletedDiscountReturn>>;
  getAllDiscountsInUserPolygonBoundaryCoords?: Maybe<Array<DiscountInUserPolygonBoundaryCoordsReturn>>;
  getUserIsEligibleBoolAndSendNotificationForEachEligibleNearbyDiscount?: Maybe<Array<UserIsEligibleBoolAndSendNotificationForEachEligibleNearbyDiscountReturn>>;
  getSystemWidePerkStats: SystemWidePerkStatsReturn;
  getChamberAdminStats: ChamberAdminStatsReturn;
  getAllMemberLoginCredentials: GetAllMemberLoginCredentialsReturn;
  getSampleMemberLoginCredentials: GetSampleMemberLoginCredentialsReturn;
  getAllPerkPartnerDiscounts?: Maybe<Array<PerkPartnerDiscountReturn>>;
  getPerkPartnerDiscount: PerkPartnerDiscountReturn;
  getAllDeletedPerkPartnerDiscounts?: Maybe<Array<DeletedPerkPartnerDiscountReturn>>;
  getAllPerkPartnerDiscountsForCapUser?: Maybe<CapUserPerkPartnerDiscountReturn>;
  getAllAdminUsersForPerkPartnerDiscount?: Maybe<Array<PerkPartnerDiscountAdminUserReturn>>;
  getPerkPartnerDiscountAdminUser: PerkPartnerDiscountAdminUserReturn;
  getPerkPartnerDiscountStats: PerkPartnerDiscountStatReturn;
  getAffinityProgramPartner: AffinityProgramPartnerReturn;
  getAllAffinityProgramPartnersForChamber?: Maybe<Array<AffinityProgramPartnerReturn>>;
  getActiveAffinityProgramPartnersForCapUser: CapUserAffinityProgramPartnersReturn;
  getAffinityProgramPartnerStats: AffinityProgramPartnerStatReturn;
  getAllAffinityProgramPartnerInvoiceData?: Maybe<Array<AffinityProgramPartnerMonthlyInvoiceDataReturn>>;
  getChamberStaffUsers: Array<ChamberStaffUserReturn>;
  getCmpUserActivityLog: Array<CmpUserActivityReturn>;
  exportCmpUserActivityLogCsv: CmpUserActivityCsvReturn;
  getUser: UserReturn;
  getUnverifiedCpaUserInfo: UnverifiedCpaUserInfoReturn;
  getAdminConsoleLoginEmailForChamber: AdminConsoleLoginEmailReturn;
  getAdminConsoleLoginEmailForChamberMember: AdminConsoleLoginEmailReturn;
  getCPASignUpChambersForCity: CpaSignUpChambersForCityReturn;
  getShopLocalCampaign?: Maybe<ShopLocalCampaignReturn>;
  getAllShopLocalCampaignsForChamber?: Maybe<Array<ShopLocalCampaignReturn>>;
  getShopLocalParticipatingMemberEligibility: Array<ShopLocalParticipatingMemberEligibilityReturn>;
  getActiveShopLocalCampaignForChamber?: Maybe<ShopLocalCampaignReturn>;
  getAllPerksLinksForChamber: Array<PerksLinkReturn>;
  getAllCategoryAdvertisingBannersForChamber: AllCategoryAdvertisingBannersForChamberReturn;
  getActiveCategoryAdvertisingBannersForChamberMember?: Maybe<Array<CategoryAdvertisingBannerReturn>>;
  getActiveCategoryAdvertisingBannersForCapUser?: Maybe<Array<CategoryAdvertisingBannerReturn>>;
  getActiveCategoryAdvertisingBannersForWebsite?: Maybe<Array<WebsiteCategoryAdvertisingBannerReturn>>;
  getRewardCampaign?: Maybe<RewardCampaignReturn>;
  getAllRewardCampaignsForChamber?: Maybe<Array<RewardCampaignReturn>>;
  getActiveRewardCampaignForCapUser?: Maybe<RewardCampaignReturn>;
  getAllChamberEngageInvoiceData?: Maybe<Array<ChamberEngageMonthlyInvoiceDataReturn>>;
  getRootAdminStats: RootAdminStatsReturn;
  getChamberIdsWithChamberMemberPro: Array<Scalars['String']>;
  getHardcodedChambers?: Maybe<Array<Maybe<HardcodedChamberReturn>>>;
  getMemberCountForExternalCaller?: Maybe<MemberCountForExternalCallerReturn>;
};


export type QueryGetCmpMemberInvoicesArgs = {
  input?: Maybe<GetCmpMemberInvoicesInput>;
};


export type QueryGetCmpMemberInvoiceDetailArgs = {
  input: CmpMemberInvoiceInput;
};


export type QueryGetCmpEventDraftArgs = {
  input: GetCmpEventDraftInput;
};


export type QueryGetCmpEventPreviewArgs = {
  input: GetCmpEventPreviewInput;
};


export type QueryGetCmpEventWaitlistArgs = {
  input: GetCmpEventWaitlistInput;
};


export type QueryGetAllChambersArgs = {
  getAllSandbox?: Maybe<Scalars['Boolean']>;
};


export type QueryGetChamberArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetCmpMemberDashboardChamberBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryGetChamberMemberProSettingsArgs = {
  chamberId: Scalars['String'];
  section?: Maybe<ChamberMemberProSettingsSectionEnum>;
};


export type QueryGetCmpAnalyticsOverviewArgs = {
  input: GetCmpAnalyticsInput;
};


export type QueryGetCmpAnalyticsMembersArgs = {
  input: GetCmpAnalyticsInput;
};


export type QueryGetCmpAnalyticsEventsArgs = {
  input: GetCmpAnalyticsInput;
};


export type QueryGetCmpAnalyticsEmailsArgs = {
  input: GetCmpAnalyticsInput;
};


export type QueryGetCmpAnalyticsWebsiteArgs = {
  input: GetCmpAnalyticsInput;
};


export type QueryGetCmpAnalyticsInvoicingArgs = {
  input: GetCmpAnalyticsInput;
};


export type QueryGetCmpPublicWebsiteAnalyticsConfigArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetCmpPublicChamberMetricsArgs = {
  input: GetCmpPublicChamberMetricsInput;
};


export type QueryGetCmpPublicChamberContactsArgs = {
  input: GetCmpPublicChamberContactsInput;
};


export type QueryGetCmpMembershipApplicationSettingsArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetCmpPublicMembershipApplicationSettingsArgs = {
  chamberId: Scalars['String'];
};


export type QueryVerifyCmpPublicMembershipCheckoutV2Args = {
  input: VerifyCmpPublicMembershipCheckoutV2Input;
};


export type QueryGetCmpManageMembersArgs = {
  input: GetCmpManageMembersInput;
};


export type QueryGetCmpProspectLeadCapturesArgs = {
  input: CmpProspectChamberInput;
};


export type QueryGetCmpProspectDetailArgs = {
  input: GetCmpProspectDetailInput;
};


export type QueryGetCmpProspectNotesArgs = {
  input: GetCmpProspectDetailInput;
};


export type QueryGetCmpProspectStaffOptionsArgs = {
  input: CmpProspectChamberInput;
};


export type QueryGetCmpProspectMemberMatchOptionsArgs = {
  input: CmpProspectChamberInput;
};


export type QueryGetCmpManageProspectsArgs = {
  input: CmpProspectChamberInput;
};


export type QueryExportCmpProspectsCsvArgs = {
  input: CmpProspectChamberInput;
};


export type QueryGetCmpMemberContactAccountsArgs = {
  input: GetCmpMemberDetailInput;
};


export type QueryGetCmpPrimaryMemberCredentialsPlanArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetCmpMassCredentialEmailEditsArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetCmpPrimaryMemberCredentialsLastSentArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetCmpCalculatorDataArgs = {
  input: GetCmpCalculatorDataInput;
};


export type QueryGetCmpMemberActivityArgs = {
  input: GetCmpMemberDetailInput;
};


export type QueryGetCmpMemberDetailArgs = {
  input: GetCmpMemberDetailInput;
};


export type QueryGetMemberDashboardLoginAvailabilityArgs = {
  input: GetMemberDashboardLoginAvailabilityInput;
};


export type QueryGetCmpMemberDirectoryExportArgs = {
  input: GetCmpMemberDirectoryExportInput;
};


export type QueryGetCmpReportLookupsArgs = {
  input: GetCmpReportLookupsInput;
};


export type QueryExportCmpReportCsvArgs = {
  input: ExportCmpReportCsvInput;
};


export type QueryGetCmpPublicEventPreCheckInArgs = {
  input: CmpPublicEventPreCheckInInput;
};


export type QueryGetCmpEventAttendeeCheckInsArgs = {
  input: GetCmpEventAttendeeCheckInsInput;
};


export type QueryGetCmpEmailCaptureAddressStatusArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetCmpEmailCaptureAddressArgs = {
  chamberId: Scalars['String'];
};


export type QueryPrepareCmpReportEmailArgs = {
  input: PrepareCmpReportEmailInput;
};


export type QueryGetCmpManageInvoicesArgs = {
  input: GetCmpManageInvoicesInput;
};


export type QueryGetCmpInvoiceDetailArgs = {
  input: GetCmpInvoiceDetailInput;
};


export type QueryGetCmpInvoicePresentationDefaultsArgs = {
  input: GetCmpInvoicePresentationDefaultsInput;
};


export type QueryGetCmpInvoiceCreateLookupsArgs = {
  input: GetCmpInvoiceCreateLookupsInput;
};


export type QueryGetCmpEventTypesArgs = {
  input: GetCmpEventTypesInput;
};


export type QueryGetCmpEventSponsorshipTaxDefaultArgs = {
  input: GetCmpEventSponsorshipTaxDefaultInput;
};


export type QueryGetCmpEventLibraryItemsArgs = {
  input: GetCmpEventLibraryItemsInput;
};


export type QueryGetCmpAdvertisingOptionsArgs = {
  input: GetCmpAdvertisingOptionsInput;
};


export type QueryGetCmpManageEventsArgs = {
  input: GetCmpManageEventsInput;
};


export type QueryGetCmpEventInvoiceDetailArgs = {
  input: GetCmpEventInvoiceDetailInput;
};


export type QueryCmpStaffRecordablePaymentMethodsArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetCmpEventAddressOptionsArgs = {
  input: GetCmpEventAddressOptionsInput;
};


export type QueryGetCmpEventsAnalyticsArgs = {
  input: GetCmpEventsAnalyticsInput;
};


export type QueryGetCmpEventDetailArgs = {
  input: GetCmpEventDetailInput;
};


export type QueryGetCmpEventRegistrationsArgs = {
  input: GetCmpEventRegistrationsInput;
};


export type QueryGetCmpEventSponsorshipRequestsArgs = {
  input: GetCmpEventSponsorshipRequestsInput;
};


export type QueryGetCmpEventSponsorshipRequestByOperationArgs = {
  input: GetCmpEventSponsorshipRequestByOperationInput;
};


export type QueryExportCmpEventAttendeesCsvArgs = {
  input: ExportCmpEventAttendeesCsvInput;
};


export type QueryExportCmpEventSponsorsCsvArgs = {
  input: ExportCmpEventSponsorsCsvInput;
};


export type QueryExportCmpEventsCsvArgs = {
  input: ExportCmpEventsCsvInput;
};


export type QueryGetCmpPublicEventSummariesArgs = {
  input: GetCmpPublicEventSummariesInput;
};


export type QueryGetCmpPublicEventsArgs = {
  input: GetCmpPublicEventsInput;
};


export type QueryGetCmpPublicEventDetailArgs = {
  input: GetCmpPublicEventDetailInput;
};


export type QueryVerifyCmpPublicEventRegistrationCheckoutArgs = {
  input: VerifyCmpPublicEventRegistrationCheckoutInput;
};


export type QueryGetCmpPublicEventPaymentSettingsArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetCmpStaffEventSponsorshipPricingPreviewArgs = {
  input: GetCmpPublicEventPricingPreviewInput;
};


export type QueryGetCmpPublicEventPricingPreviewArgs = {
  input: GetCmpPublicEventPricingPreviewInput;
};


export type QueryGetCmpPublicActiveMemberCompaniesArgs = {
  input: GetCmpPublicActiveMemberCompaniesInput;
};


export type QueryGetCmpManageNewslettersArgs = {
  input: GetCmpManageNewslettersInput;
};


export type QueryGetCmpNewsletterDetailArgs = {
  input: GetCmpNewsletterDetailInput;
};


export type QueryGetCmpNewsletterSubscribersArgs = {
  input: GetCmpNewsletterSubscribersInput;
};


export type QueryGetCmpNewsletterRecipientGroupsArgs = {
  input: GetCmpNewsletterRecipientGroupsInput;
};


export type QueryPreviewCmpNewsletterRecipientsArgs = {
  input: PreviewCmpNewsletterRecipientsInput;
};


export type QueryGetCmpPublicNewsroomEntriesArgs = {
  input: GetCmpPublicNewsroomEntriesInput;
};


export type QueryGetCmpPublicNewsroomEntryDetailArgs = {
  input: GetCmpPublicNewsroomEntryDetailInput;
};


export type QueryGetAllChamberMembersArgs = {
  chamberId: Scalars['String'];
  getHasSignedUp?: Maybe<Scalars['Boolean']>;
  getNumberOfUsers?: Maybe<Scalars['Boolean']>;
};


export type QueryGetChamberMemberArgs = {
  chamberMemberId: Scalars['String'];
};


export type QueryGetSampleLoginInfoEmailArgs = {
  type: LoginInfoEmailTypes;
  chamberMemberId?: Maybe<Scalars['String']>;
  memberContactId?: Maybe<Scalars['String']>;
};


export type QueryGetDiscountArgs = {
  discountId: Scalars['String'];
};


export type QueryGetAllDiscountsFromChamberMemberIdArgs = {
  chamberMemberId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  localDay?: Maybe<DayEnum>;
  localMonth?: Maybe<MonthEnum>;
};


export type QueryGetAllDiscountsFromChamberIdArgs = {
  chamberId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  localDay?: Maybe<DayEnum>;
  localMonth?: Maybe<MonthEnum>;
};


export type QueryGetAllDeletedDiscountsFromChamberIdArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetAllDiscountsInUserPolygonBoundaryCoordsArgs = {
  openStreetMapsGeneratedProvinceForUserCurrentCoords: Scalars['String'];
  userPolygonBoundaryCoords: Array<Maybe<Array<Maybe<Array<Scalars['Float']>>>>>;
  localDay?: Maybe<DayEnum>;
  localMonth?: Maybe<MonthEnum>;
};


export type QueryGetUserIsEligibleBoolAndSendNotificationForEachEligibleNearbyDiscountArgs = {
  discountIds: Array<Scalars['String']>;
  localDay?: Maybe<DayEnum>;
  localMonth?: Maybe<MonthEnum>;
};


export type QueryGetChamberAdminStatsArgs = {
  chamberId?: Maybe<Scalars['String']>;
};


export type QueryGetAllMemberLoginCredentialsArgs = {
  processId: Scalars['String'];
};


export type QueryGetPerkPartnerDiscountArgs = {
  id: Scalars['String'];
};


export type QueryGetAllAdminUsersForPerkPartnerDiscountArgs = {
  perkPartnerDiscountId: Scalars['String'];
};


export type QueryGetPerkPartnerDiscountStatsArgs = {
  id: Scalars['String'];
};


export type QueryGetAffinityProgramPartnerArgs = {
  id: Scalars['String'];
};


export type QueryGetAllAffinityProgramPartnersForChamberArgs = {
  cmpInternalOnly?: Maybe<Scalars['Boolean']>;
  chamberId?: Maybe<Scalars['String']>;
};


export type QueryGetAffinityProgramPartnerStatsArgs = {
  id: Scalars['String'];
  inquiryLimit?: Maybe<Scalars['Float']>;
  inquiryNextToken?: Maybe<Scalars['String']>;
};


export type QueryGetCmpUserActivityLogArgs = {
  input?: Maybe<CmpUserActivityLogFilterInput>;
};


export type QueryExportCmpUserActivityLogCsvArgs = {
  input?: Maybe<CmpUserActivityLogFilterInput>;
};


export type QueryGetUserArgs = {
  userId: Scalars['String'];
};


export type QueryGetUnverifiedCpaUserInfoArgs = {
  email: Scalars['String'];
};


export type QueryGetAdminConsoleLoginEmailForChamberArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetAdminConsoleLoginEmailForChamberMemberArgs = {
  chamberMemberId: Scalars['String'];
};


export type QueryGetCpaSignUpChambersForCityArgs = {
  googleMapsApi_City_ProvinceShort_CountryShort: Scalars['String'];
  googleMapsApiFullCityAddressSearchText: Scalars['String'];
  googleMapsApiCityPlaceId?: Maybe<Scalars['String']>;
};


export type QueryGetShopLocalCampaignArgs = {
  id: Scalars['String'];
};


export type QueryGetShopLocalParticipatingMemberEligibilityArgs = {
  startDateUtcMilli: Scalars['Float'];
  endDateUtcMilli: Scalars['Float'];
};


export type QueryGetAllCategoryAdvertisingBannersForChamberArgs = {
  chamberId?: Maybe<Scalars['String']>;
};


export type QueryGetActiveCategoryAdvertisingBannersForWebsiteArgs = {
  chamberId: Scalars['String'];
};


export type QueryGetRewardCampaignArgs = {
  id: Scalars['String'];
};


export type QueryGetMemberCountForExternalCallerArgs = {
  chamberName: Scalars['String'];
  websiteDomain: Scalars['String'];
};

export type ReactivateAffinityProgramPartnerReturn = {
  __typename?: 'ReactivateAffinityProgramPartnerReturn';
  affinityProgramPartnerReactivatedSuccessfully: Scalars['Boolean'];
};

export type RecordCmpEventRegistrationManualPaymentInput = {
  chamberId: Scalars['String'];
  operationId: Scalars['String'];
  eventId: Scalars['String'];
  registrationId: Scalars['String'];
  invoiceId: Scalars['String'];
  amountInCents: Scalars['Float'];
  manualPaymentMethodId: Scalars['String'];
  receivedAtUtcMilli?: Maybe<Scalars['Float']>;
  reference?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type RecordCmpEventSponsorshipManualPaymentInput = {
  chamberId: Scalars['String'];
  operationId: Scalars['String'];
  eventId: Scalars['String'];
  sponsorshipRequestId: Scalars['String'];
  invoiceId: Scalars['String'];
  amountInCents: Scalars['Float'];
  manualPaymentMethodId: Scalars['String'];
  receivedAtUtcMilli?: Maybe<Scalars['Float']>;
  reference?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type RecordCmpInvoiceManualPaymentInput = {
  chamberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  installmentId?: Maybe<Scalars['String']>;
  amountInCents?: Maybe<Scalars['Float']>;
  paymentMethodLabel: Scalars['String'];
  reference?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  receivedAtUtcMilli?: Maybe<Scalars['Float']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type RecordCmpInvoiceManualRefundInput = {
  chamberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  paymentId?: Maybe<Scalars['String']>;
  refundAmountInCents?: Maybe<Scalars['Float']>;
  paymentMethodLabel: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type RecordCmpMemberManualPaymentInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  amountInCents: Scalars['Float'];
  manualPaymentMethodId?: Maybe<Scalars['String']>;
  receivedAtUtcMilli?: Maybe<Scalars['Float']>;
  reference?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  isCmpMemberModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type RedBubbleNotificationViewReturn = {
  __typename?: 'RedBubbleNotificationViewReturn';
  id: Scalars['String'];
  userId: Scalars['String'];
  viewType: RedBubbleNotificationViewTypeEnum;
  viewTypeItemId: Scalars['String'];
  viewedAtUtcMilli: Scalars['Float'];
  createdAtUtcMilli: Scalars['Float'];
};

export enum RedBubbleNotificationViewTypeEnum {
  PerkPartnerDiscount = 'PERK_PARTNER_DISCOUNT',
  AffinityProgramPartner = 'AFFINITY_PROGRAM_PARTNER',
  Discount = 'DISCOUNT',
  ChamberMember = 'CHAMBER_MEMBER',
  JobPosts = 'JOB_POSTS',
  Events = 'EVENTS',
  Newsletter = 'NEWSLETTER',
  Survey = 'SURVEY',
  AdvocacyWins = 'ADVOCACY_WINS',
  CallForNominations = 'CALL_FOR_NOMINATIONS'
}

export type RedeemCmpWebsiteBuilderSsoCodeInput = {
  authorizationCode: Scalars['String'];
  nonce: Scalars['String'];
  tenantHost: Scalars['String'];
};

export type RedeemSettingsInput = {
  whereToRedeem: WhereToRedeemEnum;
  howToRedeem?: Maybe<HowToRedeemInput>;
};

export type RedeemSettingsReturn = {
  __typename?: 'RedeemSettingsReturn';
  whereToRedeem: WhereToRedeemEnum;
  howToRedeem?: Maybe<HowToRedeemReturn>;
};

export type RedeemedDiscountInput = {
  id: Scalars['String'];
  userId: Scalars['String'];
  discountId: Scalars['String'];
  redeemUtcMilli: Scalars['Float'];
};

export type RedeemedDiscountReturn = {
  __typename?: 'RedeemedDiscountReturn';
  id: Scalars['String'];
  userId: Scalars['String'];
  discountId: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
};

export type RefreshChamberMemberProSenderDomainStatusForChamberReturn = {
  __typename?: 'RefreshChamberMemberProSenderDomainStatusForChamberReturn';
  senderDomainStatusRefreshedSuccessfully: Scalars['Boolean'];
  chamberMemberProSettings: ChamberMemberProSettingsReturn;
};

export type RefreshStripeConnectStatusForChamberReturn = {
  __typename?: 'RefreshStripeConnectStatusForChamberReturn';
  stripeConnectRefreshedSuccessfully: Scalars['Boolean'];
  chamberMemberProSettings: ChamberMemberProSettingsReturn;
};

export type RefundCmpInvoiceStripePaymentInput = {
  chamberId: Scalars['String'];
  invoiceId: Scalars['String'];
  paymentId?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  idempotencyKey: Scalars['String'];
  confirmTestModeOnly: Scalars['Boolean'];
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type RemoveChamberMemberProSenderDomainForChamberReturn = {
  __typename?: 'RemoveChamberMemberProSenderDomainForChamberReturn';
  senderDomainRemovedSuccessfully: Scalars['Boolean'];
  chamberMemberProSettings: ChamberMemberProSettingsReturn;
};

export type RemoveCmpNewsletterCustomAudienceRecipientInput = {
  chamberId: Scalars['String'];
  criterionId: Scalars['ID'];
  recipientKey: Scalars['String'];
};

export type RemoveCmpNewsletterSubscriberInput = {
  chamberId: Scalars['String'];
  email: Scalars['String'];
};

export type RequestAffinityProgramPartnerRedirectReturn = {
  __typename?: 'RequestAffinityProgramPartnerRedirectReturn';
  redirectUrl: Scalars['String'];
};

export type RequestMemberDashboardCredentialsReturn = {
  __typename?: 'RequestMemberDashboardCredentialsReturn';
  success: Scalars['Boolean'];
  chamberName: Scalars['String'];
  chamberSupportContactEmail: Scalars['String'];
};

export type RequestPerksLinkReturn = {
  __typename?: 'RequestPerksLinkReturn';
  perksLinkRequestedSuccessfully: Scalars['Boolean'];
};

export type RevalidateCmpWebsiteBuilderSsoSessionInput = {
  sessionToken: Scalars['String'];
  tenantHost: Scalars['String'];
};

export type RevokeCmpWebsiteBuilderSsoSessionInput = {
  sessionToken: Scalars['String'];
  tenantHost: Scalars['String'];
};

export enum RewardCampaignChallengeTypeEnum {
  ShareDiscountOrChamberMemberLeadingToNewUser = 'SHARE_DISCOUNT_OR_CHAMBER_MEMBER_LEADING_TO_NEW_USER',
  ShareDiscount = 'SHARE_DISCOUNT',
  ShareChamberMember = 'SHARE_CHAMBER_MEMBER'
}

export type RewardCampaignInput = {
  endDateUtcMilli: Scalars['Float'];
  campaignName: Scalars['String'];
  prizeDescription: Scalars['String'];
  startDateUtcMilli: Scalars['Float'];
  sponsoringChamberMemberId: Scalars['String'];
};

export type RewardCampaignReturn = {
  __typename?: 'RewardCampaignReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  sponsoringChamberMemberId: Scalars['String'];
  campaignName: Scalars['String'];
  prizeDescription: Scalars['String'];
  startDateUtcMilli: Scalars['Float'];
  endDateUtcMilli: Scalars['Float'];
  prizeDrawParticipants?: Maybe<Array<PrizeDrawParticipantReturn>>;
  capUserHasNeverViewedCampaign: Scalars['Boolean'];
  challengeConfig: Array<IndividualRewardCampaignChallengeReturn>;
  numberOfBonusBallotsWhenAllChallengesCompleted: Scalars['Float'];
  currentlyLoggedInCapUserHasAgreedToCampaign: Scalars['Boolean'];
  currentlyLoggedInCapUserHasCompletedAllChallenges: Scalars['Boolean'];
  isCreatedByCpaAdmin?: Maybe<Scalars['Boolean']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type RootAdminPerkPartnerDiscountAvailableToChambersReturn = {
  __typename?: 'RootAdminPerkPartnerDiscountAvailableToChambersReturn';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type RootAdminStatsReturn = {
  __typename?: 'RootAdminStatsReturn';
  totalChambers: Scalars['Float'];
  totalChamberMembers: Scalars['Float'];
  totalSuspendedChamberMembers: Scalars['Float'];
  totalDiscountViews: Scalars['Float'];
  totalDiscountRedemptions: Scalars['Float'];
  numberOfChamberMembersOfferingLiveDiscounts: Scalars['Float'];
  percentOfChamberMembersOfferingLiveDiscounts: Scalars['Float'];
  totalNumberOfLiveDiscounts: Scalars['Float'];
  totalNumberOfLiveAllMemberDiscounts: Scalars['Float'];
  totalNumberOfLiveLocalMemberOnlyDiscounts: Scalars['Float'];
  totalNumberOfLiveGeneralPublicDiscounts: Scalars['Float'];
  totalNumberOfLiveCompanyEmployeesOnlyDiscounts: Scalars['Float'];
  totalNumberOfAppUsers: Scalars['Float'];
  totalNumberOfAppUsersSignedUpWithAnEmployer: Scalars['Float'];
  totalNumberOfAppUsersSignedUpWithoutAnEmployer: Scalars['Float'];
  totalNumberOfAppUsersWithNewPerkNotificationEnabled: Scalars['Float'];
  totalPercentageOfAppUsersWithNewPerkNotificationEnabled: Scalars['Float'];
  totalNumberOfAppUsersWithEmployerAndNewPerkNotificationEnabled: Scalars['Float'];
  totalPercentageOfAppUsersWithEmployerAndNewPerkNotificationEnabled: Scalars['Float'];
  totalNumberOfAppUsersWithNearbyPerkNotificationEnabled: Scalars['Float'];
  totalPercentageOfAppUsersWithNearbyPerkNotificationEnabled: Scalars['Float'];
  timeseriesAppUsersData: TimeSeriesAppUsersDataReturn;
  monthToChamberAppUserData: Array<MonthToChamberAppUserDataChamberDataReturn>;
  timeseriesChamberEngageData: TimeSeriesChamberEngageDataReturn;
  chambersSortedByNewest: Array<ChambersStatsReturn>;
  newestChamberMembers: Array<DeletedAndNonDeletedChamberMemberStatsReturn>;
  newestDiscounts: Array<DeletedAndNonDeletedDiscountStatsReturn>;
  discountsPerCategoryBreakdown: Array<DiscountsPerCategoryBreakdownReturn>;
  contactableChambersSortedByNewest: Array<ContactableChamberReturn>;
  contactableCompaniesSortedByNewest: Array<ContactableCompanyReturn>;
  perksLinkChambers: Array<PerksLinkChamberStatsReturn>;
};

export type SampleLoginInfoEmailReturn = {
  __typename?: 'SampleLoginInfoEmailReturn';
  emailHtml: Scalars['String'];
  emailSubject?: Maybe<Scalars['String']>;
};

export type SaveCmpEventDraftInput = {
  chamberId: Scalars['String'];
  draftId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  draftJson: Scalars['String'];
  expectedRevision?: Maybe<Scalars['Float']>;
};

export type SaveCmpEventInvoiceDraftInput = {
  chamberId: Scalars['String'];
  operationId: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
  expectedUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  sourceKind: CmpOperationalSourceKindEnum;
  eventId: Scalars['String'];
  chamberMemberId?: Maybe<Scalars['String']>;
  billingSnapshot: CmpInvoiceBillingSnapshotInput;
  invoiceDetails: CmpStaffEventInvoiceDetailsInput;
  lineItems: Array<CmpEventInvoiceDraftLineInput>;
  taxAmountInCents: Scalars['Float'];
  draftForm: Scalars['String'];
};

export type SaveCmpMemberInvoiceCardFormNoteInput = {
  invoiceId: Scalars['String'];
  checkoutSessionId: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type SelectMemberDashboardChamberReturn = {
  __typename?: 'SelectMemberDashboardChamberReturn';
  selected: Scalars['Boolean'];
  chamberId: Scalars['String'];
};

export type SendChamberMemberProSenderDomainTestEmailReturn = {
  __typename?: 'SendChamberMemberProSenderDomainTestEmailReturn';
  testEmailSentSuccessfully: Scalars['Boolean'];
  chamberMemberProSettings: ChamberMemberProSettingsReturn;
};

export type SendCmpMemberDashboardHelpRequestInput = {
  name: Scalars['String'];
  email: Scalars['String'];
  subject: Scalars['String'];
  message: Scalars['String'];
};

export type SendCmpMemberMembershipChangeInvoiceInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
};

export type SendCmpReportEmailInput = {
  draft: PrepareCmpReportEmailInput;
  confirmationHash: Scalars['String'];
  operationId: Scalars['String'];
};

export type SendCmpReportEmailReturn = {
  __typename?: 'SendCmpReportEmailReturn';
  id: Scalars['String'];
  sent: Scalars['Boolean'];
  alreadySent: Scalars['Boolean'];
};

export type SendLoginInfoEmailToChamberMemberReturn = {
  __typename?: 'SendLoginInfoEmailToChamberMemberReturn';
  loginInfoEmailSentSuccessfully: Scalars['Boolean'];
  trackingWarning?: Maybe<Scalars['String']>;
  credentialsSentAtUtcMilli?: Maybe<Scalars['Float']>;
  loginAvailability?: Maybe<MemberDashboardLoginAvailabilityReturn>;
};

export type SetCmpEmailSubscriberTargetInput = {
  chamberId: Scalars['String'];
  calendarYear: Scalars['Float'];
  target: Scalars['Float'];
};

export type SetHasSignedUpForChamberMemberReturn = {
  __typename?: 'SetHasSignedUpForChamberMemberReturn';
  successfullySetHasSignedUp: Scalars['Boolean'];
};

export type SetMyCmpMemberAutoRenewalInput = {
  autoRenew: Scalars['Boolean'];
};

export type SetMyCmpMemberContactPermissionsInput = {
  contactId: Scalars['String'];
  expectedMemberUpdatedAtUtcMilli: Scalars['Float'];
  permissions: CmpMemberContactDashboardPermissionsInput;
};

export type ShopLocalCampaignInput = {
  campaignName: Scalars['String'];
  prizeDescription: Scalars['String'];
  startDateUtcMilli: Scalars['Float'];
  endDateUtcMilli: Scalars['Float'];
  participatingMembers: Array<ShopLocalCampaignParticipatingMembersInput>;
};

export enum ShopLocalCampaignNotificationDeliveryStatusEnum {
  NotRequested = 'NOT_REQUESTED',
  Sent = 'SENT',
  PartiallySent = 'PARTIALLY_SENT',
  NoEligibleRecipients = 'NO_ELIGIBLE_RECIPIENTS',
  Failed = 'FAILED',
  CampaignNotActive = 'CAMPAIGN_NOT_ACTIVE',
  ConfigurationError = 'CONFIGURATION_ERROR'
}

export type ShopLocalCampaignParticipatingMembersInput = {
  id: Scalars['String'];
};

export type ShopLocalCampaignParticipatingMembersReturn = {
  __typename?: 'ShopLocalCampaignParticipatingMembersReturn';
  memberId: Scalars['String'];
  participationCode: Scalars['String'];
};

export type ShopLocalCampaignPrizeDrawPariticpantReturn = {
  __typename?: 'ShopLocalCampaignPrizeDrawPariticpantReturn';
  id: Scalars['String'];
  userId: Scalars['String'];
  userEmail: Scalars['String'];
  shopLocalCampaignId: Scalars['String'];
  participatingForMemberId: Scalars['String'];
  participatingForDiscountId: Scalars['String'];
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum ShopLocalCampaignPrizeDrawParticipantCreationStatusEnum {
  Created = 'CREATED',
  AlreadyEntered = 'ALREADY_ENTERED',
  AgreementRequired = 'AGREEMENT_REQUIRED',
  CampaignNotActive = 'CAMPAIGN_NOT_ACTIVE',
  UserNotEligible = 'USER_NOT_ELIGIBLE',
  MemberNotParticipating = 'MEMBER_NOT_PARTICIPATING',
  DiscountNotEligible = 'DISCOUNT_NOT_ELIGIBLE',
  InvalidParticipationCode = 'INVALID_PARTICIPATION_CODE'
}

export type ShopLocalCampaignPrizeDrawParticipantsReturn = {
  __typename?: 'ShopLocalCampaignPrizeDrawParticipantsReturn';
  userEmail: Scalars['String'];
  redeemedAtMemberIds: Array<Scalars['String']>;
};

export type ShopLocalCampaignReturn = {
  __typename?: 'ShopLocalCampaignReturn';
  id: Scalars['String'];
  chamberId: Scalars['String'];
  campaignName: Scalars['String'];
  prizeDescription: Scalars['String'];
  startDateUtcMilli: Scalars['Float'];
  endDateUtcMilli: Scalars['Float'];
  participatingMemberIds: Array<Scalars['String']>;
  participatingMembers: Array<ShopLocalCampaignParticipatingMembersReturn>;
  prizeDrawParticipants?: Maybe<Array<ShopLocalCampaignPrizeDrawParticipantsReturn>>;
  status: ShopLocalCampaignStatusEnum;
  currentlyLoggedInCapUserHasAgreedToCampaign?: Maybe<Scalars['Boolean']>;
  createdAtUtcMilli: Scalars['Float'];
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum ShopLocalCampaignStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ShopLocalParticipatingMemberEligibilityReturn = {
  __typename?: 'ShopLocalParticipatingMemberEligibilityReturn';
  memberId: Scalars['String'];
  memberName: Scalars['String'];
  eligible: Scalars['Boolean'];
  ineligibilityReasons: Array<ShopLocalParticipatingMemberIneligibilityReasonEnum>;
};

export enum ShopLocalParticipatingMemberIneligibilityReasonEnum {
  MemberNotAppVisible = 'MEMBER_NOT_APP_VISIBLE',
  MemberSuspended = 'MEMBER_SUSPENDED',
  NoEligiblePerk = 'NO_ELIGIBLE_PERK'
}

export type SignUpMultipleMatchingChambersReturn = {
  __typename?: 'SignUpMultipleMatchingChambersReturn';
  chambersInCity: Array<ChamberReturn>;
  chamberMembersFromAllChambersInCity: Array<ChamberMemberReturn>;
};

export type SignUpNoMatchingChambersReturn = {
  __typename?: 'SignUpNoMatchingChambersReturn';
  closestChambers: Array<ChamberReturn>;
  chamberMembersFromAllClosestChambers: Array<ChamberMemberReturn>;
};

export type SignUpSingleMatchingChamberReturn = {
  __typename?: 'SignUpSingleMatchingChamberReturn';
  chamberInfo: ChamberReturn;
  chamberMembers: Array<ChamberMemberReturn>;
  additionalApplicableCityMatch?: Maybe<Scalars['Boolean']>;
  chamberLookup?: Maybe<Array<ChamberLookupEntry>>;
};

export enum SortKey {
  CmpEventDraft = 'CMP_EVENT_DRAFT',
  CmpNewsletterRecipientPreference = 'CMP_NEWSLETTER_RECIPIENT_PREFERENCE',
  CmpEventPreview = 'CMP_EVENT_PREVIEW',
  CmpEventWaitlist = 'CMP_EVENT_WAITLIST',
  CmpEventInvoicePaymentAccess = 'CMP_EVENT_INVOICE_PAYMENT_ACCESS',
  CmpEmailCaptureAddress = 'CMP_EMAIL_CAPTURE_ADDRESS',
  CmpMemberCredentialOperation = 'CMP_MEMBER_CREDENTIAL_OPERATION',
  CmpMemberContactIdentity = 'CMP_MEMBER_CONTACT_IDENTITY',
  Chamber = 'CHAMBER',
  ChamberMember = 'CHAMBER_MEMBER',
  ChamberContactableCompany = 'CHAMBER_CONTACTABLE_COMPANY',
  ContactableChamber = 'CONTACTABLE_CHAMBER',
  User = 'USER',
  Discount = 'DISCOUNT',
  RedeemedDiscount = 'REDEEMED_DISCOUNT',
  FavoritedDiscount = 'FAVORITED_DISCOUNT',
  FavoritedChamberMember = 'FAVORITED_CHAMBER_MEMBER',
  DeletedDiscount = 'DELETED_DISCOUNT',
  PerkPartnerDiscount = 'PERK_PARTNER_DISCOUNT',
  DeletedPerkPartnerDiscount = 'DELETED_PERK_PARTNER_DISCOUNT',
  PerkPartnerDiscountUpdateRecord = 'PERK_PARTNER_DISCOUNT_UPDATE_RECORD',
  AffinityProgramPartner = 'AFFINITY_PROGRAM_PARTNER',
  DeletedAffinityProgramPartner = 'DELETED_AFFINITY_PROGRAM_PARTNER',
  AffinityProgramPartnerUpdateRecord = 'AFFINITY_PROGRAM_PARTNER_UPDATE_RECORD',
  AffinityProgramPartnerInquiry = 'AFFINITY_PROGRAM_PARTNER_INQUIRY',
  AffinityProgramPartnerInquiryStats = 'AFFINITY_PROGRAM_PARTNER_INQUIRY_STATS',
  ShopLocalCampaign = 'SHOP_LOCAL_CAMPAIGN',
  ShopLocalCampaignPrizeDrawParticipant = 'SHOP_LOCAL_CAMPAIGN_PRIZE_DRAW_PARTICIPANT',
  CapUserAgreedToShopLocalCampaign = 'CAP_USER_AGREED_TO_SHOP_LOCAL_CAMPAIGN',
  PerksLinkRequest = 'PERKS_LINK_REQUEST',
  DeletedPerksLinkRequest = 'DELETED_PERKS_LINK_REQUEST',
  RedBubbleNotificationView = 'RED_BUBBLE_NOTIFICATION_VIEW',
  AllCategoryAdvertisingBannersForChamber = 'ALL_CATEGORY_ADVERTISING_BANNERS_FOR_CHAMBER',
  CategoryAdvertisingBannerUpdateRecord = 'CATEGORY_ADVERTISING_BANNER_UPDATE_RECORD',
  MemberProfileAndPerksBannersUpdateRecord = 'MEMBER_PROFILE_AND_PERKS_BANNERS_UPDATE_RECORD',
  RewardCampaign = 'REWARD_CAMPAIGN',
  CapUserAgreedToRewardCampaign = 'CAP_USER_AGREED_TO_REWARD_CAMPAIGN',
  CapUserViewedRewardCampaign = 'CAP_USER_VIEWED_REWARD_CAMPAIGN',
  CapUserShareLeadingToOpenRecord = 'CAP_USER_SHARE_LEADING_TO_OPEN_RECORD',
  CapUserShareRecord = 'CAP_USER_SHARE_RECORD',
  CmpInvoice = 'CMP_INVOICE',
  CmpPayment = 'CMP_PAYMENT',
  CmpRefund = 'CMP_REFUND',
  CmpInvoicePaymentSurfaceClaim = 'CMP_INVOICE_PAYMENT_SURFACE_CLAIM',
  CmpOperationalEvent = 'CMP_OPERATIONAL_EVENT',
  CmpStaffNote = 'CMP_STAFF_NOTE',
  CmpOutboundEmail = 'CMP_OUTBOUND_EMAIL',
  CmpRenewalWork = 'CMP_RENEWAL_WORK',
  CmpInvoiceReminderWork = 'CMP_INVOICE_REMINDER_WORK',
  CmpEvent = 'CMP_EVENT',
  CmpEventType = 'CMP_EVENT_TYPE',
  CmpEventLibraryItem = 'CMP_EVENT_LIBRARY_ITEM',
  CmpEventTemplate = 'CMP_EVENT_TEMPLATE',
  CmpEventRegistration = 'CMP_EVENT_REGISTRATION',
  CmpEventSponsorshipRequest = 'CMP_EVENT_SPONSORSHIP_REQUEST',
  CmpNewsletter = 'CMP_NEWSLETTER',
  CmpNewsletterRecipientGroup = 'CMP_NEWSLETTER_RECIPIENT_GROUP',
  CmpNewsletterSubscriber = 'CMP_NEWSLETTER_SUBSCRIBER',
  CmpMemberMembershipChange = 'CMP_MEMBER_MEMBERSHIP_CHANGE',
  CmpAnalyticsSetting = 'CMP_ANALYTICS_SETTING',
  CmpAdvertisingOption = 'CMP_ADVERTISING_OPTION',
  CmpProspect = 'CMP_PROSPECT',
  CmpProspectLeadCapture = 'CMP_PROSPECT_LEAD_CAPTURE',
  CmpUserActivity = 'CMP_USER_ACTIVITY',
  CmpPublicMembershipOperation = 'CMP_PUBLIC_MEMBERSHIP_OPERATION'
}

export type StarBreakdownReturn = {
  __typename?: 'StarBreakdownReturn';
  firstRow: Array<StarThreshold>;
  secondRow: Array<StarThreshold>;
  showFirstRowThumbsUp: Scalars['Boolean'];
  showSecondRowThumbsUp: Scalars['Boolean'];
};

export type StarThreshold = {
  __typename?: 'StarThreshold';
  threshold: Scalars['Float'];
  fillPercentage: Scalars['Float'];
};

export type StartChamberMemberProSenderDomainVerificationReturn = {
  __typename?: 'StartChamberMemberProSenderDomainVerificationReturn';
  senderDomainVerificationStartedSuccessfully: Scalars['Boolean'];
  chamberMemberProSettings: ChamberMemberProSettingsReturn;
};

export type StartCmpEventRegistrationCardCheckoutInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  registrationId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId?: Maybe<Scalars['String']>;
  mode?: Maybe<CmpStaffCheckoutModeEnum>;
  amountInCents?: Maybe<Scalars['Float']>;
  fallbackForCheckoutSessionId?: Maybe<Scalars['String']>;
  presentation?: Maybe<CmpHostedCheckoutPresentationEnum>;
};

export type StartCmpEventSponsorshipCardCheckoutInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  sponsorshipRequestId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId?: Maybe<Scalars['String']>;
  mode?: Maybe<CmpStaffCheckoutModeEnum>;
  amountInCents?: Maybe<Scalars['Float']>;
  fallbackForCheckoutSessionId?: Maybe<Scalars['String']>;
  presentation?: Maybe<CmpHostedCheckoutPresentationEnum>;
};

export type StartCmpInvoiceCardCheckoutInput = {
  chamberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId?: Maybe<Scalars['String']>;
  installmentId?: Maybe<Scalars['String']>;
  mode?: Maybe<CmpStaffCheckoutModeEnum>;
  amountInCents?: Maybe<Scalars['Float']>;
  fallbackForCheckoutSessionId?: Maybe<Scalars['String']>;
  presentation?: Maybe<CmpHostedCheckoutPresentationEnum>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type StartCmpMemberApplicationFromExistingInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  isCmpMemberModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type StartCmpMemberApplicationFromExistingReturn = {
  __typename?: 'StartCmpMemberApplicationFromExistingReturn';
  actionSuccessful: Scalars['Boolean'];
  thirdPartyBillingSnapshot?: Maybe<CmpInvoiceBillingSnapshotReturn>;
  sourceMember: ChamberMemberReturn;
  member: ChamberMemberReturn;
  event?: Maybe<CmpOperationalEventReturn>;
};

export type StartCmpMemberCardUpdateInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  operationId: Scalars['String'];
};

export type StartCmpMemberCardUpdateReturn = {
  __typename?: 'StartCmpMemberCardUpdateReturn';
  cardOnFile?: Maybe<CmpMemberSavedCardReturn>;
  clientSecret: Scalars['String'];
  connectedAccountId: Scalars['String'];
  publishableKey: Scalars['String'];
  setupIntentId: Scalars['String'];
};

export type StartCmpMemberInvoiceCheckoutInput = {
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
};

export type StartMyCmpMemberCardUpdateInput = {
  operationId: Scalars['String'];
};

export type StartStripeConnectForChamberReturn = {
  __typename?: 'StartStripeConnectForChamberReturn';
  stripeConnectStartedSuccessfully: Scalars['Boolean'];
  stripeConnectOAuthUrl?: Maybe<Scalars['String']>;
  chamberMemberProSettings: ChamberMemberProSettingsReturn;
};

export type SubmitAffinityProgramPartnerInquiryInput = {
  affinityProgramPartnerId: Scalars['String'];
  requestId: Scalars['String'];
  fullName: Scalars['String'];
  email: Scalars['String'];
  employerName: Scalars['String'];
};

export type SubmitAffinityProgramPartnerInquiryReturn = {
  __typename?: 'SubmitAffinityProgramPartnerInquiryReturn';
  inquiryId: Scalars['String'];
  submittedSuccessfully: Scalars['Boolean'];
  emailDeliveryStatus: AffinityProgramPartnerInquiryEmailDeliveryStatusEnum;
};

export type SubmitBetaFeedbackReturn = {
  __typename?: 'SubmitBetaFeedbackReturn';
  success: Scalars['Boolean'];
  message: Scalars['String'];
};

export type SubmitCmpMemberApplicationInput = {
  chamberId: Scalars['String'];
  operationId: Scalars['String'];
  initialStaffNote?: Maybe<Scalars['String']>;
  data: ChamberMemberInput;
  sourceProspectId?: Maybe<Scalars['String']>;
  sourceMemberId?: Maybe<Scalars['String']>;
  isCmpMemberModuleTestData?: Maybe<Scalars['Boolean']>;
  stripeSuccessUrl?: Maybe<Scalars['String']>;
  stripeCancelUrl?: Maybe<Scalars['String']>;
};

export type SubmitCmpMemberApplicationReturn = {
  __typename?: 'SubmitCmpMemberApplicationReturn';
  applicationSubmittedSuccessfully: Scalars['Boolean'];
  blockedByDuplicate: Scalars['Boolean'];
  duplicateMatches: Array<CmpDuplicateMatchReturn>;
  loginAvailability?: Maybe<MemberDashboardLoginAvailabilityReturn>;
  member?: Maybe<ChamberMemberReturn>;
  invoice?: Maybe<CmpInvoiceReturn>;
  addOnInvoice?: Maybe<CmpInvoiceReturn>;
  stripeCheckout?: Maybe<CmpStripeCheckoutSessionReturn>;
  convertedProspect?: Maybe<CmpProspectReturn>;
  paymentRequestCapabilities: Array<CmpMemberApplicationPaymentRequestCapability>;
};

export type SubmitCmpPublicEventRegistrationInput = {
  guestToken?: Maybe<Scalars['String']>;
  chamberId: Scalars['String'];
  operationId: Scalars['String'];
  eventId: Scalars['String'];
  ticketTypeId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  purchaserFirstName: Scalars['String'];
  purchaserLastName: Scalars['String'];
  purchaserEmail: Scalars['String'];
  purchaserPhone?: Maybe<Scalars['String']>;
  selectedMemberCompanyId?: Maybe<Scalars['String']>;
  billing?: Maybe<CmpEventPublicBillingInput>;
  paymentChoice: CmpPaymentChoiceInput;
  ticketQuantities?: Maybe<Array<CmpEventTicketQuantityInput>>;
  attendees: Array<CmpEventAttendeeInput>;
  customFieldAnswers?: Maybe<Array<CmpEventCustomFieldAnswerInput>>;
  stripeSuccessUrl?: Maybe<Scalars['String']>;
  stripeCancelUrl?: Maybe<Scalars['String']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type SubmitCmpPublicEventRegistrationReturn = {
  __typename?: 'SubmitCmpPublicEventRegistrationReturn';
  registrationSubmittedSuccessfully: Scalars['Boolean'];
  registration?: Maybe<CmpPublicEventRegistrationReceiptReturn>;
  checkoutUrl?: Maybe<Scalars['String']>;
};

export type SubmitCmpPublicEventSponsorshipRequestInput = {
  guestToken?: Maybe<Scalars['String']>;
  chamberId: Scalars['String'];
  operationId: Scalars['String'];
  eventId: Scalars['String'];
  sponsorshipPackageId: Scalars['String'];
  selectedMemberCompanyId: Scalars['String'];
  sponsorDisplayName: Scalars['String'];
  sponsorLogoUrl?: Maybe<Scalars['String']>;
  purchaserFirstName: Scalars['String'];
  purchaserLastName: Scalars['String'];
  purchaserEmail: Scalars['String'];
  purchaserPhone?: Maybe<Scalars['String']>;
  billing?: Maybe<CmpEventPublicBillingInput>;
  paymentChoice?: Maybe<CmpPaymentChoiceInput>;
  includedAttendees?: Maybe<Array<CmpEventAttendeeInput>>;
  additionalAttendees?: Maybe<Array<CmpEventAttendeeInput>>;
  customFieldAnswers?: Maybe<Array<CmpEventCustomFieldAnswerInput>>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
  stripeSuccessUrl?: Maybe<Scalars['String']>;
  stripeCancelUrl?: Maybe<Scalars['String']>;
};

export type SubmitCmpPublicEventSponsorshipRequestReturn = {
  __typename?: 'SubmitCmpPublicEventSponsorshipRequestReturn';
  sponsorshipRequestSubmittedSuccessfully: Scalars['Boolean'];
  sponsorshipRequest?: Maybe<CmpPublicEventSponsorshipRequestReceiptReturn>;
  checkoutUrl?: Maybe<Scalars['String']>;
};

export type SubmitCmpPublicMembershipApplicationInput = {
  chamberId: Scalars['String'];
  data: ChamberMemberInput;
  isCmpMemberModuleTestData?: Maybe<Scalars['Boolean']>;
  stripeSuccessUrl?: Maybe<Scalars['String']>;
  stripeCancelUrl?: Maybe<Scalars['String']>;
};

export type SubmitCmpPublicMembershipApplicationReturn = {
  __typename?: 'SubmitCmpPublicMembershipApplicationReturn';
  requestProcessed: Scalars['Boolean'];
  checkout?: Maybe<CmpPublicMembershipApplicationCheckoutReturn>;
};

export type SubmitCmpPublicMembershipApplicationV2Input = {
  chamberId: Scalars['String'];
  tenantHost: Scalars['String'];
  operationId: Scalars['String'];
  quoteFingerprint: Scalars['String'];
  quoteExpiresAtUtcMilli: Scalars['Float'];
  serviceAssertion: Scalars['String'];
  data: ChamberMemberInput;
  paymentMethod?: Maybe<CmpPublicMembershipPaymentMethodEnum>;
  manualPaymentMethodId?: Maybe<Scalars['String']>;
  autoRenewRequested?: Maybe<Scalars['Boolean']>;
  emailCommunicationConsentConfirmed?: Maybe<Scalars['Boolean']>;
  stripeSuccessUrl?: Maybe<Scalars['String']>;
  stripeCancelUrl?: Maybe<Scalars['String']>;
};

export type SubmitCmpPublicNewsletterSubscriberInput = {
  chamberId: Scalars['String'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  contactNumber?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  consentTextSnapshot?: Maybe<Scalars['String']>;
  isCmpNewsletterModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type SubmitCmpPublicNewsletterSubscriberReturn = {
  __typename?: 'SubmitCmpPublicNewsletterSubscriberReturn';
  subscriberSavedSuccessfully: Scalars['Boolean'];
  duplicateSubscriber: Scalars['Boolean'];
  subscriber?: Maybe<CmpNewsletterSubscriberReturn>;
};

export type SystemWidePerkStatsReturn = {
  __typename?: 'SystemWidePerkStatsReturn';
  totalActivePerks: Scalars['Float'];
  numberOfMembersOfferingPerks: Scalars['Float'];
  percentOfMembersOfferingPerks: Scalars['Float'];
  totalPerkViews: Scalars['Float'];
  numOfAllMemberPerks: Scalars['Float'];
  numOfLocalMemberOnlyPerks: Scalars['Float'];
  numOfGeneralPublicPerks: Scalars['Float'];
  numOfCompanyEmployeesOnlyPerks: Scalars['Float'];
  totalNumOfMembers: Scalars['Float'];
  totalNumOfChambers: Scalars['Float'];
  totalLifeTimeCategoryAdvertisingBannersRevenueForCurrentChamber: Scalars['Float'];
  totalLifeTimeRevenueFromMemberProfileAndPerksBannersForCurrentChamber: Scalars['Float'];
  totalNumOfMembersWithActiveMemberProfileAndPerksBannersForCurrentChamber: Scalars['Float'];
  totalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersForCurrentChamber?: Maybe<Array<TotalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersReturn>>;
};

export type TimeSeriesAppUserDataPointReturn = {
  __typename?: 'TimeSeriesAppUserDataPointReturn';
  monthAndYear: Scalars['String'];
  numberOfAppUsers: Scalars['Float'];
};

export type TimeSeriesAppUsersDataReturn = {
  __typename?: 'TimeSeriesAppUsersDataReturn';
  monthly: Array<TimeSeriesAppUserDataPointReturn>;
};

export type TimeSeriesChamberEngageDataReturn = {
  __typename?: 'TimeSeriesChamberEngageDataReturn';
  monthlyTotal: Array<TimeSeriesChamberEngageMonthlyDataPointReturn>;
  monthlyPerChamber: Array<TimeSeriesChamberEngageMonthlyPerChamberDataPointReturn>;
  lifetimeTotal: ChamberEngageActivationFeeRevenueReturn;
  lifetimeTotalPerChamber: Array<TimeSeriesChamberEngageLifetimeTotalPerChamberDataPointReturn>;
  yearlyTotal: Array<TimeSeriesChamberEngageYearlyDataPointReturn>;
  yearlyTotalPerChamber: Array<TimeSeriesChamberEngageYearlyTotalPerChamberDataPointReturn>;
};

export type TimeSeriesChamberEngageLifetimeTotalPerChamberDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageLifetimeTotalPerChamberDataPointReturn';
  chamberId: Scalars['String'];
  chamberName: Scalars['String'];
  lifetimeTotalActivationFeeRevenueData: ChamberEngageActivationFeeRevenueReturn;
};

export type TimeSeriesChamberEngageMonthlyDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageMonthlyDataPointReturn';
  monthAndYear: Scalars['String'];
  activationFeeRevenueData: ChamberEngageActivationFeeRevenueReturn;
};

export type TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn';
  chamberId: Scalars['String'];
  chamberName: Scalars['String'];
  activationFeeRevenueData: ChamberEngageActivationFeeRevenueReturn;
};

export type TimeSeriesChamberEngageMonthlyPerChamberDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageMonthlyPerChamberDataPointReturn';
  monthAndYear: Scalars['String'];
  chamberData: Array<TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn>;
};

export type TimeSeriesChamberEngageYearlyDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageYearlyDataPointReturn';
  year: Scalars['String'];
  activationFeeRevenueData: ChamberEngageActivationFeeRevenueReturn;
};

export type TimeSeriesChamberEngageYearlyTotalPerChamberDataPointReturn = {
  __typename?: 'TimeSeriesChamberEngageYearlyTotalPerChamberDataPointReturn';
  year: Scalars['String'];
  chamberData: Array<TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn>;
};

export type TotalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersReturn = {
  __typename?: 'TotalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersReturn';
  categoryId: Scalars['String'];
  totalNumOfMembers: Scalars['Float'];
};

export type UnverifiedCpaUserInfoReturn = {
  __typename?: 'UnverifiedCpaUserInfoReturn';
  email: Scalars['String'];
  signUpChamber: Scalars['String'];
  signUpChamberMember?: Maybe<Scalars['String']>;
};

export type UpdateAffinityProgramPartnerReturn = {
  __typename?: 'UpdateAffinityProgramPartnerReturn';
  affinityProgramPartnerUpdatedSuccessfully: Scalars['Boolean'];
  id: Scalars['String'];
};

export type UpdateChamberEngageSettingsForChamberReturn = {
  __typename?: 'UpdateChamberEngageSettingsForChamberReturn';
  settingsUpdatedSuccessfully: Scalars['Boolean'];
};

export type UpdateChamberMemberProSettingsForChamberReturn = {
  __typename?: 'UpdateChamberMemberProSettingsForChamberReturn';
  settingsUpdatedSuccessfully: Scalars['Boolean'];
  chamberMemberProSettings: ChamberMemberProSettingsReturn;
};

export type UpdateChamberMutationInput = {
  data: ChamberInput;
};

export type UpdateChamberStaffUserInput = {
  staffUserId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  usagePermissions: ChamberStaffUsagePermissionsInput;
};

export type UpdateCmpAdvertisingOptionInput = {
  chamberId: Scalars['String'];
  advertisingOptionId: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Float'];
  sortOrder?: Maybe<Scalars['Float']>;
};

export type UpdateCmpEventAttendeeCheckInInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  attendeeId: Scalars['String'];
  registrationId?: Maybe<Scalars['String']>;
  sponsorshipRequestId?: Maybe<Scalars['String']>;
  checkedIn: Scalars['Boolean'];
  expectedUpdatedAtUtcMilli: Scalars['Float'];
};

export type UpdateCmpEventInput = {
  draftId?: Maybe<Scalars['String']>;
  expectedDraftRevision?: Maybe<Scalars['Float']>;
  expectedUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  data: CmpEventDataInput;
};

export type UpdateCmpEventLibraryItemInput = {
  pairedValue?: Maybe<Scalars['String']>;
  expectedUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  attendeesPerTicket?: Maybe<Scalars['Float']>;
  chamberId: Scalars['String'];
  itemId: Scalars['String'];
  value: Scalars['String'];
  sortOrder?: Maybe<Scalars['Float']>;
};

export type UpdateCmpEventRegistrationInput = {
  deletedAttendeeIds?: Maybe<Array<Scalars['String']>>;
  operationId?: Maybe<Scalars['String']>;
  expectedUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  registrationId: Scalars['String'];
  purchaserFirstName: Scalars['String'];
  purchaserLastName: Scalars['String'];
  purchaserEmail: Scalars['String'];
  purchaserPhone?: Maybe<Scalars['String']>;
  selectedMemberCompanyId?: Maybe<Scalars['String']>;
  selectedMemberCompanyNameSnapshot?: Maybe<Scalars['String']>;
  billing?: Maybe<CmpEventPublicBillingInput>;
  status?: Maybe<CmpEventRegistrationStatusEnum>;
  ticketQuantities?: Maybe<Array<CmpEventTicketQuantityInput>>;
  attendees: Array<CmpEventAttendeeInput>;
  customFieldAnswers?: Maybe<Array<CmpEventCustomFieldAnswerInput>>;
};

export type UpdateCmpEventSponsorshipRequestInput = {
  deletedAttendeeIds?: Maybe<Array<Scalars['String']>>;
  operationId?: Maybe<Scalars['String']>;
  expectedUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  sponsorshipRequestId: Scalars['String'];
  sponsorshipPackageId: Scalars['String'];
  selectedMemberCompanyId?: Maybe<Scalars['String']>;
  selectedMemberCompanyNameSnapshot?: Maybe<Scalars['String']>;
  sponsorDisplayName: Scalars['String'];
  sponsorLogoUrl?: Maybe<Scalars['String']>;
  sponsorLogoLink?: Maybe<Scalars['String']>;
  purchaserFirstName: Scalars['String'];
  purchaserLastName: Scalars['String'];
  purchaserEmail: Scalars['String'];
  purchaserPhone?: Maybe<Scalars['String']>;
  billing?: Maybe<CmpEventPublicBillingInput>;
  status?: Maybe<CmpEventSponsorshipRequestStatusEnum>;
  includedAttendees?: Maybe<Array<CmpEventAttendeeInput>>;
  additionalAttendees?: Maybe<Array<CmpEventAttendeeInput>>;
  customFieldAnswers?: Maybe<Array<CmpEventCustomFieldAnswerInput>>;
};

export type UpdateCmpEventTypeInput = {
  chamberId: Scalars['String'];
  eventTypeId: Scalars['String'];
  label: Scalars['String'];
  color: Scalars['String'];
  sortOrder?: Maybe<Scalars['Float']>;
};

export type UpdateCmpInvoiceDraftInput = {
  chamberId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  expectedUpdatedAtUtcMilli: Scalars['Float'];
  billingSnapshot: CmpInvoiceBillingSnapshotInput;
  billToSnapshot?: Maybe<CmpInvoiceBillingSnapshotInput>;
  lineItems: Array<CmpInvoiceLineItemInput>;
  paymentChoice: CmpPaymentChoiceInput;
  issuedAtUtcMilli?: Maybe<Scalars['Float']>;
  dueAtUtcMilli?: Maybe<Scalars['Float']>;
  referencePurchaseOrder?: Maybe<Scalars['String']>;
  publicMemo?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  isCmpInvoiceModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type UpdateCmpMemberInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  data: ChamberMemberInput;
  administrativeFields?: Maybe<CmpMemberAdministrativeFieldsInput>;
  section?: Maybe<CmpMemberSectionEnum>;
  expectedUpdatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export type UpdateCmpMemberPendingMembershipChangeInput = {
  chamberId: Scalars['String'];
  memberId: Scalars['String'];
  operationId: Scalars['String'];
  expectedMemberUpdatedAtUtcMilli: Scalars['Float'];
  expectedPendingOperationId: Scalars['String'];
  expectedPendingVersion: Scalars['Int'];
  membership: CmpMemberMembershipChangeFieldsInput;
};

export type UpdateCmpMemberReturn = {
  __typename?: 'UpdateCmpMemberReturn';
  updateSuccessful: Scalars['Boolean'];
  /** Notes for the save pop-up when a contact email change moved or turned off a contact's own login. */
  contactLoginNotes?: Maybe<Array<Scalars['String']>>;
  detail: GetCmpMemberDetailReturn;
};

export type UpdateCmpNewsletterInput = {
  chamberId: Scalars['String'];
  newsletterId: Scalars['String'];
  data: CmpNewsletterDataInput;
};

export type UpdateCmpNewsletterNewsroomInput = {
  chamberId: Scalars['String'];
  newsletterId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  featuredImageUrl?: Maybe<Scalars['String']>;
};

export type UpdateCmpNewsletterRecipientGroupInput = {
  chamberId: Scalars['String'];
  groupId: Scalars['String'];
  data: CmpNewsletterRecipientGroupDataInput;
};

export type UpdateCmpProspectInput = {
  chamberId: Scalars['String'];
  prospectId: Scalars['String'];
  data: CmpProspectFieldsInput;
};

export type UpdateDiscountReturn = {
  __typename?: 'UpdateDiscountReturn';
  id: Scalars['String'];
};

export type UpdateLoggedInUserLanguageMutationReturn = {
  __typename?: 'UpdateLoggedInUserLanguageMutationReturn';
  updated: Scalars['Boolean'];
};

export type UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationReturn = {
  __typename?: 'UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationReturn';
  updated: Scalars['Boolean'];
};

export type UpdateMyCmpMemberEventAttendeesInput = {
  registrationId: Scalars['String'];
  expectedUpdatedAtUtcMilli: Scalars['Float'];
  attendees: Array<MyCmpMemberEventAttendeeInput>;
};

export type UpdatePerkPartnerDiscountReturn = {
  __typename?: 'UpdatePerkPartnerDiscountReturn';
  id: Scalars['String'];
};

export type UpdateRewardCampaignMutationReturn = {
  __typename?: 'UpdateRewardCampaignMutationReturn';
  campaignUpdatedSuccessfully: Scalars['Boolean'];
};

export type UpdateShopLocalCampaignReturn = {
  __typename?: 'UpdateShopLocalCampaignReturn';
  shopLocalCampaignUpdatedSuccessfully: Scalars['Boolean'];
};

export type UpdateUserMutationReturn = {
  __typename?: 'UpdateUserMutationReturn';
  id: Scalars['String'];
  updated: Scalars['Boolean'];
};

export type UpsertCapUserShareRecordMutationReturn = {
  __typename?: 'UpsertCapUserShareRecordMutationReturn';
  upsertedSuccessfully: Scalars['Boolean'];
};

export type UpsertRedBubbleNotificationViewReturn = {
  __typename?: 'UpsertRedBubbleNotificationViewReturn';
  redBubbleNotificationViewCreatedSuccessfully: Scalars['Boolean'];
};

export type UsagePermissionReturn = {
  __typename?: 'UsagePermissionReturn';
  chamberMemberPro_EnabledPages?: Maybe<Array<ChamberMemberProPagePermissionsEnum>>;
  chamberPerksAppAdminConsole_EnabledPages?: Maybe<Array<ChamberPerksAppAdminConsolePagePermissionsEnum>>;
};

export type UserInput = {
  id: Scalars['String'];
  email: Scalars['String'];
  chamberId: Scalars['String'];
  chamberMemberId?: Maybe<Scalars['String']>;
  marketingEmailAccepted: Scalars['Boolean'];
  notificationToken?: Maybe<Scalars['String']>;
  newPerkNotificationsActive?: Maybe<Scalars['Boolean']>;
  nearbyPerkNotificationsActive?: Maybe<Scalars['Boolean']>;
};

export type UserIsEligibleBoolAndSendNotificationForEachEligibleNearbyDiscountReturn = {
  __typename?: 'UserIsEligibleBoolAndSendNotificationForEachEligibleNearbyDiscountReturn';
  discountId: Scalars['String'];
  userIsEligible: Scalars['Boolean'];
};

export type UserReturn = {
  __typename?: 'UserReturn';
  cmpMemberDashboardAccess?: Maybe<CmpMemberDashboardAccessReturn>;
  id: Scalars['String'];
  email: Scalars['String'];
  chamberId: Scalars['String'];
  userType?: Maybe<UserType>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  chamberAccountRole?: Maybe<ChamberAccountRoleEnum>;
  accountStatus?: Maybe<ChamberStaffAccountStatusEnum>;
  credentialDeliveryStatus?: Maybe<ChamberStaffCredentialDeliveryStatusEnum>;
  credentialsLastSentAtUtcMilli?: Maybe<Scalars['Float']>;
  lastLoginAtUtcMilli?: Maybe<Scalars['Float']>;
  chamberMemberProTimeZone?: Maybe<Scalars['String']>;
  chamberInfo: ChamberReturn;
  chamberMemberId?: Maybe<Scalars['String']>;
  chamberMemberInfo?: Maybe<ChamberMemberReturn>;
  marketingEmailAccepted: Scalars['Boolean'];
  notificationToken?: Maybe<Scalars['String']>;
  newPerkNotificationsActive?: Maybe<Scalars['Boolean']>;
  nearbyPerkNotificationsActive?: Maybe<Scalars['Boolean']>;
  languageCode?: Maybe<LanguageCodeEnum>;
  usagePermissions: UsagePermissionReturn;
  createdAtUtcMilli?: Maybe<Scalars['Float']>;
  updatedAtUtcMilli?: Maybe<Scalars['Float']>;
};

export enum UserType {
  CapUser = 'CAP_USER',
  RootAdmin = 'ROOT_ADMIN',
  ChamberAdmin = 'CHAMBER_ADMIN',
  ChamberStaff = 'CHAMBER_STAFF',
  ChamberMemberAdmin = 'CHAMBER_MEMBER_ADMIN',
  PerkPartnerDiscountAdmin = 'PERK_PARTNER_DISCOUNT_ADMIN'
}

export type VerifyCmpPublicEventRegistrationCheckoutInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  checkoutSessionId: Scalars['String'];
};

export type VerifyCmpPublicEventRegistrationCheckoutReturn = {
  __typename?: 'VerifyCmpPublicEventRegistrationCheckoutReturn';
  paymentCompleted: Scalars['Boolean'];
  registration: CmpPublicEventRegistrationReceiptReturn;
  billedToCompanyName?: Maybe<Scalars['String']>;
  issuedAtUtcMilli?: Maybe<Scalars['Float']>;
  lineItems: Array<CmpEventPricingPreviewLineItemReturn>;
  subtotalInCents: Scalars['Float'];
  taxAmountInCents: Scalars['Float'];
  cardProcessingFeeInCents: Scalars['Float'];
  totalAmountInCents: Scalars['Float'];
  taxRatePercentage: Scalars['Float'];
  taxRateLabel: Scalars['String'];
};

export type VerifyCmpPublicMembershipCheckoutV2Input = {
  chamberId: Scalars['String'];
  tenantHost: Scalars['String'];
  operationId: Scalars['String'];
  serviceAssertion: Scalars['String'];
  checkoutSessionId: Scalars['String'];
};

export type VerifyUserVerificationCodeMutationReturn = {
  __typename?: 'VerifyUserVerificationCodeMutationReturn';
  userVerificationCodeVerifiedSuccessfully: Scalars['Boolean'];
};

export type VoidCmpEventRegistrationInvoiceInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  registrationId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  reason: CmpInvoiceVoidReasonEnum;
  reasonExplanation?: Maybe<Scalars['String']>;
  sourceEffect?: Maybe<CmpInvoiceSourceEffectEnum>;
  note?: Maybe<Scalars['String']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type VoidCmpEventSponsorshipInvoiceInput = {
  chamberId: Scalars['String'];
  eventId: Scalars['String'];
  sponsorshipRequestId: Scalars['String'];
  invoiceId: Scalars['String'];
  operationId: Scalars['String'];
  reason: CmpInvoiceVoidReasonEnum;
  reasonExplanation?: Maybe<Scalars['String']>;
  sourceEffect?: Maybe<CmpInvoiceSourceEffectEnum>;
  note?: Maybe<Scalars['String']>;
  isCmpEventModuleTestData?: Maybe<Scalars['Boolean']>;
};

export type WebsiteCategoryAdvertisingBannerActivationInfoReturn = {
  __typename?: 'WebsiteCategoryAdvertisingBannerActivationInfoReturn';
  banner?: Maybe<Array<BannerReturn>>;
  chamberMemberId: Scalars['String'];
};

export type WebsiteCategoryAdvertisingBannerReturn = {
  __typename?: 'WebsiteCategoryAdvertisingBannerReturn';
  categoryId: ChamberMemberCategory;
  bannerSettings?: Maybe<WebsiteCategoryAdvertisingBannerSettingsReturn>;
};

export type WebsiteCategoryAdvertisingBannerSettingsReturn = {
  __typename?: 'WebsiteCategoryAdvertisingBannerSettingsReturn';
  activationInfo: WebsiteCategoryAdvertisingBannerActivationInfoReturn;
};

export enum WhereToRedeemEnum {
  InPerson = 'IN_PERSON',
  Online = 'ONLINE',
  ContactCompany = 'CONTACT_COMPANY'
}

export type CmpMemberInvoiceRowFragment = (
  { __typename?: 'CmpMemberInvoiceRowReturn' }
  & Pick<CmpMemberInvoiceRowReturn, 'id' | 'invoiceNumber' | 'description' | 'issuedAtUtcMilli' | 'dueAtUtcMilli' | 'currency' | 'totalAmountInCents' | 'amountDueInCents' | 'displayState' | 'paymentMethodLabel' | 'daysPastDue' | 'installmentSummary' | 'canPay' | 'payableAmountInCents' | 'paymentUnavailableReason' | 'billToName' | 'creditForInvoiceNumber' | 'creditedByInvoiceNumbers'>
);

export type AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutationVariables = Exact<{
  categoryId: ChamberMemberCategory;
  agreementVersion?: Maybe<Scalars['String']>;
}>;


export type AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation = (
  { __typename?: 'Mutation' }
  & { acceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMember: (
    { __typename?: 'AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberReturn' }
    & Pick<AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberReturn, 'agreementAcceptedSuccessfully'>
  ) }
);

export type AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutationVariables = Exact<{
  agreementVersion?: Maybe<Scalars['String']>;
}>;


export type AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation = (
  { __typename?: 'Mutation' }
  & { acceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMember: (
    { __typename?: 'AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberReturn' }
    & Pick<AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberReturn, 'agreementAcceptedSuccessfully'>
  ) }
);

export type AcceptPerksLinkRequestMutationVariables = Exact<{
  requestId: Scalars['String'];
}>;


export type AcceptPerksLinkRequestMutation = (
  { __typename?: 'Mutation' }
  & { acceptPerksLinkRequest: (
    { __typename?: 'AcceptPerksLinkRequestReturn' }
    & Pick<AcceptPerksLinkRequestReturn, 'perksLinkAcceptedSuccessfully'>
  ) }
);

export type ActivateBannerForCategoryAdvertisingBannerMutationVariables = Exact<{
  chamberId?: Maybe<Scalars['String']>;
  categoryId: ChamberMemberCategory;
  activationInfo: CategoryAdvertisingBannerActivationInfoInput;
}>;


export type ActivateBannerForCategoryAdvertisingBannerMutation = (
  { __typename?: 'Mutation' }
  & { activateBannerForCategoryAdvertisingBanner: (
    { __typename?: 'ActivateBannerForCategoryAdvertisingBannerReturn' }
    & Pick<ActivateBannerForCategoryAdvertisingBannerReturn, 'bannerActivatedSuccessfully'>
  ) }
);

export type ActivateCmpMemberMutationVariables = Exact<{
  input: CmpMemberActionInput;
}>;


export type ActivateCmpMemberMutation = (
  { __typename?: 'Mutation' }
  & { activateCmpMember: (
    { __typename?: 'CmpMemberActionReturn' }
    & Pick<CmpMemberActionReturn, 'actionSuccessful'>
    & { detail: (
      { __typename?: 'GetCmpMemberDetailReturn' }
      & Pick<GetCmpMemberDetailReturn, 'lifecycleStatus'>
      & { member: (
        { __typename?: 'ChamberMemberReturn' }
        & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'lifecycleStatus' | 'isSuspended' | 'updatedAtUtcMilli'>
      ) }
    ) }
  ) }
);

export type ActivateMemberProfileAndPerksBannersForChamberMemberMutationVariables = Exact<{
  chamberId?: Maybe<Scalars['String']>;
  chamberMemberId: Scalars['String'];
  startDateUtcMilli: Scalars['Float'];
}>;


export type ActivateMemberProfileAndPerksBannersForChamberMemberMutation = (
  { __typename?: 'Mutation' }
  & { activateMemberProfileAndPerksBannersForChamberMember: (
    { __typename?: 'ActivateMemberProfileAndPerksBannersForChamberMemberReturn' }
    & Pick<ActivateMemberProfileAndPerksBannersForChamberMemberReturn, 'activationSuccessful'>
  ) }
);

export type ChamberChangeAdminConsoleLoginEmailMutationVariables = Exact<{
  currentAdminConsoleLoginEmail: Scalars['String'];
  newAdminConsoleLoginEmail: Scalars['String'];
  chamberId: Scalars['String'];
}>;


export type ChamberChangeAdminConsoleLoginEmailMutation = (
  { __typename?: 'Mutation' }
  & { chamberChangeAdminConsoleLoginEmail: (
    { __typename?: 'ChangeAdminConsoleLoginEmailReturn' }
    & Pick<ChangeAdminConsoleLoginEmailReturn, 'password' | 'failureReason' | 'adminConsoleLoginEmailChangedSuccessfully' | 'email'>
  ) }
);

export type ChamberMemberChangeAdminConsoleLoginEmailMutationVariables = Exact<{
  currentAdminConsoleLoginEmail: Scalars['String'];
  newAdminConsoleLoginEmail: Scalars['String'];
  chamberMemberId: Scalars['String'];
}>;


export type ChamberMemberChangeAdminConsoleLoginEmailMutation = (
  { __typename?: 'Mutation' }
  & { chamberMemberChangeAdminConsoleLoginEmail: (
    { __typename?: 'ChangeAdminConsoleLoginEmailReturn' }
    & Pick<ChangeAdminConsoleLoginEmailReturn, 'password' | 'failureReason' | 'adminConsoleLoginEmailChangedSuccessfully' | 'email'>
  ) }
);

export type ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutationVariables = Exact<{
  chamberId?: Maybe<Scalars['String']>;
  categoryId: ChamberMemberCategory;
  autoApproveBannerContentUpdate: Scalars['Boolean'];
}>;


export type ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation = (
  { __typename?: 'Mutation' }
  & { changeAutoApprovalForBannerContentOfCategoryAdvertisingBanner: (
    { __typename?: 'ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerReturn' }
    & Pick<ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerReturn, 'autoApprovalUpdateSuccessful'>
  ) }
);

export type SetMyCmpMemberAutoRenewalMutationVariables = Exact<{
  input: SetMyCmpMemberAutoRenewalInput;
}>;


export type SetMyCmpMemberAutoRenewalMutation = (
  { __typename?: 'Mutation' }
  & { setMyCmpMemberAutoRenewal: (
    { __typename?: 'CmpMyMemberAutoRenewalReturn' }
    & CmpMyMemberAutoRenewalFragment
  ) }
);

export type StartMyCmpMemberCardUpdateMutationVariables = Exact<{
  input: StartMyCmpMemberCardUpdateInput;
}>;


export type StartMyCmpMemberCardUpdateMutation = (
  { __typename?: 'Mutation' }
  & { startMyCmpMemberCardUpdate: (
    { __typename?: 'StartCmpMemberCardUpdateReturn' }
    & Pick<StartCmpMemberCardUpdateReturn, 'clientSecret' | 'connectedAccountId' | 'publishableKey' | 'setupIntentId'>
    & { cardOnFile?: Maybe<(
      { __typename?: 'CmpMemberSavedCardReturn' }
      & Pick<CmpMemberSavedCardReturn, 'label'>
    )> }
  ) }
);

export type CompleteMyCmpMemberCardUpdateMutationVariables = Exact<{
  input: CompleteMyCmpMemberCardUpdateInput;
}>;


export type CompleteMyCmpMemberCardUpdateMutation = (
  { __typename?: 'Mutation' }
  & { completeMyCmpMemberCardUpdate: (
    { __typename?: 'CmpMyMemberAutoRenewalReturn' }
    & CmpMyMemberAutoRenewalFragment
  ) }
);

export type GetCmpMemberInvoiceDocumentMutationVariables = Exact<{
  input: CmpMemberInvoiceInput;
}>;


export type GetCmpMemberInvoiceDocumentMutation = (
  { __typename?: 'Mutation' }
  & { getCmpMemberInvoiceDocument: (
    { __typename?: 'CmpInvoiceDownloadReturn' }
    & Pick<CmpInvoiceDownloadReturn, 'filename' | 'contentType' | 'base64Data' | 'generatedAtUtcMilli'>
  ) }
);

export type StartCmpMemberInvoiceCheckoutMutationVariables = Exact<{
  input: StartCmpMemberInvoiceCheckoutInput;
}>;


export type StartCmpMemberInvoiceCheckoutMutation = (
  { __typename?: 'Mutation' }
  & { startCmpMemberInvoiceCheckout: (
    { __typename?: 'CmpMemberInvoiceCheckoutReturn' }
    & Pick<CmpMemberInvoiceCheckoutReturn, 'checkoutUrl'>
  ) }
);

export type StartCmpMemberInvoiceCardFormMutationVariables = Exact<{
  input: StartCmpMemberInvoiceCheckoutInput;
}>;


export type StartCmpMemberInvoiceCardFormMutation = (
  { __typename?: 'Mutation' }
  & { startCmpMemberInvoiceCardForm: (
    { __typename?: 'CmpMemberInvoiceCardFormReturn' }
    & Pick<CmpMemberInvoiceCardFormReturn, 'invoiceId' | 'checkoutSessionId' | 'clientSecret' | 'publishableKey' | 'connectedAccountId' | 'amountInCents' | 'currency' | 'expiresAtUtcMilli'>
  ) }
);

export type SaveCmpMemberInvoiceCardFormNoteMutationVariables = Exact<{
  input: SaveCmpMemberInvoiceCardFormNoteInput;
}>;


export type SaveCmpMemberInvoiceCardFormNoteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'saveCmpMemberInvoiceCardFormNote'>
);

export type CreateAffinityProgramPartnerMutationVariables = Exact<{
  input: AffinityProgramPartnerInput;
  activationStartDateUtcMilli: Scalars['Float'];
  chamberId?: Maybe<Scalars['String']>;
}>;


export type CreateAffinityProgramPartnerMutation = (
  { __typename?: 'Mutation' }
  & { createAffinityProgramPartner: (
    { __typename?: 'CreateAffinityProgramPartnerReturn' }
    & Pick<CreateAffinityProgramPartnerReturn, 'affinityProgramPartnerCreatedSuccessfully' | 'id'>
  ) }
);

export type CreateAllMemberLoginCredentialsMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateAllMemberLoginCredentialsMutation = (
  { __typename?: 'Mutation' }
  & { createAllMemberLoginCredentials: (
    { __typename?: 'CreateAllMemberLoginCredentialsReturn' }
    & Pick<CreateAllMemberLoginCredentialsReturn, 'processId'>
  ) }
);

export type CreateChamberContactableCompanyMutationVariables = Exact<{
  input: CreateChamberContactableCompanyMutationInput;
}>;


export type CreateChamberContactableCompanyMutation = (
  { __typename?: 'Mutation' }
  & { createChamberContactableCompany: (
    { __typename?: 'ContactableCompanyReturn' }
    & Pick<ContactableCompanyReturn, 'id' | 'chamberId' | 'name'>
  ) }
);

export type CreateChamberMembersMutationVariables = Exact<{
  input: CreateChamberMembersMutationInput;
}>;


export type CreateChamberMembersMutation = (
  { __typename?: 'Mutation' }
  & { createChamberMembers: (
    { __typename?: 'CreateChamberMembersMutationReturn' }
    & { results: Array<(
      { __typename?: 'ChamberMemberUserReturn' }
      & Pick<ChamberMemberUserReturn, 'chamberMemberAddedSuccessfully' | 'failureReason' | 'email' | 'password'>
    )> }
  ) }
);

export type CreateChambersMutationVariables = Exact<{
  input: CreateChamberMutationInput;
}>;


export type CreateChambersMutation = (
  { __typename?: 'Mutation' }
  & { createChambers: (
    { __typename?: 'CreateChamberMutationReturn' }
    & { results: Array<(
      { __typename?: 'ChamberAdminUserReturn' }
      & Pick<ChamberAdminUserReturn, 'chamberAddedSuccessfully' | 'email' | 'password' | 'failureReason'>
    )> }
  ) }
);

export type CreateDiscountsMutationVariables = Exact<{
  input: CreateDiscountsMutationInput;
}>;


export type CreateDiscountsMutation = (
  { __typename?: 'Mutation' }
  & { createDiscounts: (
    { __typename?: 'CreateDiscountsMutationReturn' }
    & Pick<CreateDiscountsMutationReturn, 'discountsAddedSuccessfully'>
  ) }
);

export type CreatePerkPartnerDiscountMutationVariables = Exact<{
  input: PerkPartnerDiscountInput;
}>;


export type CreatePerkPartnerDiscountMutation = (
  { __typename?: 'Mutation' }
  & { createPerkPartnerDiscount: (
    { __typename?: 'CreatePerkPartnerDiscountMutationReturn' }
    & Pick<CreatePerkPartnerDiscountMutationReturn, 'perkPartnerDiscountAddedSuccessfully'>
  ) }
);

export type CreatePerkPartnerDiscountAdminUserMutationVariables = Exact<{
  input: PerkPartnerDiscountAdminUserInput;
}>;


export type CreatePerkPartnerDiscountAdminUserMutation = (
  { __typename?: 'Mutation' }
  & { createPerkPartnerDiscountAdminUser: (
    { __typename?: 'CreatePerkPartnerDiscountAdminUserMutationReturn' }
    & Pick<CreatePerkPartnerDiscountAdminUserMutationReturn, 'perkPartnerDiscountAdminUserCreatedSuccessfully' | 'email' | 'password' | 'failureReason'>
  ) }
);

export type CreateRewardCampaignMutationVariables = Exact<{
  input: RewardCampaignInput;
}>;


export type CreateRewardCampaignMutation = (
  { __typename?: 'Mutation' }
  & { createRewardCampaign: (
    { __typename?: 'CreateRewardCampaignMutationReturn' }
    & Pick<CreateRewardCampaignMutationReturn, 'campaignCreatedSuccessfully'>
  ) }
);

export type CreateShopLocalCampaignMutationVariables = Exact<{
  input: ShopLocalCampaignInput;
  sendNotification: Scalars['Boolean'];
}>;


export type CreateShopLocalCampaignMutation = (
  { __typename?: 'Mutation' }
  & { createShopLocalCampaign: (
    { __typename?: 'CreateShopLocalCampaignReturn' }
    & Pick<CreateShopLocalCampaignReturn, 'shopLocalCampaignCreatedSuccessfully' | 'shopLocalCampaignId' | 'notificationDeliveryStatus' | 'notificationTargetCount' | 'notificationSuccessCount' | 'notificationFailureCount'>
  ) }
);

export type DeactivateAffinityProgramPartnerMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeactivateAffinityProgramPartnerMutation = (
  { __typename?: 'Mutation' }
  & { deactivateAffinityProgramPartner: (
    { __typename?: 'DeactivateAffinityProgramPartnerReturn' }
    & Pick<DeactivateAffinityProgramPartnerReturn, 'affinityProgramPartnerDeactivatedSuccessfully'>
  ) }
);

export type DeactivateBannerForCategoryAdvertisingBannerMutationVariables = Exact<{
  chamberId?: Maybe<Scalars['String']>;
  categoryId: ChamberMemberCategory;
  chamberMemberId: Scalars['String'];
}>;


export type DeactivateBannerForCategoryAdvertisingBannerMutation = (
  { __typename?: 'Mutation' }
  & { deactivateBannerForCategoryAdvertisingBanner: (
    { __typename?: 'DeactivateBannerForCategoryAdvertisingBannerReturn' }
    & Pick<DeactivateBannerForCategoryAdvertisingBannerReturn, 'deactivationSuccessful'>
  ) }
);

export type DeactivateMemberProfileAndPerksBannersForChamberMemberMutationVariables = Exact<{
  chamberId?: Maybe<Scalars['String']>;
  chamberMemberId: Scalars['String'];
}>;


export type DeactivateMemberProfileAndPerksBannersForChamberMemberMutation = (
  { __typename?: 'Mutation' }
  & { deactivateMemberProfileAndPerksBannersForChamberMember: (
    { __typename?: 'DeactivateMemberProfileAndPerksBannersForChamberMemberReturn' }
    & Pick<DeactivateMemberProfileAndPerksBannersForChamberMemberReturn, 'deactivationSuccessful'>
  ) }
);

export type DeleteChamberMemberMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteChamberMemberMutation = (
  { __typename?: 'Mutation' }
  & { deleteChamberMember: (
    { __typename?: 'DeleteReturn' }
    & Pick<DeleteReturn, 'id'>
  ) }
);

export type DeleteChamberMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteChamberMutation = (
  { __typename?: 'Mutation' }
  & { deleteChamber: (
    { __typename?: 'DeleteReturn' }
    & Pick<DeleteReturn, 'id'>
  ) }
);

export type DeleteDiscountMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteDiscountMutation = (
  { __typename?: 'Mutation' }
  & { deleteDiscount: (
    { __typename?: 'DeleteReturn' }
    & Pick<DeleteReturn, 'id'>
  ) }
);

export type DeletePerkPartnerDiscountMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePerkPartnerDiscountMutation = (
  { __typename?: 'Mutation' }
  & { deletePerkPartnerDiscount: (
    { __typename?: 'DeleteReturn' }
    & Pick<DeleteReturn, 'id'>
  ) }
);

export type DeletePerkPartnerDiscountAdminUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePerkPartnerDiscountAdminUserMutation = (
  { __typename?: 'Mutation' }
  & { deletePerkPartnerDiscountAdminUser: (
    { __typename?: 'DeleteReturn' }
    & Pick<DeleteReturn, 'id'>
  ) }
);

export type DeletePerksLinkRequestMutationVariables = Exact<{
  requestId: Scalars['String'];
  deletionReason: PerksLinkDeletionReasonEnum;
}>;


export type DeletePerksLinkRequestMutation = (
  { __typename?: 'Mutation' }
  & { deletePerksLinkRequest: (
    { __typename?: 'DeletePerksLinkRequestReturn' }
    & Pick<DeletePerksLinkRequestReturn, 'perksLinkDeletedSuccessfully'>
  ) }
);

export type EndRewardCampaignMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type EndRewardCampaignMutation = (
  { __typename?: 'Mutation' }
  & { endRewardCampaign: (
    { __typename?: 'EndRewardCampaignMutationReturn' }
    & Pick<EndRewardCampaignMutationReturn, 'campaignEndedSuccessfully'>
  ) }
);

export type EndShopLocalCampaignMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type EndShopLocalCampaignMutation = (
  { __typename?: 'Mutation' }
  & { endShopLocalCampaign: (
    { __typename?: 'EndShopLocalCampaignReturn' }
    & Pick<EndShopLocalCampaignReturn, 'shopLocalCampaignEndedSuccessfully'>
  ) }
);

export type ExcludeChamberEngageActivationFromInvoiceMutationVariables = Exact<{
  activationId: Scalars['String'];
  activationType: ChamberEngageActivationTypeEnum;
}>;


export type ExcludeChamberEngageActivationFromInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { excludeChamberEngageActivationFromInvoice: (
    { __typename?: 'ExcludeChamberEngageActivationFromInvoiceReturn' }
    & Pick<ExcludeChamberEngageActivationFromInvoiceReturn, 'excluded'>
  ) }
);

export type GetSupportCenterUrlMutationVariables = Exact<{
  nonce: Scalars['String'];
  state: Scalars['String'];
}>;


export type GetSupportCenterUrlMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'getSupportCenterUrl'>
);

export type IdaGenerateMutationVariables = Exact<{
  input: IdaGenerateInput;
}>;


export type IdaGenerateMutation = (
  { __typename?: 'Mutation' }
  & { idaGenerate: (
    { __typename?: 'IDAGenerateReturn' }
    & Pick<IdaGenerateReturn, 'success' | 'generatedText'>
    & { suggestedCategories?: Maybe<Array<(
      { __typename?: 'CategoryReturn' }
      & Pick<CategoryReturn, 'id' | 'name'>
    )>> }
  ) }
);

export type IncludeChamberEngageActivationInInvoiceMutationVariables = Exact<{
  activationId: Scalars['String'];
  activationType: ChamberEngageActivationTypeEnum;
}>;


export type IncludeChamberEngageActivationInInvoiceMutation = (
  { __typename?: 'Mutation' }
  & { includeChamberEngageActivationInInvoice: (
    { __typename?: 'IncludeChamberEngageActivationInInvoiceReturn' }
    & Pick<IncludeChamberEngageActivationInInvoiceReturn, 'included'>
  ) }
);

export type ManageMyCmpMemberContactAccountMutationVariables = Exact<{
  input: ManageMyCmpMemberContactAccountInput;
}>;


export type ManageMyCmpMemberContactAccountMutation = (
  { __typename?: 'Mutation' }
  & { manageMyCmpMemberContactAccount: (
    { __typename?: 'CmpMemberContactAccountActionReturn' }
    & Pick<CmpMemberContactAccountActionReturn, 'memberUpdatedAtUtcMilli' | 'deliveryConfirmed' | 'trackingWarning'>
    & { credentials?: Maybe<(
      { __typename?: 'CmpMemberContactCredentialsReturn' }
      & Pick<CmpMemberContactCredentialsReturn, 'email' | 'password' | 'loginUrl'>
    )>, accounts: Array<(
      { __typename?: 'CmpMemberContactAccountReturn' }
      & Pick<CmpMemberContactAccountReturn, 'contactId' | 'name' | 'email' | 'usesLegacyMemberAccount' | 'credentialActionsBlockedReason' | 'enabled' | 'hasSignedUp' | 'credentialsSentAtUtcMilli' | 'lastDashboardLoginAtUtcMilli'>
    )> }
  ) }
);

export type MarkChamberEngageActivationInvoicedMutationVariables = Exact<{
  activationsToMarkInvoiced: Array<ChamberEngageActivationToMarkInvoicedInput> | ChamberEngageActivationToMarkInvoicedInput;
}>;


export type MarkChamberEngageActivationInvoicedMutation = (
  { __typename?: 'Mutation' }
  & { markChamberEngageActivationInvoiced: (
    { __typename?: 'MarkChamberEngageActivationInvoicedReturn' }
    & Pick<MarkChamberEngageActivationInvoicedReturn, 'marked'>
  ) }
);

export type MassSendLoginInfoEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type MassSendLoginInfoEmailMutation = (
  { __typename?: 'Mutation' }
  & { massSendLoginInfoEmail: (
    { __typename?: 'MassSendLoginInfoEmailReturn' }
    & Pick<MassSendLoginInfoEmailReturn, 'successCount' | 'failureCount' | 'totalCount'>
  ) }
);

export type ReactivateAffinityProgramPartnerMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReactivateAffinityProgramPartnerMutation = (
  { __typename?: 'Mutation' }
  & { reactivateAffinityProgramPartner: (
    { __typename?: 'ReactivateAffinityProgramPartnerReturn' }
    & Pick<ReactivateAffinityProgramPartnerReturn, 'affinityProgramPartnerReactivatedSuccessfully'>
  ) }
);

export type ReactivateBannerForCategoryAdvertisingBannerMutationVariables = Exact<{
  chamberId?: Maybe<Scalars['String']>;
  categoryId: ChamberMemberCategory;
  reactivationInfo: CategoryAdvertisingBannerReactivationInfoInput;
}>;


export type ReactivateBannerForCategoryAdvertisingBannerMutation = (
  { __typename?: 'Mutation' }
  & { reactivateBannerForCategoryAdvertisingBanner: (
    { __typename?: 'ActivateBannerForCategoryAdvertisingBannerReturn' }
    & Pick<ActivateBannerForCategoryAdvertisingBannerReturn, 'bannerActivatedSuccessfully'>
  ) }
);

export type ReactivateMemberProfileAndPerksBannersForChamberMemberMutationVariables = Exact<{
  chamberId?: Maybe<Scalars['String']>;
  chamberMemberId: Scalars['String'];
}>;


export type ReactivateMemberProfileAndPerksBannersForChamberMemberMutation = (
  { __typename?: 'Mutation' }
  & { reactivateMemberProfileAndPerksBannersForChamberMember: (
    { __typename?: 'ActivateMemberProfileAndPerksBannersForChamberMemberReturn' }
    & Pick<ActivateMemberProfileAndPerksBannersForChamberMemberReturn, 'activationSuccessful'>
  ) }
);

export type RecordCmpMemberDashboardLoginMutationVariables = Exact<{ [key: string]: never; }>;


export type RecordCmpMemberDashboardLoginMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'recordCmpMemberDashboardLogin'>
);

export type RecordCpaDashboardAccessMutationVariables = Exact<{ [key: string]: never; }>;


export type RecordCpaDashboardAccessMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'recordCpaDashboardAccess'>
);

export type RequestMemberDashboardCredentialsMutationVariables = Exact<{
  chamberId: Scalars['String'];
  chamberMemberId: Scalars['String'];
}>;


export type RequestMemberDashboardCredentialsMutation = (
  { __typename?: 'Mutation' }
  & { requestMemberDashboardCredentials: (
    { __typename?: 'RequestMemberDashboardCredentialsReturn' }
    & Pick<RequestMemberDashboardCredentialsReturn, 'success' | 'chamberName' | 'chamberSupportContactEmail'>
  ) }
);

export type RequestPerksLinkMutationVariables = Exact<{
  requestingLinkToChamberId: Scalars['String'];
}>;


export type RequestPerksLinkMutation = (
  { __typename?: 'Mutation' }
  & { requestPerksLink: (
    { __typename?: 'RequestPerksLinkReturn' }
    & Pick<RequestPerksLinkReturn, 'perksLinkRequestedSuccessfully'>
  ) }
);

export type SelectMemberDashboardChamberMutationVariables = Exact<{
  chamberId: Scalars['String'];
}>;


export type SelectMemberDashboardChamberMutation = (
  { __typename?: 'Mutation' }
  & { selectMemberDashboardChamber: (
    { __typename?: 'SelectMemberDashboardChamberReturn' }
    & Pick<SelectMemberDashboardChamberReturn, 'selected' | 'chamberId'>
  ) }
);

export type SendCmpMemberDashboardHelpRequestMutationVariables = Exact<{
  input: SendCmpMemberDashboardHelpRequestInput;
}>;


export type SendCmpMemberDashboardHelpRequestMutation = (
  { __typename?: 'Mutation' }
  & { sendCmpMemberDashboardHelpRequest: (
    { __typename?: 'CmpMemberDashboardHelpRequestReturn' }
    & Pick<CmpMemberDashboardHelpRequestReturn, 'chamberName' | 'replyToEmail'>
  ) }
);

export type SendLoginInfoEmailToChamberMemberMutationVariables = Exact<{
  adminConsoleLoginEmail: Scalars['String'];
  chamberMemberId: Scalars['String'];
  type: LoginInfoEmailTypes;
}>;


export type SendLoginInfoEmailToChamberMemberMutation = (
  { __typename?: 'Mutation' }
  & { sendLoginInfoEmailToChamberMember: (
    { __typename?: 'SendLoginInfoEmailToChamberMemberReturn' }
    & Pick<SendLoginInfoEmailToChamberMemberReturn, 'loginInfoEmailSentSuccessfully'>
  ) }
);

export type SetHasSignedUpForChamberMemberMutationVariables = Exact<{ [key: string]: never; }>;


export type SetHasSignedUpForChamberMemberMutation = (
  { __typename?: 'Mutation' }
  & { setHasSignedUpForChamberMember: (
    { __typename?: 'SetHasSignedUpForChamberMemberReturn' }
    & Pick<SetHasSignedUpForChamberMemberReturn, 'successfullySetHasSignedUp'>
  ) }
);

export type SetMyCmpMemberDashboardTestModeMutationVariables = Exact<{
  input: CmpMemberDashboardTestModeInput;
}>;


export type SetMyCmpMemberDashboardTestModeMutation = (
  { __typename?: 'Mutation' }
  & { setMyCmpMemberDashboardTestMode: (
    { __typename?: 'CmpMemberDashboardTestModeReturn' }
    & Pick<CmpMemberDashboardTestModeReturn, 'available' | 'plan' | 'contactType' | 'switchChamber'>
  ) }
);

export type SetNewTemporaryChamberMemberPasswordMutationVariables = Exact<{
  adminConsoleLoginEmail: Scalars['String'];
  chamberMemberId: Scalars['String'];
}>;


export type SetNewTemporaryChamberMemberPasswordMutation = (
  { __typename?: 'Mutation' }
  & { setNewTemporaryChamberMemberPassword: (
    { __typename?: 'NewTemporaryChamberMemberPasswordReturn' }
    & Pick<NewTemporaryChamberMemberPasswordReturn, 'password' | 'failureReason'>
  ) }
);

export type SuspendCmpMemberMutationVariables = Exact<{
  input: CmpMemberActionInput;
}>;


export type SuspendCmpMemberMutation = (
  { __typename?: 'Mutation' }
  & { suspendCmpMember: (
    { __typename?: 'CmpMemberActionReturn' }
    & Pick<CmpMemberActionReturn, 'actionSuccessful'>
    & { detail: (
      { __typename?: 'GetCmpMemberDetailReturn' }
      & Pick<GetCmpMemberDetailReturn, 'lifecycleStatus'>
      & { member: (
        { __typename?: 'ChamberMemberReturn' }
        & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'lifecycleStatus' | 'isSuspended' | 'updatedAtUtcMilli'>
      ) }
    ) }
  ) }
);

export type UpdateAffinityProgramPartnerMutationVariables = Exact<{
  id: Scalars['String'];
  input: AffinityProgramPartnerInput;
}>;


export type UpdateAffinityProgramPartnerMutation = (
  { __typename?: 'Mutation' }
  & { updateAffinityProgramPartner: (
    { __typename?: 'UpdateAffinityProgramPartnerReturn' }
    & Pick<UpdateAffinityProgramPartnerReturn, 'affinityProgramPartnerUpdatedSuccessfully' | 'id'>
  ) }
);

export type UpdateBannerContentForCategoryAdvertisingBannerMutationVariables = Exact<{
  chamberId?: Maybe<Scalars['String']>;
  categoryId: ChamberMemberCategory;
  banner?: Maybe<Array<BannerInput> | BannerInput>;
}>;


export type UpdateBannerContentForCategoryAdvertisingBannerMutation = (
  { __typename?: 'Mutation' }
  & { updateBannerContentForCategoryAdvertisingBanner: (
    { __typename?: 'ActivateBannerForCategoryAdvertisingBannerReturn' }
    & Pick<ActivateBannerForCategoryAdvertisingBannerReturn, 'bannerActivatedSuccessfully'>
  ) }
);

export type UpdateChamberMutationVariables = Exact<{
  id: Scalars['String'];
  input: ChamberInput;
}>;


export type UpdateChamberMutation = (
  { __typename?: 'Mutation' }
  & { updateChamber: (
    { __typename?: 'ChamberReturn' }
    & Pick<ChamberReturn, 'id' | 'name' | 'website' | 'supportContactEmail' | 'googleMapsApi_City_ProvinceShort_CountryShort' | 'supportContactName' | 'billingContactName' | 'billingContactEmail' | 'signingAuthorityContactName' | 'signingAuthorityContactEmail' | 'supportLink' | 'phoneNumber' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'jobPostingLink' | 'eventsLink' | 'newsletterLink' | 'surveyLink' | 'advocacyWinsLink' | 'callForNominationsLink' | 'memberSignupLink' | 'sponsorLogo' | 'sponsorLogoLink' | 'logo' | 'numberOfMembersFromInitialSubscriptionAgreement' | 'description' | 'hideInApp'>
    & { address: (
      { __typename?: 'AddressReturn' }
      & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
    ) }
  ) }
);

export type UpdateChamberEngageSettingsForChamberMutationVariables = Exact<{
  chamberId: Scalars['String'];
  chamberEngageSettings: ChamberEngageSettingsInput;
}>;


export type UpdateChamberEngageSettingsForChamberMutation = (
  { __typename?: 'Mutation' }
  & { updateChamberEngageSettingsForChamber: (
    { __typename?: 'UpdateChamberEngageSettingsForChamberReturn' }
    & Pick<UpdateChamberEngageSettingsForChamberReturn, 'settingsUpdatedSuccessfully'>
  ) }
);

export type UpdateChamberMemberMutationVariables = Exact<{
  id: Scalars['String'];
  input: ChamberMemberInput;
}>;


export type UpdateChamberMemberMutation = (
  { __typename?: 'Mutation' }
  & { updateChamberMember: (
    { __typename?: 'ChamberMemberReturn' }
    & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'categoryId' | 'credentialsSentAtUtcMilli' | 'adminConsoleContactName' | 'name' | 'description' | 'website' | 'phoneNumber' | 'phoneNumberExtension' | 'contactName' | 'email' | 'logo' | 'primaryContactName' | 'primaryContactTitle' | 'primaryContactEmail' | 'primaryContactPhoneNumber' | 'primaryContactPhoneNumberExtension' | 'cpaAdminCompanyAdminContactTitle' | 'cpaAdminCompanyAdminContactNumber' | 'cpaAdminCompanyAdminContactNumberExtension' | 'cpaEmployeeAdoptionContactName' | 'cpaEmployeeAdoptionContactEmail' | 'cpaEmployeeAdoptionContactTitle' | 'cpaEmployeeAdoptionContactNumber' | 'cpaEmployeeAdoptionContactNumberExtension' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'googleReviewLink' | 'showInApp' | 'hideAddressFromDirectory' | 'isSuspended'>
    & { customContacts?: Maybe<Array<(
      { __typename?: 'CustomContactReturn' }
      & Pick<CustomContactReturn, 'id' | 'name' | 'email' | 'jobTitle' | 'phoneNumber' | 'phoneNumberExtension'>
    )>>, banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>>, address: (
      { __typename?: 'AddressReturn' }
      & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
    ) }
  ) }
);

export type UpdateDiscountMutationVariables = Exact<{
  id: Scalars['String'];
  input: DiscountInput;
}>;


export type UpdateDiscountMutation = (
  { __typename?: 'Mutation' }
  & { updateDiscount: (
    { __typename?: 'UpdateDiscountReturn' }
    & Pick<UpdateDiscountReturn, 'id'>
  ) }
);

export type UpdateLoggedInUserLanguageMutationVariables = Exact<{
  languageCode: LanguageCodeEnum;
}>;


export type UpdateLoggedInUserLanguageMutation = (
  { __typename?: 'Mutation' }
  & { updateLoggedInUserLanguage: (
    { __typename?: 'UpdateLoggedInUserLanguageMutationReturn' }
    & Pick<UpdateLoggedInUserLanguageMutationReturn, 'updated'>
  ) }
);

export type UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutationVariables = Exact<{
  activationId: Scalars['String'];
  newActivationFeeInDollars: Scalars['Float'];
}>;


export type UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation = (
  { __typename?: 'Mutation' }
  & { updateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivation: (
    { __typename?: 'UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationReturn' }
    & Pick<UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationReturn, 'updated'>
  ) }
);

export type UpdateMyCmpMemberEventAttendeesMutationVariables = Exact<{
  input: UpdateMyCmpMemberEventAttendeesInput;
}>;


export type UpdateMyCmpMemberEventAttendeesMutation = (
  { __typename?: 'Mutation' }
  & { updateMyCmpMemberEventAttendees: (
    { __typename?: 'CmpMyMemberEventRegistrationReturn' }
    & CmpMyMemberEventRegistrationFragment
  ) }
);

export type UpdatePerkPartnerDiscountMutationVariables = Exact<{
  id: Scalars['String'];
  input: PerkPartnerDiscountInput;
}>;


export type UpdatePerkPartnerDiscountMutation = (
  { __typename?: 'Mutation' }
  & { updatePerkPartnerDiscount: (
    { __typename?: 'UpdatePerkPartnerDiscountReturn' }
    & Pick<UpdatePerkPartnerDiscountReturn, 'id'>
  ) }
);

export type UpdateRewardCampaignMutationVariables = Exact<{
  id: Scalars['String'];
  input: RewardCampaignInput;
}>;


export type UpdateRewardCampaignMutation = (
  { __typename?: 'Mutation' }
  & { updateRewardCampaign: (
    { __typename?: 'UpdateRewardCampaignMutationReturn' }
    & Pick<UpdateRewardCampaignMutationReturn, 'campaignUpdatedSuccessfully'>
  ) }
);

export type UpdateShopLocalCampaignMutationVariables = Exact<{
  id: Scalars['String'];
  input: ShopLocalCampaignInput;
}>;


export type UpdateShopLocalCampaignMutation = (
  { __typename?: 'Mutation' }
  & { updateShopLocalCampaign: (
    { __typename?: 'UpdateShopLocalCampaignReturn' }
    & Pick<UpdateShopLocalCampaignReturn, 'shopLocalCampaignUpdatedSuccessfully'>
  ) }
);

export type GetActiveCategoryAdvertisingBannersForChamberMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveCategoryAdvertisingBannersForChamberMemberQuery = (
  { __typename?: 'Query' }
  & { getActiveCategoryAdvertisingBannersForChamberMember?: Maybe<Array<(
    { __typename?: 'CategoryAdvertisingBannerReturn' }
    & Pick<CategoryAdvertisingBannerReturn, 'categoryId'>
    & { bannerSettings?: Maybe<(
      { __typename?: 'CategoryAdvertisingBannerSettingsReturn' }
      & { activationInfo: (
        { __typename?: 'CategoryAdvertisingBannerActivationInfoReturn' }
        & Pick<CategoryAdvertisingBannerActivationInfoReturn, 'chamberMemberId' | 'activationStartDateUtcMilli' | 'chamberMemberHasAcceptedAgreement' | 'chamberMemberAcceptedAgreementVersion' | 'autoApproveBannerContentUpdate'>
        & { banner?: Maybe<Array<(
          { __typename?: 'BannerReturn' }
          & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position' | 'waitingForApprovalByChamberAdmin'>
        )>> }
      ) }
    )> }
  )>> }
);

export type GetActiveShopLocalCampaignForChamberMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveShopLocalCampaignForChamberMemberQuery = (
  { __typename?: 'Query' }
  & { getActiveShopLocalCampaignForChamber?: Maybe<(
    { __typename?: 'ShopLocalCampaignReturn' }
    & Pick<ShopLocalCampaignReturn, 'id' | 'chamberId' | 'campaignName' | 'prizeDescription' | 'startDateUtcMilli' | 'endDateUtcMilli' | 'createdAtUtcMilli' | 'updatedAtUtcMilli'>
    & { participatingMembers: Array<(
      { __typename?: 'ShopLocalCampaignParticipatingMembersReturn' }
      & Pick<ShopLocalCampaignParticipatingMembersReturn, 'memberId' | 'participationCode'>
    )> }
  )> }
);

export type GetAdminConsoleLoginEmailForChamberQueryVariables = Exact<{
  chamberId: Scalars['String'];
}>;


export type GetAdminConsoleLoginEmailForChamberQuery = (
  { __typename?: 'Query' }
  & { getAdminConsoleLoginEmailForChamber: (
    { __typename?: 'AdminConsoleLoginEmailReturn' }
    & Pick<AdminConsoleLoginEmailReturn, 'adminConsoleLoginEmail'>
  ) }
);

export type GetAdminConsoleLoginEmailForChamberMemberQueryVariables = Exact<{
  chamberMemberId: Scalars['String'];
}>;


export type GetAdminConsoleLoginEmailForChamberMemberQuery = (
  { __typename?: 'Query' }
  & { getAdminConsoleLoginEmailForChamberMember: (
    { __typename?: 'AdminConsoleLoginEmailReturn' }
    & Pick<AdminConsoleLoginEmailReturn, 'adminConsoleLoginEmail' | 'memberDashboardLoginsBelongToContacts'>
  ) }
);

export type GetAffinityProgramPartnerQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAffinityProgramPartnerQuery = (
  { __typename?: 'Query' }
  & { getAffinityProgramPartner: (
    { __typename?: 'AffinityProgramPartnerReturn' }
    & Pick<AffinityProgramPartnerReturn, 'id' | 'chamberId' | 'companyName' | 'title' | 'description' | 'redirectLink' | 'logo' | 'activationStatus' | 'activationStartDateUtcMilli' | 'activationEndDateUtcMilli' | 'daysUntilExpiration' | 'createdAtUtcMilli' | 'updatedAtUtcMilli'>
    & { banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>>, activationInfo?: Maybe<(
      { __typename?: 'AffinityProgramPartnerActivationInfoReturn' }
      & Pick<AffinityProgramPartnerActivationInfoReturn, 'activationStartDateUtcMilli' | 'activationEndDateUtcMilli' | 'activationFeeInDollarsAtTimeOfActivation'>
    )>, reactivationInfo?: Maybe<(
      { __typename?: 'AffinityProgramPartnerActivationInfoReturn' }
      & Pick<AffinityProgramPartnerActivationInfoReturn, 'activationStartDateUtcMilli' | 'activationEndDateUtcMilli' | 'activationFeeInDollarsAtTimeOfActivation'>
    )> }
  ) }
);

export type GetAffinityProgramPartnerStatsQueryVariables = Exact<{
  id: Scalars['String'];
  inquiryLimit?: Maybe<Scalars['Float']>;
  inquiryNextToken?: Maybe<Scalars['String']>;
}>;


export type GetAffinityProgramPartnerStatsQuery = (
  { __typename?: 'Query' }
  & { getAffinityProgramPartnerStats: (
    { __typename?: 'AffinityProgramPartnerStatReturn' }
    & Pick<AffinityProgramPartnerStatReturn, 'id' | 'totalViewCount' | 'totalIneligibleViewCount' | 'totalUnverifiedViewCount' | 'totalVerifiedViewCount' | 'totalMemberViewCount' | 'totalNonMemberViewCount' | 'totalOpenCount' | 'totalIneligibleOpenCount' | 'totalUnverifiedOpenCount' | 'totalVerifiedOpenCount' | 'totalMemberOpenCount' | 'totalNonMemberOpenCount' | 'totalOpensFromViewsConversionRatePercentage' | 'totalRedirectCount' | 'totalIneligibleRedirectCount' | 'totalUnverifiedRedirectCount' | 'totalVerifiedRedirectCount' | 'totalMemberRedirectCount' | 'totalNonMemberRedirectCount' | 'totalRedirectCountFromOpensConversionRatePercentage' | 'totalInquirySubmissionCount' | 'displayInquirySubmissionCount' | 'inquirySubmissionCountIsDemo' | 'inquiriesReturnedCount' | 'inquiriesNextToken'>
    & { inquiries: Array<(
      { __typename?: 'AffinityProgramPartnerInquiryReturn' }
      & Pick<AffinityProgramPartnerInquiryReturn, 'id' | 'fullName' | 'email' | 'employerName' | 'createdAtUtcMilli' | 'emailDeliveryStatus'>
    )>, splitByChamber?: Maybe<Array<(
      { __typename?: 'AffinityProgramPartnerStatSplitByChamberReturn' }
      & Pick<AffinityProgramPartnerStatSplitByChamberReturn, 'chamberId' | 'chamberName' | 'chamberIsEnabledForAffinityProgramPartner' | 'totalViewCount' | 'ineligibleViewCount' | 'unverifiedViewCount' | 'verifiedViewCount' | 'memberViewCount' | 'nonMemberViewCount' | 'totalOpenCount' | 'ineligibleOpenCount' | 'unverifiedOpenCount' | 'verifiedOpenCount' | 'memberOpenCount' | 'nonMemberOpenCount' | 'totalRedirectCount' | 'ineligibleRedirectCount' | 'unverifiedRedirectCount' | 'verifiedRedirectCount' | 'memberRedirectCount' | 'nonMemberRedirectCount'>
    )>>, timeseriesData?: Maybe<(
      { __typename?: 'AffinityProgramPartnerTimeseriesDataReturn' }
      & { allChambers: (
        { __typename?: 'AffinityProgramPartnerTimeseriesDataset' }
        & Pick<AffinityProgramPartnerTimeseriesDataset, 'id' | 'name'>
        & { timeseriesData: Array<(
          { __typename?: 'AffinityProgramPartnerTimeseriesDataPoint' }
          & Pick<AffinityProgramPartnerTimeseriesDataPoint, 'monthAndYear' | 'totalOpenCount' | 'totalViewCount' | 'totalRedirectCount'>
        )> }
      ), chambers: Array<(
        { __typename?: 'AffinityProgramPartnerTimeseriesDataset' }
        & Pick<AffinityProgramPartnerTimeseriesDataset, 'id' | 'name'>
        & { timeseriesData: Array<(
          { __typename?: 'AffinityProgramPartnerTimeseriesDataPoint' }
          & Pick<AffinityProgramPartnerTimeseriesDataPoint, 'monthAndYear' | 'totalOpenCount' | 'totalViewCount' | 'totalRedirectCount'>
        )> }
      )> }
    )> }
  ) }
);

export type GetAllAdminUsersForPerkPartnerDiscountQueryVariables = Exact<{
  perkPartnerDiscountId: Scalars['String'];
}>;


export type GetAllAdminUsersForPerkPartnerDiscountQuery = (
  { __typename?: 'Query' }
  & { getAllAdminUsersForPerkPartnerDiscount?: Maybe<Array<(
    { __typename?: 'PerkPartnerDiscountAdminUserReturn' }
    & Pick<PerkPartnerDiscountAdminUserReturn, 'id' | 'email' | 'perkPartnerDiscountId' | 'adminConsoleLoginEmail' | 'createdAtUtcMilli' | 'updatedAtUtcMilli'>
  )>> }
);

export type GetAllAffinityProgramPartnersForChamberQueryVariables = Exact<{
  chamberId?: Maybe<Scalars['String']>;
}>;


export type GetAllAffinityProgramPartnersForChamberQuery = (
  { __typename?: 'Query' }
  & { getAllAffinityProgramPartnersForChamber?: Maybe<Array<(
    { __typename?: 'AffinityProgramPartnerReturn' }
    & Pick<AffinityProgramPartnerReturn, 'id' | 'chamberId' | 'companyName' | 'title' | 'description' | 'redirectLink' | 'logo' | 'appPlacementOrder' | 'activationStatus' | 'activationStartDateUtcMilli' | 'activationEndDateUtcMilli' | 'daysUntilExpiration' | 'createdAtUtcMilli' | 'updatedAtUtcMilli'>
    & { banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>>, reactivationInfo?: Maybe<(
      { __typename?: 'AffinityProgramPartnerActivationInfoReturn' }
      & Pick<AffinityProgramPartnerActivationInfoReturn, 'activationStartDateUtcMilli' | 'activationEndDateUtcMilli'>
    )> }
  )>> }
);

export type GetAllCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCategoriesQuery = (
  { __typename?: 'Query' }
  & { getAllCategories?: Maybe<Array<(
    { __typename?: 'CategoryReturn' }
    & Pick<CategoryReturn, 'id' | 'name'>
  )>> }
);

export type GetAllCategoryAdvertisingBannersForChamberQueryVariables = Exact<{
  chamberId?: Maybe<Scalars['String']>;
}>;


export type GetAllCategoryAdvertisingBannersForChamberQuery = (
  { __typename?: 'Query' }
  & { getAllCategoryAdvertisingBannersForChamber: (
    { __typename?: 'AllCategoryAdvertisingBannersForChamberReturn' }
    & Pick<AllCategoryAdvertisingBannersForChamberReturn, 'id' | 'chamberId' | 'createdAtUtcMilli' | 'updatedAtUtcMilli'>
    & { categoryAdvertisingBanners: Array<(
      { __typename?: 'CategoryAdvertisingBannerReturn' }
      & Pick<CategoryAdvertisingBannerReturn, 'categoryId'>
      & { bannerSettings?: Maybe<(
        { __typename?: 'CategoryAdvertisingBannerSettingsReturn' }
        & { activationInfo: (
          { __typename?: 'CategoryAdvertisingBannerActivationInfoReturn' }
          & Pick<CategoryAdvertisingBannerActivationInfoReturn, 'chamberMemberId' | 'activationStartDateUtcMilli' | 'categoryAdvertisingBannersActivationFeeCpaSplitPercentageSetAtActivationTime' | 'autoApproveBannerContentUpdate'>
          & { banner?: Maybe<Array<(
            { __typename?: 'BannerReturn' }
            & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position' | 'waitingForApprovalByChamberAdmin'>
          )>>, bannerFeeOptionSetAtActivationTime: (
            { __typename?: 'CategoryAdvertisingBannersFeeOptionsReturn' }
            & Pick<CategoryAdvertisingBannersFeeOptionsReturn, 'timeLengthInMonths' | 'bannerFeeInDollars'>
          ) }
        ), reactivationInfo?: Maybe<(
          { __typename?: 'CategoryAdvertisingBannerActivationInfoReturn' }
          & Pick<CategoryAdvertisingBannerActivationInfoReturn, 'chamberMemberId' | 'activationStartDateUtcMilli' | 'categoryAdvertisingBannersActivationFeeCpaSplitPercentageSetAtActivationTime'>
          & { banner?: Maybe<Array<(
            { __typename?: 'BannerReturn' }
            & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position' | 'waitingForApprovalByChamberAdmin'>
          )>>, bannerFeeOptionSetAtActivationTime: (
            { __typename?: 'CategoryAdvertisingBannersFeeOptionsReturn' }
            & Pick<CategoryAdvertisingBannersFeeOptionsReturn, 'timeLengthInMonths' | 'bannerFeeInDollars'>
          ) }
        )> }
      )> }
    )> }
  ) }
);

export type GetAllChamberEngageInvoiceDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllChamberEngageInvoiceDataQuery = (
  { __typename?: 'Query' }
  & { getAllChamberEngageInvoiceData?: Maybe<Array<(
    { __typename?: 'ChamberEngageMonthlyInvoiceDataReturn' }
    & Pick<ChamberEngageMonthlyInvoiceDataReturn, 'year' | 'monthNum' | 'totalActivationFeeInDollars' | 'allInvoicesSentInMonth'>
    & { chamberData?: Maybe<Array<(
      { __typename?: 'ChamberEngageMonthlyInvoiceChamberDataReturn' }
      & Pick<ChamberEngageMonthlyInvoiceChamberDataReturn, 'chamberId' | 'chamberName' | 'memberProfileAndPerksBannersActivated' | 'memberProfileAndPerksBannersTotalActivationFeeInDollars' | 'categoryAdvertisingActivated' | 'categoryAdvertisingTotalActivationFeeInDollars' | 'allInvoicesSentForChamberInMonth'>
      & { activations?: Maybe<Array<(
        { __typename?: 'ChamberEngageMonthlyInvoiceIndividualActivationDataReturn' }
        & Pick<ChamberEngageMonthlyInvoiceIndividualActivationDataReturn, 'activationId' | 'chamberMemberId' | 'chamberMemberName' | 'activationType' | 'activationLengthInMonths' | 'activationFeeInDollars' | 'includeInInvoice' | 'invoiceSentAtUtcMilli' | 'categoryAdvertisingCategoryId'>
      )>> }
    )>> }
  )>> }
);

export type GetAllChamberMembersQueryVariables = Exact<{
  chamberId: Scalars['String'];
  getHasSignedUp?: Maybe<Scalars['Boolean']>;
  getNumberOfUsers?: Maybe<Scalars['Boolean']>;
}>;


export type GetAllChamberMembersQuery = (
  { __typename?: 'Query' }
  & { getAllChamberMembers?: Maybe<Array<(
    { __typename?: 'ChamberMemberReturn' }
    & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'categoryId' | 'credentialsSentAtUtcMilli' | 'adminConsoleContactName' | 'name' | 'description' | 'website' | 'phoneNumber' | 'phoneNumberExtension' | 'contactName' | 'email' | 'logo' | 'primaryContactName' | 'primaryContactTitle' | 'primaryContactEmail' | 'primaryContactPhoneNumber' | 'primaryContactPhoneNumberExtension' | 'cpaAdminCompanyAdminContactTitle' | 'cpaAdminCompanyAdminContactNumber' | 'cpaAdminCompanyAdminContactNumberExtension' | 'cpaEmployeeAdoptionContactName' | 'cpaEmployeeAdoptionContactEmail' | 'cpaEmployeeAdoptionContactTitle' | 'cpaEmployeeAdoptionContactNumber' | 'cpaEmployeeAdoptionContactNumberExtension' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'googleReviewLink' | 'showInApp' | 'hideAddressFromDirectory' | 'hasSignedUp' | 'firstLoginAfterSettingNewPermanentPasswordUtcMilli' | 'numberOfUsers' | 'adminConsoleLoginEmail' | 'createdAtUtcMilli' | 'isSuspended' | 'lifecycleStatus'>
    & { customContacts?: Maybe<Array<(
      { __typename?: 'CustomContactReturn' }
      & Pick<CustomContactReturn, 'id' | 'name' | 'email' | 'jobTitle' | 'phoneNumber' | 'phoneNumberExtension'>
    )>>, banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>>, activeMemberProfileAndPerksBannersSettings?: Maybe<(
      { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn' }
      & { activationInfo: (
        { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn' }
        & Pick<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn, 'startDateUtcMilli' | 'chamberMemberHasAcceptedAgreement'>
      ) }
    )>, address: (
      { __typename?: 'AddressReturn' }
      & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
    ), cmpExtension?: Maybe<{ __typename: 'CmpMemberExtensionReturn' }> }
  )>> }
);

export type GetAllChamberMembers_RootAndChamberAdminOnlyQueryVariables = Exact<{
  chamberId: Scalars['String'];
}>;


export type GetAllChamberMembers_RootAndChamberAdminOnlyQuery = (
  { __typename?: 'Query' }
  & { getAllChamberMembers?: Maybe<Array<(
    { __typename?: 'ChamberMemberReturn' }
    & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'categoryId' | 'credentialsSentAtUtcMilli' | 'adminConsoleContactName' | 'name' | 'description' | 'website' | 'phoneNumber' | 'contactName' | 'email' | 'logo' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'googleReviewLink' | 'youtube' | 'showInApp' | 'hasSignedUp' | 'numberOfUsers' | 'adminConsoleLoginEmail' | 'createdAtUtcMilli' | 'isSuspended'>
    & { customContacts?: Maybe<Array<(
      { __typename?: 'CustomContactReturn' }
      & Pick<CustomContactReturn, 'id' | 'name' | 'email' | 'jobTitle' | 'phoneNumber'>
    )>>, banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>>, address: (
      { __typename?: 'AddressReturn' }
      & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
    ), activeMemberProfileAndPerksBannersSettings?: Maybe<(
      { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn' }
      & { activationInfo: (
        { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn' }
        & Pick<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn, 'startDateUtcMilli' | 'memberProfileAndPerkBannerActivationFeeInDollarsAtTimeOfActivation' | 'memberProfileAndPerkBannerAnnualBannerFeeInDollarsAtTimeOfActivation' | 'chamberMemberHasAcceptedAgreement'>
      ), reactivationInfo?: Maybe<(
        { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn' }
        & Pick<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn, 'startDateUtcMilli' | 'memberProfileAndPerkBannerActivationFeeInDollarsAtTimeOfActivation' | 'memberProfileAndPerkBannerAnnualBannerFeeInDollarsAtTimeOfActivation' | 'chamberMemberHasAcceptedAgreement'>
      )> }
    )> }
  )>> }
);

export type GetAllChambersQueryVariables = Exact<{
  getAllSandbox?: Maybe<Scalars['Boolean']>;
}>;


export type GetAllChambersQuery = (
  { __typename?: 'Query' }
  & { getAllChambers?: Maybe<Array<(
    { __typename?: 'ChamberReturn' }
    & Pick<ChamberReturn, 'id' | 'name' | 'website' | 'supportContactEmail' | 'googleMapsApi_City_ProvinceShort_CountryShort' | 'supportContactName' | 'supportLink' | 'phoneNumber' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'jobPostingLink' | 'eventsLink' | 'newsletterLink' | 'surveyLink' | 'advocacyWinsLink' | 'callForNominationsLink' | 'memberSignupLink' | 'sponsorLogo' | 'sponsorLogoLink' | 'logo' | 'numberOfMembersFromInitialSubscriptionAgreement' | 'description' | 'createdAtUtcMilli' | 'subscriptionDate' | 'hideInApp' | 'isSandbox'>
    & { address: (
      { __typename?: 'AddressReturn' }
      & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
    ) }
  )>> }
);

export type GetAllChambersForRootAdminChamberEngageQueryVariables = Exact<{
  getAllSandbox?: Maybe<Scalars['Boolean']>;
}>;


export type GetAllChambersForRootAdminChamberEngageQuery = (
  { __typename?: 'Query' }
  & { getAllChambers?: Maybe<Array<(
    { __typename?: 'ChamberReturn' }
    & Pick<ChamberReturn, 'id' | 'name' | 'website' | 'supportContactEmail' | 'googleMapsApi_City_ProvinceShort_CountryShort' | 'supportContactName' | 'supportLink' | 'phoneNumber' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'jobPostingLink' | 'eventsLink' | 'newsletterLink' | 'surveyLink' | 'advocacyWinsLink' | 'callForNominationsLink' | 'memberSignupLink' | 'sponsorLogo' | 'sponsorLogoLink' | 'logo' | 'numberOfMembersFromInitialSubscriptionAgreement' | 'description' | 'createdAtUtcMilli' | 'subscriptionDate' | 'hideInApp'>
    & { address: (
      { __typename?: 'AddressReturn' }
      & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
    ), chamberEngageSettings: (
      { __typename?: 'ChamberEngageSettingsReturn' }
      & Pick<ChamberEngageSettingsReturn, 'isActive' | 'memberProfileAndPerkBannerActivationFeeInDollars' | 'memberProfileAndPerkBannerAnnualBannerFeeInDollars' | 'categoryAdvertisingBannersActivationFeeCpaSplitPercentage'>
      & { categoryAdvertisingBannersFeeOptions: Array<(
        { __typename?: 'CategoryAdvertisingBannersFeeOptionsReturn' }
        & Pick<CategoryAdvertisingBannersFeeOptionsReturn, 'timeLengthInMonths' | 'bannerFeeInDollars'>
      )> }
    ) }
  )>> }
);

export type GetAllChambersForRootChamberListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllChambersForRootChamberListQuery = (
  { __typename?: 'Query' }
  & { getAllChambers?: Maybe<Array<(
    { __typename?: 'ChamberReturn' }
    & Pick<ChamberReturn, 'id' | 'name' | 'logo' | 'hideInApp' | 'isSandbox'>
  )>> }
);

export type GetAllContactableCompaniesForChamberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllContactableCompaniesForChamberQuery = (
  { __typename?: 'Query' }
  & { getAllContactableCompaniesForChamber?: Maybe<Array<(
    { __typename?: 'ContactableCompanyReturn' }
    & Pick<ContactableCompanyReturn, 'id' | 'chamberId' | 'chamberName' | 'name' | 'createdAtUtcMilli'>
  )>> }
);

export type GetAllDeletedDiscountsFromChamberIdQueryVariables = Exact<{
  chamberId: Scalars['String'];
}>;


export type GetAllDeletedDiscountsFromChamberIdQuery = (
  { __typename?: 'Query' }
  & { getAllDeletedDiscountsFromChamberId?: Maybe<Array<(
    { __typename?: 'DeletedDiscountReturn' }
    & Pick<DeletedDiscountReturn, 'id' | 'title' | 'description' | 'chamberId' | 'chamberMemberId' | 'memberOnly' | 'isAvailableToAllMembers' | 'isReoccuring' | 'daysAvailable' | 'monthsAvailable' | 'isPrivate' | 'views' | 'numberOfRedemptions' | 'createdAtUtcMilli' | 'deletedAtUtcMilli'>
    & { chamberInfo: (
      { __typename?: 'ChamberReturn' }
      & Pick<ChamberReturn, 'id' | 'name' | 'website' | 'supportContactEmail' | 'googleMapsApi_City_ProvinceShort_CountryShort' | 'supportContactName' | 'supportLink' | 'phoneNumber' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'jobPostingLink' | 'eventsLink' | 'newsletterLink' | 'surveyLink' | 'advocacyWinsLink' | 'callForNominationsLink' | 'memberSignupLink' | 'sponsorLogo' | 'sponsorLogoLink' | 'description' | 'logo' | 'hideInApp'>
      & { address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ) }
    ), chamberMemberInfo: (
      { __typename?: 'ChamberMemberReturn' }
      & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'categoryId' | 'credentialsSentAtUtcMilli' | 'adminConsoleContactName' | 'name' | 'description' | 'website' | 'phoneNumber' | 'contactName' | 'email' | 'logo' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'googleReviewLink' | 'youtube' | 'showInApp' | 'isSuspended'>
      & { customContacts?: Maybe<Array<(
        { __typename?: 'CustomContactReturn' }
        & Pick<CustomContactReturn, 'id' | 'name' | 'email' | 'jobTitle' | 'phoneNumber'>
      )>>, banner?: Maybe<Array<(
        { __typename?: 'BannerReturn' }
        & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
      )>>, activeMemberProfileAndPerksBannersSettings?: Maybe<(
        { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn' }
        & { activationInfo: (
          { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn' }
          & Pick<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn, 'startDateUtcMilli' | 'chamberMemberHasAcceptedAgreement'>
        ) }
      )>, address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ) }
    ) }
  )>> }
);

export type GetAllDeletedPerkPartnerDiscountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDeletedPerkPartnerDiscountsQuery = (
  { __typename?: 'Query' }
  & { getAllDeletedPerkPartnerDiscounts?: Maybe<Array<(
    { __typename?: 'DeletedPerkPartnerDiscountReturn' }
    & Pick<DeletedPerkPartnerDiscountReturn, 'id' | 'companyName' | 'title' | 'description' | 'verifiedChamberMemberCapUserRedirectLink' | 'unverifiedChamberMemberCapUserRedirectLink' | 'logo' | 'availableToChamberIds' | 'createdAtUtcMilli' | 'updatedAtUtcMilli' | 'deletedAtUtcMilli'>
    & { banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>> }
  )>> }
);

export type GetAllDiscountsFromChamberIdQueryVariables = Exact<{
  chamberId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  localDay?: Maybe<DayEnum>;
  localMonth?: Maybe<MonthEnum>;
}>;


export type GetAllDiscountsFromChamberIdQuery = (
  { __typename?: 'Query' }
  & { getAllDiscountsFromChamberId?: Maybe<Array<(
    { __typename?: 'DiscountReturn' }
    & Pick<DiscountReturn, 'id' | 'title' | 'description' | 'chamberId' | 'chamberMemberId' | 'memberOnly' | 'isAvailableToAllMembers' | 'isReoccuring' | 'daysAvailable' | 'monthsAvailable' | 'isPrivate' | 'views' | 'numberOfRedemptions' | 'createdAtUtcMilli'>
    & { chamberInfo: (
      { __typename?: 'ChamberReturn' }
      & Pick<ChamberReturn, 'id' | 'name' | 'website' | 'supportContactEmail' | 'googleMapsApi_City_ProvinceShort_CountryShort' | 'supportContactName' | 'supportLink' | 'phoneNumber' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'jobPostingLink' | 'eventsLink' | 'newsletterLink' | 'surveyLink' | 'advocacyWinsLink' | 'callForNominationsLink' | 'memberSignupLink' | 'sponsorLogo' | 'sponsorLogoLink' | 'description' | 'logo' | 'hideInApp'>
      & { address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ) }
    ), chamberMemberInfo: (
      { __typename?: 'ChamberMemberReturn' }
      & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'categoryId' | 'credentialsSentAtUtcMilli' | 'adminConsoleContactName' | 'name' | 'description' | 'website' | 'phoneNumber' | 'contactName' | 'email' | 'logo' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'googleReviewLink' | 'youtube' | 'showInApp' | 'isSuspended'>
      & { customContacts?: Maybe<Array<(
        { __typename?: 'CustomContactReturn' }
        & Pick<CustomContactReturn, 'id' | 'name' | 'email' | 'jobTitle' | 'phoneNumber'>
      )>>, banner?: Maybe<Array<(
        { __typename?: 'BannerReturn' }
        & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
      )>>, activeMemberProfileAndPerksBannersSettings?: Maybe<(
        { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn' }
        & { activationInfo: (
          { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn' }
          & Pick<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn, 'startDateUtcMilli' | 'chamberMemberHasAcceptedAgreement'>
        ) }
      )>, address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ) }
    ), redeemSettings: (
      { __typename?: 'RedeemSettingsReturn' }
      & Pick<RedeemSettingsReturn, 'whereToRedeem'>
    ) }
  )>> }
);

export type GetAllDiscountsFromChamberMemberIdQueryVariables = Exact<{
  chamberMemberId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  localDay?: Maybe<DayEnum>;
  localMonth?: Maybe<MonthEnum>;
}>;


export type GetAllDiscountsFromChamberMemberIdQuery = (
  { __typename?: 'Query' }
  & { getAllDiscountsFromChamberMemberId?: Maybe<Array<(
    { __typename?: 'DiscountReturn' }
    & Pick<DiscountReturn, 'id' | 'title' | 'description' | 'chamberId' | 'chamberMemberId' | 'memberOnly' | 'isAvailableToAllMembers' | 'isReoccuring' | 'daysAvailable' | 'monthsAvailable' | 'isPrivate' | 'privateEmails' | 'startTimeUtcMilli' | 'expiryTimeUtcMilli' | 'numberOfRedemptions' | 'views' | 'createdAtUtcMilli'>
    & { chamberInfo: (
      { __typename?: 'ChamberReturn' }
      & Pick<ChamberReturn, 'id' | 'name' | 'website' | 'supportContactEmail' | 'googleMapsApi_City_ProvinceShort_CountryShort' | 'supportContactName' | 'supportLink' | 'phoneNumber' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'jobPostingLink' | 'eventsLink' | 'newsletterLink' | 'surveyLink' | 'advocacyWinsLink' | 'callForNominationsLink' | 'memberSignupLink' | 'sponsorLogo' | 'sponsorLogoLink' | 'description' | 'logo' | 'hideInApp'>
      & { address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ) }
    ), chamberMemberInfo: (
      { __typename?: 'ChamberMemberReturn' }
      & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'categoryId' | 'credentialsSentAtUtcMilli' | 'adminConsoleContactName' | 'name' | 'description' | 'website' | 'phoneNumber' | 'contactName' | 'email' | 'logo' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'googleReviewLink' | 'youtube' | 'showInApp' | 'isSuspended'>
      & { customContacts?: Maybe<Array<(
        { __typename?: 'CustomContactReturn' }
        & Pick<CustomContactReturn, 'id' | 'name' | 'email' | 'jobTitle' | 'phoneNumber'>
      )>>, banner?: Maybe<Array<(
        { __typename?: 'BannerReturn' }
        & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
      )>>, activeMemberProfileAndPerksBannersSettings?: Maybe<(
        { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn' }
        & { activationInfo: (
          { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn' }
          & Pick<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn, 'startDateUtcMilli' | 'chamberMemberHasAcceptedAgreement'>
        ) }
      )>, address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ) }
    ), redeemSettings: (
      { __typename?: 'RedeemSettingsReturn' }
      & Pick<RedeemSettingsReturn, 'whereToRedeem'>
      & { howToRedeem?: Maybe<(
        { __typename?: 'HowToRedeemReturn' }
        & Pick<HowToRedeemReturn, 'code' | 'websiteToEnterCodeAt' | 'contactEmail' | 'contactNumber' | 'contactName'>
      )> }
    ), banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>> }
  )>> }
);

export type GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQueryVariables = Exact<{
  chamberId: Scalars['String'];
}>;


export type GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery = (
  { __typename?: 'Query' }
  & { getChamber: (
    { __typename?: 'ChamberReturn' }
    & Pick<ChamberReturn, 'id' | 'allMemberLoginCredentialSuccessfulDownloadTimestampUtcMilli'>
  ) }
);

export type GetAllMemberLoginCredentialsQueryVariables = Exact<{
  processId: Scalars['String'];
}>;


export type GetAllMemberLoginCredentialsQuery = (
  { __typename?: 'Query' }
  & { getAllMemberLoginCredentials: (
    { __typename?: 'GetAllMemberLoginCredentialsReturn' }
    & Pick<GetAllMemberLoginCredentialsReturn, 'status' | 'successCSVRawTextOfAllMemberLoginCredentials'>
  ) }
);

export type GetAllMemberMassSendLoginCredentialTimestampUtcMilliQueryVariables = Exact<{
  chamberId: Scalars['String'];
}>;


export type GetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery = (
  { __typename?: 'Query' }
  & { getChamber: (
    { __typename?: 'ChamberReturn' }
    & Pick<ChamberReturn, 'id' | 'allMemberMassSendLoginCredentialTimestampUtcMilli'>
  ) }
);

export type GetAllPerkPartnerDiscountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPerkPartnerDiscountsQuery = (
  { __typename?: 'Query' }
  & { getAllPerkPartnerDiscounts?: Maybe<Array<(
    { __typename?: 'PerkPartnerDiscountReturn' }
    & Pick<PerkPartnerDiscountReturn, 'id' | 'companyName' | 'title' | 'description' | 'verifiedChamberMemberCapUserRedirectLink' | 'unverifiedChamberMemberCapUserRedirectLink' | 'logo' | 'availableToChamberIds' | 'createdAtUtcMilli' | 'updatedAtUtcMilli'>
    & { availableToChambers?: Maybe<Array<(
      { __typename?: 'RootAdminPerkPartnerDiscountAvailableToChambersReturn' }
      & Pick<RootAdminPerkPartnerDiscountAvailableToChambersReturn, 'id' | 'name'>
    )>>, banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>> }
  )>> }
);

export type GetAllPerksLinksForChamberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPerksLinksForChamberQuery = (
  { __typename?: 'Query' }
  & { getAllPerksLinksForChamber: Array<(
    { __typename?: 'PerksLinkReturn' }
    & Pick<PerksLinkReturn, 'chamberId' | 'chamberName' | 'chamberContactEmail' | 'chamberContactNumber'>
    & { pendingOrAcceptedPerksLinkRequestInfo?: Maybe<(
      { __typename?: 'PerksLinkRequestReturn' }
      & Pick<PerksLinkRequestReturn, 'id' | 'status' | 'requestorChamberId' | 'requesteeChamberId' | 'linkedAtTimeUtcMilli' | 'createdAtUtcMilli'>
    )> }
  )> }
);

export type GetAllRewardCampaignsForChamberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRewardCampaignsForChamberQuery = (
  { __typename?: 'Query' }
  & { getAllRewardCampaignsForChamber?: Maybe<Array<(
    { __typename?: 'RewardCampaignReturn' }
    & Pick<RewardCampaignReturn, 'id' | 'chamberId' | 'sponsoringChamberMemberId' | 'campaignName' | 'prizeDescription' | 'startDateUtcMilli' | 'endDateUtcMilli' | 'createdAtUtcMilli' | 'updatedAtUtcMilli' | 'isCreatedByCpaAdmin'>
    & { prizeDrawParticipants?: Maybe<Array<(
      { __typename?: 'PrizeDrawParticipantReturn' }
      & Pick<PrizeDrawParticipantReturn, 'email' | 'ballotsEarned'>
    )>> }
  )>> }
);

export type GetAllShopLocalCampaignsForChamberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllShopLocalCampaignsForChamberQuery = (
  { __typename?: 'Query' }
  & { getAllShopLocalCampaignsForChamber?: Maybe<Array<(
    { __typename?: 'ShopLocalCampaignReturn' }
    & Pick<ShopLocalCampaignReturn, 'id' | 'chamberId' | 'campaignName' | 'prizeDescription' | 'startDateUtcMilli' | 'endDateUtcMilli' | 'participatingMemberIds' | 'status' | 'createdAtUtcMilli' | 'updatedAtUtcMilli'>
    & { participatingMembers: Array<(
      { __typename?: 'ShopLocalCampaignParticipatingMembersReturn' }
      & Pick<ShopLocalCampaignParticipatingMembersReturn, 'memberId' | 'participationCode'>
    )>, prizeDrawParticipants?: Maybe<Array<(
      { __typename?: 'ShopLocalCampaignPrizeDrawParticipantsReturn' }
      & Pick<ShopLocalCampaignPrizeDrawParticipantsReturn, 'userEmail' | 'redeemedAtMemberIds'>
    )>> }
  )>> }
);

export type GetChamberQueryVariables = Exact<{
  chamberId: Scalars['String'];
}>;


export type GetChamberQuery = (
  { __typename?: 'Query' }
  & { getChamber: (
    { __typename?: 'ChamberReturn' }
    & Pick<ChamberReturn, 'id' | 'name' | 'website' | 'supportContactEmail' | 'googleMapsApi_City_ProvinceShort_CountryShort' | 'supportContactName' | 'billingContactName' | 'billingContactEmail' | 'signingAuthorityContactName' | 'signingAuthorityContactEmail' | 'supportLink' | 'phoneNumber' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'jobPostingLink' | 'eventsLink' | 'newsletterLink' | 'surveyLink' | 'advocacyWinsLink' | 'callForNominationsLink' | 'memberSignupLink' | 'sponsorLogo' | 'sponsorLogoLink' | 'logo' | 'numberOfMembersFromInitialSubscriptionAgreement' | 'description' | 'createdAtUtcMilli' | 'hideInApp'>
    & { address: (
      { __typename?: 'AddressReturn' }
      & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
    ), directoryBanner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>>, profileBanner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>> }
  ) }
);

export type GetChamberAdminStatsQueryVariables = Exact<{
  chamberId?: Maybe<Scalars['String']>;
}>;


export type GetChamberAdminStatsQuery = (
  { __typename?: 'Query' }
  & { getChamberAdminStats: (
    { __typename?: 'ChamberAdminStatsReturn' }
    & Pick<ChamberAdminStatsReturn, 'totalChamberMembersOnApp' | 'totalMemberCompaniesFeaturedOnAppSystemWide' | 'daysRemainingUntilSubscriptionAnniversary' | 'subscriptionAnniversaryUtcMilli' | 'subscriptionDate' | 'chamberPerksOffered' | 'chamberPerkViews' | 'totalPerksOfferedOnAppSystemWide' | 'totalPerkViewsOnAppSystemWide'>
    & { membersWithNewPerkNotificationsEnabled: (
      { __typename?: 'MemberEngagementMetricWithTargetReturn' }
      & Pick<MemberEngagementMetricWithTargetReturn, 'currentValue' | 'currentPercentage' | 'targetValue' | 'targetPercentage' | 'maxValue'>
    ), membersWhoDownloadedAppAndSetUpAccount: (
      { __typename?: 'AppSignupMetricWithTargetReturn' }
      & Pick<AppSignupMetricWithTargetReturn, 'currentValue' | 'currentPercentage' | 'targetValue' | 'targetPercentage' | 'maxValue' | 'averageMonthlySignups'>
      & { monthlyData: Array<(
        { __typename?: 'MonthlyAppSignupDataReturn' }
        & Pick<MonthlyAppSignupDataReturn, 'monthAndYear' | 'appSignups'>
      )> }
    ), membersWhoLoggedIntoMemberDashboard: (
      { __typename?: 'MemberEngagementMetricWithStarsReturn' }
      & Pick<MemberEngagementMetricWithStarsReturn, 'currentValue' | 'currentPercentage' | 'targetValue' | 'targetPercentage' | 'maxValue'>
      & { starBreakdown: (
        { __typename?: 'StarBreakdownReturn' }
        & Pick<StarBreakdownReturn, 'showFirstRowThumbsUp' | 'showSecondRowThumbsUp'>
        & { firstRow: Array<(
          { __typename?: 'StarThreshold' }
          & Pick<StarThreshold, 'threshold' | 'fillPercentage'>
        )>, secondRow: Array<(
          { __typename?: 'StarThreshold' }
          & Pick<StarThreshold, 'threshold' | 'fillPercentage'>
        )> }
      ) }
    ), companyLeads: Array<(
      { __typename?: 'ContactableCompanyReturn' }
      & Pick<ContactableCompanyReturn, 'id' | 'chamberId' | 'chamberName' | 'name' | 'createdAtUtcMilli' | 'createdAtUtcTimestamp'>
    )>, numberOfPerksOffered: (
      { __typename?: 'PerkEngagementMetricWithTargetReturn' }
      & Pick<PerkEngagementMetricWithTargetReturn, 'currentValue' | 'currentPercentage' | 'targetValue' | 'targetPercentage' | 'maxValue' | 'idealTargetValue' | 'idealTargetPercentage'>
    ), numberOfMembersOfferingPerks: (
      { __typename?: 'PerkEngagementMetricWithTargetReturn' }
      & Pick<PerkEngagementMetricWithTargetReturn, 'currentValue' | 'currentPercentage' | 'targetValue' | 'targetPercentage' | 'maxValue' | 'idealTargetValue' | 'idealTargetPercentage'>
    ), perkViewKPI: (
      { __typename?: 'PerkViewKPIReturn' }
      & Pick<PerkViewKpiReturn, 'currentValue' | 'targetValue' | 'maxValue'>
    ), perkRedeemableByBreakdown: (
      { __typename?: 'PerkRedeemableByBreakdownReturn' }
      & Pick<PerkRedeemableByBreakdownReturn, 'numOfAllMemberPerks' | 'numOfLocalMemberOnlyPerks' | 'numOfGeneralPublicPerks' | 'numOfCompanyEmployeesOnlyPerks' | 'percentOfAllMemberPerks' | 'percentOfLocalMemberOnlyPerks' | 'percentOfGeneralPublicPerks' | 'percentOfCompanyEmployeesOnlyPerks'>
    ), perksCategoryBreakdown: Array<(
      { __typename?: 'PerkCategoryBreakdownItemReturn' }
      & Pick<PerkCategoryBreakdownItemReturn, 'categoryId' | 'categoryName' | 'numberOfMembers' | 'numberOfPerks' | 'actualPercentage'>
    )>, mostPopularPerks: Array<(
      { __typename?: 'PerkListItemReturn' }
      & Pick<PerkListItemReturn, 'companyName' | 'companyLogo' | 'perkTitle' | 'offeredTo' | 'views' | 'createdAtUtcMilli'>
    )>, newestPerks: Array<(
      { __typename?: 'PerkListItemReturn' }
      & Pick<PerkListItemReturn, 'companyName' | 'companyLogo' | 'perkTitle' | 'offeredTo' | 'views' | 'createdAtUtcMilli'>
    )>, downloadMilestones: Array<(
      { __typename?: 'DownloadMilestoneReturn' }
      & Pick<DownloadMilestoneReturn, 'year' | 'goalValue' | 'isFilled' | 'fillPercentage'>
    )>, perkMilestones: Array<(
      { __typename?: 'DownloadMilestoneReturn' }
      & Pick<DownloadMilestoneReturn, 'year' | 'goalValue' | 'isFilled' | 'fillPercentage'>
    )>, memberOfferingPerksMilestones: Array<(
      { __typename?: 'MemberOfferingPerksMilestoneReturn' }
      & Pick<MemberOfferingPerksMilestoneReturn, 'year' | 'goalPercentage' | 'isFilled' | 'fillPercentage'>
    )>, nonDuesRevenueBreakdown: (
      { __typename?: 'NonDuesRevenueBreakdownReturn' }
      & Pick<NonDuesRevenueBreakdownReturn, 'featuredMemberBannersSold' | 'featuredMemberBannersTotal' | 'featuredMemberRevenuePerBanner' | 'featuredMemberCurrentRevenue' | 'featuredMemberPotentialRevenue' | 'featuredMemberBannerPrice' | 'categoryBannersSold' | 'categoryBannersTotal' | 'categoryBannerRevenuePerBanner' | 'categoryBannerCurrentRevenue' | 'categoryBannerPotentialRevenue' | 'categoryBannerPrice' | 'hasTitleSponsor' | 'titleSponsorshipAmount' | 'totalCurrentRevenue' | 'totalPotentialRevenue'>
    ) }
  ) }
);

export type GetChamberForMemberLoginQueryVariables = Exact<{
  chamberId: Scalars['String'];
}>;


export type GetChamberForMemberLoginQuery = (
  { __typename?: 'Query' }
  & { getChamber: (
    { __typename?: 'ChamberReturn' }
    & Pick<ChamberReturn, 'id' | 'name' | 'logo'>
  ) }
);

export type GetChamberIdsWithChamberMemberProQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChamberIdsWithChamberMemberProQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getChamberIdsWithChamberMemberPro'>
);

export type GetChamberMemberQueryVariables = Exact<{
  chamberMemberId: Scalars['String'];
}>;


export type GetChamberMemberQuery = (
  { __typename?: 'Query' }
  & { getChamberMember: (
    { __typename?: 'ChamberMemberReturn' }
    & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'categoryId' | 'credentialsSentAtUtcMilli' | 'adminConsoleContactName' | 'adminConsoleLoginEmail' | 'name' | 'description' | 'website' | 'phoneNumber' | 'phoneNumberExtension' | 'contactName' | 'email' | 'logo' | 'primaryContactName' | 'cpaAdminCompanyAdminContactMobilePhoneNumber' | 'primaryContactMobilePhoneNumber' | 'primaryContactTitle' | 'primaryContactEmail' | 'primaryContactPhoneNumber' | 'primaryContactPhoneNumberExtension' | 'cpaAdminCompanyAdminContactTitle' | 'cpaAdminCompanyAdminContactNumber' | 'cpaAdminCompanyAdminContactNumberExtension' | 'cpaEmployeeAdoptionContactName' | 'cpaEmployeeAdoptionContactEmail' | 'cpaEmployeeAdoptionContactTitle' | 'cpaEmployeeAdoptionContactNumber' | 'cpaEmployeeAdoptionContactNumberExtension' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'googleReviewLink' | 'showInApp' | 'hideAddressFromDirectory' | 'isSuspended' | 'lifecycleStatus'>
    & { customContacts?: Maybe<Array<(
      { __typename?: 'CustomContactReturn' }
      & Pick<CustomContactReturn, 'id' | 'name' | 'email' | 'jobTitle' | 'phoneNumber' | 'phoneNumberExtension'>
    )>>, banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>>, activeMemberProfileAndPerksBannersSettings?: Maybe<(
      { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn' }
      & { activationInfo: (
        { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn' }
        & Pick<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn, 'startDateUtcMilli' | 'chamberMemberHasAcceptedAgreement' | 'chamberMemberAcceptedAgreementVersion'>
      ) }
    )>, address: (
      { __typename?: 'AddressReturn' }
      & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode' | 'country'>
    ), cmpExtension?: Maybe<(
      { __typename: 'CmpMemberExtensionReturn' }
      & Pick<CmpMemberExtensionReturn, 'accountsPayableContactName' | 'accountsPayableContactTitle' | 'accountsPayableContactEmail' | 'accountsPayableContactNumber' | 'accountsPayableContactNumberExtension' | 'accountsPayableContactMobilePhoneNumber' | 'marketingCommunicationContactName' | 'marketingCommunicationContactTitle' | 'marketingCommunicationContactEmail' | 'marketingCommunicationContactNumber' | 'marketingCommunicationContactNumberExtension' | 'marketingCommunicationContactMobilePhoneNumber' | 'hrEmployeeEngagementContactName' | 'hrEmployeeEngagementContactTitle' | 'hrEmployeeEngagementContactEmail' | 'hrEmployeeEngagementContactNumber' | 'hrEmployeeEngagementContactNumberExtension' | 'hrEmployeeEngagementContactMobilePhoneNumber' | 'salesBusinessDevelopmentContactName' | 'salesBusinessDevelopmentContactTitle' | 'salesBusinessDevelopmentContactEmail' | 'salesBusinessDevelopmentContactNumber' | 'salesBusinessDevelopmentContactNumberExtension' | 'salesBusinessDevelopmentContactMobilePhoneNumber'>
      & { accountsPayableBillingAddress?: Maybe<(
        { __typename?: 'CmpMemberBillingAddressReturn' }
        & Pick<CmpMemberBillingAddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode' | 'country'>
      )> }
    )> }
  ) }
);

export type GetCmpMemberDashboardChamberBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetCmpMemberDashboardChamberBySlugQuery = (
  { __typename?: 'Query' }
  & { getCmpMemberDashboardChamberBySlug?: Maybe<(
    { __typename?: 'CmpMemberDashboardChamberReturn' }
    & Pick<CmpMemberDashboardChamberReturn, 'chamberId' | 'slug' | 'name' | 'logo'>
  )> }
);

export type GetCmpMemberInvoicesQueryVariables = Exact<{
  input?: Maybe<GetCmpMemberInvoicesInput>;
}>;


export type GetCmpMemberInvoicesQuery = (
  { __typename?: 'Query' }
  & { getCmpMemberInvoices: (
    { __typename?: 'GetCmpMemberInvoicesReturn' }
    & Pick<GetCmpMemberInvoicesReturn, 'totalCount' | 'generatedAtUtcMilli'>
    & { rows: Array<(
      { __typename?: 'CmpMemberInvoiceRowReturn' }
      & CmpMemberInvoiceRowFragment
    )>, outstanding: Array<(
      { __typename?: 'CmpMemberInvoiceOutstandingReturn' }
      & Pick<CmpMemberInvoiceOutstandingReturn, 'currency' | 'amountInCents' | 'count'>
    )> }
  ) }
);

export type GetCmpMemberInvoiceDetailQueryVariables = Exact<{
  input: CmpMemberInvoiceInput;
}>;


export type GetCmpMemberInvoiceDetailQuery = (
  { __typename?: 'Query' }
  & { getCmpMemberInvoiceDetail: (
    { __typename?: 'CmpMemberInvoiceRowReturn' }
    & CmpMemberInvoiceRowFragment
  ) }
);

export type GetCmpProfileSectionsSavedAtQueryVariables = Exact<{
  chamberMemberId: Scalars['String'];
}>;


export type GetCmpProfileSectionsSavedAtQuery = (
  { __typename?: 'Query' }
  & { getChamberMember: (
    { __typename?: 'ChamberMemberReturn' }
    & Pick<ChamberMemberReturn, 'id'>
    & { cmpProfileSectionsSavedAt?: Maybe<Array<(
      { __typename?: 'CmpProfileSectionSavedAtReturn' }
      & Pick<CmpProfileSectionSavedAtReturn, 'section' | 'savedAtUtcMilli'>
    )>> }
  ) }
);

export type GetDiscountQueryVariables = Exact<{
  discountId: Scalars['String'];
}>;


export type GetDiscountQuery = (
  { __typename?: 'Query' }
  & { getDiscount: (
    { __typename?: 'DiscountReturn' }
    & Pick<DiscountReturn, 'id' | 'title' | 'description' | 'chamberId' | 'chamberMemberId' | 'memberOnly' | 'isReoccuring' | 'daysAvailable' | 'monthsAvailable' | 'isAvailableToAllMembers' | 'isPrivate' | 'privateEmails' | 'expiryTimeUtcMilli' | 'startTimeUtcMilli' | 'updatedAtUtcMilli' | 'notify' | 'views'>
    & { chamberInfo: (
      { __typename?: 'ChamberReturn' }
      & Pick<ChamberReturn, 'id' | 'name' | 'website' | 'supportContactEmail' | 'googleMapsApi_City_ProvinceShort_CountryShort' | 'supportContactName' | 'supportLink' | 'phoneNumber' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'jobPostingLink' | 'eventsLink' | 'newsletterLink' | 'surveyLink' | 'advocacyWinsLink' | 'callForNominationsLink' | 'memberSignupLink' | 'sponsorLogo' | 'sponsorLogoLink' | 'description' | 'logo' | 'hideInApp'>
      & { address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ) }
    ), chamberMemberInfo: (
      { __typename?: 'ChamberMemberReturn' }
      & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'categoryId' | 'credentialsSentAtUtcMilli' | 'adminConsoleContactName' | 'name' | 'description' | 'website' | 'phoneNumber' | 'contactName' | 'email' | 'logo' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'googleReviewLink' | 'youtube' | 'showInApp' | 'isSuspended'>
      & { customContacts?: Maybe<Array<(
        { __typename?: 'CustomContactReturn' }
        & Pick<CustomContactReturn, 'id' | 'name' | 'email' | 'jobTitle' | 'phoneNumber'>
      )>>, banner?: Maybe<Array<(
        { __typename?: 'BannerReturn' }
        & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
      )>>, activeMemberProfileAndPerksBannersSettings?: Maybe<(
        { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn' }
        & { activationInfo: (
          { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn' }
          & Pick<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn, 'startDateUtcMilli' | 'chamberMemberHasAcceptedAgreement'>
        ) }
      )>, address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ) }
    ), redeemSettings: (
      { __typename?: 'RedeemSettingsReturn' }
      & Pick<RedeemSettingsReturn, 'whereToRedeem'>
      & { howToRedeem?: Maybe<(
        { __typename?: 'HowToRedeemReturn' }
        & Pick<HowToRedeemReturn, 'code' | 'websiteToEnterCodeAt' | 'contactEmail' | 'contactNumber' | 'contactName'>
      )> }
    ), banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>> }
  ) }
);

export type GetMyCmpMemberAutoRenewalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCmpMemberAutoRenewalQuery = (
  { __typename?: 'Query' }
  & { getMyCmpMemberAutoRenewal: (
    { __typename?: 'CmpMyMemberAutoRenewalReturn' }
    & CmpMyMemberAutoRenewalFragment
  ) }
);

export type CmpMyMemberAutoRenewalFragment = (
  { __typename?: 'CmpMyMemberAutoRenewalReturn' }
  & Pick<CmpMyMemberAutoRenewalReturn, 'available' | 'unavailableReason' | 'autoRenew' | 'memberName'>
  & { cardOnFile?: Maybe<(
    { __typename?: 'CmpMemberSavedCardReturn' }
    & Pick<CmpMemberSavedCardReturn, 'label' | 'shortLabel'>
  )> }
);

export type GetMyCmpMemberContactAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCmpMemberContactAccountsQuery = (
  { __typename?: 'Query' }
  & { getMyCmpMemberContactAccounts: (
    { __typename?: 'CmpMyMemberContactAccountsReturn' }
    & Pick<CmpMyMemberContactAccountsReturn, 'memberUpdatedAtUtcMilli'>
    & { accounts: Array<(
      { __typename?: 'CmpMemberContactAccountReturn' }
      & Pick<CmpMemberContactAccountReturn, 'contactId' | 'name' | 'email' | 'usesLegacyMemberAccount' | 'credentialActionsBlockedReason' | 'enabled' | 'hasSignedUp' | 'credentialsSentAtUtcMilli' | 'lastDashboardLoginAtUtcMilli'>
    )> }
  ) }
);

export type GetMyCmpMemberEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCmpMemberEventsQuery = (
  { __typename?: 'Query' }
  & { getMyCmpMemberEvents: (
    { __typename?: 'CmpMyMemberEventsReturn' }
    & Pick<CmpMyMemberEventsReturn, 'eventsPageUrl'>
    & { upcoming: Array<(
      { __typename?: 'CmpMyMemberEventRegistrationReturn' }
      & CmpMyMemberEventRegistrationFragment
    )>, past: Array<(
      { __typename?: 'CmpMyMemberEventRegistrationReturn' }
      & CmpMyMemberEventRegistrationFragment
    )> }
  ) }
);

export type CmpMyMemberEventRegistrationFragment = (
  { __typename?: 'CmpMyMemberEventRegistrationReturn' }
  & Pick<CmpMyMemberEventRegistrationReturn, 'registrationId' | 'eventId' | 'eventTitle' | 'startAtUtcMilli' | 'endAtUtcMilli' | 'timeZone' | 'locationText' | 'ticketSummary' | 'ticketCount' | 'registrationNumber' | 'amountInCents' | 'amountDueInCents' | 'currency' | 'paid' | 'updatedAtUtcMilli' | 'missingAttendeeCount' | 'canEditAttendees'>
  & { attendees: Array<(
    { __typename?: 'CmpMyMemberEventAttendeeReturn' }
    & Pick<CmpMyMemberEventAttendeeReturn, 'id' | 'firstName' | 'lastName' | 'email' | 'ticketTypeId' | 'ticketTypeName' | 'complete'>
    & { answers: Array<(
      { __typename?: 'CmpMyMemberEventAnswerReturn' }
      & Pick<CmpMyMemberEventAnswerReturn, 'fieldId' | 'value'>
    )> }
  )>, questions: Array<(
    { __typename?: 'CmpMyMemberEventQuestionReturn' }
    & Pick<CmpMyMemberEventQuestionReturn, 'id' | 'label' | 'fieldType' | 'required' | 'helperText' | 'choices' | 'appliesToTicketTypeIds'>
  )> }
);

export type GetMyMemberDashboardChambersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyMemberDashboardChambersQuery = (
  { __typename?: 'Query' }
  & { getMyMemberDashboardChambers: Array<(
    { __typename?: 'MemberDashboardChamberReturn' }
    & Pick<MemberDashboardChamberReturn, 'chamberId' | 'name' | 'logo' | 'isHome' | 'isActive'>
  )> }
);

export type GetPerkPartnerDiscountQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPerkPartnerDiscountQuery = (
  { __typename?: 'Query' }
  & { getPerkPartnerDiscount: (
    { __typename?: 'PerkPartnerDiscountReturn' }
    & Pick<PerkPartnerDiscountReturn, 'id' | 'companyName' | 'title' | 'description' | 'verifiedChamberMemberCapUserRedirectLink' | 'unverifiedChamberMemberCapUserRedirectLink' | 'logo' | 'availableToChamberIds' | 'createdAtUtcMilli' | 'updatedAtUtcMilli'>
    & { availableToChambers?: Maybe<Array<(
      { __typename?: 'RootAdminPerkPartnerDiscountAvailableToChambersReturn' }
      & Pick<RootAdminPerkPartnerDiscountAvailableToChambersReturn, 'id' | 'name'>
    )>>, banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>> }
  ) }
);

export type GetPerkPartnerDiscountAdminUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPerkPartnerDiscountAdminUserQuery = (
  { __typename?: 'Query' }
  & { getPerkPartnerDiscountAdminUser: (
    { __typename?: 'PerkPartnerDiscountAdminUserReturn' }
    & Pick<PerkPartnerDiscountAdminUserReturn, 'id' | 'email' | 'perkPartnerDiscountId' | 'adminConsoleLoginEmail' | 'createdAtUtcMilli' | 'updatedAtUtcMilli'>
  ) }
);

export type GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery = (
  { __typename?: 'Query' }
  & { getPerkPartnerDiscount: (
    { __typename?: 'PerkPartnerDiscountReturn' }
    & Pick<PerkPartnerDiscountReturn, 'id' | 'companyName' | 'title' | 'description' | 'verifiedChamberMemberCapUserRedirectLink' | 'unverifiedChamberMemberCapUserRedirectLink' | 'logo' | 'createdAtUtcMilli' | 'updatedAtUtcMilli'>
    & { banner?: Maybe<Array<(
      { __typename?: 'BannerReturn' }
      & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
    )>> }
  ) }
);

export type GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery = (
  { __typename?: 'Query' }
  & { getPerkPartnerDiscountStats: (
    { __typename?: 'PerkPartnerDiscountStatReturn' }
    & Pick<PerkPartnerDiscountStatReturn, 'id' | 'totalViewCount' | 'totalOpenCount' | 'totalOpensFromViewsConversionRatePercentage'>
    & { splitByChamber?: Maybe<Array<(
      { __typename?: 'PerkPartnerDiscountStatSplitByChamberReturn' }
      & Pick<PerkPartnerDiscountStatSplitByChamberReturn, 'chamberId' | 'chamberName' | 'totalViewCount' | 'totalOpenCount'>
    )>>, timeseriesData?: Maybe<(
      { __typename?: 'PerkPartnerDiscountTimeseriesDataReturn' }
      & { allChambers: (
        { __typename?: 'PerkPartnerDiscountTimeseriesDataset' }
        & Pick<PerkPartnerDiscountTimeseriesDataset, 'id' | 'name'>
        & { timeseriesData: Array<(
          { __typename?: 'PerkPartnerDiscountTimeseriesDataPoint' }
          & Pick<PerkPartnerDiscountTimeseriesDataPoint, 'monthAndYear' | 'totalOpenCount' | 'totalViewCount'>
        )> }
      ), chambers: Array<(
        { __typename?: 'PerkPartnerDiscountTimeseriesDataset' }
        & Pick<PerkPartnerDiscountTimeseriesDataset, 'id' | 'name'>
        & { timeseriesData: Array<(
          { __typename?: 'PerkPartnerDiscountTimeseriesDataPoint' }
          & Pick<PerkPartnerDiscountTimeseriesDataPoint, 'monthAndYear' | 'totalOpenCount' | 'totalViewCount'>
        )> }
      )> }
    )> }
  ) }
);

export type GetPerkPartnerDiscountStatsForRootAdminQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPerkPartnerDiscountStatsForRootAdminQuery = (
  { __typename?: 'Query' }
  & { getPerkPartnerDiscountStats: (
    { __typename?: 'PerkPartnerDiscountStatReturn' }
    & Pick<PerkPartnerDiscountStatReturn, 'id' | 'totalViewCount' | 'totalIneligibleViewCount' | 'totalUnverifiedViewCount' | 'totalVerifiedViewCount' | 'totalOpenCount' | 'totalIneligibleOpenCount' | 'totalUnverifiedOpenCount' | 'totalVerifiedOpenCount' | 'totalOpensFromViewsConversionRatePercentage' | 'totalRedeemCount' | 'totalUnverifiedRedeemCount' | 'totalVerifiedRedeemCount' | 'totalVerifiedNoAccessToEmailRedeemCount' | 'totalRedeemCountFromOpensConversionRatePercentage'>
    & { splitByChamber?: Maybe<Array<(
      { __typename?: 'PerkPartnerDiscountStatSplitByChamberReturn' }
      & Pick<PerkPartnerDiscountStatSplitByChamberReturn, 'chamberId' | 'chamberName' | 'chamberIsEnabledForPerkPartnerDiscount' | 'totalViewCount' | 'ineligibleViewCount' | 'unverifiedViewCount' | 'verifiedViewCount' | 'totalOpenCount' | 'ineligibleOpenCount' | 'unverifiedOpenCount' | 'verifiedOpenCount' | 'totalRedeemCount' | 'unverifiedRedeemCount' | 'verifiedRedeemCount' | 'verifiedNoAccessToEmailRedeemCount'>
    )>>, timeseriesData?: Maybe<(
      { __typename?: 'PerkPartnerDiscountTimeseriesDataReturn' }
      & { allChambers: (
        { __typename?: 'PerkPartnerDiscountTimeseriesDataset' }
        & Pick<PerkPartnerDiscountTimeseriesDataset, 'id' | 'name'>
        & { timeseriesData: Array<(
          { __typename?: 'PerkPartnerDiscountTimeseriesDataPoint' }
          & Pick<PerkPartnerDiscountTimeseriesDataPoint, 'monthAndYear' | 'totalOpenCount' | 'totalViewCount' | 'totalRedeemCount'>
        )> }
      ), chambers: Array<(
        { __typename?: 'PerkPartnerDiscountTimeseriesDataset' }
        & Pick<PerkPartnerDiscountTimeseriesDataset, 'id' | 'name'>
        & { timeseriesData: Array<(
          { __typename?: 'PerkPartnerDiscountTimeseriesDataPoint' }
          & Pick<PerkPartnerDiscountTimeseriesDataPoint, 'monthAndYear' | 'totalOpenCount' | 'totalViewCount' | 'totalRedeemCount'>
        )> }
      )> }
    )> }
  ) }
);

export type GetPremiumChamberMarketerLinkQueryVariables = Exact<{
  chamberId: Scalars['String'];
}>;


export type GetPremiumChamberMarketerLinkQuery = (
  { __typename?: 'Query' }
  & { getChamber: (
    { __typename?: 'ChamberReturn' }
    & Pick<ChamberReturn, 'id' | 'premiumChamberMarketerLink'>
  ) }
);

export type GetRewardCampaignQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRewardCampaignQuery = (
  { __typename?: 'Query' }
  & { getRewardCampaign?: Maybe<(
    { __typename?: 'RewardCampaignReturn' }
    & Pick<RewardCampaignReturn, 'id' | 'chamberId' | 'sponsoringChamberMemberId' | 'campaignName' | 'prizeDescription' | 'startDateUtcMilli' | 'endDateUtcMilli' | 'createdAtUtcMilli' | 'updatedAtUtcMilli' | 'isCreatedByCpaAdmin'>
    & { prizeDrawParticipants?: Maybe<Array<(
      { __typename?: 'PrizeDrawParticipantReturn' }
      & Pick<PrizeDrawParticipantReturn, 'email' | 'ballotsEarned'>
    )>> }
  )> }
);

export type GetRootAdminStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRootAdminStatsQuery = (
  { __typename?: 'Query' }
  & { getRootAdminStats: (
    { __typename?: 'RootAdminStatsReturn' }
    & Pick<RootAdminStatsReturn, 'totalChambers' | 'totalChamberMembers' | 'totalSuspendedChamberMembers' | 'totalDiscountViews' | 'totalDiscountRedemptions' | 'numberOfChamberMembersOfferingLiveDiscounts' | 'percentOfChamberMembersOfferingLiveDiscounts' | 'totalNumberOfLiveDiscounts' | 'totalNumberOfLiveAllMemberDiscounts' | 'totalNumberOfLiveLocalMemberOnlyDiscounts' | 'totalNumberOfLiveGeneralPublicDiscounts' | 'totalNumberOfLiveCompanyEmployeesOnlyDiscounts' | 'totalNumberOfAppUsers' | 'totalNumberOfAppUsersSignedUpWithAnEmployer' | 'totalNumberOfAppUsersSignedUpWithoutAnEmployer' | 'totalNumberOfAppUsersWithNewPerkNotificationEnabled' | 'totalPercentageOfAppUsersWithNewPerkNotificationEnabled' | 'totalNumberOfAppUsersWithEmployerAndNewPerkNotificationEnabled' | 'totalPercentageOfAppUsersWithEmployerAndNewPerkNotificationEnabled' | 'totalNumberOfAppUsersWithNearbyPerkNotificationEnabled' | 'totalPercentageOfAppUsersWithNearbyPerkNotificationEnabled'>
    & { timeseriesAppUsersData: (
      { __typename?: 'TimeSeriesAppUsersDataReturn' }
      & { monthly: Array<(
        { __typename?: 'TimeSeriesAppUserDataPointReturn' }
        & Pick<TimeSeriesAppUserDataPointReturn, 'monthAndYear' | 'numberOfAppUsers'>
      )> }
    ), monthToChamberAppUserData: Array<(
      { __typename?: 'MonthToChamberAppUserDataChamberDataReturn' }
      & Pick<MonthToChamberAppUserDataChamberDataReturn, 'monthAndYear' | 'chamberId' | 'chamberName' | 'chamberProvince' | 'numberOfAppUsersInMonth' | 'percentageOfAppUsersInMonth' | 'numberOfAppUsersGrowthVersusPreviousMonth' | 'percentageGrowthVersusPreviousMonth'>
    )>, timeseriesChamberEngageData: (
      { __typename?: 'TimeSeriesChamberEngageDataReturn' }
      & { monthlyTotal: Array<(
        { __typename?: 'TimeSeriesChamberEngageMonthlyDataPointReturn' }
        & Pick<TimeSeriesChamberEngageMonthlyDataPointReturn, 'monthAndYear'>
        & { activationFeeRevenueData: (
          { __typename?: 'ChamberEngageActivationFeeRevenueReturn' }
          & Pick<ChamberEngageActivationFeeRevenueReturn, 'activationFeeRevenue' | 'featuredMemberActivationFeeRevenue' | 'categoryAdvertisingActivationFeeRevenue' | 'chamberRevenue' | 'chamberFeaturedMemberRevenue' | 'chamberCategoryAdvertisingRevenue'>
        ) }
      )>, monthlyPerChamber: Array<(
        { __typename?: 'TimeSeriesChamberEngageMonthlyPerChamberDataPointReturn' }
        & Pick<TimeSeriesChamberEngageMonthlyPerChamberDataPointReturn, 'monthAndYear'>
        & { chamberData: Array<(
          { __typename?: 'TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn' }
          & Pick<TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn, 'chamberId' | 'chamberName'>
          & { activationFeeRevenueData: (
            { __typename?: 'ChamberEngageActivationFeeRevenueReturn' }
            & Pick<ChamberEngageActivationFeeRevenueReturn, 'activationFeeRevenue' | 'featuredMemberActivationFeeRevenue' | 'categoryAdvertisingActivationFeeRevenue' | 'chamberRevenue' | 'chamberFeaturedMemberRevenue' | 'chamberCategoryAdvertisingRevenue'>
          ) }
        )> }
      )>, lifetimeTotal: (
        { __typename?: 'ChamberEngageActivationFeeRevenueReturn' }
        & Pick<ChamberEngageActivationFeeRevenueReturn, 'activationFeeRevenue' | 'featuredMemberActivationFeeRevenue' | 'categoryAdvertisingActivationFeeRevenue' | 'chamberRevenue' | 'chamberFeaturedMemberRevenue' | 'chamberCategoryAdvertisingRevenue'>
      ), lifetimeTotalPerChamber: Array<(
        { __typename?: 'TimeSeriesChamberEngageLifetimeTotalPerChamberDataPointReturn' }
        & Pick<TimeSeriesChamberEngageLifetimeTotalPerChamberDataPointReturn, 'chamberId' | 'chamberName'>
        & { lifetimeTotalActivationFeeRevenueData: (
          { __typename?: 'ChamberEngageActivationFeeRevenueReturn' }
          & Pick<ChamberEngageActivationFeeRevenueReturn, 'activationFeeRevenue' | 'featuredMemberActivationFeeRevenue' | 'categoryAdvertisingActivationFeeRevenue' | 'chamberRevenue' | 'chamberFeaturedMemberRevenue' | 'chamberCategoryAdvertisingRevenue'>
        ) }
      )>, yearlyTotal: Array<(
        { __typename?: 'TimeSeriesChamberEngageYearlyDataPointReturn' }
        & Pick<TimeSeriesChamberEngageYearlyDataPointReturn, 'year'>
        & { activationFeeRevenueData: (
          { __typename?: 'ChamberEngageActivationFeeRevenueReturn' }
          & Pick<ChamberEngageActivationFeeRevenueReturn, 'activationFeeRevenue' | 'featuredMemberActivationFeeRevenue' | 'categoryAdvertisingActivationFeeRevenue' | 'chamberRevenue' | 'chamberFeaturedMemberRevenue' | 'chamberCategoryAdvertisingRevenue'>
        ) }
      )>, yearlyTotalPerChamber: Array<(
        { __typename?: 'TimeSeriesChamberEngageYearlyTotalPerChamberDataPointReturn' }
        & Pick<TimeSeriesChamberEngageYearlyTotalPerChamberDataPointReturn, 'year'>
        & { chamberData: Array<(
          { __typename?: 'TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn' }
          & Pick<TimeSeriesChamberEngageMonthlyOrYearlyIndividualChamberDataPointReturn, 'chamberId' | 'chamberName'>
          & { activationFeeRevenueData: (
            { __typename?: 'ChamberEngageActivationFeeRevenueReturn' }
            & Pick<ChamberEngageActivationFeeRevenueReturn, 'activationFeeRevenue' | 'featuredMemberActivationFeeRevenue' | 'categoryAdvertisingActivationFeeRevenue' | 'chamberRevenue' | 'chamberFeaturedMemberRevenue' | 'chamberCategoryAdvertisingRevenue'>
          ) }
        )> }
      )> }
    ), chambersSortedByNewest: Array<(
      { __typename?: 'ChambersStatsReturn' }
      & Pick<ChambersStatsReturn, 'name' | 'subscriptionDate' | 'subscriptionUTCMilli' | 'cpaDashboardLatestAccessAtUtcMilli' | 'numberOfAppUsers' | 'numberOfAppUsersSignedUpWithAnEmployer' | 'numberOfAppUsersSignedUpWithoutAnEmployer' | 'numberOfLiveDiscounts' | 'numberOfDiscountViews' | 'numberOfDiscountRedemptions' | 'numberOfChamberMembersLiveOnApp' | 'numberOfSuspendedChamberMembers' | 'numberOfMembersFromInitialSubscriptionAgreement' | 'numberChangeInNumberOfChamberMembersBetweenNowAndInitial' | 'percentageChangeInNumberOfChamberMembersBetweenNowAndInitial' | 'numberOfChamberMembersLoggedInToAdminPortal' | 'percentageOfChamberMembersLoggedInToAdminPortal' | 'numberOfChamberMembersThatWereEmailedTheirCredentialsBeforeFirstLogin' | 'percentageOfChamberMembersThatWereEmailedTheirCredentialsBeforeFirstLogin' | 'numberOfChamberMembersOfferingLiveDiscounts' | 'percentageOfChamberMembersOfferingLiveDiscounts' | 'numberOfAppUsersWithNewPerkNotificationEnabled' | 'percentageOfAppUsersWithNewPerkNotificationEnabled' | 'numberOfAppUsersWithEmployerAndNewPerkNotificationEnabled' | 'percentageOfAppUsersWithEmployerAndNewPerkNotificationEnabled' | 'numberOfAppUsersWithNearbyPerkNotificationEnabled' | 'percentageOfAppUsersWithNearbyPerkNotificationEnabled'>
      & { discountsPerCategoryBreakdown: Array<(
        { __typename?: 'DiscountsPerCategoryBreakdownReturn' }
        & Pick<DiscountsPerCategoryBreakdownReturn, 'categoryName' | 'numberOfDiscounts' | 'percentageVersusOtherCategories'>
      )> }
    )>, newestChamberMembers: Array<(
      { __typename?: 'DeletedAndNonDeletedChamberMemberStatsReturn' }
      & Pick<DeletedAndNonDeletedChamberMemberStatsReturn, 'name' | 'chamberName' | 'membershipStatus' | 'category1' | 'category2' | 'numberOfAppUsersWithThisMemberSetAsTheirEmployer' | 'numberOfDeletedAndNonDeletedDiscounts' | 'hasLoggedInToAdminPortal' | 'hasLogo' | 'createdAtUtcMilli' | 'createdAtUtcTimestamp'>
    )>, newestDiscounts: Array<(
      { __typename?: 'DeletedAndNonDeletedDiscountStatsReturn' }
      & Pick<DeletedAndNonDeletedDiscountStatsReturn, 'title' | 'chamberName' | 'chamberMemberName' | 'offeredTo' | 'views' | 'numberOfRedemptions' | 'category1' | 'category2' | 'createdAtUtcMilli' | 'createdAtUtcTimestamp' | 'deletedAtUtcMilli' | 'deletedAtUtcTimestamp'>
    )>, discountsPerCategoryBreakdown: Array<(
      { __typename?: 'DiscountsPerCategoryBreakdownReturn' }
      & Pick<DiscountsPerCategoryBreakdownReturn, 'categoryName' | 'numberOfDiscounts' | 'percentageVersusOtherCategories'>
    )>, contactableChambersSortedByNewest: Array<(
      { __typename?: 'ContactableChamberReturn' }
      & Pick<ContactableChamberReturn, 'id' | 'name' | 'createdAtUtcMilli' | 'createdAtUtcTimestamp'>
    )>, contactableCompaniesSortedByNewest: Array<(
      { __typename?: 'ContactableCompanyReturn' }
      & Pick<ContactableCompanyReturn, 'id' | 'chamberId' | 'chamberName' | 'name' | 'createdAtUtcMilli' | 'createdAtUtcTimestamp'>
    )>, perksLinkChambers: Array<(
      { __typename?: 'PerksLinkChamberStatsReturn' }
      & Pick<PerksLinkChamberStatsReturn, 'chamberId' | 'chamberName'>
      & { perksLinks: Array<(
        { __typename?: 'PerksLinkDetailReturn' }
        & Pick<PerksLinkDetailReturn, 'linkedChamberId' | 'linkedChamberName' | 'status' | 'requestedAtUtcMilli' | 'acceptedAtUtcMilli' | 'isRequestor'>
      )> }
    )> }
  ) }
);

export type GetSampleLoginInfoEmailQueryVariables = Exact<{
  type: LoginInfoEmailTypes;
  chamberMemberId?: Maybe<Scalars['String']>;
}>;


export type GetSampleLoginInfoEmailQuery = (
  { __typename?: 'Query' }
  & { getSampleLoginInfoEmail: (
    { __typename?: 'SampleLoginInfoEmailReturn' }
    & Pick<SampleLoginInfoEmailReturn, 'emailHtml'>
  ) }
);

export type GetSampleMemberLoginCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSampleMemberLoginCredentialsQuery = (
  { __typename?: 'Query' }
  & { getSampleMemberLoginCredentials: (
    { __typename?: 'GetSampleMemberLoginCredentialsReturn' }
    & Pick<GetSampleMemberLoginCredentialsReturn, 'sampleCSVRawTextOfAllMemberLoginCredentials'>
  ) }
);

export type GetShopLocalCampaignQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetShopLocalCampaignQuery = (
  { __typename?: 'Query' }
  & { getShopLocalCampaign?: Maybe<(
    { __typename?: 'ShopLocalCampaignReturn' }
    & Pick<ShopLocalCampaignReturn, 'id' | 'chamberId' | 'campaignName' | 'prizeDescription' | 'startDateUtcMilli' | 'endDateUtcMilli' | 'participatingMemberIds' | 'status' | 'createdAtUtcMilli' | 'updatedAtUtcMilli'>
    & { participatingMembers: Array<(
      { __typename?: 'ShopLocalCampaignParticipatingMembersReturn' }
      & Pick<ShopLocalCampaignParticipatingMembersReturn, 'memberId' | 'participationCode'>
    )>, prizeDrawParticipants?: Maybe<Array<(
      { __typename?: 'ShopLocalCampaignPrizeDrawParticipantsReturn' }
      & Pick<ShopLocalCampaignPrizeDrawParticipantsReturn, 'userEmail' | 'redeemedAtMemberIds'>
    )>> }
  )> }
);

export type GetShopLocalParticipatingMemberEligibilityQueryVariables = Exact<{
  startDateUtcMilli: Scalars['Float'];
  endDateUtcMilli: Scalars['Float'];
}>;


export type GetShopLocalParticipatingMemberEligibilityQuery = (
  { __typename?: 'Query' }
  & { getShopLocalParticipatingMemberEligibility: Array<(
    { __typename?: 'ShopLocalParticipatingMemberEligibilityReturn' }
    & Pick<ShopLocalParticipatingMemberEligibilityReturn, 'memberId' | 'memberName' | 'eligible' | 'ineligibilityReasons'>
  )> }
);

export type GetSubscriptionPlanTypeQueryVariables = Exact<{
  chamberId: Scalars['String'];
}>;


export type GetSubscriptionPlanTypeQuery = (
  { __typename?: 'Query' }
  & { getChamber: (
    { __typename?: 'ChamberReturn' }
    & Pick<ChamberReturn, 'id' | 'subscriptionPlanType'>
  ) }
);

export type GetSystemWidePerkStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSystemWidePerkStatsQuery = (
  { __typename?: 'Query' }
  & { getSystemWidePerkStats: (
    { __typename?: 'SystemWidePerkStatsReturn' }
    & Pick<SystemWidePerkStatsReturn, 'totalActivePerks' | 'numberOfMembersOfferingPerks' | 'percentOfMembersOfferingPerks' | 'totalPerkViews' | 'numOfAllMemberPerks' | 'numOfLocalMemberOnlyPerks' | 'numOfGeneralPublicPerks' | 'numOfCompanyEmployeesOnlyPerks' | 'totalNumOfMembers' | 'totalNumOfChambers' | 'totalLifeTimeCategoryAdvertisingBannersRevenueForCurrentChamber' | 'totalLifeTimeRevenueFromMemberProfileAndPerksBannersForCurrentChamber' | 'totalNumOfMembersWithActiveMemberProfileAndPerksBannersForCurrentChamber'>
    & { totalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersForCurrentChamber?: Maybe<Array<(
      { __typename?: 'TotalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersReturn' }
      & Pick<TotalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersReturn, 'categoryId' | 'totalNumOfMembers'>
    )>> }
  ) }
);

export type GetUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserQuery = (
  { __typename?: 'Query' }
  & { getUser: (
    { __typename?: 'UserReturn' }
    & Pick<UserReturn, 'id' | 'email' | 'chamberMemberProTimeZone' | 'chamberId' | 'chamberMemberId' | 'marketingEmailAccepted' | 'languageCode'>
    & { cmpMemberDashboardAccess?: Maybe<(
      { __typename?: 'CmpMemberDashboardAccessReturn' }
      & Pick<CmpMemberDashboardAccessReturn, 'cmpEnabled' | 'contactId' | 'canManageProfile' | 'canManagePerks' | 'canCreatePerks' | 'canManageBanners' | 'canViewInvoices' | 'isPrimaryContact' | 'roleLabel' | 'perksOffered'>
      & { testMode?: Maybe<(
        { __typename?: 'CmpMemberDashboardTestModeReturn' }
        & Pick<CmpMemberDashboardTestModeReturn, 'available' | 'plan' | 'contactType' | 'switchChamber'>
      )> }
    )>, chamberInfo: (
      { __typename?: 'ChamberReturn' }
      & Pick<ChamberReturn, 'id' | 'name' | 'website' | 'supportContactEmail' | 'googleMapsApi_City_ProvinceShort_CountryShort' | 'supportContactName' | 'billingContactName' | 'billingContactEmail' | 'signingAuthorityContactName' | 'signingAuthorityContactEmail' | 'supportLink' | 'phoneNumber' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'jobPostingLink' | 'eventsLink' | 'newsletterLink' | 'surveyLink' | 'advocacyWinsLink' | 'callForNominationsLink' | 'memberSignupLink' | 'sponsorLogo' | 'sponsorLogoLink' | 'description' | 'logo' | 'isSandbox' | 'hideInApp' | 'createdAtUtcMilli'>
      & { address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ), directoryBanner?: Maybe<Array<(
        { __typename?: 'BannerReturn' }
        & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
      )>>, profileBanner?: Maybe<Array<(
        { __typename?: 'BannerReturn' }
        & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
      )>>, chamberEngageSettings: (
        { __typename?: 'ChamberEngageSettingsReturn' }
        & Pick<ChamberEngageSettingsReturn, 'isActive'>
      ) }
    ), chamberMemberInfo?: Maybe<(
      { __typename?: 'ChamberMemberReturn' }
      & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'categoryId' | 'credentialsSentAtUtcMilli' | 'adminConsoleContactName' | 'adminConsoleLoginEmail' | 'name' | 'description' | 'website' | 'phoneNumber' | 'contactName' | 'email' | 'logo' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'googleReviewLink' | 'youtube' | 'showInApp' | 'hasSignedUp' | 'isSuspended'>
      & { customContacts?: Maybe<Array<(
        { __typename?: 'CustomContactReturn' }
        & Pick<CustomContactReturn, 'id' | 'name' | 'email' | 'jobTitle' | 'phoneNumber'>
      )>>, banner?: Maybe<Array<(
        { __typename?: 'BannerReturn' }
        & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
      )>>, activeMemberProfileAndPerksBannersSettings?: Maybe<(
        { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn' }
        & { activationInfo: (
          { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn' }
          & Pick<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn, 'startDateUtcMilli' | 'chamberMemberHasAcceptedAgreement' | 'chamberMemberAcceptedAgreementVersion'>
        ) }
      )>, address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ) }
    )> }
  ) }
);

export type GetUser_RootAdminChamberAdminQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUser_RootAdminChamberAdminQuery = (
  { __typename?: 'Query' }
  & { getUser: (
    { __typename?: 'UserReturn' }
    & Pick<UserReturn, 'id' | 'email' | 'chamberId' | 'chamberMemberId' | 'marketingEmailAccepted'>
    & { chamberInfo: (
      { __typename?: 'ChamberReturn' }
      & Pick<ChamberReturn, 'id' | 'subscriptionPlanType' | 'isSandbox' | 'name' | 'website' | 'supportContactEmail' | 'googleMapsApi_City_ProvinceShort_CountryShort' | 'supportContactName' | 'billingContactName' | 'billingContactEmail' | 'signingAuthorityContactName' | 'signingAuthorityContactEmail' | 'supportLink' | 'phoneNumber' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'youtube' | 'jobPostingLink' | 'eventsLink' | 'newsletterLink' | 'surveyLink' | 'advocacyWinsLink' | 'callForNominationsLink' | 'memberSignupLink' | 'sponsorLogo' | 'sponsorLogoLink' | 'description' | 'logo' | 'hideInApp' | 'createdAtUtcMilli'>
      & { address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ), directoryBanner?: Maybe<Array<(
        { __typename?: 'BannerReturn' }
        & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
      )>>, profileBanner?: Maybe<Array<(
        { __typename?: 'BannerReturn' }
        & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
      )>>, chamberEngageSettings: (
        { __typename?: 'ChamberEngageSettingsReturn' }
        & Pick<ChamberEngageSettingsReturn, 'isActive' | 'memberProfileAndPerkBannerActivationFeeInDollars' | 'memberProfileAndPerkBannerAnnualBannerFeeInDollars' | 'categoryAdvertisingBannersActivationFeeCpaSplitPercentage'>
        & { categoryAdvertisingBannersFeeOptions: Array<(
          { __typename?: 'CategoryAdvertisingBannersFeeOptionsReturn' }
          & Pick<CategoryAdvertisingBannersFeeOptionsReturn, 'timeLengthInMonths' | 'bannerFeeInDollars'>
        )> }
      ) }
    ), chamberMemberInfo?: Maybe<(
      { __typename?: 'ChamberMemberReturn' }
      & Pick<ChamberMemberReturn, 'id' | 'chamberId' | 'categoryId' | 'credentialsSentAtUtcMilli' | 'adminConsoleContactName' | 'adminConsoleLoginEmail' | 'name' | 'description' | 'website' | 'phoneNumber' | 'phoneNumberExtension' | 'contactName' | 'email' | 'logo' | 'primaryContactName' | 'primaryContactTitle' | 'primaryContactEmail' | 'primaryContactPhoneNumber' | 'primaryContactPhoneNumberExtension' | 'cpaAdminCompanyAdminContactTitle' | 'cpaAdminCompanyAdminContactNumber' | 'cpaAdminCompanyAdminContactNumberExtension' | 'cpaEmployeeAdoptionContactName' | 'cpaEmployeeAdoptionContactEmail' | 'cpaEmployeeAdoptionContactTitle' | 'cpaEmployeeAdoptionContactNumber' | 'cpaEmployeeAdoptionContactNumberExtension' | 'facebook' | 'instagram' | 'threads' | 'linkedin' | 'twitter' | 'tiktok' | 'googleReviewLink' | 'youtube' | 'showInApp' | 'hasSignedUp' | 'isSuspended'>
      & { customContacts?: Maybe<Array<(
        { __typename?: 'CustomContactReturn' }
        & Pick<CustomContactReturn, 'id' | 'name' | 'email' | 'jobTitle' | 'phoneNumber' | 'phoneNumberExtension'>
      )>>, banner?: Maybe<Array<(
        { __typename?: 'BannerReturn' }
        & Pick<BannerReturn, 'contentUrl' | 'imageLink' | 'contentType' | 'position'>
      )>>, activeMemberProfileAndPerksBannersSettings?: Maybe<(
        { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsReturn' }
        & { activationInfo: (
          { __typename?: 'ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn' }
          & Pick<ActiveMemberProfileAndPerksBannersSettingsActivationInfoReturn, 'startDateUtcMilli' | 'chamberMemberHasAcceptedAgreement'>
        ) }
      )>, address: (
        { __typename?: 'AddressReturn' }
        & Pick<AddressReturn, 'streetAddress' | 'city' | 'province' | 'postalCode'>
      ) }
    )> }
  ) }
);

export const CmpMemberInvoiceRowFragmentDoc = gql`
    fragment cmpMemberInvoiceRow on CmpMemberInvoiceRowReturn {
  id
  invoiceNumber
  description
  issuedAtUtcMilli
  dueAtUtcMilli
  currency
  totalAmountInCents
  amountDueInCents
  displayState
  paymentMethodLabel
  daysPastDue
  installmentSummary
  canPay
  payableAmountInCents
  paymentUnavailableReason
  billToName
  creditForInvoiceNumber
  creditedByInvoiceNumbers
}
    `;
export const CmpMyMemberAutoRenewalFragmentDoc = gql`
    fragment CmpMyMemberAutoRenewal on CmpMyMemberAutoRenewalReturn {
  available
  unavailableReason
  autoRenew
  memberName
  cardOnFile {
    label
    shortLabel
  }
}
    `;
export const CmpMyMemberEventRegistrationFragmentDoc = gql`
    fragment CmpMyMemberEventRegistration on CmpMyMemberEventRegistrationReturn {
  registrationId
  eventId
  eventTitle
  startAtUtcMilli
  endAtUtcMilli
  timeZone
  locationText
  ticketSummary
  ticketCount
  registrationNumber
  amountInCents
  amountDueInCents
  currency
  paid
  updatedAtUtcMilli
  missingAttendeeCount
  canEditAttendees
  attendees {
    id
    firstName
    lastName
    email
    ticketTypeId
    ticketTypeName
    complete
    answers {
      fieldId
      value
    }
  }
  questions {
    id
    label
    fieldType
    required
    helperText
    choices
    appliesToTicketTypeIds
  }
}
    `;
export const AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberDocument = gql`
    mutation acceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMember($categoryId: ChamberMemberCategory!, $agreementVersion: String) {
  acceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMember(
    categoryId: $categoryId
    agreementVersion: $agreementVersion
  ) {
    agreementAcceptedSuccessfully
  }
}
    `;
export type AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutationFn = Apollo.MutationFunction<AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation, AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutationVariables>;

/**
 * __useAcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation__
 *
 * To run a mutation, you first call `useAcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation, { data, loading, error }] = useAcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      agreementVersion: // value for 'agreementVersion'
 *   },
 * });
 */
export function useAcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation(baseOptions?: Apollo.MutationHookOptions<AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation, AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation, AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutationVariables>(AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberDocument, options);
      }
export type AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutationHookResult = ReturnType<typeof useAcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation>;
export type AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutationResult = Apollo.MutationResult<AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation>;
export type AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutationOptions = Apollo.BaseMutationOptions<AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutation, AcceptChamberMemberAgreementForActiveCategoryAdvertisingBannerOfChamberMemberMutationVariables>;
export const AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberDocument = gql`
    mutation acceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMember($agreementVersion: String) {
  acceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMember(
    agreementVersion: $agreementVersion
  ) {
    agreementAcceptedSuccessfully
  }
}
    `;
export type AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutationFn = Apollo.MutationFunction<AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation, AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutationVariables>;

/**
 * __useAcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation__
 *
 * To run a mutation, you first call `useAcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation, { data, loading, error }] = useAcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation({
 *   variables: {
 *      agreementVersion: // value for 'agreementVersion'
 *   },
 * });
 */
export function useAcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation(baseOptions?: Apollo.MutationHookOptions<AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation, AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation, AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutationVariables>(AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberDocument, options);
      }
export type AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutationHookResult = ReturnType<typeof useAcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation>;
export type AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutationResult = Apollo.MutationResult<AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation>;
export type AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutationOptions = Apollo.BaseMutationOptions<AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutation, AcceptChamberMemberAgreementForActiveMemberProfileAndPerksBannersOfChamberMemberMutationVariables>;
export const AcceptPerksLinkRequestDocument = gql`
    mutation acceptPerksLinkRequest($requestId: String!) {
  acceptPerksLinkRequest(requestId: $requestId) {
    perksLinkAcceptedSuccessfully
  }
}
    `;
export type AcceptPerksLinkRequestMutationFn = Apollo.MutationFunction<AcceptPerksLinkRequestMutation, AcceptPerksLinkRequestMutationVariables>;

/**
 * __useAcceptPerksLinkRequestMutation__
 *
 * To run a mutation, you first call `useAcceptPerksLinkRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPerksLinkRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPerksLinkRequestMutation, { data, loading, error }] = useAcceptPerksLinkRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useAcceptPerksLinkRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptPerksLinkRequestMutation, AcceptPerksLinkRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptPerksLinkRequestMutation, AcceptPerksLinkRequestMutationVariables>(AcceptPerksLinkRequestDocument, options);
      }
export type AcceptPerksLinkRequestMutationHookResult = ReturnType<typeof useAcceptPerksLinkRequestMutation>;
export type AcceptPerksLinkRequestMutationResult = Apollo.MutationResult<AcceptPerksLinkRequestMutation>;
export type AcceptPerksLinkRequestMutationOptions = Apollo.BaseMutationOptions<AcceptPerksLinkRequestMutation, AcceptPerksLinkRequestMutationVariables>;
export const ActivateBannerForCategoryAdvertisingBannerDocument = gql`
    mutation activateBannerForCategoryAdvertisingBanner($chamberId: String, $categoryId: ChamberMemberCategory!, $activationInfo: CategoryAdvertisingBannerActivationInfoInput!) {
  activateBannerForCategoryAdvertisingBanner(
    chamberId: $chamberId
    categoryId: $categoryId
    activationInfo: $activationInfo
  ) {
    bannerActivatedSuccessfully
  }
}
    `;
export type ActivateBannerForCategoryAdvertisingBannerMutationFn = Apollo.MutationFunction<ActivateBannerForCategoryAdvertisingBannerMutation, ActivateBannerForCategoryAdvertisingBannerMutationVariables>;

/**
 * __useActivateBannerForCategoryAdvertisingBannerMutation__
 *
 * To run a mutation, you first call `useActivateBannerForCategoryAdvertisingBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBannerForCategoryAdvertisingBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBannerForCategoryAdvertisingBannerMutation, { data, loading, error }] = useActivateBannerForCategoryAdvertisingBannerMutation({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      categoryId: // value for 'categoryId'
 *      activationInfo: // value for 'activationInfo'
 *   },
 * });
 */
export function useActivateBannerForCategoryAdvertisingBannerMutation(baseOptions?: Apollo.MutationHookOptions<ActivateBannerForCategoryAdvertisingBannerMutation, ActivateBannerForCategoryAdvertisingBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateBannerForCategoryAdvertisingBannerMutation, ActivateBannerForCategoryAdvertisingBannerMutationVariables>(ActivateBannerForCategoryAdvertisingBannerDocument, options);
      }
export type ActivateBannerForCategoryAdvertisingBannerMutationHookResult = ReturnType<typeof useActivateBannerForCategoryAdvertisingBannerMutation>;
export type ActivateBannerForCategoryAdvertisingBannerMutationResult = Apollo.MutationResult<ActivateBannerForCategoryAdvertisingBannerMutation>;
export type ActivateBannerForCategoryAdvertisingBannerMutationOptions = Apollo.BaseMutationOptions<ActivateBannerForCategoryAdvertisingBannerMutation, ActivateBannerForCategoryAdvertisingBannerMutationVariables>;
export const ActivateCmpMemberDocument = gql`
    mutation ActivateCmpMember($input: CmpMemberActionInput!) {
  activateCmpMember(input: $input) {
    actionSuccessful
    detail {
      lifecycleStatus
      member {
        id
        chamberId
        lifecycleStatus
        isSuspended
        updatedAtUtcMilli
      }
    }
  }
}
    `;
export type ActivateCmpMemberMutationFn = Apollo.MutationFunction<ActivateCmpMemberMutation, ActivateCmpMemberMutationVariables>;

/**
 * __useActivateCmpMemberMutation__
 *
 * To run a mutation, you first call `useActivateCmpMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateCmpMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateCmpMemberMutation, { data, loading, error }] = useActivateCmpMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateCmpMemberMutation(baseOptions?: Apollo.MutationHookOptions<ActivateCmpMemberMutation, ActivateCmpMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateCmpMemberMutation, ActivateCmpMemberMutationVariables>(ActivateCmpMemberDocument, options);
      }
export type ActivateCmpMemberMutationHookResult = ReturnType<typeof useActivateCmpMemberMutation>;
export type ActivateCmpMemberMutationResult = Apollo.MutationResult<ActivateCmpMemberMutation>;
export type ActivateCmpMemberMutationOptions = Apollo.BaseMutationOptions<ActivateCmpMemberMutation, ActivateCmpMemberMutationVariables>;
export const ActivateMemberProfileAndPerksBannersForChamberMemberDocument = gql`
    mutation activateMemberProfileAndPerksBannersForChamberMember($chamberId: String, $chamberMemberId: String!, $startDateUtcMilli: Float!) {
  activateMemberProfileAndPerksBannersForChamberMember(
    chamberId: $chamberId
    chamberMemberId: $chamberMemberId
    startDateUtcMilli: $startDateUtcMilli
  ) {
    activationSuccessful
  }
}
    `;
export type ActivateMemberProfileAndPerksBannersForChamberMemberMutationFn = Apollo.MutationFunction<ActivateMemberProfileAndPerksBannersForChamberMemberMutation, ActivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>;

/**
 * __useActivateMemberProfileAndPerksBannersForChamberMemberMutation__
 *
 * To run a mutation, you first call `useActivateMemberProfileAndPerksBannersForChamberMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateMemberProfileAndPerksBannersForChamberMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateMemberProfileAndPerksBannersForChamberMemberMutation, { data, loading, error }] = useActivateMemberProfileAndPerksBannersForChamberMemberMutation({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      chamberMemberId: // value for 'chamberMemberId'
 *      startDateUtcMilli: // value for 'startDateUtcMilli'
 *   },
 * });
 */
export function useActivateMemberProfileAndPerksBannersForChamberMemberMutation(baseOptions?: Apollo.MutationHookOptions<ActivateMemberProfileAndPerksBannersForChamberMemberMutation, ActivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateMemberProfileAndPerksBannersForChamberMemberMutation, ActivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>(ActivateMemberProfileAndPerksBannersForChamberMemberDocument, options);
      }
export type ActivateMemberProfileAndPerksBannersForChamberMemberMutationHookResult = ReturnType<typeof useActivateMemberProfileAndPerksBannersForChamberMemberMutation>;
export type ActivateMemberProfileAndPerksBannersForChamberMemberMutationResult = Apollo.MutationResult<ActivateMemberProfileAndPerksBannersForChamberMemberMutation>;
export type ActivateMemberProfileAndPerksBannersForChamberMemberMutationOptions = Apollo.BaseMutationOptions<ActivateMemberProfileAndPerksBannersForChamberMemberMutation, ActivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>;
export const ChamberChangeAdminConsoleLoginEmailDocument = gql`
    mutation chamberChangeAdminConsoleLoginEmail($currentAdminConsoleLoginEmail: String!, $newAdminConsoleLoginEmail: String!, $chamberId: String!) {
  chamberChangeAdminConsoleLoginEmail(
    currentAdminConsoleLoginEmail: $currentAdminConsoleLoginEmail
    newAdminConsoleLoginEmail: $newAdminConsoleLoginEmail
    chamberId: $chamberId
  ) {
    password
    failureReason
    adminConsoleLoginEmailChangedSuccessfully
    email
  }
}
    `;
export type ChamberChangeAdminConsoleLoginEmailMutationFn = Apollo.MutationFunction<ChamberChangeAdminConsoleLoginEmailMutation, ChamberChangeAdminConsoleLoginEmailMutationVariables>;

/**
 * __useChamberChangeAdminConsoleLoginEmailMutation__
 *
 * To run a mutation, you first call `useChamberChangeAdminConsoleLoginEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChamberChangeAdminConsoleLoginEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chamberChangeAdminConsoleLoginEmailMutation, { data, loading, error }] = useChamberChangeAdminConsoleLoginEmailMutation({
 *   variables: {
 *      currentAdminConsoleLoginEmail: // value for 'currentAdminConsoleLoginEmail'
 *      newAdminConsoleLoginEmail: // value for 'newAdminConsoleLoginEmail'
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useChamberChangeAdminConsoleLoginEmailMutation(baseOptions?: Apollo.MutationHookOptions<ChamberChangeAdminConsoleLoginEmailMutation, ChamberChangeAdminConsoleLoginEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChamberChangeAdminConsoleLoginEmailMutation, ChamberChangeAdminConsoleLoginEmailMutationVariables>(ChamberChangeAdminConsoleLoginEmailDocument, options);
      }
export type ChamberChangeAdminConsoleLoginEmailMutationHookResult = ReturnType<typeof useChamberChangeAdminConsoleLoginEmailMutation>;
export type ChamberChangeAdminConsoleLoginEmailMutationResult = Apollo.MutationResult<ChamberChangeAdminConsoleLoginEmailMutation>;
export type ChamberChangeAdminConsoleLoginEmailMutationOptions = Apollo.BaseMutationOptions<ChamberChangeAdminConsoleLoginEmailMutation, ChamberChangeAdminConsoleLoginEmailMutationVariables>;
export const ChamberMemberChangeAdminConsoleLoginEmailDocument = gql`
    mutation chamberMemberChangeAdminConsoleLoginEmail($currentAdminConsoleLoginEmail: String!, $newAdminConsoleLoginEmail: String!, $chamberMemberId: String!) {
  chamberMemberChangeAdminConsoleLoginEmail(
    currentAdminConsoleLoginEmail: $currentAdminConsoleLoginEmail
    newAdminConsoleLoginEmail: $newAdminConsoleLoginEmail
    chamberMemberId: $chamberMemberId
  ) {
    password
    failureReason
    adminConsoleLoginEmailChangedSuccessfully
    email
  }
}
    `;
export type ChamberMemberChangeAdminConsoleLoginEmailMutationFn = Apollo.MutationFunction<ChamberMemberChangeAdminConsoleLoginEmailMutation, ChamberMemberChangeAdminConsoleLoginEmailMutationVariables>;

/**
 * __useChamberMemberChangeAdminConsoleLoginEmailMutation__
 *
 * To run a mutation, you first call `useChamberMemberChangeAdminConsoleLoginEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChamberMemberChangeAdminConsoleLoginEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chamberMemberChangeAdminConsoleLoginEmailMutation, { data, loading, error }] = useChamberMemberChangeAdminConsoleLoginEmailMutation({
 *   variables: {
 *      currentAdminConsoleLoginEmail: // value for 'currentAdminConsoleLoginEmail'
 *      newAdminConsoleLoginEmail: // value for 'newAdminConsoleLoginEmail'
 *      chamberMemberId: // value for 'chamberMemberId'
 *   },
 * });
 */
export function useChamberMemberChangeAdminConsoleLoginEmailMutation(baseOptions?: Apollo.MutationHookOptions<ChamberMemberChangeAdminConsoleLoginEmailMutation, ChamberMemberChangeAdminConsoleLoginEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChamberMemberChangeAdminConsoleLoginEmailMutation, ChamberMemberChangeAdminConsoleLoginEmailMutationVariables>(ChamberMemberChangeAdminConsoleLoginEmailDocument, options);
      }
export type ChamberMemberChangeAdminConsoleLoginEmailMutationHookResult = ReturnType<typeof useChamberMemberChangeAdminConsoleLoginEmailMutation>;
export type ChamberMemberChangeAdminConsoleLoginEmailMutationResult = Apollo.MutationResult<ChamberMemberChangeAdminConsoleLoginEmailMutation>;
export type ChamberMemberChangeAdminConsoleLoginEmailMutationOptions = Apollo.BaseMutationOptions<ChamberMemberChangeAdminConsoleLoginEmailMutation, ChamberMemberChangeAdminConsoleLoginEmailMutationVariables>;
export const ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerDocument = gql`
    mutation changeAutoApprovalForBannerContentOfCategoryAdvertisingBanner($chamberId: String, $categoryId: ChamberMemberCategory!, $autoApproveBannerContentUpdate: Boolean!) {
  changeAutoApprovalForBannerContentOfCategoryAdvertisingBanner(
    chamberId: $chamberId
    categoryId: $categoryId
    autoApproveBannerContentUpdate: $autoApproveBannerContentUpdate
  ) {
    autoApprovalUpdateSuccessful
  }
}
    `;
export type ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutationFn = Apollo.MutationFunction<ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation, ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutationVariables>;

/**
 * __useChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation__
 *
 * To run a mutation, you first call `useChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation, { data, loading, error }] = useChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      categoryId: // value for 'categoryId'
 *      autoApproveBannerContentUpdate: // value for 'autoApproveBannerContentUpdate'
 *   },
 * });
 */
export function useChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation(baseOptions?: Apollo.MutationHookOptions<ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation, ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation, ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutationVariables>(ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerDocument, options);
      }
export type ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutationHookResult = ReturnType<typeof useChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation>;
export type ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutationResult = Apollo.MutationResult<ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation>;
export type ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutationOptions = Apollo.BaseMutationOptions<ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutation, ChangeAutoApprovalForBannerContentOfCategoryAdvertisingBannerMutationVariables>;
export const SetMyCmpMemberAutoRenewalDocument = gql`
    mutation setMyCmpMemberAutoRenewal($input: SetMyCmpMemberAutoRenewalInput!) {
  setMyCmpMemberAutoRenewal(input: $input) {
    ...CmpMyMemberAutoRenewal
  }
}
    ${CmpMyMemberAutoRenewalFragmentDoc}`;
export type SetMyCmpMemberAutoRenewalMutationFn = Apollo.MutationFunction<SetMyCmpMemberAutoRenewalMutation, SetMyCmpMemberAutoRenewalMutationVariables>;

/**
 * __useSetMyCmpMemberAutoRenewalMutation__
 *
 * To run a mutation, you first call `useSetMyCmpMemberAutoRenewalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyCmpMemberAutoRenewalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyCmpMemberAutoRenewalMutation, { data, loading, error }] = useSetMyCmpMemberAutoRenewalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMyCmpMemberAutoRenewalMutation(baseOptions?: Apollo.MutationHookOptions<SetMyCmpMemberAutoRenewalMutation, SetMyCmpMemberAutoRenewalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyCmpMemberAutoRenewalMutation, SetMyCmpMemberAutoRenewalMutationVariables>(SetMyCmpMemberAutoRenewalDocument, options);
      }
export type SetMyCmpMemberAutoRenewalMutationHookResult = ReturnType<typeof useSetMyCmpMemberAutoRenewalMutation>;
export type SetMyCmpMemberAutoRenewalMutationResult = Apollo.MutationResult<SetMyCmpMemberAutoRenewalMutation>;
export type SetMyCmpMemberAutoRenewalMutationOptions = Apollo.BaseMutationOptions<SetMyCmpMemberAutoRenewalMutation, SetMyCmpMemberAutoRenewalMutationVariables>;
export const StartMyCmpMemberCardUpdateDocument = gql`
    mutation startMyCmpMemberCardUpdate($input: StartMyCmpMemberCardUpdateInput!) {
  startMyCmpMemberCardUpdate(input: $input) {
    clientSecret
    connectedAccountId
    publishableKey
    setupIntentId
    cardOnFile {
      label
    }
  }
}
    `;
export type StartMyCmpMemberCardUpdateMutationFn = Apollo.MutationFunction<StartMyCmpMemberCardUpdateMutation, StartMyCmpMemberCardUpdateMutationVariables>;

/**
 * __useStartMyCmpMemberCardUpdateMutation__
 *
 * To run a mutation, you first call `useStartMyCmpMemberCardUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMyCmpMemberCardUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMyCmpMemberCardUpdateMutation, { data, loading, error }] = useStartMyCmpMemberCardUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartMyCmpMemberCardUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StartMyCmpMemberCardUpdateMutation, StartMyCmpMemberCardUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMyCmpMemberCardUpdateMutation, StartMyCmpMemberCardUpdateMutationVariables>(StartMyCmpMemberCardUpdateDocument, options);
      }
export type StartMyCmpMemberCardUpdateMutationHookResult = ReturnType<typeof useStartMyCmpMemberCardUpdateMutation>;
export type StartMyCmpMemberCardUpdateMutationResult = Apollo.MutationResult<StartMyCmpMemberCardUpdateMutation>;
export type StartMyCmpMemberCardUpdateMutationOptions = Apollo.BaseMutationOptions<StartMyCmpMemberCardUpdateMutation, StartMyCmpMemberCardUpdateMutationVariables>;
export const CompleteMyCmpMemberCardUpdateDocument = gql`
    mutation completeMyCmpMemberCardUpdate($input: CompleteMyCmpMemberCardUpdateInput!) {
  completeMyCmpMemberCardUpdate(input: $input) {
    ...CmpMyMemberAutoRenewal
  }
}
    ${CmpMyMemberAutoRenewalFragmentDoc}`;
export type CompleteMyCmpMemberCardUpdateMutationFn = Apollo.MutationFunction<CompleteMyCmpMemberCardUpdateMutation, CompleteMyCmpMemberCardUpdateMutationVariables>;

/**
 * __useCompleteMyCmpMemberCardUpdateMutation__
 *
 * To run a mutation, you first call `useCompleteMyCmpMemberCardUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMyCmpMemberCardUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMyCmpMemberCardUpdateMutation, { data, loading, error }] = useCompleteMyCmpMemberCardUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteMyCmpMemberCardUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CompleteMyCmpMemberCardUpdateMutation, CompleteMyCmpMemberCardUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteMyCmpMemberCardUpdateMutation, CompleteMyCmpMemberCardUpdateMutationVariables>(CompleteMyCmpMemberCardUpdateDocument, options);
      }
export type CompleteMyCmpMemberCardUpdateMutationHookResult = ReturnType<typeof useCompleteMyCmpMemberCardUpdateMutation>;
export type CompleteMyCmpMemberCardUpdateMutationResult = Apollo.MutationResult<CompleteMyCmpMemberCardUpdateMutation>;
export type CompleteMyCmpMemberCardUpdateMutationOptions = Apollo.BaseMutationOptions<CompleteMyCmpMemberCardUpdateMutation, CompleteMyCmpMemberCardUpdateMutationVariables>;
export const GetCmpMemberInvoiceDocumentDocument = gql`
    mutation getCmpMemberInvoiceDocument($input: CmpMemberInvoiceInput!) {
  getCmpMemberInvoiceDocument(input: $input) {
    filename
    contentType
    base64Data
    generatedAtUtcMilli
  }
}
    `;
export type GetCmpMemberInvoiceDocumentMutationFn = Apollo.MutationFunction<GetCmpMemberInvoiceDocumentMutation, GetCmpMemberInvoiceDocumentMutationVariables>;

/**
 * __useGetCmpMemberInvoiceDocumentMutation__
 *
 * To run a mutation, you first call `useGetCmpMemberInvoiceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetCmpMemberInvoiceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getCmpMemberInvoiceDocumentMutation, { data, loading, error }] = useGetCmpMemberInvoiceDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCmpMemberInvoiceDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GetCmpMemberInvoiceDocumentMutation, GetCmpMemberInvoiceDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetCmpMemberInvoiceDocumentMutation, GetCmpMemberInvoiceDocumentMutationVariables>(GetCmpMemberInvoiceDocumentDocument, options);
      }
export type GetCmpMemberInvoiceDocumentMutationHookResult = ReturnType<typeof useGetCmpMemberInvoiceDocumentMutation>;
export type GetCmpMemberInvoiceDocumentMutationResult = Apollo.MutationResult<GetCmpMemberInvoiceDocumentMutation>;
export type GetCmpMemberInvoiceDocumentMutationOptions = Apollo.BaseMutationOptions<GetCmpMemberInvoiceDocumentMutation, GetCmpMemberInvoiceDocumentMutationVariables>;
export const StartCmpMemberInvoiceCheckoutDocument = gql`
    mutation startCmpMemberInvoiceCheckout($input: StartCmpMemberInvoiceCheckoutInput!) {
  startCmpMemberInvoiceCheckout(input: $input) {
    checkoutUrl
  }
}
    `;
export type StartCmpMemberInvoiceCheckoutMutationFn = Apollo.MutationFunction<StartCmpMemberInvoiceCheckoutMutation, StartCmpMemberInvoiceCheckoutMutationVariables>;

/**
 * __useStartCmpMemberInvoiceCheckoutMutation__
 *
 * To run a mutation, you first call `useStartCmpMemberInvoiceCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCmpMemberInvoiceCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCmpMemberInvoiceCheckoutMutation, { data, loading, error }] = useStartCmpMemberInvoiceCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartCmpMemberInvoiceCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<StartCmpMemberInvoiceCheckoutMutation, StartCmpMemberInvoiceCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCmpMemberInvoiceCheckoutMutation, StartCmpMemberInvoiceCheckoutMutationVariables>(StartCmpMemberInvoiceCheckoutDocument, options);
      }
export type StartCmpMemberInvoiceCheckoutMutationHookResult = ReturnType<typeof useStartCmpMemberInvoiceCheckoutMutation>;
export type StartCmpMemberInvoiceCheckoutMutationResult = Apollo.MutationResult<StartCmpMemberInvoiceCheckoutMutation>;
export type StartCmpMemberInvoiceCheckoutMutationOptions = Apollo.BaseMutationOptions<StartCmpMemberInvoiceCheckoutMutation, StartCmpMemberInvoiceCheckoutMutationVariables>;
export const StartCmpMemberInvoiceCardFormDocument = gql`
    mutation startCmpMemberInvoiceCardForm($input: StartCmpMemberInvoiceCheckoutInput!) {
  startCmpMemberInvoiceCardForm(input: $input) {
    invoiceId
    checkoutSessionId
    clientSecret
    publishableKey
    connectedAccountId
    amountInCents
    currency
    expiresAtUtcMilli
  }
}
    `;
export type StartCmpMemberInvoiceCardFormMutationFn = Apollo.MutationFunction<StartCmpMemberInvoiceCardFormMutation, StartCmpMemberInvoiceCardFormMutationVariables>;

/**
 * __useStartCmpMemberInvoiceCardFormMutation__
 *
 * To run a mutation, you first call `useStartCmpMemberInvoiceCardFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCmpMemberInvoiceCardFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCmpMemberInvoiceCardFormMutation, { data, loading, error }] = useStartCmpMemberInvoiceCardFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartCmpMemberInvoiceCardFormMutation(baseOptions?: Apollo.MutationHookOptions<StartCmpMemberInvoiceCardFormMutation, StartCmpMemberInvoiceCardFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCmpMemberInvoiceCardFormMutation, StartCmpMemberInvoiceCardFormMutationVariables>(StartCmpMemberInvoiceCardFormDocument, options);
      }
export type StartCmpMemberInvoiceCardFormMutationHookResult = ReturnType<typeof useStartCmpMemberInvoiceCardFormMutation>;
export type StartCmpMemberInvoiceCardFormMutationResult = Apollo.MutationResult<StartCmpMemberInvoiceCardFormMutation>;
export type StartCmpMemberInvoiceCardFormMutationOptions = Apollo.BaseMutationOptions<StartCmpMemberInvoiceCardFormMutation, StartCmpMemberInvoiceCardFormMutationVariables>;
export const SaveCmpMemberInvoiceCardFormNoteDocument = gql`
    mutation saveCmpMemberInvoiceCardFormNote($input: SaveCmpMemberInvoiceCardFormNoteInput!) {
  saveCmpMemberInvoiceCardFormNote(input: $input)
}
    `;
export type SaveCmpMemberInvoiceCardFormNoteMutationFn = Apollo.MutationFunction<SaveCmpMemberInvoiceCardFormNoteMutation, SaveCmpMemberInvoiceCardFormNoteMutationVariables>;

/**
 * __useSaveCmpMemberInvoiceCardFormNoteMutation__
 *
 * To run a mutation, you first call `useSaveCmpMemberInvoiceCardFormNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCmpMemberInvoiceCardFormNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCmpMemberInvoiceCardFormNoteMutation, { data, loading, error }] = useSaveCmpMemberInvoiceCardFormNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCmpMemberInvoiceCardFormNoteMutation(baseOptions?: Apollo.MutationHookOptions<SaveCmpMemberInvoiceCardFormNoteMutation, SaveCmpMemberInvoiceCardFormNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCmpMemberInvoiceCardFormNoteMutation, SaveCmpMemberInvoiceCardFormNoteMutationVariables>(SaveCmpMemberInvoiceCardFormNoteDocument, options);
      }
export type SaveCmpMemberInvoiceCardFormNoteMutationHookResult = ReturnType<typeof useSaveCmpMemberInvoiceCardFormNoteMutation>;
export type SaveCmpMemberInvoiceCardFormNoteMutationResult = Apollo.MutationResult<SaveCmpMemberInvoiceCardFormNoteMutation>;
export type SaveCmpMemberInvoiceCardFormNoteMutationOptions = Apollo.BaseMutationOptions<SaveCmpMemberInvoiceCardFormNoteMutation, SaveCmpMemberInvoiceCardFormNoteMutationVariables>;
export const CreateAffinityProgramPartnerDocument = gql`
    mutation createAffinityProgramPartner($input: AffinityProgramPartnerInput!, $activationStartDateUtcMilli: Float!, $chamberId: String) {
  createAffinityProgramPartner(
    input: $input
    activationStartDateUtcMilli: $activationStartDateUtcMilli
    chamberId: $chamberId
  ) {
    affinityProgramPartnerCreatedSuccessfully
    id
  }
}
    `;
export type CreateAffinityProgramPartnerMutationFn = Apollo.MutationFunction<CreateAffinityProgramPartnerMutation, CreateAffinityProgramPartnerMutationVariables>;

/**
 * __useCreateAffinityProgramPartnerMutation__
 *
 * To run a mutation, you first call `useCreateAffinityProgramPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAffinityProgramPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAffinityProgramPartnerMutation, { data, loading, error }] = useCreateAffinityProgramPartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *      activationStartDateUtcMilli: // value for 'activationStartDateUtcMilli'
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useCreateAffinityProgramPartnerMutation(baseOptions?: Apollo.MutationHookOptions<CreateAffinityProgramPartnerMutation, CreateAffinityProgramPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAffinityProgramPartnerMutation, CreateAffinityProgramPartnerMutationVariables>(CreateAffinityProgramPartnerDocument, options);
      }
export type CreateAffinityProgramPartnerMutationHookResult = ReturnType<typeof useCreateAffinityProgramPartnerMutation>;
export type CreateAffinityProgramPartnerMutationResult = Apollo.MutationResult<CreateAffinityProgramPartnerMutation>;
export type CreateAffinityProgramPartnerMutationOptions = Apollo.BaseMutationOptions<CreateAffinityProgramPartnerMutation, CreateAffinityProgramPartnerMutationVariables>;
export const CreateAllMemberLoginCredentialsDocument = gql`
    mutation createAllMemberLoginCredentials {
  createAllMemberLoginCredentials {
    processId
  }
}
    `;
export type CreateAllMemberLoginCredentialsMutationFn = Apollo.MutationFunction<CreateAllMemberLoginCredentialsMutation, CreateAllMemberLoginCredentialsMutationVariables>;

/**
 * __useCreateAllMemberLoginCredentialsMutation__
 *
 * To run a mutation, you first call `useCreateAllMemberLoginCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAllMemberLoginCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAllMemberLoginCredentialsMutation, { data, loading, error }] = useCreateAllMemberLoginCredentialsMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateAllMemberLoginCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAllMemberLoginCredentialsMutation, CreateAllMemberLoginCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAllMemberLoginCredentialsMutation, CreateAllMemberLoginCredentialsMutationVariables>(CreateAllMemberLoginCredentialsDocument, options);
      }
export type CreateAllMemberLoginCredentialsMutationHookResult = ReturnType<typeof useCreateAllMemberLoginCredentialsMutation>;
export type CreateAllMemberLoginCredentialsMutationResult = Apollo.MutationResult<CreateAllMemberLoginCredentialsMutation>;
export type CreateAllMemberLoginCredentialsMutationOptions = Apollo.BaseMutationOptions<CreateAllMemberLoginCredentialsMutation, CreateAllMemberLoginCredentialsMutationVariables>;
export const CreateChamberContactableCompanyDocument = gql`
    mutation createChamberContactableCompany($input: CreateChamberContactableCompanyMutationInput!) {
  createChamberContactableCompany(input: $input) {
    id
    chamberId
    name
  }
}
    `;
export type CreateChamberContactableCompanyMutationFn = Apollo.MutationFunction<CreateChamberContactableCompanyMutation, CreateChamberContactableCompanyMutationVariables>;

/**
 * __useCreateChamberContactableCompanyMutation__
 *
 * To run a mutation, you first call `useCreateChamberContactableCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChamberContactableCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChamberContactableCompanyMutation, { data, loading, error }] = useCreateChamberContactableCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChamberContactableCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateChamberContactableCompanyMutation, CreateChamberContactableCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChamberContactableCompanyMutation, CreateChamberContactableCompanyMutationVariables>(CreateChamberContactableCompanyDocument, options);
      }
export type CreateChamberContactableCompanyMutationHookResult = ReturnType<typeof useCreateChamberContactableCompanyMutation>;
export type CreateChamberContactableCompanyMutationResult = Apollo.MutationResult<CreateChamberContactableCompanyMutation>;
export type CreateChamberContactableCompanyMutationOptions = Apollo.BaseMutationOptions<CreateChamberContactableCompanyMutation, CreateChamberContactableCompanyMutationVariables>;
export const CreateChamberMembersDocument = gql`
    mutation createChamberMembers($input: CreateChamberMembersMutationInput!) {
  createChamberMembers(input: $input) {
    results {
      chamberMemberAddedSuccessfully
      failureReason
      email
      password
    }
  }
}
    `;
export type CreateChamberMembersMutationFn = Apollo.MutationFunction<CreateChamberMembersMutation, CreateChamberMembersMutationVariables>;

/**
 * __useCreateChamberMembersMutation__
 *
 * To run a mutation, you first call `useCreateChamberMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChamberMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChamberMembersMutation, { data, loading, error }] = useCreateChamberMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChamberMembersMutation(baseOptions?: Apollo.MutationHookOptions<CreateChamberMembersMutation, CreateChamberMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChamberMembersMutation, CreateChamberMembersMutationVariables>(CreateChamberMembersDocument, options);
      }
export type CreateChamberMembersMutationHookResult = ReturnType<typeof useCreateChamberMembersMutation>;
export type CreateChamberMembersMutationResult = Apollo.MutationResult<CreateChamberMembersMutation>;
export type CreateChamberMembersMutationOptions = Apollo.BaseMutationOptions<CreateChamberMembersMutation, CreateChamberMembersMutationVariables>;
export const CreateChambersDocument = gql`
    mutation createChambers($input: CreateChamberMutationInput!) {
  createChambers(input: $input) {
    results {
      chamberAddedSuccessfully
      email
      password
      failureReason
    }
  }
}
    `;
export type CreateChambersMutationFn = Apollo.MutationFunction<CreateChambersMutation, CreateChambersMutationVariables>;

/**
 * __useCreateChambersMutation__
 *
 * To run a mutation, you first call `useCreateChambersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChambersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChambersMutation, { data, loading, error }] = useCreateChambersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChambersMutation(baseOptions?: Apollo.MutationHookOptions<CreateChambersMutation, CreateChambersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChambersMutation, CreateChambersMutationVariables>(CreateChambersDocument, options);
      }
export type CreateChambersMutationHookResult = ReturnType<typeof useCreateChambersMutation>;
export type CreateChambersMutationResult = Apollo.MutationResult<CreateChambersMutation>;
export type CreateChambersMutationOptions = Apollo.BaseMutationOptions<CreateChambersMutation, CreateChambersMutationVariables>;
export const CreateDiscountsDocument = gql`
    mutation createDiscounts($input: CreateDiscountsMutationInput!) {
  createDiscounts(input: $input) {
    discountsAddedSuccessfully
  }
}
    `;
export type CreateDiscountsMutationFn = Apollo.MutationFunction<CreateDiscountsMutation, CreateDiscountsMutationVariables>;

/**
 * __useCreateDiscountsMutation__
 *
 * To run a mutation, you first call `useCreateDiscountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscountsMutation, { data, loading, error }] = useCreateDiscountsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiscountsMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscountsMutation, CreateDiscountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscountsMutation, CreateDiscountsMutationVariables>(CreateDiscountsDocument, options);
      }
export type CreateDiscountsMutationHookResult = ReturnType<typeof useCreateDiscountsMutation>;
export type CreateDiscountsMutationResult = Apollo.MutationResult<CreateDiscountsMutation>;
export type CreateDiscountsMutationOptions = Apollo.BaseMutationOptions<CreateDiscountsMutation, CreateDiscountsMutationVariables>;
export const CreatePerkPartnerDiscountDocument = gql`
    mutation createPerkPartnerDiscount($input: PerkPartnerDiscountInput!) {
  createPerkPartnerDiscount(input: $input) {
    perkPartnerDiscountAddedSuccessfully
  }
}
    `;
export type CreatePerkPartnerDiscountMutationFn = Apollo.MutationFunction<CreatePerkPartnerDiscountMutation, CreatePerkPartnerDiscountMutationVariables>;

/**
 * __useCreatePerkPartnerDiscountMutation__
 *
 * To run a mutation, you first call `useCreatePerkPartnerDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePerkPartnerDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPerkPartnerDiscountMutation, { data, loading, error }] = useCreatePerkPartnerDiscountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePerkPartnerDiscountMutation(baseOptions?: Apollo.MutationHookOptions<CreatePerkPartnerDiscountMutation, CreatePerkPartnerDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePerkPartnerDiscountMutation, CreatePerkPartnerDiscountMutationVariables>(CreatePerkPartnerDiscountDocument, options);
      }
export type CreatePerkPartnerDiscountMutationHookResult = ReturnType<typeof useCreatePerkPartnerDiscountMutation>;
export type CreatePerkPartnerDiscountMutationResult = Apollo.MutationResult<CreatePerkPartnerDiscountMutation>;
export type CreatePerkPartnerDiscountMutationOptions = Apollo.BaseMutationOptions<CreatePerkPartnerDiscountMutation, CreatePerkPartnerDiscountMutationVariables>;
export const CreatePerkPartnerDiscountAdminUserDocument = gql`
    mutation createPerkPartnerDiscountAdminUser($input: PerkPartnerDiscountAdminUserInput!) {
  createPerkPartnerDiscountAdminUser(input: $input) {
    perkPartnerDiscountAdminUserCreatedSuccessfully
    email
    password
    failureReason
  }
}
    `;
export type CreatePerkPartnerDiscountAdminUserMutationFn = Apollo.MutationFunction<CreatePerkPartnerDiscountAdminUserMutation, CreatePerkPartnerDiscountAdminUserMutationVariables>;

/**
 * __useCreatePerkPartnerDiscountAdminUserMutation__
 *
 * To run a mutation, you first call `useCreatePerkPartnerDiscountAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePerkPartnerDiscountAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPerkPartnerDiscountAdminUserMutation, { data, loading, error }] = useCreatePerkPartnerDiscountAdminUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePerkPartnerDiscountAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<CreatePerkPartnerDiscountAdminUserMutation, CreatePerkPartnerDiscountAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePerkPartnerDiscountAdminUserMutation, CreatePerkPartnerDiscountAdminUserMutationVariables>(CreatePerkPartnerDiscountAdminUserDocument, options);
      }
export type CreatePerkPartnerDiscountAdminUserMutationHookResult = ReturnType<typeof useCreatePerkPartnerDiscountAdminUserMutation>;
export type CreatePerkPartnerDiscountAdminUserMutationResult = Apollo.MutationResult<CreatePerkPartnerDiscountAdminUserMutation>;
export type CreatePerkPartnerDiscountAdminUserMutationOptions = Apollo.BaseMutationOptions<CreatePerkPartnerDiscountAdminUserMutation, CreatePerkPartnerDiscountAdminUserMutationVariables>;
export const CreateRewardCampaignDocument = gql`
    mutation createRewardCampaign($input: RewardCampaignInput!) {
  createRewardCampaign(input: $input) {
    campaignCreatedSuccessfully
  }
}
    `;
export type CreateRewardCampaignMutationFn = Apollo.MutationFunction<CreateRewardCampaignMutation, CreateRewardCampaignMutationVariables>;

/**
 * __useCreateRewardCampaignMutation__
 *
 * To run a mutation, you first call `useCreateRewardCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRewardCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRewardCampaignMutation, { data, loading, error }] = useCreateRewardCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRewardCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateRewardCampaignMutation, CreateRewardCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRewardCampaignMutation, CreateRewardCampaignMutationVariables>(CreateRewardCampaignDocument, options);
      }
export type CreateRewardCampaignMutationHookResult = ReturnType<typeof useCreateRewardCampaignMutation>;
export type CreateRewardCampaignMutationResult = Apollo.MutationResult<CreateRewardCampaignMutation>;
export type CreateRewardCampaignMutationOptions = Apollo.BaseMutationOptions<CreateRewardCampaignMutation, CreateRewardCampaignMutationVariables>;
export const CreateShopLocalCampaignDocument = gql`
    mutation createShopLocalCampaign($input: ShopLocalCampaignInput!, $sendNotification: Boolean!) {
  createShopLocalCampaign(input: $input, sendNotification: $sendNotification) {
    shopLocalCampaignCreatedSuccessfully
    shopLocalCampaignId
    notificationDeliveryStatus
    notificationTargetCount
    notificationSuccessCount
    notificationFailureCount
  }
}
    `;
export type CreateShopLocalCampaignMutationFn = Apollo.MutationFunction<CreateShopLocalCampaignMutation, CreateShopLocalCampaignMutationVariables>;

/**
 * __useCreateShopLocalCampaignMutation__
 *
 * To run a mutation, you first call `useCreateShopLocalCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShopLocalCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShopLocalCampaignMutation, { data, loading, error }] = useCreateShopLocalCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sendNotification: // value for 'sendNotification'
 *   },
 * });
 */
export function useCreateShopLocalCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateShopLocalCampaignMutation, CreateShopLocalCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShopLocalCampaignMutation, CreateShopLocalCampaignMutationVariables>(CreateShopLocalCampaignDocument, options);
      }
export type CreateShopLocalCampaignMutationHookResult = ReturnType<typeof useCreateShopLocalCampaignMutation>;
export type CreateShopLocalCampaignMutationResult = Apollo.MutationResult<CreateShopLocalCampaignMutation>;
export type CreateShopLocalCampaignMutationOptions = Apollo.BaseMutationOptions<CreateShopLocalCampaignMutation, CreateShopLocalCampaignMutationVariables>;
export const DeactivateAffinityProgramPartnerDocument = gql`
    mutation deactivateAffinityProgramPartner($id: String!) {
  deactivateAffinityProgramPartner(id: $id) {
    affinityProgramPartnerDeactivatedSuccessfully
  }
}
    `;
export type DeactivateAffinityProgramPartnerMutationFn = Apollo.MutationFunction<DeactivateAffinityProgramPartnerMutation, DeactivateAffinityProgramPartnerMutationVariables>;

/**
 * __useDeactivateAffinityProgramPartnerMutation__
 *
 * To run a mutation, you first call `useDeactivateAffinityProgramPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAffinityProgramPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAffinityProgramPartnerMutation, { data, loading, error }] = useDeactivateAffinityProgramPartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateAffinityProgramPartnerMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAffinityProgramPartnerMutation, DeactivateAffinityProgramPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAffinityProgramPartnerMutation, DeactivateAffinityProgramPartnerMutationVariables>(DeactivateAffinityProgramPartnerDocument, options);
      }
export type DeactivateAffinityProgramPartnerMutationHookResult = ReturnType<typeof useDeactivateAffinityProgramPartnerMutation>;
export type DeactivateAffinityProgramPartnerMutationResult = Apollo.MutationResult<DeactivateAffinityProgramPartnerMutation>;
export type DeactivateAffinityProgramPartnerMutationOptions = Apollo.BaseMutationOptions<DeactivateAffinityProgramPartnerMutation, DeactivateAffinityProgramPartnerMutationVariables>;
export const DeactivateBannerForCategoryAdvertisingBannerDocument = gql`
    mutation deactivateBannerForCategoryAdvertisingBanner($chamberId: String, $categoryId: ChamberMemberCategory!, $chamberMemberId: String!) {
  deactivateBannerForCategoryAdvertisingBanner(
    chamberId: $chamberId
    categoryId: $categoryId
    chamberMemberId: $chamberMemberId
  ) {
    deactivationSuccessful
  }
}
    `;
export type DeactivateBannerForCategoryAdvertisingBannerMutationFn = Apollo.MutationFunction<DeactivateBannerForCategoryAdvertisingBannerMutation, DeactivateBannerForCategoryAdvertisingBannerMutationVariables>;

/**
 * __useDeactivateBannerForCategoryAdvertisingBannerMutation__
 *
 * To run a mutation, you first call `useDeactivateBannerForCategoryAdvertisingBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateBannerForCategoryAdvertisingBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateBannerForCategoryAdvertisingBannerMutation, { data, loading, error }] = useDeactivateBannerForCategoryAdvertisingBannerMutation({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      categoryId: // value for 'categoryId'
 *      chamberMemberId: // value for 'chamberMemberId'
 *   },
 * });
 */
export function useDeactivateBannerForCategoryAdvertisingBannerMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateBannerForCategoryAdvertisingBannerMutation, DeactivateBannerForCategoryAdvertisingBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateBannerForCategoryAdvertisingBannerMutation, DeactivateBannerForCategoryAdvertisingBannerMutationVariables>(DeactivateBannerForCategoryAdvertisingBannerDocument, options);
      }
export type DeactivateBannerForCategoryAdvertisingBannerMutationHookResult = ReturnType<typeof useDeactivateBannerForCategoryAdvertisingBannerMutation>;
export type DeactivateBannerForCategoryAdvertisingBannerMutationResult = Apollo.MutationResult<DeactivateBannerForCategoryAdvertisingBannerMutation>;
export type DeactivateBannerForCategoryAdvertisingBannerMutationOptions = Apollo.BaseMutationOptions<DeactivateBannerForCategoryAdvertisingBannerMutation, DeactivateBannerForCategoryAdvertisingBannerMutationVariables>;
export const DeactivateMemberProfileAndPerksBannersForChamberMemberDocument = gql`
    mutation deactivateMemberProfileAndPerksBannersForChamberMember($chamberId: String, $chamberMemberId: String!) {
  deactivateMemberProfileAndPerksBannersForChamberMember(
    chamberId: $chamberId
    chamberMemberId: $chamberMemberId
  ) {
    deactivationSuccessful
  }
}
    `;
export type DeactivateMemberProfileAndPerksBannersForChamberMemberMutationFn = Apollo.MutationFunction<DeactivateMemberProfileAndPerksBannersForChamberMemberMutation, DeactivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>;

/**
 * __useDeactivateMemberProfileAndPerksBannersForChamberMemberMutation__
 *
 * To run a mutation, you first call `useDeactivateMemberProfileAndPerksBannersForChamberMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateMemberProfileAndPerksBannersForChamberMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateMemberProfileAndPerksBannersForChamberMemberMutation, { data, loading, error }] = useDeactivateMemberProfileAndPerksBannersForChamberMemberMutation({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      chamberMemberId: // value for 'chamberMemberId'
 *   },
 * });
 */
export function useDeactivateMemberProfileAndPerksBannersForChamberMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateMemberProfileAndPerksBannersForChamberMemberMutation, DeactivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateMemberProfileAndPerksBannersForChamberMemberMutation, DeactivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>(DeactivateMemberProfileAndPerksBannersForChamberMemberDocument, options);
      }
export type DeactivateMemberProfileAndPerksBannersForChamberMemberMutationHookResult = ReturnType<typeof useDeactivateMemberProfileAndPerksBannersForChamberMemberMutation>;
export type DeactivateMemberProfileAndPerksBannersForChamberMemberMutationResult = Apollo.MutationResult<DeactivateMemberProfileAndPerksBannersForChamberMemberMutation>;
export type DeactivateMemberProfileAndPerksBannersForChamberMemberMutationOptions = Apollo.BaseMutationOptions<DeactivateMemberProfileAndPerksBannersForChamberMemberMutation, DeactivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>;
export const DeleteChamberMemberDocument = gql`
    mutation deleteChamberMember($id: String!) {
  deleteChamberMember(id: $id) {
    id
  }
}
    `;
export type DeleteChamberMemberMutationFn = Apollo.MutationFunction<DeleteChamberMemberMutation, DeleteChamberMemberMutationVariables>;

/**
 * __useDeleteChamberMemberMutation__
 *
 * To run a mutation, you first call `useDeleteChamberMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChamberMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChamberMemberMutation, { data, loading, error }] = useDeleteChamberMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChamberMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChamberMemberMutation, DeleteChamberMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChamberMemberMutation, DeleteChamberMemberMutationVariables>(DeleteChamberMemberDocument, options);
      }
export type DeleteChamberMemberMutationHookResult = ReturnType<typeof useDeleteChamberMemberMutation>;
export type DeleteChamberMemberMutationResult = Apollo.MutationResult<DeleteChamberMemberMutation>;
export type DeleteChamberMemberMutationOptions = Apollo.BaseMutationOptions<DeleteChamberMemberMutation, DeleteChamberMemberMutationVariables>;
export const DeleteChamberDocument = gql`
    mutation deleteChamber($id: String!) {
  deleteChamber(id: $id) {
    id
  }
}
    `;
export type DeleteChamberMutationFn = Apollo.MutationFunction<DeleteChamberMutation, DeleteChamberMutationVariables>;

/**
 * __useDeleteChamberMutation__
 *
 * To run a mutation, you first call `useDeleteChamberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChamberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChamberMutation, { data, loading, error }] = useDeleteChamberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChamberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChamberMutation, DeleteChamberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChamberMutation, DeleteChamberMutationVariables>(DeleteChamberDocument, options);
      }
export type DeleteChamberMutationHookResult = ReturnType<typeof useDeleteChamberMutation>;
export type DeleteChamberMutationResult = Apollo.MutationResult<DeleteChamberMutation>;
export type DeleteChamberMutationOptions = Apollo.BaseMutationOptions<DeleteChamberMutation, DeleteChamberMutationVariables>;
export const DeleteDiscountDocument = gql`
    mutation deleteDiscount($id: String!) {
  deleteDiscount(id: $id) {
    id
  }
}
    `;
export type DeleteDiscountMutationFn = Apollo.MutationFunction<DeleteDiscountMutation, DeleteDiscountMutationVariables>;

/**
 * __useDeleteDiscountMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscountMutation, { data, loading, error }] = useDeleteDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiscountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiscountMutation, DeleteDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiscountMutation, DeleteDiscountMutationVariables>(DeleteDiscountDocument, options);
      }
export type DeleteDiscountMutationHookResult = ReturnType<typeof useDeleteDiscountMutation>;
export type DeleteDiscountMutationResult = Apollo.MutationResult<DeleteDiscountMutation>;
export type DeleteDiscountMutationOptions = Apollo.BaseMutationOptions<DeleteDiscountMutation, DeleteDiscountMutationVariables>;
export const DeletePerkPartnerDiscountDocument = gql`
    mutation deletePerkPartnerDiscount($id: String!) {
  deletePerkPartnerDiscount(id: $id) {
    id
  }
}
    `;
export type DeletePerkPartnerDiscountMutationFn = Apollo.MutationFunction<DeletePerkPartnerDiscountMutation, DeletePerkPartnerDiscountMutationVariables>;

/**
 * __useDeletePerkPartnerDiscountMutation__
 *
 * To run a mutation, you first call `useDeletePerkPartnerDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePerkPartnerDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePerkPartnerDiscountMutation, { data, loading, error }] = useDeletePerkPartnerDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePerkPartnerDiscountMutation(baseOptions?: Apollo.MutationHookOptions<DeletePerkPartnerDiscountMutation, DeletePerkPartnerDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePerkPartnerDiscountMutation, DeletePerkPartnerDiscountMutationVariables>(DeletePerkPartnerDiscountDocument, options);
      }
export type DeletePerkPartnerDiscountMutationHookResult = ReturnType<typeof useDeletePerkPartnerDiscountMutation>;
export type DeletePerkPartnerDiscountMutationResult = Apollo.MutationResult<DeletePerkPartnerDiscountMutation>;
export type DeletePerkPartnerDiscountMutationOptions = Apollo.BaseMutationOptions<DeletePerkPartnerDiscountMutation, DeletePerkPartnerDiscountMutationVariables>;
export const DeletePerkPartnerDiscountAdminUserDocument = gql`
    mutation deletePerkPartnerDiscountAdminUser($id: String!) {
  deletePerkPartnerDiscountAdminUser(id: $id) {
    id
  }
}
    `;
export type DeletePerkPartnerDiscountAdminUserMutationFn = Apollo.MutationFunction<DeletePerkPartnerDiscountAdminUserMutation, DeletePerkPartnerDiscountAdminUserMutationVariables>;

/**
 * __useDeletePerkPartnerDiscountAdminUserMutation__
 *
 * To run a mutation, you first call `useDeletePerkPartnerDiscountAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePerkPartnerDiscountAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePerkPartnerDiscountAdminUserMutation, { data, loading, error }] = useDeletePerkPartnerDiscountAdminUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePerkPartnerDiscountAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<DeletePerkPartnerDiscountAdminUserMutation, DeletePerkPartnerDiscountAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePerkPartnerDiscountAdminUserMutation, DeletePerkPartnerDiscountAdminUserMutationVariables>(DeletePerkPartnerDiscountAdminUserDocument, options);
      }
export type DeletePerkPartnerDiscountAdminUserMutationHookResult = ReturnType<typeof useDeletePerkPartnerDiscountAdminUserMutation>;
export type DeletePerkPartnerDiscountAdminUserMutationResult = Apollo.MutationResult<DeletePerkPartnerDiscountAdminUserMutation>;
export type DeletePerkPartnerDiscountAdminUserMutationOptions = Apollo.BaseMutationOptions<DeletePerkPartnerDiscountAdminUserMutation, DeletePerkPartnerDiscountAdminUserMutationVariables>;
export const DeletePerksLinkRequestDocument = gql`
    mutation deletePerksLinkRequest($requestId: String!, $deletionReason: PerksLinkDeletionReasonEnum!) {
  deletePerksLinkRequest(requestId: $requestId, deletionReason: $deletionReason) {
    perksLinkDeletedSuccessfully
  }
}
    `;
export type DeletePerksLinkRequestMutationFn = Apollo.MutationFunction<DeletePerksLinkRequestMutation, DeletePerksLinkRequestMutationVariables>;

/**
 * __useDeletePerksLinkRequestMutation__
 *
 * To run a mutation, you first call `useDeletePerksLinkRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePerksLinkRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePerksLinkRequestMutation, { data, loading, error }] = useDeletePerksLinkRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      deletionReason: // value for 'deletionReason'
 *   },
 * });
 */
export function useDeletePerksLinkRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeletePerksLinkRequestMutation, DeletePerksLinkRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePerksLinkRequestMutation, DeletePerksLinkRequestMutationVariables>(DeletePerksLinkRequestDocument, options);
      }
export type DeletePerksLinkRequestMutationHookResult = ReturnType<typeof useDeletePerksLinkRequestMutation>;
export type DeletePerksLinkRequestMutationResult = Apollo.MutationResult<DeletePerksLinkRequestMutation>;
export type DeletePerksLinkRequestMutationOptions = Apollo.BaseMutationOptions<DeletePerksLinkRequestMutation, DeletePerksLinkRequestMutationVariables>;
export const EndRewardCampaignDocument = gql`
    mutation endRewardCampaign($id: String!) {
  endRewardCampaign(id: $id) {
    campaignEndedSuccessfully
  }
}
    `;
export type EndRewardCampaignMutationFn = Apollo.MutationFunction<EndRewardCampaignMutation, EndRewardCampaignMutationVariables>;

/**
 * __useEndRewardCampaignMutation__
 *
 * To run a mutation, you first call `useEndRewardCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndRewardCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endRewardCampaignMutation, { data, loading, error }] = useEndRewardCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEndRewardCampaignMutation(baseOptions?: Apollo.MutationHookOptions<EndRewardCampaignMutation, EndRewardCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndRewardCampaignMutation, EndRewardCampaignMutationVariables>(EndRewardCampaignDocument, options);
      }
export type EndRewardCampaignMutationHookResult = ReturnType<typeof useEndRewardCampaignMutation>;
export type EndRewardCampaignMutationResult = Apollo.MutationResult<EndRewardCampaignMutation>;
export type EndRewardCampaignMutationOptions = Apollo.BaseMutationOptions<EndRewardCampaignMutation, EndRewardCampaignMutationVariables>;
export const EndShopLocalCampaignDocument = gql`
    mutation endShopLocalCampaign($id: String!) {
  endShopLocalCampaign(id: $id) {
    shopLocalCampaignEndedSuccessfully
  }
}
    `;
export type EndShopLocalCampaignMutationFn = Apollo.MutationFunction<EndShopLocalCampaignMutation, EndShopLocalCampaignMutationVariables>;

/**
 * __useEndShopLocalCampaignMutation__
 *
 * To run a mutation, you first call `useEndShopLocalCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndShopLocalCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endShopLocalCampaignMutation, { data, loading, error }] = useEndShopLocalCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEndShopLocalCampaignMutation(baseOptions?: Apollo.MutationHookOptions<EndShopLocalCampaignMutation, EndShopLocalCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndShopLocalCampaignMutation, EndShopLocalCampaignMutationVariables>(EndShopLocalCampaignDocument, options);
      }
export type EndShopLocalCampaignMutationHookResult = ReturnType<typeof useEndShopLocalCampaignMutation>;
export type EndShopLocalCampaignMutationResult = Apollo.MutationResult<EndShopLocalCampaignMutation>;
export type EndShopLocalCampaignMutationOptions = Apollo.BaseMutationOptions<EndShopLocalCampaignMutation, EndShopLocalCampaignMutationVariables>;
export const ExcludeChamberEngageActivationFromInvoiceDocument = gql`
    mutation excludeChamberEngageActivationFromInvoice($activationId: String!, $activationType: ChamberEngageActivationTypeEnum!) {
  excludeChamberEngageActivationFromInvoice(
    activationId: $activationId
    activationType: $activationType
  ) {
    excluded
  }
}
    `;
export type ExcludeChamberEngageActivationFromInvoiceMutationFn = Apollo.MutationFunction<ExcludeChamberEngageActivationFromInvoiceMutation, ExcludeChamberEngageActivationFromInvoiceMutationVariables>;

/**
 * __useExcludeChamberEngageActivationFromInvoiceMutation__
 *
 * To run a mutation, you first call `useExcludeChamberEngageActivationFromInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcludeChamberEngageActivationFromInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excludeChamberEngageActivationFromInvoiceMutation, { data, loading, error }] = useExcludeChamberEngageActivationFromInvoiceMutation({
 *   variables: {
 *      activationId: // value for 'activationId'
 *      activationType: // value for 'activationType'
 *   },
 * });
 */
export function useExcludeChamberEngageActivationFromInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ExcludeChamberEngageActivationFromInvoiceMutation, ExcludeChamberEngageActivationFromInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExcludeChamberEngageActivationFromInvoiceMutation, ExcludeChamberEngageActivationFromInvoiceMutationVariables>(ExcludeChamberEngageActivationFromInvoiceDocument, options);
      }
export type ExcludeChamberEngageActivationFromInvoiceMutationHookResult = ReturnType<typeof useExcludeChamberEngageActivationFromInvoiceMutation>;
export type ExcludeChamberEngageActivationFromInvoiceMutationResult = Apollo.MutationResult<ExcludeChamberEngageActivationFromInvoiceMutation>;
export type ExcludeChamberEngageActivationFromInvoiceMutationOptions = Apollo.BaseMutationOptions<ExcludeChamberEngageActivationFromInvoiceMutation, ExcludeChamberEngageActivationFromInvoiceMutationVariables>;
export const GetSupportCenterUrlDocument = gql`
    mutation GetSupportCenterUrl($nonce: String!, $state: String!) {
  getSupportCenterUrl(nonce: $nonce, state: $state)
}
    `;
export type GetSupportCenterUrlMutationFn = Apollo.MutationFunction<GetSupportCenterUrlMutation, GetSupportCenterUrlMutationVariables>;

/**
 * __useGetSupportCenterUrlMutation__
 *
 * To run a mutation, you first call `useGetSupportCenterUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSupportCenterUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSupportCenterUrlMutation, { data, loading, error }] = useGetSupportCenterUrlMutation({
 *   variables: {
 *      nonce: // value for 'nonce'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetSupportCenterUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetSupportCenterUrlMutation, GetSupportCenterUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetSupportCenterUrlMutation, GetSupportCenterUrlMutationVariables>(GetSupportCenterUrlDocument, options);
      }
export type GetSupportCenterUrlMutationHookResult = ReturnType<typeof useGetSupportCenterUrlMutation>;
export type GetSupportCenterUrlMutationResult = Apollo.MutationResult<GetSupportCenterUrlMutation>;
export type GetSupportCenterUrlMutationOptions = Apollo.BaseMutationOptions<GetSupportCenterUrlMutation, GetSupportCenterUrlMutationVariables>;
export const IdaGenerateDocument = gql`
    mutation idaGenerate($input: IDAGenerateInput!) {
  idaGenerate(input: $input) {
    success
    generatedText
    suggestedCategories {
      id
      name
    }
  }
}
    `;
export type IdaGenerateMutationFn = Apollo.MutationFunction<IdaGenerateMutation, IdaGenerateMutationVariables>;

/**
 * __useIdaGenerateMutation__
 *
 * To run a mutation, you first call `useIdaGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdaGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [idaGenerateMutation, { data, loading, error }] = useIdaGenerateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIdaGenerateMutation(baseOptions?: Apollo.MutationHookOptions<IdaGenerateMutation, IdaGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IdaGenerateMutation, IdaGenerateMutationVariables>(IdaGenerateDocument, options);
      }
export type IdaGenerateMutationHookResult = ReturnType<typeof useIdaGenerateMutation>;
export type IdaGenerateMutationResult = Apollo.MutationResult<IdaGenerateMutation>;
export type IdaGenerateMutationOptions = Apollo.BaseMutationOptions<IdaGenerateMutation, IdaGenerateMutationVariables>;
export const IncludeChamberEngageActivationInInvoiceDocument = gql`
    mutation includeChamberEngageActivationInInvoice($activationId: String!, $activationType: ChamberEngageActivationTypeEnum!) {
  includeChamberEngageActivationInInvoice(
    activationId: $activationId
    activationType: $activationType
  ) {
    included
  }
}
    `;
export type IncludeChamberEngageActivationInInvoiceMutationFn = Apollo.MutationFunction<IncludeChamberEngageActivationInInvoiceMutation, IncludeChamberEngageActivationInInvoiceMutationVariables>;

/**
 * __useIncludeChamberEngageActivationInInvoiceMutation__
 *
 * To run a mutation, you first call `useIncludeChamberEngageActivationInInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIncludeChamberEngageActivationInInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [includeChamberEngageActivationInInvoiceMutation, { data, loading, error }] = useIncludeChamberEngageActivationInInvoiceMutation({
 *   variables: {
 *      activationId: // value for 'activationId'
 *      activationType: // value for 'activationType'
 *   },
 * });
 */
export function useIncludeChamberEngageActivationInInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<IncludeChamberEngageActivationInInvoiceMutation, IncludeChamberEngageActivationInInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IncludeChamberEngageActivationInInvoiceMutation, IncludeChamberEngageActivationInInvoiceMutationVariables>(IncludeChamberEngageActivationInInvoiceDocument, options);
      }
export type IncludeChamberEngageActivationInInvoiceMutationHookResult = ReturnType<typeof useIncludeChamberEngageActivationInInvoiceMutation>;
export type IncludeChamberEngageActivationInInvoiceMutationResult = Apollo.MutationResult<IncludeChamberEngageActivationInInvoiceMutation>;
export type IncludeChamberEngageActivationInInvoiceMutationOptions = Apollo.BaseMutationOptions<IncludeChamberEngageActivationInInvoiceMutation, IncludeChamberEngageActivationInInvoiceMutationVariables>;
export const ManageMyCmpMemberContactAccountDocument = gql`
    mutation manageMyCmpMemberContactAccount($input: ManageMyCmpMemberContactAccountInput!) {
  manageMyCmpMemberContactAccount(input: $input) {
    memberUpdatedAtUtcMilli
    deliveryConfirmed
    trackingWarning
    credentials {
      email
      password
      loginUrl
    }
    accounts {
      contactId
      name
      email
      usesLegacyMemberAccount
      credentialActionsBlockedReason
      enabled
      hasSignedUp
      credentialsSentAtUtcMilli
      lastDashboardLoginAtUtcMilli
    }
  }
}
    `;
export type ManageMyCmpMemberContactAccountMutationFn = Apollo.MutationFunction<ManageMyCmpMemberContactAccountMutation, ManageMyCmpMemberContactAccountMutationVariables>;

/**
 * __useManageMyCmpMemberContactAccountMutation__
 *
 * To run a mutation, you first call `useManageMyCmpMemberContactAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageMyCmpMemberContactAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageMyCmpMemberContactAccountMutation, { data, loading, error }] = useManageMyCmpMemberContactAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManageMyCmpMemberContactAccountMutation(baseOptions?: Apollo.MutationHookOptions<ManageMyCmpMemberContactAccountMutation, ManageMyCmpMemberContactAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageMyCmpMemberContactAccountMutation, ManageMyCmpMemberContactAccountMutationVariables>(ManageMyCmpMemberContactAccountDocument, options);
      }
export type ManageMyCmpMemberContactAccountMutationHookResult = ReturnType<typeof useManageMyCmpMemberContactAccountMutation>;
export type ManageMyCmpMemberContactAccountMutationResult = Apollo.MutationResult<ManageMyCmpMemberContactAccountMutation>;
export type ManageMyCmpMemberContactAccountMutationOptions = Apollo.BaseMutationOptions<ManageMyCmpMemberContactAccountMutation, ManageMyCmpMemberContactAccountMutationVariables>;
export const MarkChamberEngageActivationInvoicedDocument = gql`
    mutation MarkChamberEngageActivationInvoiced($activationsToMarkInvoiced: [ChamberEngageActivationToMarkInvoicedInput!]!) {
  markChamberEngageActivationInvoiced(
    activationsToMarkInvoiced: $activationsToMarkInvoiced
  ) {
    marked
  }
}
    `;
export type MarkChamberEngageActivationInvoicedMutationFn = Apollo.MutationFunction<MarkChamberEngageActivationInvoicedMutation, MarkChamberEngageActivationInvoicedMutationVariables>;

/**
 * __useMarkChamberEngageActivationInvoicedMutation__
 *
 * To run a mutation, you first call `useMarkChamberEngageActivationInvoicedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChamberEngageActivationInvoicedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChamberEngageActivationInvoicedMutation, { data, loading, error }] = useMarkChamberEngageActivationInvoicedMutation({
 *   variables: {
 *      activationsToMarkInvoiced: // value for 'activationsToMarkInvoiced'
 *   },
 * });
 */
export function useMarkChamberEngageActivationInvoicedMutation(baseOptions?: Apollo.MutationHookOptions<MarkChamberEngageActivationInvoicedMutation, MarkChamberEngageActivationInvoicedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkChamberEngageActivationInvoicedMutation, MarkChamberEngageActivationInvoicedMutationVariables>(MarkChamberEngageActivationInvoicedDocument, options);
      }
export type MarkChamberEngageActivationInvoicedMutationHookResult = ReturnType<typeof useMarkChamberEngageActivationInvoicedMutation>;
export type MarkChamberEngageActivationInvoicedMutationResult = Apollo.MutationResult<MarkChamberEngageActivationInvoicedMutation>;
export type MarkChamberEngageActivationInvoicedMutationOptions = Apollo.BaseMutationOptions<MarkChamberEngageActivationInvoicedMutation, MarkChamberEngageActivationInvoicedMutationVariables>;
export const MassSendLoginInfoEmailDocument = gql`
    mutation massSendLoginInfoEmail {
  massSendLoginInfoEmail {
    successCount
    failureCount
    totalCount
  }
}
    `;
export type MassSendLoginInfoEmailMutationFn = Apollo.MutationFunction<MassSendLoginInfoEmailMutation, MassSendLoginInfoEmailMutationVariables>;

/**
 * __useMassSendLoginInfoEmailMutation__
 *
 * To run a mutation, you first call `useMassSendLoginInfoEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassSendLoginInfoEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massSendLoginInfoEmailMutation, { data, loading, error }] = useMassSendLoginInfoEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useMassSendLoginInfoEmailMutation(baseOptions?: Apollo.MutationHookOptions<MassSendLoginInfoEmailMutation, MassSendLoginInfoEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MassSendLoginInfoEmailMutation, MassSendLoginInfoEmailMutationVariables>(MassSendLoginInfoEmailDocument, options);
      }
export type MassSendLoginInfoEmailMutationHookResult = ReturnType<typeof useMassSendLoginInfoEmailMutation>;
export type MassSendLoginInfoEmailMutationResult = Apollo.MutationResult<MassSendLoginInfoEmailMutation>;
export type MassSendLoginInfoEmailMutationOptions = Apollo.BaseMutationOptions<MassSendLoginInfoEmailMutation, MassSendLoginInfoEmailMutationVariables>;
export const ReactivateAffinityProgramPartnerDocument = gql`
    mutation reactivateAffinityProgramPartner($id: String!) {
  reactivateAffinityProgramPartner(id: $id) {
    affinityProgramPartnerReactivatedSuccessfully
  }
}
    `;
export type ReactivateAffinityProgramPartnerMutationFn = Apollo.MutationFunction<ReactivateAffinityProgramPartnerMutation, ReactivateAffinityProgramPartnerMutationVariables>;

/**
 * __useReactivateAffinityProgramPartnerMutation__
 *
 * To run a mutation, you first call `useReactivateAffinityProgramPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateAffinityProgramPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateAffinityProgramPartnerMutation, { data, loading, error }] = useReactivateAffinityProgramPartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReactivateAffinityProgramPartnerMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateAffinityProgramPartnerMutation, ReactivateAffinityProgramPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateAffinityProgramPartnerMutation, ReactivateAffinityProgramPartnerMutationVariables>(ReactivateAffinityProgramPartnerDocument, options);
      }
export type ReactivateAffinityProgramPartnerMutationHookResult = ReturnType<typeof useReactivateAffinityProgramPartnerMutation>;
export type ReactivateAffinityProgramPartnerMutationResult = Apollo.MutationResult<ReactivateAffinityProgramPartnerMutation>;
export type ReactivateAffinityProgramPartnerMutationOptions = Apollo.BaseMutationOptions<ReactivateAffinityProgramPartnerMutation, ReactivateAffinityProgramPartnerMutationVariables>;
export const ReactivateBannerForCategoryAdvertisingBannerDocument = gql`
    mutation reactivateBannerForCategoryAdvertisingBanner($chamberId: String, $categoryId: ChamberMemberCategory!, $reactivationInfo: CategoryAdvertisingBannerReactivationInfoInput!) {
  reactivateBannerForCategoryAdvertisingBanner(
    chamberId: $chamberId
    categoryId: $categoryId
    reactivationInfo: $reactivationInfo
  ) {
    bannerActivatedSuccessfully
  }
}
    `;
export type ReactivateBannerForCategoryAdvertisingBannerMutationFn = Apollo.MutationFunction<ReactivateBannerForCategoryAdvertisingBannerMutation, ReactivateBannerForCategoryAdvertisingBannerMutationVariables>;

/**
 * __useReactivateBannerForCategoryAdvertisingBannerMutation__
 *
 * To run a mutation, you first call `useReactivateBannerForCategoryAdvertisingBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateBannerForCategoryAdvertisingBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateBannerForCategoryAdvertisingBannerMutation, { data, loading, error }] = useReactivateBannerForCategoryAdvertisingBannerMutation({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      categoryId: // value for 'categoryId'
 *      reactivationInfo: // value for 'reactivationInfo'
 *   },
 * });
 */
export function useReactivateBannerForCategoryAdvertisingBannerMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateBannerForCategoryAdvertisingBannerMutation, ReactivateBannerForCategoryAdvertisingBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateBannerForCategoryAdvertisingBannerMutation, ReactivateBannerForCategoryAdvertisingBannerMutationVariables>(ReactivateBannerForCategoryAdvertisingBannerDocument, options);
      }
export type ReactivateBannerForCategoryAdvertisingBannerMutationHookResult = ReturnType<typeof useReactivateBannerForCategoryAdvertisingBannerMutation>;
export type ReactivateBannerForCategoryAdvertisingBannerMutationResult = Apollo.MutationResult<ReactivateBannerForCategoryAdvertisingBannerMutation>;
export type ReactivateBannerForCategoryAdvertisingBannerMutationOptions = Apollo.BaseMutationOptions<ReactivateBannerForCategoryAdvertisingBannerMutation, ReactivateBannerForCategoryAdvertisingBannerMutationVariables>;
export const ReactivateMemberProfileAndPerksBannersForChamberMemberDocument = gql`
    mutation reactivateMemberProfileAndPerksBannersForChamberMember($chamberId: String, $chamberMemberId: String!) {
  reactivateMemberProfileAndPerksBannersForChamberMember(
    chamberId: $chamberId
    chamberMemberId: $chamberMemberId
  ) {
    activationSuccessful
  }
}
    `;
export type ReactivateMemberProfileAndPerksBannersForChamberMemberMutationFn = Apollo.MutationFunction<ReactivateMemberProfileAndPerksBannersForChamberMemberMutation, ReactivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>;

/**
 * __useReactivateMemberProfileAndPerksBannersForChamberMemberMutation__
 *
 * To run a mutation, you first call `useReactivateMemberProfileAndPerksBannersForChamberMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateMemberProfileAndPerksBannersForChamberMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateMemberProfileAndPerksBannersForChamberMemberMutation, { data, loading, error }] = useReactivateMemberProfileAndPerksBannersForChamberMemberMutation({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      chamberMemberId: // value for 'chamberMemberId'
 *   },
 * });
 */
export function useReactivateMemberProfileAndPerksBannersForChamberMemberMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateMemberProfileAndPerksBannersForChamberMemberMutation, ReactivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateMemberProfileAndPerksBannersForChamberMemberMutation, ReactivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>(ReactivateMemberProfileAndPerksBannersForChamberMemberDocument, options);
      }
export type ReactivateMemberProfileAndPerksBannersForChamberMemberMutationHookResult = ReturnType<typeof useReactivateMemberProfileAndPerksBannersForChamberMemberMutation>;
export type ReactivateMemberProfileAndPerksBannersForChamberMemberMutationResult = Apollo.MutationResult<ReactivateMemberProfileAndPerksBannersForChamberMemberMutation>;
export type ReactivateMemberProfileAndPerksBannersForChamberMemberMutationOptions = Apollo.BaseMutationOptions<ReactivateMemberProfileAndPerksBannersForChamberMemberMutation, ReactivateMemberProfileAndPerksBannersForChamberMemberMutationVariables>;
export const RecordCmpMemberDashboardLoginDocument = gql`
    mutation recordCmpMemberDashboardLogin {
  recordCmpMemberDashboardLogin
}
    `;
export type RecordCmpMemberDashboardLoginMutationFn = Apollo.MutationFunction<RecordCmpMemberDashboardLoginMutation, RecordCmpMemberDashboardLoginMutationVariables>;

/**
 * __useRecordCmpMemberDashboardLoginMutation__
 *
 * To run a mutation, you first call `useRecordCmpMemberDashboardLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCmpMemberDashboardLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCmpMemberDashboardLoginMutation, { data, loading, error }] = useRecordCmpMemberDashboardLoginMutation({
 *   variables: {
 *   },
 * });
 */
export function useRecordCmpMemberDashboardLoginMutation(baseOptions?: Apollo.MutationHookOptions<RecordCmpMemberDashboardLoginMutation, RecordCmpMemberDashboardLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordCmpMemberDashboardLoginMutation, RecordCmpMemberDashboardLoginMutationVariables>(RecordCmpMemberDashboardLoginDocument, options);
      }
export type RecordCmpMemberDashboardLoginMutationHookResult = ReturnType<typeof useRecordCmpMemberDashboardLoginMutation>;
export type RecordCmpMemberDashboardLoginMutationResult = Apollo.MutationResult<RecordCmpMemberDashboardLoginMutation>;
export type RecordCmpMemberDashboardLoginMutationOptions = Apollo.BaseMutationOptions<RecordCmpMemberDashboardLoginMutation, RecordCmpMemberDashboardLoginMutationVariables>;
export const RecordCpaDashboardAccessDocument = gql`
    mutation recordCpaDashboardAccess {
  recordCpaDashboardAccess
}
    `;
export type RecordCpaDashboardAccessMutationFn = Apollo.MutationFunction<RecordCpaDashboardAccessMutation, RecordCpaDashboardAccessMutationVariables>;

/**
 * __useRecordCpaDashboardAccessMutation__
 *
 * To run a mutation, you first call `useRecordCpaDashboardAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCpaDashboardAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCpaDashboardAccessMutation, { data, loading, error }] = useRecordCpaDashboardAccessMutation({
 *   variables: {
 *   },
 * });
 */
export function useRecordCpaDashboardAccessMutation(baseOptions?: Apollo.MutationHookOptions<RecordCpaDashboardAccessMutation, RecordCpaDashboardAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordCpaDashboardAccessMutation, RecordCpaDashboardAccessMutationVariables>(RecordCpaDashboardAccessDocument, options);
      }
export type RecordCpaDashboardAccessMutationHookResult = ReturnType<typeof useRecordCpaDashboardAccessMutation>;
export type RecordCpaDashboardAccessMutationResult = Apollo.MutationResult<RecordCpaDashboardAccessMutation>;
export type RecordCpaDashboardAccessMutationOptions = Apollo.BaseMutationOptions<RecordCpaDashboardAccessMutation, RecordCpaDashboardAccessMutationVariables>;
export const RequestMemberDashboardCredentialsDocument = gql`
    mutation requestMemberDashboardCredentials($chamberId: String!, $chamberMemberId: String!) {
  requestMemberDashboardCredentials(
    chamberId: $chamberId
    chamberMemberId: $chamberMemberId
  ) {
    success
    chamberName
    chamberSupportContactEmail
  }
}
    `;
export type RequestMemberDashboardCredentialsMutationFn = Apollo.MutationFunction<RequestMemberDashboardCredentialsMutation, RequestMemberDashboardCredentialsMutationVariables>;

/**
 * __useRequestMemberDashboardCredentialsMutation__
 *
 * To run a mutation, you first call `useRequestMemberDashboardCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMemberDashboardCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMemberDashboardCredentialsMutation, { data, loading, error }] = useRequestMemberDashboardCredentialsMutation({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      chamberMemberId: // value for 'chamberMemberId'
 *   },
 * });
 */
export function useRequestMemberDashboardCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<RequestMemberDashboardCredentialsMutation, RequestMemberDashboardCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMemberDashboardCredentialsMutation, RequestMemberDashboardCredentialsMutationVariables>(RequestMemberDashboardCredentialsDocument, options);
      }
export type RequestMemberDashboardCredentialsMutationHookResult = ReturnType<typeof useRequestMemberDashboardCredentialsMutation>;
export type RequestMemberDashboardCredentialsMutationResult = Apollo.MutationResult<RequestMemberDashboardCredentialsMutation>;
export type RequestMemberDashboardCredentialsMutationOptions = Apollo.BaseMutationOptions<RequestMemberDashboardCredentialsMutation, RequestMemberDashboardCredentialsMutationVariables>;
export const RequestPerksLinkDocument = gql`
    mutation requestPerksLink($requestingLinkToChamberId: String!) {
  requestPerksLink(requestingLinkToChamberId: $requestingLinkToChamberId) {
    perksLinkRequestedSuccessfully
  }
}
    `;
export type RequestPerksLinkMutationFn = Apollo.MutationFunction<RequestPerksLinkMutation, RequestPerksLinkMutationVariables>;

/**
 * __useRequestPerksLinkMutation__
 *
 * To run a mutation, you first call `useRequestPerksLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPerksLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPerksLinkMutation, { data, loading, error }] = useRequestPerksLinkMutation({
 *   variables: {
 *      requestingLinkToChamberId: // value for 'requestingLinkToChamberId'
 *   },
 * });
 */
export function useRequestPerksLinkMutation(baseOptions?: Apollo.MutationHookOptions<RequestPerksLinkMutation, RequestPerksLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPerksLinkMutation, RequestPerksLinkMutationVariables>(RequestPerksLinkDocument, options);
      }
export type RequestPerksLinkMutationHookResult = ReturnType<typeof useRequestPerksLinkMutation>;
export type RequestPerksLinkMutationResult = Apollo.MutationResult<RequestPerksLinkMutation>;
export type RequestPerksLinkMutationOptions = Apollo.BaseMutationOptions<RequestPerksLinkMutation, RequestPerksLinkMutationVariables>;
export const SelectMemberDashboardChamberDocument = gql`
    mutation selectMemberDashboardChamber($chamberId: String!) {
  selectMemberDashboardChamber(chamberId: $chamberId) {
    selected
    chamberId
  }
}
    `;
export type SelectMemberDashboardChamberMutationFn = Apollo.MutationFunction<SelectMemberDashboardChamberMutation, SelectMemberDashboardChamberMutationVariables>;

/**
 * __useSelectMemberDashboardChamberMutation__
 *
 * To run a mutation, you first call `useSelectMemberDashboardChamberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectMemberDashboardChamberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectMemberDashboardChamberMutation, { data, loading, error }] = useSelectMemberDashboardChamberMutation({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useSelectMemberDashboardChamberMutation(baseOptions?: Apollo.MutationHookOptions<SelectMemberDashboardChamberMutation, SelectMemberDashboardChamberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectMemberDashboardChamberMutation, SelectMemberDashboardChamberMutationVariables>(SelectMemberDashboardChamberDocument, options);
      }
export type SelectMemberDashboardChamberMutationHookResult = ReturnType<typeof useSelectMemberDashboardChamberMutation>;
export type SelectMemberDashboardChamberMutationResult = Apollo.MutationResult<SelectMemberDashboardChamberMutation>;
export type SelectMemberDashboardChamberMutationOptions = Apollo.BaseMutationOptions<SelectMemberDashboardChamberMutation, SelectMemberDashboardChamberMutationVariables>;
export const SendCmpMemberDashboardHelpRequestDocument = gql`
    mutation sendCmpMemberDashboardHelpRequest($input: SendCmpMemberDashboardHelpRequestInput!) {
  sendCmpMemberDashboardHelpRequest(input: $input) {
    chamberName
    replyToEmail
  }
}
    `;
export type SendCmpMemberDashboardHelpRequestMutationFn = Apollo.MutationFunction<SendCmpMemberDashboardHelpRequestMutation, SendCmpMemberDashboardHelpRequestMutationVariables>;

/**
 * __useSendCmpMemberDashboardHelpRequestMutation__
 *
 * To run a mutation, you first call `useSendCmpMemberDashboardHelpRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCmpMemberDashboardHelpRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCmpMemberDashboardHelpRequestMutation, { data, loading, error }] = useSendCmpMemberDashboardHelpRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCmpMemberDashboardHelpRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendCmpMemberDashboardHelpRequestMutation, SendCmpMemberDashboardHelpRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCmpMemberDashboardHelpRequestMutation, SendCmpMemberDashboardHelpRequestMutationVariables>(SendCmpMemberDashboardHelpRequestDocument, options);
      }
export type SendCmpMemberDashboardHelpRequestMutationHookResult = ReturnType<typeof useSendCmpMemberDashboardHelpRequestMutation>;
export type SendCmpMemberDashboardHelpRequestMutationResult = Apollo.MutationResult<SendCmpMemberDashboardHelpRequestMutation>;
export type SendCmpMemberDashboardHelpRequestMutationOptions = Apollo.BaseMutationOptions<SendCmpMemberDashboardHelpRequestMutation, SendCmpMemberDashboardHelpRequestMutationVariables>;
export const SendLoginInfoEmailToChamberMemberDocument = gql`
    mutation sendLoginInfoEmailToChamberMember($adminConsoleLoginEmail: String!, $chamberMemberId: String!, $type: LoginInfoEmailTypes!) {
  sendLoginInfoEmailToChamberMember(
    adminConsoleLoginEmail: $adminConsoleLoginEmail
    chamberMemberId: $chamberMemberId
    type: $type
  ) {
    loginInfoEmailSentSuccessfully
  }
}
    `;
export type SendLoginInfoEmailToChamberMemberMutationFn = Apollo.MutationFunction<SendLoginInfoEmailToChamberMemberMutation, SendLoginInfoEmailToChamberMemberMutationVariables>;

/**
 * __useSendLoginInfoEmailToChamberMemberMutation__
 *
 * To run a mutation, you first call `useSendLoginInfoEmailToChamberMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLoginInfoEmailToChamberMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLoginInfoEmailToChamberMemberMutation, { data, loading, error }] = useSendLoginInfoEmailToChamberMemberMutation({
 *   variables: {
 *      adminConsoleLoginEmail: // value for 'adminConsoleLoginEmail'
 *      chamberMemberId: // value for 'chamberMemberId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSendLoginInfoEmailToChamberMemberMutation(baseOptions?: Apollo.MutationHookOptions<SendLoginInfoEmailToChamberMemberMutation, SendLoginInfoEmailToChamberMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendLoginInfoEmailToChamberMemberMutation, SendLoginInfoEmailToChamberMemberMutationVariables>(SendLoginInfoEmailToChamberMemberDocument, options);
      }
export type SendLoginInfoEmailToChamberMemberMutationHookResult = ReturnType<typeof useSendLoginInfoEmailToChamberMemberMutation>;
export type SendLoginInfoEmailToChamberMemberMutationResult = Apollo.MutationResult<SendLoginInfoEmailToChamberMemberMutation>;
export type SendLoginInfoEmailToChamberMemberMutationOptions = Apollo.BaseMutationOptions<SendLoginInfoEmailToChamberMemberMutation, SendLoginInfoEmailToChamberMemberMutationVariables>;
export const SetHasSignedUpForChamberMemberDocument = gql`
    mutation setHasSignedUpForChamberMember {
  setHasSignedUpForChamberMember {
    successfullySetHasSignedUp
  }
}
    `;
export type SetHasSignedUpForChamberMemberMutationFn = Apollo.MutationFunction<SetHasSignedUpForChamberMemberMutation, SetHasSignedUpForChamberMemberMutationVariables>;

/**
 * __useSetHasSignedUpForChamberMemberMutation__
 *
 * To run a mutation, you first call `useSetHasSignedUpForChamberMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHasSignedUpForChamberMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHasSignedUpForChamberMemberMutation, { data, loading, error }] = useSetHasSignedUpForChamberMemberMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetHasSignedUpForChamberMemberMutation(baseOptions?: Apollo.MutationHookOptions<SetHasSignedUpForChamberMemberMutation, SetHasSignedUpForChamberMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHasSignedUpForChamberMemberMutation, SetHasSignedUpForChamberMemberMutationVariables>(SetHasSignedUpForChamberMemberDocument, options);
      }
export type SetHasSignedUpForChamberMemberMutationHookResult = ReturnType<typeof useSetHasSignedUpForChamberMemberMutation>;
export type SetHasSignedUpForChamberMemberMutationResult = Apollo.MutationResult<SetHasSignedUpForChamberMemberMutation>;
export type SetHasSignedUpForChamberMemberMutationOptions = Apollo.BaseMutationOptions<SetHasSignedUpForChamberMemberMutation, SetHasSignedUpForChamberMemberMutationVariables>;
export const SetMyCmpMemberDashboardTestModeDocument = gql`
    mutation setMyCmpMemberDashboardTestMode($input: CmpMemberDashboardTestModeInput!) {
  setMyCmpMemberDashboardTestMode(input: $input) {
    available
    plan
    contactType
    switchChamber
  }
}
    `;
export type SetMyCmpMemberDashboardTestModeMutationFn = Apollo.MutationFunction<SetMyCmpMemberDashboardTestModeMutation, SetMyCmpMemberDashboardTestModeMutationVariables>;

/**
 * __useSetMyCmpMemberDashboardTestModeMutation__
 *
 * To run a mutation, you first call `useSetMyCmpMemberDashboardTestModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyCmpMemberDashboardTestModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyCmpMemberDashboardTestModeMutation, { data, loading, error }] = useSetMyCmpMemberDashboardTestModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMyCmpMemberDashboardTestModeMutation(baseOptions?: Apollo.MutationHookOptions<SetMyCmpMemberDashboardTestModeMutation, SetMyCmpMemberDashboardTestModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMyCmpMemberDashboardTestModeMutation, SetMyCmpMemberDashboardTestModeMutationVariables>(SetMyCmpMemberDashboardTestModeDocument, options);
      }
export type SetMyCmpMemberDashboardTestModeMutationHookResult = ReturnType<typeof useSetMyCmpMemberDashboardTestModeMutation>;
export type SetMyCmpMemberDashboardTestModeMutationResult = Apollo.MutationResult<SetMyCmpMemberDashboardTestModeMutation>;
export type SetMyCmpMemberDashboardTestModeMutationOptions = Apollo.BaseMutationOptions<SetMyCmpMemberDashboardTestModeMutation, SetMyCmpMemberDashboardTestModeMutationVariables>;
export const SetNewTemporaryChamberMemberPasswordDocument = gql`
    mutation setNewTemporaryChamberMemberPassword($adminConsoleLoginEmail: String!, $chamberMemberId: String!) {
  setNewTemporaryChamberMemberPassword(
    adminConsoleLoginEmail: $adminConsoleLoginEmail
    chamberMemberId: $chamberMemberId
  ) {
    password
    failureReason
  }
}
    `;
export type SetNewTemporaryChamberMemberPasswordMutationFn = Apollo.MutationFunction<SetNewTemporaryChamberMemberPasswordMutation, SetNewTemporaryChamberMemberPasswordMutationVariables>;

/**
 * __useSetNewTemporaryChamberMemberPasswordMutation__
 *
 * To run a mutation, you first call `useSetNewTemporaryChamberMemberPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNewTemporaryChamberMemberPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNewTemporaryChamberMemberPasswordMutation, { data, loading, error }] = useSetNewTemporaryChamberMemberPasswordMutation({
 *   variables: {
 *      adminConsoleLoginEmail: // value for 'adminConsoleLoginEmail'
 *      chamberMemberId: // value for 'chamberMemberId'
 *   },
 * });
 */
export function useSetNewTemporaryChamberMemberPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetNewTemporaryChamberMemberPasswordMutation, SetNewTemporaryChamberMemberPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNewTemporaryChamberMemberPasswordMutation, SetNewTemporaryChamberMemberPasswordMutationVariables>(SetNewTemporaryChamberMemberPasswordDocument, options);
      }
export type SetNewTemporaryChamberMemberPasswordMutationHookResult = ReturnType<typeof useSetNewTemporaryChamberMemberPasswordMutation>;
export type SetNewTemporaryChamberMemberPasswordMutationResult = Apollo.MutationResult<SetNewTemporaryChamberMemberPasswordMutation>;
export type SetNewTemporaryChamberMemberPasswordMutationOptions = Apollo.BaseMutationOptions<SetNewTemporaryChamberMemberPasswordMutation, SetNewTemporaryChamberMemberPasswordMutationVariables>;
export const SuspendCmpMemberDocument = gql`
    mutation SuspendCmpMember($input: CmpMemberActionInput!) {
  suspendCmpMember(input: $input) {
    actionSuccessful
    detail {
      lifecycleStatus
      member {
        id
        chamberId
        lifecycleStatus
        isSuspended
        updatedAtUtcMilli
      }
    }
  }
}
    `;
export type SuspendCmpMemberMutationFn = Apollo.MutationFunction<SuspendCmpMemberMutation, SuspendCmpMemberMutationVariables>;

/**
 * __useSuspendCmpMemberMutation__
 *
 * To run a mutation, you first call `useSuspendCmpMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendCmpMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendCmpMemberMutation, { data, loading, error }] = useSuspendCmpMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuspendCmpMemberMutation(baseOptions?: Apollo.MutationHookOptions<SuspendCmpMemberMutation, SuspendCmpMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendCmpMemberMutation, SuspendCmpMemberMutationVariables>(SuspendCmpMemberDocument, options);
      }
export type SuspendCmpMemberMutationHookResult = ReturnType<typeof useSuspendCmpMemberMutation>;
export type SuspendCmpMemberMutationResult = Apollo.MutationResult<SuspendCmpMemberMutation>;
export type SuspendCmpMemberMutationOptions = Apollo.BaseMutationOptions<SuspendCmpMemberMutation, SuspendCmpMemberMutationVariables>;
export const UpdateAffinityProgramPartnerDocument = gql`
    mutation updateAffinityProgramPartner($id: String!, $input: AffinityProgramPartnerInput!) {
  updateAffinityProgramPartner(id: $id, input: $input) {
    affinityProgramPartnerUpdatedSuccessfully
    id
  }
}
    `;
export type UpdateAffinityProgramPartnerMutationFn = Apollo.MutationFunction<UpdateAffinityProgramPartnerMutation, UpdateAffinityProgramPartnerMutationVariables>;

/**
 * __useUpdateAffinityProgramPartnerMutation__
 *
 * To run a mutation, you first call `useUpdateAffinityProgramPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffinityProgramPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffinityProgramPartnerMutation, { data, loading, error }] = useUpdateAffinityProgramPartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAffinityProgramPartnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAffinityProgramPartnerMutation, UpdateAffinityProgramPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAffinityProgramPartnerMutation, UpdateAffinityProgramPartnerMutationVariables>(UpdateAffinityProgramPartnerDocument, options);
      }
export type UpdateAffinityProgramPartnerMutationHookResult = ReturnType<typeof useUpdateAffinityProgramPartnerMutation>;
export type UpdateAffinityProgramPartnerMutationResult = Apollo.MutationResult<UpdateAffinityProgramPartnerMutation>;
export type UpdateAffinityProgramPartnerMutationOptions = Apollo.BaseMutationOptions<UpdateAffinityProgramPartnerMutation, UpdateAffinityProgramPartnerMutationVariables>;
export const UpdateBannerContentForCategoryAdvertisingBannerDocument = gql`
    mutation updateBannerContentForCategoryAdvertisingBanner($chamberId: String, $categoryId: ChamberMemberCategory!, $banner: [BannerInput!]) {
  updateBannerContentForCategoryAdvertisingBanner(
    chamberId: $chamberId
    categoryId: $categoryId
    banner: $banner
  ) {
    bannerActivatedSuccessfully
  }
}
    `;
export type UpdateBannerContentForCategoryAdvertisingBannerMutationFn = Apollo.MutationFunction<UpdateBannerContentForCategoryAdvertisingBannerMutation, UpdateBannerContentForCategoryAdvertisingBannerMutationVariables>;

/**
 * __useUpdateBannerContentForCategoryAdvertisingBannerMutation__
 *
 * To run a mutation, you first call `useUpdateBannerContentForCategoryAdvertisingBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBannerContentForCategoryAdvertisingBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBannerContentForCategoryAdvertisingBannerMutation, { data, loading, error }] = useUpdateBannerContentForCategoryAdvertisingBannerMutation({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      categoryId: // value for 'categoryId'
 *      banner: // value for 'banner'
 *   },
 * });
 */
export function useUpdateBannerContentForCategoryAdvertisingBannerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBannerContentForCategoryAdvertisingBannerMutation, UpdateBannerContentForCategoryAdvertisingBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBannerContentForCategoryAdvertisingBannerMutation, UpdateBannerContentForCategoryAdvertisingBannerMutationVariables>(UpdateBannerContentForCategoryAdvertisingBannerDocument, options);
      }
export type UpdateBannerContentForCategoryAdvertisingBannerMutationHookResult = ReturnType<typeof useUpdateBannerContentForCategoryAdvertisingBannerMutation>;
export type UpdateBannerContentForCategoryAdvertisingBannerMutationResult = Apollo.MutationResult<UpdateBannerContentForCategoryAdvertisingBannerMutation>;
export type UpdateBannerContentForCategoryAdvertisingBannerMutationOptions = Apollo.BaseMutationOptions<UpdateBannerContentForCategoryAdvertisingBannerMutation, UpdateBannerContentForCategoryAdvertisingBannerMutationVariables>;
export const UpdateChamberDocument = gql`
    mutation updateChamber($id: String!, $input: ChamberInput!) {
  updateChamber(id: $id, input: $input) {
    id
    name
    website
    address {
      streetAddress
      city
      province
      postalCode
    }
    supportContactEmail
    googleMapsApi_City_ProvinceShort_CountryShort
    supportContactName
    billingContactName
    billingContactEmail
    signingAuthorityContactName
    signingAuthorityContactEmail
    supportLink
    phoneNumber
    facebook
    instagram
    threads
    linkedin
    twitter
    tiktok
    youtube
    jobPostingLink
    eventsLink
    newsletterLink
    surveyLink
    advocacyWinsLink
    callForNominationsLink
    memberSignupLink
    sponsorLogo
    sponsorLogoLink
    logo
    numberOfMembersFromInitialSubscriptionAgreement
    description
    hideInApp
  }
}
    `;
export type UpdateChamberMutationFn = Apollo.MutationFunction<UpdateChamberMutation, UpdateChamberMutationVariables>;

/**
 * __useUpdateChamberMutation__
 *
 * To run a mutation, you first call `useUpdateChamberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChamberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChamberMutation, { data, loading, error }] = useUpdateChamberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChamberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChamberMutation, UpdateChamberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChamberMutation, UpdateChamberMutationVariables>(UpdateChamberDocument, options);
      }
export type UpdateChamberMutationHookResult = ReturnType<typeof useUpdateChamberMutation>;
export type UpdateChamberMutationResult = Apollo.MutationResult<UpdateChamberMutation>;
export type UpdateChamberMutationOptions = Apollo.BaseMutationOptions<UpdateChamberMutation, UpdateChamberMutationVariables>;
export const UpdateChamberEngageSettingsForChamberDocument = gql`
    mutation updateChamberEngageSettingsForChamber($chamberId: String!, $chamberEngageSettings: ChamberEngageSettingsInput!) {
  updateChamberEngageSettingsForChamber(
    chamberId: $chamberId
    chamberEngageSettings: $chamberEngageSettings
  ) {
    settingsUpdatedSuccessfully
  }
}
    `;
export type UpdateChamberEngageSettingsForChamberMutationFn = Apollo.MutationFunction<UpdateChamberEngageSettingsForChamberMutation, UpdateChamberEngageSettingsForChamberMutationVariables>;

/**
 * __useUpdateChamberEngageSettingsForChamberMutation__
 *
 * To run a mutation, you first call `useUpdateChamberEngageSettingsForChamberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChamberEngageSettingsForChamberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChamberEngageSettingsForChamberMutation, { data, loading, error }] = useUpdateChamberEngageSettingsForChamberMutation({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      chamberEngageSettings: // value for 'chamberEngageSettings'
 *   },
 * });
 */
export function useUpdateChamberEngageSettingsForChamberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChamberEngageSettingsForChamberMutation, UpdateChamberEngageSettingsForChamberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChamberEngageSettingsForChamberMutation, UpdateChamberEngageSettingsForChamberMutationVariables>(UpdateChamberEngageSettingsForChamberDocument, options);
      }
export type UpdateChamberEngageSettingsForChamberMutationHookResult = ReturnType<typeof useUpdateChamberEngageSettingsForChamberMutation>;
export type UpdateChamberEngageSettingsForChamberMutationResult = Apollo.MutationResult<UpdateChamberEngageSettingsForChamberMutation>;
export type UpdateChamberEngageSettingsForChamberMutationOptions = Apollo.BaseMutationOptions<UpdateChamberEngageSettingsForChamberMutation, UpdateChamberEngageSettingsForChamberMutationVariables>;
export const UpdateChamberMemberDocument = gql`
    mutation updateChamberMember($id: String!, $input: ChamberMemberInput!) {
  updateChamberMember(id: $id, input: $input) {
    id
    chamberId
    categoryId
    customContacts {
      id
      name
      email
      jobTitle
      phoneNumber
      phoneNumberExtension
    }
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
    credentialsSentAtUtcMilli
    adminConsoleContactName
    name
    description
    website
    address {
      streetAddress
      city
      province
      postalCode
    }
    phoneNumber
    phoneNumberExtension
    contactName
    email
    logo
    primaryContactName
    primaryContactTitle
    primaryContactEmail
    primaryContactPhoneNumber
    primaryContactPhoneNumberExtension
    cpaAdminCompanyAdminContactTitle
    cpaAdminCompanyAdminContactNumber
    cpaAdminCompanyAdminContactNumberExtension
    cpaEmployeeAdoptionContactName
    cpaEmployeeAdoptionContactEmail
    cpaEmployeeAdoptionContactTitle
    cpaEmployeeAdoptionContactNumber
    cpaEmployeeAdoptionContactNumberExtension
    facebook
    instagram
    threads
    linkedin
    twitter
    tiktok
    youtube
    googleReviewLink
    showInApp
    hideAddressFromDirectory
    isSuspended
  }
}
    `;
export type UpdateChamberMemberMutationFn = Apollo.MutationFunction<UpdateChamberMemberMutation, UpdateChamberMemberMutationVariables>;

/**
 * __useUpdateChamberMemberMutation__
 *
 * To run a mutation, you first call `useUpdateChamberMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChamberMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChamberMemberMutation, { data, loading, error }] = useUpdateChamberMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChamberMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChamberMemberMutation, UpdateChamberMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChamberMemberMutation, UpdateChamberMemberMutationVariables>(UpdateChamberMemberDocument, options);
      }
export type UpdateChamberMemberMutationHookResult = ReturnType<typeof useUpdateChamberMemberMutation>;
export type UpdateChamberMemberMutationResult = Apollo.MutationResult<UpdateChamberMemberMutation>;
export type UpdateChamberMemberMutationOptions = Apollo.BaseMutationOptions<UpdateChamberMemberMutation, UpdateChamberMemberMutationVariables>;
export const UpdateDiscountDocument = gql`
    mutation updateDiscount($id: String!, $input: DiscountInput!) {
  updateDiscount(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateDiscountMutationFn = Apollo.MutationFunction<UpdateDiscountMutation, UpdateDiscountMutationVariables>;

/**
 * __useUpdateDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountMutation, { data, loading, error }] = useUpdateDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscountMutation, UpdateDiscountMutationVariables>(UpdateDiscountDocument, options);
      }
export type UpdateDiscountMutationHookResult = ReturnType<typeof useUpdateDiscountMutation>;
export type UpdateDiscountMutationResult = Apollo.MutationResult<UpdateDiscountMutation>;
export type UpdateDiscountMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountMutation, UpdateDiscountMutationVariables>;
export const UpdateLoggedInUserLanguageDocument = gql`
    mutation updateLoggedInUserLanguage($languageCode: LanguageCodeEnum!) {
  updateLoggedInUserLanguage(languageCode: $languageCode) {
    updated
  }
}
    `;
export type UpdateLoggedInUserLanguageMutationFn = Apollo.MutationFunction<UpdateLoggedInUserLanguageMutation, UpdateLoggedInUserLanguageMutationVariables>;

/**
 * __useUpdateLoggedInUserLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateLoggedInUserLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoggedInUserLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoggedInUserLanguageMutation, { data, loading, error }] = useUpdateLoggedInUserLanguageMutation({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useUpdateLoggedInUserLanguageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoggedInUserLanguageMutation, UpdateLoggedInUserLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoggedInUserLanguageMutation, UpdateLoggedInUserLanguageMutationVariables>(UpdateLoggedInUserLanguageDocument, options);
      }
export type UpdateLoggedInUserLanguageMutationHookResult = ReturnType<typeof useUpdateLoggedInUserLanguageMutation>;
export type UpdateLoggedInUserLanguageMutationResult = Apollo.MutationResult<UpdateLoggedInUserLanguageMutation>;
export type UpdateLoggedInUserLanguageMutationOptions = Apollo.BaseMutationOptions<UpdateLoggedInUserLanguageMutation, UpdateLoggedInUserLanguageMutationVariables>;
export const UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationDocument = gql`
    mutation updateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivation($activationId: String!, $newActivationFeeInDollars: Float!) {
  updateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivation(
    activationId: $activationId
    newActivationFeeInDollars: $newActivationFeeInDollars
  ) {
    updated
  }
}
    `;
export type UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutationFn = Apollo.MutationFunction<UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation, UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutationVariables>;

/**
 * __useUpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation__
 *
 * To run a mutation, you first call `useUpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation, { data, loading, error }] = useUpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation({
 *   variables: {
 *      activationId: // value for 'activationId'
 *      newActivationFeeInDollars: // value for 'newActivationFeeInDollars'
 *   },
 * });
 */
export function useUpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation, UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation, UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutationVariables>(UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationDocument, options);
      }
export type UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutationHookResult = ReturnType<typeof useUpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation>;
export type UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutationResult = Apollo.MutationResult<UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation>;
export type UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutationOptions = Apollo.BaseMutationOptions<UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutation, UpdateMemberProfileAndPerksBannersActivationFeeOfChamberEngageActivationMutationVariables>;
export const UpdateMyCmpMemberEventAttendeesDocument = gql`
    mutation updateMyCmpMemberEventAttendees($input: UpdateMyCmpMemberEventAttendeesInput!) {
  updateMyCmpMemberEventAttendees(input: $input) {
    ...CmpMyMemberEventRegistration
  }
}
    ${CmpMyMemberEventRegistrationFragmentDoc}`;
export type UpdateMyCmpMemberEventAttendeesMutationFn = Apollo.MutationFunction<UpdateMyCmpMemberEventAttendeesMutation, UpdateMyCmpMemberEventAttendeesMutationVariables>;

/**
 * __useUpdateMyCmpMemberEventAttendeesMutation__
 *
 * To run a mutation, you first call `useUpdateMyCmpMemberEventAttendeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyCmpMemberEventAttendeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyCmpMemberEventAttendeesMutation, { data, loading, error }] = useUpdateMyCmpMemberEventAttendeesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyCmpMemberEventAttendeesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyCmpMemberEventAttendeesMutation, UpdateMyCmpMemberEventAttendeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyCmpMemberEventAttendeesMutation, UpdateMyCmpMemberEventAttendeesMutationVariables>(UpdateMyCmpMemberEventAttendeesDocument, options);
      }
export type UpdateMyCmpMemberEventAttendeesMutationHookResult = ReturnType<typeof useUpdateMyCmpMemberEventAttendeesMutation>;
export type UpdateMyCmpMemberEventAttendeesMutationResult = Apollo.MutationResult<UpdateMyCmpMemberEventAttendeesMutation>;
export type UpdateMyCmpMemberEventAttendeesMutationOptions = Apollo.BaseMutationOptions<UpdateMyCmpMemberEventAttendeesMutation, UpdateMyCmpMemberEventAttendeesMutationVariables>;
export const UpdatePerkPartnerDiscountDocument = gql`
    mutation updatePerkPartnerDiscount($id: String!, $input: PerkPartnerDiscountInput!) {
  updatePerkPartnerDiscount(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdatePerkPartnerDiscountMutationFn = Apollo.MutationFunction<UpdatePerkPartnerDiscountMutation, UpdatePerkPartnerDiscountMutationVariables>;

/**
 * __useUpdatePerkPartnerDiscountMutation__
 *
 * To run a mutation, you first call `useUpdatePerkPartnerDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerkPartnerDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerkPartnerDiscountMutation, { data, loading, error }] = useUpdatePerkPartnerDiscountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePerkPartnerDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePerkPartnerDiscountMutation, UpdatePerkPartnerDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePerkPartnerDiscountMutation, UpdatePerkPartnerDiscountMutationVariables>(UpdatePerkPartnerDiscountDocument, options);
      }
export type UpdatePerkPartnerDiscountMutationHookResult = ReturnType<typeof useUpdatePerkPartnerDiscountMutation>;
export type UpdatePerkPartnerDiscountMutationResult = Apollo.MutationResult<UpdatePerkPartnerDiscountMutation>;
export type UpdatePerkPartnerDiscountMutationOptions = Apollo.BaseMutationOptions<UpdatePerkPartnerDiscountMutation, UpdatePerkPartnerDiscountMutationVariables>;
export const UpdateRewardCampaignDocument = gql`
    mutation updateRewardCampaign($id: String!, $input: RewardCampaignInput!) {
  updateRewardCampaign(id: $id, input: $input) {
    campaignUpdatedSuccessfully
  }
}
    `;
export type UpdateRewardCampaignMutationFn = Apollo.MutationFunction<UpdateRewardCampaignMutation, UpdateRewardCampaignMutationVariables>;

/**
 * __useUpdateRewardCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateRewardCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRewardCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRewardCampaignMutation, { data, loading, error }] = useUpdateRewardCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRewardCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRewardCampaignMutation, UpdateRewardCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRewardCampaignMutation, UpdateRewardCampaignMutationVariables>(UpdateRewardCampaignDocument, options);
      }
export type UpdateRewardCampaignMutationHookResult = ReturnType<typeof useUpdateRewardCampaignMutation>;
export type UpdateRewardCampaignMutationResult = Apollo.MutationResult<UpdateRewardCampaignMutation>;
export type UpdateRewardCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateRewardCampaignMutation, UpdateRewardCampaignMutationVariables>;
export const UpdateShopLocalCampaignDocument = gql`
    mutation updateShopLocalCampaign($id: String!, $input: ShopLocalCampaignInput!) {
  updateShopLocalCampaign(id: $id, input: $input) {
    shopLocalCampaignUpdatedSuccessfully
  }
}
    `;
export type UpdateShopLocalCampaignMutationFn = Apollo.MutationFunction<UpdateShopLocalCampaignMutation, UpdateShopLocalCampaignMutationVariables>;

/**
 * __useUpdateShopLocalCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateShopLocalCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShopLocalCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShopLocalCampaignMutation, { data, loading, error }] = useUpdateShopLocalCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShopLocalCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShopLocalCampaignMutation, UpdateShopLocalCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShopLocalCampaignMutation, UpdateShopLocalCampaignMutationVariables>(UpdateShopLocalCampaignDocument, options);
      }
export type UpdateShopLocalCampaignMutationHookResult = ReturnType<typeof useUpdateShopLocalCampaignMutation>;
export type UpdateShopLocalCampaignMutationResult = Apollo.MutationResult<UpdateShopLocalCampaignMutation>;
export type UpdateShopLocalCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateShopLocalCampaignMutation, UpdateShopLocalCampaignMutationVariables>;
export const GetActiveCategoryAdvertisingBannersForChamberMemberDocument = gql`
    query getActiveCategoryAdvertisingBannersForChamberMember {
  getActiveCategoryAdvertisingBannersForChamberMember {
    categoryId
    bannerSettings {
      activationInfo {
        banner {
          contentUrl
          imageLink
          contentType
          position
          waitingForApprovalByChamberAdmin
        }
        chamberMemberId
        activationStartDateUtcMilli
        chamberMemberHasAcceptedAgreement
        chamberMemberAcceptedAgreementVersion
        autoApproveBannerContentUpdate
      }
    }
  }
}
    `;

/**
 * __useGetActiveCategoryAdvertisingBannersForChamberMemberQuery__
 *
 * To run a query within a React component, call `useGetActiveCategoryAdvertisingBannersForChamberMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCategoryAdvertisingBannersForChamberMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCategoryAdvertisingBannersForChamberMemberQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveCategoryAdvertisingBannersForChamberMemberQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveCategoryAdvertisingBannersForChamberMemberQuery, GetActiveCategoryAdvertisingBannersForChamberMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCategoryAdvertisingBannersForChamberMemberQuery, GetActiveCategoryAdvertisingBannersForChamberMemberQueryVariables>(GetActiveCategoryAdvertisingBannersForChamberMemberDocument, options);
      }
export function useGetActiveCategoryAdvertisingBannersForChamberMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCategoryAdvertisingBannersForChamberMemberQuery, GetActiveCategoryAdvertisingBannersForChamberMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCategoryAdvertisingBannersForChamberMemberQuery, GetActiveCategoryAdvertisingBannersForChamberMemberQueryVariables>(GetActiveCategoryAdvertisingBannersForChamberMemberDocument, options);
        }
export type GetActiveCategoryAdvertisingBannersForChamberMemberQueryHookResult = ReturnType<typeof useGetActiveCategoryAdvertisingBannersForChamberMemberQuery>;
export type GetActiveCategoryAdvertisingBannersForChamberMemberLazyQueryHookResult = ReturnType<typeof useGetActiveCategoryAdvertisingBannersForChamberMemberLazyQuery>;
export type GetActiveCategoryAdvertisingBannersForChamberMemberQueryResult = Apollo.QueryResult<GetActiveCategoryAdvertisingBannersForChamberMemberQuery, GetActiveCategoryAdvertisingBannersForChamberMemberQueryVariables>;
export const GetActiveShopLocalCampaignForChamberMemberDocument = gql`
    query getActiveShopLocalCampaignForChamberMember {
  getActiveShopLocalCampaignForChamber {
    id
    chamberId
    campaignName
    prizeDescription
    startDateUtcMilli
    endDateUtcMilli
    participatingMembers {
      memberId
      participationCode
    }
    createdAtUtcMilli
    updatedAtUtcMilli
  }
}
    `;

/**
 * __useGetActiveShopLocalCampaignForChamberMemberQuery__
 *
 * To run a query within a React component, call `useGetActiveShopLocalCampaignForChamberMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveShopLocalCampaignForChamberMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveShopLocalCampaignForChamberMemberQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveShopLocalCampaignForChamberMemberQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveShopLocalCampaignForChamberMemberQuery, GetActiveShopLocalCampaignForChamberMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveShopLocalCampaignForChamberMemberQuery, GetActiveShopLocalCampaignForChamberMemberQueryVariables>(GetActiveShopLocalCampaignForChamberMemberDocument, options);
      }
export function useGetActiveShopLocalCampaignForChamberMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveShopLocalCampaignForChamberMemberQuery, GetActiveShopLocalCampaignForChamberMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveShopLocalCampaignForChamberMemberQuery, GetActiveShopLocalCampaignForChamberMemberQueryVariables>(GetActiveShopLocalCampaignForChamberMemberDocument, options);
        }
export type GetActiveShopLocalCampaignForChamberMemberQueryHookResult = ReturnType<typeof useGetActiveShopLocalCampaignForChamberMemberQuery>;
export type GetActiveShopLocalCampaignForChamberMemberLazyQueryHookResult = ReturnType<typeof useGetActiveShopLocalCampaignForChamberMemberLazyQuery>;
export type GetActiveShopLocalCampaignForChamberMemberQueryResult = Apollo.QueryResult<GetActiveShopLocalCampaignForChamberMemberQuery, GetActiveShopLocalCampaignForChamberMemberQueryVariables>;
export const GetAdminConsoleLoginEmailForChamberDocument = gql`
    query getAdminConsoleLoginEmailForChamber($chamberId: String!) {
  getAdminConsoleLoginEmailForChamber(chamberId: $chamberId) {
    adminConsoleLoginEmail
  }
}
    `;

/**
 * __useGetAdminConsoleLoginEmailForChamberQuery__
 *
 * To run a query within a React component, call `useGetAdminConsoleLoginEmailForChamberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminConsoleLoginEmailForChamberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminConsoleLoginEmailForChamberQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetAdminConsoleLoginEmailForChamberQuery(baseOptions: Apollo.QueryHookOptions<GetAdminConsoleLoginEmailForChamberQuery, GetAdminConsoleLoginEmailForChamberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminConsoleLoginEmailForChamberQuery, GetAdminConsoleLoginEmailForChamberQueryVariables>(GetAdminConsoleLoginEmailForChamberDocument, options);
      }
export function useGetAdminConsoleLoginEmailForChamberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminConsoleLoginEmailForChamberQuery, GetAdminConsoleLoginEmailForChamberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminConsoleLoginEmailForChamberQuery, GetAdminConsoleLoginEmailForChamberQueryVariables>(GetAdminConsoleLoginEmailForChamberDocument, options);
        }
export type GetAdminConsoleLoginEmailForChamberQueryHookResult = ReturnType<typeof useGetAdminConsoleLoginEmailForChamberQuery>;
export type GetAdminConsoleLoginEmailForChamberLazyQueryHookResult = ReturnType<typeof useGetAdminConsoleLoginEmailForChamberLazyQuery>;
export type GetAdminConsoleLoginEmailForChamberQueryResult = Apollo.QueryResult<GetAdminConsoleLoginEmailForChamberQuery, GetAdminConsoleLoginEmailForChamberQueryVariables>;
export const GetAdminConsoleLoginEmailForChamberMemberDocument = gql`
    query getAdminConsoleLoginEmailForChamberMember($chamberMemberId: String!) {
  getAdminConsoleLoginEmailForChamberMember(chamberMemberId: $chamberMemberId) {
    adminConsoleLoginEmail
    memberDashboardLoginsBelongToContacts
  }
}
    `;

/**
 * __useGetAdminConsoleLoginEmailForChamberMemberQuery__
 *
 * To run a query within a React component, call `useGetAdminConsoleLoginEmailForChamberMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminConsoleLoginEmailForChamberMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminConsoleLoginEmailForChamberMemberQuery({
 *   variables: {
 *      chamberMemberId: // value for 'chamberMemberId'
 *   },
 * });
 */
export function useGetAdminConsoleLoginEmailForChamberMemberQuery(baseOptions: Apollo.QueryHookOptions<GetAdminConsoleLoginEmailForChamberMemberQuery, GetAdminConsoleLoginEmailForChamberMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminConsoleLoginEmailForChamberMemberQuery, GetAdminConsoleLoginEmailForChamberMemberQueryVariables>(GetAdminConsoleLoginEmailForChamberMemberDocument, options);
      }
export function useGetAdminConsoleLoginEmailForChamberMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminConsoleLoginEmailForChamberMemberQuery, GetAdminConsoleLoginEmailForChamberMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminConsoleLoginEmailForChamberMemberQuery, GetAdminConsoleLoginEmailForChamberMemberQueryVariables>(GetAdminConsoleLoginEmailForChamberMemberDocument, options);
        }
export type GetAdminConsoleLoginEmailForChamberMemberQueryHookResult = ReturnType<typeof useGetAdminConsoleLoginEmailForChamberMemberQuery>;
export type GetAdminConsoleLoginEmailForChamberMemberLazyQueryHookResult = ReturnType<typeof useGetAdminConsoleLoginEmailForChamberMemberLazyQuery>;
export type GetAdminConsoleLoginEmailForChamberMemberQueryResult = Apollo.QueryResult<GetAdminConsoleLoginEmailForChamberMemberQuery, GetAdminConsoleLoginEmailForChamberMemberQueryVariables>;
export const GetAffinityProgramPartnerDocument = gql`
    query getAffinityProgramPartner($id: String!) {
  getAffinityProgramPartner(id: $id) {
    id
    chamberId
    companyName
    title
    description
    redirectLink
    logo
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
    activationStatus
    activationStartDateUtcMilli
    activationEndDateUtcMilli
    daysUntilExpiration
    createdAtUtcMilli
    updatedAtUtcMilli
    activationInfo {
      activationStartDateUtcMilli
      activationEndDateUtcMilli
      activationFeeInDollarsAtTimeOfActivation
    }
    reactivationInfo {
      activationStartDateUtcMilli
      activationEndDateUtcMilli
      activationFeeInDollarsAtTimeOfActivation
    }
  }
}
    `;

/**
 * __useGetAffinityProgramPartnerQuery__
 *
 * To run a query within a React component, call `useGetAffinityProgramPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAffinityProgramPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAffinityProgramPartnerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAffinityProgramPartnerQuery(baseOptions: Apollo.QueryHookOptions<GetAffinityProgramPartnerQuery, GetAffinityProgramPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAffinityProgramPartnerQuery, GetAffinityProgramPartnerQueryVariables>(GetAffinityProgramPartnerDocument, options);
      }
export function useGetAffinityProgramPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAffinityProgramPartnerQuery, GetAffinityProgramPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAffinityProgramPartnerQuery, GetAffinityProgramPartnerQueryVariables>(GetAffinityProgramPartnerDocument, options);
        }
export type GetAffinityProgramPartnerQueryHookResult = ReturnType<typeof useGetAffinityProgramPartnerQuery>;
export type GetAffinityProgramPartnerLazyQueryHookResult = ReturnType<typeof useGetAffinityProgramPartnerLazyQuery>;
export type GetAffinityProgramPartnerQueryResult = Apollo.QueryResult<GetAffinityProgramPartnerQuery, GetAffinityProgramPartnerQueryVariables>;
export const GetAffinityProgramPartnerStatsDocument = gql`
    query getAffinityProgramPartnerStats($id: String!, $inquiryLimit: Float, $inquiryNextToken: String) {
  getAffinityProgramPartnerStats(
    id: $id
    inquiryLimit: $inquiryLimit
    inquiryNextToken: $inquiryNextToken
  ) {
    id
    totalViewCount
    totalIneligibleViewCount
    totalUnverifiedViewCount
    totalVerifiedViewCount
    totalMemberViewCount
    totalNonMemberViewCount
    totalOpenCount
    totalIneligibleOpenCount
    totalUnverifiedOpenCount
    totalVerifiedOpenCount
    totalMemberOpenCount
    totalNonMemberOpenCount
    totalOpensFromViewsConversionRatePercentage
    totalRedirectCount
    totalIneligibleRedirectCount
    totalUnverifiedRedirectCount
    totalVerifiedRedirectCount
    totalMemberRedirectCount
    totalNonMemberRedirectCount
    totalRedirectCountFromOpensConversionRatePercentage
    totalInquirySubmissionCount
    displayInquirySubmissionCount
    inquirySubmissionCountIsDemo
    inquiriesReturnedCount
    inquiriesNextToken
    inquiries {
      id
      fullName
      email
      employerName
      createdAtUtcMilli
      emailDeliveryStatus
    }
    splitByChamber {
      chamberId
      chamberName
      chamberIsEnabledForAffinityProgramPartner
      totalViewCount
      ineligibleViewCount
      unverifiedViewCount
      verifiedViewCount
      memberViewCount
      nonMemberViewCount
      totalOpenCount
      ineligibleOpenCount
      unverifiedOpenCount
      verifiedOpenCount
      memberOpenCount
      nonMemberOpenCount
      totalRedirectCount
      ineligibleRedirectCount
      unverifiedRedirectCount
      verifiedRedirectCount
      memberRedirectCount
      nonMemberRedirectCount
    }
    timeseriesData {
      allChambers {
        id
        name
        timeseriesData {
          monthAndYear
          totalOpenCount
          totalViewCount
          totalRedirectCount
        }
      }
      chambers {
        id
        name
        timeseriesData {
          monthAndYear
          totalOpenCount
          totalViewCount
          totalRedirectCount
        }
      }
    }
  }
}
    `;

/**
 * __useGetAffinityProgramPartnerStatsQuery__
 *
 * To run a query within a React component, call `useGetAffinityProgramPartnerStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAffinityProgramPartnerStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAffinityProgramPartnerStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      inquiryLimit: // value for 'inquiryLimit'
 *      inquiryNextToken: // value for 'inquiryNextToken'
 *   },
 * });
 */
export function useGetAffinityProgramPartnerStatsQuery(baseOptions: Apollo.QueryHookOptions<GetAffinityProgramPartnerStatsQuery, GetAffinityProgramPartnerStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAffinityProgramPartnerStatsQuery, GetAffinityProgramPartnerStatsQueryVariables>(GetAffinityProgramPartnerStatsDocument, options);
      }
export function useGetAffinityProgramPartnerStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAffinityProgramPartnerStatsQuery, GetAffinityProgramPartnerStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAffinityProgramPartnerStatsQuery, GetAffinityProgramPartnerStatsQueryVariables>(GetAffinityProgramPartnerStatsDocument, options);
        }
export type GetAffinityProgramPartnerStatsQueryHookResult = ReturnType<typeof useGetAffinityProgramPartnerStatsQuery>;
export type GetAffinityProgramPartnerStatsLazyQueryHookResult = ReturnType<typeof useGetAffinityProgramPartnerStatsLazyQuery>;
export type GetAffinityProgramPartnerStatsQueryResult = Apollo.QueryResult<GetAffinityProgramPartnerStatsQuery, GetAffinityProgramPartnerStatsQueryVariables>;
export const GetAllAdminUsersForPerkPartnerDiscountDocument = gql`
    query getAllAdminUsersForPerkPartnerDiscount($perkPartnerDiscountId: String!) {
  getAllAdminUsersForPerkPartnerDiscount(
    perkPartnerDiscountId: $perkPartnerDiscountId
  ) {
    id
    email
    perkPartnerDiscountId
    adminConsoleLoginEmail
    createdAtUtcMilli
    updatedAtUtcMilli
  }
}
    `;

/**
 * __useGetAllAdminUsersForPerkPartnerDiscountQuery__
 *
 * To run a query within a React component, call `useGetAllAdminUsersForPerkPartnerDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAdminUsersForPerkPartnerDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAdminUsersForPerkPartnerDiscountQuery({
 *   variables: {
 *      perkPartnerDiscountId: // value for 'perkPartnerDiscountId'
 *   },
 * });
 */
export function useGetAllAdminUsersForPerkPartnerDiscountQuery(baseOptions: Apollo.QueryHookOptions<GetAllAdminUsersForPerkPartnerDiscountQuery, GetAllAdminUsersForPerkPartnerDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAdminUsersForPerkPartnerDiscountQuery, GetAllAdminUsersForPerkPartnerDiscountQueryVariables>(GetAllAdminUsersForPerkPartnerDiscountDocument, options);
      }
export function useGetAllAdminUsersForPerkPartnerDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAdminUsersForPerkPartnerDiscountQuery, GetAllAdminUsersForPerkPartnerDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAdminUsersForPerkPartnerDiscountQuery, GetAllAdminUsersForPerkPartnerDiscountQueryVariables>(GetAllAdminUsersForPerkPartnerDiscountDocument, options);
        }
export type GetAllAdminUsersForPerkPartnerDiscountQueryHookResult = ReturnType<typeof useGetAllAdminUsersForPerkPartnerDiscountQuery>;
export type GetAllAdminUsersForPerkPartnerDiscountLazyQueryHookResult = ReturnType<typeof useGetAllAdminUsersForPerkPartnerDiscountLazyQuery>;
export type GetAllAdminUsersForPerkPartnerDiscountQueryResult = Apollo.QueryResult<GetAllAdminUsersForPerkPartnerDiscountQuery, GetAllAdminUsersForPerkPartnerDiscountQueryVariables>;
export const GetAllAffinityProgramPartnersForChamberDocument = gql`
    query getAllAffinityProgramPartnersForChamber($chamberId: String) {
  getAllAffinityProgramPartnersForChamber(chamberId: $chamberId) {
    id
    chamberId
    companyName
    title
    description
    redirectLink
    logo
    appPlacementOrder
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
    activationStatus
    activationStartDateUtcMilli
    activationEndDateUtcMilli
    daysUntilExpiration
    createdAtUtcMilli
    updatedAtUtcMilli
    reactivationInfo {
      activationStartDateUtcMilli
      activationEndDateUtcMilli
    }
  }
}
    `;

/**
 * __useGetAllAffinityProgramPartnersForChamberQuery__
 *
 * To run a query within a React component, call `useGetAllAffinityProgramPartnersForChamberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAffinityProgramPartnersForChamberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAffinityProgramPartnersForChamberQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetAllAffinityProgramPartnersForChamberQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAffinityProgramPartnersForChamberQuery, GetAllAffinityProgramPartnersForChamberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAffinityProgramPartnersForChamberQuery, GetAllAffinityProgramPartnersForChamberQueryVariables>(GetAllAffinityProgramPartnersForChamberDocument, options);
      }
export function useGetAllAffinityProgramPartnersForChamberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAffinityProgramPartnersForChamberQuery, GetAllAffinityProgramPartnersForChamberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAffinityProgramPartnersForChamberQuery, GetAllAffinityProgramPartnersForChamberQueryVariables>(GetAllAffinityProgramPartnersForChamberDocument, options);
        }
export type GetAllAffinityProgramPartnersForChamberQueryHookResult = ReturnType<typeof useGetAllAffinityProgramPartnersForChamberQuery>;
export type GetAllAffinityProgramPartnersForChamberLazyQueryHookResult = ReturnType<typeof useGetAllAffinityProgramPartnersForChamberLazyQuery>;
export type GetAllAffinityProgramPartnersForChamberQueryResult = Apollo.QueryResult<GetAllAffinityProgramPartnersForChamberQuery, GetAllAffinityProgramPartnersForChamberQueryVariables>;
export const GetAllCategoriesDocument = gql`
    query getAllCategories {
  getAllCategories {
    id
    name
  }
}
    `;

/**
 * __useGetAllCategoriesQuery__
 *
 * To run a query within a React component, call `useGetAllCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>(GetAllCategoriesDocument, options);
      }
export function useGetAllCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>(GetAllCategoriesDocument, options);
        }
export type GetAllCategoriesQueryHookResult = ReturnType<typeof useGetAllCategoriesQuery>;
export type GetAllCategoriesLazyQueryHookResult = ReturnType<typeof useGetAllCategoriesLazyQuery>;
export type GetAllCategoriesQueryResult = Apollo.QueryResult<GetAllCategoriesQuery, GetAllCategoriesQueryVariables>;
export const GetAllCategoryAdvertisingBannersForChamberDocument = gql`
    query getAllCategoryAdvertisingBannersForChamber($chamberId: String) {
  getAllCategoryAdvertisingBannersForChamber(chamberId: $chamberId) {
    id
    chamberId
    categoryAdvertisingBanners {
      categoryId
      bannerSettings {
        activationInfo {
          banner {
            contentUrl
            imageLink
            contentType
            position
            waitingForApprovalByChamberAdmin
          }
          chamberMemberId
          bannerFeeOptionSetAtActivationTime {
            timeLengthInMonths
            bannerFeeInDollars
          }
          activationStartDateUtcMilli
          categoryAdvertisingBannersActivationFeeCpaSplitPercentageSetAtActivationTime
          autoApproveBannerContentUpdate
        }
        reactivationInfo {
          banner {
            contentUrl
            imageLink
            contentType
            position
            waitingForApprovalByChamberAdmin
          }
          chamberMemberId
          bannerFeeOptionSetAtActivationTime {
            timeLengthInMonths
            bannerFeeInDollars
          }
          activationStartDateUtcMilli
          categoryAdvertisingBannersActivationFeeCpaSplitPercentageSetAtActivationTime
        }
      }
    }
    createdAtUtcMilli
    updatedAtUtcMilli
  }
}
    `;

/**
 * __useGetAllCategoryAdvertisingBannersForChamberQuery__
 *
 * To run a query within a React component, call `useGetAllCategoryAdvertisingBannersForChamberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCategoryAdvertisingBannersForChamberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCategoryAdvertisingBannersForChamberQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetAllCategoryAdvertisingBannersForChamberQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCategoryAdvertisingBannersForChamberQuery, GetAllCategoryAdvertisingBannersForChamberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCategoryAdvertisingBannersForChamberQuery, GetAllCategoryAdvertisingBannersForChamberQueryVariables>(GetAllCategoryAdvertisingBannersForChamberDocument, options);
      }
export function useGetAllCategoryAdvertisingBannersForChamberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCategoryAdvertisingBannersForChamberQuery, GetAllCategoryAdvertisingBannersForChamberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCategoryAdvertisingBannersForChamberQuery, GetAllCategoryAdvertisingBannersForChamberQueryVariables>(GetAllCategoryAdvertisingBannersForChamberDocument, options);
        }
export type GetAllCategoryAdvertisingBannersForChamberQueryHookResult = ReturnType<typeof useGetAllCategoryAdvertisingBannersForChamberQuery>;
export type GetAllCategoryAdvertisingBannersForChamberLazyQueryHookResult = ReturnType<typeof useGetAllCategoryAdvertisingBannersForChamberLazyQuery>;
export type GetAllCategoryAdvertisingBannersForChamberQueryResult = Apollo.QueryResult<GetAllCategoryAdvertisingBannersForChamberQuery, GetAllCategoryAdvertisingBannersForChamberQueryVariables>;
export const GetAllChamberEngageInvoiceDataDocument = gql`
    query getAllChamberEngageInvoiceData {
  getAllChamberEngageInvoiceData {
    year
    monthNum
    totalActivationFeeInDollars
    allInvoicesSentInMonth
    chamberData {
      chamberId
      chamberName
      memberProfileAndPerksBannersActivated
      memberProfileAndPerksBannersTotalActivationFeeInDollars
      categoryAdvertisingActivated
      categoryAdvertisingTotalActivationFeeInDollars
      activations {
        activationId
        chamberMemberId
        chamberMemberName
        activationType
        activationLengthInMonths
        activationFeeInDollars
        includeInInvoice
        invoiceSentAtUtcMilli
        categoryAdvertisingCategoryId
      }
      allInvoicesSentForChamberInMonth
    }
  }
}
    `;

/**
 * __useGetAllChamberEngageInvoiceDataQuery__
 *
 * To run a query within a React component, call `useGetAllChamberEngageInvoiceDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllChamberEngageInvoiceDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllChamberEngageInvoiceDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllChamberEngageInvoiceDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAllChamberEngageInvoiceDataQuery, GetAllChamberEngageInvoiceDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllChamberEngageInvoiceDataQuery, GetAllChamberEngageInvoiceDataQueryVariables>(GetAllChamberEngageInvoiceDataDocument, options);
      }
export function useGetAllChamberEngageInvoiceDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllChamberEngageInvoiceDataQuery, GetAllChamberEngageInvoiceDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllChamberEngageInvoiceDataQuery, GetAllChamberEngageInvoiceDataQueryVariables>(GetAllChamberEngageInvoiceDataDocument, options);
        }
export type GetAllChamberEngageInvoiceDataQueryHookResult = ReturnType<typeof useGetAllChamberEngageInvoiceDataQuery>;
export type GetAllChamberEngageInvoiceDataLazyQueryHookResult = ReturnType<typeof useGetAllChamberEngageInvoiceDataLazyQuery>;
export type GetAllChamberEngageInvoiceDataQueryResult = Apollo.QueryResult<GetAllChamberEngageInvoiceDataQuery, GetAllChamberEngageInvoiceDataQueryVariables>;
export const GetAllChamberMembersDocument = gql`
    query getAllChamberMembers($chamberId: String!, $getHasSignedUp: Boolean, $getNumberOfUsers: Boolean) {
  getAllChamberMembers(
    chamberId: $chamberId
    getHasSignedUp: $getHasSignedUp
    getNumberOfUsers: $getNumberOfUsers
  ) {
    id
    chamberId
    categoryId
    customContacts {
      id
      name
      email
      jobTitle
      phoneNumber
      phoneNumberExtension
    }
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
    activeMemberProfileAndPerksBannersSettings {
      activationInfo {
        startDateUtcMilli
        chamberMemberHasAcceptedAgreement
      }
    }
    credentialsSentAtUtcMilli
    adminConsoleContactName
    name
    description
    website
    address {
      streetAddress
      city
      province
      postalCode
    }
    phoneNumber
    phoneNumberExtension
    contactName
    email
    logo
    primaryContactName
    primaryContactTitle
    primaryContactEmail
    primaryContactPhoneNumber
    primaryContactPhoneNumberExtension
    cpaAdminCompanyAdminContactTitle
    cpaAdminCompanyAdminContactNumber
    cpaAdminCompanyAdminContactNumberExtension
    cpaEmployeeAdoptionContactName
    cpaEmployeeAdoptionContactEmail
    cpaEmployeeAdoptionContactTitle
    cpaEmployeeAdoptionContactNumber
    cpaEmployeeAdoptionContactNumberExtension
    facebook
    instagram
    threads
    linkedin
    twitter
    tiktok
    youtube
    googleReviewLink
    showInApp
    hideAddressFromDirectory
    hasSignedUp
    firstLoginAfterSettingNewPermanentPasswordUtcMilli
    numberOfUsers
    adminConsoleLoginEmail
    createdAtUtcMilli
    isSuspended
    lifecycleStatus
    cmpExtension {
      __typename
    }
  }
}
    `;

/**
 * __useGetAllChamberMembersQuery__
 *
 * To run a query within a React component, call `useGetAllChamberMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllChamberMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllChamberMembersQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      getHasSignedUp: // value for 'getHasSignedUp'
 *      getNumberOfUsers: // value for 'getNumberOfUsers'
 *   },
 * });
 */
export function useGetAllChamberMembersQuery(baseOptions: Apollo.QueryHookOptions<GetAllChamberMembersQuery, GetAllChamberMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllChamberMembersQuery, GetAllChamberMembersQueryVariables>(GetAllChamberMembersDocument, options);
      }
export function useGetAllChamberMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllChamberMembersQuery, GetAllChamberMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllChamberMembersQuery, GetAllChamberMembersQueryVariables>(GetAllChamberMembersDocument, options);
        }
export type GetAllChamberMembersQueryHookResult = ReturnType<typeof useGetAllChamberMembersQuery>;
export type GetAllChamberMembersLazyQueryHookResult = ReturnType<typeof useGetAllChamberMembersLazyQuery>;
export type GetAllChamberMembersQueryResult = Apollo.QueryResult<GetAllChamberMembersQuery, GetAllChamberMembersQueryVariables>;
export const GetAllChamberMembers_RootAndChamberAdminOnlyDocument = gql`
    query getAllChamberMembers_RootAndChamberAdminOnly($chamberId: String!) {
  getAllChamberMembers(chamberId: $chamberId) {
    id
    chamberId
    categoryId
    customContacts {
      id
      name
      email
      jobTitle
      phoneNumber
    }
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
    credentialsSentAtUtcMilli
    adminConsoleContactName
    name
    description
    website
    address {
      streetAddress
      city
      province
      postalCode
    }
    phoneNumber
    contactName
    email
    logo
    facebook
    instagram
    threads
    linkedin
    twitter
    tiktok
    googleReviewLink
    youtube
    showInApp
    hasSignedUp
    numberOfUsers
    adminConsoleLoginEmail
    createdAtUtcMilli
    activeMemberProfileAndPerksBannersSettings {
      activationInfo {
        startDateUtcMilli
        memberProfileAndPerkBannerActivationFeeInDollarsAtTimeOfActivation
        memberProfileAndPerkBannerAnnualBannerFeeInDollarsAtTimeOfActivation
        chamberMemberHasAcceptedAgreement
      }
      reactivationInfo {
        startDateUtcMilli
        memberProfileAndPerkBannerActivationFeeInDollarsAtTimeOfActivation
        memberProfileAndPerkBannerAnnualBannerFeeInDollarsAtTimeOfActivation
        chamberMemberHasAcceptedAgreement
      }
    }
    isSuspended
  }
}
    `;

/**
 * __useGetAllChamberMembers_RootAndChamberAdminOnlyQuery__
 *
 * To run a query within a React component, call `useGetAllChamberMembers_RootAndChamberAdminOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllChamberMembers_RootAndChamberAdminOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllChamberMembers_RootAndChamberAdminOnlyQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetAllChamberMembers_RootAndChamberAdminOnlyQuery(baseOptions: Apollo.QueryHookOptions<GetAllChamberMembers_RootAndChamberAdminOnlyQuery, GetAllChamberMembers_RootAndChamberAdminOnlyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllChamberMembers_RootAndChamberAdminOnlyQuery, GetAllChamberMembers_RootAndChamberAdminOnlyQueryVariables>(GetAllChamberMembers_RootAndChamberAdminOnlyDocument, options);
      }
export function useGetAllChamberMembers_RootAndChamberAdminOnlyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllChamberMembers_RootAndChamberAdminOnlyQuery, GetAllChamberMembers_RootAndChamberAdminOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllChamberMembers_RootAndChamberAdminOnlyQuery, GetAllChamberMembers_RootAndChamberAdminOnlyQueryVariables>(GetAllChamberMembers_RootAndChamberAdminOnlyDocument, options);
        }
export type GetAllChamberMembers_RootAndChamberAdminOnlyQueryHookResult = ReturnType<typeof useGetAllChamberMembers_RootAndChamberAdminOnlyQuery>;
export type GetAllChamberMembers_RootAndChamberAdminOnlyLazyQueryHookResult = ReturnType<typeof useGetAllChamberMembers_RootAndChamberAdminOnlyLazyQuery>;
export type GetAllChamberMembers_RootAndChamberAdminOnlyQueryResult = Apollo.QueryResult<GetAllChamberMembers_RootAndChamberAdminOnlyQuery, GetAllChamberMembers_RootAndChamberAdminOnlyQueryVariables>;
export const GetAllChambersDocument = gql`
    query getAllChambers($getAllSandbox: Boolean) {
  getAllChambers(getAllSandbox: $getAllSandbox) {
    id
    name
    website
    address {
      streetAddress
      city
      province
      postalCode
    }
    supportContactEmail
    googleMapsApi_City_ProvinceShort_CountryShort
    supportContactName
    supportLink
    phoneNumber
    facebook
    instagram
    threads
    linkedin
    twitter
    tiktok
    youtube
    jobPostingLink
    eventsLink
    newsletterLink
    surveyLink
    advocacyWinsLink
    callForNominationsLink
    memberSignupLink
    sponsorLogo
    sponsorLogoLink
    logo
    numberOfMembersFromInitialSubscriptionAgreement
    description
    createdAtUtcMilli
    subscriptionDate
    hideInApp
    isSandbox
  }
}
    `;

/**
 * __useGetAllChambersQuery__
 *
 * To run a query within a React component, call `useGetAllChambersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllChambersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllChambersQuery({
 *   variables: {
 *      getAllSandbox: // value for 'getAllSandbox'
 *   },
 * });
 */
export function useGetAllChambersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllChambersQuery, GetAllChambersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllChambersQuery, GetAllChambersQueryVariables>(GetAllChambersDocument, options);
      }
export function useGetAllChambersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllChambersQuery, GetAllChambersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllChambersQuery, GetAllChambersQueryVariables>(GetAllChambersDocument, options);
        }
export type GetAllChambersQueryHookResult = ReturnType<typeof useGetAllChambersQuery>;
export type GetAllChambersLazyQueryHookResult = ReturnType<typeof useGetAllChambersLazyQuery>;
export type GetAllChambersQueryResult = Apollo.QueryResult<GetAllChambersQuery, GetAllChambersQueryVariables>;
export const GetAllChambersForRootAdminChamberEngageDocument = gql`
    query getAllChambersForRootAdminChamberEngage($getAllSandbox: Boolean) {
  getAllChambers(getAllSandbox: $getAllSandbox) {
    id
    name
    website
    address {
      streetAddress
      city
      province
      postalCode
    }
    supportContactEmail
    googleMapsApi_City_ProvinceShort_CountryShort
    supportContactName
    supportLink
    phoneNumber
    facebook
    instagram
    threads
    linkedin
    twitter
    tiktok
    youtube
    jobPostingLink
    eventsLink
    newsletterLink
    surveyLink
    advocacyWinsLink
    callForNominationsLink
    memberSignupLink
    sponsorLogo
    sponsorLogoLink
    logo
    numberOfMembersFromInitialSubscriptionAgreement
    description
    createdAtUtcMilli
    subscriptionDate
    chamberEngageSettings {
      isActive
      memberProfileAndPerkBannerActivationFeeInDollars
      memberProfileAndPerkBannerAnnualBannerFeeInDollars
      categoryAdvertisingBannersFeeOptions {
        timeLengthInMonths
        bannerFeeInDollars
      }
      categoryAdvertisingBannersActivationFeeCpaSplitPercentage
    }
    hideInApp
  }
}
    `;

/**
 * __useGetAllChambersForRootAdminChamberEngageQuery__
 *
 * To run a query within a React component, call `useGetAllChambersForRootAdminChamberEngageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllChambersForRootAdminChamberEngageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllChambersForRootAdminChamberEngageQuery({
 *   variables: {
 *      getAllSandbox: // value for 'getAllSandbox'
 *   },
 * });
 */
export function useGetAllChambersForRootAdminChamberEngageQuery(baseOptions?: Apollo.QueryHookOptions<GetAllChambersForRootAdminChamberEngageQuery, GetAllChambersForRootAdminChamberEngageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllChambersForRootAdminChamberEngageQuery, GetAllChambersForRootAdminChamberEngageQueryVariables>(GetAllChambersForRootAdminChamberEngageDocument, options);
      }
export function useGetAllChambersForRootAdminChamberEngageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllChambersForRootAdminChamberEngageQuery, GetAllChambersForRootAdminChamberEngageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllChambersForRootAdminChamberEngageQuery, GetAllChambersForRootAdminChamberEngageQueryVariables>(GetAllChambersForRootAdminChamberEngageDocument, options);
        }
export type GetAllChambersForRootAdminChamberEngageQueryHookResult = ReturnType<typeof useGetAllChambersForRootAdminChamberEngageQuery>;
export type GetAllChambersForRootAdminChamberEngageLazyQueryHookResult = ReturnType<typeof useGetAllChambersForRootAdminChamberEngageLazyQuery>;
export type GetAllChambersForRootAdminChamberEngageQueryResult = Apollo.QueryResult<GetAllChambersForRootAdminChamberEngageQuery, GetAllChambersForRootAdminChamberEngageQueryVariables>;
export const GetAllChambersForRootChamberListDocument = gql`
    query getAllChambersForRootChamberList {
  getAllChambers {
    id
    name
    logo
    hideInApp
    isSandbox
  }
}
    `;

/**
 * __useGetAllChambersForRootChamberListQuery__
 *
 * To run a query within a React component, call `useGetAllChambersForRootChamberListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllChambersForRootChamberListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllChambersForRootChamberListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllChambersForRootChamberListQuery(baseOptions?: Apollo.QueryHookOptions<GetAllChambersForRootChamberListQuery, GetAllChambersForRootChamberListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllChambersForRootChamberListQuery, GetAllChambersForRootChamberListQueryVariables>(GetAllChambersForRootChamberListDocument, options);
      }
export function useGetAllChambersForRootChamberListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllChambersForRootChamberListQuery, GetAllChambersForRootChamberListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllChambersForRootChamberListQuery, GetAllChambersForRootChamberListQueryVariables>(GetAllChambersForRootChamberListDocument, options);
        }
export type GetAllChambersForRootChamberListQueryHookResult = ReturnType<typeof useGetAllChambersForRootChamberListQuery>;
export type GetAllChambersForRootChamberListLazyQueryHookResult = ReturnType<typeof useGetAllChambersForRootChamberListLazyQuery>;
export type GetAllChambersForRootChamberListQueryResult = Apollo.QueryResult<GetAllChambersForRootChamberListQuery, GetAllChambersForRootChamberListQueryVariables>;
export const GetAllContactableCompaniesForChamberDocument = gql`
    query getAllContactableCompaniesForChamber {
  getAllContactableCompaniesForChamber {
    id
    chamberId
    chamberName
    name
    createdAtUtcMilli
  }
}
    `;

/**
 * __useGetAllContactableCompaniesForChamberQuery__
 *
 * To run a query within a React component, call `useGetAllContactableCompaniesForChamberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContactableCompaniesForChamberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContactableCompaniesForChamberQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllContactableCompaniesForChamberQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContactableCompaniesForChamberQuery, GetAllContactableCompaniesForChamberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContactableCompaniesForChamberQuery, GetAllContactableCompaniesForChamberQueryVariables>(GetAllContactableCompaniesForChamberDocument, options);
      }
export function useGetAllContactableCompaniesForChamberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContactableCompaniesForChamberQuery, GetAllContactableCompaniesForChamberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContactableCompaniesForChamberQuery, GetAllContactableCompaniesForChamberQueryVariables>(GetAllContactableCompaniesForChamberDocument, options);
        }
export type GetAllContactableCompaniesForChamberQueryHookResult = ReturnType<typeof useGetAllContactableCompaniesForChamberQuery>;
export type GetAllContactableCompaniesForChamberLazyQueryHookResult = ReturnType<typeof useGetAllContactableCompaniesForChamberLazyQuery>;
export type GetAllContactableCompaniesForChamberQueryResult = Apollo.QueryResult<GetAllContactableCompaniesForChamberQuery, GetAllContactableCompaniesForChamberQueryVariables>;
export const GetAllDeletedDiscountsFromChamberIdDocument = gql`
    query getAllDeletedDiscountsFromChamberId($chamberId: String!) {
  getAllDeletedDiscountsFromChamberId(chamberId: $chamberId) {
    id
    title
    description
    chamberId
    chamberMemberId
    chamberInfo {
      id
      name
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      supportContactEmail
      googleMapsApi_City_ProvinceShort_CountryShort
      supportContactName
      supportLink
      phoneNumber
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      youtube
      jobPostingLink
      eventsLink
      newsletterLink
      surveyLink
      advocacyWinsLink
      callForNominationsLink
      memberSignupLink
      sponsorLogo
      sponsorLogoLink
      description
      logo
      hideInApp
    }
    chamberMemberInfo {
      id
      chamberId
      categoryId
      customContacts {
        id
        name
        email
        jobTitle
        phoneNumber
      }
      banner {
        contentUrl
        imageLink
        contentType
        position
      }
      activeMemberProfileAndPerksBannersSettings {
        activationInfo {
          startDateUtcMilli
          chamberMemberHasAcceptedAgreement
        }
      }
      credentialsSentAtUtcMilli
      adminConsoleContactName
      name
      description
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      phoneNumber
      contactName
      email
      logo
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      googleReviewLink
      youtube
      showInApp
      isSuspended
    }
    memberOnly
    isAvailableToAllMembers
    isReoccuring
    daysAvailable
    monthsAvailable
    isPrivate
    views
    numberOfRedemptions
    createdAtUtcMilli
    deletedAtUtcMilli
  }
}
    `;

/**
 * __useGetAllDeletedDiscountsFromChamberIdQuery__
 *
 * To run a query within a React component, call `useGetAllDeletedDiscountsFromChamberIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDeletedDiscountsFromChamberIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDeletedDiscountsFromChamberIdQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetAllDeletedDiscountsFromChamberIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllDeletedDiscountsFromChamberIdQuery, GetAllDeletedDiscountsFromChamberIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDeletedDiscountsFromChamberIdQuery, GetAllDeletedDiscountsFromChamberIdQueryVariables>(GetAllDeletedDiscountsFromChamberIdDocument, options);
      }
export function useGetAllDeletedDiscountsFromChamberIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDeletedDiscountsFromChamberIdQuery, GetAllDeletedDiscountsFromChamberIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDeletedDiscountsFromChamberIdQuery, GetAllDeletedDiscountsFromChamberIdQueryVariables>(GetAllDeletedDiscountsFromChamberIdDocument, options);
        }
export type GetAllDeletedDiscountsFromChamberIdQueryHookResult = ReturnType<typeof useGetAllDeletedDiscountsFromChamberIdQuery>;
export type GetAllDeletedDiscountsFromChamberIdLazyQueryHookResult = ReturnType<typeof useGetAllDeletedDiscountsFromChamberIdLazyQuery>;
export type GetAllDeletedDiscountsFromChamberIdQueryResult = Apollo.QueryResult<GetAllDeletedDiscountsFromChamberIdQuery, GetAllDeletedDiscountsFromChamberIdQueryVariables>;
export const GetAllDeletedPerkPartnerDiscountsDocument = gql`
    query getAllDeletedPerkPartnerDiscounts {
  getAllDeletedPerkPartnerDiscounts {
    id
    companyName
    title
    description
    verifiedChamberMemberCapUserRedirectLink
    unverifiedChamberMemberCapUserRedirectLink
    logo
    availableToChamberIds
    createdAtUtcMilli
    updatedAtUtcMilli
    deletedAtUtcMilli
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
  }
}
    `;

/**
 * __useGetAllDeletedPerkPartnerDiscountsQuery__
 *
 * To run a query within a React component, call `useGetAllDeletedPerkPartnerDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDeletedPerkPartnerDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDeletedPerkPartnerDiscountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDeletedPerkPartnerDiscountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDeletedPerkPartnerDiscountsQuery, GetAllDeletedPerkPartnerDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDeletedPerkPartnerDiscountsQuery, GetAllDeletedPerkPartnerDiscountsQueryVariables>(GetAllDeletedPerkPartnerDiscountsDocument, options);
      }
export function useGetAllDeletedPerkPartnerDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDeletedPerkPartnerDiscountsQuery, GetAllDeletedPerkPartnerDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDeletedPerkPartnerDiscountsQuery, GetAllDeletedPerkPartnerDiscountsQueryVariables>(GetAllDeletedPerkPartnerDiscountsDocument, options);
        }
export type GetAllDeletedPerkPartnerDiscountsQueryHookResult = ReturnType<typeof useGetAllDeletedPerkPartnerDiscountsQuery>;
export type GetAllDeletedPerkPartnerDiscountsLazyQueryHookResult = ReturnType<typeof useGetAllDeletedPerkPartnerDiscountsLazyQuery>;
export type GetAllDeletedPerkPartnerDiscountsQueryResult = Apollo.QueryResult<GetAllDeletedPerkPartnerDiscountsQuery, GetAllDeletedPerkPartnerDiscountsQueryVariables>;
export const GetAllDiscountsFromChamberIdDocument = gql`
    query getAllDiscountsFromChamberId($chamberId: String!, $userId: String, $localDay: DayEnum, $localMonth: MonthEnum) {
  getAllDiscountsFromChamberId(
    chamberId: $chamberId
    userId: $userId
    localDay: $localDay
    localMonth: $localMonth
  ) {
    id
    title
    description
    chamberId
    chamberMemberId
    chamberInfo {
      id
      name
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      supportContactEmail
      googleMapsApi_City_ProvinceShort_CountryShort
      supportContactName
      supportLink
      phoneNumber
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      youtube
      jobPostingLink
      eventsLink
      newsletterLink
      surveyLink
      advocacyWinsLink
      callForNominationsLink
      memberSignupLink
      sponsorLogo
      sponsorLogoLink
      description
      logo
      hideInApp
    }
    chamberMemberInfo {
      id
      chamberId
      categoryId
      customContacts {
        id
        name
        email
        jobTitle
        phoneNumber
      }
      banner {
        contentUrl
        imageLink
        contentType
        position
      }
      activeMemberProfileAndPerksBannersSettings {
        activationInfo {
          startDateUtcMilli
          chamberMemberHasAcceptedAgreement
        }
      }
      credentialsSentAtUtcMilli
      adminConsoleContactName
      name
      description
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      phoneNumber
      contactName
      email
      logo
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      googleReviewLink
      youtube
      showInApp
      isSuspended
    }
    memberOnly
    isAvailableToAllMembers
    isReoccuring
    daysAvailable
    monthsAvailable
    isPrivate
    views
    numberOfRedemptions
    createdAtUtcMilli
    redeemSettings {
      whereToRedeem
    }
  }
}
    `;

/**
 * __useGetAllDiscountsFromChamberIdQuery__
 *
 * To run a query within a React component, call `useGetAllDiscountsFromChamberIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDiscountsFromChamberIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDiscountsFromChamberIdQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *      userId: // value for 'userId'
 *      localDay: // value for 'localDay'
 *      localMonth: // value for 'localMonth'
 *   },
 * });
 */
export function useGetAllDiscountsFromChamberIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllDiscountsFromChamberIdQuery, GetAllDiscountsFromChamberIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDiscountsFromChamberIdQuery, GetAllDiscountsFromChamberIdQueryVariables>(GetAllDiscountsFromChamberIdDocument, options);
      }
export function useGetAllDiscountsFromChamberIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDiscountsFromChamberIdQuery, GetAllDiscountsFromChamberIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDiscountsFromChamberIdQuery, GetAllDiscountsFromChamberIdQueryVariables>(GetAllDiscountsFromChamberIdDocument, options);
        }
export type GetAllDiscountsFromChamberIdQueryHookResult = ReturnType<typeof useGetAllDiscountsFromChamberIdQuery>;
export type GetAllDiscountsFromChamberIdLazyQueryHookResult = ReturnType<typeof useGetAllDiscountsFromChamberIdLazyQuery>;
export type GetAllDiscountsFromChamberIdQueryResult = Apollo.QueryResult<GetAllDiscountsFromChamberIdQuery, GetAllDiscountsFromChamberIdQueryVariables>;
export const GetAllDiscountsFromChamberMemberIdDocument = gql`
    query getAllDiscountsFromChamberMemberId($chamberMemberId: String!, $userId: String, $localDay: DayEnum, $localMonth: MonthEnum) {
  getAllDiscountsFromChamberMemberId(
    chamberMemberId: $chamberMemberId
    userId: $userId
    localDay: $localDay
    localMonth: $localMonth
  ) {
    id
    title
    description
    chamberId
    chamberMemberId
    chamberInfo {
      id
      name
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      supportContactEmail
      googleMapsApi_City_ProvinceShort_CountryShort
      supportContactName
      supportLink
      phoneNumber
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      youtube
      jobPostingLink
      eventsLink
      newsletterLink
      surveyLink
      advocacyWinsLink
      callForNominationsLink
      memberSignupLink
      sponsorLogo
      sponsorLogoLink
      description
      logo
      hideInApp
    }
    chamberMemberInfo {
      id
      chamberId
      categoryId
      customContacts {
        id
        name
        email
        jobTitle
        phoneNumber
      }
      banner {
        contentUrl
        imageLink
        contentType
        position
      }
      activeMemberProfileAndPerksBannersSettings {
        activationInfo {
          startDateUtcMilli
          chamberMemberHasAcceptedAgreement
        }
      }
      credentialsSentAtUtcMilli
      adminConsoleContactName
      name
      description
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      phoneNumber
      contactName
      email
      logo
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      googleReviewLink
      youtube
      showInApp
      isSuspended
    }
    memberOnly
    isAvailableToAllMembers
    isReoccuring
    daysAvailable
    monthsAvailable
    isPrivate
    privateEmails
    redeemSettings {
      whereToRedeem
      howToRedeem {
        code
        websiteToEnterCodeAt
        contactEmail
        contactNumber
        contactName
      }
    }
    startTimeUtcMilli
    expiryTimeUtcMilli
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
    numberOfRedemptions
    views
    createdAtUtcMilli
  }
}
    `;

/**
 * __useGetAllDiscountsFromChamberMemberIdQuery__
 *
 * To run a query within a React component, call `useGetAllDiscountsFromChamberMemberIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDiscountsFromChamberMemberIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDiscountsFromChamberMemberIdQuery({
 *   variables: {
 *      chamberMemberId: // value for 'chamberMemberId'
 *      userId: // value for 'userId'
 *      localDay: // value for 'localDay'
 *      localMonth: // value for 'localMonth'
 *   },
 * });
 */
export function useGetAllDiscountsFromChamberMemberIdQuery(baseOptions: Apollo.QueryHookOptions<GetAllDiscountsFromChamberMemberIdQuery, GetAllDiscountsFromChamberMemberIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDiscountsFromChamberMemberIdQuery, GetAllDiscountsFromChamberMemberIdQueryVariables>(GetAllDiscountsFromChamberMemberIdDocument, options);
      }
export function useGetAllDiscountsFromChamberMemberIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDiscountsFromChamberMemberIdQuery, GetAllDiscountsFromChamberMemberIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDiscountsFromChamberMemberIdQuery, GetAllDiscountsFromChamberMemberIdQueryVariables>(GetAllDiscountsFromChamberMemberIdDocument, options);
        }
export type GetAllDiscountsFromChamberMemberIdQueryHookResult = ReturnType<typeof useGetAllDiscountsFromChamberMemberIdQuery>;
export type GetAllDiscountsFromChamberMemberIdLazyQueryHookResult = ReturnType<typeof useGetAllDiscountsFromChamberMemberIdLazyQuery>;
export type GetAllDiscountsFromChamberMemberIdQueryResult = Apollo.QueryResult<GetAllDiscountsFromChamberMemberIdQuery, GetAllDiscountsFromChamberMemberIdQueryVariables>;
export const GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliDocument = gql`
    query getAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilli($chamberId: String!) {
  getChamber(chamberId: $chamberId) {
    id
    allMemberLoginCredentialSuccessfulDownloadTimestampUtcMilli
  }
}
    `;

/**
 * __useGetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery__
 *
 * To run a query within a React component, call `useGetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery(baseOptions: Apollo.QueryHookOptions<GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery, GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery, GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQueryVariables>(GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliDocument, options);
      }
export function useGetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery, GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery, GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQueryVariables>(GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliDocument, options);
        }
export type GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQueryHookResult = ReturnType<typeof useGetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery>;
export type GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliLazyQueryHookResult = ReturnType<typeof useGetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliLazyQuery>;
export type GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQueryResult = Apollo.QueryResult<GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQuery, GetAllMemberLoginCredentialSuccessfulDownloadTimestampUtcMilliQueryVariables>;
export const GetAllMemberLoginCredentialsDocument = gql`
    query getAllMemberLoginCredentials($processId: String!) {
  getAllMemberLoginCredentials(processId: $processId) {
    status
    successCSVRawTextOfAllMemberLoginCredentials
  }
}
    `;

/**
 * __useGetAllMemberLoginCredentialsQuery__
 *
 * To run a query within a React component, call `useGetAllMemberLoginCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMemberLoginCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMemberLoginCredentialsQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useGetAllMemberLoginCredentialsQuery(baseOptions: Apollo.QueryHookOptions<GetAllMemberLoginCredentialsQuery, GetAllMemberLoginCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMemberLoginCredentialsQuery, GetAllMemberLoginCredentialsQueryVariables>(GetAllMemberLoginCredentialsDocument, options);
      }
export function useGetAllMemberLoginCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMemberLoginCredentialsQuery, GetAllMemberLoginCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMemberLoginCredentialsQuery, GetAllMemberLoginCredentialsQueryVariables>(GetAllMemberLoginCredentialsDocument, options);
        }
export type GetAllMemberLoginCredentialsQueryHookResult = ReturnType<typeof useGetAllMemberLoginCredentialsQuery>;
export type GetAllMemberLoginCredentialsLazyQueryHookResult = ReturnType<typeof useGetAllMemberLoginCredentialsLazyQuery>;
export type GetAllMemberLoginCredentialsQueryResult = Apollo.QueryResult<GetAllMemberLoginCredentialsQuery, GetAllMemberLoginCredentialsQueryVariables>;
export const GetAllMemberMassSendLoginCredentialTimestampUtcMilliDocument = gql`
    query getAllMemberMassSendLoginCredentialTimestampUtcMilli($chamberId: String!) {
  getChamber(chamberId: $chamberId) {
    id
    allMemberMassSendLoginCredentialTimestampUtcMilli
  }
}
    `;

/**
 * __useGetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery__
 *
 * To run a query within a React component, call `useGetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery(baseOptions: Apollo.QueryHookOptions<GetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery, GetAllMemberMassSendLoginCredentialTimestampUtcMilliQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery, GetAllMemberMassSendLoginCredentialTimestampUtcMilliQueryVariables>(GetAllMemberMassSendLoginCredentialTimestampUtcMilliDocument, options);
      }
export function useGetAllMemberMassSendLoginCredentialTimestampUtcMilliLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery, GetAllMemberMassSendLoginCredentialTimestampUtcMilliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery, GetAllMemberMassSendLoginCredentialTimestampUtcMilliQueryVariables>(GetAllMemberMassSendLoginCredentialTimestampUtcMilliDocument, options);
        }
export type GetAllMemberMassSendLoginCredentialTimestampUtcMilliQueryHookResult = ReturnType<typeof useGetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery>;
export type GetAllMemberMassSendLoginCredentialTimestampUtcMilliLazyQueryHookResult = ReturnType<typeof useGetAllMemberMassSendLoginCredentialTimestampUtcMilliLazyQuery>;
export type GetAllMemberMassSendLoginCredentialTimestampUtcMilliQueryResult = Apollo.QueryResult<GetAllMemberMassSendLoginCredentialTimestampUtcMilliQuery, GetAllMemberMassSendLoginCredentialTimestampUtcMilliQueryVariables>;
export const GetAllPerkPartnerDiscountsDocument = gql`
    query getAllPerkPartnerDiscounts {
  getAllPerkPartnerDiscounts {
    id
    companyName
    title
    description
    verifiedChamberMemberCapUserRedirectLink
    unverifiedChamberMemberCapUserRedirectLink
    logo
    availableToChamberIds
    availableToChambers {
      id
      name
    }
    createdAtUtcMilli
    updatedAtUtcMilli
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
  }
}
    `;

/**
 * __useGetAllPerkPartnerDiscountsQuery__
 *
 * To run a query within a React component, call `useGetAllPerkPartnerDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPerkPartnerDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPerkPartnerDiscountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPerkPartnerDiscountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPerkPartnerDiscountsQuery, GetAllPerkPartnerDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPerkPartnerDiscountsQuery, GetAllPerkPartnerDiscountsQueryVariables>(GetAllPerkPartnerDiscountsDocument, options);
      }
export function useGetAllPerkPartnerDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPerkPartnerDiscountsQuery, GetAllPerkPartnerDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPerkPartnerDiscountsQuery, GetAllPerkPartnerDiscountsQueryVariables>(GetAllPerkPartnerDiscountsDocument, options);
        }
export type GetAllPerkPartnerDiscountsQueryHookResult = ReturnType<typeof useGetAllPerkPartnerDiscountsQuery>;
export type GetAllPerkPartnerDiscountsLazyQueryHookResult = ReturnType<typeof useGetAllPerkPartnerDiscountsLazyQuery>;
export type GetAllPerkPartnerDiscountsQueryResult = Apollo.QueryResult<GetAllPerkPartnerDiscountsQuery, GetAllPerkPartnerDiscountsQueryVariables>;
export const GetAllPerksLinksForChamberDocument = gql`
    query getAllPerksLinksForChamber {
  getAllPerksLinksForChamber {
    pendingOrAcceptedPerksLinkRequestInfo {
      id
      status
      requestorChamberId
      requesteeChamberId
      linkedAtTimeUtcMilli
      createdAtUtcMilli
    }
    chamberId
    chamberName
    chamberContactEmail
    chamberContactNumber
  }
}
    `;

/**
 * __useGetAllPerksLinksForChamberQuery__
 *
 * To run a query within a React component, call `useGetAllPerksLinksForChamberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPerksLinksForChamberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPerksLinksForChamberQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPerksLinksForChamberQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPerksLinksForChamberQuery, GetAllPerksLinksForChamberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPerksLinksForChamberQuery, GetAllPerksLinksForChamberQueryVariables>(GetAllPerksLinksForChamberDocument, options);
      }
export function useGetAllPerksLinksForChamberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPerksLinksForChamberQuery, GetAllPerksLinksForChamberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPerksLinksForChamberQuery, GetAllPerksLinksForChamberQueryVariables>(GetAllPerksLinksForChamberDocument, options);
        }
export type GetAllPerksLinksForChamberQueryHookResult = ReturnType<typeof useGetAllPerksLinksForChamberQuery>;
export type GetAllPerksLinksForChamberLazyQueryHookResult = ReturnType<typeof useGetAllPerksLinksForChamberLazyQuery>;
export type GetAllPerksLinksForChamberQueryResult = Apollo.QueryResult<GetAllPerksLinksForChamberQuery, GetAllPerksLinksForChamberQueryVariables>;
export const GetAllRewardCampaignsForChamberDocument = gql`
    query getAllRewardCampaignsForChamber {
  getAllRewardCampaignsForChamber {
    id
    chamberId
    sponsoringChamberMemberId
    campaignName
    prizeDescription
    startDateUtcMilli
    endDateUtcMilli
    prizeDrawParticipants {
      email
      ballotsEarned
    }
    createdAtUtcMilli
    updatedAtUtcMilli
    isCreatedByCpaAdmin
  }
}
    `;

/**
 * __useGetAllRewardCampaignsForChamberQuery__
 *
 * To run a query within a React component, call `useGetAllRewardCampaignsForChamberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRewardCampaignsForChamberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRewardCampaignsForChamberQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRewardCampaignsForChamberQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRewardCampaignsForChamberQuery, GetAllRewardCampaignsForChamberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRewardCampaignsForChamberQuery, GetAllRewardCampaignsForChamberQueryVariables>(GetAllRewardCampaignsForChamberDocument, options);
      }
export function useGetAllRewardCampaignsForChamberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRewardCampaignsForChamberQuery, GetAllRewardCampaignsForChamberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRewardCampaignsForChamberQuery, GetAllRewardCampaignsForChamberQueryVariables>(GetAllRewardCampaignsForChamberDocument, options);
        }
export type GetAllRewardCampaignsForChamberQueryHookResult = ReturnType<typeof useGetAllRewardCampaignsForChamberQuery>;
export type GetAllRewardCampaignsForChamberLazyQueryHookResult = ReturnType<typeof useGetAllRewardCampaignsForChamberLazyQuery>;
export type GetAllRewardCampaignsForChamberQueryResult = Apollo.QueryResult<GetAllRewardCampaignsForChamberQuery, GetAllRewardCampaignsForChamberQueryVariables>;
export const GetAllShopLocalCampaignsForChamberDocument = gql`
    query getAllShopLocalCampaignsForChamber {
  getAllShopLocalCampaignsForChamber {
    id
    chamberId
    campaignName
    prizeDescription
    startDateUtcMilli
    endDateUtcMilli
    participatingMemberIds
    participatingMembers {
      memberId
      participationCode
    }
    prizeDrawParticipants {
      userEmail
      redeemedAtMemberIds
    }
    status
    createdAtUtcMilli
    updatedAtUtcMilli
  }
}
    `;

/**
 * __useGetAllShopLocalCampaignsForChamberQuery__
 *
 * To run a query within a React component, call `useGetAllShopLocalCampaignsForChamberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllShopLocalCampaignsForChamberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllShopLocalCampaignsForChamberQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllShopLocalCampaignsForChamberQuery(baseOptions?: Apollo.QueryHookOptions<GetAllShopLocalCampaignsForChamberQuery, GetAllShopLocalCampaignsForChamberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllShopLocalCampaignsForChamberQuery, GetAllShopLocalCampaignsForChamberQueryVariables>(GetAllShopLocalCampaignsForChamberDocument, options);
      }
export function useGetAllShopLocalCampaignsForChamberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllShopLocalCampaignsForChamberQuery, GetAllShopLocalCampaignsForChamberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllShopLocalCampaignsForChamberQuery, GetAllShopLocalCampaignsForChamberQueryVariables>(GetAllShopLocalCampaignsForChamberDocument, options);
        }
export type GetAllShopLocalCampaignsForChamberQueryHookResult = ReturnType<typeof useGetAllShopLocalCampaignsForChamberQuery>;
export type GetAllShopLocalCampaignsForChamberLazyQueryHookResult = ReturnType<typeof useGetAllShopLocalCampaignsForChamberLazyQuery>;
export type GetAllShopLocalCampaignsForChamberQueryResult = Apollo.QueryResult<GetAllShopLocalCampaignsForChamberQuery, GetAllShopLocalCampaignsForChamberQueryVariables>;
export const GetChamberDocument = gql`
    query getChamber($chamberId: String!) {
  getChamber(chamberId: $chamberId) {
    id
    name
    website
    address {
      streetAddress
      city
      province
      postalCode
    }
    supportContactEmail
    googleMapsApi_City_ProvinceShort_CountryShort
    supportContactName
    billingContactName
    billingContactEmail
    signingAuthorityContactName
    signingAuthorityContactEmail
    supportLink
    phoneNumber
    facebook
    instagram
    threads
    linkedin
    twitter
    tiktok
    youtube
    jobPostingLink
    eventsLink
    newsletterLink
    surveyLink
    advocacyWinsLink
    callForNominationsLink
    memberSignupLink
    sponsorLogo
    sponsorLogoLink
    logo
    numberOfMembersFromInitialSubscriptionAgreement
    description
    createdAtUtcMilli
    directoryBanner {
      contentUrl
      imageLink
      contentType
      position
    }
    profileBanner {
      contentUrl
      imageLink
      contentType
      position
    }
    hideInApp
  }
}
    `;

/**
 * __useGetChamberQuery__
 *
 * To run a query within a React component, call `useGetChamberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChamberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChamberQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetChamberQuery(baseOptions: Apollo.QueryHookOptions<GetChamberQuery, GetChamberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChamberQuery, GetChamberQueryVariables>(GetChamberDocument, options);
      }
export function useGetChamberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChamberQuery, GetChamberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChamberQuery, GetChamberQueryVariables>(GetChamberDocument, options);
        }
export type GetChamberQueryHookResult = ReturnType<typeof useGetChamberQuery>;
export type GetChamberLazyQueryHookResult = ReturnType<typeof useGetChamberLazyQuery>;
export type GetChamberQueryResult = Apollo.QueryResult<GetChamberQuery, GetChamberQueryVariables>;
export const GetChamberAdminStatsDocument = gql`
    query GetChamberAdminStats($chamberId: String) {
  getChamberAdminStats(chamberId: $chamberId) {
    totalChamberMembersOnApp
    totalMemberCompaniesFeaturedOnAppSystemWide
    membersWithNewPerkNotificationsEnabled {
      currentValue
      currentPercentage
      targetValue
      targetPercentage
      maxValue
    }
    membersWhoDownloadedAppAndSetUpAccount {
      currentValue
      currentPercentage
      targetValue
      targetPercentage
      maxValue
      monthlyData {
        monthAndYear
        appSignups
      }
      averageMonthlySignups
    }
    membersWhoLoggedIntoMemberDashboard {
      currentValue
      currentPercentage
      targetValue
      targetPercentage
      maxValue
      starBreakdown {
        firstRow {
          threshold
          fillPercentage
        }
        secondRow {
          threshold
          fillPercentage
        }
        showFirstRowThumbsUp
        showSecondRowThumbsUp
      }
    }
    daysRemainingUntilSubscriptionAnniversary
    subscriptionAnniversaryUtcMilli
    subscriptionDate
    companyLeads {
      id
      chamberId
      chamberName
      name
      createdAtUtcMilli
      createdAtUtcTimestamp
    }
    chamberPerksOffered
    chamberPerkViews
    totalPerksOfferedOnAppSystemWide
    totalPerkViewsOnAppSystemWide
    numberOfPerksOffered {
      currentValue
      currentPercentage
      targetValue
      targetPercentage
      maxValue
      idealTargetValue
      idealTargetPercentage
    }
    numberOfMembersOfferingPerks {
      currentValue
      currentPercentage
      targetValue
      targetPercentage
      maxValue
      idealTargetValue
      idealTargetPercentage
    }
    perkViewKPI {
      currentValue
      targetValue
      maxValue
    }
    perkRedeemableByBreakdown {
      numOfAllMemberPerks
      numOfLocalMemberOnlyPerks
      numOfGeneralPublicPerks
      numOfCompanyEmployeesOnlyPerks
      percentOfAllMemberPerks
      percentOfLocalMemberOnlyPerks
      percentOfGeneralPublicPerks
      percentOfCompanyEmployeesOnlyPerks
    }
    perksCategoryBreakdown {
      categoryId
      categoryName
      numberOfMembers
      numberOfPerks
      actualPercentage
    }
    mostPopularPerks {
      companyName
      companyLogo
      perkTitle
      offeredTo
      views
      createdAtUtcMilli
    }
    newestPerks {
      companyName
      companyLogo
      perkTitle
      offeredTo
      views
      createdAtUtcMilli
    }
    downloadMilestones {
      year
      goalValue
      isFilled
      fillPercentage
    }
    perkMilestones {
      year
      goalValue
      isFilled
      fillPercentage
    }
    memberOfferingPerksMilestones {
      year
      goalPercentage
      isFilled
      fillPercentage
    }
    nonDuesRevenueBreakdown {
      featuredMemberBannersSold
      featuredMemberBannersTotal
      featuredMemberRevenuePerBanner
      featuredMemberCurrentRevenue
      featuredMemberPotentialRevenue
      featuredMemberBannerPrice
      categoryBannersSold
      categoryBannersTotal
      categoryBannerRevenuePerBanner
      categoryBannerCurrentRevenue
      categoryBannerPotentialRevenue
      categoryBannerPrice
      hasTitleSponsor
      titleSponsorshipAmount
      totalCurrentRevenue
      totalPotentialRevenue
    }
  }
}
    `;

/**
 * __useGetChamberAdminStatsQuery__
 *
 * To run a query within a React component, call `useGetChamberAdminStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChamberAdminStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChamberAdminStatsQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetChamberAdminStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetChamberAdminStatsQuery, GetChamberAdminStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChamberAdminStatsQuery, GetChamberAdminStatsQueryVariables>(GetChamberAdminStatsDocument, options);
      }
export function useGetChamberAdminStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChamberAdminStatsQuery, GetChamberAdminStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChamberAdminStatsQuery, GetChamberAdminStatsQueryVariables>(GetChamberAdminStatsDocument, options);
        }
export type GetChamberAdminStatsQueryHookResult = ReturnType<typeof useGetChamberAdminStatsQuery>;
export type GetChamberAdminStatsLazyQueryHookResult = ReturnType<typeof useGetChamberAdminStatsLazyQuery>;
export type GetChamberAdminStatsQueryResult = Apollo.QueryResult<GetChamberAdminStatsQuery, GetChamberAdminStatsQueryVariables>;
export const GetChamberForMemberLoginDocument = gql`
    query getChamberForMemberLogin($chamberId: String!) {
  getChamber(chamberId: $chamberId) {
    id
    name
    logo
  }
}
    `;

/**
 * __useGetChamberForMemberLoginQuery__
 *
 * To run a query within a React component, call `useGetChamberForMemberLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChamberForMemberLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChamberForMemberLoginQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetChamberForMemberLoginQuery(baseOptions: Apollo.QueryHookOptions<GetChamberForMemberLoginQuery, GetChamberForMemberLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChamberForMemberLoginQuery, GetChamberForMemberLoginQueryVariables>(GetChamberForMemberLoginDocument, options);
      }
export function useGetChamberForMemberLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChamberForMemberLoginQuery, GetChamberForMemberLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChamberForMemberLoginQuery, GetChamberForMemberLoginQueryVariables>(GetChamberForMemberLoginDocument, options);
        }
export type GetChamberForMemberLoginQueryHookResult = ReturnType<typeof useGetChamberForMemberLoginQuery>;
export type GetChamberForMemberLoginLazyQueryHookResult = ReturnType<typeof useGetChamberForMemberLoginLazyQuery>;
export type GetChamberForMemberLoginQueryResult = Apollo.QueryResult<GetChamberForMemberLoginQuery, GetChamberForMemberLoginQueryVariables>;
export const GetChamberIdsWithChamberMemberProDocument = gql`
    query getChamberIdsWithChamberMemberPro {
  getChamberIdsWithChamberMemberPro
}
    `;

/**
 * __useGetChamberIdsWithChamberMemberProQuery__
 *
 * To run a query within a React component, call `useGetChamberIdsWithChamberMemberProQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChamberIdsWithChamberMemberProQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChamberIdsWithChamberMemberProQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChamberIdsWithChamberMemberProQuery(baseOptions?: Apollo.QueryHookOptions<GetChamberIdsWithChamberMemberProQuery, GetChamberIdsWithChamberMemberProQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChamberIdsWithChamberMemberProQuery, GetChamberIdsWithChamberMemberProQueryVariables>(GetChamberIdsWithChamberMemberProDocument, options);
      }
export function useGetChamberIdsWithChamberMemberProLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChamberIdsWithChamberMemberProQuery, GetChamberIdsWithChamberMemberProQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChamberIdsWithChamberMemberProQuery, GetChamberIdsWithChamberMemberProQueryVariables>(GetChamberIdsWithChamberMemberProDocument, options);
        }
export type GetChamberIdsWithChamberMemberProQueryHookResult = ReturnType<typeof useGetChamberIdsWithChamberMemberProQuery>;
export type GetChamberIdsWithChamberMemberProLazyQueryHookResult = ReturnType<typeof useGetChamberIdsWithChamberMemberProLazyQuery>;
export type GetChamberIdsWithChamberMemberProQueryResult = Apollo.QueryResult<GetChamberIdsWithChamberMemberProQuery, GetChamberIdsWithChamberMemberProQueryVariables>;
export const GetChamberMemberDocument = gql`
    query getChamberMember($chamberMemberId: String!) {
  getChamberMember(chamberMemberId: $chamberMemberId) {
    id
    chamberId
    categoryId
    customContacts {
      id
      name
      email
      jobTitle
      phoneNumber
      phoneNumberExtension
    }
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
    activeMemberProfileAndPerksBannersSettings {
      activationInfo {
        startDateUtcMilli
        chamberMemberHasAcceptedAgreement
        chamberMemberAcceptedAgreementVersion
      }
    }
    credentialsSentAtUtcMilli
    adminConsoleContactName
    adminConsoleLoginEmail
    name
    description
    website
    address {
      streetAddress
      city
      province
      postalCode
      country
    }
    phoneNumber
    phoneNumberExtension
    contactName
    email
    logo
    primaryContactName
    cpaAdminCompanyAdminContactMobilePhoneNumber
    primaryContactMobilePhoneNumber
    primaryContactTitle
    primaryContactEmail
    primaryContactPhoneNumber
    primaryContactPhoneNumberExtension
    cpaAdminCompanyAdminContactTitle
    cpaAdminCompanyAdminContactNumber
    cpaAdminCompanyAdminContactNumberExtension
    cpaEmployeeAdoptionContactName
    cpaEmployeeAdoptionContactEmail
    cpaEmployeeAdoptionContactTitle
    cpaEmployeeAdoptionContactNumber
    cpaEmployeeAdoptionContactNumberExtension
    facebook
    instagram
    threads
    linkedin
    twitter
    tiktok
    youtube
    googleReviewLink
    showInApp
    hideAddressFromDirectory
    isSuspended
    lifecycleStatus
    cmpExtension {
      __typename
      accountsPayableContactName
      accountsPayableContactTitle
      accountsPayableContactEmail
      accountsPayableContactNumber
      accountsPayableContactNumberExtension
      accountsPayableContactMobilePhoneNumber
      marketingCommunicationContactName
      marketingCommunicationContactTitle
      marketingCommunicationContactEmail
      marketingCommunicationContactNumber
      marketingCommunicationContactNumberExtension
      marketingCommunicationContactMobilePhoneNumber
      hrEmployeeEngagementContactName
      hrEmployeeEngagementContactTitle
      hrEmployeeEngagementContactEmail
      hrEmployeeEngagementContactNumber
      hrEmployeeEngagementContactNumberExtension
      hrEmployeeEngagementContactMobilePhoneNumber
      salesBusinessDevelopmentContactName
      salesBusinessDevelopmentContactTitle
      salesBusinessDevelopmentContactEmail
      salesBusinessDevelopmentContactNumber
      salesBusinessDevelopmentContactNumberExtension
      salesBusinessDevelopmentContactMobilePhoneNumber
      accountsPayableBillingAddress {
        streetAddress
        city
        province
        postalCode
        country
      }
    }
  }
}
    `;

/**
 * __useGetChamberMemberQuery__
 *
 * To run a query within a React component, call `useGetChamberMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChamberMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChamberMemberQuery({
 *   variables: {
 *      chamberMemberId: // value for 'chamberMemberId'
 *   },
 * });
 */
export function useGetChamberMemberQuery(baseOptions: Apollo.QueryHookOptions<GetChamberMemberQuery, GetChamberMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChamberMemberQuery, GetChamberMemberQueryVariables>(GetChamberMemberDocument, options);
      }
export function useGetChamberMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChamberMemberQuery, GetChamberMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChamberMemberQuery, GetChamberMemberQueryVariables>(GetChamberMemberDocument, options);
        }
export type GetChamberMemberQueryHookResult = ReturnType<typeof useGetChamberMemberQuery>;
export type GetChamberMemberLazyQueryHookResult = ReturnType<typeof useGetChamberMemberLazyQuery>;
export type GetChamberMemberQueryResult = Apollo.QueryResult<GetChamberMemberQuery, GetChamberMemberQueryVariables>;
export const GetCmpMemberDashboardChamberBySlugDocument = gql`
    query getCmpMemberDashboardChamberBySlug($slug: String!) {
  getCmpMemberDashboardChamberBySlug(slug: $slug) {
    chamberId
    slug
    name
    logo
  }
}
    `;

/**
 * __useGetCmpMemberDashboardChamberBySlugQuery__
 *
 * To run a query within a React component, call `useGetCmpMemberDashboardChamberBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmpMemberDashboardChamberBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmpMemberDashboardChamberBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCmpMemberDashboardChamberBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetCmpMemberDashboardChamberBySlugQuery, GetCmpMemberDashboardChamberBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmpMemberDashboardChamberBySlugQuery, GetCmpMemberDashboardChamberBySlugQueryVariables>(GetCmpMemberDashboardChamberBySlugDocument, options);
      }
export function useGetCmpMemberDashboardChamberBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmpMemberDashboardChamberBySlugQuery, GetCmpMemberDashboardChamberBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmpMemberDashboardChamberBySlugQuery, GetCmpMemberDashboardChamberBySlugQueryVariables>(GetCmpMemberDashboardChamberBySlugDocument, options);
        }
export type GetCmpMemberDashboardChamberBySlugQueryHookResult = ReturnType<typeof useGetCmpMemberDashboardChamberBySlugQuery>;
export type GetCmpMemberDashboardChamberBySlugLazyQueryHookResult = ReturnType<typeof useGetCmpMemberDashboardChamberBySlugLazyQuery>;
export type GetCmpMemberDashboardChamberBySlugQueryResult = Apollo.QueryResult<GetCmpMemberDashboardChamberBySlugQuery, GetCmpMemberDashboardChamberBySlugQueryVariables>;
export const GetCmpMemberInvoicesDocument = gql`
    query getCmpMemberInvoices($input: GetCmpMemberInvoicesInput) {
  getCmpMemberInvoices(input: $input) {
    rows {
      ...cmpMemberInvoiceRow
    }
    totalCount
    outstanding {
      currency
      amountInCents
      count
    }
    generatedAtUtcMilli
  }
}
    ${CmpMemberInvoiceRowFragmentDoc}`;

/**
 * __useGetCmpMemberInvoicesQuery__
 *
 * To run a query within a React component, call `useGetCmpMemberInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmpMemberInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmpMemberInvoicesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCmpMemberInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetCmpMemberInvoicesQuery, GetCmpMemberInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmpMemberInvoicesQuery, GetCmpMemberInvoicesQueryVariables>(GetCmpMemberInvoicesDocument, options);
      }
export function useGetCmpMemberInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmpMemberInvoicesQuery, GetCmpMemberInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmpMemberInvoicesQuery, GetCmpMemberInvoicesQueryVariables>(GetCmpMemberInvoicesDocument, options);
        }
export type GetCmpMemberInvoicesQueryHookResult = ReturnType<typeof useGetCmpMemberInvoicesQuery>;
export type GetCmpMemberInvoicesLazyQueryHookResult = ReturnType<typeof useGetCmpMemberInvoicesLazyQuery>;
export type GetCmpMemberInvoicesQueryResult = Apollo.QueryResult<GetCmpMemberInvoicesQuery, GetCmpMemberInvoicesQueryVariables>;
export const GetCmpMemberInvoiceDetailDocument = gql`
    query getCmpMemberInvoiceDetail($input: CmpMemberInvoiceInput!) {
  getCmpMemberInvoiceDetail(input: $input) {
    ...cmpMemberInvoiceRow
  }
}
    ${CmpMemberInvoiceRowFragmentDoc}`;

/**
 * __useGetCmpMemberInvoiceDetailQuery__
 *
 * To run a query within a React component, call `useGetCmpMemberInvoiceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmpMemberInvoiceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmpMemberInvoiceDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCmpMemberInvoiceDetailQuery(baseOptions: Apollo.QueryHookOptions<GetCmpMemberInvoiceDetailQuery, GetCmpMemberInvoiceDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmpMemberInvoiceDetailQuery, GetCmpMemberInvoiceDetailQueryVariables>(GetCmpMemberInvoiceDetailDocument, options);
      }
export function useGetCmpMemberInvoiceDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmpMemberInvoiceDetailQuery, GetCmpMemberInvoiceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmpMemberInvoiceDetailQuery, GetCmpMemberInvoiceDetailQueryVariables>(GetCmpMemberInvoiceDetailDocument, options);
        }
export type GetCmpMemberInvoiceDetailQueryHookResult = ReturnType<typeof useGetCmpMemberInvoiceDetailQuery>;
export type GetCmpMemberInvoiceDetailLazyQueryHookResult = ReturnType<typeof useGetCmpMemberInvoiceDetailLazyQuery>;
export type GetCmpMemberInvoiceDetailQueryResult = Apollo.QueryResult<GetCmpMemberInvoiceDetailQuery, GetCmpMemberInvoiceDetailQueryVariables>;
export const GetCmpProfileSectionsSavedAtDocument = gql`
    query getCmpProfileSectionsSavedAt($chamberMemberId: String!) {
  getChamberMember(chamberMemberId: $chamberMemberId) {
    id
    cmpProfileSectionsSavedAt {
      section
      savedAtUtcMilli
    }
  }
}
    `;

/**
 * __useGetCmpProfileSectionsSavedAtQuery__
 *
 * To run a query within a React component, call `useGetCmpProfileSectionsSavedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmpProfileSectionsSavedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmpProfileSectionsSavedAtQuery({
 *   variables: {
 *      chamberMemberId: // value for 'chamberMemberId'
 *   },
 * });
 */
export function useGetCmpProfileSectionsSavedAtQuery(baseOptions: Apollo.QueryHookOptions<GetCmpProfileSectionsSavedAtQuery, GetCmpProfileSectionsSavedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmpProfileSectionsSavedAtQuery, GetCmpProfileSectionsSavedAtQueryVariables>(GetCmpProfileSectionsSavedAtDocument, options);
      }
export function useGetCmpProfileSectionsSavedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmpProfileSectionsSavedAtQuery, GetCmpProfileSectionsSavedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmpProfileSectionsSavedAtQuery, GetCmpProfileSectionsSavedAtQueryVariables>(GetCmpProfileSectionsSavedAtDocument, options);
        }
export type GetCmpProfileSectionsSavedAtQueryHookResult = ReturnType<typeof useGetCmpProfileSectionsSavedAtQuery>;
export type GetCmpProfileSectionsSavedAtLazyQueryHookResult = ReturnType<typeof useGetCmpProfileSectionsSavedAtLazyQuery>;
export type GetCmpProfileSectionsSavedAtQueryResult = Apollo.QueryResult<GetCmpProfileSectionsSavedAtQuery, GetCmpProfileSectionsSavedAtQueryVariables>;
export const GetDiscountDocument = gql`
    query getDiscount($discountId: String!) {
  getDiscount(discountId: $discountId) {
    id
    title
    description
    chamberId
    chamberMemberId
    chamberInfo {
      id
      name
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      supportContactEmail
      googleMapsApi_City_ProvinceShort_CountryShort
      supportContactName
      supportLink
      phoneNumber
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      youtube
      jobPostingLink
      eventsLink
      newsletterLink
      surveyLink
      advocacyWinsLink
      callForNominationsLink
      memberSignupLink
      sponsorLogo
      sponsorLogoLink
      description
      logo
      hideInApp
    }
    chamberMemberInfo {
      id
      chamberId
      categoryId
      customContacts {
        id
        name
        email
        jobTitle
        phoneNumber
      }
      banner {
        contentUrl
        imageLink
        contentType
        position
      }
      activeMemberProfileAndPerksBannersSettings {
        activationInfo {
          startDateUtcMilli
          chamberMemberHasAcceptedAgreement
        }
      }
      credentialsSentAtUtcMilli
      adminConsoleContactName
      name
      description
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      phoneNumber
      contactName
      email
      logo
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      googleReviewLink
      youtube
      showInApp
      isSuspended
    }
    memberOnly
    isReoccuring
    daysAvailable
    monthsAvailable
    isAvailableToAllMembers
    isPrivate
    privateEmails
    redeemSettings {
      whereToRedeem
      howToRedeem {
        code
        websiteToEnterCodeAt
        contactEmail
        contactNumber
        contactName
      }
    }
    expiryTimeUtcMilli
    startTimeUtcMilli
    updatedAtUtcMilli
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
    notify
    views
  }
}
    `;

/**
 * __useGetDiscountQuery__
 *
 * To run a query within a React component, call `useGetDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountQuery({
 *   variables: {
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useGetDiscountQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, options);
      }
export function useGetDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountQuery, GetDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountQuery, GetDiscountQueryVariables>(GetDiscountDocument, options);
        }
export type GetDiscountQueryHookResult = ReturnType<typeof useGetDiscountQuery>;
export type GetDiscountLazyQueryHookResult = ReturnType<typeof useGetDiscountLazyQuery>;
export type GetDiscountQueryResult = Apollo.QueryResult<GetDiscountQuery, GetDiscountQueryVariables>;
export const GetMyCmpMemberAutoRenewalDocument = gql`
    query getMyCmpMemberAutoRenewal {
  getMyCmpMemberAutoRenewal {
    ...CmpMyMemberAutoRenewal
  }
}
    ${CmpMyMemberAutoRenewalFragmentDoc}`;

/**
 * __useGetMyCmpMemberAutoRenewalQuery__
 *
 * To run a query within a React component, call `useGetMyCmpMemberAutoRenewalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCmpMemberAutoRenewalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCmpMemberAutoRenewalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCmpMemberAutoRenewalQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCmpMemberAutoRenewalQuery, GetMyCmpMemberAutoRenewalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCmpMemberAutoRenewalQuery, GetMyCmpMemberAutoRenewalQueryVariables>(GetMyCmpMemberAutoRenewalDocument, options);
      }
export function useGetMyCmpMemberAutoRenewalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCmpMemberAutoRenewalQuery, GetMyCmpMemberAutoRenewalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCmpMemberAutoRenewalQuery, GetMyCmpMemberAutoRenewalQueryVariables>(GetMyCmpMemberAutoRenewalDocument, options);
        }
export type GetMyCmpMemberAutoRenewalQueryHookResult = ReturnType<typeof useGetMyCmpMemberAutoRenewalQuery>;
export type GetMyCmpMemberAutoRenewalLazyQueryHookResult = ReturnType<typeof useGetMyCmpMemberAutoRenewalLazyQuery>;
export type GetMyCmpMemberAutoRenewalQueryResult = Apollo.QueryResult<GetMyCmpMemberAutoRenewalQuery, GetMyCmpMemberAutoRenewalQueryVariables>;
export const GetMyCmpMemberContactAccountsDocument = gql`
    query getMyCmpMemberContactAccounts {
  getMyCmpMemberContactAccounts {
    memberUpdatedAtUtcMilli
    accounts {
      contactId
      name
      email
      usesLegacyMemberAccount
      credentialActionsBlockedReason
      enabled
      hasSignedUp
      credentialsSentAtUtcMilli
      lastDashboardLoginAtUtcMilli
    }
  }
}
    `;

/**
 * __useGetMyCmpMemberContactAccountsQuery__
 *
 * To run a query within a React component, call `useGetMyCmpMemberContactAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCmpMemberContactAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCmpMemberContactAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCmpMemberContactAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCmpMemberContactAccountsQuery, GetMyCmpMemberContactAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCmpMemberContactAccountsQuery, GetMyCmpMemberContactAccountsQueryVariables>(GetMyCmpMemberContactAccountsDocument, options);
      }
export function useGetMyCmpMemberContactAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCmpMemberContactAccountsQuery, GetMyCmpMemberContactAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCmpMemberContactAccountsQuery, GetMyCmpMemberContactAccountsQueryVariables>(GetMyCmpMemberContactAccountsDocument, options);
        }
export type GetMyCmpMemberContactAccountsQueryHookResult = ReturnType<typeof useGetMyCmpMemberContactAccountsQuery>;
export type GetMyCmpMemberContactAccountsLazyQueryHookResult = ReturnType<typeof useGetMyCmpMemberContactAccountsLazyQuery>;
export type GetMyCmpMemberContactAccountsQueryResult = Apollo.QueryResult<GetMyCmpMemberContactAccountsQuery, GetMyCmpMemberContactAccountsQueryVariables>;
export const GetMyCmpMemberEventsDocument = gql`
    query getMyCmpMemberEvents {
  getMyCmpMemberEvents {
    upcoming {
      ...CmpMyMemberEventRegistration
    }
    past {
      ...CmpMyMemberEventRegistration
    }
    eventsPageUrl
  }
}
    ${CmpMyMemberEventRegistrationFragmentDoc}`;

/**
 * __useGetMyCmpMemberEventsQuery__
 *
 * To run a query within a React component, call `useGetMyCmpMemberEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCmpMemberEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCmpMemberEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCmpMemberEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCmpMemberEventsQuery, GetMyCmpMemberEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCmpMemberEventsQuery, GetMyCmpMemberEventsQueryVariables>(GetMyCmpMemberEventsDocument, options);
      }
export function useGetMyCmpMemberEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCmpMemberEventsQuery, GetMyCmpMemberEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCmpMemberEventsQuery, GetMyCmpMemberEventsQueryVariables>(GetMyCmpMemberEventsDocument, options);
        }
export type GetMyCmpMemberEventsQueryHookResult = ReturnType<typeof useGetMyCmpMemberEventsQuery>;
export type GetMyCmpMemberEventsLazyQueryHookResult = ReturnType<typeof useGetMyCmpMemberEventsLazyQuery>;
export type GetMyCmpMemberEventsQueryResult = Apollo.QueryResult<GetMyCmpMemberEventsQuery, GetMyCmpMemberEventsQueryVariables>;
export const GetMyMemberDashboardChambersDocument = gql`
    query getMyMemberDashboardChambers {
  getMyMemberDashboardChambers {
    chamberId
    name
    logo
    isHome
    isActive
  }
}
    `;

/**
 * __useGetMyMemberDashboardChambersQuery__
 *
 * To run a query within a React component, call `useGetMyMemberDashboardChambersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMemberDashboardChambersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMemberDashboardChambersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyMemberDashboardChambersQuery(baseOptions?: Apollo.QueryHookOptions<GetMyMemberDashboardChambersQuery, GetMyMemberDashboardChambersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyMemberDashboardChambersQuery, GetMyMemberDashboardChambersQueryVariables>(GetMyMemberDashboardChambersDocument, options);
      }
export function useGetMyMemberDashboardChambersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyMemberDashboardChambersQuery, GetMyMemberDashboardChambersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyMemberDashboardChambersQuery, GetMyMemberDashboardChambersQueryVariables>(GetMyMemberDashboardChambersDocument, options);
        }
export type GetMyMemberDashboardChambersQueryHookResult = ReturnType<typeof useGetMyMemberDashboardChambersQuery>;
export type GetMyMemberDashboardChambersLazyQueryHookResult = ReturnType<typeof useGetMyMemberDashboardChambersLazyQuery>;
export type GetMyMemberDashboardChambersQueryResult = Apollo.QueryResult<GetMyMemberDashboardChambersQuery, GetMyMemberDashboardChambersQueryVariables>;
export const GetPerkPartnerDiscountDocument = gql`
    query getPerkPartnerDiscount($id: String!) {
  getPerkPartnerDiscount(id: $id) {
    id
    companyName
    title
    description
    verifiedChamberMemberCapUserRedirectLink
    unverifiedChamberMemberCapUserRedirectLink
    logo
    availableToChamberIds
    availableToChambers {
      id
      name
    }
    createdAtUtcMilli
    updatedAtUtcMilli
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
  }
}
    `;

/**
 * __useGetPerkPartnerDiscountQuery__
 *
 * To run a query within a React component, call `useGetPerkPartnerDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerkPartnerDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerkPartnerDiscountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPerkPartnerDiscountQuery(baseOptions: Apollo.QueryHookOptions<GetPerkPartnerDiscountQuery, GetPerkPartnerDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerkPartnerDiscountQuery, GetPerkPartnerDiscountQueryVariables>(GetPerkPartnerDiscountDocument, options);
      }
export function useGetPerkPartnerDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerkPartnerDiscountQuery, GetPerkPartnerDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerkPartnerDiscountQuery, GetPerkPartnerDiscountQueryVariables>(GetPerkPartnerDiscountDocument, options);
        }
export type GetPerkPartnerDiscountQueryHookResult = ReturnType<typeof useGetPerkPartnerDiscountQuery>;
export type GetPerkPartnerDiscountLazyQueryHookResult = ReturnType<typeof useGetPerkPartnerDiscountLazyQuery>;
export type GetPerkPartnerDiscountQueryResult = Apollo.QueryResult<GetPerkPartnerDiscountQuery, GetPerkPartnerDiscountQueryVariables>;
export const GetPerkPartnerDiscountAdminUserDocument = gql`
    query getPerkPartnerDiscountAdminUser {
  getPerkPartnerDiscountAdminUser {
    id
    email
    perkPartnerDiscountId
    adminConsoleLoginEmail
    createdAtUtcMilli
    updatedAtUtcMilli
  }
}
    `;

/**
 * __useGetPerkPartnerDiscountAdminUserQuery__
 *
 * To run a query within a React component, call `useGetPerkPartnerDiscountAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerkPartnerDiscountAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerkPartnerDiscountAdminUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPerkPartnerDiscountAdminUserQuery(baseOptions?: Apollo.QueryHookOptions<GetPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountAdminUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountAdminUserQueryVariables>(GetPerkPartnerDiscountAdminUserDocument, options);
      }
export function useGetPerkPartnerDiscountAdminUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountAdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountAdminUserQueryVariables>(GetPerkPartnerDiscountAdminUserDocument, options);
        }
export type GetPerkPartnerDiscountAdminUserQueryHookResult = ReturnType<typeof useGetPerkPartnerDiscountAdminUserQuery>;
export type GetPerkPartnerDiscountAdminUserLazyQueryHookResult = ReturnType<typeof useGetPerkPartnerDiscountAdminUserLazyQuery>;
export type GetPerkPartnerDiscountAdminUserQueryResult = Apollo.QueryResult<GetPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountAdminUserQueryVariables>;
export const GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserDocument = gql`
    query getPerkPartnerDiscountForPerkPartnerDiscountAdminUser($id: String!) {
  getPerkPartnerDiscount(id: $id) {
    id
    companyName
    title
    description
    verifiedChamberMemberCapUserRedirectLink
    unverifiedChamberMemberCapUserRedirectLink
    logo
    createdAtUtcMilli
    updatedAtUtcMilli
    banner {
      contentUrl
      imageLink
      contentType
      position
    }
  }
}
    `;

/**
 * __useGetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery__
 *
 * To run a query within a React component, call `useGetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery(baseOptions: Apollo.QueryHookOptions<GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQueryVariables>(GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserDocument, options);
      }
export function useGetPerkPartnerDiscountForPerkPartnerDiscountAdminUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQueryVariables>(GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserDocument, options);
        }
export type GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQueryHookResult = ReturnType<typeof useGetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery>;
export type GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserLazyQueryHookResult = ReturnType<typeof useGetPerkPartnerDiscountForPerkPartnerDiscountAdminUserLazyQuery>;
export type GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQueryResult = Apollo.QueryResult<GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountForPerkPartnerDiscountAdminUserQueryVariables>;
export const GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserDocument = gql`
    query getPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUser($id: String!) {
  getPerkPartnerDiscountStats(id: $id) {
    id
    totalViewCount
    totalOpenCount
    totalOpensFromViewsConversionRatePercentage
    splitByChamber {
      chamberId
      chamberName
      totalViewCount
      totalOpenCount
    }
    timeseriesData {
      allChambers {
        id
        name
        timeseriesData {
          monthAndYear
          totalOpenCount
          totalViewCount
        }
      }
      chambers {
        id
        name
        timeseriesData {
          monthAndYear
          totalOpenCount
          totalViewCount
        }
      }
    }
  }
}
    `;

/**
 * __useGetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery__
 *
 * To run a query within a React component, call `useGetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery(baseOptions: Apollo.QueryHookOptions<GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQueryVariables>(GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserDocument, options);
      }
export function useGetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQueryVariables>(GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserDocument, options);
        }
export type GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQueryHookResult = ReturnType<typeof useGetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery>;
export type GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserLazyQueryHookResult = ReturnType<typeof useGetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserLazyQuery>;
export type GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQueryResult = Apollo.QueryResult<GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQuery, GetPerkPartnerDiscountStatsForPerkPartnerDiscountAdminUserQueryVariables>;
export const GetPerkPartnerDiscountStatsForRootAdminDocument = gql`
    query getPerkPartnerDiscountStatsForRootAdmin($id: String!) {
  getPerkPartnerDiscountStats(id: $id) {
    id
    totalViewCount
    totalIneligibleViewCount
    totalUnverifiedViewCount
    totalVerifiedViewCount
    totalOpenCount
    totalIneligibleOpenCount
    totalUnverifiedOpenCount
    totalVerifiedOpenCount
    totalOpensFromViewsConversionRatePercentage
    totalRedeemCount
    totalUnverifiedRedeemCount
    totalVerifiedRedeemCount
    totalVerifiedNoAccessToEmailRedeemCount
    totalRedeemCountFromOpensConversionRatePercentage
    splitByChamber {
      chamberId
      chamberName
      chamberIsEnabledForPerkPartnerDiscount
      totalViewCount
      ineligibleViewCount
      unverifiedViewCount
      verifiedViewCount
      totalOpenCount
      ineligibleOpenCount
      unverifiedOpenCount
      verifiedOpenCount
      totalRedeemCount
      unverifiedRedeemCount
      verifiedRedeemCount
      verifiedNoAccessToEmailRedeemCount
    }
    timeseriesData {
      allChambers {
        id
        name
        timeseriesData {
          monthAndYear
          totalOpenCount
          totalViewCount
          totalRedeemCount
        }
      }
      chambers {
        id
        name
        timeseriesData {
          monthAndYear
          totalOpenCount
          totalViewCount
          totalRedeemCount
        }
      }
    }
  }
}
    `;

/**
 * __useGetPerkPartnerDiscountStatsForRootAdminQuery__
 *
 * To run a query within a React component, call `useGetPerkPartnerDiscountStatsForRootAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerkPartnerDiscountStatsForRootAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerkPartnerDiscountStatsForRootAdminQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPerkPartnerDiscountStatsForRootAdminQuery(baseOptions: Apollo.QueryHookOptions<GetPerkPartnerDiscountStatsForRootAdminQuery, GetPerkPartnerDiscountStatsForRootAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerkPartnerDiscountStatsForRootAdminQuery, GetPerkPartnerDiscountStatsForRootAdminQueryVariables>(GetPerkPartnerDiscountStatsForRootAdminDocument, options);
      }
export function useGetPerkPartnerDiscountStatsForRootAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerkPartnerDiscountStatsForRootAdminQuery, GetPerkPartnerDiscountStatsForRootAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerkPartnerDiscountStatsForRootAdminQuery, GetPerkPartnerDiscountStatsForRootAdminQueryVariables>(GetPerkPartnerDiscountStatsForRootAdminDocument, options);
        }
export type GetPerkPartnerDiscountStatsForRootAdminQueryHookResult = ReturnType<typeof useGetPerkPartnerDiscountStatsForRootAdminQuery>;
export type GetPerkPartnerDiscountStatsForRootAdminLazyQueryHookResult = ReturnType<typeof useGetPerkPartnerDiscountStatsForRootAdminLazyQuery>;
export type GetPerkPartnerDiscountStatsForRootAdminQueryResult = Apollo.QueryResult<GetPerkPartnerDiscountStatsForRootAdminQuery, GetPerkPartnerDiscountStatsForRootAdminQueryVariables>;
export const GetPremiumChamberMarketerLinkDocument = gql`
    query getPremiumChamberMarketerLink($chamberId: String!) {
  getChamber(chamberId: $chamberId) {
    id
    premiumChamberMarketerLink
  }
}
    `;

/**
 * __useGetPremiumChamberMarketerLinkQuery__
 *
 * To run a query within a React component, call `useGetPremiumChamberMarketerLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPremiumChamberMarketerLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPremiumChamberMarketerLinkQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetPremiumChamberMarketerLinkQuery(baseOptions: Apollo.QueryHookOptions<GetPremiumChamberMarketerLinkQuery, GetPremiumChamberMarketerLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPremiumChamberMarketerLinkQuery, GetPremiumChamberMarketerLinkQueryVariables>(GetPremiumChamberMarketerLinkDocument, options);
      }
export function useGetPremiumChamberMarketerLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPremiumChamberMarketerLinkQuery, GetPremiumChamberMarketerLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPremiumChamberMarketerLinkQuery, GetPremiumChamberMarketerLinkQueryVariables>(GetPremiumChamberMarketerLinkDocument, options);
        }
export type GetPremiumChamberMarketerLinkQueryHookResult = ReturnType<typeof useGetPremiumChamberMarketerLinkQuery>;
export type GetPremiumChamberMarketerLinkLazyQueryHookResult = ReturnType<typeof useGetPremiumChamberMarketerLinkLazyQuery>;
export type GetPremiumChamberMarketerLinkQueryResult = Apollo.QueryResult<GetPremiumChamberMarketerLinkQuery, GetPremiumChamberMarketerLinkQueryVariables>;
export const GetRewardCampaignDocument = gql`
    query getRewardCampaign($id: String!) {
  getRewardCampaign(id: $id) {
    id
    chamberId
    sponsoringChamberMemberId
    campaignName
    prizeDescription
    startDateUtcMilli
    endDateUtcMilli
    prizeDrawParticipants {
      email
      ballotsEarned
    }
    createdAtUtcMilli
    updatedAtUtcMilli
    isCreatedByCpaAdmin
  }
}
    `;

/**
 * __useGetRewardCampaignQuery__
 *
 * To run a query within a React component, call `useGetRewardCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRewardCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetRewardCampaignQuery, GetRewardCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewardCampaignQuery, GetRewardCampaignQueryVariables>(GetRewardCampaignDocument, options);
      }
export function useGetRewardCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewardCampaignQuery, GetRewardCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewardCampaignQuery, GetRewardCampaignQueryVariables>(GetRewardCampaignDocument, options);
        }
export type GetRewardCampaignQueryHookResult = ReturnType<typeof useGetRewardCampaignQuery>;
export type GetRewardCampaignLazyQueryHookResult = ReturnType<typeof useGetRewardCampaignLazyQuery>;
export type GetRewardCampaignQueryResult = Apollo.QueryResult<GetRewardCampaignQuery, GetRewardCampaignQueryVariables>;
export const GetRootAdminStatsDocument = gql`
    query GetRootAdminStats {
  getRootAdminStats {
    totalChambers
    totalChamberMembers
    totalSuspendedChamberMembers
    totalDiscountViews
    totalDiscountRedemptions
    numberOfChamberMembersOfferingLiveDiscounts
    percentOfChamberMembersOfferingLiveDiscounts
    totalNumberOfLiveDiscounts
    totalNumberOfLiveAllMemberDiscounts
    totalNumberOfLiveLocalMemberOnlyDiscounts
    totalNumberOfLiveGeneralPublicDiscounts
    totalNumberOfLiveCompanyEmployeesOnlyDiscounts
    totalNumberOfAppUsers
    totalNumberOfAppUsersSignedUpWithAnEmployer
    totalNumberOfAppUsersSignedUpWithoutAnEmployer
    totalNumberOfAppUsersWithNewPerkNotificationEnabled
    totalPercentageOfAppUsersWithNewPerkNotificationEnabled
    totalNumberOfAppUsersWithEmployerAndNewPerkNotificationEnabled
    totalPercentageOfAppUsersWithEmployerAndNewPerkNotificationEnabled
    totalNumberOfAppUsersWithNearbyPerkNotificationEnabled
    totalPercentageOfAppUsersWithNearbyPerkNotificationEnabled
    timeseriesAppUsersData {
      monthly {
        monthAndYear
        numberOfAppUsers
      }
    }
    monthToChamberAppUserData {
      monthAndYear
      chamberId
      chamberName
      chamberProvince
      numberOfAppUsersInMonth
      percentageOfAppUsersInMonth
      numberOfAppUsersGrowthVersusPreviousMonth
      percentageGrowthVersusPreviousMonth
    }
    timeseriesChamberEngageData {
      monthlyTotal {
        monthAndYear
        activationFeeRevenueData {
          activationFeeRevenue
          featuredMemberActivationFeeRevenue
          categoryAdvertisingActivationFeeRevenue
          chamberRevenue
          chamberFeaturedMemberRevenue
          chamberCategoryAdvertisingRevenue
        }
      }
      monthlyPerChamber {
        monthAndYear
        chamberData {
          chamberId
          chamberName
          activationFeeRevenueData {
            activationFeeRevenue
            featuredMemberActivationFeeRevenue
            categoryAdvertisingActivationFeeRevenue
            chamberRevenue
            chamberFeaturedMemberRevenue
            chamberCategoryAdvertisingRevenue
          }
        }
      }
      lifetimeTotal {
        activationFeeRevenue
        featuredMemberActivationFeeRevenue
        categoryAdvertisingActivationFeeRevenue
        chamberRevenue
        chamberFeaturedMemberRevenue
        chamberCategoryAdvertisingRevenue
      }
      lifetimeTotalPerChamber {
        chamberId
        chamberName
        lifetimeTotalActivationFeeRevenueData {
          activationFeeRevenue
          featuredMemberActivationFeeRevenue
          categoryAdvertisingActivationFeeRevenue
          chamberRevenue
          chamberFeaturedMemberRevenue
          chamberCategoryAdvertisingRevenue
        }
      }
      yearlyTotal {
        year
        activationFeeRevenueData {
          activationFeeRevenue
          featuredMemberActivationFeeRevenue
          categoryAdvertisingActivationFeeRevenue
          chamberRevenue
          chamberFeaturedMemberRevenue
          chamberCategoryAdvertisingRevenue
        }
      }
      yearlyTotalPerChamber {
        year
        chamberData {
          chamberId
          chamberName
          activationFeeRevenueData {
            activationFeeRevenue
            featuredMemberActivationFeeRevenue
            categoryAdvertisingActivationFeeRevenue
            chamberRevenue
            chamberFeaturedMemberRevenue
            chamberCategoryAdvertisingRevenue
          }
        }
      }
    }
    chambersSortedByNewest {
      name
      subscriptionDate
      subscriptionUTCMilli
      cpaDashboardLatestAccessAtUtcMilli
      numberOfAppUsers
      numberOfAppUsersSignedUpWithAnEmployer
      numberOfAppUsersSignedUpWithoutAnEmployer
      numberOfLiveDiscounts
      numberOfDiscountViews
      numberOfDiscountRedemptions
      numberOfChamberMembersLiveOnApp
      numberOfSuspendedChamberMembers
      numberOfMembersFromInitialSubscriptionAgreement
      numberChangeInNumberOfChamberMembersBetweenNowAndInitial
      percentageChangeInNumberOfChamberMembersBetweenNowAndInitial
      numberOfChamberMembersLoggedInToAdminPortal
      percentageOfChamberMembersLoggedInToAdminPortal
      numberOfChamberMembersThatWereEmailedTheirCredentialsBeforeFirstLogin
      percentageOfChamberMembersThatWereEmailedTheirCredentialsBeforeFirstLogin
      numberOfChamberMembersOfferingLiveDiscounts
      percentageOfChamberMembersOfferingLiveDiscounts
      discountsPerCategoryBreakdown {
        categoryName
        numberOfDiscounts
        percentageVersusOtherCategories
      }
      numberOfAppUsersWithNewPerkNotificationEnabled
      percentageOfAppUsersWithNewPerkNotificationEnabled
      numberOfAppUsersWithEmployerAndNewPerkNotificationEnabled
      percentageOfAppUsersWithEmployerAndNewPerkNotificationEnabled
      numberOfAppUsersWithNearbyPerkNotificationEnabled
      percentageOfAppUsersWithNearbyPerkNotificationEnabled
    }
    newestChamberMembers {
      name
      chamberName
      membershipStatus
      category1
      category2
      numberOfAppUsersWithThisMemberSetAsTheirEmployer
      numberOfDeletedAndNonDeletedDiscounts
      hasLoggedInToAdminPortal
      hasLogo
      createdAtUtcMilli
      createdAtUtcTimestamp
    }
    newestDiscounts {
      title
      chamberName
      chamberMemberName
      offeredTo
      views
      numberOfRedemptions
      category1
      category2
      createdAtUtcMilli
      createdAtUtcTimestamp
      deletedAtUtcMilli
      deletedAtUtcTimestamp
    }
    discountsPerCategoryBreakdown {
      categoryName
      numberOfDiscounts
      percentageVersusOtherCategories
    }
    contactableChambersSortedByNewest {
      id
      name
      createdAtUtcMilli
      createdAtUtcTimestamp
    }
    contactableCompaniesSortedByNewest {
      id
      chamberId
      chamberName
      name
      createdAtUtcMilli
      createdAtUtcTimestamp
    }
    perksLinkChambers {
      chamberId
      chamberName
      perksLinks {
        linkedChamberId
        linkedChamberName
        status
        requestedAtUtcMilli
        acceptedAtUtcMilli
        isRequestor
      }
    }
  }
}
    `;

/**
 * __useGetRootAdminStatsQuery__
 *
 * To run a query within a React component, call `useGetRootAdminStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRootAdminStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRootAdminStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRootAdminStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetRootAdminStatsQuery, GetRootAdminStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRootAdminStatsQuery, GetRootAdminStatsQueryVariables>(GetRootAdminStatsDocument, options);
      }
export function useGetRootAdminStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRootAdminStatsQuery, GetRootAdminStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRootAdminStatsQuery, GetRootAdminStatsQueryVariables>(GetRootAdminStatsDocument, options);
        }
export type GetRootAdminStatsQueryHookResult = ReturnType<typeof useGetRootAdminStatsQuery>;
export type GetRootAdminStatsLazyQueryHookResult = ReturnType<typeof useGetRootAdminStatsLazyQuery>;
export type GetRootAdminStatsQueryResult = Apollo.QueryResult<GetRootAdminStatsQuery, GetRootAdminStatsQueryVariables>;
export const GetSampleLoginInfoEmailDocument = gql`
    query getSampleLoginInfoEmail($type: LoginInfoEmailTypes!, $chamberMemberId: String) {
  getSampleLoginInfoEmail(type: $type, chamberMemberId: $chamberMemberId) {
    emailHtml
  }
}
    `;

/**
 * __useGetSampleLoginInfoEmailQuery__
 *
 * To run a query within a React component, call `useGetSampleLoginInfoEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSampleLoginInfoEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSampleLoginInfoEmailQuery({
 *   variables: {
 *      type: // value for 'type'
 *      chamberMemberId: // value for 'chamberMemberId'
 *   },
 * });
 */
export function useGetSampleLoginInfoEmailQuery(baseOptions: Apollo.QueryHookOptions<GetSampleLoginInfoEmailQuery, GetSampleLoginInfoEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSampleLoginInfoEmailQuery, GetSampleLoginInfoEmailQueryVariables>(GetSampleLoginInfoEmailDocument, options);
      }
export function useGetSampleLoginInfoEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSampleLoginInfoEmailQuery, GetSampleLoginInfoEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSampleLoginInfoEmailQuery, GetSampleLoginInfoEmailQueryVariables>(GetSampleLoginInfoEmailDocument, options);
        }
export type GetSampleLoginInfoEmailQueryHookResult = ReturnType<typeof useGetSampleLoginInfoEmailQuery>;
export type GetSampleLoginInfoEmailLazyQueryHookResult = ReturnType<typeof useGetSampleLoginInfoEmailLazyQuery>;
export type GetSampleLoginInfoEmailQueryResult = Apollo.QueryResult<GetSampleLoginInfoEmailQuery, GetSampleLoginInfoEmailQueryVariables>;
export const GetSampleMemberLoginCredentialsDocument = gql`
    query getSampleMemberLoginCredentials {
  getSampleMemberLoginCredentials {
    sampleCSVRawTextOfAllMemberLoginCredentials
  }
}
    `;

/**
 * __useGetSampleMemberLoginCredentialsQuery__
 *
 * To run a query within a React component, call `useGetSampleMemberLoginCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSampleMemberLoginCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSampleMemberLoginCredentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSampleMemberLoginCredentialsQuery(baseOptions?: Apollo.QueryHookOptions<GetSampleMemberLoginCredentialsQuery, GetSampleMemberLoginCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSampleMemberLoginCredentialsQuery, GetSampleMemberLoginCredentialsQueryVariables>(GetSampleMemberLoginCredentialsDocument, options);
      }
export function useGetSampleMemberLoginCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSampleMemberLoginCredentialsQuery, GetSampleMemberLoginCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSampleMemberLoginCredentialsQuery, GetSampleMemberLoginCredentialsQueryVariables>(GetSampleMemberLoginCredentialsDocument, options);
        }
export type GetSampleMemberLoginCredentialsQueryHookResult = ReturnType<typeof useGetSampleMemberLoginCredentialsQuery>;
export type GetSampleMemberLoginCredentialsLazyQueryHookResult = ReturnType<typeof useGetSampleMemberLoginCredentialsLazyQuery>;
export type GetSampleMemberLoginCredentialsQueryResult = Apollo.QueryResult<GetSampleMemberLoginCredentialsQuery, GetSampleMemberLoginCredentialsQueryVariables>;
export const GetShopLocalCampaignDocument = gql`
    query getShopLocalCampaign($id: String!) {
  getShopLocalCampaign(id: $id) {
    id
    chamberId
    campaignName
    prizeDescription
    startDateUtcMilli
    endDateUtcMilli
    participatingMemberIds
    participatingMembers {
      memberId
      participationCode
    }
    prizeDrawParticipants {
      userEmail
      redeemedAtMemberIds
    }
    status
    createdAtUtcMilli
    updatedAtUtcMilli
  }
}
    `;

/**
 * __useGetShopLocalCampaignQuery__
 *
 * To run a query within a React component, call `useGetShopLocalCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopLocalCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopLocalCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShopLocalCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetShopLocalCampaignQuery, GetShopLocalCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopLocalCampaignQuery, GetShopLocalCampaignQueryVariables>(GetShopLocalCampaignDocument, options);
      }
export function useGetShopLocalCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopLocalCampaignQuery, GetShopLocalCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopLocalCampaignQuery, GetShopLocalCampaignQueryVariables>(GetShopLocalCampaignDocument, options);
        }
export type GetShopLocalCampaignQueryHookResult = ReturnType<typeof useGetShopLocalCampaignQuery>;
export type GetShopLocalCampaignLazyQueryHookResult = ReturnType<typeof useGetShopLocalCampaignLazyQuery>;
export type GetShopLocalCampaignQueryResult = Apollo.QueryResult<GetShopLocalCampaignQuery, GetShopLocalCampaignQueryVariables>;
export const GetShopLocalParticipatingMemberEligibilityDocument = gql`
    query getShopLocalParticipatingMemberEligibility($startDateUtcMilli: Float!, $endDateUtcMilli: Float!) {
  getShopLocalParticipatingMemberEligibility(
    startDateUtcMilli: $startDateUtcMilli
    endDateUtcMilli: $endDateUtcMilli
  ) {
    memberId
    memberName
    eligible
    ineligibilityReasons
  }
}
    `;

/**
 * __useGetShopLocalParticipatingMemberEligibilityQuery__
 *
 * To run a query within a React component, call `useGetShopLocalParticipatingMemberEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopLocalParticipatingMemberEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopLocalParticipatingMemberEligibilityQuery({
 *   variables: {
 *      startDateUtcMilli: // value for 'startDateUtcMilli'
 *      endDateUtcMilli: // value for 'endDateUtcMilli'
 *   },
 * });
 */
export function useGetShopLocalParticipatingMemberEligibilityQuery(baseOptions: Apollo.QueryHookOptions<GetShopLocalParticipatingMemberEligibilityQuery, GetShopLocalParticipatingMemberEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopLocalParticipatingMemberEligibilityQuery, GetShopLocalParticipatingMemberEligibilityQueryVariables>(GetShopLocalParticipatingMemberEligibilityDocument, options);
      }
export function useGetShopLocalParticipatingMemberEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopLocalParticipatingMemberEligibilityQuery, GetShopLocalParticipatingMemberEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopLocalParticipatingMemberEligibilityQuery, GetShopLocalParticipatingMemberEligibilityQueryVariables>(GetShopLocalParticipatingMemberEligibilityDocument, options);
        }
export type GetShopLocalParticipatingMemberEligibilityQueryHookResult = ReturnType<typeof useGetShopLocalParticipatingMemberEligibilityQuery>;
export type GetShopLocalParticipatingMemberEligibilityLazyQueryHookResult = ReturnType<typeof useGetShopLocalParticipatingMemberEligibilityLazyQuery>;
export type GetShopLocalParticipatingMemberEligibilityQueryResult = Apollo.QueryResult<GetShopLocalParticipatingMemberEligibilityQuery, GetShopLocalParticipatingMemberEligibilityQueryVariables>;
export const GetSubscriptionPlanTypeDocument = gql`
    query getSubscriptionPlanType($chamberId: String!) {
  getChamber(chamberId: $chamberId) {
    id
    subscriptionPlanType
  }
}
    `;

/**
 * __useGetSubscriptionPlanTypeQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionPlanTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionPlanTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionPlanTypeQuery({
 *   variables: {
 *      chamberId: // value for 'chamberId'
 *   },
 * });
 */
export function useGetSubscriptionPlanTypeQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionPlanTypeQuery, GetSubscriptionPlanTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionPlanTypeQuery, GetSubscriptionPlanTypeQueryVariables>(GetSubscriptionPlanTypeDocument, options);
      }
export function useGetSubscriptionPlanTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionPlanTypeQuery, GetSubscriptionPlanTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionPlanTypeQuery, GetSubscriptionPlanTypeQueryVariables>(GetSubscriptionPlanTypeDocument, options);
        }
export type GetSubscriptionPlanTypeQueryHookResult = ReturnType<typeof useGetSubscriptionPlanTypeQuery>;
export type GetSubscriptionPlanTypeLazyQueryHookResult = ReturnType<typeof useGetSubscriptionPlanTypeLazyQuery>;
export type GetSubscriptionPlanTypeQueryResult = Apollo.QueryResult<GetSubscriptionPlanTypeQuery, GetSubscriptionPlanTypeQueryVariables>;
export const GetSystemWidePerkStatsDocument = gql`
    query getSystemWidePerkStats {
  getSystemWidePerkStats {
    totalActivePerks
    numberOfMembersOfferingPerks
    percentOfMembersOfferingPerks
    totalPerkViews
    numOfAllMemberPerks
    numOfLocalMemberOnlyPerks
    numOfGeneralPublicPerks
    numOfCompanyEmployeesOnlyPerks
    totalNumOfMembers
    totalNumOfChambers
    totalLifeTimeCategoryAdvertisingBannersRevenueForCurrentChamber
    totalLifeTimeRevenueFromMemberProfileAndPerksBannersForCurrentChamber
    totalNumOfMembersWithActiveMemberProfileAndPerksBannersForCurrentChamber
    totalNumOfMembersPerCategoryWithActiveMemberProfileAndPerksBannersForCurrentChamber {
      categoryId
      totalNumOfMembers
    }
  }
}
    `;

/**
 * __useGetSystemWidePerkStatsQuery__
 *
 * To run a query within a React component, call `useGetSystemWidePerkStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemWidePerkStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemWidePerkStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSystemWidePerkStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetSystemWidePerkStatsQuery, GetSystemWidePerkStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemWidePerkStatsQuery, GetSystemWidePerkStatsQueryVariables>(GetSystemWidePerkStatsDocument, options);
      }
export function useGetSystemWidePerkStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemWidePerkStatsQuery, GetSystemWidePerkStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemWidePerkStatsQuery, GetSystemWidePerkStatsQueryVariables>(GetSystemWidePerkStatsDocument, options);
        }
export type GetSystemWidePerkStatsQueryHookResult = ReturnType<typeof useGetSystemWidePerkStatsQuery>;
export type GetSystemWidePerkStatsLazyQueryHookResult = ReturnType<typeof useGetSystemWidePerkStatsLazyQuery>;
export type GetSystemWidePerkStatsQueryResult = Apollo.QueryResult<GetSystemWidePerkStatsQuery, GetSystemWidePerkStatsQueryVariables>;
export const GetUserDocument = gql`
    query getUser($userId: String!) {
  getUser(userId: $userId) {
    id
    email
    chamberMemberProTimeZone
    cmpMemberDashboardAccess {
      cmpEnabled
      contactId
      canManageProfile
      canManagePerks
      canCreatePerks
      canManageBanners
      canViewInvoices
      isPrimaryContact
      roleLabel
      perksOffered
      testMode {
        available
        plan
        contactType
        switchChamber
      }
    }
    chamberId
    chamberInfo {
      id
      name
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      supportContactEmail
      googleMapsApi_City_ProvinceShort_CountryShort
      supportContactName
      billingContactName
      billingContactEmail
      signingAuthorityContactName
      signingAuthorityContactEmail
      supportLink
      phoneNumber
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      youtube
      jobPostingLink
      eventsLink
      newsletterLink
      surveyLink
      advocacyWinsLink
      callForNominationsLink
      memberSignupLink
      sponsorLogo
      sponsorLogoLink
      description
      logo
      isSandbox
      directoryBanner {
        contentUrl
        imageLink
        contentType
        position
      }
      profileBanner {
        contentUrl
        imageLink
        contentType
        position
      }
      chamberEngageSettings {
        isActive
      }
      hideInApp
      createdAtUtcMilli
    }
    chamberMemberId
    chamberMemberInfo {
      id
      chamberId
      categoryId
      customContacts {
        id
        name
        email
        jobTitle
        phoneNumber
      }
      banner {
        contentUrl
        imageLink
        contentType
        position
      }
      activeMemberProfileAndPerksBannersSettings {
        activationInfo {
          startDateUtcMilli
          chamberMemberHasAcceptedAgreement
          chamberMemberAcceptedAgreementVersion
        }
      }
      credentialsSentAtUtcMilli
      adminConsoleContactName
      adminConsoleLoginEmail
      name
      description
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      phoneNumber
      contactName
      email
      logo
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      googleReviewLink
      youtube
      showInApp
      hasSignedUp
      isSuspended
    }
    marketingEmailAccepted
    languageCode
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUser_RootAdminChamberAdminDocument = gql`
    query getUser_RootAdminChamberAdmin($userId: String!) {
  getUser(userId: $userId) {
    id
    email
    chamberId
    chamberInfo {
      id
      subscriptionPlanType
      isSandbox
      name
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      supportContactEmail
      googleMapsApi_City_ProvinceShort_CountryShort
      supportContactName
      billingContactName
      billingContactEmail
      signingAuthorityContactName
      signingAuthorityContactEmail
      supportLink
      phoneNumber
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      youtube
      jobPostingLink
      eventsLink
      newsletterLink
      surveyLink
      advocacyWinsLink
      callForNominationsLink
      memberSignupLink
      sponsorLogo
      sponsorLogoLink
      description
      logo
      isSandbox
      directoryBanner {
        contentUrl
        imageLink
        contentType
        position
      }
      profileBanner {
        contentUrl
        imageLink
        contentType
        position
      }
      chamberEngageSettings {
        isActive
        memberProfileAndPerkBannerActivationFeeInDollars
        memberProfileAndPerkBannerAnnualBannerFeeInDollars
        categoryAdvertisingBannersFeeOptions {
          timeLengthInMonths
          bannerFeeInDollars
        }
        categoryAdvertisingBannersActivationFeeCpaSplitPercentage
      }
      hideInApp
      createdAtUtcMilli
    }
    chamberMemberId
    chamberMemberInfo {
      id
      chamberId
      categoryId
      customContacts {
        id
        name
        email
        jobTitle
        phoneNumber
        phoneNumberExtension
      }
      banner {
        contentUrl
        imageLink
        contentType
        position
      }
      activeMemberProfileAndPerksBannersSettings {
        activationInfo {
          startDateUtcMilli
          chamberMemberHasAcceptedAgreement
        }
      }
      credentialsSentAtUtcMilli
      adminConsoleContactName
      adminConsoleLoginEmail
      name
      description
      website
      address {
        streetAddress
        city
        province
        postalCode
      }
      phoneNumber
      phoneNumberExtension
      contactName
      email
      logo
      primaryContactName
      primaryContactTitle
      primaryContactEmail
      primaryContactPhoneNumber
      primaryContactPhoneNumberExtension
      cpaAdminCompanyAdminContactTitle
      cpaAdminCompanyAdminContactNumber
      cpaAdminCompanyAdminContactNumberExtension
      cpaEmployeeAdoptionContactName
      cpaEmployeeAdoptionContactEmail
      cpaEmployeeAdoptionContactTitle
      cpaEmployeeAdoptionContactNumber
      cpaEmployeeAdoptionContactNumberExtension
      facebook
      instagram
      threads
      linkedin
      twitter
      tiktok
      googleReviewLink
      youtube
      showInApp
      hasSignedUp
      isSuspended
    }
    marketingEmailAccepted
  }
}
    `;

/**
 * __useGetUser_RootAdminChamberAdminQuery__
 *
 * To run a query within a React component, call `useGetUser_RootAdminChamberAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUser_RootAdminChamberAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUser_RootAdminChamberAdminQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUser_RootAdminChamberAdminQuery(baseOptions: Apollo.QueryHookOptions<GetUser_RootAdminChamberAdminQuery, GetUser_RootAdminChamberAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUser_RootAdminChamberAdminQuery, GetUser_RootAdminChamberAdminQueryVariables>(GetUser_RootAdminChamberAdminDocument, options);
      }
export function useGetUser_RootAdminChamberAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUser_RootAdminChamberAdminQuery, GetUser_RootAdminChamberAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUser_RootAdminChamberAdminQuery, GetUser_RootAdminChamberAdminQueryVariables>(GetUser_RootAdminChamberAdminDocument, options);
        }
export type GetUser_RootAdminChamberAdminQueryHookResult = ReturnType<typeof useGetUser_RootAdminChamberAdminQuery>;
export type GetUser_RootAdminChamberAdminLazyQueryHookResult = ReturnType<typeof useGetUser_RootAdminChamberAdminLazyQuery>;
export type GetUser_RootAdminChamberAdminQueryResult = Apollo.QueryResult<GetUser_RootAdminChamberAdminQuery, GetUser_RootAdminChamberAdminQueryVariables>;